export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never;
};
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: Date; output: Date };
  /** Monetary value stored as exact Decimal128 server-side; serialised as a JSON number. */
  Decimal: { input: number; output: number };
};

export type ArrAnalytics = {
  __typename?: 'ARRAnalytics';
  arrByPlan: Array<ArrByPlan>;
  arrByRegion: Array<ArrByRegion>;
  arrBySubscriptionType: Array<ArrBySubscriptionType>;
  calculatedAt: Scalars['DateTime']['output'];
  /** Committed ARR: includes current ARR plus subscriptions with a future startDate. Answers "what ARR have we already signed for, regardless of when it starts". */
  committedARR: Scalars['Float']['output'];
  monthlyARR: Scalars['Float']['output'];
  /** Net (effective) MRR: this period's revenue after the discounts active now, summed across subscriptions. May differ from netTotalARR / 12 while temporary discounts are active. */
  netMonthlyRecurringRevenue: Scalars['Float']['output'];
  /** Net (effective) ARR: the year summed period-by-period after discounts, applying each discount only for the periods it is active (a one-time or temporary discount reduces only its own periods, not the whole year). Equals totalARR when no discounts are active. Additive — totalARR remains the list/contracted figure. */
  netTotalARR: Scalars['Float']['output'];
  /** ARR contributed by QUARTERLY-billed subscriptions (annualized ×4). */
  quarterlyARR: Scalars['Float']['output'];
  /** Current ARR: subscriptions already started and not yet ended (or cancelled). Excludes booked-but-not-yet-started subscriptions — see committedARR. */
  totalARR: Scalars['Float']['output'];
  totalActiveSubscriptions: Scalars['Int']['output'];
  /** Current MRR, summed from each subscription's own monthly figure (billed period cost ÷ months in period). Read this instead of dividing totalARR by 12: each subscription derives its MRR and ARR independently from what it is billed, so a book holding quarterly or annual subscriptions has totalMRR × 12 ≠ totalARR. Equals netMonthlyRecurringRevenue exactly when no discounts are active. */
  totalMRR: Scalars['Float']['output'];
  /** How many variable components were EXCLUDED from every figure above because they could not be priced (no price variant in the subscription's currency, or a variant whose shape does not match its pricing model). The walk skips such a row rather than failing the whole query, so a non-zero count means the totals are understated by those components. 0 in normal operation. */
  unpriceableComponentCount: Scalars['Int']['output'];
  /** A bounded sample of the excluded components (see unpriceableComponentCount for the true total), enough to identify and fix them. */
  unpriceableComponents: Array<UnpriceableComponent>;
  yearlyARR: Scalars['Float']['output'];
};

export type ArrByPlan = {
  __typename?: 'ARRByPlan';
  arr: Scalars['Float']['output'];
  planId: Scalars['String']['output'];
  planName: Scalars['String']['output'];
  subscriptionCount: Scalars['Int']['output'];
};

export type ArrByRegion = {
  __typename?: 'ARRByRegion';
  arr: Scalars['Float']['output'];
  region: Scalars['String']['output'];
  subscriptionCount: Scalars['Int']['output'];
};

export type ArrBySubscriptionType = {
  __typename?: 'ARRBySubscriptionType';
  arr: Scalars['Float']['output'];
  subscriptionCount: Scalars['Int']['output'];
  subscriptionType: Scalars['String']['output'];
};

export type ArrTrendPoint = {
  __typename?: 'ARRTrendPoint';
  arr: Scalars['Float']['output'];
  month: Scalars['String']['output'];
};

/** What accepting one cluster of catalog gaps created */
export type AcceptCatalogGapResultEntity = {
  __typename?: 'AcceptCatalogGapResultEntity';
  /** Oldest first — the price history as the invoices evidence it */
  created: Array<AcceptedCatalogVersionEntity>;
  /** NEW_LINEAGE or NEW_VERSION */
  kind: Scalars['String']['output'];
  /** The lineage created, or the one the versions joined */
  lineageId: Scalars['String']['output'];
  /** Metered lines these invoices billed that the created versions do not price. Above zero the product bills its plan and nothing for usage until components are added by hand — the invoices evidence that there was usage, not how it was priced. */
  meteredLinesUnpriced: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type AcceptDriveFolderSuggestionInput = {
  folderId: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export type AcceptDriveFolderSuggestionResult = {
  __typename?: 'AcceptDriveFolderSuggestionResult';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  organizationId: Scalars['ID']['output'];
};

/** Where a new member lands after accepting */
export type AcceptMemberInviteResult = {
  __typename?: 'AcceptMemberInviteResult';
  companyName: Scalars['String']['output'];
  tenantId: Scalars['ID']['output'];
};

/** One catalog version an accepted gap created */
export type AcceptedCatalogVersionEntity = {
  __typename?: 'AcceptedCatalogVersionEntity';
  basePrice: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  effectiveFrom: Scalars['DateTime']['output'];
  period: Scalars['String']['output'];
  /** PUBLISHED for the segment still in force, ARCHIVED for a closed window. Both match; only DRAFT is excluded from resolution, so an accepted gap resolves either way. */
  status: Scalars['String']['output'];
  version: Scalars['Int']['output'];
  /** The version document id — what prices key on */
  versionId: Scalars['String']['output'];
};

/** Eligibility for deleting the current account */
export type AccountDeletionEligibility = {
  __typename?: 'AccountDeletionEligibility';
  /** Names of teams that would be orphaned (user is the only active member) */
  blockingTeams: Array<Scalars['String']['output']>;
  /** Whether the account may be deleted */
  canDelete: Scalars['Boolean']['output'];
  /** Human-readable reason the account cannot be deleted, when blocked */
  reason?: Maybe<Scalars['String']['output']>;
};

/** An account-level situation derived from synced email metadata by the nightly sweep. Situations are opened and closed rather than deleted, so a recovered account keeps its history. */
export type AccountSituation = {
  __typename?: 'AccountSituation';
  /** When the sweep last evaluated the account. */
  computedAt: Scalars['DateTime']['output'];
  /** Always null for now: situations are scoped to the client, because no rule yet decides which open deal a thread belongs to when a client has several. */
  dealId?: Maybe<Scalars['ID']['output']>;
  evidence: AccountSituationEvidence;
  /** When this situation was first raised, kept across a close and reopen. */
  firstOpenedAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** When the status last changed. A nightly refresh of the evidence does not move this — only an actual open or close does. */
  lastTransitionAt: Scalars['DateTime']['output'];
  organizationId: Scalars['ID']['output'];
  /** Name of the client this situation is about. Null when the client could not be resolved — the situation is still real. */
  organizationName?: Maybe<Scalars['String']['output']>;
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  status: AccountSituationStatus;
  type: AccountSituationType;
};

/** Why the sweep reached this verdict. */
export type AccountSituationEvidence = {
  __typename?: 'AccountSituationEvidence';
  /** The most engaged contact, who has dropped out of the recent conversation. Null unless the situation is a lost champion. */
  championContactId?: Maybe<Scalars['ID']['output']>;
  /** Distinct known contacts across those threads. Null when the situation did not depend on it. Zero would mean nobody on the account has been identified yet, which is why the stakeholder situations require a positive count. */
  contactCount?: Maybe<Scalars['Int']['output']>;
  /** Whole days since we last wrote. Null unless the situation is about silence. */
  daysSinceLastOutbound?: Maybe<Scalars['Int']['output']>;
  /** Which trigger raised a going-dark situation. Null on every other type. */
  goingDarkSignal?: Maybe<GoingDarkSignal>;
  lastInboundAt?: Maybe<Scalars['DateTime']['output']>;
  lastOutboundAt?: Maybe<Scalars['DateTime']['output']>;
  /** Due date of the commitment that has been owed longest. */
  oldestCommitmentDueAt?: Maybe<Scalars['DateTime']['output']>;
  /** Commitments on this account that are past due with nothing done since. Null unless the situation is about a missed commitment. */
  overdueCommitmentCount?: Maybe<Scalars['Int']['output']>;
  /** Which side owes every overdue commitment. Null when both sides do — that account needs a human to read it, not a one-sided prompt. */
  overdueCommitmentOwner?: Maybe<CommitmentOwner>;
  /** Threads on the account that passed triage and were considered. */
  qualifiedThreadCount: Scalars['Int']['output'];
};

/** Whether a derived account situation is currently open. */
export enum AccountSituationStatus {
  Open = 'OPEN',
  Resolved = 'RESOLVED',
}

/** An account-level situation derived from email thread metadata. */
export enum AccountSituationType {
  AwaitingThem = 'AWAITING_THEM',
  AwaitingUs = 'AWAITING_US',
  ChampionLost = 'CHAMPION_LOST',
  CommitmentOverdue = 'COMMITMENT_OVERDUE',
  GoingDark = 'GOING_DARK',
  Multithreading = 'MULTITHREADING',
  SingleThreaded = 'SINGLE_THREADED',
  Stalled = 'STALLED',
}

export type AccountingMailbox = {
  __typename?: 'AccountingMailbox';
  /** Whether the email service is configured, i.e. connecting is possible */
  available: Scalars['Boolean']['output'];
  connected: Scalars['Boolean']['output'];
  /** The address invoices sent from this mailbox come from */
  senderEmail?: Maybe<Scalars['String']['output']>;
  /** The mailbox's own signature. Independent of any user's signatures. */
  signature?: Maybe<EmailSignature>;
};

export type ActivateSubscriptionInput = {
  /** Go-live date. Defaults to now, and may be backdated so an activation recorded a few days late still anchors the term to the real go-live. Never forward — a period that has not started cannot be billed or metered. */
  effectiveAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Why now — recorded on the activation event for the audit trail. */
  reason?: InputMaybe<Scalars['String']['input']>;
  subscriptionId: Scalars['ID']['input'];
};

/** A file currently being analyzed in parallel */
export type ActiveSyncFile = {
  __typename?: 'ActiveSyncFile';
  /** Original filename from Google Drive */
  name: Scalars['String']['output'];
  /** Presigned preview URL (may be absent if not yet uploaded) */
  previewUrl?: Maybe<Scalars['String']['output']>;
};

/** Who performed an action, as shown next to the record */
export type ActorSummary = {
  __typename?: 'ActorSummary';
  /** Email address */
  email: Scalars['String']['output'];
  /** User id (the value stored in createdBy) */
  id: Scalars['ID']['output'];
  /** Full display name */
  name?: Maybe<Scalars['String']['output']>;
};

export type AddCurrencyToRegionInput = {
  currency: Currency;
  regionId: Scalars['ID']['input'];
};

export type AddFeatureFlagToTierInput = {
  featureFlagId: Scalars['String']['input'];
  moduleId: Scalars['ID']['input'];
  tierId: Scalars['String']['input'];
};

export type AddLibraryDocumentVersionInput = {
  documentId: Scalars['ID']['input'];
  /** The file id returned by requestLibraryDocumentUpload. */
  fileId: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};

export type AddModuleTierInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  featureFlagIds?: InputMaybe<Array<Scalars['String']['input']>>;
  moduleId: Scalars['ID']['input'];
  /** Rank (0-based). Defaults to appending after existing tiers. */
  order?: InputMaybe<Scalars['Int']['input']>;
  status?: EntityStatus;
  tierName: Scalars['String']['input'];
};

export type AddProductMarketBasePriceInput = {
  /** ISO 4217 currency code (must be supported by the market). */
  currency: Scalars['String']['input'];
  price: Scalars['Float']['input'];
  subscriptionPeriod: SubscriptionPeriod;
  /** ModuleTier id this price applies to. Omit for a bundle / untiered base price. */
  tierId?: InputMaybe<Scalars['ID']['input']>;
  /** Optional included-quantity / per-unit limits carried on the base price. */
  variableLimits?: InputMaybe<Array<VariableLimitInput>>;
};

export type AddProductMarketComponentPriceInput = {
  componentId: Scalars['ID']['input'];
  componentVersion: Scalars['Int']['input'];
  /** Period-agnostic variants; at least one currency (or supply pricesByPeriod). */
  pricesByCurrency: Array<PricingVariantInput>;
  /** Optional per-term overrides. */
  pricesByPeriod?: InputMaybe<Array<PeriodPriceInput>>;
};

export type AddProductMarketInput = {
  /** Base prices to author for the market. One of basePrices / componentPrices required. */
  basePrices?: InputMaybe<Array<AddProductMarketBasePriceInput>>;
  /** Component prices to author for the market. */
  componentPrices?: InputMaybe<Array<AddProductMarketComponentPriceInput>>;
  productId: Scalars['ID']['input'];
  productType: ProductType;
  /** The current published version of the product. */
  productVersion: Scalars['Int']['input'];
  /** Audit note recorded with the created base prices. */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** The market (Region id) to add. */
  regionId: Scalars['ID']['input'];
};

/** Summary of an additive add-market operation on a product. */
export type AddProductMarketResult = {
  __typename?: 'AddProductMarketResult';
  /** Number of base-price rules created for the market. */
  basePricesCreated: Scalars['Int']['output'];
  /** Number of component prices created for the market. */
  componentPricesCreated: Scalars['Int']['output'];
  /** Attached component ids left without a price in the new market — they fall back to a region-agnostic price if one exists. */
  componentsWithoutRegionPrice: Array<Scalars['ID']['output']>;
  /** Distinct currencies now covered by at least one price in the new market. */
  currenciesCovered: Array<Scalars['String']['output']>;
  productId: Scalars['ID']['output'];
  productType: ProductType;
  productVersion: Scalars['Int']['output'];
  /** The market (Region id) that was added. */
  regionId: Scalars['ID']['output'];
};

/** Which suggested people to add, and to which client or prospect. */
export type AddSuggestedContactsInput = {
  organizationId: Scalars['ID']['input'];
  /** One entry for a single-click add, or the whole list for Add all. */
  suggestions: Array<SuggestedContactSelectionInput>;
};

/** The outcome of adding suggested contacts: what landed, and what did not. */
export type AddSuggestedContactsResult = {
  __typename?: 'AddSuggestedContactsResult';
  added: Array<OrganizationContact>;
  /** Selections that were not added. A per-row skip rather than a failed batch: one address a colleague added a second earlier must not cost the operator the rest of the list. */
  skipped: Array<SkippedContactSuggestion>;
};

/** Add several people to a team at once */
export type AddTeamMembersInput = {
  /** Team id */
  teamId: Scalars['ID']['input'];
  /** Auth ids to add. Adding someone already on the team does nothing */
  userIds: Array<Scalars['String']['input']>;
};

export type AddVariableUsageInput = {
  /** Positive delta to add to currentCount */
  delta: Scalars['Float']['input'];
  /** Caller-supplied idempotency identifier (UUID recommended) */
  idempotencyKey: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  /** When the change occurred at the source */
  reportedAt?: InputMaybe<Scalars['DateTime']['input']>;
  subscriptionId: Scalars['ID']['input'];
  variableId: Scalars['ID']['input'];
};

export type AdjustComponentUsageInput = {
  /** Variable Component document _id (the subscription ref pin). */
  componentId: Scalars['ID']['input'];
  /** When the change takes effect. Defaults to now. Proration counts days (DAILY) or months (FULL_MONTH) from this date to period end and the MRR event is dated here — set it in the past to backdate a change. */
  effectiveDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Absolute new provisioned count for the period. */
  newCount: Scalars['Int']['input'];
  /** Audit note for the usage audit + lifecycle event. */
  reason?: InputMaybe<Scalars['String']['input']>;
  subscriptionId: Scalars['ID']['input'];
};

/** What the Revvly Agent receives about this workspace at the start of every turn */
export type AgentContextPreview = {
  __typename?: 'AgentContextPreview';
  /** The exact block sent to the model, or null when there is nothing to send */
  text?: Maybe<Scalars['String']['output']>;
};

/** Something a person asked the Revvly Agent to keep in mind */
export type AgentMemory = {
  __typename?: 'AgentMemory';
  /** Whether the person asking may remove it */
  canRemove: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  scope: AgentMemoryScope;
  /** AGENT: approved on a Remember card in a conversation. SETTINGS: typed in Settings. */
  source: Scalars['String']['output'];
  text: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type AgentMemoryList = {
  __typename?: 'AgentMemoryList';
  /** Whether the asking person may save or remove workspace memories */
  canManageWorkspace: Scalars['Boolean']['output'];
  /** The asking person's own memories */
  personal: Array<AgentMemory>;
  personalMax: Scalars['Int']['output'];
  textMax: Scalars['Int']['output'];
  workspace: Array<AgentMemory>;
  workspaceMax: Scalars['Int']['output'];
};

/** WORKSPACE applies to every member (admins save and remove); PERSONAL to its owner only */
export enum AgentMemoryScope {
  Personal = 'PERSONAL',
  Workspace = 'WORKSPACE',
}

export type AgentSessionType = {
  __typename?: 'AgentSessionType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  status: Scalars['String']['output'];
  title: Scalars['String']['output'];
  /** Render-friendly transcript (raw tool payloads omitted). */
  transcript: Array<AgentTranscriptMessage>;
  turnCount: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Resolutions an agent may close a ticket with. */
export enum AgentTicketResolution {
  AgentResolved = 'AGENT_RESOLVED',
  Duplicate = 'DUPLICATE',
  WontFix = 'WONT_FIX',
}

export type AgentTranscriptMessage = {
  __typename?: 'AgentTranscriptMessage';
  createdAt: Scalars['DateTime']['output'];
  role: Scalars['String']['output'];
  text: Scalars['String']['output'];
  toolCalls: Array<Scalars['String']['output']>;
};

export type AiBudgetPeriod = {
  __typename?: 'AiBudgetPeriod';
  /** Calls that reserved and settled in this period. */
  callCount: Scalars['Int']['output'];
  /** The cap for this tenant-month, from configuration. */
  ceilingUsd: Scalars['Float']['output'];
  /** True when no further model call can be admitted this period. */
  exhausted: Scalars['Boolean']['output'];
  /** UTC month bucket, `YYYY-MM`. Lexical order is chronological order. */
  period: Scalars['String']['output'];
  /** Ceiling minus committed spend. Never negative; zero means the tenant is capped. */
  remainingUsd: Scalars['Float']['output'];
  /** Committed spend: reserved before each call and corrected afterwards. This is what the ceiling is checked against, so it is what explains a tenant being refused. */
  reservedUsd: Scalars['Float']['output'];
  /** Settled spend, read from the provider’s reported token usage. */
  spentUsd: Scalars['Float']['output'];
};

export type AiCostTotals = {
  __typename?: 'AiCostTotals';
  calls: Scalars['Int']['output'];
  /** Calls that did not return a usable answer. */
  failedCalls: Scalars['Int']['output'];
  inputTokens: Scalars['Float']['output'];
  outputTokens: Scalars['Float']['output'];
  /** What the provider charged, in US dollars. */
  providerCostUsd: Scalars['Float']['output'];
  /** Failed calls that may still have been billed. Their cost is recorded as 0 for want of a figure, so the total is a floor when this is above 0. */
  unknownCostCalls: Scalars['Int']['output'];
};

export type AiCreditRuleInput = {
  /** PER_ACTION: credits per successful call. */
  credits?: InputMaybe<Scalars['Float']['input']>;
  /** COST_MULTIPLE: credits per dollar of provider cost. */
  creditsPerUsdCost?: InputMaybe<Scalars['Float']['input']>;
  featureKey: Scalars['String']['input'];
  type: AiCreditRuleKind;
};

/** INCLUDED and ABSORBED use no credits. PER_ACTION uses a fixed number per call. COST_MULTIPLE uses a number of credits per dollar of provider cost. */
export enum AiCreditRuleKind {
  Absorbed = 'ABSORBED',
  CostMultiple = 'COST_MULTIPLE',
  Included = 'INCLUDED',
  PerAction = 'PER_ACTION',
}

export type AiCreditSimulation = {
  __typename?: 'AiCreditSimulation';
  byFeature: Array<AiSimulatedFeature>;
  /** Most expensive first, at most 200. */
  byTenant: Array<AiSimulatedTenant>;
  includedCreditsPerTenant: Scalars['Float']['output'];
  /** The days of usage the figures were projected from: the window, or fewer when metering has not been running that long. */
  observedDays: Scalars['Int']['output'];
  pricePerCredit: Scalars['Float']['output'];
  /** Every figure is projected to this many days. */
  projectedDays: Scalars['Int']['output'];
  totals: AiSimulationTotals;
  windowDays: Scalars['Int']['output'];
};

export type AiCreditSimulationInput = {
  /** Credits each workspace gets before overage starts. */
  includedCreditsPerTenant: Scalars['Float']['input'];
  /** What one credit costs the customer, in US dollars. */
  pricePerCredit: Scalars['Float']['input'];
  /** A feature with no rule uses no credits. */
  rules: Array<AiCreditRuleInput>;
  /** Days of recent usage to read, 1 to 90. */
  windowDays: Scalars['Int']['input'];
};

export type AiEconomics = {
  __typename?: 'AiEconomics';
  byFeature: Array<AiFeatureEconomics>;
  /** Most expensive first, at most 200. */
  byTenant: Array<AiTenantEconomics>;
  period: Scalars['String']['output'];
  /** Spend no workspace caused. */
  platform: AiCostTotals;
  /** Workspaces with any usage, before the 200 row cut. */
  tenantCount: Scalars['Int']['output'];
  /** Customer workspaces only. */
  totals: AiCostTotals;
};

export type AiFeatureCatalogEntry = {
  __typename?: 'AiFeatureCatalogEntry';
  area: Scalars['String']['output'];
  /** The rule the simulator starts this feature from. */
  defaultRule: AiCreditRuleKind;
  featureKey: Scalars['String']['output'];
  label: Scalars['String']['output'];
  proposedTreatment: Scalars['String']['output'];
};

export type AiFeatureEconomics = {
  __typename?: 'AiFeatureEconomics';
  area: Scalars['String']['output'];
  calls: Scalars['Int']['output'];
  /** Calls that did not return a usable answer. */
  failedCalls: Scalars['Int']['output'];
  featureKey: Scalars['String']['output'];
  inputTokens: Scalars['Float']['output'];
  label: Scalars['String']['output'];
  outputTokens: Scalars['Float']['output'];
  /** The starting treatment: INCLUDED, CHARGED or ABSORBED. */
  proposedTreatment: Scalars['String']['output'];
  /** What the provider charged, in US dollars. */
  providerCostUsd: Scalars['Float']['output'];
  tenantCount: Scalars['Int']['output'];
  /** Failed calls that may still have been billed. Their cost is recorded as 0 for want of a figure, so the total is a floor when this is above 0. */
  unknownCostCalls: Scalars['Int']['output'];
};

export type AiResolutionUsage = {
  __typename?: 'AiResolutionUsage';
  /** Everything the AI cost in the period, charged or not. Practice (sandbox) spend is left out. */
  aiSpendUsd: Scalars['Float']['output'];
  /** US dollars billed for the period. */
  amountUsd: Scalars['Float']['output'];
  /** The AI answered and the customer stayed silent for 24 hours. */
  assumed: Scalars['Int']['output'];
  /** Charges minus reversals: what is billed. */
  billable: Scalars['Int']['output'];
  /** The customer said the AI answer solved it. */
  confirmed: Scalars['Int']['output'];
  /** Calendar month, UTC, like 2026-10. */
  period: Scalars['String']['output'];
  /** US dollars per resolution. */
  priceUsd: Scalars['Float']['output'];
  /** What the AI cost on the tickets charged. */
  tokenCostUsd: Scalars['Float']['output'];
  /** Charges reversed in this period. */
  voided: Scalars['Int']['output'];
};

export type AiSimulatedFeature = {
  __typename?: 'AiSimulatedFeature';
  creditValueUsd: Scalars['Float']['output'];
  creditsUsed: Scalars['Float']['output'];
  featureKey: Scalars['String']['output'];
  label: Scalars['String']['output'];
  marginUsd: Scalars['Float']['output'];
  providerCostUsd: Scalars['Float']['output'];
  rule: AiCreditRuleKind;
};

export type AiSimulatedTenant = {
  __typename?: 'AiSimulatedTenant';
  creditsUsed: Scalars['Float']['output'];
  includedCredits: Scalars['Float']['output'];
  overAllowance: Scalars['Boolean']['output'];
  overageCredits: Scalars['Float']['output'];
  overageRevenueUsd: Scalars['Float']['output'];
  providerCostUsd: Scalars['Float']['output'];
  tenantId: Scalars['ID']['output'];
  tenantName?: Maybe<Scalars['String']['output']>;
};

export type AiSimulationTotals = {
  __typename?: 'AiSimulationTotals';
  /** Provider cost of the features that use credits. */
  coveredCostUsd: Scalars['Float']['output'];
  /** Credits used, at the candidate price. */
  creditValueUsd: Scalars['Float']['output'];
  creditsUsed: Scalars['Float']['output'];
  /** Credit value less the cost of the features that use credits. */
  marginUsd: Scalars['Float']['output'];
  overageCredits: Scalars['Float']['output'];
  /** What would be billed: credits beyond each allowance, at the price. */
  overageRevenueUsd: Scalars['Float']['output'];
  providerCostUsd: Scalars['Float']['output'];
  tenants: Scalars['Int']['output'];
  tenantsOverAllowance: Scalars['Int']['output'];
  /** Provider cost of included and absorbed features. */
  uncoveredCostUsd: Scalars['Float']['output'];
  /** Failed calls in the window that may still have been billed. Their cost is counted as 0, so the cost and margin figures are a floor and a ceiling respectively when this is above 0. */
  unknownCostCalls: Scalars['Int']['output'];
};

export type AiTenantEconomics = {
  __typename?: 'AiTenantEconomics';
  calls: Scalars['Int']['output'];
  /** Calls that did not return a usable answer. */
  failedCalls: Scalars['Int']['output'];
  inputTokens: Scalars['Float']['output'];
  outputTokens: Scalars['Float']['output'];
  /** What the provider charged, in US dollars. */
  providerCostUsd: Scalars['Float']['output'];
  tenantId: Scalars['ID']['output'];
  tenantName?: Maybe<Scalars['String']['output']>;
  topFeatureKey: Scalars['String']['output'];
  topFeatureLabel: Scalars['String']['output'];
  /** Failed calls that may still have been billed. Their cost is recorded as 0 for want of a figure, so the total is a floor when this is above 0. */
  unknownCostCalls: Scalars['Int']['output'];
};

export type AiUsageDay = {
  __typename?: 'AiUsageDay';
  actions: Scalars['Int']['output'];
  date: Scalars['String']['output'];
};

export type AiUsageFeature = {
  __typename?: 'AiUsageFeature';
  /** Calls it made to an AI model or search that returned an answer. One question or task can make several. */
  actions: Scalars['Int']['output'];
  area: Scalars['String']['output'];
  featureKey: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type AiUsageSummary = {
  __typename?: 'AiUsageSummary';
  daily: Array<AiUsageDay>;
  features: Array<AiUsageFeature>;
  period: Scalars['String']['output'];
  /** Calls across all the features shown. */
  totalActions: Scalars['Int']['output'];
};

/** What a scheduled charge is worth. BASE and USAGE point at the existing pricing engine; FLAT is a fixed amount; PERCENT_OF_BASE is a share of the covered base price. */
export enum AmountRuleType {
  Base = 'BASE',
  Flat = 'FLAT',
  PercentOfBase = 'PERCENT_OF_BASE',
  Usage = 'USAGE',
}

export type AnalyzeColumnsInput = {
  /** Column data to analyze */
  columns: Array<ColumnSampleInput>;
};

export type AnalyzeColumnsResult = {
  __typename?: 'AnalyzeColumnsResult';
  /** Error message if analysis failed */
  error?: Maybe<Scalars['String']['output']>;
  /** Analysis method used (ai or heuristic) */
  method: Scalars['String']['output'];
  /** Whether analysis was successful */
  success: Scalars['Boolean']['output'];
  /** Suggested mappings for each column */
  suggestions: Array<ColumnMappingSuggestion>;
};

/** Event a relative anchor resolves against. */
export enum AnchorEventType {
  ContractExpiry = 'CONTRACT_EXPIRY',
  CustomDate = 'CUSTOM_DATE',
  EmailOpened = 'EMAIL_OPENED',
  LeadCreated = 'LEAD_CREATED',
  LeadStageChanged = 'LEAD_STAGE_CHANGED',
  SubscriptionEnd = 'SUBSCRIPTION_END',
  SubscriptionRenewal = 'SUBSCRIPTION_RENEWAL',
}

/** Absolute vs relative scheduling. */
export enum AnchorType {
  Absolute = 'ABSOLUTE',
  Relative = 'RELATIVE',
}

export type ApiKey = {
  __typename?: 'ApiKey';
  /** Public GraphQL capabilities. Every key includes READ; WRITE is opt-in for mutations. */
  capabilities: Array<PublicApiCapability>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  issuedAt: Scalars['DateTime']['output'];
  issuedBy: Scalars['ID']['output'];
  /** First 12 characters of the key (e.g. rvly_sk_live_) — for display + rotation reference. */
  keyPrefix: Scalars['String']['output'];
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  rateLimits: ApiKeyRateLimits;
  revokedAt?: Maybe<Scalars['DateTime']['output']>;
  revokedBy?: Maybe<Scalars['ID']['output']>;
  rotatedToId?: Maybe<Scalars['ID']['output']>;
  /** Set during rotation; both keys valid until this timestamp */
  rotatingUntil?: Maybe<Scalars['DateTime']['output']>;
  scope: ApiKeyScope;
  status: ApiKeyStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type ApiKeyRateLimits = {
  __typename?: 'ApiKeyRateLimits';
  perMinute: Scalars['Int']['output'];
  perSecond: Scalars['Int']['output'];
};

export type ApiKeyRateLimitsInput = {
  perMinute?: InputMaybe<Scalars['Int']['input']>;
  perSecond?: InputMaybe<Scalars['Int']['input']>;
};

export type ApiKeyScope = {
  __typename?: 'ApiKeyScope';
  /** Empty list means "all endpoints". Wildcard "*" allowed. */
  endpoints: Array<Scalars['String']['output']>;
  /** Empty list means "all subscriptions" */
  subscriptionIds: Array<Scalars['ID']['output']>;
  /** Empty list means "all variables" */
  variableIds: Array<Scalars['ID']['output']>;
};

export type ApiKeyScopeInput = {
  /** Restrict to these endpoints (e.g. ["/usage", "/usage/set"]). Wildcard "*" allowed; trailing wildcards work as "/usage/*". */
  endpoints?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Restrict to these subscription IDs. Empty = all. */
  subscriptionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Restrict to these variable IDs. Empty = all. */
  variableIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Lifecycle state of an API key (PRD §12.8) */
export enum ApiKeyStatus {
  Active = 'ACTIVE',
  Revoked = 'REVOKED',
  Rotating = 'ROTATING',
}

/** Request counts for one API key over the last 24 hours, read from the rate limiter. Zero when Redis is unavailable. */
export type ApiKeyUsage = {
  __typename?: 'ApiKeyUsage';
  /** Requests in the current minute */
  currentMinute: Scalars['Int']['output'];
  /** Oldest first; the last entry is the current hour */
  hourly: Array<ApiKeyUsageHour>;
  last24Hours: Scalars['Int']['output'];
  throttledLast24Hours: Scalars['Int']['output'];
};

export type ApiKeyUsageHour = {
  __typename?: 'ApiKeyUsageHour';
  /** Start of the UTC hour */
  hourStart: Scalars['DateTime']['output'];
  /** Requests counted in this hour, refused ones included */
  requests: Scalars['Int']['output'];
  /** Requests refused with RATE_LIMITED in this hour */
  throttled: Scalars['Int']['output'];
};

export type ApplyCreditNoteInput = {
  /** Omit to apply as much as both sides allow — the smaller of the credit left and the invoice's outstanding balance. A larger figure is refused rather than overpaying. */
  amount?: InputMaybe<Scalars['Float']['input']>;
  creditNoteId: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  /** The outstanding receivable to settle. */
  toInvoiceId: Scalars['ID']['input'];
};

export type ApplyCreditNoteResult = {
  __typename?: 'ApplyCreditNoteResult';
  /** How much credit this call actually applied. */
  appliedAmount: Scalars['Float']['output'];
  /** The credit note after the application. */
  creditNote: SubscriptionInvoice;
  /** Credit still available on the note. */
  creditRemaining: Scalars['Float']['output'];
  /** The receivable that was settled down. */
  invoice: SubscriptionInvoice;
};

export type ApplyDiscountInput = {
  /** Also apply to Adjustment/proration invoices (§8.9). Default true. */
  applyToAdjustments?: InputMaybe<Scalars['Boolean']['input']>;
  /** Library definition to apply (snapshots its terms). Omit for a one-off. */
  definitionId?: InputMaybe<Scalars['ID']['input']>;
  /** Optional calendar end. The discount stops applying to invoices billing service on or after this date, independently of its renewal-count duration — whichever runs out first ends it. Omit for no calendar bound. */
  endsAt?: InputMaybe<Scalars['String']['input']>;
  /** PER_UNIT or FLAT_LUMP_SUM for a fixed discount on a component (§8.3). Default PER_UNIT. */
  fixedMode?: InputMaybe<FixedDiscountMode>;
  /** COMPONENT targets only: discount at most this many of the billed units (e.g. 3 of 15 seats). Omit to discount every unit. */
  maxQuantity?: InputMaybe<Scalars['Float']['input']>;
  /** One-off terms — required when definitionId is omitted (§8.6). */
  oneOff?: InputMaybe<OneOffDiscountInput>;
  /** Free-text reason, recorded in the audit trail (§8.14 — required). */
  reason: Scalars['String']['input'];
  subscriptionId: Scalars['ID']['input'];
  /** Required for a COMPONENT target. */
  targetComponentId?: InputMaybe<Scalars['ID']['input']>;
  /** Exactly one target per instance (§8.2). */
  targetElementType: DiscountTargetType;
};

/** The result of an owner deciding on an approval request */
export type ApproveInviteRequestResult = {
  __typename?: 'ApproveInviteRequestResult';
  request: InviteApprovalRequest;
  sent: SendMemberInvitesResult;
  /** People left out because they joined or were invited since the request was made */
  skipped: Array<Scalars['String']['output']>;
};

export type ArchiveCrmPipelineInput = {
  /** Where the deals go. Required when the pipeline still has deals. */
  moveDealsToPipelineId?: InputMaybe<Scalars['ID']['input']>;
  /** Per-stage destinations. Unmapped stages go to the same-named stage on the destination, else its first stage of the same kind. */
  stageMappings?: InputMaybe<Array<PipelineStageMappingInput>>;
};

export type AssigneeInput = {
  assigneeId: Scalars['ID']['input'];
  assigneeType?: AssigneeType;
};

/** Assignee kind. v1 accepts USER only; AGENT is reserved. */
export enum AssigneeType {
  Agent = 'AGENT',
  User = 'USER',
}

export enum AssistantOnboardingMode {
  Docked = 'DOCKED',
  FullPage = 'FULL_PAGE',
}

export enum AssistantOnboardingPhase {
  Complete = 'COMPLETE',
  Discovery = 'DISCOVERY',
  Tour = 'TOUR',
  TrialSetup = 'TRIAL_SETUP',
}

/** Assistant-led onboarding, as the signed-in person sees it */
export type AssistantOnboardingState = {
  __typename?: 'AssistantOnboardingState';
  gate: OnboardingGateType;
  gatePassedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The signed-in person owns the workspace; only they run its onboarding */
  isOwner: Scalars['Boolean']['output'];
  mode?: Maybe<AssistantOnboardingMode>;
  /** The workspace is in (or may start) assistant-led onboarding */
  open: Scalars['Boolean']['output'];
  phase?: Maybe<AssistantOnboardingPhase>;
  started: Scalars['Boolean']['output'];
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The tour, while it runs; null before the trial is confirmed and after it ends */
  tour?: Maybe<OnboardingTourType>;
};

export type AtRiskSubscription = {
  __typename?: 'AtRiskSubscription';
  /** Monthly recurring amount in the reporting currency. */
  amount: Scalars['Float']['output'];
  /** Whole days between renewalDueDate and now. Null when there is no due date. */
  daysOverdue?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  organizationName: Scalars['String']['output'];
  /** Why this subscription is flagged: RENEWAL_OVERDUE or AWAITING_PAYMENT. */
  reason: Scalars['String']['output'];
  renewalDueDate?: Maybe<Scalars['DateTime']['output']>;
  /** Subscription status — GRACE_PERIOD, ACTIVE, etc. */
  status: Scalars['String']['output'];
};

export type AtRiskSummary = {
  __typename?: 'AtRiskSummary';
  amount: Scalars['Float']['output'];
  count: Scalars['Int']['output'];
  subscriptions: Array<AtRiskSubscription>;
};

export type AttachmentInput = {
  fileId: Scalars['ID']['input'];
  filename: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
  sizeBytes: Scalars['Int']['input'];
};

export type BackfillComponentQuantityInput = {
  /** Variable Component the quantity applies to. */
  componentId: Scalars['ID']['input'];
  /** Billed quantity of this component for the period. Interpreted as the measured usage for the period (overage is computed against the component inclusion, exactly like a live renewal). COMMISSION components bill on GMV and ignore this value. */
  quantity: Scalars['Float']['input'];
};

export type BackfillExchangeRatesInput = {
  /** End date for backfill (YYYY-MM-DD) */
  endDate: Scalars['String']['input'];
  /** Start date for backfill (YYYY-MM-DD) */
  startDate: Scalars['String']['input'];
};

export type BackfillExchangeRatesResult = {
  __typename?: 'BackfillExchangeRatesResult';
  /** Number of days with errors */
  errors: Scalars['Int']['output'];
  /** Number of days successfully fetched */
  fetched: Scalars['Int']['output'];
  /** Status message */
  message: Scalars['String']['output'];
  /** Number of days skipped (already exist) */
  skipped: Scalars['Int']['output'];
};

export type BackfillPeriodInput = {
  /** Per-component billed quantities for this backfilled invoice. Any component the subscription bills that is omitted here falls back to its creation-time starting quantity. Honoured only when `backfillInvoicesUntilNow` is true. */
  componentQuantities?: InputMaybe<Array<BackfillComponentQuantityInput>>;
  /** Whether this backfilled invoice is marked paid. */
  paid: Scalars['Boolean']['input'];
  /** Date the invoice was paid / received. Honoured only when `paid` is true; defaults to the issue date when omitted. */
  paidDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Issue date (period start) of the backfilled invoice this override targets. Matched against the periods the backfill generates from the subscription start date. */
  periodStartDate: Scalars['DateTime']['input'];
};

export type BackfillSnapshotsResult = {
  __typename?: 'BackfillSnapshotsResult';
  created: Scalars['Int']['output'];
  errors: Scalars['Int']['output'];
  message: Scalars['String']['output'];
};

/** Which identifier scheme a bank account entry uses, so only the relevant fields need to be filled in. */
export enum BankAccountType {
  Iban = 'IBAN',
  RoutingSort = 'ROUTING_SORT',
  Swift = 'SWIFT',
}

/** Per-subscription base-price override (PRD §7.4). Present when the base price was deliberately set away from the catalog list price. `value` is what is billed; `listValueAtOverride` is a reference snapshot never used in calculations. */
export type BasePriceOverride = {
  __typename?: 'BasePriceOverride';
  effectiveDate: Scalars['DateTime']['output'];
  effectiveMode: PriceEffectiveMode;
  /** Catalog list price snapshot at the moment of the last override. */
  listValueAtOverride?: Maybe<Scalars['Decimal']['output']>;
  /** The base price billed immediately before this override. For a PROSPECTIVE override this is what the customer keeps paying (and what analytics reports) until effectiveDate. */
  previousValue?: Maybe<Scalars['Decimal']['output']>;
  /** The overridden base price actually billed. */
  value: Scalars['Decimal']['output'];
};

export type BilledRevenueByLineKind = {
  __typename?: 'BilledRevenueByLineKind';
  /** Billed amount in this row’s own invoice currency. */
  amount: Scalars['Float']['output'];
  /** Billed amount converted to the tenant's reporting currency, each invoice at its own invoice date. Null when no reporting currency was requested, or when a rate could not be resolved — never a silently unconverted native figure. */
  amountInReportingCurrency?: Maybe<Scalars['Float']['output']>;
  /** The invoice currency this row is denominated in. */
  currency: Scalars['String']['output'];
  /** How many invoice lines are behind this figure. */
  lineCount: Scalars['Int']['output'];
  /** The line kind: BASE / BASE_SPLIT (recurring plan), VARIABLE (usage), FREE_INCLUSION, PRORATION, ONE_TIME_FEE, CREDIT. Null for lines written before line typing existed and not reached by the backfill (imported invoices) — reported rather than dropped, so the split always reconciles with the invoice totals. */
  lineKind?: Maybe<Scalars['String']['output']>;
  periodEnd: Scalars['DateTime']['output'];
  periodStart: Scalars['DateTime']['output'];
  reportingCurrency?: Maybe<Scalars['String']['output']>;
};

/** Which number in the period is rated: MAX (highest observed), TOTAL (sum over the period), or CLOSING (value at period end). */
export enum BilledValue {
  Closing = 'CLOSING',
  Max = 'MAX',
  Total = 'TOTAL',
}

/** What a prepaid span means on cancellation. Governs cancellation only, never invoicing: BINDING owes the span and extends the term to it, REFUNDABLE credits the unconsumed whole periods back, NONE is standard cancellation. */
export enum BillingCommitment {
  Binding = 'BINDING',
  None = 'NONE',
  Refundable = 'REFUNDABLE',
}

export type BillingPeriodSnapshot = {
  __typename?: 'BillingPeriodSnapshot';
  /** When set, this snapshot adjusts the original snapshot identified here (PRD §21.3) */
  adjustmentForSnapshotId?: Maybe<Scalars['ID']['output']>;
  /** The locked term this line was billed for. */
  billedPeriod?: Maybe<SubscriptionPeriod>;
  billedQuantity: Scalars['Float']['output'];
  /** Which number in the period is rated: MAX, TOTAL or CLOSING. Null until migration 0028 has run — resolve via measurement-axis.util. */
  billedValue?: Maybe<BilledValue>;
  billingTiming: BillingTiming;
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  customAgreementId?: Maybe<Scalars['ID']['output']>;
  discountApplied: Scalars['Decimal']['output'];
  freeAllowanceApplied: Scalars['Decimal']['output'];
  id: Scalars['ID']['output'];
  invoiceId: Scalars['ID']['output'];
  measurementMode: MeasurementMode;
  modelType: PricingModelType;
  periodEnd: Scalars['DateTime']['output'];
  periodStart: Scalars['DateTime']['output'];
  /** Scope chain level the applied price was resolved from per v4 §7.1 (SUBSCRIPTION / BUNDLE / MODULE / GLOBAL_DEFAULT). */
  priceScope: VariableComponentPriceScope;
  /** scopeId on the resolved VariableComponentPrice; null for GLOBAL_DEFAULT. */
  priceScopeId?: Maybe<Scalars['ID']['output']>;
  /** scopeVersion (MODULE/BUNDLE) on the resolved VariableComponentPrice. */
  priceScopeVersion?: Maybe<Scalars['Int']['output']>;
  /** Currency variant that was applied (matches `currency`). */
  priceVariantCurrency: Scalars['String']['output'];
  /** True when a per-term price override produced the variant. */
  priceVariantFromPeriodOverride?: Maybe<Scalars['Boolean']['output']>;
  promotionId?: Maybe<Scalars['ID']['output']>;
  prorationApplied: Scalars['Boolean']['output'];
  prorationFactor?: Maybe<Scalars['Float']['output']>;
  regionId?: Maybe<Scalars['ID']['output']>;
  /** Resets each period (PER_PERIOD) or carries forward (STANDING). Null until migration 0028 has run — resolve via measurement-axis.util. */
  resetBehaviour?: Maybe<ResetBehaviour>;
  subscriptionId: Scalars['ID']['output'];
  subtotal: Scalars['Decimal']['output'];
  tenantId: Scalars['ID']['output'];
  totalCharged: Scalars['Decimal']['output'];
  unitPriceApplied: Scalars['Decimal']['output'];
  variableComponentId: Scalars['ID']['output'];
  variableId: Scalars['ID']['output'];
};

/** When and how a subscription is invoiced. */
export type BillingSchedule = {
  __typename?: 'BillingSchedule';
  activatedAt?: Maybe<Scalars['DateTime']['output']>;
  activationDeadlineAt?: Maybe<Scalars['DateTime']['output']>;
  /** Signed but not switched on: the ACTIVATION trigger has not fired, so this subscription’s term dates are provisional and activating will re-anchor them. Read this rather than deriving it — it needs all three facts (the subscription PENDING, the clock starting at go-live, and the schedule still PENDING), and a caller holding only some of them cannot tell a deferred deal from an ordinary future-dated start, where nothing is provisional and firing ACTIVATION is a no-op. */
  awaitingGoLive: Scalars['Boolean']['output'];
  charges: Array<ScheduleCharge>;
  clockStart: ClockStart;
  commitment: BillingCommitment;
  /** How far the base charge has been billed. Every renewal ending on or before this date skips its base line — the mechanism by which a prepaid span is honoured. */
  coveredThrough?: Maybe<Scalars['DateTime']['output']>;
  /** False when the subscription stores no schedule and this is the implicit default — base and ADVANCE components at period start, ARREARS components at period close. */
  isExplicit: Scalars['Boolean']['output'];
  /** Periods paid upfront, when this schedule carries a prepaid span. Null otherwise. */
  prepaidPeriods?: Maybe<Scalars['Int']['output']>;
  /** What the prepay incentive discounts: the base, the standing components paid ahead, or both. A term sold before the choice existed reads BASE, which is what it was. Null whenever prepayDiscountPercent is. */
  prepayDiscountAppliesTo?: Maybe<PrepayDiscountScope>;
  /** The prepay incentive agreed on a prepaid term, as a percentage. Null when none was given or the schedule carries no prepaid span. */
  prepayDiscountPercent?: Maybe<Scalars['Float']['output']>;
  presetType: SchedulePreset;
  status: BillingScheduleStatus;
  subscriptionId: Scalars['ID']['output'];
  /** Total periods covered; null is open-ended. */
  term?: Maybe<Scalars['Int']['output']>;
};

export type BillingSchedulePresetInput = {
  /** Whether the prepayment is binding. Defaults to the tenant's billingScheduleConfig.defaultCommitment. BINDING extends the term to the paid-through date on cancellation; REFUNDABLE stops at the current period end and credits the unconsumed whole periods back. */
  commitment?: InputMaybe<BillingCommitment>;
  /** DEFERRED_ACTIVATION: days the deal may sit un-activated before the daily sweep raises it with the workspace. Defaults to the tenant's billingScheduleConfig.defaultActivationGapDays. No auto-activation and no auto-cancel — only an alert. */
  maxGapDays?: InputMaybe<Scalars['Int']['input']>;
  /** PREPAID_TERM: how many consecutive billing periods the customer pays for upfront. Two or more — a single period is an ordinary subscription and needs no schedule. The base charge appears on the start invoice with this quantity, the invoice period runs to the end of the span, and the renewal cron skips the base charge for every covered period. Usage is still metered and billed period by period. */
  prepaidPeriods?: InputMaybe<Scalars['Int']['input']>;
  /** What the prepay incentive discounts: the BASE price (default), the standing COMPONENTS paid ahead with it, or BOTH. Each is an ordinary FIXED_COUNT discount instance over the prepaid periods — one on the base, one per prepaid component. */
  prepayDiscountAppliesTo?: InputMaybe<PrepayDiscountScope>;
  /** Prepay incentive, as a percentage off what is paid upfront (see prepayDiscountAppliesTo). Recorded as ordinary FIXED_COUNT discount instances, so it shows on the subscription like any other discount and expires with the span rather than running on. */
  prepayDiscountPercent?: InputMaybe<Scalars['Float']['input']>;
  /** Which preset to derive the schedule from: PREPAID_TERM (first N periods billed upfront) or DEFERRED_ACTIVATION (part of the first period at signing, the rest at go-live). CUSTOM is refused rather than silently ignored — the fields below say which preset they belong to. */
  preset: SchedulePreset;
  /** DEFERRED_ACTIVATION: one-time setup fee raised on the signing invoice, in the subscription's locked currency. Billed as its own line and deliberately not a base-price discount target — "20% off the plan" does not mean 20% off a setup fee. */
  setupFee?: InputMaybe<Scalars['Float']['input']>;
  /** DEFERRED_ACTIVATION: share of the first period's base billed at signing (0–100). The remainder bills when the customer goes live. 0 and 100 are both meaningful: 0 is "nothing until go-live" and 100 is "pay now, start when ready". The discount is computed once over the whole first period and then split, so a fixed amount off the plan is not taken twice. */
  signingChargePercent?: InputMaybe<Scalars['Float']['input']>;
};

/** Lifecycle of a billing schedule: PENDING (awaiting activation) → ACTIVE → COMPLETE, or CANCELLED when the subscription is cancelled first. */
export enum BillingScheduleStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Complete = 'COMPLETE',
  Pending = 'PENDING',
}

/** Whether the component is billed at period start (ADVANCE) or end (ARREARS) */
export enum BillingTiming {
  Advance = 'ADVANCE',
  Arrears = 'ARREARS',
}

/** Immutable audit entry for a per-subscription component billing-timing override (arrears vs advance). */
export type BillingTimingOverrideHistoryEntry = {
  __typename?: 'BillingTimingOverrideHistoryEntry';
  changedAt: Scalars['DateTime']['output'];
  /** User who made the change. */
  changedBy?: Maybe<Scalars['String']['output']>;
  /** The component whose billing timing was overridden. */
  componentId: Scalars['ID']['output'];
  /** Always PROSPECTIVE — timing changes only apply from the next billing cycle (§7.3). */
  effectiveMode: PriceEffectiveMode;
  id: Scalars['ID']['output'];
  /** New billing timing now pinned on the component. */
  newValue: BillingTiming;
  /** Prior effective timing (the product default if this is the first override). */
  oldValue: BillingTiming;
  /** Snapshot of the product component's default timing at the moment of this change. */
  productDefaultAtChange?: Maybe<BillingTiming>;
  /** Free-text reason entered by the user. */
  reason?: Maybe<Scalars['String']['output']>;
  subscriptionId: Scalars['ID']['output'];
};

/** Outcome of a per-subscription component billing-timing override. Always takes effect at the next billing cycle. */
export type BillingTimingOverrideResult = {
  __typename?: 'BillingTimingOverrideResult';
  componentId: Scalars['ID']['output'];
  /** Start of the next billing cycle for this component — the first cycle billed under the new timing. */
  effectiveFrom?: Maybe<Scalars['DateTime']['output']>;
  /** New billing timing pinned on the component. */
  newValue: BillingTiming;
  /** Human-readable summary of when the change lands. */
  note?: Maybe<Scalars['String']['output']>;
  /** Prior effective timing. */
  oldValue: BillingTiming;
  /** The product component's current default timing (reference only). */
  productDefault?: Maybe<BillingTiming>;
  subscriptionId: Scalars['ID']['output'];
};

/** How much of this tenant's daily prospect-creation allowance today has used, and when it resets. */
export type BookingIntakeCapStatus = {
  __typename?: 'BookingIntakeCapStatus';
  /** Whether further bookings from strangers are being dropped. They are still recorded as meetings when an attendee is a known client. */
  capReached: Scalars['Boolean']['output'];
  /** Prospects this tenant may create from bookings in one UTC day. */
  dailyProspectCap: Scalars['Int']['output'];
  /** Prospects created so far today. Counts prospects created, not bookings received — a redelivered webhook that resolves to an existing lead consumes nothing. */
  prospectsCreatedToday: Scalars['Int']['output'];
  /** What is left of the allowance. Never negative. */
  remainingToday: Scalars['Int']['output'];
  /** When the count returns to zero. Sent as an instant so it can be shown in the reader’s own timezone — the boundary itself is UTC midnight. */
  windowResetsAt: Scalars['DateTime']['output'];
};

/** An organization a revert is keeping, and why. */
export type BookingIntakeKeptOrganization = {
  __typename?: 'BookingIntakeKeptOrganization';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** reused_pre_existing | has_subscriptions | has_invoices | has_other_contacts | has_other_leads | has_other_crm_records | promoted_to_client */
  reason: Scalars['String']['output'];
};

/** An organization named by a revert plan. */
export type BookingIntakeOrganizationRef = {
  __typename?: 'BookingIntakeOrganizationRef';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** What reverting a booking intake run would remove, or did remove. Organizations are only deleted when intake created them and nothing else references them. */
export type BookingIntakeRevertPlanResult = {
  __typename?: 'BookingIntakeRevertPlanResult';
  /** Contacts the run created. */
  contacts: Scalars['Int']['output'];
  /** Leads the run created. */
  leads: Scalars['Int']['output'];
  /** Meetings the run recorded. */
  meetings: Scalars['Int']['output'];
  /** Organizations actually deleted. Always zero for a preview. */
  organizationsDeleted: Scalars['Int']['output'];
  /** Organizations the run touched that are staying, each with its reason. */
  organizationsKept: Array<BookingIntakeKeptOrganization>;
  /** Organizations that will be deleted, or were. */
  organizationsToDelete: Array<BookingIntakeOrganizationRef>;
};

/** A scheduling link this tenant has opted into prospect creation for. Absent means disabled. */
export type BookingIntakeRoute = {
  __typename?: 'BookingIntakeRoute';
  createdAt: Scalars['DateTime']['output'];
  enabled: Scalars['Boolean']['output'];
  /** Names this link is matched by on the mail path, which only ever sees an ICS SUMMARY. Stored normalised (lowercased, whitespace collapsed). */
  eventTypeNames: Array<Scalars['String']['output']>;
  /** Calendly's stable event-type URI. Survives renaming the link in Calendly. */
  eventTypeUri?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** When a booking last matched this route, by either key. */
  lastMatchedAt?: Maybe<Scalars['DateTime']['output']>;
  /** When a booking last matched one of the name aliases. Stops moving when the link is renamed in Calendly, which is how a silently-broken mail path becomes visible rather than inferred. */
  lastNameMatchedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Pipeline new leads land in. Null uses the tenant default. */
  pipelineId?: Maybe<Scalars['ID']['output']>;
  /** Stage new leads land in. Null uses the pipeline's first OPEN stage. */
  pipelineStageId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type BookingIntakeRouteInput = {
  /** Defaults to true on create. */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Names to match on the mail path. Normalised on write, so case and spacing do not matter. */
  eventTypeNames?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Calendly's event-type URI. Omit for a name-only route (no Calendly connection). */
  eventTypeUri?: InputMaybe<Scalars['String']['input']>;
  /** Null uses the tenant default pipeline. */
  pipelineId?: InputMaybe<Scalars['ID']['input']>;
  /** Null uses the first OPEN stage. */
  pipelineStageId?: InputMaybe<Scalars['ID']['input']>;
};

/** How soon a client must be told of a personal data breach. */
export type BreachNotificationClause = {
  __typename?: 'BreachNotificationClause';
  /** Hours after becoming aware. Null: no number, e.g. "without undue delay". */
  hours?: Maybe<Scalars['Int']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  /** The contract's own words. */
  quote?: Maybe<Scalars['String']['output']>;
};

export type BreachNotificationClauseInput = {
  hours?: InputMaybe<Scalars['Int']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  quote?: InputMaybe<Scalars['String']['input']>;
};

/** Breach terms read from a document, before a person checks them. */
export type BreachNotificationProposal = {
  __typename?: 'BreachNotificationProposal';
  hours?: Maybe<Scalars['Int']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  quote?: Maybe<Scalars['String']['output']>;
};

export type BulkClientFailure = {
  __typename?: 'BulkClientFailure';
  organizationId: Scalars['ID']['output'];
  reason: Scalars['String']['output'];
};

export type BulkDeleteInvoicesInput = {
  /** Delete even when the invoice has payments, credit notes, a card charge or billing history. The invoice is copied to an audit collection first. */
  force?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceIds: Array<Scalars['ID']['input']>;
};

export type BulkEnableOrganizationFeatureFlagInput = {
  featureFlagId: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  organizationIds: Array<Scalars['ID']['input']>;
};

export type BulkEnterUsageReadingRowInput = {
  netGmv?: InputMaybe<Scalars['Float']['input']>;
  quantity: Scalars['Float']['input'];
  readingId: Scalars['ID']['input'];
  transactionCount?: InputMaybe<Scalars['Int']['input']>;
};

export type BulkEnterUsageReadingsInput = {
  rows: Array<BulkEnterUsageReadingRowInput>;
};

/** Result of bulk-entering quantities on closed-period readings (Phase 6). */
export type BulkEnterUsageReadingsResult = {
  __typename?: 'BulkEnterUsageReadingsResult';
  /** Human-readable failure messages, one per failed row. */
  errors: Array<Scalars['String']['output']>;
  /** Rows that failed validation or concurrent claim. */
  failedCount: Scalars['Int']['output'];
  /** Readings successfully sealed with a quantity. */
  sealed: Array<UsageReading>;
};

export type BulkInvoiceActionFailure = {
  __typename?: 'BulkInvoiceActionFailure';
  invoiceId: Scalars['ID']['output'];
  /** Invoice number, when it has one. */
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  reason: Scalars['String']['output'];
};

export type BulkInvoiceActionResult = {
  __typename?: 'BulkInvoiceActionResult';
  failed: Array<BulkInvoiceActionFailure>;
  succeededIds: Array<Scalars['ID']['output']>;
};

export type BulkInvoiceIdsInput = {
  invoiceIds: Array<Scalars['ID']['input']>;
};

export type BulkMarkInvoicesPaidInput = {
  invoiceIds: Array<Scalars['ID']['input']>;
  /** Day the payments were received. Defaults to today. */
  paidAt?: InputMaybe<Scalars['String']['input']>;
};

export type BulkMigrationFailure = {
  __typename?: 'BulkMigrationFailure';
  message: Scalars['String']['output'];
  subscriptionId: Scalars['ID']['output'];
};

export type BulkMigrationResult = {
  __typename?: 'BulkMigrationResult';
  attempted: Scalars['Int']['output'];
  failed: Scalars['Int']['output'];
  failures: Array<BulkMigrationFailure>;
  succeeded: Scalars['Int']['output'];
  succeededIds: Array<Scalars['ID']['output']>;
};

export type BulkOperationItemResult = {
  __typename?: 'BulkOperationItemResult';
  error?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type BulkOperationResult = {
  __typename?: 'BulkOperationResult';
  failureCount: Scalars['Int']['output'];
  results: Array<BulkOperationItemResult>;
  successCount: Scalars['Int']['output'];
};

/** Resolution mode for bulk discrepancy resolution */
export enum BulkResolutionMode {
  AcceptSource_1 = 'ACCEPT_SOURCE_1',
  AcceptSource_2 = 'ACCEPT_SOURCE_2',
}

export type BulkResolveInput = {
  resolution: BulkResolutionMode;
};

export type BulkResolveResult = {
  __typename?: 'BulkResolveResult';
  failedCount: Scalars['Int']['output'];
  failures: Array<Scalars['String']['output']>;
  resolvedCount: Scalars['Int']['output'];
};

export type BulkUpdateClientsInput = {
  /** Tags to put on every client. */
  addTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Clear the status (ignored when `csLifecycleStatus` is set). */
  clearCsStatus?: InputMaybe<Scalars['Boolean']['input']>;
  /** Clear the manager (ignored when `csmUserId` is set). */
  clearCsm?: InputMaybe<Scalars['Boolean']['input']>;
  /** Set this customer-success status. */
  csLifecycleStatus?: InputMaybe<CsLifecycleStatus>;
  /** Assign this customer-success manager. */
  csmUserId?: InputMaybe<Scalars['ID']['input']>;
  organizationIds: Array<Scalars['ID']['input']>;
  /** Tags to take off every client. */
  removeTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type BulkUpdateClientsResult = {
  __typename?: 'BulkUpdateClientsResult';
  failures: Array<BulkClientFailure>;
  requested: Scalars['Int']['output'];
  /** Clients that already had everything asked for. */
  unchanged: Scalars['Int']['output'];
  /** Clients that changed. */
  updated: Scalars['Int']['output'];
};

export type BulkUpdatePaymentStatusInput = {
  invoiceIds: Array<Scalars['ID']['input']>;
  newStatus: PaymentStatus;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type Bundle = {
  __typename?: 'Bundle';
  /** Active pricing rules only (excludes inactive/draft rules) */
  activePricing?: Maybe<Array<PricingRule>>;
  /** Full history across all versions in the chain, newest first. */
  allVersionsSummary: Array<BundleVersionSummary>;
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  archivedBy?: Maybe<Scalars['String']['output']>;
  /** Subscription periods available for this bundle */
  availablePeriods: Array<SubscriptionPeriod>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** When this version took effect. A version runs until the next one in its lineage begins, so there is no stored end date. Null on a draft that has never published. */
  effectiveFrom?: Maybe<Scalars['DateTime']['output']>;
  featureFlagIds?: Maybe<Array<Scalars['String']['output']>>;
  featureFlags?: Maybe<Array<BundleFeatureFlag>>;
  id: Scalars['ID']['output'];
  /** Stable identity shared by every version in this chain (the id of its root version). Group by this to address one plan rather than one version of it. */
  lineageId?: Maybe<Scalars['ID']['output']>;
  /** Versioned module references included in this bundle. */
  moduleRefs: Array<BundleModuleRef>;
  modules?: Maybe<Array<BundleModule>>;
  name: Scalars['String']['output'];
  /** The _id of the prior published version document. */
  previousVersionId?: Maybe<Scalars['ID']['output']>;
  pricing?: Maybe<Array<PricingRule>>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  publishedBy?: Maybe<Scalars['String']['output']>;
  status: EntityStatus;
  tier?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
  /** Variable components referenced directly by this bundle. */
  variableComponentRefs: Array<BundleVariableComponentRef>;
  /** Version number. Each publishNewVersion creates a new document. */
  version: Scalars['Int']['output'];
  /** Convenience log of prior version entries. */
  versionHistory: Array<BundleVersionEntry>;
};

export type BundleFeatureFlag = {
  __typename?: 'BundleFeatureFlag';
  bundle: Bundle;
  bundleId: Scalars['String']['output'];
  featureFlag: FeatureFlag;
  featureFlagId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type BundleFilterInput = {
  /** Search across name and description fields (partial match) */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Filter by bundle status */
  status?: InputMaybe<EntityStatus>;
  /** Filter by bundle tier */
  tier?: InputMaybe<Scalars['String']['input']>;
};

export type BundleModule = {
  __typename?: 'BundleModule';
  bundle: Bundle;
  bundleId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  module: Module;
  moduleId: Scalars['String']['output'];
};

export type BundleModuleRef = {
  __typename?: 'BundleModuleRef';
  moduleId: Scalars['ID']['output'];
  moduleVersion: Scalars['Int']['output'];
};

export type BundlePricingOption = {
  __typename?: 'BundlePricingOption';
  breakdown: PricingBreakdown;
  bundleId: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  limits: PricingLimits;
  totalPrice: Scalars['Float']['output'];
};

export type BundleVariableComponentRef = {
  __typename?: 'BundleVariableComponentRef';
  autoIncludeOnSubscribe: Scalars['Boolean']['output'];
  componentId: Scalars['ID']['output'];
  componentVersion: Scalars['Int']['output'];
  includedQuantity?: Maybe<Scalars['Int']['output']>;
  includedTransactionCount?: Maybe<Scalars['Int']['output']>;
  /** Per-term inclusion overrides; the matching term wins over the period-agnostic inclusion. */
  inclusionByPeriod?: Maybe<Array<InclusionPeriodEntry>>;
  notes?: Maybe<Scalars['String']['output']>;
};

export type BundleVersionEntry = {
  __typename?: 'BundleVersionEntry';
  changedAt: Scalars['DateTime']['output'];
  changedBy?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  version: Scalars['Int']['output'];
};

/** Published-version summary used in cross-version history chains. */
export type BundleVersionSummary = {
  __typename?: 'BundleVersionSummary';
  /** Differences against the version this one was branched from. */
  changes: Array<VersionChange>;
  /** When this version took effect — the start of its window. The lineage is ordered by THIS, not by publishedAt (when the document was written down) and not by version number. A version's window runs until the next one begins. */
  effectiveFrom?: Maybe<Scalars['DateTime']['output']>;
  /** This version's own document id. Each version is a separate document, so this is what a caller pins or migrates onto — the version NUMBER is not addressable on its own. */
  id?: Maybe<Scalars['ID']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  publishedBy?: Maybe<Scalars['String']['output']>;
  /** DRAFT / PUBLISHED / ARCHIVED. Read this rather than inferring from the version number: numbering is immutable mint order, so a retro-authored version holds the highest number in its lineage while being archived and first in time. */
  status?: Maybe<Scalars['String']['output']>;
  version: Scalars['Int']['output'];
  versionHistory: Array<BundleVersionEntry>;
};

/** What started a website pull */
export enum BusinessProfilePullTrigger {
  Manual = 'MANUAL',
  OkrCycleCreated = 'OKR_CYCLE_CREATED',
}

/** A draft read from the website. Nothing is saved until the form is. */
export type BusinessProfilePullType = {
  __typename?: 'BusinessProfilePullType';
  /** Fields where the website says something different from what is saved */
  changedFields: Array<Scalars['String']['output']>;
  /** Who buys, in the company’s own words */
  customerSegments?: Maybe<Scalars['String']['output']>;
  /** A short industry label */
  industry?: Maybe<Scalars['String']['output']>;
  pagesRead: Array<Scalars['String']['output']>;
  /** How it charges */
  pricingModel?: Maybe<Scalars['String']['output']>;
  pulledAt: Scalars['DateTime']['output'];
  salesModels: Array<SalesModel>;
  /** About 80 words: what the company does, for whom, how it makes money */
  summary?: Maybe<Scalars['String']['output']>;
  teamSize?: Maybe<TeamSizeRange>;
  /** The main problem it solves and why customers choose it */
  valueProposition?: Maybe<Scalars['String']['output']>;
  website: Scalars['String']['output'];
};

/** A website read nobody has accepted yet, started by a new OKR cycle. Offered in the form; never read by the OKR review. */
export type BusinessProfileSuggestionType = {
  __typename?: 'BusinessProfileSuggestionType';
  /** Who buys, in the company’s own words */
  customerSegments?: Maybe<Scalars['String']['output']>;
  /** The OKR cycle whose creation started the read */
  cycleName?: Maybe<Scalars['String']['output']>;
  /** A short industry label */
  industry?: Maybe<Scalars['String']['output']>;
  pagesRead: Array<Scalars['String']['output']>;
  /** How it charges */
  pricingModel?: Maybe<Scalars['String']['output']>;
  pulledAt: Scalars['DateTime']['output'];
  salesModels: Array<SalesModel>;
  /** About 80 words: what the company does, for whom, how it makes money */
  summary?: Maybe<Scalars['String']['output']>;
  teamSize?: Maybe<TeamSizeRange>;
  trigger: BusinessProfilePullTrigger;
  /** The main problem it solves and why customers choose it */
  valueProposition?: Maybe<Scalars['String']['output']>;
  website: Scalars['String']['output'];
};

/** What the company does, as its administrators saved it. The OKR draft review reads it as context. */
export type BusinessProfileType = {
  __typename?: 'BusinessProfileType';
  /** Things the company will not do, one each. Written by a person; never drafted. */
  constraints: Array<Scalars['String']['output']>;
  /** Who buys, in the company’s own words */
  customerSegments?: Maybe<Scalars['String']['output']>;
  /** What matters most this period. Written by a person; never drafted from the website. */
  focus?: Maybe<Scalars['String']['output']>;
  /** A short industry label */
  industry?: Maybe<Scalars['String']['output']>;
  lastPulledAt?: Maybe<Scalars['DateTime']['output']>;
  /** How it charges */
  pricingModel?: Maybe<Scalars['String']['output']>;
  /** Whether "Pull from website" is configured on this server */
  pullAvailable: Scalars['Boolean']['output'];
  salesModels: Array<SalesModel>;
  /** The invoice header website, offered while the profile has none of its own */
  suggestedWebsite?: Maybe<Scalars['String']['output']>;
  suggestion?: Maybe<BusinessProfileSuggestionType>;
  /** About 80 words: what the company does, for whom, how it makes money */
  summary?: Maybe<Scalars['String']['output']>;
  teamSize?: Maybe<TeamSizeRange>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The main problem it solves and why customers choose it */
  valueProposition?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type CacheStats = {
  __typename?: 'CacheStats';
  errors: Scalars['Int']['output'];
  hitRate: Scalars['Float']['output'];
  hits: Scalars['Int']['output'];
  misses: Scalars['Int']['output'];
  totalRequests: Scalars['Int']['output'];
};

export type CalendarInvitePreview = {
  __typename?: 'CalendarInvitePreview';
  /** True when DTSTART was VALUE=DATE — show a date, not a clock time. */
  allDay: Scalars['Boolean']['output'];
  attendeeNames: Array<Scalars['String']['output']>;
  cancelled: Scalars['Boolean']['output'];
  conferenceUrl?: Maybe<Scalars['String']['output']>;
  endAt?: Maybe<Scalars['DateTime']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  startAt?: Maybe<Scalars['DateTime']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
};

/** A person in the connected Calendly organization. */
export type CalendlyDirectoryEntry = {
  __typename?: 'CalendlyDirectoryEntry';
  calendlyUserUri: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  schedulingUrl?: Maybe<Scalars['String']['output']>;
};

/** Outcome of disconnecting a tenant from Calendly. */
export type CalendlyDisconnectResult = {
  __typename?: 'CalendlyDisconnectResult';
  /** Whether there was a connection to disconnect. */
  disconnected: Scalars['Boolean']['output'];
  /** Whether the subscription was also removed at Calendly. False when there was nothing to remove or Calendly would not take it — ingestion stops on our side either way. */
  subscriptionRemoved: Scalars['Boolean']['output'];
};

/** A scheduling link on the connected Calendly organization, for picking which ones create prospects. */
export type CalendlyEventType = {
  __typename?: 'CalendlyEventType';
  /** Whether the link is live in Calendly. An inactive one takes no bookings, so routing it does nothing until it is switched back on. */
  active: Scalars['Boolean']['output'];
  /** The link’s current name in Calendly. */
  name: Scalars['String']['output'];
  /** Name of the Calendly user or team the link belongs to. */
  ownerName?: Maybe<Scalars['String']['output']>;
  /** Whether that route is switched on. Null when there is no route for this link. */
  routeEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** The booking intake route already covering this link, if any. Null means bookings on it create nothing. */
  routeId?: Maybe<Scalars['ID']['output']>;
  /** The public booking page for this link. Null when Calendly returned none. */
  schedulingUrl?: Maybe<Scalars['String']['output']>;
  /** Calendly's stable event-type URI. */
  uri: Scalars['String']['output'];
};

/** A tenant's Calendly webhook subscription. */
export type CalendlyIntegrationStatus = {
  __typename?: 'CalendlyIntegrationStatus';
  /** Whether this deployment has a Calendly OAuth app configured at all. False means the connect button cannot work and an administrator has to set the CALENDLY_* variables. */
  available: Scalars['Boolean']['output'];
  /** URI of the Calendly user who authorised the connection. */
  calendlyOwnerUri?: Maybe<Scalars['String']['output']>;
  /** Calendly organization or user URI it was set up for. */
  calendlyScopeUri?: Maybe<Scalars['String']['output']>;
  connected: Scalars['Boolean']['output'];
  enabled: Scalars['Boolean']['output'];
  /** Whether we hold a webhook subscription at Calendly that we created and can also remove. */
  subscribed: Scalars['Boolean']['output'];
  /** The URL Calendly posts deliveries to, shown for support. Null when the API base URL is not configured. */
  webhookUrl?: Maybe<Scalars['String']['output']>;
};

export type CalendlyMappingResult = {
  __typename?: 'CalendlyMappingResult';
  mapped: Scalars['Int']['output'];
  /** Reasons, one per person who could not be linked. */
  skipped: Array<Scalars['String']['output']>;
};

export enum CalendlyMappingSource {
  EmailMatch = 'EMAIL_MATCH',
  Manual = 'MANUAL',
}

/** Everything the Calendly member-mapping screen renders. */
export type CalendlyMappingView = {
  __typename?: 'CalendlyMappingView';
  /** Calendly could not be read just now. Stored links are still listed, but nothing can be proposed and whether a linked person is still in the organization is unknown. */
  calendlyUnavailable: Scalars['Boolean']['output'];
  mapped: Array<CalendlyMemberLink>;
  /** Nothing matched at all, which usually means the Calendly and Revvly email domains differ. */
  noMatchesFound: Scalars['Boolean']['output'];
  proposals: Array<CalendlyMatchSuggestion>;
  unlinkedCalendlyMembers: Array<CalendlyDirectoryEntry>;
  unmapped: Array<CalendlyUnmappedUser>;
};

/** An email match waiting for an admin to confirm it. */
export type CalendlyMatchSuggestion = {
  __typename?: 'CalendlyMatchSuggestion';
  calendlyEmail?: Maybe<Scalars['String']['output']>;
  calendlyName: Scalars['String']['output'];
  calendlyUserUri: Scalars['String']['output'];
  userEmail: Scalars['String']['output'];
  userId: Scalars['String']['output'];
  userName: Scalars['String']['output'];
};

/** A confirmed link between a Revvly member and a Calendly person. */
export type CalendlyMemberLink = {
  __typename?: 'CalendlyMemberLink';
  calendlyEmail?: Maybe<Scalars['String']['output']>;
  calendlyName?: Maybe<Scalars['String']['output']>;
  calendlyUserUri: Scalars['String']['output'];
  /** False when the person has left the Calendly organization since being linked. Their links are no longer on offer; an admin should unlink or relink them. */
  inOrganization: Scalars['Boolean']['output'];
  mappedAt: Scalars['DateTime']['output'];
  /** False when the Revvly member was deactivated or removed. The link is kept so an admin can see and clear it, but their links are not offered. */
  memberActive: Scalars['Boolean']['output'];
  /** Their personal Calendly booking page. */
  schedulingUrl?: Maybe<Scalars['String']['output']>;
  source: CalendlyMappingSource;
  userEmail?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
  userName?: Maybe<Scalars['String']['output']>;
};

/** A live Calendly scheduling link an operator can insert into an email so the recipient can book a meeting. */
export type CalendlySchedulingLink = {
  __typename?: 'CalendlySchedulingLink';
  /** How long the meeting lasts, in minutes. Null when Calendly does not say. */
  durationMinutes?: Maybe<Scalars['Int']['output']>;
  /** Whether the link belongs to the member asking, so theirs can be listed first. */
  isMine: Scalars['Boolean']['output'];
  /** The link’s current name in Calendly. */
  name: Scalars['String']['output'];
  /** Name of the Calendly user or team the link belongs to. */
  ownerName?: Maybe<Scalars['String']['output']>;
  /** Auth id of the Revvly member this link belongs to, when that person is linked to their Calendly account. Null for a team link or someone nobody has linked. */
  ownerUserId?: Maybe<Scalars['String']['output']>;
  /** The Revvly name of that member, so the menu can group by person. */
  ownerUserName?: Maybe<Scalars['String']['output']>;
  /** The public booking page the recipient opens. */
  schedulingUrl: Scalars['String']['output'];
  /** Calendly's stable event-type URI. */
  uri: Scalars['String']['output'];
};

export type CalendlyUnmappedUser = {
  __typename?: 'CalendlyUnmappedUser';
  userEmail?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
  userName: Scalars['String']['output'];
};

/** Outcome of a per-subscription component capture-mode override (API vs MANUAL). */
export type CaptureModeOverrideResult = {
  __typename?: 'CaptureModeOverrideResult';
  componentId: Scalars['ID']['output'];
  /** Effective capture mode after this change (override or client default or API). */
  effectiveMode: UsageCaptureMode;
  /** New override value. Null means the override was cleared and the component inherits the client default. */
  newValue?: Maybe<UsageCaptureMode>;
  /** Human-readable note for the operator UI. */
  note: Scalars['String']['output'];
  /** Prior effective capture mode (client default or previous override). */
  oldValue?: Maybe<UsageCaptureMode>;
  subscriptionId: Scalars['ID']['output'];
};

/** What the browser needs to collect a card with Stripe Elements. */
export type CardSetupResult = {
  __typename?: 'CardSetupResult';
  clientSecret: Scalars['String']['output'];
  publishableKey: Scalars['String']['output'];
  setupIntentId: Scalars['String']['output'];
  /** Pass to Stripe.js as stripeAccount (Stripe Connect only). */
  stripeAccountId?: Maybe<Scalars['String']['output']>;
};

/** Parent entity kind a cascaded draft was created on. */
export enum CascadeEntityType {
  Bundle = 'BUNDLE',
  Module = 'MODULE',
}

export type CascadedDraft = {
  __typename?: 'CascadedDraft';
  entityId: Scalars['ID']['output'];
  entityType: CascadeEntityType;
  newDraftVersion: Scalars['Int']['output'];
  previousVersion: Scalars['Int']['output'];
};

/** Catalog gaps implied by one client’s invoices. Read-only — asking creates nothing. */
export type CatalogGapReportEntity = {
  __typename?: 'CatalogGapReportEntity';
  proposals: Array<ProposedCatalogVersionEntity>;
  /** Listed rather than dropped: an operator who expected a proposal needs to see that the evidence bar was the reason, not a bug. */
  skipped: Array<SkippedCatalogGapEntity>;
};

/** A row in the unified catalog (Products) table. */
export type CatalogItem = {
  __typename?: 'CatalogItem';
  /** Components only: billed at period start (ADVANCE) or after it closes (ARREARS). */
  billingTiming?: Maybe<BillingTiming>;
  id: Scalars['ID']['output'];
  /** Display name (invoice line item for components). */
  name: Scalars['String']['output'];
  /** When the current version was published; null for drafts. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Markets (Regions) this item is fully priced and ready to sell in. */
  readyMarkets: Array<ReadyMarket>;
  /** Components only: STANDING carries the quantity forward, PER_PERIOD resets it when the period closes. */
  resetBehaviour?: Maybe<ResetBehaviour>;
  /** Lifecycle status as a string — unifies EntityStatus (modules/bundles) and VariableComponentStatus (components) into one column. */
  status: Scalars['String']['output'];
  /** Server-derived one-line summary shown under the name (e.g. "3 tiers · 0 components", "Bundle · 2 modules", "graduated tiered · seat"). */
  summary: Scalars['String']['output'];
  type: CatalogItemType;
  /** Components only: what an unreported period means — REVIEW waits for a person to enter the quantity, ZERO seals at zero automatically. */
  unreportedUsagePolicy?: Maybe<UnreportedUsagePolicy>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Where-used count: bundles referencing a module; modules + bundles referencing a component. Bundles report 0 (nothing references them in the catalog). */
  usageCount: Scalars['Int']['output'];
  /** Current version number of this item. */
  version: Scalars['Int']['output'];
};

/** Kind of catalog item in the unified Products surface (MODULE | BUNDLE | COMPONENT). */
export enum CatalogItemType {
  Bundle = 'BUNDLE',
  Component = 'COMPONENT',
  Module = 'MODULE',
}

export type CatalogUsage = {
  __typename?: 'CatalogUsage';
  /** Custom pricing agreements referencing this item (variable components). */
  agreements: Scalars['Int']['output'];
  /** Billing snapshots referencing this item (variable components) — invoiced history. */
  billingRecords: Scalars['Int']['output'];
  /** Distinct clients among the referencing subscriptions. */
  clients: Scalars['Int']['output'];
  /** True when nothing references the item — safe to hard-delete. */
  deletable: Scalars['Boolean']['output'];
  /** Bundles that reference this item (a pinned module or attached component). */
  inBundles: Scalars['Int']['output'];
  /** Components that bind this item (a meter bound by variable components). */
  inComponents: Scalars['Int']['output'];
  /** Modules that reference this item (an attached component). */
  inModules: Scalars['Int']['output'];
  /** Human-readable reasons the item is in use (empty when deletable). */
  reasons: Array<Scalars['String']['output']>;
  /** Subscriptions (live or historical) referencing this item. */
  subscriptions: Scalars['Int']['output'];
};

export type CategoryStats = {
  __typename?: 'CategoryStats';
  category: FileCategory;
  count: Scalars['Int']['output'];
  sizeBytes: Scalars['String']['output'];
  sizeFormatted: Scalars['String']['output'];
};

/** Whether a scheduled charge fires once or on every qualifying period. */
export enum ChargeRecurrence {
  Once = 'ONCE',
  Recurring = 'RECURRING',
}

/** When a scheduled charge is invoiced. SIGNING and ACTIVATION are fired by the billing-schedule service; PERIOD_START and PERIOD_END describe the existing renewal pipeline; MILESTONE and EXPLICIT_DATE are accepted by the schema but have no firing path yet. */
export enum ChargeTrigger {
  Activation = 'ACTIVATION',
  ExplicitDate = 'EXPLICIT_DATE',
  Milestone = 'MILESTONE',
  PeriodEnd = 'PERIOD_END',
  PeriodStart = 'PERIOD_START',
  Signing = 'SIGNING',
}

export type ChatArtifact = {
  __typename?: 'ChatArtifact';
  /** Overall confidence label shown in the artifact header. */
  confidence: Scalars['String']['output'];
  fieldCount: Scalars['Int']['output'];
  fields: Array<ChatArtifactField>;
  issueCount: Scalars['Int']['output'];
  /** Pricing model type — e.g. 'Per-unit', 'Tiered', 'Commission %'. */
  modelType: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ChatArtifactField = {
  __typename?: 'ChatArtifactField';
  /** Confidence — 'high' / 'medium' / 'low'. */
  confidence: Scalars['String']['output'];
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ChatCreationSession = {
  __typename?: 'ChatCreationSession';
  artifact?: Maybe<ChatArtifact>;
  /** User ID of the session creator. */
  createdBy: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** User IDs of everyone who can read and write in this session. */
  participants: Array<Scalars['String']['output']>;
  startedAt: Scalars['DateTime']['output'];
  turns: Array<ChatTurn>;
};

export type ChatFollowupSuggestion = {
  __typename?: 'ChatFollowupSuggestion';
  /** Stable identifier for the follow-up; the UI dispatches this back as the next user turn. */
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type ChatInfo = {
  __typename?: 'ChatInfo';
  /**
   * Max number of Chat Groups
   * @deprecated Chat are no longer limited by plan
   */
  chatGroupLimit: Scalars['Int']['output'];
  /**
   * Current selected plan for the incubator
   * @deprecated Chat are no longer limited by plan
   */
  chatPlan?: Maybe<PlanOptions>;
  /**
   * Max number of Chat Users
   * @deprecated Chat are no longer limited by plan
   */
  chatUserLimit: Scalars['Int']['output'];
};

export type ChatInfoUpdateInput = {
  /** Max number of Chat Groups */
  chatGroupLimit?: InputMaybe<Scalars['Int']['input']>;
  /** Current selected plan for the incubator */
  chatPlan?: InputMaybe<PlanOptions>;
  /** Max number of Chat Users */
  chatUserLimit?: InputMaybe<Scalars['Int']['input']>;
};

export type ChatTurn = {
  __typename?: 'ChatTurn';
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** Optional follow-up suggestions surfaced as quick-action buttons under an assistant turn. */
  followups?: Maybe<Array<ChatFollowupSuggestion>>;
  id: Scalars['ID']['output'];
  role: ChatTurnRole;
  /** Status pill shown next to assistant turns — 'Plan' / 'Drafting' / 'Reasoning'. */
  status?: Maybe<Scalars['String']['output']>;
};

/** Author of a chat turn in the creation flow. */
export enum ChatTurnRole {
  Assistant = 'ASSISTANT',
  User = 'USER',
}

export enum CheckInChannel {
  Clickup = 'CLICKUP',
  Slack = 'SLACK',
  Web = 'WEB',
}

export type Checkin = {
  __typename?: 'Checkin';
  createdAt: Scalars['DateTime']['output'];
  destination: CheckinDestination;
  /** Custom days that are not working days (any more) and so will not run */
  droppedDays: Array<Scalars['Int']['output']>;
  /** The weekdays it actually runs on: the tenant working days, narrowed by any custom days */
  effectiveDays: Array<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** When the sweeper next acts on this check-in; null while paused. FIXED: when everyone is asked. PARTICIPANT_LOCAL: when the next day opens (or its first person is due), not when any given person is asked; show nextRunDate with the ask time instead. */
  nextAskAt?: Maybe<Scalars['DateTime']['output']>;
  /** The local calendar date (YYYY-MM-DD) of the next run; null while paused or with no effective day */
  nextRunDate?: Maybe<Scalars['String']['output']>;
  participants: CheckinParticipantSelection;
  pausedReason?: Maybe<CheckinPauseReason>;
  questions: Array<CheckinQuestion>;
  schedule: CheckinSchedule;
  status: CheckinStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export enum CheckinAskTimeMode {
  Fixed = 'FIXED',
  ParticipantLocal = 'PARTICIPANT_LOCAL',
}

export type CheckinAway = {
  __typename?: 'CheckinAway';
  /** First day away, YYYY-MM-DD */
  from: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  /** Last day away, YYYY-MM-DD. Empty: away until they say they are back */
  to?: Maybe<Scalars['String']['output']>;
  /** Auth id of the person who is away */
  userId: Scalars['String']['output'];
};

export type CheckinChannel = {
  __typename?: 'CheckinChannel';
  id: Scalars['ID']['output'];
  /** Whether the bot is already in the channel */
  isMember: Scalars['Boolean']['output'];
  isPrivate: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type CheckinChannelList = {
  __typename?: 'CheckinChannelList';
  channels: Array<CheckinChannel>;
  /** False when the app was installed before it could list private channels; reinstall to see them */
  privateChannelsVisible: Scalars['Boolean']['output'];
};

export enum CheckinDaysMode {
  Custom = 'CUSTOM',
  Tenant = 'TENANT',
}

export type CheckinDestination = {
  __typename?: 'CheckinDestination';
  slackChannelId: Scalars['String']['output'];
  slackChannelName: Scalars['String']['output'];
};

export type CheckinParticipant = {
  __typename?: 'CheckinParticipant';
  email: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  reachability: CheckinParticipantReachability;
  /** Their own IANA timezone, when they have one (used by PARTICIPANT_LOCAL) */
  timezone?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export enum CheckinParticipantReachability {
  Deactivated = 'DEACTIVATED',
  Reachable = 'REACHABLE',
  Unmapped = 'UNMAPPED',
}

export type CheckinParticipantSelection = {
  __typename?: 'CheckinParticipantSelection';
  /** People left out of a team-based selection */
  excludedUserIds: Array<Scalars['String']['output']>;
  teamIds: Array<Scalars['ID']['output']>;
  /** Auth ids of the people asked individually */
  userIds: Array<Scalars['String']['output']>;
};

export type CheckinParticipantsInput = {
  excludedUserIds?: Array<Scalars['String']['input']>;
  teamIds?: Array<Scalars['ID']['input']>;
  /** Auth ids of individuals */
  userIds?: Array<Scalars['String']['input']>;
};

export enum CheckinPauseReason {
  Admin = 'ADMIN',
  SlackDisconnected = 'SLACK_DISCONNECTED',
}

export type CheckinQuestion = {
  __typename?: 'CheckinQuestion';
  /** Marks the question in the report */
  color: CheckinQuestionColor;
  /** ISO weekdays the question is asked on; empty means every day the check-in runs */
  days: Array<Scalars['Int']['output']>;
  /** The answer comes first in each person’s channel post */
  highlight: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  options: Array<Scalars['String']['output']>;
  order: Scalars['Int']['output'];
  required: Scalars['Boolean']['output'];
  text: Scalars['String']['output'];
  type: CheckinQuestionType;
};

export enum CheckinQuestionColor {
  Blue = 'BLUE',
  Brown = 'BROWN',
  Green = 'GREEN',
  Orange = 'ORANGE',
  Purple = 'PURPLE',
  Red = 'RED',
  Yellow = 'YELLOW',
}

export type CheckinQuestionInput = {
  /** Marks the question in the report; omitted, one is picked from its position */
  color?: InputMaybe<CheckinQuestionColor>;
  /** ISO weekdays (1 = Monday) to ask this question on; omitted or empty = every day */
  days?: InputMaybe<Array<Scalars['Int']['input']>>;
  highlight?: Scalars['Boolean']['input'];
  /** Keep the id of an existing question so past answers still match */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** SINGLE_CHOICE only: 2 to 10 options */
  options?: InputMaybe<Array<Scalars['String']['input']>>;
  required?: Scalars['Boolean']['input'];
  text: Scalars['String']['input'];
  type: CheckinQuestionType;
};

export enum CheckinQuestionType {
  LongText = 'LONG_TEXT',
  Scale_1_5 = 'SCALE_1_5',
  ShortText = 'SHORT_TEXT',
  SingleChoice = 'SINGLE_CHOICE',
  YesNo = 'YES_NO',
}

export type CheckinSchedule = {
  __typename?: 'CheckinSchedule';
  /** HH:mm. In the schedule timezone, or on each person's own clock when askTimeMode is PARTICIPANT_LOCAL */
  askTime: Scalars['String']['output'];
  askTimeMode: CheckinAskTimeMode;
  /** ISO weekdays; used when daysMode is CUSTOM */
  customDays: Array<Scalars['Int']['output']>;
  daysMode: CheckinDaysMode;
  /** Minutes before the report; 0 is off */
  reminderMinutesBeforeReport: Scalars['Int']['output'];
  /** HH:mm, read the same way as askTime */
  reportTime: Scalars['String']['output'];
  /** The schedule timezone; with PARTICIPANT_LOCAL, the fallback for people with no timezone of their own */
  timezone: Scalars['String']['output'];
};

export type CheckinScheduleInput = {
  /** HH:mm */
  askTime: Scalars['String']['input'];
  /** FIXED asks everyone at askTime in `timezone`; PARTICIPANT_LOCAL asks each person at askTime on their own clock. Omitted: FIXED for a new check-in; an edit keeps the current mode. */
  askTimeMode?: InputMaybe<CheckinAskTimeMode>;
  /** Omitted: none for a new check-in; an edit keeps the current days. */
  customDays?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Omitted: TENANT for a new check-in; an edit keeps the current one. */
  daysMode?: InputMaybe<CheckinDaysMode>;
  /** Omitted: 60 for a new check-in; an edit keeps the current value. */
  reminderMinutesBeforeReport?: InputMaybe<Scalars['Int']['input']>;
  /** HH:mm, at least 30 minutes after askTime */
  reportTime: Scalars['String']['input'];
  /** IANA timezone, e.g. Europe/Brussels. With PARTICIPANT_LOCAL it is the fallback for people with no timezone of their own. */
  timezone: Scalars['String']['input'];
};

export enum CheckinStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Paused = 'PAUSED',
}

/** Reason a subscription churned. Finance splits involuntary (recoverable, e.g. PAYMENT_FAILURE) from voluntary (product signal, e.g. CUSTOMER_REQUEST). */
export enum ChurnReason {
  CustomerRequest = 'CUSTOMER_REQUEST',
  Involuntary = 'INVOLUNTARY',
  Migration = 'MIGRATION',
  NaturalExpiration = 'NATURAL_EXPIRATION',
  NonRenewal = 'NON_RENEWAL',
  Other = 'OTHER',
  PaymentFailure = 'PAYMENT_FAILURE',
  UpgradeDowngrade = 'UPGRADE_DOWNGRADE',
  Voluntary = 'VOLUNTARY',
}

export type ChurnReconciliationResultOutput = {
  __typename?: 'ChurnReconciliationResultOutput';
  /** CHURNED events stamped by this run. */
  recorded: Scalars['Int']['output'];
  /** Subscriptions whose term ended past the grace window. */
  scanned: Scalars['Int']['output'];
  /** Skipped: a CHURNED event already existed. */
  skippedAlreadyChurned: Scalars['Int']['output'];
  /** Skipped: still inside the tenant churn grace period. */
  skippedFuture: Scalars['Int']['output'];
  /** Skipped: the organization started a new subscription. */
  skippedHasRenewal: Scalars['Int']['output'];
  /** Deferred to a later run because an invoice for the final period is still held as a DRAFT. */
  skippedHeldDraft: Scalars['Int']['output'];
  /** Skipped: signed on a deferred-activation schedule and never switched on, so it recognised no revenue and there is none to write off. Named for exactly what it counts — the scan does NOT infer "never earned" from a lifecycle log that holds no CREATED/RENEWED/REACTIVATED, because a legacy row acquires its first event from its own cancellation and would then be skipped for good. */
  skippedNeverLive: Scalars['Int']['output'];
  tenantId: Scalars['ID']['output'];
};

/** A ClickUp Chat channel announcements can go to */
export type ClickUpChatChannelOption = {
  __typename?: 'ClickUpChatChannelOption';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** Who is who between Revvly and ClickUp */
export type ClickUpChatMapping = {
  __typename?: 'ClickUpChatMapping';
  availableMembers: Array<ClickUpMemberOption>;
  linked: Array<ClickUpLinkedPerson>;
  proposals: Array<ClickUpMatchProposal>;
  unlinked: Array<ClickUpUnlinkedPerson>;
};

export type ClickUpConfirmResult = {
  __typename?: 'ClickUpConfirmResult';
  mapped: Scalars['Int']['output'];
  skipped: Array<ClickUpSkippedMatch>;
};

/** This tenant’s ClickUp connection */
export type ClickUpConnection = {
  __typename?: 'ClickUpConnection';
  /** Where company-wide posts go. Null: they are not sent through ClickUp */
  announcementChannelId?: Maybe<Scalars['String']['output']>;
  announcementChannelName?: Maybe<Scalars['String']['output']>;
  /** OKR messages go through ClickUp Chat instead of Slack. Off until an admin switches it on */
  chatEnabled: Scalars['Boolean']['output'];
  /** The ClickUp workspace whose Chat is used */
  chatWorkspaceId?: Maybe<Scalars['String']['output']>;
  /** The ClickUp account that authorised it */
  clickUpUsername?: Maybe<Scalars['String']['output']>;
  /** False when this deployment has no ClickUp app to connect through. Connecting is not offered then */
  configured: Scalars['Boolean']['output'];
  connectedAt?: Maybe<Scalars['DateTime']['output']>;
  lastHealthyAt?: Maybe<Scalars['DateTime']['output']>;
  status: ClickUpConnectionStatus;
  /** Why the status is what it is */
  statusReason?: Maybe<Scalars['String']['output']>;
  /** The workspaces Revvly may read */
  workspaces: Array<ClickUpWorkspaceRef>;
};

export enum ClickUpConnectionStatus {
  Connected = 'CONNECTED',
  Disconnected = 'DISCONNECTED',
  Revoked = 'REVOKED',
}

export type ClickUpDocLocation = {
  __typename?: 'ClickUpDocLocation';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** Where it sits, e.g. "Product / Help". Empty for a Space. */
  path: Scalars['String']['output'];
  scopeType: ClickUpDocScopeKind;
  workspaceId: Scalars['String']['output'];
  workspaceName: Scalars['String']['output'];
};

/** A ClickUp Space, Folder or List (every Doc in it), or one Doc. */
export enum ClickUpDocScopeKind {
  Doc = 'DOC',
  Folder = 'FOLDER',
  List = 'LIST',
  Space = 'SPACE',
}

/** A Revvly user linked to a ClickUp account */
export type ClickUpLinkedPerson = {
  __typename?: 'ClickUpLinkedPerson';
  clickUpEmail?: Maybe<Scalars['String']['output']>;
  clickUpUserId: Scalars['String']['output'];
  clickUpUsername?: Maybe<Scalars['String']['output']>;
  mappedAt: Scalars['DateTime']['output'];
  source: ClickUpMappingSource;
  userEmail?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
  userName: Scalars['String']['output'];
};

export enum ClickUpMappingSource {
  EmailMatch = 'EMAIL_MATCH',
  Manual = 'MANUAL',
}

export type ClickUpMatchInput = {
  clickUpUserId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

/** A ClickUp account whose email matches a Revvly user. Stored only once confirmed */
export type ClickUpMatchProposal = {
  __typename?: 'ClickUpMatchProposal';
  clickUpEmail: Scalars['String']['output'];
  clickUpUserId: Scalars['String']['output'];
  clickUpUsername?: Maybe<Scalars['String']['output']>;
  userEmail: Scalars['String']['output'];
  userId: Scalars['String']['output'];
  userName: Scalars['String']['output'];
};

/** A person in the connected ClickUp workspace nobody is linked to */
export type ClickUpMemberOption = {
  __typename?: 'ClickUpMemberOption';
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  username?: Maybe<Scalars['String']['output']>;
};

export type ClickUpSkippedMatch = {
  __typename?: 'ClickUpSkippedMatch';
  reason: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

/** An active Revvly member with no ClickUp link and no match */
export type ClickUpUnlinkedPerson = {
  __typename?: 'ClickUpUnlinkedPerson';
  userEmail?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
  userName: Scalars['String']['output'];
};

export type ClickUpWorkspaceRef = {
  __typename?: 'ClickUpWorkspaceRef';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** One client’s catalog gaps inside a tenant-wide scan. The client is the unit a proposal is accepted under — a cluster key means nothing without the client whose invoices formed it. */
export type ClientCatalogGapsEntity = {
  __typename?: 'ClientCatalogGapsEntity';
  organizationId: Scalars['String']['output'];
  /** Empty when the client could not be read — the row still names its id */
  organizationName: Scalars['String']['output'];
  proposals: Array<ProposedCatalogVersionEntity>;
  /** Listed rather than dropped: an operator who expected a proposal needs to see that the evidence bar was the reason, not a bug. */
  skipped: Array<SkippedCatalogGapEntity>;
};

/** One client’s standing in a sync job’s commit */
export type ClientCommitReadinessEntity = {
  __typename?: 'ClientCommitReadinessEntity';
  /** Rows a reviewer has settled, including not-an-invoice */
  answered: Scalars['Int']['output'];
  /** Why this client is not READY, in the reviewer’s words. Empty when it is. */
  blockers: Array<Scalars['String']['output']>;
  /** The ids behind `readyToCommit` — pass these to `commitSyncedInvoices` so the set a commit covers is the one this query reported, not one the caller re-derived. */
  commitResultIds: Array<Scalars['String']['output']>;
  /** Rows that already produced an invoice */
  committed: Scalars['Int']['output'];
  /** Rows marked not an invoice. Counted inside `answered`. */
  discarded: Scalars['Int']['output'];
  /** Rows whose extraction failed — they need a retry, not an answer */
  errored: Scalars['Int']['output'];
  organizationId: Scalars['String']['output'];
  /** The client’s name. Empty only when the client record could not be read — the id is still the handle the commit mutations take. */
  organizationName: Scalars['String']['output'];
  /** Rows still waiting for an answer */
  pending: Scalars['Int']['output'];
  /** Rows that would become invoices on the next commit */
  readyToCommit: Scalars['Int']['output'];
  state: ClientCommitState;
};

/** Whether one client’s rows in a sync job can be committed yet */
export enum ClientCommitState {
  Committed = 'COMMITTED',
  NothingToCommit = 'NOTHING_TO_COMMIT',
  Ready = 'READY',
  Waiting = 'WAITING',
}

/** A step the client is told progress in. Order is the list order. */
export type ClientStage = {
  __typename?: 'ClientStage';
  /** Also announce reaching this stage by moving backwards. */
  announceRegressions: Scalars['Boolean']['output'];
  /** Stable id: renaming the stage does not orphan a mapping or an announcement. */
  key: Scalars['String']['output'];
  /** What the client reads. */
  label: Scalars['String']['output'];
  /** Also move the ticket to the status with this key when work reaches the stage, where its workflow has it. Never a closed status. */
  moveToStatusKey?: Maybe<Scalars['String']['output']>;
  /** Post a short update in the ticket chat the first time a ticket reaches this stage. */
  notifyClient: Scalars['Boolean']['output'];
  /** The update, with {{title}}, {{stage}} and {{number}}. Empty means the default message. */
  template: Scalars['String']['output'];
};

export type ClientStageInput = {
  announceRegressions: Scalars['Boolean']['input'];
  key: Scalars['String']['input'];
  label: Scalars['String']['input'];
  moveToStatusKey?: InputMaybe<Scalars['String']['input']>;
  notifyClient: Scalars['Boolean']['input'];
  template: Scalars['String']['input'];
};

export type ClientStageSettings = {
  __typename?: 'ClientStageSettings';
  /** Add a one-line comment to a linked ClickUp task when its ticket changes status, closes or reopens. Revvly never moves the task. */
  commentOnLinkedTasks: Scalars['Boolean']['output'];
  /** These are the defaults, not yet saved. */
  isDefault: Scalars['Boolean']['output'];
  /** A client who closed their ticket still hears the stage the work reaches. */
  notifyAfterClose: Scalars['Boolean']['output'];
  stages: Array<ClientStage>;
  /** Pass back as expectedVersion. 0 until the defaults are first edited. */
  version: Scalars['Int']['output'];
};

export type ClientStagesInput = {
  /** Default on. */
  commentOnLinkedTasks?: InputMaybe<Scalars['Boolean']['input']>;
  notifyAfterClose: Scalars['Boolean']['input'];
  stages: Array<ClientStageInput>;
};

/** The subscriptions a client’s invoices imply, as a reviewable proposal. Nothing is created by asking for it. */
export type ClientSubscriptionPlanEntity = {
  __typename?: 'ClientSubscriptionPlanEntity';
  /** Already linked to a subscription and excluded from the plan. Listed rather than dropped, so a half-imported client looks like one. */
  alreadyLinkedInvoiceIds: Array<Scalars['String']['output']>;
  /** Plan-level blockers, in addition to any on a proposal */
  blockers: Array<Scalars['String']['output']>;
  /** No blockers anywhere. A plan that is not committable needs an explicit force. */
  committable: Scalars['Boolean']['output'];
  /** Invoices with no recurring line — setup fees, credit notes. Left unlinked on purpose: attaching one to a subscription is how one-off cash becomes a monthly run-rate. */
  oneTimeInvoiceIds: Array<Scalars['String']['output']>;
  organizationId: Scalars['String']['output'];
  /** Fingerprint of the invoices this plan was built from. Pass it back to commit: it is what stops a plan reviewed yesterday being applied to invoices that have since changed shape. */
  planHash: Scalars['String']['output'];
  subscriptions: Array<PlannedSubscriptionEntity>;
};

/** When the subscription period clock starts: at sale (today’s behaviour) or at activation (the subscription waits as PENDING until the go-live action fires). */
export enum ClockStart {
  Activation = 'ACTIVATION',
  Sale = 'SALE',
}

export type CollectedLast30Days = {
  __typename?: 'CollectedLast30Days';
  amount: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  invoiceCount: Scalars['Int']['output'];
};

export type ColumnMappingSuggestion = {
  __typename?: 'ColumnMappingSuggestion';
  /** Column index */
  columnIndex: Scalars['Int']['output'];
  /** Original column name */
  columnName: Scalars['String']['output'];
  /** Confidence score (0-1) */
  confidence: Scalars['Float']['output'];
  /** Reason for the suggestion */
  reason: Scalars['String']['output'];
  /** Suggested target field (null if no match) */
  suggestedField?: Maybe<Scalars['String']['output']>;
};

export type ColumnSampleInput = {
  /** Column index (0-based) */
  index: Scalars['Int']['input'];
  /** Inferred data type */
  inferredType?: InputMaybe<Scalars['String']['input']>;
  /** Column header name */
  name: Scalars['String']['input'];
  /** Sample values from this column */
  samples: Array<Scalars['String']['input']>;
};

/** Joint analysis of a spreadsheet import against a staged Drive sync job, before anything is committed. */
export type CombinedImportAnalysisEntity = {
  __typename?: 'CombinedImportAnalysisEntity';
  /** Corroborated records where the two sources name incompatible clients */
  clientNameMismatchCount: Scalars['Int']['output'];
  /** Total field conflicts across corroborated records */
  conflictCount: Scalars['Int']['output'];
  corroborated: Array<CorroboratedImportRecord>;
  /** Rows with no Drive counterpart (spreadsheet-only) */
  csvOnlyRowIndexes: Array<Scalars['Int']['output']>;
  /** Staged Drive results with no spreadsheet counterpart */
  driveOnlyResultIds: Array<Scalars['ID']['output']>;
  totalCsvRows: Scalars['Int']['output'];
  totalDriveResults: Scalars['Int']['output'];
};

/** A field both sources supplied with different values — needs reviewer resolution. */
export type CombinedImportFieldConflict = {
  __typename?: 'CombinedImportFieldConflict';
  csvValue?: Maybe<Scalars['String']['output']>;
  driveValue?: Maybe<Scalars['String']['output']>;
  field: Scalars['String']['output'];
};

/** Whether commission applies to gross sale value or net of fees */
export enum CommissionApplyTo {
  Gross = 'GROSS',
  Net = 'NET',
}

export type CommitSubscriptionPlanInput = {
  /** The planHash the reviewer approved. Required: a plan reviewed yesterday must not be applied to invoices that have since changed shape. */
  expectedPlanHash: Scalars['String']['input'];
  /** Commit despite blockers. For a judgement a person can overrule with context the invoices do not carry — "yes, those really are two contracts". Not a formality. */
  force?: InputMaybe<Scalars['Boolean']['input']>;
  /** Client whose plan is being applied */
  organizationId: Scalars['String']['input'];
};

/** What committing a plan actually did */
export type CommitSubscriptionPlanResultEntity = {
  __typename?: 'CommitSubscriptionPlanResultEntity';
  /** Invoices this plan claimed that another path had already linked. The existing link wins, so these are periods the created subscription does not own. */
  contendedInvoiceIds: Array<Scalars['String']['output']>;
  createdSubscriptionIds: Array<Scalars['String']['output']>;
  /** Reverses the whole commit in one call. Absent when the batch could not be stamped. */
  importBatchId?: Maybe<Scalars['String']['output']>;
  linkedInvoiceIds: Array<Scalars['String']['output']>;
  /** One-time invoices left deliberately unlinked */
  skippedOneTimeInvoiceIds: Array<Scalars['String']['output']>;
  /** Everything that went wrong without stopping the commit — an unwritten timeline segment, a lifecycle event that did not land. Each one is a silent misstatement of revenue if ignored. */
  warnings: Array<Scalars['String']['output']>;
};

export type CommitSyncError = {
  __typename?: 'CommitSyncError';
  /** Error code: DUPLICATE_INVOICE, MISSING_DATA, SKIPPED, or UNKNOWN */
  errorCode: Scalars['String']['output'];
  /** ID of the existing invoice when the error is a duplicate */
  existingInvoiceId?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  resultId: Scalars['String']['output'];
};

export type CommitSyncResultEntity = {
  __typename?: 'CommitSyncResultEntity';
  createdCount: Scalars['Int']['output'];
  discrepancyCount: Scalars['Int']['output'];
  errors?: Maybe<Array<CommitSyncError>>;
  /** Id of the import batch this commit recorded — pass to rollbackImportBatch to undo it */
  importBatchId?: Maybe<Scalars['String']['output']>;
  unmatchedCount: Scalars['Int']['output'];
};

/** Which side of the conversation owes a commitment. */
export enum CommitmentOwner {
  Them = 'THEM',
  Us = 'US',
}

/** Where a commitment stands: upcoming, overdue, or past due with activity since. */
export enum CommitmentStatus {
  ActivitySince = 'ACTIVITY_SINCE',
  Overdue = 'OVERDUE',
  Upcoming = 'UPCOMING',
}

export type CommittedTermExposure = {
  __typename?: 'CommittedTermExposure';
  /** What CHARGE_REMAINDER would invoice, in the subscription's own currency: the plan charge for each owed period. Usage is metered rather than committed, so it is not included — a client owes the periods they signed up for, not a projection of consumption they will not have. */
  amountOwed: Scalars['Float']['output'];
  /** The committed end the client is bound to and has not been invoiced through. */
  committedEnd: Scalars['DateTime']['output'];
  /** Whole billing periods owed and not yet invoiced. Counted from the paid line, not from the period boundary the cancellation lands on — a prepaid span pays months past that boundary, and those periods are already in AR. */
  periodsRemaining: Scalars['Int']['output'];
};

/** How a preview field was read: the site's structured data (JSON-LD), a meta tag, the page title, a fixed pattern in the page text (VAT and registration numbers, legal names), a link on the page, or the domain itself (country from .be, .fr…). */
export enum CompanyFactMethod {
  Domain = 'DOMAIN',
  Link = 'LINK',
  MetaTag = 'META_TAG',
  PageText = 'PAGE_TEXT',
  PageTitle = 'PAGE_TITLE',
  StructuredData = 'STRUCTURED_DATA',
}

/** Where one preview field came from. */
export type CompanyFactSource = {
  __typename?: 'CompanyFactSource';
  /** The preview field: name, description, legalName, legalStructure, companyNumber, taxId, address, country, email, logoUrl or linkedinUrl. */
  field: Scalars['String']['output'];
  method: CompanyFactMethod;
  /** The page it was read from. */
  url: Scalars['String']['output'];
};

/** A preview of the company behind a domain, for the first step of creating a client or prospect. Read-only: it stores nothing and spends nothing beyond fetching the site. */
export type CompanyPreview = {
  __typename?: 'CompanyPreview';
  /** The registrable domain the input reduced to (hooli.com for https://www.hooli.com/about or priya@eu.hooli.com). */
  domain?: Maybe<Scalars['String']['output']>;
  /** Records in this workspace that already hold the domain. When non-empty the site is not read: the company exists, and the domain cannot be stored twice. */
  existing: Array<CompanyPreviewMatch>;
  /** People at this domain in the workspace's own contacts and email, under the same rules as suggestedOrganizationContacts. */
  knownPeople: Array<SuggestedContact>;
  problem?: Maybe<CompanyPreviewProblem>;
  /** An active region of this workspace that matches the company's country: one whose code is the country, else an EU region for an EU country. */
  suggestedRegionId?: Maybe<Scalars['ID']['output']>;
  website?: Maybe<CompanyWebsiteFacts>;
  /** Why the site could not be read, worded for the operator. Null when it was read or not attempted. */
  websiteError?: Maybe<Scalars['String']['output']>;
};

/** A client or prospect that already holds this domain. */
export type CompanyPreviewMatch = {
  __typename?: 'CompanyPreviewMatch';
  domain?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lifecycleStage: CrmLifecycleStage;
  name: Scalars['String']['output'];
};

/** Why no preview could be made. INVALID_INPUT: nothing domain-shaped was typed. FREEMAIL: the domain is a consumer mailbox provider (gmail.com), which identifies no company. */
export enum CompanyPreviewProblem {
  Freemail = 'FREEMAIL',
  InvalidInput = 'INVALID_INPUT',
}

/** What a company states about itself on its own website, read by fixed rules (no model). Every field is optional: a field the rules could not settle is absent, never guessed. Nothing here is stored — it pre-fills a form a person submits. */
export type CompanyWebsiteFacts = {
  __typename?: 'CompanyWebsiteFacts';
  /** Postal address the site publishes in its structured data. */
  address?: Maybe<Scalars['String']['output']>;
  /** Registration number, written as its registry writes it (0403.170.701, HRB 12345). Taken only after its keyword, or implied by a Belgian or French VAT number; checksums are verified where the country has one. */
  companyNumber?: Maybe<Scalars['String']['output']>;
  /** ISO 3166-1 alpha-2 country code. */
  country?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** A shared mailbox at the company's own domain (billing@, info@) — never a person's address. */
  email?: Maybe<Scalars['String']['output']>;
  legalName?: Maybe<Scalars['String']['output']>;
  /** The legal form, e.g. BV, SRL, GmbH, Ltd. */
  legalStructure?: Maybe<Scalars['String']['output']>;
  linkedinUrl?: Maybe<Scalars['String']['output']>;
  /** Logo or icon URL, for display in the preview only. */
  logoUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** Every page that was read. */
  pagesRead: Array<Scalars['String']['output']>;
  sources: Array<CompanyFactSource>;
  /** VAT number in compact form, e.g. BE0403170701. */
  taxId?: Maybe<Scalars['String']['output']>;
};

/** Input for completing an onboarding step */
export type CompleteOnboardingStepInput = {
  /** Optional data associated with step completion */
  data?: InputMaybe<Scalars['String']['input']>;
  /** Step ID to complete */
  stepId: Scalars['String']['input'];
};

/** Result of completing an onboarding step */
export type CompleteStepResult = {
  __typename?: 'CompleteStepResult';
  /** Error message if failed */
  error?: Maybe<Scalars['String']['output']>;
  /** Whether onboarding is now complete */
  isOnboardingComplete: Scalars['Boolean']['output'];
  /** Next step ID, if any */
  nextStep?: Maybe<Scalars['String']['output']>;
  /** Whether the step was completed successfully */
  success: Scalars['Boolean']['output'];
};

/** How completion is checked for a step */
export enum CompletionCheckType {
  Auto = 'AUTO',
  Manual = 'MANUAL',
}

/** Type of auto-completion criteria */
export enum CompletionCriteriaType {
  Count = 'COUNT',
  FieldSet = 'FIELD_SET',
  HasData = 'HAS_DATA',
}

/** Per-component billing-timing status on a subscription: product default, override (if any), and what applies now vs next cycle. */
export type ComponentBillingTimingStatus = {
  __typename?: 'ComponentBillingTimingStatus';
  componentId: Scalars['ID']['output'];
  componentVersion: Scalars['Int']['output'];
  /** Timing the current billing cycle is invoiced under (locked at cycle start). */
  currentCycleTiming?: Maybe<BillingTiming>;
  /** Timing that applies from the next billing cycle: override ?? product default. */
  effectiveTiming: BillingTiming;
  /** When the next billing cycle for this component starts (current period end). */
  nextCycleStartsAt?: Maybe<Scalars['DateTime']['output']>;
  /** Subscription-level override. Null = inheriting (tracks the product default). */
  override?: Maybe<BillingTiming>;
  /** True when a change is queued: the next cycle bills under a different timing than the current one. */
  pendingChange: Scalars['Boolean']['output'];
  /** The product component's configured default timing. */
  productDefault?: Maybe<BillingTiming>;
};

/** How many Modules and Bundles reference a Variable Component. */
export type ComponentUsage = {
  __typename?: 'ComponentUsage';
  bundleCount: Scalars['Int']['output'];
  moduleCount: Scalars['Int']['output'];
};

export type ComponentUsageAdjustment = {
  __typename?: 'ComponentUsageAdjustment';
  /** Amount invoiced today. 0 when nothing posts mid-cycle. */
  chargedNow: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  delta: Scalars['Float']['output'];
  invoiceId?: Maybe<Scalars['ID']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  newCount: Scalars['Float']['output'];
  /** Full-period charge difference at the resolved price (after inclusions). */
  periodChargeDelta: Scalars['Float']['output'];
  previousCount: Scalars['Float']['output'];
  /** Mid-cycle proration factor applied, if any. */
  prorationFactor?: Maybe<Scalars['Float']['output']>;
  /** Whole calendar days left in the period (inclusive of today). DAILY proration only. */
  remainingDays?: Maybe<Scalars['Int']['output']>;
  /** Months charged, the month of the change counted in full. FULL_MONTH proration only. */
  remainingMonths?: Maybe<Scalars['Int']['output']>;
  /** Whole calendar days in the full period. DAILY proration only. */
  totalDays?: Maybe<Scalars['Int']['output']>;
  /** Whole months in the full period. FULL_MONTH proration only. */
  totalMonths?: Maybe<Scalars['Int']['output']>;
  usage: SubscriptionVariableUsage;
};

/** What adjustComponentUsage would charge for a count change, computed without writing anything — the same proration and pricing the mutation applies. */
export type ComponentUsageQuote = {
  __typename?: 'ComponentUsageQuote';
  /** What the change would invoice today. */
  chargedNow: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  delta: Scalars['Float']['output'];
  inTrial: Scalars['Boolean']['output'];
  newCount: Scalars['Float']['output'];
  /** Full-period charge difference at the resolved price (after inclusions). */
  periodChargeDelta: Scalars['Float']['output'];
  previousCount: Scalars['Float']['output'];
  prorationFactor?: Maybe<Scalars['Float']['output']>;
  remainingDays?: Maybe<Scalars['Int']['output']>;
  remainingMonths?: Maybe<Scalars['Int']['output']>;
  totalDays?: Maybe<Scalars['Int']['output']>;
  totalMonths?: Maybe<Scalars['Int']['output']>;
};

export type ConcludeHypothesisInputType = {
  acknowledge?: InputMaybe<Array<Scalars['String']['input']>>;
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  inconclusiveReason?: InputMaybe<HypothesisInconclusiveReason>;
  /** At least 10 characters */
  learning?: InputMaybe<Scalars['String']['input']>;
  nextStep?: InputMaybe<HypothesisNextStep>;
  observedEffect?: InputMaybe<Scalars['Float']['input']>;
  outcome?: InputMaybe<HypothesisOutcome>;
  result?: InputMaybe<Scalars['String']['input']>;
};

/** Result of confirming an account email change */
export type ConfirmEmailChangeResult = {
  __typename?: 'ConfirmEmailChangeResult';
  /** The account email address after confirmation */
  email: Scalars['String']['output'];
  /** Whether the email change was applied */
  success: Scalars['Boolean']['output'];
};

/** Input for confirming file upload completion */
export type ConfirmUploadInput = {
  /** The bucket returned from requestUploadUrl */
  bucket: Scalars['String']['input'];
  /** ETag returned from S3 upload response */
  etag?: InputMaybe<Scalars['String']['input']>;
  /** The key returned from requestUploadUrl */
  key: Scalars['String']['input'];
};

export type ConnectClickUpKnowledgeSourceInput = {
  /** Defaults to the name in ClickUp. */
  name?: InputMaybe<Scalars['String']['input']>;
  pageCap?: InputMaybe<Scalars['Int']['input']>;
  reguessAudience?: InputMaybe<Scalars['Boolean']['input']>;
  /** Defaults to HOURLY. */
  schedule?: InputMaybe<KnowledgeSchedule>;
  scopeId: Scalars['String']['input'];
  scopeType: ClickUpDocScopeKind;
  /** Trust a `Revvly audience:` line at the top of a page. Off by default. */
  trustAudienceLines?: InputMaybe<Scalars['Boolean']['input']>;
  workspaceId: Scalars['String']['input'];
};

export type ConnectKnowledgeSourceInput = {
  /** The API token. Write-only: stored encrypted and never returned. */
  credential: Scalars['String']['input'];
  /** Zendesk: the agent email the token belongs to. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** INTERCOM or ZENDESK. */
  kind: KnowledgeSourceKind;
  /** Zendesk: the language to read, such as en-us. */
  locale?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  pageCap?: InputMaybe<Scalars['Int']['input']>;
  /** Intercom: us, eu or au. */
  region?: InputMaybe<Scalars['String']['input']>;
  /** Stored for later reads: re-guess who can read articles whose audience was guessed. Defaults to true. */
  reguessAudience?: InputMaybe<Scalars['Boolean']['input']>;
  schedule?: InputMaybe<KnowledgeSchedule>;
  /** Zendesk: the acme of acme.zendesk.com. */
  subdomain?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectStripeWithKeyInput = {
  /** The matching publishable key (pk_live_… / pk_test_…). */
  publishableKey: Scalars['String']['input'];
  /** A Stripe restricted key (rk_live_… / rk_test_…). */
  secretKey: Scalars['String']['input'];
};

export type ContactConflict = {
  __typename?: 'ContactConflict';
  email: Scalars['String']['output'];
  sourceContactId: Scalars['ID']['output'];
  sourceContactName: Scalars['String']['output'];
  sourceLabels?: Maybe<Array<Scalars['String']['output']>>;
  targetContactId: Scalars['ID']['output'];
  targetContactName: Scalars['String']['output'];
  targetLabels?: Maybe<Array<Scalars['String']['output']>>;
};

/** A prospect or client a standalone contact could belong to, matched on the contact's email domain. Shown on the tenant-wide contact list when the person is not attached to a company yet. */
export type ContactOrganizationSuggestion = {
  __typename?: 'ContactOrganizationSuggestion';
  domain?: Maybe<Scalars['String']['output']>;
  /** The organization id. Same as organizationId — present so the Apollo cache can identify the row. */
  id: Scalars['ID']['output'];
  lifecycleStage: CrmLifecycleStage;
  /** The host that matched this record — the website domain or a linked email host. */
  matchedDomain: Scalars['String']['output'];
  name: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
};

export type ContactResolutionInput = {
  email: Scalars['String']['input'];
  keepContactId: Scalars['String']['input'];
  mergeLabels?: Scalars['Boolean']['input'];
};

/** A role a contact can hold at a client: the five built in, or one the workspace added. */
export type ContactRole = {
  __typename?: 'ContactRole';
  /** One of the five every workspace has; these cannot be changed. */
  builtIn: Scalars['Boolean']['output'];
  /** What a contact stores. Never changes. */
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  /** Left out of the picker; contacts that hold it keep it. */
  retired: Scalars['Boolean']['output'];
};

/** Where a same-domain contact suggestion was found. */
export enum ContactSuggestionSource {
  EmailParticipant = 'EMAIL_PARTICIPANT',
  UnassignedContact = 'UNASSIGNED_CONTACT',
}

/** A form question whose answer fills part of the contract. */
export type ContractAnswerMappingInput = {
  /** The form field's answer key. */
  question: Scalars['String']['input'];
  /** `field.<key>` (any field, the signer's included) or a client detail token such as `client.legal_name` (used where the record has none). */
  target: Scalars['String']['input'];
};

/** One of a choice field's options. */
export type ContractChoiceOption = {
  __typename?: 'ContractChoiceOption';
  /** What is stored, and what a calculated field matches on. */
  key: Scalars['String']['output'];
  /** What the contract prints. */
  label: Scalars['String']['output'];
};

export type ContractChoiceOptionInput = {
  key: Scalars['String']['input'];
  label: Scalars['String']['input'];
};

/** An operational clause tracked across contracts. */
export enum ContractClauseKind {
  BreachNotification = 'BREACH_NOTIFICATION',
  SubprocessorChange = 'SUBPROCESSOR_CHANGE',
}

/** What reading a contract document found. Nothing is stored until it is saved. */
export type ContractClauseProposal = {
  __typename?: 'ContractClauseProposal';
  /** Null: the document does not state it. */
  breachNotification?: Maybe<BreachNotificationProposal>;
  contractType?: Maybe<ContractType>;
  /** The contract record already made from this document; saving updates it. */
  existingContractId?: Maybe<Scalars['ID']['output']>;
  /** YYYY-MM-DD. */
  signedAt?: Maybe<Scalars['String']['output']>;
  /** Null: the document does not state it. */
  subprocessorChange?: Maybe<SubprocessorChangeProposal>;
  title?: Maybe<Scalars['String']['output']>;
};

/** One client bound by a signed contract, and where it stands on a clause. */
export type ContractClauseRegisterRow = {
  __typename?: 'ContractClauseRegisterRow';
  clauses?: Maybe<ContractClauses>;
  /** The contract the terms come from; else the newest signed one, to check. */
  contractId?: Maybe<Scalars['ID']['output']>;
  contractName?: Maybe<Scalars['String']['output']>;
  /** The client's contacts labelled DPO: who is told. */
  dpoContacts: Array<DpoContact>;
  organizationId: Scalars['ID']['output'];
  organizationName: Scalars['String']['output'];
  signedAt?: Maybe<Scalars['DateTime']['output']>;
  standing: ContractClauseStanding;
};

export enum ContractClauseSource {
  Document = 'DOCUMENT',
  Manual = 'MANUAL',
}

/** Where a client stands on one tracked clause. */
export enum ContractClauseStanding {
  NotRecorded = 'NOT_RECORDED',
  NotStated = 'NOT_STATED',
  Stated = 'STATED',
}

/** The operational clauses a contract states, as a person confirmed them. */
export type ContractClauses = {
  __typename?: 'ContractClauses';
  breachNotification?: Maybe<BreachNotificationClause>;
  source: ContractClauseSource;
  subprocessorChange?: Maybe<SubprocessorChangeClause>;
  updatedAt: Scalars['DateTime']['output'];
};

/** A clause left out or null: the contract does not state it. */
export type ContractClausesInput = {
  breachNotification?: InputMaybe<BreachNotificationClauseInput>;
  subprocessorChange?: InputMaybe<SubprocessorChangeClauseInput>;
};

/** The signed copy owed to one address. */
export type ContractCopyEmail = {
  __typename?: 'ContractCopyEmail';
  lastError?: Maybe<Scalars['String']['output']>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  status: SignedCopyStatus;
  to: Scalars['String']['output'];
};

export type ContractDateOffset = {
  __typename?: 'ContractDateOffset';
  amount: Scalars['Int']['output'];
  unit: ContractDateUnit;
};

export type ContractDateOffsetInput = {
  amount: Scalars['Int']['input'];
  unit: ContractDateUnit;
};

/** A calculated date: the base date plus the first matching case, else `otherwise`, less a day when `inclusiveEnd`. */
export type ContractDateRule = {
  __typename?: 'ContractDateRule';
  /** The date field it starts from. */
  base: Scalars['String']['output'];
  cases: Array<ContractDateRuleCase>;
  inclusiveEnd: Scalars['Boolean']['output'];
  otherwise?: Maybe<ContractDateOffset>;
};

/** What a calculated date adds when its choice holds one option. */
export type ContractDateRuleCase = {
  __typename?: 'ContractDateRuleCase';
  amount: Scalars['Int']['output'];
  /** The option key it matches. */
  equals: Scalars['String']['output'];
  /** The choice field it tests. */
  field: Scalars['String']['output'];
  unit: ContractDateUnit;
};

export type ContractDateRuleCaseInput = {
  amount: Scalars['Int']['input'];
  equals: Scalars['String']['input'];
  field: Scalars['String']['input'];
  unit: ContractDateUnit;
};

export type ContractDateRuleInput = {
  base: Scalars['String']['input'];
  cases?: Array<ContractDateRuleCaseInput>;
  inclusiveEnd?: Scalars['Boolean']['input'];
  otherwise?: InputMaybe<ContractDateOffsetInput>;
};

export enum ContractDateUnit {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR',
}

export enum ContractFieldFilledBy {
  Computed = 'COMPUTED',
  Sender = 'SENDER',
  Signer = 'SIGNER',
}

export enum ContractFieldType {
  Choice = 'CHOICE',
  Date = 'DATE',
  Number = 'NUMBER',
  Text = 'TEXT',
}

/** A published form a contract can start with. */
export type ContractForm = {
  __typename?: 'ContractForm';
  /** It binds the signer's name and email, so it can name who signs. */
  asksWhoSigns: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  questions: Array<ContractFormQuestion>;
};

/** A question a form asks. */
export type ContractFormQuestion = {
  __typename?: 'ContractFormQuestion';
  /** What it fills on a client, if linked. */
  binding?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export enum ContractInviteStatus {
  Failed = 'FAILED',
  Manual = 'MANUAL',
  Pending = 'PENDING',
  Sent = 'SENT',
  Skipped = 'SKIPPED',
  Waiting = 'WAITING',
}

/** What the sender chose for the order form where the template leaves it to them. Amounts are never sent: they come from the catalog. */
export type ContractOrderChoiceInput = {
  included?: Array<ContractOrderIncludedInput>;
  period?: InputMaybe<Scalars['String']['input']>;
  plan?: InputMaybe<Scalars['String']['input']>;
};

export type ContractOrderComponent = {
  __typename?: 'ContractOrderComponent';
  id: Scalars['ID']['output'];
  /** Units that come with the plan. */
  included: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  unit?: Maybe<Scalars['String']['output']>;
  /** The price of one more unit, when it has one. */
  unitPrice?: Maybe<Scalars['Float']['output']>;
};

/** Who chooses the plan and billing period an `{{order.*}}` placeholder reads, and the template's own choice. */
export type ContractOrderForm = {
  __typename?: 'ContractOrderForm';
  /** A billing period when the template fixes it. */
  period?: Maybe<Scalars['String']['output']>;
  periodFilledBy: ContractOrderFormFilledBy;
  /** `BUNDLE:<lineageId>` / `MODULE:<lineageId>` when the template fixes the plan. */
  plan?: Maybe<Scalars['String']['output']>;
  planFilledBy: ContractOrderFormFilledBy;
  /** The key of the date field (filled by the sender or the signer) that is the order's start date. */
  startField?: Maybe<Scalars['String']['output']>;
};

export enum ContractOrderFormFilledBy {
  Sender = 'SENDER',
  Template = 'TEMPLATE',
}

export type ContractOrderFormInput = {
  period?: InputMaybe<Scalars['String']['input']>;
  periodFilledBy: ContractOrderFormFilledBy;
  plan?: InputMaybe<Scalars['String']['input']>;
  planFilledBy: ContractOrderFormFilledBy;
  startField?: InputMaybe<Scalars['String']['input']>;
};

/** Included units the sender set for one item of the order form. */
export type ContractOrderIncludedInput = {
  componentId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
};

/** A plan on sale, priced for one client’s market, for an order form. */
export type ContractOrderPlanOption = {
  __typename?: 'ContractOrderPlanOption';
  components: Array<ContractOrderComponent>;
  kind: Scalars['String']['output'];
  name: Scalars['String']['output'];
  prices: Array<ContractOrderPrice>;
  /** `BUNDLE:<lineageId>` / `MODULE:<lineageId>`: what a choice stores. */
  ref: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export type ContractOrderPrice = {
  __typename?: 'ContractOrderPrice';
  amount: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  period: Scalars['String']['output'];
};

export type ContractPdf = {
  __typename?: 'ContractPdf';
  base64: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
};

export type ContractPreview = {
  __typename?: 'ContractPreview';
  html: Scalars['String']['output'];
  /** Client details the record lacks; they print as blanks. */
  missing: Array<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

/** Someone a signer passed the contract on to. */
export type ContractReassignment = {
  __typename?: 'ContractReassignment';
  at: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
};

/** One person a contract goes to, in the order they are asked. */
export type ContractRecipientInput = {
  contactId?: InputMaybe<Scalars['ID']['input']>;
  email?: Scalars['String']['input'];
  /** A client signer a form names: sendContractAfterForm sends the contract once the form is answered. */
  fromForm?: InputMaybe<Scalars['Boolean']['input']>;
  name?: Scalars['String']['input'];
  role: ContractRecipientRole;
  /** The slot a signer fills. */
  slot?: InputMaybe<Scalars['String']['input']>;
  /** A member of the sender's team (their auth id); required for a countersigner. */
  userSub?: InputMaybe<Scalars['String']['input']>;
};

export enum ContractRecipientRole {
  Cc = 'CC',
  Signer = 'SIGNER',
}

/** One person a contract went to: a signer, or a copy. */
export type ContractRecipientView = {
  __typename?: 'ContractRecipientView';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  inviteError?: Maybe<Scalars['String']['output']>;
  inviteStatus?: Maybe<ContractInviteStatus>;
  /** MAILBOX or REVVLY. */
  inviteVia?: Maybe<Scalars['String']['output']>;
  lastOpenedAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  openCount: Scalars['Int']['output'];
  reassignedFrom: Array<ContractReassignment>;
  role: ContractRecipientRole;
  side?: Maybe<ContractSlotSide>;
  signedAt?: Maybe<Scalars['DateTime']['output']>;
  slot?: Maybe<Scalars['String']['output']>;
  slotLabel?: Maybe<Scalars['String']['output']>;
  /** WAITING, SENDING, INVITED, FAILED, MANUAL (the sender writes it), NOT_SENT, OPENED, SIGNED, or COPY (a CC). */
  state: Scalars['String']['output'];
  /** 1-based step, as the sender set it. */
  step: Scalars['Int']['output'];
  /** Their link, while the contract is out. */
  url?: Maybe<Scalars['String']['output']>;
  /** The viewer is this countersigner, and it is their turn. */
  viewerSignsHere: Scalars['Boolean']['output'];
};

/** What happens at the end of the committed term. Governs the commitment boundary only — ordinary period boundaries inside the term stay with the subscription's autoRenew flag. */
export enum ContractRenewalTerms {
  AutoRenew = 'AUTO_RENEW',
  None = 'NONE',
  NoticeDays = 'NOTICE_DAYS',
}

/** A contract sent to a client for signature. */
export type ContractRequest = {
  __typename?: 'ContractRequest';
  id: Scalars['ID']['output'];
  openedAt?: Maybe<Scalars['DateTime']['output']>;
  recordedContractId?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['DateTime']['output'];
  signedAt?: Maybe<Scalars['DateTime']['output']>;
  signerEmail: Scalars['String']['output'];
  /** The client's first signer. */
  signerName: Scalars['String']['output'];
  status: ContractRequestStatus;
  /** The subscription a signed contract's order form points at, to open the subscription wizard with. Only on the client's list; null when there is no order form or it is not signed. */
  subscriptionProposal?: Maybe<FormSubscriptionProposal>;
  title: Scalars['String']['output'];
  /** The client's first signer's link, while they can still sign. */
  url?: Maybe<Scalars['String']['output']>;
  /** Who it waits on now, while it is out. */
  waitingOn?: Maybe<Scalars['String']['output']>;
};

export enum ContractRequestStatus {
  Cancelled = 'CANCELLED',
  Opened = 'OPENED',
  Sent = 'SENT',
  Signed = 'SIGNED',
}

/** A contract waiting on a form that asks who signs it. */
export type ContractSendPlan = {
  __typename?: 'ContractSendPlan';
  createdAt: Scalars['DateTime']['output'];
  formName: Scalars['String']['output'];
  /** The form's link, while it waits. */
  formUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Why it was not sent on its own. */
  problem?: Maybe<Scalars['String']['output']>;
  /** The contract it became, once sent. */
  requestId?: Maybe<Scalars['ID']['output']>;
  signerEmail?: Maybe<Scalars['String']['output']>;
  signerName?: Maybe<Scalars['String']['output']>;
  status: ContractSendPlanStatus;
  title: Scalars['String']['output'];
};

export enum ContractSendPlanStatus {
  Cancelled = 'CANCELLED',
  NeedsAttention = 'NEEDS_ATTENTION',
  Sent = 'SENT',
  Waiting = 'WAITING',
}

export type ContractSignatureBlock = {
  __typename?: 'ContractSignatureBlock';
  company?: Maybe<Scalars['String']['output']>;
  /** The drawn signature as a PNG data URL. */
  drawing?: Maybe<Scalars['String']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  signedAt?: Maybe<Scalars['DateTime']['output']>;
  slot: Scalars['String']['output'];
};

/** A published form that asks who signs a contract. */
export type ContractSignerForm = {
  __typename?: 'ContractSignerForm';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** Who signs where: `{{signature.<key>}}` in the text. */
export type ContractSlot = {
  __typename?: 'ContractSlot';
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  side: ContractSlotSide;
};

export type ContractSlotInput = {
  key: Scalars['String']['input'];
  label: Scalars['String']['input'];
  side: ContractSlotSide;
};

export enum ContractSlotSide {
  Client = 'CLIENT',
  Company = 'COMPANY',
}

/** Where a contract sits in its signing lifecycle. */
export enum ContractStatus {
  Cancelled = 'CANCELLED',
  Draft = 'DRAFT',
  Expired = 'EXPIRED',
  PendingSignature = 'PENDING_SIGNATURE',
  Signed = 'SIGNED',
}

/** Someone on the team who can countersign. */
export type ContractTeamMember = {
  __typename?: 'ContractTeamMember';
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** Their auth id: what a countersigner recipient takes as userSub. */
  userSub: Scalars['String']['output'];
};

/** A contract on Library → Contracts, sent for signature from a client page. */
export type ContractTemplate = {
  __typename?: 'ContractTemplate';
  /** The working copy, when there are changes that are not published. */
  draft?: Maybe<ContractTemplateDraft>;
  fields: Array<ContractTemplateField>;
  /** Sanitised HTML with {{scope.name}} placeholders. */
  html: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  orderForm?: Maybe<ContractOrderForm>;
  /** Signers confirm a code emailed to them before signing. */
  requireEmailCode: Scalars['Boolean']['output'];
  /** The order a send starts from. */
  signingOrder: SigningOrder;
  slots: Array<ContractSlot>;
  /** DRAFT: never published, so it cannot be sent yet. */
  status: ContractTemplateStatus;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  /** Goes up when a version is published, never on a draft save. */
  version: Scalars['Int']['output'];
};

/** The content of a contract template: live, drafted or kept as a version. */
export type ContractTemplateContent = {
  __typename?: 'ContractTemplateContent';
  fields: Array<ContractTemplateField>;
  /** Sanitised HTML with {{scope.name}} placeholders. */
  html: Scalars['String']['output'];
  orderForm?: Maybe<ContractOrderForm>;
  requireEmailCode: Scalars['Boolean']['output'];
  signingOrder: SigningOrder;
  slots: Array<ContractSlot>;
  title: Scalars['String']['output'];
};

/** The working copy of a contract. It saves as it is edited, finished or not; completeness is checked when it is published. */
export type ContractTemplateDraft = {
  __typename?: 'ContractTemplateDraft';
  /** The published version this draft started from. */
  baseVersion: Scalars['Int']['output'];
  fields: Array<ContractTemplateField>;
  /** Sanitised HTML with {{scope.name}} placeholders. */
  html: Scalars['String']['output'];
  orderForm?: Maybe<ContractOrderForm>;
  requireEmailCode: Scalars['Boolean']['output'];
  /** Send it back with the next save: a mismatch means a conflict. */
  revision: Scalars['Int']['output'];
  savedAt: Scalars['DateTime']['output'];
  savedBy?: Maybe<Scalars['String']['output']>;
  signingOrder: SigningOrder;
  slots: Array<ContractSlot>;
  title: Scalars['String']['output'];
};

export type ContractTemplateField = {
  __typename?: 'ContractTemplateField';
  /** A blank with no question: the signer fills it where it sits. */
  blank: Scalars['Boolean']['output'];
  filledBy: ContractFieldFilledBy;
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  /** A CHOICE field only. */
  options?: Maybe<Array<ContractChoiceOption>>;
  required: Scalars['Boolean']['output'];
  /** A COMPUTED field only. */
  rule?: Maybe<ContractDateRule>;
  /** A SIGNER field only: the key of the signer slot who fills it. Null: the first client signer. */
  signerSlot?: Maybe<Scalars['String']['output']>;
  type: ContractFieldType;
};

export type ContractTemplateFieldInput = {
  blank?: Scalars['Boolean']['input'];
  filledBy: ContractFieldFilledBy;
  key: Scalars['String']['input'];
  label: Scalars['String']['input'];
  options?: InputMaybe<Array<ContractChoiceOptionInput>>;
  required?: Scalars['Boolean']['input'];
  rule?: InputMaybe<ContractDateRuleInput>;
  signerSlot?: InputMaybe<Scalars['String']['input']>;
  type: ContractFieldType;
};

export type ContractTemplateInput = {
  fields?: Array<ContractTemplateFieldInput>;
  html: Scalars['String']['input'];
  orderForm?: InputMaybe<ContractOrderFormInput>;
  requireEmailCode?: InputMaybe<Scalars['Boolean']['input']>;
  signingOrder?: InputMaybe<SigningOrder>;
  slots?: InputMaybe<Array<ContractSlotInput>>;
  title: Scalars['String']['input'];
};

export enum ContractTemplateStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  /** Never published: it exists only as a draft and cannot be sent. */
  Draft = 'DRAFT',
}

/** One published version of a contract, as it was published. */
export type ContractTemplateVersion = {
  __typename?: 'ContractTemplateVersion';
  fields: Array<ContractTemplateField>;
  /** Sanitised HTML with {{scope.name}} placeholders. */
  html: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  orderForm?: Maybe<ContractOrderForm>;
  publishedAt: Scalars['DateTime']['output'];
  publishedBy?: Maybe<Scalars['String']['output']>;
  requireEmailCode: Scalars['Boolean']['output'];
  signingOrder: SigningOrder;
  slots: Array<ContractSlot>;
  title: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

/** Kind of agreement. An MSA is the framework and is usually evergreen; a SOW is where a committed term normally lives. */
export enum ContractType {
  Amendment = 'AMENDMENT',
  Msa = 'MSA',
  Nda = 'NDA',
  Other = 'OTHER',
  Sow = 'SOW',
}

export type ContractValueInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type ConversationThreadVisibility = {
  __typename?: 'ConversationThreadVisibility';
  /** Owner of a PRIVATE thread. Null for SHARED and HIDDEN. */
  privateToAuthId?: Maybe<Scalars['String']['output']>;
  state: ConversationThreadVisibilityState;
  threadId: Scalars['String']['output'];
};

/** How a conversation thread is shown: to the whole team, only to its owner, or hidden from the default list. */
export enum ConversationThreadVisibilityState {
  Hidden = 'HIDDEN',
  Private = 'PRIVATE',
  Shared = 'SHARED',
}

export type CopilotSignalAction = {
  __typename?: 'CopilotSignalAction';
  /** Action identifier the UI dispatches — e.g. 'open-subscription:abc123' */
  action: Scalars['String']['output'];
  /** Button label, e.g. 'Open subscription' */
  label: Scalars['String']['output'];
  primary: Scalars['Boolean']['output'];
};

export type CorrectUsageReadingInput = {
  /** COMMISSION: corrected net GMV for the period. */
  netGmv?: InputMaybe<Scalars['Float']['input']>;
  /** Corrected billable quantity for the closed period. */
  quantity: Scalars['Float']['input'];
  readingId: Scalars['ID']['input'];
  /** Required reason recorded in the audit trail for the superseding correction. */
  reason: Scalars['String']['input'];
  /** COMMISSION: corrected transaction count for the period. */
  transactionCount?: InputMaybe<Scalars['Int']['input']>;
};

/** An invoice present in BOTH the spreadsheet and the Drive sync — corroborated field-by-field before any commit. */
export type CorroboratedImportRecord = {
  __typename?: 'CorroboratedImportRecord';
  /** Whether the two sources name a compatible client (false = likely mis-join or OCR error) */
  clientNameCompatible: Scalars['Boolean']['output'];
  /** Fields the sources disagree on */
  conflicts: Array<CombinedImportFieldConflict>;
  /** Fields both sources agree on (raised confidence) */
  corroboratedFields: Array<Scalars['String']['output']>;
  csvClientName?: Maybe<Scalars['String']['output']>;
  /** Index of the matching row in the submitted transactions array */
  csvRowIndex: Scalars['Int']['output'];
  driveClientName?: Maybe<Scalars['String']['output']>;
  /** Id of the matching staged Drive sync result */
  driveResultId: Scalars['ID']['output'];
  fileName?: Maybe<Scalars['String']['output']>;
  /** Fields only the spreadsheet supplies */
  filledFromCsv: Array<Scalars['String']['output']>;
  /** Fields only the Drive extraction supplies */
  filledFromDrive: Array<Scalars['String']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  /** How the pair was joined: invoiceNumber (strong) or amountAndDate (heuristic) */
  matchedBy: Scalars['String']['output'];
};

export type CreateBundleInput = {
  /** Subscription periods available for this bundle */
  availablePeriods?: InputMaybe<Array<SubscriptionPeriod>>;
  description?: InputMaybe<Scalars['String']['input']>;
  featureFlagIds?: InputMaybe<Array<Scalars['String']['input']>>;
  moduleIds?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
  status?: EntityStatus;
  tier?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCheckInInputType = {
  /** 1 to 10. */
  confidence: Scalars['Int']['input'];
  keyResultId: Scalars['ID']['input'];
  /** Required when confidence drops 3 or more from the previous check-in. */
  note?: InputMaybe<Scalars['String']['input']>;
  /** Required on a manual Key Result; ignored on a metric one. */
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateCheckinInput = {
  name: Scalars['String']['input'];
  participants: CheckinParticipantsInput;
  questions: Array<CheckinQuestionInput>;
  schedule: CheckinScheduleInput;
  /** Slack channel id for the report. The bot must be able to post there. */
  slackChannelId: Scalars['String']['input'];
};

export type CreateContactRoleInput = {
  label: Scalars['String']['input'];
};

export type CreateCrmDocumentInput = {
  category?: InputMaybe<CrmDocumentCategory>;
  fileName: Scalars['String']['input'];
  fileSize: Scalars['Int']['input'];
  mimeType: Scalars['String']['input'];
  subjectId: Scalars['ID']['input'];
  subjectType: EntityTargetType;
};

export type CreateCrmEmailTemplateInput = {
  body: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  /** Library documents to attach when the template is applied (at most 5). */
  libraryDocumentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  name: Scalars['String']['input'];
  subject: Scalars['String']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  visibility?: InputMaybe<EmailTemplateVisibility>;
};

export type CreateCrmLeadInput = {
  billingPeriod?: InputMaybe<SubscriptionPeriod>;
  closeProbability?: InputMaybe<Scalars['Int']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  /** Demo date, entered by hand. */
  demoDate?: InputMaybe<Scalars['DateTime']['input']>;
  estimatedValue?: InputMaybe<Scalars['Float']['input']>;
  /** Expected annual recurring revenue, in the deal currency. */
  expectedArr?: InputMaybe<Scalars['Float']['input']>;
  expectedCloseDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Idempotency key for API-created leads. */
  externalRef?: InputMaybe<Scalars['String']['input']>;
  /** Selected module tier; only meaningful when interestedPlanKind is MODULE. */
  interestedModuleTierId?: InputMaybe<Scalars['ID']['input']>;
  interestedPlanId?: InputMaybe<Scalars['ID']['input']>;
  interestedPlanKind?: InputMaybe<CrmInterestedPlanKind>;
  /** Create a new PROSPECT organization in the same call. */
  newOrganization?: InputMaybe<NewOrganizationForLeadInput>;
  /** Existing organization; omit to create inline. */
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  ownerUserId?: InputMaybe<Scalars['ID']['input']>;
  /** Defaults to the tenant default pipeline. */
  pipelineId?: InputMaybe<Scalars['ID']['input']>;
  /** Defaults to the first OPEN stage. */
  pipelineStageId?: InputMaybe<Scalars['ID']['input']>;
  /** Estimated contract length, in billing periods paid upfront (mirrors the PREPAID_TERM billing schedule preset). Two or more. */
  prepaidPeriods?: InputMaybe<Scalars['Int']['input']>;
  primaryOrganizationContactId?: InputMaybe<Scalars['ID']['input']>;
  source?: InputMaybe<LeadSource>;
  title: Scalars['String']['input'];
  /** Trial end date, entered by hand. */
  trialEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Trial start date, entered by hand. */
  trialStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  variableEstimates?: InputMaybe<Array<CrmLeadVariableEstimateInput>>;
};

export type CreateCrmNoteInput = {
  body: Scalars['String']['input'];
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  subjectId: Scalars['ID']['input'];
  subjectType: EntityTargetType;
};

export type CreateCrmPipelineInput = {
  /** Teams whose members are granted access. */
  accessTeamIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Auth ids granted access. Leave both access lists empty for everyone. */
  accessUserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Rich-text description, as Markdown. */
  description?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  /** Omit to start from the standard New → Qualified → Proposal → Won/Lost stages. */
  stages?: InputMaybe<Array<PipelineStageInput>>;
};

export type CreateCrmTagInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateCustomFieldInput = {
  entityType: CustomFieldEntityType;
  fieldType: CustomFieldType;
  label: Scalars['String']['input'];
  options?: InputMaybe<Array<CustomFieldOptionInput>>;
  visibilityRole?: InputMaybe<FunctionRole>;
};

export type CreateCustomPricingAgreementInput = {
  aiAssisted?: InputMaybe<Scalars['Boolean']['input']>;
  creationRationale?: InputMaybe<Scalars['String']['input']>;
  customBillingTiming?: InputMaybe<BillingTiming>;
  customCommittedQty?: InputMaybe<Scalars['Int']['input']>;
  customCurrency?: InputMaybe<Scalars['String']['input']>;
  customIncludedUnits?: InputMaybe<Scalars['Int']['input']>;
  customModelType?: InputMaybe<PricingModelType>;
  customOveragePrice?: InputMaybe<Scalars['Float']['input']>;
  customProrationCalculation?: InputMaybe<ProrationCalculation>;
  customSteps?: InputMaybe<Array<CustomPricingStepInput>>;
  customTiers?: InputMaybe<Array<CustomPricingTierInput>>;
  customUnitPrice?: InputMaybe<Scalars['Float']['input']>;
  effectiveFrom: Scalars['DateTime']['input'];
  endCustomerId: Scalars['ID']['input'];
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Axes this agreement overrides (PRICE, MODEL, PRORATION, BILLING_TIMING, CURRENCY). */
  overrideScope: Array<CustomAgreementOverrideAxis>;
  publishPath?: InputMaybe<PublishPath>;
  variableComponentId: Scalars['ID']['input'];
};

export type CreateCycleInputType = {
  endDate: Scalars['DateTime']['input'];
  name: Scalars['String']['input'];
  /** Defaults to the person creating it. */
  ownerUserId?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTime']['input'];
};

export type CreateEmailSignatureInput = {
  /** Signature HTML. Sanitized on save. */
  bodyHtml: Scalars['String']['input'];
  /** Make this the default signature */
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** Operator-facing label, e.g. "Full" or "Short reply" */
  name: Scalars['String']['input'];
  /** Bind the signature to one from-address. Omit for a signature that applies to any address. */
  sendingAddress?: InputMaybe<Scalars['String']['input']>;
};

export type CreateExpansionInput = {
  currency: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  effectiveDate?: InputMaybe<Scalars['DateTime']['input']>;
  expansionType: ExpansionType;
  itemId?: InputMaybe<Scalars['ID']['input']>;
  itemName?: InputMaybe<Scalars['String']['input']>;
  proratedAmount: Scalars['Float']['input'];
  quantityChange?: InputMaybe<Scalars['Float']['input']>;
  subscriptionId: Scalars['ID']['input'];
};

export type CreateFeatureFlagCategoryInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type CreateFeatureFlagInput = {
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: Scalars['Boolean']['input'];
  key: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreateFormInput = {
  definition?: InputMaybe<FormDefinitionInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateGeoRegionInput = {
  countryCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
  shapes?: InputMaybe<Array<GeoShapeInput>>;
};

export type CreateHypothesisInputType = {
  /** Confirm codes the person has accepted */
  acknowledge?: InputMaybe<Array<Scalars['String']['input']>>;
  /** 50, 80 or 100 */
  confidence?: InputMaybe<Scalars['Int']['input']>;
  decisionRule?: InputMaybe<Scalars['String']['input']>;
  /** Person-weeks, at least 0.25, in steps of 0.25 */
  effort?: InputMaybe<Scalars['Float']['input']>;
  estimatedEffect?: InputMaybe<Scalars['Float']['input']>;
  expectedOutcome?: InputMaybe<Scalars['String']['input']>;
  /** 0.25, 0.5, 1, 2 or 3 */
  impact?: InputMaybe<Scalars['Float']['input']>;
  keyResultId: Scalars['ID']['input'];
  /** Assigning needs the Key Result owner, its team lead or a cycle owner */
  ownerUserId?: InputMaybe<Scalars['String']['input']>;
  plannedEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  reach?: InputMaybe<Scalars['Int']['input']>;
  /** Defaults to the unit last used on this Key Result */
  reachUnit?: InputMaybe<Scalars['String']['input']>;
  /** We believe that [change] will [effect] because [reason]. Up to 1,000 characters */
  statement: Scalars['String']['input'];
  /** Up to 200 characters */
  title: Scalars['String']['input'];
};

export type CreateIncubatorInput = {
  /** Domain URL */
  domainUrl: Scalars['String']['input'];
  /** General Email for incubator */
  generalEmail: EmailInput;
  /** Name of incubator */
  name: Scalars['String']['input'];
  /** Incubators Plan Information */
  planInfo: PlanInfoInput;
  /** Slug */
  slug: Scalars['String']['input'];
  /** Email of Support for incubator. If not provided, could be same as General email */
  supportEmail: EmailInput;
};

export type CreateInvoiceInput = {
  /** ISO 4217 currency code */
  currency?: Scalars['String']['input'];
  /** Payment due date (ISO format) */
  dueDate: Scalars['String']['input'];
  /** Invoice date (ISO format) */
  invoiceDate: Scalars['String']['input'];
  /** Line items (at least one required) */
  lineItems: Array<CreateInvoiceLineItemInput>;
  /** Notes to show on the invoice */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Organization to bill */
  organizationId: Scalars['ID']['input'];
  /** Payment terms in days */
  paymentTermsDays?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateInvoiceLineItemInput = {
  /** Line item description */
  description: Scalars['String']['input'];
  /** What this line represents. Defaults to ONE_TIME_FEE — a manual invoice is an off-plan charge unless the operator says otherwise, and defaulting to a plan line would make it a base-price discount target. */
  lineKind?: InputMaybe<InvoiceLineKind>;
  /** Quantity */
  quantity: Scalars['Float']['input'];
  /** End of the service window this line bills */
  servicePeriodEnd?: InputMaybe<Scalars['String']['input']>;
  /** Start of the service window this line bills */
  servicePeriodStart?: InputMaybe<Scalars['String']['input']>;
  /** Tax category of the line, so a rate scoped to a category (a reduced rate) can apply to it. Left empty, the line is taxed at the all-items rate. */
  taxCategory?: InputMaybe<Scalars['String']['input']>;
  /** Unit price */
  unitPrice: Scalars['Float']['input'];
};

export type CreateKeyResultInputType = {
  cycleId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  /** Inferred from the numbers when omitted. */
  direction?: InputMaybe<KeyResultDirection>;
  /** Required when source is METRIC; refused otherwise. */
  metricKey?: InputMaybe<OkrMetricKey>;
  /** Required when the metric counts over a pipeline; refused otherwise. */
  metricPipelineId?: InputMaybe<Scalars['ID']['input']>;
  /** Null is allowed — an unattached draft. */
  objectiveId?: InputMaybe<Scalars['ID']['input']>;
  ownerUserId?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<KeyResultSource>;
  /** Ignored, along with unit and direction, when source is METRIC — all three come from the live metric instead. */
  startValue: Scalars['Float']['input'];
  targetValue: Scalars['Float']['input'];
  title: Scalars['String']['input'];
  unit: KeyResultUnit;
};

export type CreateLeadActionSettings = {
  __typename?: 'CreateLeadActionSettings';
  companyFieldKey?: Maybe<Scalars['String']['output']>;
  emailFieldKey?: Maybe<Scalars['String']['output']>;
  firstNameFieldKey?: Maybe<Scalars['String']['output']>;
  lastNameFieldKey?: Maybe<Scalars['String']['output']>;
  nameFieldKey?: Maybe<Scalars['String']['output']>;
  ownerUserId?: Maybe<Scalars['ID']['output']>;
  phoneFieldKey?: Maybe<Scalars['String']['output']>;
  pipelineId?: Maybe<Scalars['ID']['output']>;
  pipelineStageId?: Maybe<Scalars['ID']['output']>;
  titleTemplate?: Maybe<Scalars['String']['output']>;
  websiteFieldKey?: Maybe<Scalars['String']['output']>;
};

export type CreateLeadActionSettingsInput = {
  companyFieldKey?: InputMaybe<Scalars['String']['input']>;
  emailFieldKey?: InputMaybe<Scalars['String']['input']>;
  firstNameFieldKey?: InputMaybe<Scalars['String']['input']>;
  lastNameFieldKey?: InputMaybe<Scalars['String']['input']>;
  nameFieldKey?: InputMaybe<Scalars['String']['input']>;
  ownerUserId?: InputMaybe<Scalars['ID']['input']>;
  phoneFieldKey?: InputMaybe<Scalars['String']['input']>;
  pipelineId?: InputMaybe<Scalars['ID']['input']>;
  pipelineStageId?: InputMaybe<Scalars['ID']['input']>;
  titleTemplate?: InputMaybe<Scalars['String']['input']>;
  websiteFieldKey?: InputMaybe<Scalars['String']['input']>;
};

export type CreateLibraryDocumentInput = {
  category?: InputMaybe<LibraryDocumentCategory>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** The file id returned by requestLibraryDocumentUpload. */
  fileId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateMeterInput = {
  /** Default billed value for components bound to this meter. */
  billedValue?: InputMaybe<BilledValue>;
  /** Category or group this variable belongs to (e.g., "capacity", "usage", "custom") */
  category?: InputMaybe<Scalars['String']['input']>;
  /** Description of what this variable represents */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Human-readable name for this variable type */
  displayName: Scalars['String']['input'];
  /** Whether this variable type is currently available for use */
  isActive?: Scalars['Boolean']['input'];
  /** Legacy default measurement preset. Prefer resetBehaviour + billedValue. */
  measurementMode?: InputMaybe<MeasurementMode>;
  /** Default reset behaviour for components bound to this meter. */
  resetBehaviour?: InputMaybe<ResetBehaviour>;
  /** URL-safe identifier, unique per tenant, used to reference this meter from the external usage API. When omitted it is derived by slugifying variableType, with a numeric suffix if that is already taken. */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** Singular unit label shown in UIs and invoices (e.g. "seat", "GB") */
  unitLabel?: InputMaybe<Scalars['String']['input']>;
  /** Plural unit label shown in UIs (e.g. "seats", "GB"); defaults to singular */
  unitLabelPlural?: InputMaybe<Scalars['String']['input']>;
  /** Whether this variable counts whole units or decimal amounts */
  unitType?: InputMaybe<VariableUnitType>;
  /** The variable type identifier (e.g., "user", "storage", "api_calls") */
  variableType: Scalars['String']['input'];
};

export type CreateModuleInput = {
  /** Subscription periods available for this module */
  availablePeriods?: InputMaybe<Array<SubscriptionPeriod>>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  status?: EntityStatus;
  tiers: Array<CreateModuleTierInput>;
};

export type CreateModuleTierInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  /** Incremental feature flags this tier adds over the lower tiers. */
  featureFlagIds?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
  /** Rank (0-based). Defaults to the tier array position. Lower = smaller/cheaper tier. */
  order?: InputMaybe<Scalars['Int']['input']>;
  status?: EntityStatus;
};

export type CreateObjectiveInputType = {
  cycleId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  level: ObjectiveLevel;
  ownerUserId?: InputMaybe<Scalars['String']['input']>;
  /** Defaults to the editor’s own team. */
  teamId?: InputMaybe<Scalars['ID']['input']>;
  title: Scalars['String']['input'];
  type?: InputMaybe<ObjectiveType>;
};

export type CreateOrganizationContactInput = {
  /** Email address of the contact. Optional if a first or last name is given. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** First name of the contact. Optional if a last name or email is given. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Whether this is the primary contact for the organization */
  isPrimary?: Scalars['Boolean']['input'];
  /** Labels for the contact (e.g., billing, owner, champion, technical) */
  labels?: Array<Scalars['String']['input']>;
  /** Last name of the contact. Optional if a first name or email is given. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Additional notes about the contact */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** The organization to add the contact to; omit for a standalone contact. */
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  /** Phone number of the contact */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** Roles: finance, operations, champion, executive, technical */
  roles?: Array<Scalars['String']['input']>;
};

export type CreateOrganizationContractInput = {
  /** Defaults to OTHER. An MSA is the framework and is usually evergreen; a SOW is where a committed term normally lives. */
  contractType?: InputMaybe<ContractType>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** What happens to the uninvoiced remainder if the client leaves the committed term early. The default a cancellation inherits, not the answer — the cancel mutation may override it. Omit to leave the contract silent, which makes a cancellation inside a committed term state a policy of its own. */
  earlyTerminationPolicy?: InputMaybe<EarlyTerminationPolicy>;
  /** Operator-facing name. A contract nobody can identify is noise. */
  name: Scalars['String']['input'];
  /** Days of notice required before the term ends. Required with NOTICE_DAYS and refused with any other renewalTerms, where it would read as a rule nothing consults. */
  noticeDays?: InputMaybe<Scalars['Int']['input']>;
  /** The client this contract belongs to. */
  organizationId: Scalars['ID']['input'];
  /** What happens at the end of the committed term. Defaults to NONE (the commitment simply ends). Governs the commitment boundary only — ordinary period boundaries stay with the subscription's autoRenew flag. */
  renewalTerms?: InputMaybe<ContractRenewalTerms>;
  signedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** When the committed term begins. Independent of any subscription's startDate — attaching a contract never moves service or invoice dates. */
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Defaults to DRAFT. */
  status?: InputMaybe<ContractStatus>;
  /** Months the commitment runs. OMIT IT FOR AN EVERGREEN AGREEMENT — no committed span, which is the honest shape for an MSA. This is what separates the committed term from the billing cadence: "annual commitment paid monthly" is termMonths 12 on a MONTHLY subscription. A term the cadence cannot divide is refused when the contract is attached. */
  termMonths?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateOrganizationInput = {
  billingAddress?: InputMaybe<Scalars['String']['input']>;
  companyNumber?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** The client's primary web domain, e.g. acme.com. Unique per tenant — it is the CRM dedup key, and what same-domain contact suggestions are matched against. Requires the CRM feature, the same as editing it later does. */
  domain?: InputMaybe<Scalars['String']['input']>;
  /** Your own external reference for this client (unique per tenant). Store the id from your system and address the client by it later. */
  externalId?: InputMaybe<Scalars['String']['input']>;
  incubatorId?: InputMaybe<Scalars['String']['input']>;
  /** Prefix for this client's invoice numbers, e.g. "INV-ACME" yields INV-ACME-00042. Must be unique per tenant. Omit it and one is derived from the name (first four letters, uppercased, with a numeric suffix if another client already took that slug). */
  invoicePrefix?: InputMaybe<Scalars['String']['input']>;
  isTrialActive?: Scalars['Boolean']['input'];
  legalName?: InputMaybe<Scalars['String']['input']>;
  legalStructure?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  /** Sequence number to use on this client's next generated invoice. Set it when onboarding a client that already has invoice history elsewhere (e.g. they are at invoice 14, so pass 15). Consumed on the first generated invoice; numbering continues from there on its own. */
  nextInvoiceNumber?: InputMaybe<Scalars['Int']['input']>;
  /** Payment terms in days for invoices sent to this client. Overrides the tenant default when set; leave unset to inherit. */
  paymentTermsDays?: InputMaybe<Scalars['Int']['input']>;
  /** An existing customer that is only now being added to Revvly. Its first subscription is reported as a renewal rather than a new acquisition — in the MRR movement, the drill-down and the new/renewed-accounts OKR metrics. Changeable later; analytics follow the current value. */
  preExistingCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  /** Region ID where the organization will be located. Must be a valid, active region. */
  regionId: Scalars['String']['input'];
  /** Per-period override of the tenant's renewal-invoice lead time. Each period left unset inherits the tenant default; 0 disables advance invoicing for that period. */
  renewalInvoiceLeadDays?: InputMaybe<RenewalInvoiceLeadDaysInput>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  trialEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  trialStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Default how metered usage reaches Revvly for this client (API or MANUAL). Null inherits the platform default (API). Per-component overrides on a subscription win over this. */
  usageCaptureMode?: InputMaybe<UsageCaptureMode>;
};

export type CreateOutboundWebhookEndpointInput = {
  /** Defaults to true. */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** See `webhookEventTypes` for the valid values. */
  eventTypes: Array<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  /** Limit to these pipelines. Omit or leave empty for every pipeline. */
  pipelineIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** An https URL, e.g. a Zapier "Catch Hook" address. */
  url: Scalars['String']['input'];
};

export type CreatePricingRuleInput = {
  currency: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['Float']['input'];
  refId?: InputMaybe<Scalars['String']['input']>;
  refType?: InputMaybe<PricingRuleRefType>;
  regionId?: InputMaybe<Scalars['String']['input']>;
  ruleType: PricingRuleType;
  scope: PricingScope;
  subscriptionPeriod?: InputMaybe<SubscriptionPeriod>;
  /** Module tier this rule prices (ModuleTier id). Omit/null for the base/untiered price. ClickUp 86cabjuxn. */
  tierId?: InputMaybe<Scalars['String']['input']>;
  validFrom?: InputMaybe<Scalars['DateTime']['input']>;
  validTo?: InputMaybe<Scalars['DateTime']['input']>;
  /** Variable limits that define included quantities and pricing for additional units */
  variableLimits?: InputMaybe<Array<VariableLimitInput>>;
};

export type CreateProspectOrganizationContactInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  ownerUserId?: InputMaybe<Scalars['ID']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<LeadSource>;
};

export type CreateProspectOrganizationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  /** Web domain — normalized + deduplicated. */
  domain?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  /** Free-text industry / sector. */
  industry?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  ownerUserId?: InputMaybe<Scalars['ID']['input']>;
  /** Optional region; not required for a prospect. */
  regionId?: InputMaybe<Scalars['ID']['input']>;
  source?: InputMaybe<LeadSource>;
};

export type CreateRecurrenceRuleInput = {
  /** User ids each generated task is assigned to. */
  assigneeUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Stop generating after this date. */
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Stop after this many generated tasks. */
  maxOccurrences?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  priority?: InputMaybe<TaskPriority>;
  recurrence: RecurrenceSpecInput;
  /** Entity each generated task is anchored to (e.g. a client). */
  relation?: InputMaybe<RecurrenceRelationInput>;
  /** Series anchor. Defaults to now. */
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreateRegionInput = {
  code: Scalars['String']['input'];
  defaultCurrency: Currency;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  supportedCurrencies: Array<Currency>;
};

export type CreateSubscriptionWithPricingInput = {
  /** Whether the subscription auto-renews */
  autoRenew?: Scalars['Boolean']['input'];
  /** When the start date is in the past, also generate the renewal invoices for every billing period that has already elapsed between the start date and now. Each backfilled invoice is backdated to its period start; periods that have fully elapsed are marked PAID. The subscription end / next-renewal dates are advanced to the current period so automatic renewal continues from today. */
  backfillInvoicesUntilNow?: Scalars['Boolean']['input'];
  /** Per-period payment overrides for the historical backfill, one per invoice the backfill emits (identified by issue date). Honoured only when `backfillInvoicesUntilNow` is true. Any period without a matching override falls back to the default rule (fully-elapsed terms paid on their issue date, the current term pending). */
  backfillPeriods?: InputMaybe<Array<BackfillPeriodInput>>;
  /** Override base price (if not using calculated pricing) */
  basePriceOverride?: InputMaybe<Scalars['Float']['input']>;
  /** When and how this subscription is invoiced, as a preset (PRD §2.3). Omit for the implicit default: one base charge per period, on renewal. Requires the BILLING_SCHEDULE tenant feature. */
  billingSchedule?: InputMaybe<BillingSchedulePresetInput>;
  /** Bundle ID (if subscribing to a bundle) */
  bundleId?: InputMaybe<Scalars['ID']['input']>;
  /** Locked currency for the subscription. Must be one of the organization region's supported currencies; defaults to the region's default currency. */
  currency?: InputMaybe<Scalars['String']['input']>;
  /** Components attached directly at creation (PRD §18.2), each carrying its single-term inclusion and an optional inline subscription-scoped price. Preferred over variableComponentIds when inclusion or an inline price is needed; the two may be combined. */
  directComponents?: InputMaybe<Array<DirectComponentInput>>;
  /** Subscription end date (optional for auto-renewing subscriptions) */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Auto-include Variable Component lineages to leave OFF this subscription, despite the chosen Module/Bundle marking them autoIncludeOnSubscribe. Each id must be a Variable Component lineage id that is actually an auto-include candidate for the chosen plan, or creation is refused. Persisted so the exclusion survives later plan changes rather than silently reappearing. */
  excludedComponentLineageIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Customer-supplied external reference (e.g. your own account/subscription id). Unique per tenant. Lets you report usage by `externalSubscriptionId` without storing Revvly internal IDs. */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** Initial discounts to apply to the subscription at creation time (Flexible Discounting §8.1). Applied before invoice generation so the start invoice reflects the discount. */
  initialDiscounts?: InputMaybe<Array<InitialDiscountInput>>;
  /** Per-item price overrides: replace the list price of the pinned bundle and/or any pinned module. The subscription bills the sum of the (overridden) items. Mutually exclusive with basePriceOverride, which replaces the whole base price instead. */
  itemPriceOverrides?: InputMaybe<Array<ItemPriceOverrideInput>>;
  /** Deliberately pin this subscription to an ARCHIVED (past) catalog version — the grandfathering case. Without it, only PUBLISHED versions can be subscribed to, so an archived id is refused. This is not an authorisation flag: it is the difference between knowingly putting a migrated client on a legacy plan and accidentally selling a plan that was retired, and the reason is recorded on the subscription's pin history. */
  legacyVersionPin?: InputMaybe<LegacyVersionPinInput>;
  /** Free-form metadata (key/value pairs) echoed back on the read API. */
  metadata?: InputMaybe<Array<MetadataEntryInput>>;
  /** Module ID - single-module pin (mutually exclusive with bundleId) */
  moduleId?: InputMaybe<Scalars['ID']['input']>;
  /** Module IDs (if subscribing to individual modules) */
  moduleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Per-module priced tier selection (86cabjuxn). Each entry pins one of moduleId/moduleIds to a tier; the tier price is used (with fallback to the module base price). Modules without an entry use the base/untiered price. */
  moduleTiers?: InputMaybe<Array<ModuleTierSelectionInput>>;
  /** Notes about the subscription */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Organization ID */
  organizationId: Scalars['ID']['input'];
  /** Billing period */
  period: SubscriptionPeriod;
  /** The plan changes in this client's history, oldest first — the migration case, where a subscription being imported has been through several plans before Revvly existed. The subscription starts on the plan named by bundleId / moduleIds; each entry here is recorded as a backdated change, so the historical invoices generated by backfillInvoicesUntilNow bill the plan in force for their own period. Without it every reconstructed period bills the plan the subscription is created on. */
  pinTimeline?: InputMaybe<Array<PinTimelineEntryInput>>;
  /** Whether to skip price validation and use provided prices */
  skipPriceValidation?: Scalars['Boolean']['input'];
  /** Subscription start date */
  startDate: Scalars['DateTime']['input'];
  /** Free trial length in days (1–365). The subscription starts as TRIAL: usage can be reported, nothing is invoiced and nothing counts as revenue. When the trial ends it converts to ACTIVE, its first period starts that day and is invoiced. Requires a start date that is not in the future; not combinable with an end date, a billing schedule or backfill. */
  trialDays?: InputMaybe<Scalars['Int']['input']>;
  /** With trialDays: the trial converts only once the client has a card on file. A trial past its end without one stays TRIAL; saving a card converts it from that moment. */
  trialRequiresPaymentMethod?: InputMaybe<Scalars['Boolean']['input']>;
  /** Variable Component IDs to attach to this subscription (PRD §25.4). Standalone Variable Components — sold without a Module/Bundle parent — are listed here. Auto-include catalog links on the chosen Modules/Bundles are merged in automatically; explicit IDs here are deduped against them. */
  variableComponentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CreateTaskInput = {
  anchor?: InputMaybe<TaskAnchorInput>;
  assignees?: InputMaybe<Array<AssigneeInput>>;
  /** Markdown source (<= 10,000 chars). */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Today or later when provided. */
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  externalLinks?: InputMaybe<Array<ExternalLinkInput>>;
  name: Scalars['String']['input'];
  priority?: TaskPriority;
  relation?: InputMaybe<TaskRelationInput>;
  remindAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: TaskStatus;
};

export type CreateTaxRateInput = {
  code: Scalars['String']['input'];
  compound?: InputMaybe<Scalars['Boolean']['input']>;
  countryCode: Scalars['String']['input'];
  displayLabel: Scalars['String']['input'];
  effectiveFrom: Scalars['DateTime']['input'];
  effectiveTo?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  ratePct: Scalars['String']['input'];
  registrationId: Scalars['ID']['input'];
  replacesCountryRates?: InputMaybe<Scalars['Boolean']['input']>;
  sequence?: InputMaybe<Scalars['Int']['input']>;
  subdivisionCode?: InputMaybe<Scalars['String']['input']>;
  taxCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  taxCode: Scalars['String']['input'];
  taxType: TaxType;
  treatment: TaxTreatment;
};

export type CreateTaxRegistrationInput = {
  countryCode: Scalars['String']['input'];
  effectiveFrom: Scalars['DateTime']['input'];
  effectiveTo?: InputMaybe<Scalars['DateTime']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  registrationNumber: Scalars['String']['input'];
  scheme: TaxType;
  subdivisionCode?: InputMaybe<Scalars['String']['input']>;
};

/** Create a team */
export type CreateTeamInput = {
  /** Auth id of the lead. They need not be a member of the team */
  leadUserId?: InputMaybe<Scalars['String']['input']>;
  /** Auth ids to add on creation. Only offered while creating; afterwards membership is managed on the team itself */
  memberUserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Display name. Duplicates are permitted */
  name: Scalars['String']['input'];
};

export type CreateTenantInput = {
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
};

export type CreateVariableComponentInput = {
  /** True if generated by chat, template, or AI assist */
  aiAssisted?: InputMaybe<Scalars['Boolean']['input']>;
  appliesTo?: InputMaybe<PromotionalAppliesTo>;
  applyTo?: InputMaybe<CommissionApplyTo>;
  /** Billing terms this component is offered on. Defaults to all terms (monthly, quarterly, yearly) when omitted. */
  availablePeriods?: InputMaybe<Array<SubscriptionPeriod>>;
  basePricingRuleId?: InputMaybe<Scalars['ID']['input']>;
  /** Which number in the period is rated: MAX, TOTAL, or CLOSING. Wins over measurementMode when set. */
  billedValue?: InputMaybe<BilledValue>;
  billingTiming?: BillingTiming;
  committedQuantity?: InputMaybe<Scalars['Int']['input']>;
  /** Original chat prompt or template name */
  creationRationale?: InputMaybe<Scalars['String']['input']>;
  discountType?: InputMaybe<PromotionalDiscountType>;
  discountValue?: InputMaybe<Scalars['Float']['input']>;
  durationPeriods?: InputMaybe<Scalars['Int']['input']>;
  freeAllowance?: InputMaybe<Scalars['Int']['input']>;
  hardCap?: Scalars['Boolean']['input'];
  includedUnits?: InputMaybe<Scalars['Int']['input']>;
  /** Customer-facing invoice rendering options. Defaults applied when omitted. */
  invoicePresentation?: InputMaybe<InvoicePresentationInput>;
  limitPeriod?: InputMaybe<LimitPeriodInput>;
  /** Legacy preset. Prefer resetBehaviour + billedValue. When all axis fields are omitted and a meter is bound, the meter’s axes are inherited; otherwise defaults to PEAK (STANDING/MAX). */
  measurementMode?: InputMaybe<MeasurementMode>;
  modelType: PricingModelType;
  /** Operator-facing display name for this component */
  name: Scalars['String']['input'];
  percentageRate?: InputMaybe<Scalars['Float']['input']>;
  promotionStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  prorationCalculation?: ProrationCalculation;
  /** How this draft was authored — defaults to FORM */
  publishPath?: InputMaybe<PublishPath>;
  /** What happens when the period closes: STANDING carries forward, PER_PERIOD resets. Wins over measurementMode when set. */
  resetBehaviour?: InputMaybe<ResetBehaviour>;
  startTrigger?: InputMaybe<PromotionalStartTrigger>;
  steps?: InputMaybe<Array<PricingStepInput>>;
  tiers?: InputMaybe<Array<PricingTierInput>>;
  unit: Scalars['String']['input'];
  unitPlural: Scalars['String']['input'];
  /** What an unreported metered period means here: REVIEW holds the invoice for a human (default), ZERO seals at zero automatically. */
  unreportedUsagePolicy?: InputMaybe<UnreportedUsagePolicy>;
  unusedUnitBehavior?: InputMaybe<UnusedUnitBehavior>;
  /** Bind to an existing Meter. Omit to auto-provision a Meter from `name` — the normal path; only set this to deliberately share usage-tracking identity with another meter/component. */
  variableId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreditApplication = {
  __typename?: 'CreditApplication';
  /** Positive: credit spent on that invoice. */
  amount: Scalars['Decimal']['output'];
  appliedAt: Scalars['DateTime']['output'];
  /** The receivable this slice of credit settled. */
  invoiceId: Scalars['ID']['output'];
};

export type CreditNoteLineItemInput = {
  /** POSITIVE amount to credit. The server stores the negative — sending a negative here is refused rather than flipped, because a caller that already negated would otherwise produce a credit note that BILLS the client. */
  amount: Scalars['Float']['input'];
  /** Shown on the credit note, so write it for the client. */
  description: Scalars['String']['input'];
  /** Defaults to 1. */
  quantity?: InputMaybe<Scalars['Int']['input']>;
  /** End of the service window being credited. */
  servicePeriodEnd?: InputMaybe<Scalars['String']['input']>;
  /** Start of the service window being credited. */
  servicePeriodStart?: InputMaybe<Scalars['String']['input']>;
};

export type CrmBoard = {
  __typename?: 'CrmBoard';
  columns: Array<CrmBoardColumn>;
  pipeline: CrmPipeline;
  /** Every pipeline on the board, in the order requested. */
  pipelines: Array<CrmPipeline>;
};

export type CrmBoardColumn = {
  __typename?: 'CrmBoardColumn';
  leadCount: Scalars['Int']['output'];
  leads: Array<CrmLead>;
  /** The pipeline this stage belongs to. */
  pipelineId: Scalars['ID']['output'];
  pipelineName: Scalars['String']['output'];
  stage: PipelineStage;
};

/** How a CRM record was created (provenance). */
export enum CrmCreatedVia {
  Agent = 'AGENT',
  Api = 'API',
  Direct = 'DIRECT',
  Integration = 'INTEGRATION',
}

/** Provenance for a CRM record that was derived from another artefact rather than typed by an operator. */
export type CrmDerivedFrom = {
  __typename?: 'CrmDerivedFrom';
  /** 0..1 for probabilistic extractors; null for a deterministic parse. */
  confidence?: Maybe<Scalars['Float']['output']>;
  derivedAt: Scalars['DateTime']['output'];
  extractor?: Maybe<Scalars['String']['output']>;
  extractorVersion?: Maybe<Scalars['String']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
  sourceSystem: CrmMeetingSource;
};

export type CrmDocument = {
  __typename?: 'CrmDocument';
  category?: Maybe<CrmDocumentCategory>;
  createdAt: Scalars['DateTime']['output'];
  /** Whether the bytes can actually be fetched. False for an attachment the mailbox recorded but never stored — storage unconfigured at ingest, a provider that supplied no bytes, or a failed upload. The row is still worth showing (the record is more complete with it), but offering a download for it only produces an error. */
  downloadable: Scalars['Boolean']['output'];
  /** DRIVE documents: PENDING, COPIED, LINK_ONLY or FAILED. */
  driveCopyState?: Maybe<Scalars['String']['output']>;
  /** Set on a DRIVE document: open the file in Google Drive. */
  driveWebViewLink?: Maybe<Scalars['String']['output']>;
  fileName: Scalars['String']['output'];
  fileSize: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  /** For a document In review: the import batch to open to review and commit it. */
  importReviewJobId?: Maybe<Scalars['ID']['output']>;
  /** The invoice an import created from this file. */
  invoiceId?: Maybe<Scalars['ID']['output']>;
  /** The mark cannot change (the file was imported, or Revvly wrote it). */
  markLocked: Scalars['Boolean']['output'];
  markSource?: Maybe<CrmDocumentMarkSource>;
  markState?: Maybe<CrmDocumentMarkState>;
  mimeType: Scalars['String']['output'];
  source: CrmDocumentSource;
  /** Set when source is EMAIL: the message this document arrived on. */
  sourceEmail?: Maybe<CrmDocumentSourceEmail>;
  subject: CrmSubjectRef;
  /** "Looks like an invoice" under the Suggest setting. Not a mark until confirmed. */
  suggestedCategory?: Maybe<CrmDocumentCategory>;
  updatedAt: Scalars['DateTime']['output'];
  /** Null on an email-filed document — nobody uploaded it. */
  uploadedBy?: Maybe<Scalars['ID']['output']>;
  /** Signed download URL (field resolver). */
  url?: Maybe<Scalars['String']['output']>;
};

/** CRM document category. */
export enum CrmDocumentCategory {
  Contract = 'CONTRACT',
  CreditNote = 'CREDIT_NOTE',
  Deck = 'DECK',
  Invoice = 'INVOICE',
  Other = 'OTHER',
  ProofOfPayment = 'PROOF_OF_PAYMENT',
  Proposal = 'PROPOSAL',
}

/** Who set a document mark. */
export enum CrmDocumentMarkSource {
  Folder = 'FOLDER',
  SuggestionConfirmed = 'SUGGESTION_CONFIRMED',
  System = 'SYSTEM',
  User = 'USER',
}

/** Where an Invoice or Credit note mark is: marked, in review, imported, paid. */
export enum CrmDocumentMarkState {
  Imported = 'IMPORTED',
  InReview = 'IN_REVIEW',
  Marked = 'MARKED',
  Paid = 'PAID',
  PartlyPaid = 'PARTLY_PAID',
}

/** Whether a CRM document was uploaded by a person or filed from an email. */
export enum CrmDocumentSource {
  Drive = 'DRIVE',
  Email = 'EMAIL',
  Upload = 'UPLOAD',
}

export type CrmDocumentSourceEmail = {
  __typename?: 'CrmDocumentSourceEmail';
  /** Sender inbound, recipients outbound. */
  counterparty?: Maybe<Scalars['String']['output']>;
  /** INBOUND or OUTBOUND. */
  direction: Scalars['String']['output'];
  /** Mailbox email id — the handle the download query takes. */
  mailboxEmailId: Scalars['ID']['output'];
  occurredAt: Scalars['DateTime']['output'];
  subject?: Maybe<Scalars['String']['output']>;
  /** Conversation thread key, for deep-linking the thread. */
  threadId?: Maybe<Scalars['String']['output']>;
};

export type CrmDocumentUploadTarget = {
  __typename?: 'CrmDocumentUploadTarget';
  /** Bucket the object was presigned into. Required by confirmUpload, which the client MUST call once the PUT succeeds — an unconfirmed file stays PENDING and can never be downloaded. */
  bucket: Scalars['String']['output'];
  /** StoredFile id to confirm the upload against. */
  fileId: Scalars['ID']['output'];
  storageKey: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
};

/** A mark-based view of a record’s documents: unmarked, to import, paid or unpaid invoices. */
export enum CrmDocumentView {
  PaidInvoices = 'PAID_INVOICES',
  ToImport = 'TO_IMPORT',
  Unmarked = 'UNMARKED',
  UnpaidInvoices = 'UNPAID_INVOICES',
}

/** Marketing-email consent state for a contact. */
export enum CrmEmailConsent {
  Bounced = 'BOUNCED',
  Subscribed = 'SUBSCRIBED',
  Unsubscribed = 'UNSUBSCRIBED',
}

/** Email direction. */
export enum CrmEmailDirection {
  Inbound = 'INBOUND',
  Outbound = 'OUTBOUND',
}

export type CrmEmailDocumentFilingResult = {
  __typename?: 'CrmEmailDocumentFilingResult';
  /** Documents written by this pass; 0 when everything was already filed. */
  filed: Scalars['Int']['output'];
  /** Conversation messages examined. */
  scanned: Scalars['Int']['output'];
};

export type CrmEmailMessage = {
  __typename?: 'CrmEmailMessage';
  bodyText: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdVia: CrmCreatedVia;
  direction: CrmEmailDirection;
  id: Scalars['ID']['output'];
  loggedBy: Scalars['ID']['output'];
  occurredAt: Scalars['DateTime']['output'];
  organizationContactId?: Maybe<Scalars['ID']['output']>;
  origin: CrmEmailOrigin;
  subject: CrmSubjectRef;
  subjectLine?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Email log origin. */
export enum CrmEmailOrigin {
  Manual = 'MANUAL',
  Synced = 'SYNCED',
}

export type CrmEmailTemplate = {
  __typename?: 'CrmEmailTemplate';
  /** Markdown body, same canonical form as the composer. */
  body: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** Auth sub of the creator. */
  createdBy: Scalars['String']['output'];
  /** Resolved display name for the selector. */
  createdByName?: Maybe<Scalars['String']['output']>;
  /** Operator-only blurb shown in the selector. Never sent. */
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Document Library documents attached when the template is applied. */
  libraryDocumentIds: Array<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  subject: Scalars['String']['output'];
  tags: Array<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  visibility: EmailTemplateVisibility;
};

export type CrmEmailTemplateUsage = {
  __typename?: 'CrmEmailTemplateUsage';
  /** Newest first, capped. */
  entries: Array<CrmEmailTemplateUsageEntry>;
  /** Every message sent from the template. */
  total: Scalars['Int']['output'];
};

export type CrmEmailTemplateUsageEntry = {
  __typename?: 'CrmEmailTemplateUsageEntry';
  createdAt: Scalars['DateTime']['output'];
  /** The sent message. */
  emailId: Scalars['ID']['output'];
  openCount: Scalars['Int']['output'];
  organizationId: Scalars['ID']['output'];
  /** Client or prospect the message was filed against. */
  organizationName?: Maybe<Scalars['String']['output']>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  /** PENDING, SENT, DELIVERED, BOUNCED or FAILED. */
  status: Scalars['String']['output'];
  subject: Scalars['String']['output'];
  /** Conversation thread, for opening the exchange. */
  threadId?: Maybe<Scalars['String']['output']>;
  to: Array<Scalars['String']['output']>;
};

export type CrmEnrichment = {
  __typename?: 'CrmEnrichment';
  aiAssisted?: Maybe<Scalars['Boolean']['output']>;
  confidence?: Maybe<Scalars['Float']['output']>;
  creationRationale?: Maybe<Scalars['String']['output']>;
  lastEnrichedAt?: Maybe<Scalars['DateTime']['output']>;
  source?: Maybe<Scalars['String']['output']>;
};

export type CrmForecastColumnWidth = {
  __typename?: 'CrmForecastColumnWidth';
  column: Scalars['String']['output'];
  /** Width in CSS pixels. */
  width: Scalars['Int']['output'];
};

export type CrmForecastColumnWidthInput = {
  column: Scalars['String']['input'];
  /** Width in CSS pixels. */
  width: Scalars['Int']['input'];
};

export type CrmForecastViewState = {
  __typename?: 'CrmForecastViewState';
  /** Columns the user resized; others keep their default width. */
  columnWidths?: Maybe<Array<CrmForecastColumnWidth>>;
  /** Every column in display order, hidden ones included. Null means the default order. */
  columns?: Maybe<Array<Scalars['String']['output']>>;
  /** Columns the user hid. */
  hiddenColumns?: Maybe<Array<Scalars['String']['output']>>;
  pageSize: Scalars['Int']['output'];
  /** 'all' or a pipeline id. */
  pipeline: Scalars['String']['output'];
  query: Scalars['String']['output'];
  /** 'all', '' for unassigned deals, or a rep's user id. */
  rep: Scalars['String']['output'];
  /** asc or desc. */
  sortDir: Scalars['String']['output'];
  /** Column the table is sorted by (client, company, close, arr, …). */
  sortKey: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CrmForecastViewStateInput = {
  /** Resized columns. Omit to keep the stored widths; null resets every column. */
  columnWidths?: InputMaybe<Array<CrmForecastColumnWidthInput>>;
  /** Every column in display order, hidden ones included. Omit to keep the stored order; null resets it. */
  columns?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Columns the user hid. Omit to keep the stored list; null shows every column. */
  hiddenColumns?: InputMaybe<Array<Scalars['String']['input']>>;
  pageSize: Scalars['Int']['input'];
  /** 'all' or a pipeline id. */
  pipeline: Scalars['String']['input'];
  query: Scalars['String']['input'];
  /** 'all', '' for unassigned deals, or a rep's user id. */
  rep: Scalars['String']['input'];
  sortDir: Scalars['String']['input'];
  sortKey: Scalars['String']['input'];
};

export type CrmImportBatch = {
  __typename?: 'CrmImportBatch';
  /** True when this batch recorded created ids and has not already been reverted. */
  canRevert: Scalars['Boolean']['output'];
  columnMapping: Array<CrmImportColumnMapping>;
  companiesCreated: Scalars['Int']['output'];
  companiesMatched: Scalars['Int']['output'];
  completedAt: Scalars['DateTime']['output'];
  contactsCreated: Scalars['Int']['output'];
  createdByEmail: Scalars['String']['output'];
  createdByName: Scalars['String']['output'];
  createdByUserId: Scalars['ID']['output'];
  failureCount: Scalars['Int']['output'];
  failures: Array<CrmImportFailure>;
  fileName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  rolledBackAt?: Maybe<Scalars['DateTime']['output']>;
  rowCount: Scalars['Int']['output'];
  startedAt: Scalars['DateTime']['output'];
  status: CrmImportBatchStatus;
};

/** Outcome of a CRM contact and company import batch. */
export enum CrmImportBatchStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Partial = 'PARTIAL',
  RolledBack = 'ROLLED_BACK',
}

export type CrmImportColumnMapping = {
  __typename?: 'CrmImportColumnMapping';
  field: Scalars['String']['output'];
  sourceColumn: Scalars['String']['output'];
};

/** Which entity a CRM import failure refers to. */
export enum CrmImportEntityType {
  Company = 'COMPANY',
  Contact = 'CONTACT',
  Row = 'ROW',
}

export type CrmImportFailure = {
  __typename?: 'CrmImportFailure';
  entityType: CrmImportEntityType;
  field?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  rowNumber: Scalars['Int']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type CrmImportRollbackResult = {
  __typename?: 'CrmImportRollbackResult';
  batchId: Scalars['ID']['output'];
  /** Companies this batch created that were removed because nothing else referenced them. */
  companiesDeleted: Scalars['Int']['output'];
  /** Companies this batch created that were left in place (other contacts, a deal, or no longer a prospect). */
  companiesKept: Scalars['Int']['output'];
  contactsDeleted: Scalars['Int']['output'];
};

/** Whether the deal is aimed at a module or a bundle. */
export enum CrmInterestedPlanKind {
  Bundle = 'BUNDLE',
  Module = 'MODULE',
}

export type CrmLead = {
  __typename?: 'CrmLead';
  aiAssisted: Scalars['Boolean']['output'];
  billingPeriod?: Maybe<SubscriptionPeriod>;
  closeProbability?: Maybe<Scalars['Int']['output']>;
  convertedAt?: Maybe<Scalars['DateTime']['output']>;
  convertedSubscriptionId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** User who created the deal. Null when a form, signup, import or the API raised it. */
  createdByUserId?: Maybe<Scalars['ID']['output']>;
  creationRationale?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  /** Filled-in custom fields, by field key (`customFieldDefinitions`). */
  customFieldValues: Array<CustomFieldValue>;
  /** Demo date entered by hand. When set it overrides the date derived from a booked meeting. */
  demoDate?: Maybe<Scalars['DateTime']['output']>;
  demoMeeting?: Maybe<CrmLeadMeeting>;
  /** Value of the deal's first invoice: one billing period's charge. */
  estimatedValue?: Maybe<Scalars['Float']['output']>;
  /** Annual recurring revenue the deal is expected to bring, in the deal currency. */
  expectedArr?: Maybe<Scalars['Float']['output']>;
  expectedCloseDate?: Maybe<Scalars['DateTime']['output']>;
  externalRef?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Selected module tier; only meaningful when interestedPlanKind is MODULE. */
  interestedModuleTierId?: Maybe<Scalars['ID']['output']>;
  interestedPlanId?: Maybe<Scalars['ID']['output']>;
  interestedPlanKind?: Maybe<CrmInterestedPlanKind>;
  interestedPlanName?: Maybe<Scalars['String']['output']>;
  lostReason?: Maybe<Scalars['String']['output']>;
  organizationDomain?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['ID']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  ownerUserId?: Maybe<Scalars['ID']['output']>;
  pipelineId: Scalars['ID']['output'];
  pipelineStageId: Scalars['ID']['output'];
  /** Estimated contract length, in billing periods paid upfront (mirrors the PREPAID_TERM billing schedule). Two or more; null means no contract length has been estimated. */
  prepaidPeriods?: Maybe<Scalars['Int']['output']>;
  primaryContact?: Maybe<CrmLeadContact>;
  primaryOrganizationContactId?: Maybe<Scalars['ID']['output']>;
  source: LeadSource;
  stageEnteredAt: Scalars['DateTime']['output'];
  status: LeadStatus;
  /** Tags on this deal (`crmTags`). */
  tagIds: Array<Scalars['ID']['output']>;
  title: Scalars['String']['output'];
  /** Trial end date, entered by hand. */
  trialEndDate?: Maybe<Scalars['DateTime']['output']>;
  /** Trial start date, entered by hand. */
  trialStartDate?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  variableEstimates?: Maybe<Array<CrmLeadVariableEstimate>>;
};

export type CrmLeadContact = {
  __typename?: 'CrmLeadContact';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
};

export type CrmLeadFilter = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  ownerUserId?: InputMaybe<Scalars['ID']['input']>;
  pipelineId?: InputMaybe<Scalars['ID']['input']>;
  pipelineStageId?: InputMaybe<Scalars['ID']['input']>;
  source?: InputMaybe<LeadSource>;
  status?: InputMaybe<Array<LeadStatus>>;
};

export type CrmLeadForecastInput = {
  billingPeriod?: InputMaybe<SubscriptionPeriod>;
  closeProbability?: InputMaybe<Scalars['Int']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  /** Demo date, entered by hand. Overrides the date derived from a booked meeting; null clears it. */
  demoDate?: InputMaybe<Scalars['DateTime']['input']>;
  estimatedValue?: InputMaybe<Scalars['Float']['input']>;
  /** Expected annual recurring revenue, in the deal currency. */
  expectedArr?: InputMaybe<Scalars['Float']['input']>;
  expectedCloseDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Selected module tier; only meaningful when interestedPlanKind is MODULE. */
  interestedModuleTierId?: InputMaybe<Scalars['ID']['input']>;
  interestedPlanId?: InputMaybe<Scalars['ID']['input']>;
  interestedPlanKind?: InputMaybe<CrmInterestedPlanKind>;
  /** Estimated contract length, in billing periods paid upfront (mirrors the PREPAID_TERM billing schedule preset). Two or more; null clears it. */
  prepaidPeriods?: InputMaybe<Scalars['Int']['input']>;
  /** Trial end date, entered by hand; null clears it. */
  trialEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Trial start date, entered by hand; null clears it. */
  trialStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  variableEstimates?: InputMaybe<Array<CrmLeadVariableEstimateInput>>;
};

/** The meeting the forecasting table's Demo column shows for a deal: the soonest upcoming one with the deal, its company or its primary contact, else the latest past one. */
export type CrmLeadMeeting = {
  __typename?: 'CrmLeadMeeting';
  id: Scalars['ID']['output'];
  startAt: Scalars['DateTime']['output'];
  status: CrmMeetingStatus;
  title: Scalars['String']['output'];
};

export type CrmLeadVariableEstimate = {
  __typename?: 'CrmLeadVariableEstimate';
  componentId: Scalars['ID']['output'];
  quantity: Scalars['Float']['output'];
};

export type CrmLeadVariableEstimateInput = {
  componentId: Scalars['ID']['input'];
  quantity: Scalars['Float']['input'];
};

/** Relationship funnel stage for an organization or contact. */
export enum CrmLifecycleStage {
  Client = 'CLIENT',
  Disqualified = 'DISQUALIFIED',
  Lead = 'LEAD',
  Prospect = 'PROSPECT',
}

/** A meeting as CRM history: who attended, what it was about, what came of it, and which client it belongs to. Not a calendar entry — scheduling and calendar sync live elsewhere. */
export type CrmMeeting = {
  __typename?: 'CrmMeeting';
  agenda?: Maybe<Scalars['String']['output']>;
  attendees: Array<CrmMeetingAttendee>;
  /** Highest-ranked source that has set this meeting’s calendar facts. */
  calendarFactOwner?: Maybe<CrmMeetingSource>;
  conferenceUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdVia: CrmCreatedVia;
  derivedFrom?: Maybe<CrmDerivedFrom>;
  endAt?: Maybe<Scalars['DateTime']['output']>;
  externalRefs: Array<CrmMeetingExternalRef>;
  id: Scalars['ID']['output'];
  locationDetail?: Maybe<Scalars['String']['output']>;
  locationType?: Maybe<CrmMeetingLocationType>;
  loggedBy?: Maybe<Scalars['ID']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  /** Another meeting this one probably duplicates. Set when sources matched fuzzily; a merge is never applied automatically. */
  possibleDuplicateOf?: Maybe<Scalars['ID']['output']>;
  scheduledVia: CrmMeetingScheduledVia;
  /** Groups the occurrences of a recurring meeting. */
  seriesId?: Maybe<Scalars['String']['output']>;
  startAt: Scalars['DateTime']['output'];
  status: CrmMeetingStatus;
  subject: CrmSubjectRef;
  /** IANA zone the meeting was booked in. */
  timezone?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CrmMeetingAttendee = {
  __typename?: 'CrmMeetingAttendee';
  email?: Maybe<Scalars['String']['output']>;
  kind: CrmMeetingAttendeeKind;
  name?: Maybe<Scalars['String']['output']>;
  organizationContactId?: Maybe<Scalars['ID']['output']>;
  organizer: Scalars['Boolean']['output'];
  /** RSVP state; only a syncing source populates this. */
  responseStatus?: Maybe<CrmMeetingAttendeeResponse>;
  userId?: Maybe<Scalars['ID']['output']>;
};

/** One attendee. Exactly one identifying field is expected per kind: userId for USER, organizationContactId for CONTACT, email for EXTERNAL. */
export type CrmMeetingAttendeeInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  kind: CrmMeetingAttendeeKind;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationContactId?: InputMaybe<Scalars['ID']['input']>;
  organizer?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Whether an attendee is a platform user, a known contact, or an outside address. */
export enum CrmMeetingAttendeeKind {
  Contact = 'CONTACT',
  External = 'EXTERNAL',
  User = 'USER',
}

/** Attendee RSVP state; only a syncing source populates it. */
export enum CrmMeetingAttendeeResponse {
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED',
  NeedsAction = 'NEEDS_ACTION',
  Tentative = 'TENTATIVE',
}

/** An external system that has named this meeting. */
export type CrmMeetingExternalRef = {
  __typename?: 'CrmMeetingExternalRef';
  key: Scalars['String']['output'];
  system: CrmMeetingSource;
};

/** How a meeting is held. */
export enum CrmMeetingLocationType {
  InPerson = 'IN_PERSON',
  Other = 'OTHER',
  Phone = 'PHONE',
  Video = 'VIDEO',
}

/** How the meeting came to be booked. */
export enum CrmMeetingScheduledVia {
  Calendly = 'CALENDLY',
  Email = 'EMAIL',
  Inbound = 'INBOUND',
  Manual = 'MANUAL',
  Other = 'OTHER',
  RevvlyScheduler = 'REVVLY_SCHEDULER',
}

/** System a meeting record or one of its facts came from. */
export enum CrmMeetingSource {
  Calendly = 'CALENDLY',
  Google = 'GOOGLE',
  Ics = 'ICS',
  Manual = 'MANUAL',
  Microsoft = 'MICROSOFT',
  RevvlyScheduler = 'REVVLY_SCHEDULER',
}

/** Whether a meeting is upcoming, happened, was a no-show, or was cancelled. */
export enum CrmMeetingStatus {
  Cancelled = 'CANCELLED',
  Held = 'HELD',
  NoShow = 'NO_SHOW',
  Scheduled = 'SCHEDULED',
}

export type CrmNote = {
  __typename?: 'CrmNote';
  authorUserId: Scalars['ID']['output'];
  body: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdVia: CrmCreatedVia;
  id: Scalars['ID']['output'];
  pinned: Scalars['Boolean']['output'];
  subject: CrmSubjectRef;
  updatedAt: Scalars['DateTime']['output'];
};

export type CrmPipeline = {
  __typename?: 'CrmPipeline';
  /** Teams whose members are granted access. */
  accessTeamIds: Array<Scalars['ID']['output']>;
  /** Auth ids of the people granted access. Empty together with accessTeamIds means everyone in the workspace. */
  accessUserIds: Array<Scalars['String']['output']>;
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** Deals currently on this pipeline, open or closed. */
  dealCount: Scalars['Int']['output'];
  /** Rich-text description, as Markdown source. */
  description?: Maybe<Scalars['String']['output']>;
  /** The description rendered to allowlist-sanitized HTML, for display. */
  descriptionHtml?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  /** True when access is limited to the listed people and teams. */
  isRestricted: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  stages: Array<PipelineStage>;
  updatedAt: Scalars['DateTime']['output'];
};

export type CrmSubjectRef = {
  __typename?: 'CrmSubjectRef';
  subjectId: Scalars['ID']['output'];
  subjectType: EntityTargetType;
};

export type CrmTag = {
  __typename?: 'CrmTag';
  /** One of blue, teal, green, orange, red, gray. */
  color: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type CrmTimelineConnection = {
  __typename?: 'CrmTimelineConnection';
  items: Array<CrmTimelineItem>;
  pageInfo: CrmTimelinePageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CrmTimelineFormSubmission = {
  __typename?: 'CrmTimelineFormSubmission';
  formId: Scalars['ID']['output'];
  formName: Scalars['String']['output'];
  /** The submission. */
  id: Scalars['ID']['output'];
  submittedAt: Scalars['DateTime']['output'];
  submitterEmail?: Maybe<Scalars['String']['output']>;
  /** Answered through a link made for this company. */
  viaClientLink: Scalars['Boolean']['output'];
};

export type CrmTimelineItem = {
  __typename?: 'CrmTimelineItem';
  document?: Maybe<CrmDocument>;
  email?: Maybe<CrmEmailMessage>;
  formSubmission?: Maybe<CrmTimelineFormSubmission>;
  /** Underlying record id. */
  id: Scalars['ID']['output'];
  meeting?: Maybe<CrmMeeting>;
  note?: Maybe<CrmNote>;
  /** Natural timestamp used for ordering. */
  occurredAt: Scalars['DateTime']['output'];
  syncedEmailThread?: Maybe<SyncedEmailThread>;
  task?: Maybe<Task>;
  type: CrmTimelineItemType;
};

/** Kind of item in a CRM subject timeline. */
export enum CrmTimelineItemType {
  Document = 'DOCUMENT',
  Email = 'EMAIL',
  FormSubmission = 'FORM_SUBMISSION',
  Meeting = 'MEETING',
  Note = 'NOTE',
  SyncedEmail = 'SYNCED_EMAIL',
  Task = 'TASK',
}

export type CrmTimelinePageInfo = {
  __typename?: 'CrmTimelinePageInfo';
  /** Compound cursor: occurredAt|type|id. Legacy ISO timestamps still work. */
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
};

/** Customer-success lifecycle of a client. Separate from the sales funnel stage. */
export enum CsLifecycleStatus {
  Churned = 'CHURNED',
  Nurturing = 'NURTURING',
  Onboarding = 'ONBOARDING',
  Renewal = 'RENEWAL',
  Trial = 'TRIAL',
}

export type CsmWorkloadClient = {
  __typename?: 'CsmWorkloadClient';
  csLifecycleStatus?: Maybe<CsLifecycleStatus>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type CsmWorkloadRow = {
  __typename?: 'CsmWorkloadRow';
  byStatus: Array<CsmWorkloadStatusCount>;
  /** The first 100 clients by name. */
  clients: Array<CsmWorkloadClient>;
  /** The manager (a user id). Null is the row for clients nobody manages yet. */
  csmUserId?: Maybe<Scalars['ID']['output']>;
  total: Scalars['Int']['output'];
};

export type CsmWorkloadStatusCount = {
  __typename?: 'CsmWorkloadStatusCount';
  count: Scalars['Int']['output'];
  /** Null: no status set. */
  status?: Maybe<CsLifecycleStatus>;
};

/** Supported currencies for regions */
export enum Currency {
  Aed = 'AED',
  Afn = 'AFN',
  All = 'ALL',
  Amd = 'AMD',
  Ang = 'ANG',
  Aoa = 'AOA',
  Ars = 'ARS',
  Aud = 'AUD',
  Awg = 'AWG',
  Azn = 'AZN',
  Bam = 'BAM',
  Bbd = 'BBD',
  Bdt = 'BDT',
  Bgn = 'BGN',
  Bhd = 'BHD',
  Bmd = 'BMD',
  Bnd = 'BND',
  Bob = 'BOB',
  Brl = 'BRL',
  Bsd = 'BSD',
  Btn = 'BTN',
  Bwp = 'BWP',
  Byn = 'BYN',
  Bzd = 'BZD',
  Cad = 'CAD',
  Cdf = 'CDF',
  Chf = 'CHF',
  Clp = 'CLP',
  Cny = 'CNY',
  Cop = 'COP',
  Crc = 'CRC',
  Cup = 'CUP',
  Cve = 'CVE',
  Czk = 'CZK',
  Djf = 'DJF',
  Dkk = 'DKK',
  Dop = 'DOP',
  Dzd = 'DZD',
  Egp = 'EGP',
  Ern = 'ERN',
  Etb = 'ETB',
  Eur = 'EUR',
  Fjd = 'FJD',
  Fkp = 'FKP',
  Gbp = 'GBP',
  Gel = 'GEL',
  Ghs = 'GHS',
  Gip = 'GIP',
  Gmd = 'GMD',
  Gtq = 'GTQ',
  Gyd = 'GYD',
  Hkd = 'HKD',
  Hnl = 'HNL',
  Htg = 'HTG',
  Huf = 'HUF',
  Idr = 'IDR',
  Ils = 'ILS',
  Inr = 'INR',
  Iqd = 'IQD',
  Irr = 'IRR',
  Isk = 'ISK',
  Jmd = 'JMD',
  Jod = 'JOD',
  Jpy = 'JPY',
  Kes = 'KES',
  Kgs = 'KGS',
  Khr = 'KHR',
  Krw = 'KRW',
  Kwd = 'KWD',
  Kyd = 'KYD',
  Kzt = 'KZT',
  Lak = 'LAK',
  Lbp = 'LBP',
  Lkr = 'LKR',
  Lrd = 'LRD',
  Lyd = 'LYD',
  Mad = 'MAD',
  Mdl = 'MDL',
  Mga = 'MGA',
  Mkd = 'MKD',
  Mmk = 'MMK',
  Mnt = 'MNT',
  Mop = 'MOP',
  Mru = 'MRU',
  Mur = 'MUR',
  Mvr = 'MVR',
  Mwk = 'MWK',
  Mxn = 'MXN',
  Myr = 'MYR',
  Mzn = 'MZN',
  Nad = 'NAD',
  Ngn = 'NGN',
  Nio = 'NIO',
  Nok = 'NOK',
  Npr = 'NPR',
  Nzd = 'NZD',
  Omr = 'OMR',
  Pab = 'PAB',
  Pen = 'PEN',
  Pgk = 'PGK',
  Php = 'PHP',
  Pkr = 'PKR',
  Pln = 'PLN',
  Pyg = 'PYG',
  Qar = 'QAR',
  Ron = 'RON',
  Rsd = 'RSD',
  Rub = 'RUB',
  Rwf = 'RWF',
  Sar = 'SAR',
  Sbd = 'SBD',
  Scr = 'SCR',
  Sdg = 'SDG',
  Sek = 'SEK',
  Sgd = 'SGD',
  Sll = 'SLL',
  Sos = 'SOS',
  Srd = 'SRD',
  Ssp = 'SSP',
  Stn = 'STN',
  Svc = 'SVC',
  Szl = 'SZL',
  Thb = 'THB',
  Tjs = 'TJS',
  Tmt = 'TMT',
  Tnd = 'TND',
  Top = 'TOP',
  Try = 'TRY',
  Ttd = 'TTD',
  Twd = 'TWD',
  Tzs = 'TZS',
  Uah = 'UAH',
  Ugx = 'UGX',
  Usd = 'USD',
  Uyu = 'UYU',
  Uzs = 'UZS',
  Ves = 'VES',
  Vnd = 'VND',
  Vuv = 'VUV',
  Wst = 'WST',
  Xaf = 'XAF',
  Xcd = 'XCD',
  Xof = 'XOF',
  Xpf = 'XPF',
  Yer = 'YER',
  Zar = 'ZAR',
  Zmw = 'ZMW',
  Zwl = 'ZWL',
}

export type CurrencyBreakdown = {
  __typename?: 'CurrencyBreakdown';
  /** ARR converted to reporting currency */
  convertedARR: Scalars['Float']['output'];
  /** MRR converted to reporting currency */
  convertedMRR: Scalars['Float']['output'];
  /** Currency code (e.g., USD, EUR, GBP) */
  currency: Scalars['String']['output'];
  /** Exchange rate used (native → reporting) */
  exchangeRate: Scalars['Float']['output'];
  /** ARR in native currency (not converted) */
  nativeARR: Scalars['Float']['output'];
  /** MRR in native currency (not converted) */
  nativeMRR: Scalars['Float']['output'];
  subscriptionCount: Scalars['Int']['output'];
};

export type CurrencyDatePair = {
  /** Currency code */
  currency: Scalars['String']['input'];
  /** Date for the rate (ISO string) */
  date: Scalars['String']['input'];
};

export type CurrencyInfo = {
  __typename?: 'CurrencyInfo';
  code: Currency;
  name: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
};

export type CurrencyReceivables = {
  __typename?: 'CurrencyReceivables';
  currency: Scalars['String']['output'];
  invoiceCount: Scalars['Int']['output'];
  overdueAmount: Scalars['Float']['output'];
  overdueTaxAmount: Scalars['Float']['output'];
  pendingAmount: Scalars['Float']['output'];
  pendingTaxAmount: Scalars['Float']['output'];
  thisWeekAmount: Scalars['Float']['output'];
  thisWeekTaxAmount: Scalars['Float']['output'];
  totalAmount: Scalars['Float']['output'];
  totalTaxAmount: Scalars['Float']['output'];
};

export type CurrentMonthProgress = {
  __typename?: 'CurrentMonthProgress';
  /** Instant this payload was computed. */
  asOf: Scalars['DateTime']['output'];
  atRisk: AtRiskSummary;
  /** Movements whose lifecycle event has already fired, from month start to asOf. */
  confirmed: MovementSet;
  /** Run-rate over subscriptions whose service is live right now. Earned. A subscription with a scheduled cancellation still counts here until its endDate passes. */
  confirmedMRR: Scalars['Float']['output'];
  /** UTC day-of-month of asOf, 1-based. */
  dayOfMonth: Scalars['Int']['output'];
  daysInMonth: Scalars['Int']['output'];
  /** False when the requested month has already closed. The client then renders the settled view rather than the progress view. */
  inProgress: Scalars['Boolean']['output'];
  /** Month in YYYY-MM format (UTC). */
  month: Scalars['String']['output'];
  /** Elapsed share of the month as a 0–100 percentage. */
  monthElapsedPercent: Scalars['Float']['output'];
  /** Opening balance — the previous month's closing MRR, chained. */
  openingMRR: Scalars['Float']['output'];
  /** Run-rate at the last instant of the month — includes starts dated later this month and drops scheduled cancellations. NOT earned. Equals the mrrMovement series’ ending MRR for this month, so the panel and the chart cannot disagree. */
  projectedMonthEndMRR: Scalars['Float']['output'];
  renewalBase: RenewalBaseProgress;
  /** ISO 4217 currency every amount in this payload is denominated in. */
  reportingCurrency: Scalars['String']['output'];
  /** Movements dated later this month that have not happened yet: future-dated starts and cancellations already scheduled. Derived from subscription dates, not the event log — lifecycle events are only ever written when something actually occurs. */
  scheduled: MovementSet;
};

export type CurrentPlan = {
  __typename?: 'CurrentPlan';
  /** Plan Type */
  planType: PlanOptions;
};

export type CurrentPlanInput = {
  /** Plan Type */
  planType: PlanOptions;
};

export type CursorPaginationInput = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrder>;
};

/** Axes a custom pricing agreement is permitted to override */
export enum CustomAgreementOverrideAxis {
  BillingTiming = 'BILLING_TIMING',
  Currency = 'CURRENCY',
  Model = 'MODEL',
  Price = 'PRICE',
  Proration = 'PRORATION',
}

/** Lifecycle state of a custom pricing agreement */
export enum CustomAgreementStatus {
  Draft = 'DRAFT',
  Expired = 'EXPIRED',
  Published = 'PUBLISHED',
  Revoked = 'REVOKED',
}

export type CustomFieldDefinition = {
  __typename?: 'CustomFieldDefinition';
  entityType: CustomFieldEntityType;
  fieldType: CustomFieldType;
  id: Scalars['ID']['output'];
  /** What a record stores the value under. Never changes. */
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  options: Array<CustomFieldOption>;
  retired: Scalars['Boolean']['output'];
  /** Limits who sees and fills in the field; null shows it to everyone with CRM. */
  visibilityRole?: Maybe<FunctionRole>;
};

/** The record type a custom field or tag applies to. */
export enum CustomFieldEntityType {
  Contact = 'CONTACT',
  Lead = 'LEAD',
  Organization = 'ORGANIZATION',
}

export type CustomFieldFilterValueInput = {
  /** The field key (`customFieldDefinitions`). */
  key: Scalars['String']['input'];
  /** The value to match, JSON-encoded. A multiple-choice field matches on one option it holds. */
  valueJson: Scalars['String']['input'];
};

export type CustomFieldOption = {
  __typename?: 'CustomFieldOption';
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type CustomFieldOptionInput = {
  /** Omit for a new option. */
  key?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
};

export enum CustomFieldType {
  Boolean = 'BOOLEAN',
  Currency = 'CURRENCY',
  Date = 'DATE',
  Location = 'LOCATION',
  Multiselect = 'MULTISELECT',
  Number = 'NUMBER',
  Select = 'SELECT',
  Text = 'TEXT',
  Url = 'URL',
  User = 'USER',
}

/** One filled-in custom field on a record. */
export type CustomFieldValue = {
  __typename?: 'CustomFieldValue';
  key: Scalars['String']['output'];
  /** The stored value, JSON-encoded. */
  valueJson: Scalars['String']['output'];
};

export type CustomFieldValueInput = {
  key: Scalars['String']['input'];
  /** JSON-encoded value; null clears the field. */
  valueJson?: InputMaybe<Scalars['String']['input']>;
};

export type CustomPricingAgreement = {
  __typename?: 'CustomPricingAgreement';
  aiAssisted: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  creationRationale?: Maybe<Scalars['String']['output']>;
  customBillingTiming?: Maybe<BillingTiming>;
  customCommittedQty?: Maybe<Scalars['Int']['output']>;
  customCurrency?: Maybe<Scalars['String']['output']>;
  customIncludedUnits?: Maybe<Scalars['Int']['output']>;
  customModelType?: Maybe<PricingModelType>;
  customOveragePrice?: Maybe<Scalars['Decimal']['output']>;
  customProrationCalculation?: Maybe<ProrationCalculation>;
  customSteps?: Maybe<Array<CustomPricingStep>>;
  customTiers?: Maybe<Array<CustomPricingTier>>;
  customUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  effectiveFrom: Scalars['DateTime']['output'];
  endCustomerId: Scalars['ID']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  overrideScope: Array<CustomAgreementOverrideAxis>;
  publishPath?: Maybe<PublishPath>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  publishedBy?: Maybe<Scalars['ID']['output']>;
  status: CustomAgreementStatus;
  tenantId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  variableComponentId: Scalars['ID']['output'];
};

export type CustomPricingAgreementFilterInput = {
  endCustomerId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<CustomAgreementStatus>;
  variableComponentId?: InputMaybe<Scalars['ID']['input']>;
};

export type CustomPricingStep = {
  __typename?: 'CustomPricingStep';
  flatFee: Scalars['Decimal']['output'];
  /** Upper bound (inclusive); null = unlimited */
  limit?: Maybe<Scalars['Int']['output']>;
};

export type CustomPricingStepInput = {
  flatFee: Scalars['Float']['input'];
  /** Upper bound (inclusive); null = unlimited */
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type CustomPricingTier = {
  __typename?: 'CustomPricingTier';
  /** Upper bound (inclusive); null = unlimited */
  limit?: Maybe<Scalars['Int']['output']>;
  pricePerUnit: Scalars['Decimal']['output'];
};

export type CustomPricingTierInput = {
  /** Upper bound (inclusive); null = unlimited */
  limit?: InputMaybe<Scalars['Int']['input']>;
  pricePerUnit: Scalars['Float']['input'];
};

export type CustomerTaxId = {
  __typename?: 'CustomerTaxId';
  countryCode: Scalars['String']['output'];
  idType: Scalars['String']['output'];
  validationStatus: TaxIdValidationStatus;
  value: Scalars['String']['output'];
};

export type CustomerTaxIdInput = {
  countryCode: Scalars['String']['input'];
  idType: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type CustomerTaxProfile = {
  __typename?: 'CustomerTaxProfile';
  billingCountry: Scalars['String']['output'];
  billingSubdivision?: Maybe<Scalars['String']['output']>;
  exempt: TaxExemption;
  id: Scalars['ID']['output'];
  isBusiness: Scalars['Boolean']['output'];
  organizationId: Scalars['ID']['output'];
  reverseChargeEligible: Scalars['Boolean']['output'];
  taxIds: Array<CustomerTaxId>;
};

export type CustomerTaxProfileChange = {
  __typename?: 'CustomerTaxProfileChange';
  changedAt: Scalars['DateTime']['output'];
  /** Who saved it, by email at the time. */
  changedBy?: Maybe<Scalars['String']['output']>;
  changes: Array<CustomerTaxProfileChangeItem>;
  id: Scalars['ID']['output'];
  /** CREATED or UPDATED. */
  kind: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
};

export type CustomerTaxProfileChangeItem = {
  __typename?: 'CustomerTaxProfileChangeItem';
  field: Scalars['String']['output'];
  /** Null when there was no value before. */
  from?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  /** Null when the value was cleared. */
  to?: Maybe<Scalars['String']['output']>;
};

export enum CycleState {
  Active = 'ACTIVE',
  Closed = 'CLOSED',
  Draft = 'DRAFT',
  Scoring = 'SCORING',
}

/** Input for deleting a stored file */
export type DeleteFileInput = {
  /** ID of the stored file to delete */
  fileId: Scalars['String']['input'];
  /** Permanently delete (default: soft delete) */
  permanent?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Result of file deletion */
export type DeleteFileResult = {
  __typename?: 'DeleteFileResult';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DeleteImportedInvoicesInput = {
  /** How many invoices the caller saw in the preview. The delete is refused if the selection now matches a different number, so it never removes what was not shown. */
  expectedCount: Scalars['Int']['input'];
  filter: ImportedInvoiceFilterInput;
  /** Delete only these invoices (each must also match the filter). Omit to delete every invoice the filter matches. */
  invoiceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Also delete subscriptions and clients an import created that are left with no invoices. Records that existed before the import are never deleted. */
  removeEmptyImportedRecords?: Scalars['Boolean']['input'];
};

export type DeleteImportedInvoicesResult = {
  __typename?: 'DeleteImportedInvoicesResult';
  invoicesDeleted: Scalars['Int']['output'];
  organizationsDeleted: Scalars['Int']['output'];
  subscriptionsDeleted: Scalars['Int']['output'];
};

export type DeleteOrganizationInput = {
  force?: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};

export type DeleteOrganizationResult = {
  __typename?: 'DeleteOrganizationResult';
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type DeleteSubscriptionResult = {
  __typename?: 'DeleteSubscriptionResult';
  /** Breakdown of operational child records removed by the cascade. */
  cascade?: Maybe<SubscriptionCascadeDeletionCounts>;
  /** Number of invoices permanently deleted when deleting the subscription */
  deletedInvoicesCount: Scalars['Int']['output'];
  deletedVariablesCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  subscription?: Maybe<OrganizationSubscription>;
  success: Scalars['Boolean']['output'];
  /** Number of invoices voided when deleting the subscription */
  voidedInvoicesCount: Scalars['Int']['output'];
};

export type DeleteWorkspaceDataInput = {
  /** The workspace slug, typed by the admin to confirm */
  confirmSlug: Scalars['String']['input'];
  /** The client in the Master tenant */
  organizationId: Scalars['ID']['input'];
};

/** Counts by outcome over a window */
export type DeliveryStats = {
  __typename?: 'DeliveryStats';
  /** Folded into a digest */
  collapsed: Scalars['Int']['output'];
  /** Messages that failed every attempt */
  failed: Scalars['Int']['output'];
  /** Distinct people actually reached. The number that makes zero visible — a cycle owner seeing "0 people prompted" knows something is wrong. */
  peopleReached: Scalars['Int']['output'];
  /** Waiting for their digest slot */
  queued: Scalars['Int']['output'];
  /** Messages delivered */
  sent: Scalars['Int']['output'];
  /** Silenced by the recipient */
  skippedMuted: Scalars['Int']['output'];
  /** Held back by a delivery rule */
  skippedSuppressed: Scalars['Int']['output'];
  /** Recipients nobody has linked to a channel */
  skippedUnmapped: Scalars['Int']['output'];
};

/** Task description storage format. Only MARKDOWN is active in v1. */
export enum DescriptionFormat {
  Markdown = 'MARKDOWN',
  Plain = 'PLAIN',
}

export type DirectComponentInput = {
  /** Billing timing for this component on this subscription (Billing Timing Override PRD §7.1). The wizard pre-fills the product default; a differing value pins a client-specific override, while omitting it (or sending the default back) inherits and keeps tracking the product setting. */
  billingTiming?: InputMaybe<BillingTiming>;
  /** Capture mode for this component on this subscription (R7). When set and different from the client's usageCaptureMode (or API when the client has none), pins a per-component override. Omit to inherit the client default. */
  captureModeOverride?: InputMaybe<UsageCaptureMode>;
  componentId: Scalars['ID']['input'];
  /** Pinned component version (defaults to the active PUBLISHED version). */
  componentVersion?: InputMaybe<Scalars['Int']['input']>;
  /** COMMISSION GMV inclusion per currency. */
  includedGmvByCurrency?: InputMaybe<Array<IncludedGmvInput>>;
  includedQuantity?: InputMaybe<Scalars['Int']['input']>;
  includedTransactionCount?: InputMaybe<Scalars['Int']['input']>;
  /** Inline subscription-scoped price; required only when no default/module/bundle price covers the locked currency. */
  pricesByCurrency?: InputMaybe<Array<PricingVariantInput>>;
  /** Quantity provisioned at creation (e.g. starting seats). Seeds the initial usage counter so the single subscription-start invoice bills any overage above the inclusion. Provisioning at creation must NOT produce a separate mid-cycle adjustment invoice. */
  startingQuantity?: InputMaybe<Scalars['Int']['input']>;
};

export type DisambiguationLogEntry = {
  __typename?: 'DisambiguationLogEntry';
  answer: Scalars['String']['output'];
  question: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
};

/** Tenant-wide discount analytics rollups (Flexible Discounting §10). */
export type DiscountAnalytics = {
  __typename?: 'DiscountAnalytics';
  /** Total discounted value currently active, per currency (estimated per renewal cycle). */
  activeDiscountedValueByCurrency: Array<DiscountValueByCurrency>;
  definitionSourcedInstances: Scalars['Int']['output'];
  instancesByStackingMode: Array<StackingModeCount>;
  oneOffInstances: Scalars['Int']['output'];
  /** Discounted value rolling off over upcoming renewal cycles as counted durations expire. */
  rolloff: Array<DiscountRolloffPoint>;
  totalActiveInstances: Scalars['Int']['output'];
};

/** Blast radius of archiving a definition: active instances that would be terminated (§8.12). */
export type DiscountArchiveCheck = {
  __typename?: 'DiscountArchiveCheck';
  activeInstanceCount: Scalars['Int']['output'];
  affected: Array<DiscountDefinitionUsageRow>;
  definitionId: Scalars['ID']['output'];
};

/** One discount contribution within a line calculation (Flexible Discounting §9). */
export type DiscountContribution = {
  __typename?: 'DiscountContribution';
  /** Amount actually subtracted from the line. */
  amountApplied: Scalars['Decimal']['output'];
  instanceId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** Unit-limited discounts only: how many of the billed units it covered. */
  quantityApplied?: Maybe<Scalars['Float']['output']>;
  /** Unit-limited discounts only: how many units the line billed. */
  quantityBilled?: Maybe<Scalars['Float']['output']>;
  type: DiscountType;
  /** Percentage or fixed amount configured on the instance. */
  value: Scalars['Decimal']['output'];
};

/** Per-currency fixed discount value (Flexible Discounting §8.3). */
export type DiscountCurrencyValue = {
  __typename?: 'DiscountCurrencyValue';
  amount: Scalars['Decimal']['output'];
  currency: Scalars['String']['output'];
};

export type DiscountCurrencyValueInput = {
  /** Non-negative fixed amount in this currency (§8.10). */
  amount: Scalars['Float']['input'];
  currency: Scalars['String']['input'];
};

/** Reusable discount library definition (Flexible Discounting §6.1). Applying it snapshots its terms into an instance; edits here never change existing instances. */
export type DiscountDefinitionEntity = {
  __typename?: 'DiscountDefinitionEntity';
  /** Active instances currently sourced from this definition (§10 blast radius). */
  activeInstanceCount: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  /** Renewal count when durationType = FIXED_COUNT. */
  durationCount?: Maybe<Scalars['Int']['output']>;
  durationType: DiscountDurationType;
  /** Fixed value per currency (FIXED type). Only applicable where a currency is covered. */
  fixedValueByCurrency?: Maybe<Array<DiscountCurrencyValue>>;
  id: Scalars['ID']['output'];
  /** Unique per tenant. */
  name: Scalars['String']['output'];
  /** Currency-agnostic percentage (PERCENTAGE type). */
  percentageValue?: Maybe<Scalars['Float']['output']>;
  status: DiscountDefinitionStatus;
  type: DiscountType;
  updatedAt: Scalars['DateTime']['output'];
};

/** Library definition lifecycle: active, stopped (no new use), archived (instances terminated). */
export enum DiscountDefinitionStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Stopped = 'STOPPED',
}

/** A subscription still carrying an active instance of a definition (§8.12 archive warning). */
export type DiscountDefinitionUsageRow = {
  __typename?: 'DiscountDefinitionUsageRow';
  instanceId: Scalars['ID']['output'];
  /** Client (organization) name. */
  organizationName?: Maybe<Scalars['String']['output']>;
  subscriptionId: Scalars['ID']['output'];
  targetComponentId?: Maybe<Scalars['ID']['output']>;
  targetElementType: DiscountTargetType;
  /** Human-readable target label (component name or "Base price"). */
  targetLabel?: Maybe<Scalars['String']['output']>;
};

/** Discount duration: the first order (first invoice) only, a fixed number of billing cycles, or forever. */
export enum DiscountDurationType {
  FirstOnly = 'FIRST_ONLY',
  FixedCount = 'FIXED_COUNT',
  Forever = 'FOREVER',
}

/** Discount audit action (instance applied/overwritten/cancelled/expired; definition created/edited/stopped/archived). */
export enum DiscountHistoryAction {
  Applied = 'APPLIED',
  Archived = 'ARCHIVED',
  Cancelled = 'CANCELLED',
  Created = 'CREATED',
  Edited = 'EDITED',
  Expired = 'EXPIRED',
  Overwritten = 'OVERWRITTEN',
  Stopped = 'STOPPED',
}

/** Whether an audit entry concerns a discount instance or a library definition. */
export enum DiscountHistoryEntityType {
  Definition = 'DEFINITION',
  Instance = 'INSTANCE',
}

/** Immutable discount audit entry (Flexible Discounting §8.14). */
export type DiscountHistoryEntry = {
  __typename?: 'DiscountHistoryEntry';
  action: DiscountHistoryAction;
  /** For an archive: every subscription whose instance was terminated (§8.14). */
  affectedSubscriptionIds?: Maybe<Array<Scalars['ID']['output']>>;
  changedAt: Scalars['DateTime']['output'];
  changedBy?: Maybe<Scalars['String']['output']>;
  discountDefinitionId?: Maybe<Scalars['ID']['output']>;
  discountInstanceId?: Maybe<Scalars['ID']['output']>;
  entityType: DiscountHistoryEntityType;
  id: Scalars['ID']['output'];
  /** New terms (JSON). */
  newValue?: Maybe<Scalars['String']['output']>;
  /** Prior terms (JSON). */
  oldValue?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  sourceDefinitionId?: Maybe<Scalars['ID']['output']>;
  subscriptionId?: Maybe<Scalars['ID']['output']>;
};

/** One applied discount on one subscription target (Flexible Discounting §6.2) — a snapshot of the definition terms at application time, or a one-off with no source. */
export type DiscountInstanceEntity = {
  __typename?: 'DiscountInstanceEntity';
  appliedAt: Scalars['DateTime']['output'];
  /** Renewal-cycle invoices this instance has applied to (§8.4). */
  appliedCount: Scalars['Int']['output'];
  /** Whether the discount also applies to Adjustment invoices (§8.9). */
  applyToAdjustments: Scalars['Boolean']['output'];
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  cancelledBy?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  /** Currency of a FIXED value (resolved at application). */
  currency?: Maybe<Scalars['String']['output']>;
  durationCount?: Maybe<Scalars['Int']['output']>;
  durationType: DiscountDurationType;
  /** Optional calendar end. The discount stops applying to invoices billing service on or after this date, independently of its renewal-count duration. */
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  fixedMode?: Maybe<FixedDiscountMode>;
  id: Scalars['ID']['output'];
  /** COMPONENT discounts only: at most this many billed units are discounted. */
  maxQuantity?: Maybe<Scalars['Float']['output']>;
  /** Display name, shown on the invoice (§9). */
  name: Scalars['String']['output'];
  /** Renewals remaining before expiry; null = forever. */
  remainingRenewals?: Maybe<Scalars['Int']['output']>;
  /** Source library definition; null for one-offs. */
  sourceDefinitionId?: Maybe<Scalars['ID']['output']>;
  status: DiscountInstanceStatus;
  subscriptionId: Scalars['ID']['output'];
  /** True when an ACTIVE instance is currently superseded by another under first_wins/latest_wins (§8.7) — pending in the tenant UI, never shown on the invoice. */
  superseded: Scalars['Boolean']['output'];
  targetComponentId?: Maybe<Scalars['ID']['output']>;
  targetElementType: DiscountTargetType;
  type: DiscountType;
  /** Percentage, or fixed amount in `currency`. */
  value: Scalars['Decimal']['output'];
};

/** Discount instance lifecycle: active, expired (duration reached), or cancelled. */
export enum DiscountInstanceStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Expired = 'EXPIRED',
}

/** Preview of the discount chain for one target: pre-discount effective amount → each contribution → final amount (Flexible Discounting §8.13). */
export type DiscountPreviewLine = {
  __typename?: 'DiscountPreviewLine';
  currency: Scalars['String']['output'];
  discounts: Array<DiscountContribution>;
  /** Final amount after discounts, floored at zero (§8.10). */
  finalAmount: Scalars['Decimal']['output'];
  /** Effective amount before discounts (post price-override, post included-quantity netting). */
  preDiscountAmount: Scalars['Decimal']['output'];
  targetComponentId?: Maybe<Scalars['ID']['output']>;
  targetElementType: DiscountTargetType;
  /** Human-readable target label. */
  targetLabel: Scalars['String']['output'];
};

/** Expected billed-revenue recovery as counted discounts roll off (§10). */
export type DiscountRolloffPoint = {
  __typename?: 'DiscountRolloffPoint';
  /** Discounted value expiring at this horizon, by currency. */
  expiringValueByCurrency: Array<DiscountValueByCurrency>;
  /** Renewal cycles from now (1 = next renewal). */
  renewalsFromNow: Scalars['Int']['output'];
};

/** How multiple discount instances on the same target compose: best wins, first wins, latest wins, or combine (default). */
export enum DiscountStackingMode {
  BestWins = 'BEST_WINS',
  Combine = 'COMBINE',
  FirstWins = 'FIRST_WINS',
  LatestWins = 'LATEST_WINS',
}

/** What a discount instance reduces: the base price, one variable component, or the whole invoice. */
export enum DiscountTargetType {
  BasePrice = 'BASE_PRICE',
  Component = 'COMPONENT',
  Invoice = 'INVOICE',
}

/** Percentage (currency-agnostic) or fixed amount (per-currency values). */
export enum DiscountType {
  Fixed = 'FIXED',
  Percentage = 'PERCENTAGE',
}

/** Per-currency discounted value rollup (Flexible Discounting §10). */
export type DiscountValueByCurrency = {
  __typename?: 'DiscountValueByCurrency';
  /** Discounted value per renewal cycle at current terms. */
  amount: Scalars['Decimal']['output'];
  currency: Scalars['String']['output'];
};

export enum DiscoveryQuestion {
  ClientFacingApp = 'CLIENT_FACING_APP',
  CurrentTools = 'CURRENT_TOOLS',
  Description = 'DESCRIPTION',
  Domain = 'DOMAIN',
  Priorities = 'PRIORITIES',
  RevenueModel = 'REVENUE_MODEL',
  SalesMotion = 'SALES_MOTION',
  StrategyFramework = 'STRATEGY_FRAMEWORK',
}

export type DiscrepancyFilterInput = {
  /** Opaque cursor from a previous response's `next` or `prev` field */
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  resolution?: InputMaybe<DiscrepancyResolution>;
  /** Matches the invoice number or the client name, case-insensitively. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Only discrepancies where either side came from this source. */
  source?: InputMaybe<DiscrepancySourceType>;
};

/** What the discrepancy list needs of the invoice to show and edit its expected payment date. */
export type DiscrepancyInvoiceEntity = {
  __typename?: 'DiscrepancyInvoiceEntity';
  estimatedPaymentDate?: Maybe<Scalars['DateTime']['output']>;
  isCreditNote: Scalars['Boolean']['output'];
  paymentStatus?: Maybe<Scalars['String']['output']>;
};

/** Resolution status of a discrepancy */
export enum DiscrepancyResolution {
  Pending = 'PENDING',
  Resolved = 'RESOLVED',
}

/** Source type for discrepancy comparison */
export enum DiscrepancySourceType {
  Excel = 'EXCEL',
  GoogleDrive = 'GOOGLE_DRIVE',
  GoogleDriveResync = 'GOOGLE_DRIVE_RESYNC',
  System = 'SYSTEM',
}

/** A conversation with the coach about a Key Result still in the editor. */
export type DiscussKeyResultDraftInputType = {
  /** The draft as it stands now, with its last review under `previous`. */
  draft: ReviewKeyResultDraftInputType;
  /** The conversation so far, oldest first, ending with the author. */
  messages: Array<OkrCoachMessageInputType>;
  /** The start value is locked (the cycle is live), so the coach must not move it. */
  startValueLocked?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A conversation with the coach about an objective still in the editor. */
export type DiscussObjectiveDraftInputType = {
  /** The draft as it stands now, with its last review under `previous`. */
  draft: ReviewObjectiveDraftInputType;
  /** The conversation so far, oldest first, ending with the author. */
  messages: Array<OkrCoachMessageInputType>;
};

export type DocumentPaymentInputEntity = {
  /** Omit to pay the balance due in full. */
  amount?: InputMaybe<Scalars['Float']['input']>;
  /** Unique per click; a retry with the same id records one payment. */
  clientRequestId: Scalars['String']['input'];
  documentId: Scalars['ID']['input'];
  paidAt: Scalars['DateTime']['input'];
  /** A file of the same client, attached as proof of payment. */
  proofDocumentId?: InputMaybe<Scalars['ID']['input']>;
};

export type DocumentPaymentResult = {
  __typename?: 'DocumentPaymentResult';
  appliedAmount?: Maybe<Scalars['Float']['output']>;
  documentId: Scalars['ID']['output'];
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DocumentShareLinkEntity = {
  __typename?: 'DocumentShareLinkEntity';
  allowDownload: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** Auth sub of who sent it. */
  createdBy: Scalars['String']['output'];
  documentId: Scalars['ID']['output'];
  documentName: Scalars['String']['output'];
  downloadCount: Scalars['Int']['output'];
  expiresAt: Scalars['DateTime']['output'];
  firstViewedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  lastViewedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The pinned version number, when the link is pinned. */
  pinnedVersionNumber?: Maybe<Scalars['Int']['output']>;
  /** To and Cc addresses it was sent to. Bcc is never listed. */
  recipients: Array<Scalars['String']['output']>;
  revokedAt?: Maybe<Scalars['DateTime']['output']>;
  /** True when the link serves whichever version is current when it is opened. */
  servesLatest: Scalars['Boolean']['output'];
  sourceId: Scalars['String']['output'];
  sourceType: DocumentShareSourceType;
  viewCount: Scalars['Int']['output'];
};

/** What a share link was sent in. */
export enum DocumentShareSourceType {
  Email = 'EMAIL',
  SupportTicket = 'SUPPORT_TICKET',
}

/** Type of subscription document */
export enum DocumentType {
  Amendment = 'AMENDMENT',
  Contract = 'CONTRACT',
  Invoice = 'INVOICE',
  Msa = 'MSA',
  Other = 'OTHER',
}

export type DocumentViewEntity = {
  __typename?: 'DocumentViewEntity';
  documentId: Scalars['ID']['output'];
  documentName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  kind: DocumentViewKind;
  linkId: Scalars['ID']['output'];
  versionNumber: Scalars['Int']['output'];
  viewedAt: Scalars['DateTime']['output'];
  /** Who viewed it, when that is known (a one-recipient link, or their own "Viewing as" choice). */
  viewerEmail?: Maybe<Scalars['String']['output']>;
};

/** A browser viewed the shared document, or downloaded it. */
export enum DocumentViewKind {
  Download = 'DOWNLOAD',
  View = 'VIEW',
  Visit = 'VISIT',
}

export type DpoContact = {
  __typename?: 'DpoContact';
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type DriveAttachmentFileResult = {
  __typename?: 'DriveAttachmentFileResult';
  /** Stored file id to put in `attachmentFileIds`. */
  fileId: Scalars['ID']['output'];
  fileName: Scalars['String']['output'];
  fileSize: Scalars['Int']['output'];
  mimeType: Scalars['String']['output'];
};

export type DriveBrowseCrumbEntity = {
  __typename?: 'DriveBrowseCrumbEntity';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type DriveBrowseEntryEntity = {
  __typename?: 'DriveBrowseEntryEntity';
  /** Why it cannot go on an email. */
  blockedReason?: Maybe<Scalars['String']['output']>;
  /** A Google Doc, Sheet or Slides file: it goes out as a PDF export. */
  exportsAsPdf: Scalars['Boolean']['output'];
  fileSize: Scalars['Int']['output'];
  /** The Drive file or folder id. */
  id: Scalars['String']['output'];
  isFolder: Scalars['Boolean']['output'];
  mimeType: Scalars['String']['output'];
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  /** Search results: the record holding the file. */
  organizationName?: Maybe<Scalars['String']['output']>;
};

export type DriveBrowseResultEntity = {
  __typename?: 'DriveBrowseResultEntity';
  /** A Drive root or a linked folder exists to start from. */
  configured: Scalars['Boolean']['output'];
  files: Array<DriveBrowseEntryEntity>;
  folders: Array<DriveBrowseEntryEntity>;
  /** From the top of the browsable area down to the folder shown. */
  path: Array<DriveBrowseCrumbEntity>;
  /** More items than were returned; search finds the rest. */
  truncated: Scalars['Boolean']['output'];
};

/** Client and prospect folder settings, with what the Drive connection allows. */
export type DriveClientFolderSettings = {
  __typename?: 'DriveClientFolderSettings';
  clientsRoot?: Maybe<DriveRootFolder>;
  /** Google Drive is connected for this workspace. */
  connected: Scalars['Boolean']['output'];
  /** CRM is enabled, so prospects get folders too. */
  crmEnabled: Scalars['Boolean']['output'];
  enabled: Scalars['Boolean']['output'];
  googleAccountEmail?: Maybe<Scalars['String']['output']>;
  /** The Drive grant can write. False means "Reconnect to enable client folders". */
  hasWriteScope: Scalars['Boolean']['output'];
  importFromClientFolders: DriveImportMode;
  inboundEnabled: Scalars['Boolean']['output'];
  invoicesSubfolderMarks: Scalars['Boolean']['output'];
  lastReconciledAt?: Maybe<Scalars['DateTime']['output']>;
  layout: DriveFolderLayout;
  nameTemplate: Scalars['String']['output'];
  newRecordPolicy: DriveNewRecordPolicy;
  onProspectConverted: DriveProspectConvertedPolicy;
  onProspectConvertedOutsideRoot: DriveOutsideFolderPolicy;
  pausedAt?: Maybe<Scalars['DateTime']['output']>;
  pausedReason?: Maybe<DrivePausedReason>;
  prospectsRoot?: Maybe<DriveRootFolder>;
  /** The two roots are in different drives; moving folders between them may be refused. */
  rootsInDifferentDrives: Scalars['Boolean']['output'];
  /** Sync is running right now (enabled, connected, write scope, not paused). */
  running: Scalars['Boolean']['output'];
  sources: Array<DriveSyncSource>;
  subfolderNames: Array<DriveSubfolderName>;
};

export type DriveCreatedFolder = {
  __typename?: 'DriveCreatedFolder';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** One file Revvly keeps in a Drive folder, and its sync state. */
export type DriveFileSyncItem = {
  __typename?: 'DriveFileSyncItem';
  attempts: Scalars['Int']['output'];
  driveName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastError?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  organizationName?: Maybe<Scalars['String']['output']>;
  skipReason?: Maybe<Scalars['String']['output']>;
  sourceId: Scalars['String']['output'];
  sourceType: DriveSyncSourceType;
  status: DriveSyncStatus;
  syncedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  webViewLink?: Maybe<Scalars['String']['output']>;
};

export type DriveFolderEntry = {
  __typename?: 'DriveFolderEntry';
  hasChildren: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** Section label — only set on root-level results: "my-drive" or "shared-drive" */
  section?: Maybe<Scalars['String']['output']>;
};

export enum DriveFolderLayout {
  BySource = 'BY_SOURCE',
  Flat = 'FLAT',
}

export enum DriveFolderLinkStatus {
  Active = 'ACTIVE',
  Missing = 'MISSING',
  PendingCreate = 'PENDING_CREATE',
  Unlinked = 'UNLINKED',
}

export type DriveFolderMappingPage = {
  __typename?: 'DriveFolderMappingPage';
  rows: Array<DriveFolderMappingRow>;
  total: Scalars['Int']['output'];
};

export type DriveFolderMappingRow = {
  __typename?: 'DriveFolderMappingRow';
  folderId?: Maybe<Scalars['String']['output']>;
  folderName?: Maybe<Scalars['String']['output']>;
  lastError?: Maybe<Scalars['String']['output']>;
  lifecycleStage: Scalars['String']['output'];
  mode?: Maybe<DriveFolderMode>;
  organizationId: Scalars['ID']['output'];
  organizationName: Scalars['String']['output'];
  /** IN_CLIENTS, IN_PROSPECTS, ELSEWHERE or UNKNOWN. */
  placement: Scalars['String']['output'];
  state: DriveFolderState;
  suggestion?: Maybe<DriveFolderSuggestionEntity>;
  webViewLink?: Maybe<Scalars['String']['output']>;
};

export enum DriveFolderMode {
  Create = 'CREATE',
  Link = 'LINK',
}

export type DriveFolderMoveState = {
  __typename?: 'DriveFolderMoveState';
  /** Drive refused the move; it will not be retried until someone presses Retry. */
  blocked: Scalars['Boolean']['output'];
  /** Why the last move attempt failed. */
  lastError?: Maybe<Scalars['String']['output']>;
  movedToClientsAt?: Maybe<Scalars['DateTime']['output']>;
  /** Show "Move it to Clients?" on the client page. */
  offered: Scalars['Boolean']['output'];
  /** The folder it currently sits in. */
  parentName?: Maybe<Scalars['String']['output']>;
  /** A move is planned and has not happened yet. */
  pending: Scalars['Boolean']['output'];
  /** IN_CLIENTS, IN_PROSPECTS, ELSEWHERE or UNKNOWN. */
  placement: Scalars['String']['output'];
};

export type DriveFolderSearchResult = {
  __typename?: 'DriveFolderSearchResult';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** The folder's full path, from its drive down to the folder itself, e.g. ["My Drive", "Clients", "Acme"]. Starts at "Shared with me" when the account cannot see the folder's parents. */
  path: Array<Scalars['String']['output']>;
};

export enum DriveFolderState {
  Error = 'ERROR',
  Missing = 'MISSING',
  NotSynced = 'NOT_SYNCED',
  Paused = 'PAUSED',
  Pending = 'PENDING',
  Synced = 'SYNCED',
}

export type DriveFolderSuggestionEntity = {
  __typename?: 'DriveFolderSuggestionEntity';
  folderId: Scalars['String']['output'];
  folderName: Scalars['String']['output'];
  /** FROM_INVOICE_IMPORT, EXACT_NAME or NORMALIZED_NAME. */
  reason: Scalars['String']['output'];
};

export enum DriveImportMode {
  Off = 'OFF',
  Suggest = 'SUGGEST',
  WhenMarked = 'WHEN_MARKED',
}

export enum DriveNewRecordPolicy {
  Ask = 'ASK',
  Auto = 'AUTO',
  Manual = 'MANUAL',
}

export enum DriveOutsideFolderPolicy {
  Ask = 'ASK',
  Move = 'MOVE',
  Never = 'NEVER',
}

export enum DrivePausedReason {
  DriveDisconnected = 'DRIVE_DISCONNECTED',
  ScopeMissing = 'SCOPE_MISSING',
}

export enum DriveProspectConvertedPolicy {
  Ask = 'ASK',
  Leave = 'LEAVE',
  Move = 'MOVE',
}

export type DriveRootFolder = {
  __typename?: 'DriveRootFolder';
  /** Set when the folder is in a shared drive. */
  driveId?: Maybe<Scalars['String']['output']>;
  folderId: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum DriveSubfolderKey {
  Documents = 'DOCUMENTS',
  Email = 'EMAIL',
  Forms = 'FORMS',
  Invoices = 'INVOICES',
  Support = 'SUPPORT',
}

export type DriveSubfolderName = {
  __typename?: 'DriveSubfolderName';
  key: DriveSubfolderKey;
  name: Scalars['String']['output'];
};

export type DriveSubfolderNameInput = {
  key: DriveSubfolderKey;
  name: Scalars['String']['input'];
};

export type DriveSyncActivityPage = {
  __typename?: 'DriveSyncActivityPage';
  counts: DriveSyncCounts;
  rows: Array<DriveFileSyncItem>;
  total: Scalars['Int']['output'];
};

export type DriveSyncCounts = {
  __typename?: 'DriveSyncCounts';
  failed: Scalars['Int']['output'];
  pending: Scalars['Int']['output'];
  removedInDrive: Scalars['Int']['output'];
  synced: Scalars['Int']['output'];
};

export enum DriveSyncSource {
  EmailAttachments = 'EMAIL_ATTACHMENTS',
  FormUploads = 'FORM_UPLOADS',
  Invoices = 'INVOICES',
  SupportAttachments = 'SUPPORT_ATTACHMENTS',
  Uploads = 'UPLOADS',
}

export enum DriveSyncSourceType {
  CreditNote = 'CREDIT_NOTE',
  CrmUpload = 'CRM_UPLOAD',
  EmailAttachment = 'EMAIL_ATTACHMENT',
  FormUpload = 'FORM_UPLOAD',
  Invoice = 'INVOICE',
  SupportAttachment = 'SUPPORT_ATTACHMENT',
}

export enum DriveSyncStatus {
  Cancelled = 'CANCELLED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  RemovedInDrive = 'REMOVED_IN_DRIVE',
  Skipped = 'SKIPPED',
  SourceRemoved = 'SOURCE_REMOVED',
  Synced = 'SYNCED',
}

export type DuplicatePricingRuleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  sourceId: Scalars['ID']['input'];
};

/** A single variable type limit with base, additional, and total quantities */
export type DynamicVariableLimit = {
  __typename?: 'DynamicVariableLimit';
  /** Additional quantity purchased beyond base limits */
  additionalQuantity: Scalars['Int']['output'];
  /** Base quantity included from bundle/module configuration */
  baseQuantity: Scalars['Int']['output'];
  /** Category of this variable (e.g., "capacity", "usage", "custom") */
  category?: Maybe<Scalars['String']['output']>;
  /** Display name for this variable type */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Total available quantity (base + additional) */
  totalQuantity: Scalars['Int']['output'];
  /** The variable type (e.g., "user", "funnel", "api_calls", "custom_metric") */
  variableType: Scalars['String']['output'];
};

/** Collection of all variable limits for an organization or subscription. Supports any variable type dynamically without code changes. */
export type DynamicVariableLimits = {
  __typename?: 'DynamicVariableLimits';
  /** List of all variable types that have configured limits */
  availableVariableTypes: Array<Scalars['String']['output']>;
  /** Array of all variable limits, each containing base, additional, and total quantities */
  limits: Array<DynamicVariableLimit>;
  /** Raw limits data as JSON string for flexible client-side processing */
  rawLimits: Scalars['String']['output'];
  /** Human-readable summary of limits per source (bundle/module) */
  summary: Array<Scalars['String']['output']>;
};

/** What happens to the uninvoiced remainder when a client leaves a committed term early. CHARGE_REMAINDER invoices it now as a one-time fee (never a rate, so MRR is untouched); CONTINUE_BILLING keeps the subscription billing period by period to the committed end and ends it there; WAIVE writes it off, recording the figure that was waived. */
export enum EarlyTerminationPolicy {
  ChargeRemainder = 'CHARGE_REMAINDER',
  ContinueBilling = 'CONTINUE_BILLING',
  Waive = 'WAIVE',
}

/** Surface that produced a billing-impacting edit */
export enum EditPath {
  Api = 'API',
  BulkImport = 'BULK_IMPORT',
  ChatDraft = 'CHAT_DRAFT',
  Form = 'FORM',
  System = 'SYSTEM',
  Template = 'TEMPLATE',
}

export type Email = {
  __typename?: 'Email';
  address: Scalars['String']['output'];
};

export type EmailAttachment = {
  __typename?: 'EmailAttachment';
  /** False when the bytes were never stored (provider reference), so no download can be minted. */
  downloadable: Scalars['Boolean']['output'];
  fileName: Scalars['String']['output'];
  fileSize?: Maybe<Scalars['Int']['output']>;
  /** True when the part was embedded in the body (signature logo, tracking pixel, pasted image) rather than attached as a document. */
  isEmbedded: Scalars['Boolean']['output'];
  mimeType?: Maybe<Scalars['String']['output']>;
  /** Opaque mailbox storage key; pass it back to emailAttachmentDownloadUrl to get a link. */
  storagePath: Scalars['String']['output'];
};

export type EmailAttachmentDownload = {
  __typename?: 'EmailAttachmentDownload';
  available: Scalars['Boolean']['output'];
  fileName: Scalars['String']['output'];
  fileSize?: Maybe<Scalars['Int']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** A dated promise extracted from synced mail on this client — who owes it, what, and by when. */
export type EmailCommitment = {
  __typename?: 'EmailCommitment';
  /** What was promised, in a sentence. Null when it could not be read. */
  description?: Maybe<Scalars['String']['output']>;
  /** When it comes due. */
  dueAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** When the message carrying the promise was sent. */
  madeAt: Scalars['DateTime']['output'];
  /** Which side owes it. */
  owner: CommitmentOwner;
  /** Upcoming, overdue, or past due with activity since — judged by the same rule that raises the overdue-commitment situation. */
  status: CommitmentStatus;
  /** The synced thread the promise was found on. */
  threadId: Scalars['ID']['output'];
  /** Subject of that thread. */
  threadSubject?: Maybe<Scalars['String']['output']>;
};

export type EmailCommunication = {
  __typename?: 'EmailCommunication';
  attachmentCount: Scalars['Int']['output'];
  /** Tenant-storage file ids on a DRAFT so Resume can restore attachments. Absent on sent mail. */
  attachmentFileIds?: Maybe<Array<Scalars['ID']['output']>>;
  attachmentNames?: Maybe<Array<Scalars['String']['output']>>;
  /** Attachments on this message, embedded and attached alike, each saying which it is. Empty on rows that never reached the mailbox (SES reminders) and on stored placeholders. */
  attachments: Array<EmailAttachment>;
  bcc?: Maybe<Array<Scalars['String']['output']>>;
  /** Sanitized HTML body. Present for messages composed in the rich-text editor and for inbound mailbox mail that carried HTML. Same allowlist as task descriptions. */
  bodyHtml?: Maybe<Scalars['String']['output']>;
  /** Preview of email body (first 500 characters) */
  bodyPreview: Scalars['String']['output'];
  cc?: Maybe<Array<Scalars['String']['output']>>;
  /** Composer markdown for a draft, so Resume can restore the editor. Absent on sent mail. */
  composerMarkdown?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deliveredAt?: Maybe<Scalars['DateTime']['output']>;
  /** Attachments a human would call documents — the total minus signature images and other embedded parts. This is what a paperclip should be driven from. */
  documentAttachmentCount: Scalars['Int']['output'];
  /** Counted views of the library documents linked in this email. */
  documentViewCount?: Maybe<Scalars['Int']['output']>;
  /** First time a linked library document was viewed. */
  documentViewedAt?: Maybe<Scalars['DateTime']['output']>;
  emailType: EmailType;
  errorMessage?: Maybe<Scalars['String']['output']>;
  failedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Sender address. Present on inbound mailbox messages; omitted on outbound tracking rows. */
  from?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** False when the operator chose no sign-off on this DRAFT. */
  includeSignature?: Maybe<Scalars['Boolean']['output']>;
  invoiceId?: Maybe<Scalars['ID']['output']>;
  lastDocumentViewedAt?: Maybe<Scalars['DateTime']['output']>;
  lastOpenedAt?: Maybe<Scalars['DateTime']['output']>;
  lastTeamOpenedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Library documents a DRAFT will go out as links, so Resume can restore them. Absent on sent mail. */
  libraryLinks?: Maybe<Array<LibraryLinkSelection>>;
  /** Mailbox document id in the email-integration service. Conversation content and delivery status are read from that document when present. */
  mailboxEmailId?: Maybe<Scalars['String']['output']>;
  messageId: Scalars['String']['output'];
  /** Opens by the recipient side. The tenant's own team is counted in teamOpenCount. */
  openCount: Scalars['Int']['output'];
  openedAt?: Maybe<Scalars['DateTime']['output']>;
  organizationId: Scalars['ID']['output'];
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  sentBy?: Maybe<User>;
  /** Signature chosen on a DRAFT so Resume restores the picker. Absent on sent mail. */
  signatureId?: Maybe<Scalars['ID']['output']>;
  status: EmailStatus;
  subject: Scalars['String']['output'];
  /** Opens by the tenant's own team (a CC'd teammate, or a fetch from an address a member signed in from). */
  teamOpenCount: Scalars['Int']['output'];
  /** First time one of the tenant's own team opened this email. */
  teamOpenedAt?: Maybe<Scalars['DateTime']['output']>;
  tenantId: Scalars['ID']['output'];
  threadId?: Maybe<Scalars['String']['output']>;
  to: Array<Scalars['String']['output']>;
  trackingEnabled: Scalars['Boolean']['output'];
  trackingId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type EmailCommunicationConnection = {
  __typename?: 'EmailCommunicationConnection';
  edges: Array<EmailCommunicationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EmailCommunicationEdge = {
  __typename?: 'EmailCommunicationEdge';
  cursor: Scalars['String']['output'];
  node: EmailCommunication;
};

export type EmailCountInfo = {
  __typename?: 'EmailCountInfo';
  /** Max number of Employees */
  emailsThreshold: Scalars['Int']['output'];
  /** Max number of Employees */
  sentEmailsCount: Scalars['Int']['output'];
  /** Max number of Employees */
  totalEmailsCount: Scalars['Int']['output'];
};

export type EmailCountInfoUpdateInput = {
  emailsThreshold?: InputMaybe<Scalars['Int']['input']>;
  sentEmailsCount?: InputMaybe<Scalars['Int']['input']>;
  totalEmailsCount?: InputMaybe<Scalars['Int']['input']>;
};

export type EmailInput = {
  address: Scalars['String']['input'];
};

/** What the AI tiers have produced, as opposed to what they cost. All-time totals: triage records no decision date, so a per-month split would be a guess. */
export type EmailIntelligenceOutcomes = {
  __typename?: 'EmailIntelligenceOutcomes';
  tier1: Tier1Outcomes;
  tier2: Tier2Outcomes;
};

/** Which incoming email puts a notification in your bell. */
export enum EmailNotificationScope {
  All = 'ALL',
  Clients = 'CLIENTS',
  ClientsAndProspects = 'CLIENTS_AND_PROSPECTS',
  None = 'NONE',
  Prospects = 'PROSPECTS',
}

export type EmailOpenEvent = {
  __typename?: 'EmailOpenEvent';
  /** 'TEAM' when the open came from the tenant's own people, 'CLIENT' otherwise. */
  audience?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  device?: Maybe<Scalars['String']['output']>;
  emailCommunicationId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  ipAddress?: Maybe<Scalars['String']['output']>;
  openedAt: Scalars['DateTime']['output'];
  /** To or CC address this open is attributed to. */
  recipientEmail?: Maybe<Scalars['String']['output']>;
  /** 'document' when a linked library document was viewed and the tracking pixel never fired. */
  source?: Maybe<Scalars['String']['output']>;
  trackingId: Scalars['String']['output'];
  userAgent?: Maybe<Scalars['String']['output']>;
};

/** The provider a mailbox is connected through. */
export enum EmailProvider {
  Gmail = 'GMAIL',
  MsGraph = 'MS_GRAPH',
}

export type EmailRecipientInput = {
  email: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type EmailSignature = {
  __typename?: 'EmailSignature';
  /** Sanitized signature HTML */
  bodyHtml: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** Used when no signature matches the sending address */
  isDefault: Scalars['Boolean']['output'];
  /** Operator-facing label */
  name: Scalars['String']['output'];
  /** From-address this signature is used for. Null means it applies to any sending address. */
  sendingAddress?: Maybe<Scalars['String']['output']>;
  source: EmailSignatureSource;
  updatedAt: Scalars['DateTime']['output'];
};

/** Whether the signature was authored in Revvly or imported from Gmail. */
export enum EmailSignatureSource {
  Gmail = 'GMAIL',
  Manual = 'MANUAL',
}

/** Status of email delivery */
export enum EmailStatus {
  Bounced = 'BOUNCED',
  Delivered = 'DELIVERED',
  Draft = 'DRAFT',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Received = 'RECEIVED',
  Sent = 'SENT',
}

/** PRIVATE is only the creator; SHARED can be used by anyone on the tenant. */
export enum EmailTemplateVisibility {
  Private = 'PRIVATE',
  Shared = 'SHARED',
}

export type EmailThread = {
  __typename?: 'EmailThread';
  emails: Array<EmailCommunication>;
  lastEmailAt: Scalars['DateTime']['output'];
  subject: Scalars['String']['output'];
  threadId: Scalars['String']['output'];
  totalEmails: Scalars['Int']['output'];
};

/** Which triage tier decided a message. */
export enum EmailTriageTier {
  T0 = 'T0',
  T1 = 'T1',
  T2 = 'T2',
}

/** Type/category of email sent */
export enum EmailType {
  Inbound = 'INBOUND',
  Manual = 'MANUAL',
  Notification = 'NOTIFICATION',
  PaymentReminder = 'PAYMENT_REMINDER',
  RenewalReminder = 'RENEWAL_REMINDER',
}

export type EmptyResponse = {
  __typename?: 'EmptyResponse';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type EnableOrganizationFeatureFlagInput = {
  featureFlagId: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
};

export type EnsureExchangeRatesInput = {
  /** List of currency codes (uses current date) */
  currencies?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Currency-date pairs for historical rates */
  currencyDates?: InputMaybe<Array<CurrencyDatePair>>;
  /** Reporting/target currency to convert to */
  reportingCurrency?: InputMaybe<Scalars['String']['input']>;
};

export type EnsureExchangeRatesResult = {
  __typename?: 'EnsureExchangeRatesResult';
  /** Available exchange rates */
  availableRates: Array<ExchangeRateInfo>;
  /** Status message */
  message: Scalars['String']['output'];
  /** Rates that could not be fetched */
  missingRates: Array<MissingRateInfo>;
  /** Whether all rates are available */
  success: Scalars['Boolean']['output'];
};

export type EnterUsageReadingInput = {
  /** COMMISSION: net GMV for the period. Required for commission components when applicable. */
  netGmv?: InputMaybe<Scalars['Float']['input']>;
  /** Billable quantity for the closed period. */
  quantity: Scalars['Float']['input'];
  readingId: Scalars['ID']['input'];
  /** COMMISSION: transaction count for the period. */
  transactionCount?: InputMaybe<Scalars['Int']['input']>;
};

/** Lifecycle status for catalog entities. DRAFT → PUBLISHED (immutable) → ARCHIVED. */
export enum EntityStatus {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
}

/** The kind of platform entity a task relation or CRM subject reference points at (shared by TasksModule and CrmModule). */
export enum EntityTargetType {
  Lead = 'LEAD',
  Organization = 'ORGANIZATION',
  OrganizationContact = 'ORGANIZATION_CONTACT',
}

export type ExchangeRateInfo = {
  __typename?: 'ExchangeRateInfo';
  /** Currency code (e.g., USD, EUR, QAR) */
  currency: Scalars['String']['output'];
  /** Date of the rate (YYYY-MM-DD) */
  date?: Maybe<Scalars['String']['output']>;
  /** When the rate was last updated */
  lastUpdated?: Maybe<Scalars['String']['output']>;
  /** Exchange rate to reporting currency */
  rate: Scalars['Float']['output'];
};

export type ExchangeRateUsed = {
  __typename?: 'ExchangeRateUsed';
  /** Date the rate was effective */
  effectiveDate: Scalars['DateTime']['output'];
  /** Source currency */
  fromCurrency: Scalars['String']['output'];
  /** Exchange rate applied */
  rate: Scalars['Float']['output'];
  /** Source of the rate (fixer, manual, ecb) */
  source: Scalars['String']['output'];
  /** Target currency (reporting currency) */
  toCurrency: Scalars['String']['output'];
};

export type ExpansionFilterInput = {
  expansionType?: InputMaybe<ExpansionType>;
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  itemId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  subscriptionId?: InputMaybe<Scalars['ID']['input']>;
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ExpansionMetrics = {
  __typename?: 'ExpansionMetrics';
  contractionCount: Scalars['Int']['output'];
  contractionRevenue: Scalars['Float']['output'];
  expansionCount: Scalars['Int']['output'];
  expansionRevenue: Scalars['Float']['output'];
  netExpansionRevenue: Scalars['Float']['output'];
};

export type ExpansionMetricsResponse = {
  __typename?: 'ExpansionMetricsResponse';
  /** When these metrics were calculated */
  calculatedAt: Scalars['DateTime']['output'];
  /** Number of contraction events (downgrades) in the period */
  contractionCount: Scalars['Int']['output'];
  /** Total revenue lost from customer downgrades */
  contractionRevenue: Scalars['Float']['output'];
  /** End date of the measurement period */
  endDate: Scalars['DateTime']['output'];
  /** Number of expansion events (upgrades) in the period */
  expansionCount: Scalars['Int']['output'];
  /** Total revenue gained from customer upgrades and expansions */
  expansionRevenue: Scalars['Float']['output'];
  /** Net revenue change from expansions and contractions (expansion - contraction) */
  netExpansionRevenue: Scalars['Float']['output'];
  /** Start date of the measurement period */
  startDate: Scalars['DateTime']['output'];
};

export type ExpansionStatistics = {
  __typename?: 'ExpansionStatistics';
  byType: Array<ExpansionTypeStatsEntry>;
  recentExpansions: Array<SubscriptionExpansion>;
  totalCost: Scalars['Float']['output'];
  totalExpansions: Scalars['Int']['output'];
};

export type ExpansionTrendDataPoint = {
  __typename?: 'ExpansionTrendDataPoint';
  /** Number of contraction events in this month */
  contractionCount: Scalars['Int']['output'];
  /** Monthly recurring revenue lost from customer downgrades in this month */
  contractionMRR: Scalars['Float']['output'];
  /** Number of expansion events in this month */
  expansionCount: Scalars['Int']['output'];
  /** Monthly recurring revenue gained from customer upgrades and expansions in this month */
  expansionMRR: Scalars['Float']['output'];
  /** Month in YYYY-MM format */
  month: Scalars['String']['output'];
  /** Net monthly recurring revenue change (expansionMRR - contractionMRR) in this month */
  netExpansionMRR: Scalars['Float']['output'];
};

/** Type of subscription expansion/change */
export enum ExpansionType {
  BundleChange = 'BUNDLE_CHANGE',
  FeatureFlagAdd = 'FEATURE_FLAG_ADD',
  FeatureFlagRemove = 'FEATURE_FLAG_REMOVE',
  FunnelIncrease = 'FUNNEL_INCREASE',
  ModuleAdd = 'MODULE_ADD',
  ModuleRemove = 'MODULE_REMOVE',
  PriceOverride = 'PRICE_OVERRIDE',
  UserIncrease = 'USER_INCREASE',
}

export type ExpansionTypeStats = {
  __typename?: 'ExpansionTypeStats';
  count: Scalars['Int']['output'];
  totalAmount: Scalars['Float']['output'];
};

export type ExpansionTypeStatsEntry = {
  __typename?: 'ExpansionTypeStatsEntry';
  stats: ExpansionTypeStats;
  type: ExpansionType;
};

/** Active discount instance across the tenant (Flexible Discounting §10). */
export type ExpiringDiscountRow = {
  __typename?: 'ExpiringDiscountRow';
  instance: DiscountInstanceEntity;
  organizationName?: Maybe<Scalars['String']['output']>;
  /** "One-off" or the source definition name. */
  sourceName?: Maybe<Scalars['String']['output']>;
  /** Subscription's locked currency. */
  subscriptionCurrency: Scalars['String']['output'];
  targetLabel?: Maybe<Scalars['String']['output']>;
};

export type ExpiringDiscountsFilterInput = {
  /** Only instances sourced from this definition. */
  definitionId?: InputMaybe<Scalars['ID']['input']>;
  /** Only instances expiring within this many renewals (1 = next renewal). */
  withinRenewals?: InputMaybe<Scalars['Int']['input']>;
};

export type ExtendTestInputType = {
  acknowledge?: InputMaybe<Array<Scalars['String']['input']>>;
  plannedEndDate: Scalars['DateTime']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type ExternalLinkInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

/** A ClickUp list a task can be created in, with where it sits. */
export type ExternalList = {
  __typename?: 'ExternalList';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** Space, or Space / Folder, so two lists with one name can be told apart. */
  path: Scalars['String']['output'];
};

/** A status a ClickUp list defines. */
export type ExternalStatus = {
  __typename?: 'ExternalStatus';
  color?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type FeatureFlag = {
  __typename?: 'FeatureFlag';
  bundleFeatureFlags?: Maybe<Array<BundleFeatureFlag>>;
  category?: Maybe<FeatureFlagCategory>;
  categoryId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  featureFlagCategory?: Maybe<FeatureFlagCategory>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  moduleFeatureFlags?: Maybe<Array<ModuleFeatureFlag>>;
  name: Scalars['String']['output'];
  organizationFeatureFlags?: Maybe<Array<OrganizationFeatureFlag>>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type FeatureFlagCategory = {
  __typename?: 'FeatureFlagCategory';
  color?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  featureFlags?: Maybe<Array<FeatureFlag>>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type FeatureFlagConflict = {
  __typename?: 'FeatureFlagConflict';
  featureFlagId: Scalars['String']['output'];
  flagName?: Maybe<Scalars['String']['output']>;
  sourceEnabled: Scalars['Boolean']['output'];
  targetEnabled: Scalars['Boolean']['output'];
};

export type FeatureFlagFilterInput = {
  /** Filter by category ID */
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  /** Filter by active status */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Search across name, key, and description fields (partial match) */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FeatureFlagResolutionInput = {
  featureFlagId: Scalars['String']['input'];
  keepEnabled: Scalars['Boolean']['input'];
};

/** Source of how the feature flag was assigned to organization */
export enum FeatureFlagSource {
  Bundle = 'BUNDLE',
  Manual = 'MANUAL',
  Module = 'MODULE',
}

export type FeatureFlags = {
  __typename?: 'FeatureFlags';
  activityFeed?: Maybe<Scalars['Boolean']['output']>;
  anonymityApplications?: Maybe<Scalars['Boolean']['output']>;
  applicationsDashboard?: Maybe<Scalars['Boolean']['output']>;
  assessment?: Maybe<Scalars['Boolean']['output']>;
  auth0?: Maybe<Scalars['Boolean']['output']>;
  broadSearch?: Maybe<Scalars['Boolean']['output']>;
  bulkDataAssignation?: Maybe<Scalars['Boolean']['output']>;
  coreMetrics?: Maybe<Scalars['Boolean']['output']>;
  course?: Maybe<Scalars['Boolean']['output']>;
  createMetrics?: Maybe<Scalars['Boolean']['output']>;
  customDomainsManagement?: Maybe<Scalars['Boolean']['output']>;
  customFieldsAnalytics?: Maybe<Scalars['Boolean']['output']>;
  customFieldsEdit?: Maybe<Scalars['Boolean']['output']>;
  dataCollection?: Maybe<Scalars['Boolean']['output']>;
  designEditor?: Maybe<Scalars['Boolean']['output']>;
  designEditorPlus?: Maybe<Scalars['Boolean']['output']>;
  editEvaluationCriteria?: Maybe<Scalars['Boolean']['output']>;
  editIndustries?: Maybe<Scalars['Boolean']['output']>;
  editTags?: Maybe<Scalars['Boolean']['output']>;
  emailEvents?: Maybe<Scalars['Boolean']['output']>;
  emailTemplates?: Maybe<Scalars['Boolean']['output']>;
  engagementAnalytics?: Maybe<Scalars['Boolean']['output']>;
  evaluationSubmissionSettings?: Maybe<Scalars['Boolean']['output']>;
  evaluationVisibility?: Maybe<Scalars['Boolean']['output']>;
  feedbackForms?: Maybe<Scalars['Boolean']['output']>;
  groupChat?: Maybe<Scalars['Boolean']['output']>;
  hidePoweredBy?: Maybe<Scalars['Boolean']['output']>;
  hoursAllocation?: Maybe<Scalars['Boolean']['output']>;
  isIncubator?: Maybe<Scalars['Boolean']['output']>;
  liveChat?: Maybe<Scalars['Boolean']['output']>;
  lockedSkills?: Maybe<Scalars['Boolean']['output']>;
  microsoftIntegration?: Maybe<Scalars['Boolean']['output']>;
  milestones?: Maybe<Scalars['Boolean']['output']>;
  nameOnlyEmailSender?: Maybe<Scalars['Boolean']['output']>;
  newUI?: Maybe<Scalars['Boolean']['output']>;
  newsFeed?: Maybe<Scalars['Boolean']['output']>;
  oneOnOneEvents?: Maybe<Scalars['Boolean']['output']>;
  plannedActions?: Maybe<Scalars['Boolean']['output']>;
  programPage?: Maybe<Scalars['Boolean']['output']>;
  qNumericalChoice?: Maybe<Scalars['Boolean']['output']>;
  qUserAddRow?: Maybe<Scalars['Boolean']['output']>;
  questionVisibility?: Maybe<Scalars['Boolean']['output']>;
  reminderEmails?: Maybe<Scalars['Boolean']['output']>;
  resourceVisibility?: Maybe<Scalars['Boolean']['output']>;
  savedViewsApplications?: Maybe<Scalars['Boolean']['output']>;
  savedViewsStartups?: Maybe<Scalars['Boolean']['output']>;
  savedViewsUsers?: Maybe<Scalars['Boolean']['output']>;
  startupFilter?: Maybe<Scalars['Boolean']['output']>;
  startupTaxonomyEditable?: Maybe<Scalars['Boolean']['output']>;
  teamsIntegration?: Maybe<Scalars['Boolean']['output']>;
  videoIntegration?: Maybe<Scalars['Boolean']['output']>;
  zapierIntegration?: Maybe<Scalars['Boolean']['output']>;
  zoomIntegration?: Maybe<Scalars['Boolean']['output']>;
};

export type FieldConflict = {
  __typename?: 'FieldConflict';
  fieldName: Scalars['String']['output'];
  /** Human-readable form of sourceValue (e.g. a region or tenant name instead of its id) */
  sourceDisplay?: Maybe<Scalars['String']['output']>;
  sourceValue?: Maybe<Scalars['String']['output']>;
  /** Human-readable form of targetValue (e.g. a region or tenant name instead of its id) */
  targetDisplay?: Maybe<Scalars['String']['output']>;
  targetValue?: Maybe<Scalars['String']['output']>;
};

export type FieldMatch = {
  __typename?: 'FieldMatch';
  /** Human-readable form of value */
  display?: Maybe<Scalars['String']['output']>;
  fieldName: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type FieldResolutionInput = {
  fieldName: Scalars['String']['input'];
  useSource: Scalars['String']['input'];
};

/** Category of stored file */
export enum FileCategory {
  AgentAttachment = 'AGENT_ATTACHMENT',
  Attachment = 'ATTACHMENT',
  Backup = 'BACKUP',
  Document = 'DOCUMENT',
  Export = 'EXPORT',
  FormUpload = 'FORM_UPLOAD',
  Import = 'IMPORT',
  LibraryDocument = 'LIBRARY_DOCUMENT',
  Other = 'OTHER',
  Report = 'REPORT',
  SupportAttachment = 'SUPPORT_ATTACHMENT',
}

/** Status of stored file */
export enum FileStatus {
  Completed = 'COMPLETED',
  Expired = 'EXPIRED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
}

/** What Intercom recorded for its AI agent (Fin) on a conversation. NONE: Fin did not take part. UNKNOWN: Intercom did not say. ASSUMED_RESOLUTION means the customer did not come back, not that they confirmed. */
export enum FinResolutionState {
  Abandoned = 'ABANDONED',
  AssumedResolution = 'ASSUMED_RESOLUTION',
  ConfirmedResolution = 'CONFIRMED_RESOLUTION',
  None = 'NONE',
  RoutedToTeam = 'ROUTED_TO_TEAM',
  Unknown = 'UNKNOWN',
}

/** Fixed-amount application mode on a component: per unit, or flat lump sum off the line. */
export enum FixedDiscountMode {
  FlatLumpSum = 'FLAT_LUMP_SUM',
  PerUnit = 'PER_UNIT',
}

export type Form = {
  __typename?: 'Form';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /** What the builder edits. Not live until published. */
  draft: FormDefinitionType;
  hasUnpublishedChanges: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  lastSubmissionAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  /** Public handle used by the hosted page, the embed and the API. */
  publicId: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  publishedVersion?: Maybe<Scalars['Int']['output']>;
  status: FormStatus;
  submissionCount: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type FormAction = {
  __typename?: 'FormAction';
  createLead?: Maybe<CreateLeadActionSettings>;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  notifyUsers?: Maybe<NotifyUsersActionSettings>;
  onFailure: FormActionFailurePolicy;
  postSlack?: Maybe<PostSlackActionSettings>;
  sendEmail?: Maybe<SendEmailActionSettings>;
  type: FormActionType;
};

export enum FormActionFailurePolicy {
  Continue = 'CONTINUE',
  Stop = 'STOP',
}

export type FormActionInput = {
  createLead?: InputMaybe<CreateLeadActionSettingsInput>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  notifyUsers?: InputMaybe<NotifyUsersActionSettingsInput>;
  onFailure?: FormActionFailurePolicy;
  postSlack?: InputMaybe<PostSlackActionSettingsInput>;
  sendEmail?: InputMaybe<SendEmailActionSettingsInput>;
  type: FormActionType;
};

export type FormActionRun = {
  __typename?: 'FormActionRun';
  actionId: Scalars['String']['output'];
  attempts: Scalars['Int']['output'];
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  lastError?: Maybe<Scalars['String']['output']>;
  /** CREATE_LEAD: the lead it created. */
  leadId?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** CREATE_LEAD: the company the lead is on. */
  organizationId?: Maybe<Scalars['ID']['output']>;
  /** Step output as JSON. */
  outputJson?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: FormActionRunStatus;
  type: FormActionType;
};

export enum FormActionRunStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Skipped = 'SKIPPED',
  Succeeded = 'SUCCEEDED',
}

export enum FormActionType {
  CreateLead = 'CREATE_LEAD',
  NotifyUsers = 'NOTIFY_USERS',
  PostSlack = 'POST_SLACK',
  SendEmail = 'SEND_EMAIL',
}

/** One part of a client submission that can be written to the client. */
export type FormClientApplyRow = {
  __typename?: 'FormClientApplyRow';
  appliedAt?: Maybe<Scalars['DateTime']['output']>;
  /** What the client record holds now. */
  current?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  /** The client record already holds what was sent. */
  matches: Scalars['Boolean']['output'];
  /** What the client sent. */
  submitted: Scalars['String']['output'];
  target: FormClientApplyTarget;
};

export enum FormClientApplyTarget {
  BillingAddress = 'BILLING_ADDRESS',
  BillingContact = 'BILLING_CONTACT',
  CompanyNumber = 'COMPANY_NUMBER',
  LegalName = 'LEGAL_NAME',
  LegalStructure = 'LEGAL_STRUCTURE',
  SignerContact = 'SIGNER_CONTACT',
  TaxId = 'TAX_ID',
}

export enum FormClientLinkStatus {
  Open = 'OPEN',
  Submitted = 'SUBMITTED',
}

/** A form sent to a client: the link, and the answers once given. */
export type FormClientSubmission = {
  __typename?: 'FormClientSubmission';
  applyRows: Array<FormClientApplyRow>;
  createdAt: Scalars['DateTime']['output'];
  formId: Scalars['ID']['output'];
  formName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastOpenedAt?: Maybe<Scalars['DateTime']['output']>;
  openCount: Scalars['Int']['output'];
  /** Null for a submission linked to the client without a link. */
  status?: Maybe<FormClientLinkStatus>;
  /** Null until the client answers. */
  submission?: Maybe<FormSubmission>;
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The subscription the answers point at, to open the subscription wizard with. Null when the form asks no plan, billing period or start date, or the client left them blank. */
  subscriptionProposal?: Maybe<FormSubscriptionProposal>;
  /** The link to send, while it has not been answered. */
  url?: Maybe<Scalars['String']['output']>;
};

export type FormDefinitionInput = {
  actions: Array<FormActionInput>;
  fields: Array<FormFieldInput>;
  settings: FormSettingsInput;
};

export type FormDefinitionType = {
  __typename?: 'FormDefinitionType';
  actions: Array<FormAction>;
  fields: Array<FormField>;
  settings: FormSettings;
};

export enum FormEmailSender {
  OrgMailbox = 'ORG_MAILBOX',
  Revvly = 'REVVLY',
  UserMailbox = 'USER_MAILBOX',
}

export type FormEmailSenderOption = {
  __typename?: 'FormEmailSenderOption';
  /** The address it sends as, when known. */
  address?: Maybe<Scalars['String']['output']>;
  available: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  sender: FormEmailSender;
  /** Why it cannot be used right now. */
  unavailableReason?: Maybe<Scalars['String']['output']>;
};

export type FormField = {
  __typename?: 'FormField';
  /** Where the answer belongs on the client a client link was sent for. */
  binding?: Maybe<FormFieldBinding>;
  defaultValue?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fileKinds?: Maybe<Array<FormFileKind>>;
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  maxFileSizeMb?: Maybe<Scalars['Int']['output']>;
  maxFiles?: Maybe<Scalars['Int']['output']>;
  maxLength?: Maybe<Scalars['Int']['output']>;
  options: Array<FormFieldOption>;
  placeholder?: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
  role?: Maybe<FormFieldRole>;
  type: FormFieldType;
  urlParam?: Maybe<Scalars['String']['output']>;
};

export enum FormFieldBinding {
  BillingContactEmail = 'BILLING_CONTACT_EMAIL',
  BillingContactName = 'BILLING_CONTACT_NAME',
  BillingContactPhone = 'BILLING_CONTACT_PHONE',
  ClientBillingAddress = 'CLIENT_BILLING_ADDRESS',
  ClientCompanyNumber = 'CLIENT_COMPANY_NUMBER',
  ClientLegalName = 'CLIENT_LEGAL_NAME',
  ClientLegalStructure = 'CLIENT_LEGAL_STRUCTURE',
  ClientTaxId = 'CLIENT_TAX_ID',
  SignerContactEmail = 'SIGNER_CONTACT_EMAIL',
  SignerContactName = 'SIGNER_CONTACT_NAME',
  SignerContactPhone = 'SIGNER_CONTACT_PHONE',
  SubscriptionPeriod = 'SUBSCRIPTION_PERIOD',
  SubscriptionPlan = 'SUBSCRIPTION_PLAN',
  SubscriptionStartDate = 'SUBSCRIPTION_START_DATE',
}

export type FormFieldInput = {
  binding?: InputMaybe<FormFieldBinding>;
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fileKinds?: InputMaybe<Array<FormFileKind>>;
  id: Scalars['String']['input'];
  key: Scalars['String']['input'];
  label: Scalars['String']['input'];
  maxFileSizeMb?: InputMaybe<Scalars['Int']['input']>;
  maxFiles?: InputMaybe<Scalars['Int']['input']>;
  maxLength?: InputMaybe<Scalars['Int']['input']>;
  options?: InputMaybe<Array<FormFieldOptionInput>>;
  placeholder?: InputMaybe<Scalars['String']['input']>;
  required?: Scalars['Boolean']['input'];
  role?: InputMaybe<FormFieldRole>;
  type: FormFieldType;
  urlParam?: InputMaybe<Scalars['String']['input']>;
};

export type FormFieldOption = {
  __typename?: 'FormFieldOption';
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  /** What the option stands for on a field bound to a subscription term: BUNDLE:<lineageId> or MODULE:<lineageId> for a plan, MONTHLY / QUARTERLY / YEARLY for a billing period. */
  value?: Maybe<Scalars['String']['output']>;
};

export type FormFieldOptionInput = {
  id: Scalars['String']['input'];
  label: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum FormFieldRole {
  CompanyName = 'COMPANY_NAME',
  CompanyWebsite = 'COMPANY_WEBSITE',
  ContactEmail = 'CONTACT_EMAIL',
  ContactFirstName = 'CONTACT_FIRST_NAME',
  ContactLastName = 'CONTACT_LAST_NAME',
  ContactName = 'CONTACT_NAME',
  ContactPhone = 'CONTACT_PHONE',
}

export enum FormFieldType {
  Consent = 'CONSENT',
  Date = 'DATE',
  Dropdown = 'DROPDOWN',
  Email = 'EMAIL',
  FileUpload = 'FILE_UPLOAD',
  Heading = 'HEADING',
  Hidden = 'HIDDEN',
  LongText = 'LONG_TEXT',
  MultipleChoice = 'MULTIPLE_CHOICE',
  Number = 'NUMBER',
  Paragraph = 'PARAGRAPH',
  Phone = 'PHONE',
  RichText = 'RICH_TEXT',
  ShortText = 'SHORT_TEXT',
  SingleChoice = 'SINGLE_CHOICE',
  Url = 'URL',
}

export enum FormFileKind {
  Document = 'DOCUMENT',
  Image = 'IMAGE',
  Pdf = 'PDF',
  Presentation = 'PRESENTATION',
  Spreadsheet = 'SPREADSHEET',
  Text = 'TEXT',
}

export type FormSettings = {
  __typename?: 'FormSettings';
  /** Only reachable through links made for a client. */
  clientLinksOnly: Scalars['Boolean']['output'];
  redirectUrl?: Maybe<Scalars['String']['output']>;
  submitLabel: Scalars['String']['output'];
  successMessage: Scalars['String']['output'];
};

export type FormSettingsInput = {
  clientLinksOnly?: InputMaybe<Scalars['Boolean']['input']>;
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
  submitLabel: Scalars['String']['input'];
  successMessage: Scalars['String']['input'];
};

export type FormSlackChannel = {
  __typename?: 'FormSlackChannel';
  id: Scalars['String']['output'];
  /** Whether the Revvly bot is already in the channel. */
  isMember: Scalars['Boolean']['output'];
  isPrivate: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type FormSlackChannels = {
  __typename?: 'FormSlackChannels';
  channels: Array<FormSlackChannel>;
  /** Whether this workspace has Slack connected at all. */
  connected: Scalars['Boolean']['output'];
  /** False when the Slack app was installed without the scope to see private channels; reinstall to list them. */
  privateChannelsVisible: Scalars['Boolean']['output'];
};

export enum FormStatus {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
}

export type FormSubmission = {
  __typename?: 'FormSubmission';
  actionRuns: Array<FormActionRun>;
  actionStatus: FormSubmissionActionStatus;
  answers: Array<FormSubmissionAnswer>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  formId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** The client a client link was sent for. */
  organizationId?: Maybe<Scalars['ID']['output']>;
  pageUrl?: Maybe<Scalars['String']['output']>;
  referrer?: Maybe<Scalars['String']['output']>;
  source: FormSubmissionSource;
  submitterEmail?: Maybe<Scalars['String']['output']>;
  version: Scalars['Int']['output'];
};

export enum FormSubmissionActionStatus {
  AwaitingResponse = 'AWAITING_RESPONSE',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Skipped = 'SKIPPED',
}

export type FormSubmissionAnswer = {
  __typename?: 'FormSubmissionAnswer';
  /** FILE_UPLOAD only. */
  files: Array<FormSubmissionFile>;
  /** Sanitised HTML, RICH_TEXT only. */
  html?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  /** The answer as plain text (choices joined, rich text flattened). */
  text: Scalars['String']['output'];
  type: FormFieldType;
};

/** Submissions as a CSV file, generated on request. */
export type FormSubmissionExport = {
  __typename?: 'FormSubmissionExport';
  /** The CSV text (UTF-8 with a byte-order mark, CRLF line endings). */
  content: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  rowCount: Scalars['Int']['output'];
  /** True when there were more rows than one export carries (the newest are kept). */
  truncated: Scalars['Boolean']['output'];
};

export type FormSubmissionFile = {
  __typename?: 'FormSubmissionFile';
  filename: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mimeType: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  /** Download link, valid for 30 minutes. */
  url?: Maybe<Scalars['String']['output']>;
};

export type FormSubmissionFilterInput = {
  actionStatus?: InputMaybe<FormSubmissionActionStatus>;
  /** Cursor: the last id of the previous page. */
  before?: InputMaybe<Scalars['ID']['input']>;
  formId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Matches the submitter email. */
  search?: InputMaybe<Scalars['String']['input']>;
};

export type FormSubmissionPage = {
  __typename?: 'FormSubmissionPage';
  hasMore: Scalars['Boolean']['output'];
  items: Array<FormSubmission>;
};

export enum FormSubmissionSource {
  Api = 'API',
  ClientLink = 'CLIENT_LINK',
  Custom = 'CUSTOM',
  Embed = 'EMBED',
  Hosted = 'HOSTED',
}

/** A subscription proposed by a client's answers. Never created on its own: a person reviews it in the subscription wizard. */
export type FormSubscriptionProposal = {
  __typename?: 'FormSubscriptionProposal';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  issues: Array<Scalars['String']['output']>;
  period?: Maybe<SubscriptionPeriod>;
  /** The plan's current published version. Null when it is no longer offered. */
  planId?: Maybe<Scalars['ID']['output']>;
  /** BUNDLE or MODULE. */
  planKind?: Maybe<Scalars['String']['output']>;
  planName?: Maybe<Scalars['String']['output']>;
  /** YYYY-MM-DD. */
  startDate?: Maybe<Scalars['String']['output']>;
  /** The subscription created from it, once one was. */
  subscriptionId?: Maybe<Scalars['ID']['output']>;
};

/** A capability within a feature, granted independently of account administration */
export enum FunctionRole {
  CsManager = 'CS_MANAGER',
  CsTeamLead = 'CS_TEAM_LEAD',
  CycleOwner = 'CYCLE_OWNER',
}

/** Grant or revoke a function role */
export type FunctionRoleGrantInput = {
  /** The role */
  role: FunctionRole;
  /** Auth id of the person */
  userId: Scalars['String']['input'];
};

/** One holder of a function role */
export type FunctionRoleHolder = {
  __typename?: 'FunctionRoleHolder';
  /** When it was granted, for direct grants */
  grantedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The holder */
  person: TeamPerson;
  /** Whether they were granted the role directly or hold it as an account admin */
  source: FunctionRoleSource;
};

/** Whether a role was granted directly or is implied by account administration */
export enum FunctionRoleSource {
  Granted = 'GRANTED',
  ImpliedAdmin = 'IMPLIED_ADMIN',
}

/** A function role and everyone who holds it */
export type FunctionRoleSummary = {
  __typename?: 'FunctionRoleSummary';
  /** One line on what the role permits */
  description: Scalars['String']['output'];
  /** Everyone holding it, direct grants first */
  holders: Array<FunctionRoleHolder>;
  /** True when nobody holds the role directly and it is held only through account administration — a real configuration, not an empty state. */
  impliedOnly: Scalars['Boolean']['output'];
  /** Human label, e.g. “Cycle owner” */
  label: Scalars['String']['output'];
  /** The role */
  role: FunctionRole;
};

export type GeneralEmail = {
  __typename?: 'GeneralEmail';
  address?: Maybe<Scalars['String']['output']>;
  confirmed: Scalars['Boolean']['output'];
  neWAddress: Scalars['String']['output'];
};

export type GenerateVariableInvoiceLinesInput = {
  endCustomerId?: InputMaybe<Scalars['ID']['input']>;
  invoiceId: Scalars['ID']['input'];
  /** Period boundary for this billing run */
  periodEnd: Scalars['DateTime']['input'];
  regionId?: InputMaybe<Scalars['ID']['input']>;
  /** When false, snapshots/lines are produced but counters NOT reset (preview mode) */
  resetCounters?: InputMaybe<Scalars['Boolean']['input']>;
  subscriptionId: Scalars['ID']['input'];
};

export type GeneratedInvoiceLine = {
  __typename?: 'GeneratedInvoiceLine';
  currency: Scalars['String']['output'];
  description: Scalars['String']['output'];
  quantity: Scalars['Float']['output'];
  snapshot: BillingPeriodSnapshot;
  totalAmount: Scalars['Float']['output'];
  unitPrice: Scalars['Float']['output'];
};

export type GeneratedSubscriptionPreview = {
  __typename?: 'GeneratedSubscriptionPreview';
  /** Base price */
  amount: Scalars['Float']['output'];
  /** Currency */
  currency: Scalars['String']['output'];
  /** Subscription end date */
  endDate: Scalars['String']['output'];
  /** Organization name */
  organizationName: Scalars['String']['output'];
  /** Billing period */
  period: SubscriptionPeriod;
  /** Subscription start date */
  startDate: Scalars['String']['output'];
  /** Subscription status: ACTIVE, EXPIRED, or CANCELLED */
  status: Scalars['String']['output'];
  /** Subscription type: ACQUISITION, RENEWAL, or EXPANSION */
  subscriptionType: Scalars['String']['output'];
};

export type GeoCountry = {
  __typename?: 'GeoCountry';
  /** ISO 3166-1 alpha-2. The dashboard names it with Intl.DisplayNames. */
  code: Scalars['String']['output'];
  continentCode?: Maybe<Scalars['String']['output']>;
};

export type GeoRegion = {
  __typename?: 'GeoRegion';
  /** ISO 3166-1 alpha-2 codes of the countries it contains. */
  countryCodes: Array<Scalars['String']['output']>;
  /** What a location filter names: `continent:EU` for a built-in continent, an id for a workspace region. */
  id: Scalars['ID']['output'];
  kind: GeoRegionKind;
  name: Scalars['String']['output'];
  shapes: Array<GeoShape>;
};

/** A built-in continent, or a region the workspace defined. */
export enum GeoRegionKind {
  Continent = 'CONTINENT',
  Custom = 'CUSTOM',
}

export type GeoShape = {
  __typename?: 'GeoShape';
  east?: Maybe<Scalars['Float']['output']>;
  /** What the editor shows for the area. */
  label?: Maybe<Scalars['String']['output']>;
  /** CIRCLE: the centre. */
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  /** BOX: the box edges. West greater than east crosses the antimeridian. */
  north?: Maybe<Scalars['Float']['output']>;
  /** CIRCLE: the radius in kilometres. */
  radiusKm?: Maybe<Scalars['Float']['output']>;
  south?: Maybe<Scalars['Float']['output']>;
  type: GeoShapeType;
  west?: Maybe<Scalars['Float']['output']>;
};

export type GeoShapeInput = {
  east?: InputMaybe<Scalars['Float']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  north?: InputMaybe<Scalars['Float']['input']>;
  radiusKm?: InputMaybe<Scalars['Float']['input']>;
  south?: InputMaybe<Scalars['Float']['input']>;
  type: GeoShapeType;
  west?: InputMaybe<Scalars['Float']['input']>;
};

export enum GeoShapeType {
  Box = 'BOX',
  Circle = 'CIRCLE',
}

export type GlobalSearchGroup = {
  __typename?: 'GlobalSearchGroup';
  hits: Array<GlobalSearchHit>;
  /** True when there are more matches than `totalCount` says */
  totalCapped: Scalars['Boolean']['output'];
  /** Matches of this kind, counted up to `totalCapped` */
  totalCount: Scalars['Int']['output'];
  type: GlobalSearchType;
};

export type GlobalSearchHit = {
  __typename?: 'GlobalSearchHit';
  amount?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  match?: Maybe<SearchMatchInfo>;
  /** The client this record belongs to */
  organizationId?: Maybe<Scalars['ID']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  /** Relevance; higher is better. Only comparable within one search */
  score: Scalars['Float']['output'];
  /** Lifecycle stage (clients), payment status (invoices) or status (subscriptions) */
  status?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: GlobalSearchType;
};

export type GlobalSearchInput = {
  /** Hits per kind (default 5, max 20) */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** What was typed. A leading `email:`, `vat:`, `inv:`, `phone:` … narrows to that field */
  query: Scalars['String']['input'];
  /** Only these kinds; every kind when empty */
  types?: InputMaybe<Array<GlobalSearchType>>;
};

export type GlobalSearchResult = {
  __typename?: 'GlobalSearchResult';
  /** Kinds with at least one hit, most relevant first */
  groups: Array<GlobalSearchGroup>;
  /** email | invoiceNumber | phone | taxId when the query looks like one */
  intent?: Maybe<Scalars['String']['output']>;
  /** The query as it was read: normalised, with any operator taken off */
  query: Scalars['String']['output'];
  /** The field operator that narrowed the search, if any */
  scopedTo?: Maybe<Scalars['String']['output']>;
};

/** A kind of record Cmd-K searches */
export enum GlobalSearchType {
  Client = 'CLIENT',
  Contact = 'CONTACT',
  Invoice = 'INVOICE',
  Subscription = 'SUBSCRIPTION',
}

export type GmailAuthUrl = {
  __typename?: 'GmailAuthUrl';
  url: Scalars['String']['output'];
};

export type GmailIntegrationStatus = {
  __typename?: 'GmailIntegrationStatus';
  connected: Scalars['Boolean']['output'];
  senderEmail?: Maybe<Scalars['String']['output']>;
};

export type GmailSignatureCandidate = {
  __typename?: 'GmailSignatureCandidate';
  /** Sanitized signature HTML as configured in Gmail */
  bodyHtml: Scalars['String']['output'];
  /** Display name Gmail sends this address as */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Whether this is the default send-as address in Gmail */
  isPrimary: Scalars['Boolean']['output'];
  /** The Gmail send-as address the signature belongs to */
  sendingAddress: Scalars['String']['output'];
};

/** Which trigger raised a going-dark situation. */
export enum GoingDarkSignal {
  SlowReplies = 'SLOW_REPLIES',
  UnansweredOutbound = 'UNANSWERED_OUTBOUND',
}

export type GoogleAuthUrl = {
  __typename?: 'GoogleAuthUrl';
  url: Scalars['String']['output'];
};

export type GoogleDriveAuthUrl = {
  __typename?: 'GoogleDriveAuthUrl';
  url: Scalars['String']['output'];
};

export type GoogleDriveConnectionEntity = {
  __typename?: 'GoogleDriveConnectionEntity';
  connectedBy?: Maybe<Scalars['String']['output']>;
  googleAccountEmail?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isConnected: Scalars['Boolean']['output'];
  syncedFolders: Array<SyncedFolderEntity>;
};

export type GoogleDriveSyncJobEntity = {
  __typename?: 'GoogleDriveSyncJobEntity';
  /** Files currently being analyzed in parallel */
  activeFiles?: Maybe<Array<ActiveSyncFile>>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** Name of the file currently being analyzed */
  currentFileName?: Maybe<Scalars['String']['output']>;
  /** Presigned URL to preview/thumbnail the file currently being analyzed */
  currentFilePreviewUrl?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  /** Folder names included in this sync job */
  folderNames?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  processedFiles: Scalars['Int']['output'];
  /** Current step while listing Drive files or before per-file progress applies */
  progressMessage?: Maybe<Scalars['String']['output']>;
  /** Review progress over the invoices this job staged. Null when the job staged none — which is a different statement from "none answered yet", and the caller should not render a 0/0 bar for it. */
  reviewProgress?: Maybe<SyncJobReviewProgress>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
  totalFiles?: Maybe<Scalars['Int']['output']>;
  triggeredBy?: Maybe<Scalars['String']['output']>;
};

export type GoogleDriveSyncResultEntity = {
  __typename?: 'GoogleDriveSyncResultEntity';
  confidence?: Maybe<Scalars['Float']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  existingInvoiceId?: Maybe<Scalars['String']['output']>;
  extractedData?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  googleFileId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  invoicePrefix?: Maybe<Scalars['String']['output']>;
  /** The invoice-side facts the proposals were judged against */
  matchFingerprint?: Maybe<MatchFingerprintEntity>;
  /** Why the policy would not auto-accept: ledger-safety reasons, not scoring. Recorded today rather than acted on — routing still follows extraction confidence. */
  matchHoldReasons?: Maybe<Array<Scalars['String']['output']>>;
  /** Which strategy owned the decision, even if it proposed nothing */
  matchPrimaryStrategy?: Maybe<Scalars['String']['output']>;
  /** Every strategy’s answer for this invoice, recorded before any human touched it. The applied one is the non-shadow, non-failed entry naming primaryStrategy. */
  matchProposals?: Maybe<Array<MatchProposalEntity>>;
  matchReason?: Maybe<Scalars['String']['output']>;
  matchWarning?: Maybe<Scalars['String']['output']>;
  matchedBundleId?: Maybe<Scalars['String']['output']>;
  matchedModuleIds?: Maybe<Array<Scalars['String']['output']>>;
  matchedOrganizationId?: Maybe<Scalars['String']['output']>;
  matchedSubscriptionId?: Maybe<Scalars['String']['output']>;
  /** Payments a reviewer entered (client-folder imports); applied once after commit. */
  payments?: Maybe<Array<SyncResultPayment>>;
  productMatchConfidence?: Maybe<Scalars['Float']['output']>;
  productMatchReasoning?: Maybe<Scalars['String']['output']>;
  s3Key?: Maybe<Scalars['String']['output']>;
  status: SyncResultStatus;
  syncJobId: Scalars['String']['output'];
};

/** Google access Revvly can request in a single consent. */
export enum GoogleFeature {
  Calendar = 'CALENDAR',
  Drive = 'DRIVE',
  DriveFolders = 'DRIVE_FOLDERS',
  Gmail = 'GMAIL',
}

export type HealthStatus = {
  __typename?: 'HealthStatus';
  message: Scalars['String']['output'];
  status: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
  uptime: Scalars['Float']['output'];
};

export type HoldUsageReadingInput = {
  readingId: Scalars['ID']['input'];
  /** Required reason: why the figure needs a look before it bills. */
  reason: Scalars['String']['input'];
};

export type HypothesisBoardFilterInputType = {
  keyResultId?: InputMaybe<Scalars['ID']['input']>;
  objectiveId?: InputMaybe<Scalars['ID']['input']>;
  ownerUserId?: InputMaybe<Scalars['String']['input']>;
  teamId?: InputMaybe<Scalars['ID']['input']>;
};

export enum HypothesisDispositionAction {
  Carry = 'CARRY',
  Conclude = 'CONCLUDE',
  Drop = 'DROP',
}

export type HypothesisDispositionInputType = {
  action: HypothesisDispositionAction;
  /** Required for CONCLUDE */
  conclusion?: InputMaybe<ConcludeHypothesisInputType>;
  hypothesisId: Scalars['ID']['input'];
  /** Required for DROP */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** Required for CARRY: a Key Result in a later cycle */
  targetKeyResultId?: InputMaybe<Scalars['ID']['input']>;
};

export enum HypothesisInconclusiveReason {
  Confounded = 'CONFOUNDED',
  EndedEarly = 'ENDED_EARLY',
  InsufficientData = 'INSUFFICIENT_DATA',
  MeasurementFailed = 'MEASUREMENT_FAILED',
  Other = 'OTHER',
}

export enum HypothesisIssueSeverity {
  Block = 'BLOCK',
  Confirm = 'CONFIRM',
  Inform = 'INFORM',
}

export type HypothesisLearningsFilterInputType = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  cycleId?: InputMaybe<Scalars['ID']['input']>;
  keyResultId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  outcomes?: InputMaybe<Array<HypothesisOutcome>>;
  ownerUserId?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  teamId?: InputMaybe<Scalars['ID']['input']>;
};

export enum HypothesisLinkSource {
  Clickup = 'CLICKUP',
  Manual = 'MANUAL',
}

export enum HypothesisNextStep {
  Iterate = 'ITERATE',
  None = 'NONE',
  Retest = 'RETEST',
  RollOut = 'ROLL_OUT',
}

export enum HypothesisOutcome {
  Inconclusive = 'INCONCLUSIVE',
  Invalidated = 'INVALIDATED',
  Validated = 'VALIDATED',
}

export enum HypothesisSnapshotKind {
  End = 'END',
  Start = 'START',
}

export enum HypothesisSnapshotSkip {
  MetricChanged = 'METRIC_CHANGED',
  MetricWithdrawn = 'METRIC_WITHDRAWN',
  ReadFailed = 'READ_FAILED',
}

export enum HypothesisStatus {
  Backlog = 'BACKLOG',
  Carried = 'CARRIED',
  Concluded = 'CONCLUDED',
  Developing = 'DEVELOPING',
  Dropped = 'DROPPED',
  Testing = 'TESTING',
}

export type ImportAnalysisResult = {
  __typename?: 'ImportAnalysisResult';
  /** When this analysis was performed */
  analyzedAt: Scalars['DateTime']['output'];
  /** Number of items needing attention */
  attentionCount: Scalars['Int']['output'];
  /** Items needing attention before import */
  attentionItems: Array<ImportAttentionItem>;
  /** Whether the import can proceed (no blocking issues) */
  canProceed: Scalars['Boolean']['output'];
  /** Organization analysis */
  organizations: ImportOrganizationAnalysis;
  /** Product matching analysis (when products are configured) */
  productMatching?: Maybe<ImportProductMatchAnalysis>;
  /** Revenue impact analysis */
  revenue: ImportRevenueAnalysis;
  /** Subscription analysis */
  subscriptions: ImportSubscriptionAnalysis;
  /** Total number of transactions analyzed */
  totalTransactions: Scalars['Int']['output'];
};

export type ImportAttentionItem = {
  __typename?: 'ImportAttentionItem';
  /** Amount if applicable */
  amount?: Maybe<Scalars['Float']['output']>;
  /** Human-readable message */
  message: Scalars['String']['output'];
  /** Organization name if applicable */
  organizationName?: Maybe<Scalars['String']['output']>;
  /** Row number in the import file (1-based) */
  rowNumber: Scalars['Int']['output'];
  /** Type of attention needed */
  type: Scalars['String']['output'];
};

export type ImportBatchRollbackResult = {
  __typename?: 'ImportBatchRollbackResult';
  /** The rolled-back batch id */
  batchId: Scalars['String']['output'];
  /** Version/price-override/billing-timing history rows deleted */
  historyRecordsDeleted: Scalars['Int']['output'];
  /** Invoices deleted */
  invoicesDeleted: Scalars['Int']['output'];
  /** Pre-existing invoices the batch had linked to a subscription it created, unlinked and returned to the unmatched worklist */
  invoicesUnlinked: Scalars['Int']['output'];
  /** Lifecycle events deleted */
  lifecycleEventsDeleted: Scalars['Int']['output'];
  /** Clients deleted (only those left with no other records) */
  organizationsDeleted: Scalars['Int']['output'];
  /** Subscriptions deleted */
  subscriptionsDeleted: Scalars['Int']['output'];
};

/** Whether an import run still stands or has been rolled back */
export enum ImportBatchStatus {
  Completed = 'COMPLETED',
  RolledBack = 'ROLLED_BACK',
}

export type ImportBatchSummary = {
  __typename?: 'ImportBatchSummary';
  createdAt: Scalars['DateTime']['output'];
  /** Who ran the import, when recorded */
  createdByName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invoicesCreated: Scalars['Int']['output'];
  /** Invoices this run created that still exist */
  invoicesRemaining: Scalars['Int']['output'];
  organizationsCreated: Scalars['Int']['output'];
  /** Clients this run created that still exist */
  organizationsRemaining: Scalars['Int']['output'];
  rolledBackAt?: Maybe<Scalars['DateTime']['output']>;
  rolledBackByName?: Maybe<Scalars['String']['output']>;
  source: InvoiceSource;
  status: ImportBatchStatus;
  subscriptionsCreated: Scalars['Int']['output'];
  /** Subscriptions this run created that still exist */
  subscriptionsRemaining: Scalars['Int']['output'];
};

export type ImportCrmColumnMappingInput = {
  field: Scalars['String']['input'];
  sourceColumn: Scalars['String']['input'];
};

export type ImportCrmContactsAndCompaniesInput = {
  /** How the operator mapped file columns; stored on the batch for the log. */
  columnMapping?: InputMaybe<Array<ImportCrmColumnMappingInput>>;
  /** Original filename, stored on the batch log. */
  fileName: Scalars['String']['input'];
  /** Added to stored spreadsheet row numbers so a chunk of a larger file still cites the original row. */
  rowNumberOffset?: InputMaybe<Scalars['Int']['input']>;
  rows: Array<ImportCrmRowInput>;
};

export type ImportCrmFieldValueInput = {
  /** The custom field key. */
  key: Scalars['String']['input'];
  /** The cell as written in the file. */
  value: Scalars['String']['input'];
};

export type ImportCrmRowInput = {
  companyDescription?: InputMaybe<Scalars['String']['input']>;
  companyDomain?: InputMaybe<Scalars['String']['input']>;
  companyEmail?: InputMaybe<Scalars['String']['input']>;
  /** Custom-field cells for the company. Fills only fields the company has no value for; a value that does not fit its field is reported on the batch and the row still imports. */
  companyFields?: InputMaybe<Array<ImportCrmFieldValueInput>>;
  companyIndustry?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactFirstName?: InputMaybe<Scalars['String']['input']>;
  /** Comma-separated contact labels. */
  contactLabels?: InputMaybe<Scalars['String']['input']>;
  contactLastName?: InputMaybe<Scalars['String']['input']>;
  contactNotes?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
};

export type ImportError = {
  __typename?: 'ImportError';
  /** ID of the existing invoice when error is a duplicate */
  existingInvoiceId?: Maybe<Scalars['String']['output']>;
  /** The problematic field */
  field?: Maybe<Scalars['String']['output']>;
  /** Error message */
  message: Scalars['String']['output'];
  /** Row number in the original file */
  rowNumber: Scalars['Int']['output'];
  /** The problematic value */
  value?: Maybe<Scalars['String']['output']>;
};

export type ImportExchangeRate = {
  /** Currency code (e.g., QAR, USD) */
  currency: Scalars['String']['input'];
  /** Date for the rate (YYYY-MM-DD), null for current */
  date?: InputMaybe<Scalars['String']['input']>;
  /** Exchange rate to reporting currency */
  rate: Scalars['Float']['input'];
};

export type ImportMarkedDocumentsResult = {
  __typename?: 'ImportMarkedDocumentsResult';
  /** Not marked Invoice/Credit note, not stored yet, or not a PDF/image. */
  skipped: Scalars['Int']['output'];
  staged: Scalars['Int']['output'];
  /** The import job the staged files are in, for the review link. */
  syncJobId?: Maybe<Scalars['ID']['output']>;
};

export type ImportMatchTelemetry = {
  __typename?: 'ImportMatchTelemetry';
  /** New clients flagged as potential duplicates of an existing client (need review) */
  flaggedPotentialDuplicates: Scalars['Int']['output'];
  /** Rows linked to an existing client by a learned alias (from a merge or reviewer correction) */
  matchedByAlias: Scalars['Int']['output'];
  /** Rows linked to an existing client by Google Drive folder */
  matchedByDriveFolder: Scalars['Int']['output'];
  /** Rows linked to an existing client by contact email */
  matchedByEmail: Scalars['Int']['output'];
  /** Rows linked to an existing client by external id */
  matchedByExternalId: Scalars['Int']['output'];
  /** Rows linked to an existing client by fuzzy name match */
  matchedByFuzzy: Scalars['Int']['output'];
  /** Rows linked to an existing client by exact name */
  matchedByName: Scalars['Int']['output'];
  /** Rows linked to an existing client by invoice prefix */
  matchedByPrefix: Scalars['Int']['output'];
  /** Rows that created a new client (no existing match) */
  newClients: Scalars['Int']['output'];
  /** Subscriptions matched to a product (bundle/module) */
  subscriptionsProductMatched: Scalars['Int']['output'];
  /** Subscriptions with no product match */
  subscriptionsProductUnmatched: Scalars['Int']['output'];
};

export type ImportOrganizationAnalysis = {
  __typename?: 'ImportOrganizationAnalysis';
  /** Number of existing organizations to update */
  existingCount: Scalars['Int']['output'];
  /** Number of new organizations to create */
  newCount: Scalars['Int']['output'];
  /** Names of new organizations */
  newOrganizationNames: Array<Scalars['String']['output']>;
  /** Names of organizations that may be duplicates */
  potentialDuplicateNames: Array<Scalars['String']['output']>;
  /** Number of potential duplicate organizations */
  potentialDuplicatesCount: Scalars['Int']['output'];
};

export type ImportProductMatchAnalysis = {
  __typename?: 'ImportProductMatchAnalysis';
  /** Average confidence of AI matches */
  avgConfidence: Scalars['Float']['output'];
  /** Number of transactions with explicit product assignment */
  explicitCount: Scalars['Int']['output'];
  /** Number of transactions matched to a product */
  matchedCount: Scalars['Int']['output'];
  /** Product match suggestions (up to 20) */
  suggestions: Array<ImportProductMatchSuggestion>;
  /** Number of transactions with no product match */
  unmatchedCount: Scalars['Int']['output'];
};

export type ImportProductMatchSuggestion = {
  __typename?: 'ImportProductMatchSuggestion';
  /** Suggested bundle ID */
  bundleId?: Maybe<Scalars['String']['output']>;
  /** Suggested bundle name */
  bundleName?: Maybe<Scalars['String']['output']>;
  /** Confidence score (0-1) */
  confidence: Scalars['Float']['output'];
  /** Transaction description */
  description?: Maybe<Scalars['String']['output']>;
  /** Whether a product match was found */
  matched: Scalars['Boolean']['output'];
  /** Suggested module IDs */
  moduleIds: Array<Scalars['String']['output']>;
  /** Suggested module names */
  moduleNames: Array<Scalars['String']['output']>;
  /** Organization name */
  organizationName?: Maybe<Scalars['String']['output']>;
  /** AI reasoning for the match */
  reasoning: Scalars['String']['output'];
  /** Row number in the import file (1-based) */
  rowNumber: Scalars['Int']['output'];
};

export type ImportRevenueAnalysis = {
  __typename?: 'ImportRevenueAnalysis';
  /** Estimated ARR impact (annualized revenue) */
  estimatedARRImpact: Scalars['Float']['output'];
  /** Estimated MRR impact (monthly revenue) */
  estimatedMRRImpact: Scalars['Float']['output'];
  /** Primary currency of imported transactions */
  primaryCurrency: Scalars['String']['output'];
  /** Total value of transactions being imported */
  totalImportValue: Scalars['Float']['output'];
};

export type ImportSubscriptionAnalysis = {
  __typename?: 'ImportSubscriptionAnalysis';
  /** Number of subscriptions that will be ACTIVE (end date in future) */
  activeCount: Scalars['Int']['output'];
  /** Average extension in days (for extended subs) */
  avgExtensionDays: Scalars['Float']['output'];
  /** Number of subscriptions that will be EXPIRED (end date in past) */
  expiredCount: Scalars['Int']['output'];
  /** Number of existing subscriptions to extend */
  extendCount: Scalars['Int']['output'];
  /** Number inferred as monthly */
  monthlyCount: Scalars['Int']['output'];
  /** Number of new subscriptions to create */
  newCount: Scalars['Int']['output'];
  /** Number inferred as quarterly */
  quarterlyCount: Scalars['Int']['output'];
  /** Number inferred as yearly */
  yearlyCount: Scalars['Int']['output'];
};

export type ImportSubscriptionsInput = {
  /** Bundle ID to associate with imported subscriptions (optional) */
  bundleId?: InputMaybe<Scalars['String']['input']>;
  /** Default region ID to apply to all imported subscriptions (optional) */
  defaultRegionId?: InputMaybe<Scalars['String']['input']>;
  /** Exchange rates for currency conversion (currency-date pairs) */
  exchangeRates?: InputMaybe<Array<ImportExchangeRate>>;
  /** Generate renewal subscriptions for non-churned organizations up to current date */
  generateRenewals?: InputMaybe<Scalars['Boolean']['input']>;
  /** Module IDs to associate with imported subscriptions (optional) */
  moduleIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Reporting currency to convert all amounts to */
  reportingCurrency?: InputMaybe<Scalars['String']['input']>;
  /** Array of subscriptions to import */
  subscriptions: Array<SubscriptionImportItem>;
  /** Use invoice prefix as organization identifier instead of name */
  useInvoicePrefixAsIdentifier?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImportSubscriptionsPreview = {
  __typename?: 'ImportSubscriptionsPreview';
  /** Number of initial (acquisition) subscriptions */
  acquisitionCount: Scalars['Int']['output'];
  /** Number of churned organizations (no renewals generated) */
  churnedCount: Scalars['Int']['output'];
  /** Number of existing organizations found */
  existingOrganizationsCount: Scalars['Int']['output'];
  /** Number of new organizations to create */
  newOrganizationsCount: Scalars['Int']['output'];
  /** Number of renewal subscriptions to generate */
  renewalCount: Scalars['Int']['output'];
  /** Preview of first 50 subscriptions to be created */
  sampleSubscriptions: Array<GeneratedSubscriptionPreview>;
  /** Number of source rows processed */
  sourceRowCount: Scalars['Int']['output'];
  /** Total subscriptions that will be created (including renewals) */
  totalSubscriptionsCount: Scalars['Int']['output'];
};

export type ImportSubscriptionsResult = {
  __typename?: 'ImportSubscriptionsResult';
  /** Bundle ID applied (if any) */
  appliedBundleId?: Maybe<Scalars['String']['output']>;
  /** Module IDs applied (if any) */
  appliedModuleIds?: Maybe<Array<Scalars['String']['output']>>;
  /** IDs of created organizations */
  createdOrganizationIds: Array<Scalars['String']['output']>;
  /** IDs of created subscriptions */
  createdSubscriptionIds: Array<Scalars['String']['output']>;
  /** Details of any errors */
  errors: Array<Scalars['String']['output']>;
  /** Number of source rows that failed */
  failureCount: Scalars['Int']['output'];
  /** Id of the import batch this run recorded — pass to rollbackImportBatch to undo it */
  importBatchId?: Maybe<Scalars['String']['output']>;
  /** Number of renewal subscriptions generated */
  renewalsGenerated: Scalars['Int']['output'];
  /** Number of source rows successfully processed */
  successCount: Scalars['Int']['output'];
  /** Total source rows processed */
  totalProcessed: Scalars['Int']['output'];
  /** Total subscriptions created (including renewals) */
  totalSubscriptionsCreated: Scalars['Int']['output'];
};

export type ImportTaxReferenceRatesInput = {
  /** When the drafts take effect. Defaults to the start of today (UTC). */
  effectiveFrom?: InputMaybe<Scalars['DateTime']['input']>;
  /** Layer keys from the reference rates, e.g. CA-ON-HST. */
  keys: Array<Scalars['String']['input']>;
};

export type ImportTransactionsInput = {
  /** Bundle ID to associate with imported subscriptions (optional) */
  bundleId?: InputMaybe<Scalars['String']['input']>;
  /** Default region ID to apply to all imported subscriptions (optional) */
  defaultRegionId?: InputMaybe<Scalars['String']['input']>;
  /** Module IDs to associate with imported subscriptions (optional) */
  moduleIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Array of transactions to import */
  transactions: Array<TransactionImportItem>;
  /** Use invoice prefix (from invoiceNumber or invoicePrefix field) as organization identifier instead of name */
  useInvoicePrefixAsIdentifier?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImportTransactionsResult = {
  __typename?: 'ImportTransactionsResult';
  /** Bundle ID applied to subscriptions (if any) */
  appliedBundleId?: Maybe<Scalars['String']['output']>;
  /** Module IDs applied to subscriptions (if any) */
  appliedModuleIds?: Maybe<Array<Scalars['String']['output']>>;
  /** IDs of created invoices */
  createdInvoiceIds: Array<Scalars['String']['output']>;
  /** IDs of created organizations */
  createdOrganizationIds: Array<Scalars['String']['output']>;
  /** IDs of newly created subscriptions */
  createdSubscriptionIds: Array<Scalars['String']['output']>;
  /** Number of invoices with data discrepancies */
  discrepancyCount: Scalars['Int']['output'];
  /** IDs of created discrepancy records */
  discrepancyIds: Array<Scalars['String']['output']>;
  /** Details of any errors */
  errors: Array<ImportError>;
  /** Number of transactions that failed */
  failureCount: Scalars['Int']['output'];
  /** Rows auto-linked to an existing client by fuzzy name match, formatted "imported name -> matched client" (for user review) */
  fuzzyMatchedOrganizations?: Maybe<Array<Scalars['String']['output']>>;
  /** Id of the import batch this run recorded — pass to rollbackImportBatch to undo it */
  importBatchId?: Maybe<Scalars['String']['output']>;
  /** Per-signal client-match breakdown and headline match rates for this import */
  matchTelemetry?: Maybe<ImportMatchTelemetry>;
  /** Organization names that were matched by name instead of invoice prefix (for user review) */
  nameMatchedOrganizations?: Maybe<Array<Scalars['String']['output']>>;
  /** Invoices already in Revvly that this import marked paid (or part paid) from the payment date on their row */
  paymentsRecordedCount?: Maybe<Scalars['Int']['output']>;
  /** Clients created despite a similarly-named existing client, formatted "created name ~ similar existing client". Each created client carries potentialDuplicateOfId for reviewer confirmation. */
  potentialDuplicateOrganizations?: Maybe<Array<Scalars['String']['output']>>;
  /** Number of subscriptions matched to a product by AI */
  productMatchedCount?: Maybe<Scalars['Int']['output']>;
  /** Number of subscriptions that could not be matched to a product */
  productUnmatchedCount?: Maybe<Scalars['Int']['output']>;
  /** Number of rows that fell back to name-based matching because invoice number was missing or had no extractable prefix */
  rowsMatchedByNameFallback?: Maybe<Scalars['Int']['output']>;
  /** Number of subscriptions with extended end dates */
  subscriptionDatesExtended: Scalars['Int']['output'];
  /** Number of transactions successfully imported */
  successCount: Scalars['Int']['output'];
  /** Total number processed */
  totalProcessed: Scalars['Int']['output'];
  /** IDs of subscriptions that had dates extended */
  updatedSubscriptionIds: Array<Scalars['String']['output']>;
};

export type ImportedInvoiceFilterInput = {
  /** Only invoices created by this import run */
  batchId?: InputMaybe<Scalars['ID']['input']>;
  /** Invoice date on or after */
  invoiceDateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  /** Invoice date on or before */
  invoiceDateTo?: InputMaybe<Scalars['DateTime']['input']>;
  /** Only invoices with no payment date recorded */
  missingPaymentDate?: InputMaybe<Scalars['Boolean']['input']>;
  paymentStatuses?: InputMaybe<Array<PaymentStatus>>;
  source?: InputMaybe<InvoiceSource>;
};

export type ImportedInvoicePage = {
  __typename?: 'ImportedInvoicePage';
  items: Array<ImportedInvoiceRow>;
  /** Invoices matching the filter, across all pages */
  totalCount: Scalars['Int']['output'];
};

export type ImportedInvoiceRow = {
  __typename?: 'ImportedInvoiceRow';
  actualPaymentDate?: Maybe<Scalars['DateTime']['output']>;
  amount: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  importBatchId?: Maybe<Scalars['ID']['output']>;
  invoiceDate?: Maybe<Scalars['DateTime']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['String']['output'];
  organizationName?: Maybe<Scalars['String']['output']>;
  paymentStatus?: Maybe<PaymentStatus>;
  source?: Maybe<InvoiceSource>;
  subscriptionId?: Maybe<Scalars['ID']['output']>;
};

/** One automatic action the inbox took, with what is needed to undo it. */
export type InboxActionLogEntry = {
  __typename?: 'InboxActionLogEntry';
  action: InboxPolicyAction;
  afterDays: Scalars['Int']['output'];
  at: Scalars['DateTime']['output'];
  /** Whether Undo is still on offer: nothing has changed on the thread since. */
  canUndo: Scalars['Boolean']['output'];
  category: InboxCategory;
  /** Why it failed, when it did. */
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inboxItemId: Scalars['ID']['output'];
  sender?: Maybe<Scalars['String']['output']>;
  status: InboxActionStatus;
  subject?: Maybe<Scalars['String']['output']>;
  undoneAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum InboxActionStatus {
  Applied = 'APPLIED',
  Failed = 'FAILED',
  Undone = 'UNDONE',
}

export type InboxBulkDoneResult = {
  __typename?: 'InboxBulkDoneResult';
  /** Pass to the next call to carry on past every thread this one tried. */
  cursor?: Maybe<Scalars['String']['output']>;
  done: Scalars['Int']['output'];
  failed: Scalars['Int']['output'];
  /** More threads remain; call again to close the next batch. */
  more: Scalars['Boolean']['output'];
  /** Open threads the category still holds: refused by Gmail, or with new mail behind the walk. Start again (no cursor) to try them. */
  remaining: Scalars['Int']['output'];
};

export enum InboxCategory {
  Bills = 'BILLS',
  Calendar = 'CALENDAR',
  Client = 'CLIENT',
  Hr = 'HR',
  Legal = 'LEGAL',
  Newsletters = 'NEWSLETTERS',
  NewContact = 'NEW_CONTACT',
  Payments = 'PAYMENTS',
  Personal = 'PERSONAL',
  Promotions = 'PROMOTIONS',
  Prospect = 'PROSPECT',
  Receivables = 'RECEIVABLES',
  Security = 'SECURITY',
  Team = 'TEAM',
  Tools = 'TOOLS',
  Unsorted = 'UNSORTED',
}

export type InboxCategoryCount = {
  __typename?: 'InboxCategoryCount';
  category: InboxCategory;
  open: Scalars['Int']['output'];
  unread: Scalars['Int']['output'];
};

export type InboxCategoryPlacement = {
  __typename?: 'InboxCategoryPlacement';
  category: InboxCategory;
  /** False when the caller changed it from the default. */
  isDefault: Scalars['Boolean']['output'];
  placement: InboxPlacement;
};

export type InboxCategoryPlacementInput = {
  category: InboxCategory;
  placement: InboxPlacement;
};

/** What the inbox does on its own with one category, for the caller. */
export type InboxCategoryPolicy = {
  __typename?: 'InboxCategoryPolicy';
  action: InboxPolicyAction;
  /** Days since the latest inbound message before it applies. */
  afterDays: Scalars['Int']['output'];
  category: InboxCategory;
  enabled: Scalars['Boolean']['output'];
  /** Skip threads still unread (archive and move only). */
  leaveUnread: Scalars['Boolean']['output'];
};

export enum InboxCategorySource {
  LearnedProfile = 'LEARNED_PROFILE',
  Lexical = 'LEXICAL',
  Model = 'MODEL',
  Neighbours = 'NEIGHBOURS',
  Rule = 'RULE',
  User = 'USER',
  UserRule = 'USER_RULE',
}

export type InboxCounts = {
  __typename?: 'InboxCounts';
  byCategory: Array<InboxCategoryCount>;
  needsReply: Scalars['Int']['output'];
  other: Scalars['Int']['output'];
  primary: Scalars['Int']['output'];
  snoozed: Scalars['Int']['output'];
  unreadPrimary: Scalars['Int']['output'];
  /** Open Unsorted threads as a share of all open threads, 0-1. The Inbox’s headline accuracy metric. */
  unsortedShare: Scalars['Float']['output'];
};

/** Something the caller’s inbox learned about a sender (PRD §4.4). */
export type InboxLearnedSender = {
  __typename?: 'InboxLearnedSender';
  category?: Maybe<InboxCategory>;
  id: Scalars['ID']['output'];
  kind: InboxLearnedSenderKind;
  /** The caller undid a demotion: this sender is never demoted again. */
  pinned: Scalars['Boolean']['output'];
  placement?: Maybe<InboxPlacement>;
  /** The sender’s address, or the domain for a domain-wide profile. */
  sender: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum InboxLearnedSenderKind {
  Address = 'ADDRESS',
  Domain = 'DOMAIN',
}

/** A message of an inbox thread, read live from the mailbox. */
export type InboxMessage = {
  __typename?: 'InboxMessage';
  attachments: Array<InboxMessageAttachment>;
  /** Sanitized HTML. */
  bodyHtml?: Maybe<Scalars['String']['output']>;
  bodyPlain: Scalars['String']['output'];
  cc: Array<Scalars['String']['output']>;
  direction: Scalars['String']['output'];
  from?: Maybe<Scalars['String']['output']>;
  fromName?: Maybe<Scalars['String']['output']>;
  /** The mailbox service id of the message. */
  id: Scalars['ID']['output'];
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  to: Array<Scalars['String']['output']>;
};

export type InboxMessageAttachment = {
  __typename?: 'InboxMessageAttachment';
  fileName: Scalars['String']['output'];
  fileSize?: Maybe<Scalars['Int']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  storagePath: Scalars['String']['output'];
};

/** What to ask the person after a move (Smart Classification, Learning). */
export type InboxMoveFollowUp = {
  __typename?: 'InboxMoveFollowUp';
  /** Whether "whole domain" can be offered (never for a freemail domain). */
  canUseDomain: Scalars['Boolean']['output'];
  /** CONFLICT: the category the sender is currently filed under. */
  currentCategory?: Maybe<InboxCategory>;
  /** The sender’s domain, when a whole-domain rule is offered. */
  domain?: Maybe<Scalars['String']['output']>;
  kind: InboxMoveFollowUpKind;
};

export enum InboxMoveFollowUpKind {
  Conflict = 'CONFLICT',
  None = 'NONE',
  OfferRule = 'OFFER_RULE',
}

export type InboxMoveResult = {
  __typename?: 'InboxMoveResult';
  followUp: InboxMoveFollowUp;
  thread: InboxThread;
};

export enum InboxPlacement {
  Other = 'OTHER',
  Primary = 'PRIMARY',
  Skip = 'SKIP',
}

export enum InboxPolicyAction {
  AgingAlert = 'AGING_ALERT',
  Archive = 'ARCHIVE',
  DraftReply = 'DRAFT_REPLY',
  MarkRead = 'MARK_READ',
  MoveToOther = 'MOVE_TO_OTHER',
}

/** A reply the inbox wrote for the caller to review. Never sent by the inbox. */
export type InboxReplyDraft = {
  __typename?: 'InboxReplyDraft';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  inboxItemId: Scalars['ID']['output'];
  /** The drafted reply, plain text. Placeholders like [date] mark what the inbox could not know. */
  text: Scalars['String']['output'];
};

export type InboxReplyInput = {
  attachmentFileIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  bcc?: InputMaybe<Array<EmailRecipientInput>>;
  body: Scalars['String']['input'];
  cc?: InputMaybe<Array<EmailRecipientInput>>;
  includeSignature?: InputMaybe<Scalars['Boolean']['input']>;
  signatureId?: InputMaybe<Scalars['ID']['input']>;
  subject: Scalars['String']['input'];
  to: Array<EmailRecipientInput>;
};

/** One of the caller’s own rules. */
export type InboxRule = {
  __typename?: 'InboxRule';
  category: InboxCategory;
  createdAt: Scalars['DateTime']['output'];
  /** The rule as a sentence. */
  description: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  field: InboxRuleField;
  /** Threads this rule has filed. */
  filed: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
};

export enum InboxRuleField {
  OwnDomain = 'OWN_DOMAIN',
  SenderAddress = 'SENDER_ADDRESS',
  SenderDomain = 'SENDER_DOMAIN',
  SubjectContains = 'SUBJECT_CONTAINS',
}

/** A plain-language rule read into the structured form the person confirms. */
export type InboxRulePreview = {
  __typename?: 'InboxRulePreview';
  category?: Maybe<InboxCategory>;
  /** The rule as one sentence, to confirm. */
  description?: Maybe<Scalars['String']['output']>;
  field?: Maybe<InboxRuleField>;
  /** Why the sentence was not understood, with examples. */
  message?: Maybe<Scalars['String']['output']>;
  /** False when the sentence was not understood; see `message`. */
  ok: Scalars['Boolean']['output'];
  /** The domain, address or subject words; empty for the own-domain rule. */
  value?: Maybe<Scalars['String']['output']>;
};

export enum InboxRuleScope {
  Address = 'ADDRESS',
  Domain = 'DOMAIN',
}

export type InboxSenderRuleResult = {
  __typename?: 'InboxSenderRuleResult';
  /** Other threads re-filed by the new rule. */
  refiled: Scalars['Int']['output'];
  thread: InboxThread;
};

/** The caller’s own inbox settings (PRD §5.6). */
export type InboxSettings = {
  __typename?: 'InboxSettings';
  /** Mail filed with less confidence than this goes to Unsorted instead of a guess. 0 is off. */
  confidenceThreshold: Scalars['Float']['output'];
  dailyDigest: Scalars['Boolean']['output'];
  /** Hour of the digest, 0-23, in the caller’s own timezone. */
  digestHour: Scalars['Int']['output'];
  /** Apply Revvly/<Category> labels in Gmail. Stored only for now: labels are not yet written to Gmail. */
  gmailCategoryLabels: Scalars['Boolean']['output'];
  placements: Array<InboxCategoryPlacement>;
  /** The caller asked the inbox to write reply drafts for them. Each draft uses AI credits; off until switched on. */
  replyDrafts: Scalars['Boolean']['output'];
};

export enum InboxTab {
  Done = 'DONE',
  NeedsReply = 'NEEDS_REPLY',
  Other = 'OTHER',
  Primary = 'PRIMARY',
  Snoozed = 'SNOOZED',
}

/** One thread in the caller’s own inbox. */
export type InboxThread = {
  __typename?: 'InboxThread';
  /** In the Needs-reply tab: a person wrote last, expects an answer, and nobody has replied. */
  awaitingReply: Scalars['Boolean']['output'];
  /** The latest message offers one-click unsubscribe (RFC 8058). */
  canUnsubscribe: Scalars['Boolean']['output'];
  candidates: Array<InboxCategory>;
  category: InboxCategory;
  categorySource: InboxCategorySource;
  confidence: Scalars['Float']['output'];
  /** The shared synced-mail thread. */
  emailThreadId: Scalars['ID']['output'];
  hasInvoice: Scalars['Boolean']['output'];
  hasMeeting: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  invoiceNumbers: Array<Scalars['String']['output']>;
  lastInboundAt?: Maybe<Scalars['DateTime']['output']>;
  lastMessageAt: Scalars['DateTime']['output'];
  mailboxId: Scalars['String']['output'];
  messageCount: Scalars['Int']['output'];
  /** Whether the latest inbound message expects an answer; null when nothing judged it. */
  needsReply?: Maybe<Scalars['Boolean']['output']>;
  organizationId?: Maybe<Scalars['ID']['output']>;
  placement: InboxPlacement;
  providerThreadId: Scalars['String']['output'];
  /** One-line reason shown under the subject (PRD §5.3). */
  reason: Scalars['String']['output'];
  senderAddress?: Maybe<Scalars['String']['output']>;
  senderDomain?: Maybe<Scalars['String']['output']>;
  /** The sender writes from a free mailbox (Gmail, Outlook…): its domain names no company, so it is never offered as one. */
  senderIsFreemail: Scalars['Boolean']['output'];
  /** Why the thread is in its category, as stable signal ids. */
  signals: Array<Scalars['String']['output']>;
  snippet?: Maybe<Scalars['String']['output']>;
  /** When a snoozed thread comes back. */
  snoozedUntil?: Maybe<Scalars['DateTime']['output']>;
  starred: Scalars['Boolean']['output'];
  state: InboxThreadState;
  subject?: Maybe<Scalars['String']['output']>;
  unread: Scalars['Boolean']['output'];
};

/** An invoice of this workspace that an inbox thread mentions. */
export type InboxThreadInvoice = {
  __typename?: 'InboxThreadInvoice';
  amount?: Maybe<Scalars['Float']['output']>;
  amountPaid?: Maybe<Scalars['Float']['output']>;
  currency: Scalars['String']['output'];
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  invoiceNumber: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
  paymentStatus?: Maybe<Scalars['String']['output']>;
};

export type InboxThreadPage = {
  __typename?: 'InboxThreadPage';
  hasMore: Scalars['Boolean']['output'];
  items: Array<InboxThread>;
  /** Pass back as `before` for the next page. */
  nextCursor?: Maybe<Scalars['String']['output']>;
};

export enum InboxThreadState {
  Done = 'DONE',
  Open = 'OPEN',
  Snoozed = 'SNOOZED',
}

export type InboxThreadsInput = {
  before?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<InboxCategory>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  tab: InboxTab;
};

/** One sender’s open Unsorted threads: decide once to clear them all. */
export type InboxUnsortedGroup = {
  __typename?: 'InboxUnsortedGroup';
  /** False when the sender could not be read: only this thread can be filed. */
  canTeachSender: Scalars['Boolean']['output'];
  canUseDomain: Scalars['Boolean']['output'];
  /** Unsorted threads across the sender’s whole domain. */
  domainThreadCount: Scalars['Int']['output'];
  lastMessageAt: Scalars['DateTime']['output'];
  /** What was missing, so the person knows why it is here. */
  reason: Scalars['String']['output'];
  /** A thread of the group; pass it back to file the group. */
  sampleThreadId: Scalars['ID']['output'];
  sender?: Maybe<Scalars['String']['output']>;
  senderDomain?: Maybe<Scalars['String']['output']>;
  /** The Inbox’s best guess, accepted in one tap. */
  suggestedCategory?: Maybe<InboxCategory>;
  threadCount: Scalars['Int']['output'];
};

export type IncludedGmvInput = {
  /** Free GMV in this currency before commission applies. */
  amount: Scalars['Float']['input'];
  /** ISO 4217 currency code. */
  currency: Scalars['String']['input'];
};

/** Per-term inclusion override on a plan component reference. */
export type InclusionPeriodEntry = {
  __typename?: 'InclusionPeriodEntry';
  includedQuantity?: Maybe<Scalars['Int']['output']>;
  includedTransactionCount?: Maybe<Scalars['Int']['output']>;
  period: SubscriptionPeriod;
  /** Optional market (Region id). null = applies to every region. A specific region lets the same term include a different quantity per market; resolution prefers the (period, region) entry, then the region-agnostic one, then the ref-level defaults. */
  regionId?: Maybe<Scalars['ID']['output']>;
};

export type InclusionPeriodInput = {
  includedQuantity?: InputMaybe<Scalars['Int']['input']>;
  includedTransactionCount?: InputMaybe<Scalars['Int']['input']>;
  period: SubscriptionPeriod;
  /** Optional market (Region id). null = applies to every region. Lets the same term include a different quantity per market (e.g. USD-USA vs USD-LatAm). */
  regionId?: InputMaybe<Scalars['ID']['input']>;
};

export type Incubator = {
  __typename?: 'Incubator';
  active: Scalars['Boolean']['output'];
  address?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  customDomain?: Maybe<Scalars['String']['output']>;
  defaultLanguage: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  domainUrl: Scalars['String']['output'];
  /** List of features that can be activated by Plan selected */
  featureFlags: FeatureFlags;
  /** Email of contact (Principal) */
  generalEmail: GeneralEmail;
  gtmId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** Incubators Plan Information */
  planInfo?: Maybe<PlanInfo>;
  slug: Scalars['String']['output'];
  /** Email of Support */
  supportEmail?: Maybe<Email>;
  updatedAt: Scalars['String']['output'];
  /** Roles of the users for permission on events */
  userRolesEventsPermission: Array<Scalars['String']['output']>;
};

export type IncubatorFlag = {
  __typename?: 'IncubatorFlag';
  active: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type IncubatorFlagInput = {
  active: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type IncubatorFlags = {
  __typename?: 'IncubatorFlags';
  flags: Array<IncubatorFlag>;
  id: Scalars['String']['output'];
};

export type IncubatorSummary = {
  __typename?: 'IncubatorSummary';
  featureFlags: FeatureFlags;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type InitialDiscountInput = {
  /** Library discount definition to apply. When set, type/value/duration are taken from the definition (snapshotted) and the one-off fields are ignored; omit for a one-off discount. */
  definitionId?: InputMaybe<Scalars['ID']['input']>;
  /** Required if durationType is FIXED_COUNT */
  durationCount?: InputMaybe<Scalars['Int']['input']>;
  /** Duration type: FIRST_ONLY, FIXED_COUNT, or FOREVER. Required for a one-off; ignored when definitionId is set. */
  durationType?: InputMaybe<Scalars['String']['input']>;
  /** Optional calendar end (FR-28). The discount stops applying to invoices billing service on or after this date, independently of its renewal-count duration — whichever runs out first ends it. Omit for no calendar bound. Same field as ApplyDiscountInput.endsAt: the two authoring paths must be able to express the same discount, or a term agreed at signing has to be re-entered by hand afterwards. */
  endsAt?: InputMaybe<Scalars['String']['input']>;
  /** For a FIXED discount on a COMPONENT: PER_UNIT (default — amount off each unit) or FLAT_LUMP_SUM (one amount off the whole line). Ignored for percentage/base-price discounts. */
  fixedMode?: InputMaybe<FixedDiscountMode>;
  /** For a COMPONENT discount: discount at most this many of the billed units (e.g. 3 of 15 seats). Omit to discount every unit. */
  maxQuantity?: InputMaybe<Scalars['Float']['input']>;
  /** Optional discount name for tracking/display */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Component ID if targeting a component discount. Required when targetElementType is COMPONENT. */
  targetComponentId?: InputMaybe<Scalars['String']['input']>;
  /** Target for the discount: BASE_PRICE (default), COMPONENT, or INVOICE (the whole invoice) */
  targetElementType?: InputMaybe<Scalars['String']['input']>;
  /** Discount type: PERCENTAGE or FIXED. Required for a one-off; ignored when definitionId is set. */
  type?: InputMaybe<Scalars['String']['input']>;
  /** Discount value (percentage or fixed amount). Required for a one-off; ignored when definitionId is set. */
  value?: InputMaybe<Scalars['Float']['input']>;
};

/** Where the Intercom workspace is hosted: api.intercom.io, EU or AU. */
export enum IntercomRegion {
  Au = 'AU',
  Eu = 'EU',
  Us = 'US',
}

/** A Slack account that could be invited to Revvly */
export type InvitableSlackMember = {
  __typename?: 'InvitableSlackMember';
  displayName: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  /** A single-channel or restricted guest of the workspace */
  isGuest: Scalars['Boolean']['output'];
  slackUserId: Scalars['String']['output'];
};

/** The Slack accounts an admin may invite, and what was left out */
export type InvitableSlackMembers = {
  __typename?: 'InvitableSlackMembers';
  excluded: InviteExclusions;
  members: Array<InvitableSlackMember>;
};

/** A person named in an approval request */
export type InviteApprovalInvitee = {
  __typename?: 'InviteApprovalInvitee';
  displayName: Scalars['String']['output'];
  slackUserId: Scalars['String']['output'];
};

/** An admin asking an owner to send some invitations */
export type InviteApprovalRequest = {
  __typename?: 'InviteApprovalRequest';
  createdAt: Scalars['DateTime']['output'];
  decidedAt?: Maybe<Scalars['DateTime']['output']>;
  decidedByName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invitees: Array<InviteApprovalInvitee>;
  quotedCount: Scalars['Int']['output'];
  quotedCurrency: Scalars['String']['output'];
  quotedMonthlyCeiling: Scalars['Float']['output'];
  quotedUnitAmount: Scalars['Float']['output'];
  requestedByName?: Maybe<Scalars['String']['output']>;
  requestedByUserId: Scalars['String']['output'];
  status: InviteApprovalStatus;
};

export enum InviteApprovalStatus {
  Approved = 'APPROVED',
  Declined = 'DECLINED',
  Pending = 'PENDING',
}

/** What the invite list left out, and why */
export type InviteExclusions = {
  __typename?: 'InviteExclusions';
  bots: Scalars['Int']['output'];
  deactivated: Scalars['Int']['output'];
  /** Slack Connect people and members of other workspaces */
  external: Scalars['Int']['output'];
  /** Guests, counted only while "Include guests" is off */
  guests: Scalars['Int']['output'];
};

export type InviteUserToTenantInput = {
  email: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};

export type InvoiceAttachment = {
  __typename?: 'InvoiceAttachment';
  fileName: Scalars['String']['output'];
  fileSize?: Maybe<Scalars['Float']['output']>;
  fileUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mimeType?: Maybe<Scalars['String']['output']>;
  storageKey?: Maybe<Scalars['String']['output']>;
  uploadedAt: Scalars['DateTime']['output'];
  uploadedBy?: Maybe<Scalars['String']['output']>;
};

export type InvoiceAttachmentInput = {
  fileName: Scalars['String']['input'];
  fileSize?: InputMaybe<Scalars['Float']['input']>;
  fileUrl: Scalars['String']['input'];
  mimeType?: InputMaybe<Scalars['String']['input']>;
};

export type InvoiceCashFlowWeek = {
  __typename?: 'InvoiceCashFlowWeek';
  collectedAmount: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  expectedAmount: Scalars['Float']['output'];
  invoiceCount: Scalars['Int']['output'];
  weekEndDate: Scalars['DateTime']['output'];
  weekStartDate: Scalars['DateTime']['output'];
};

export type InvoiceChargeAttemptView = {
  __typename?: 'InvoiceChargeAttemptView';
  at: Scalars['DateTime']['output'];
  declineCode?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  outcome: Scalars['String']['output'];
};

/** The charge of one invoice to the client’s card. */
export type InvoiceChargeView = {
  __typename?: 'InvoiceChargeView';
  attempts: Scalars['Int']['output'];
  history: Array<InvoiceChargeAttemptView>;
  id: Scalars['ID']['output'];
  lastError?: Maybe<Scalars['String']['output']>;
  nextAttemptAt?: Maybe<Scalars['DateTime']['output']>;
  paymentIntentId?: Maybe<Scalars['String']['output']>;
  /** PENDING, PROCESSING, AWAITING_SETTLEMENT, ACTION_REQUIRED, SUCCEEDED, ABANDONED or SKIPPED. */
  status: Scalars['String']['output'];
};

export type InvoiceConnection = {
  __typename?: 'InvoiceConnection';
  edges: Array<InvoiceEdge>;
  filteredCount: Scalars['Int']['output'];
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** How a subscription's invoices are treated on delete: LEAVE keeps them, VOID marks them CANCELLED (kept for audit), DELETE permanently removes them (mistake correction). */
export enum InvoiceDeletionMode {
  Delete = 'DELETE',
  Leave = 'LEAVE',
  Void = 'VOID',
}

export type InvoiceDiscountInput = {
  /** Shown on the invoice. Defaults to "Discount". */
  name?: InputMaybe<Scalars['String']['input']>;
  type: DiscountType;
  /** Percent (0–100) or an amount in the invoice currency. 0 removes a discount added earlier. */
  value: Scalars['Float']['input'];
};

export type InvoiceDiscrepancyEntity = {
  __typename?: 'InvoiceDiscrepancyEntity';
  conflictingFields: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  invoice?: Maybe<DiscrepancyInvoiceEntity>;
  invoiceId: Scalars['ID']['output'];
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  resolution: DiscrepancyResolution;
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  resolvedBy?: Maybe<Scalars['String']['output']>;
  resolvedValues?: Maybe<Scalars['String']['output']>;
  source1Data: Scalars['String']['output'];
  source1Type: DiscrepancySourceType;
  source2Data: Scalars['String']['output'];
  source2Type: DiscrepancySourceType;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type InvoiceEdge = {
  __typename?: 'InvoiceEdge';
  cursor: Scalars['String']['output'];
  node: SubscriptionInvoice;
  /** Which field matched, when the list was searched */
  searchMatch?: Maybe<SearchMatchInfo>;
};

/** The identity an invoice email is sent from. */
export enum InvoiceEmailSender {
  AccountingMailbox = 'ACCOUNTING_MAILBOX',
  Platform = 'PLATFORM',
  UserMailbox = 'USER_MAILBOX',
}

export type InvoiceFilterInput = {
  /** Only invoices with an amount of at most this. */
  amountMax?: InputMaybe<Scalars['Float']['input']>;
  /** Only invoices with an amount of at least this. */
  amountMin?: InputMaybe<Scalars['Float']['input']>;
  /** Only invoices created by this user. */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  /** Only invoices whose created date is on or after this day (YYYY-MM-DD, UTC). */
  createdFrom?: InputMaybe<Scalars['String']['input']>;
  /** Only invoices whose created date is on or before this day (YYYY-MM-DD, UTC). */
  createdTo?: InputMaybe<Scalars['String']['input']>;
  /** Cursor for pagination (next or prev) */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /** Only invoices whose due date is on or after this day (YYYY-MM-DD, UTC). */
  dueFrom?: InputMaybe<Scalars['String']['input']>;
  /** Only invoices whose due date is on or before this day (YYYY-MM-DD, UTC). */
  dueTo?: InputMaybe<Scalars['String']['input']>;
  /** Leave out invoices of clients in these regions. Clients with no region are kept. */
  excludeRegionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Only invoices whose expected payment date is on or after this day (YYYY-MM-DD, UTC). */
  expectedFrom?: InputMaybe<Scalars['String']['input']>;
  /** Only invoices whose expected payment date is on or before this day (YYYY-MM-DD, UTC). */
  expectedTo?: InputMaybe<Scalars['String']['input']>;
  /** true: only invoices linked to a subscription. false: only invoices with none. */
  hasSubscription?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter to specific invoice IDs */
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Only invoices of clients in one of these regions (the client's region, not the invoice's currency). */
  includeRegionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Only invoices whose invoice date is on or after this day (YYYY-MM-DD, UTC). */
  invoiceDateFrom?: InputMaybe<Scalars['String']['input']>;
  /** Only invoices whose invoice date is on or before this day (YYYY-MM-DD, UTC). */
  invoiceDateTo?: InputMaybe<Scalars['String']['input']>;
  /** Filter by invoice type */
  invoiceType?: InputMaybe<InvoiceType>;
  /** Filter by unmatched status */
  isUnmatched?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by issue lifecycle (DRAFT = held awaiting usage / seal; ISSUED = normal). R7 Awaiting Usage chip. */
  issueState?: InputMaybe<InvoiceIssueState>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Filter by organization ID */
  organizationId?: InputMaybe<Scalars['String']['input']>;
  /** Filter by payment status */
  paymentStatus?: InputMaybe<PaymentStatus>;
  /** Search by invoice number or organization name */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Narrow `search` to these field groups; every field when empty */
  searchFields?: InputMaybe<Array<SearchField>>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrder>;
  /** Filter by subscription ID */
  subscriptionId?: InputMaybe<Scalars['String']['input']>;
};

/** Issuance state, independent of payment: DRAFT (created, not issued, no number or dates), ISSUED (number and dates stamped), VOID (abandoned; drafts are voided, never deleted). */
export enum InvoiceIssueState {
  Draft = 'DRAFT',
  Issued = 'ISSUED',
  Void = 'VOID',
}

export type InvoiceLineItem = {
  __typename?: 'InvoiceLineItem';
  description: Scalars['String']['output'];
  /** What this line represents. Null on lines written before the field existed and on imported invoices, where the original system’s intent is not knowable. */
  lineKind?: Maybe<InvoiceLineKind>;
  metadata?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Float']['output'];
  /** End of the service window this line bills */
  servicePeriodEnd?: Maybe<Scalars['DateTime']['output']>;
  /** Start of the service window this line bills */
  servicePeriodStart?: Maybe<Scalars['DateTime']['output']>;
  /** Tax classification, carried for a future tax pass. No tax is computed today. */
  taxCategory?: Maybe<Scalars['String']['output']>;
  totalAmount: Scalars['Decimal']['output'];
  unitPrice: Scalars['Decimal']['output'];
};

/** What an invoice line represents: a plan charge (BASE, or BASE_SPLIT for one share of one), metered usage (VARIABLE), an included-units display line (FREE_INCLUSION), a mid-cycle adjustment (PRORATION), a one-off charge (ONE_TIME_FEE), or a credit-note line (CREDIT). */
export enum InvoiceLineKind {
  Base = 'BASE',
  BaseSplit = 'BASE_SPLIT',
  Credit = 'CREDIT',
  FreeInclusion = 'FREE_INCLUSION',
  OneTimeFee = 'ONE_TIME_FEE',
  Proration = 'PRORATION',
  Variable = 'VARIABLE',
}

/** Commercial meaning of a line on an imported invoice */
export enum InvoiceLineType {
  BaseRecurring = 'BASE_RECURRING',
  Credit = 'CREDIT',
  Discount = 'DISCOUNT',
  Informational = 'INFORMATIONAL',
  OneTime = 'ONE_TIME',
  Tax = 'TAX',
  Unknown = 'UNKNOWN',
  Usage = 'USAGE',
}

/** A line type a reviewer taught: imported lines worded exactly like `phrase` are read as `lineType`, ahead of the extraction model and the keyword rules. */
export type InvoiceLineTypeRuleEntity = {
  __typename?: 'InvoiceLineTypeRuleEntity';
  id: Scalars['ID']['output'];
  lineType: InvoiceLineType;
  /** The line wording, as the reviewer saw it */
  phrase: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** A discount an operator added by hand to one unpaid invoice. */
export type InvoiceManualDiscount = {
  __typename?: 'InvoiceManualDiscount';
  appliedAt: Scalars['DateTime']['output'];
  name?: Maybe<Scalars['String']['output']>;
  type: DiscountType;
  /** Percent for PERCENTAGE, an amount in the invoice currency for FIXED. */
  value: Scalars['Float']['output'];
};

export type InvoicePayment = {
  __typename?: 'InvoicePayment';
  amount: Scalars['Decimal']['output'];
  currency: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  /** When the money moved, as reported by whoever recorded it. */
  paidAt: Scalars['DateTime']['output'];
  /** When Revvly recorded it. */
  recordedAt: Scalars['DateTime']['output'];
  /** The payer's reference — charge id, bank transaction id. */
  reference?: Maybe<Scalars['String']['output']>;
  source: InvoicePaymentSource;
};

/** Where a recorded payment came from — the inbound payment webhook, or an operator settling the invoice in Revvly. */
export enum InvoicePaymentSource {
  CreditNote = 'CREDIT_NOTE',
  Manual = 'MANUAL',
  Stripe = 'STRIPE',
  Webhook = 'WEBHOOK',
}

/** Status of the system-generated PDF attachment for an invoice */
export enum InvoicePdfStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Ready = 'READY',
}

/** Customer-facing invoice rendering options for this component. Presentational only — does not affect the amount charged. */
export type InvoicePresentation = {
  __typename?: 'InvoicePresentation';
  /** Optional grouping label; lines sharing it group together. */
  groupWith?: Maybe<Scalars['String']['output']>;
  /** Render the per-period worked-example breakdown line under the charge. */
  showBreakdown: Scalars['Boolean']['output'];
  /** Render the unit/transaction count alongside the amount. */
  showQuantity: Scalars['Boolean']['output'];
  /** Optional tax category label passed to the tax engine. */
  taxCategory?: Maybe<Scalars['String']['output']>;
};

export type InvoicePresentationInput = {
  /** Optional grouping label for invoice lines. */
  groupWith?: InputMaybe<Scalars['String']['input']>;
  /** Render the per-period worked-example breakdown line. */
  showBreakdown?: Scalars['Boolean']['input'];
  /** Render the unit/transaction count alongside the amount. */
  showQuantity?: Scalars['Boolean']['input'];
  /** Optional tax category label. */
  taxCategory?: InputMaybe<Scalars['String']['input']>;
};

/** How a subscription's invoices are handled when its start date changes and the billing series is regenerated: REBUILD_ALL deletes and rebuilds everything, PRESERVE_PAID keeps paid invoices and only rebuilds the unpaid/uncovered periods, VOID_AND_REISSUE marks the old invoices CANCELLED (audit trail) and issues a fresh series. */
export enum InvoiceRegenerationMode {
  PreservePaid = 'PRESERVE_PAID',
  RebuildAll = 'REBUILD_ALL',
  VoidAndReissue = 'VOID_AND_REISSUE',
}

/** How the invoice was created */
export enum InvoiceSource {
  ExcelImport = 'EXCEL_IMPORT',
  GoogleDrive = 'GOOGLE_DRIVE',
  Manual = 'MANUAL',
  System = 'SYSTEM',
}

/** One tax on an invoice: a tax code at a rate, summed over the lines it applied to. */
export type InvoiceTaxLine = {
  __typename?: 'InvoiceTaxLine';
  displayLabel: Scalars['String']['output'];
  ratePct: Scalars['Decimal']['output'];
  taxAmount: Scalars['Decimal']['output'];
  taxCode: Scalars['String']['output'];
  taxableBase: Scalars['Decimal']['output'];
};

/** Seller, buyer, jurisdiction and treatment as they were when the invoice was issued. */
export type InvoiceTaxSnapshot = {
  __typename?: 'InvoiceTaxSnapshot';
  buyerTaxId?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  /** Reverse-charge / exempt wording printed on the invoice. */
  legends: Array<Scalars['String']['output']>;
  sellerLegalName?: Maybe<Scalars['String']['output']>;
  sellerRegistrationNumber?: Maybe<Scalars['String']['output']>;
  subdivisionCode?: Maybe<Scalars['String']['output']>;
  /** STANDARD, REDUCED, ZERO_RATED, EXEMPT, REVERSE_CHARGE, OUT_OF_SCOPE. */
  treatments: Array<Scalars['String']['output']>;
};

/** Type of invoice (subscription, expansion, service, etc.) */
export enum InvoiceType {
  Discount = 'DISCOUNT',
  Expansion = 'EXPANSION',
  Overage = 'OVERAGE',
  Refund = 'REFUND',
  Renewal = 'RENEWAL',
  Service = 'SERVICE',
  Subscription = 'SUBSCRIPTION',
}

export type IssueApiKeyInput = {
  /** Public GraphQL capabilities. Omit or pass [READ] for read-only; pass [READ, WRITE] (or [WRITE]) for mutations. READ is always included. */
  capabilities?: InputMaybe<Array<PublicApiCapability>>;
  /** Human-readable label shown in admin UIs */
  name: Scalars['String']['input'];
  rateLimits?: InputMaybe<ApiKeyRateLimitsInput>;
  scope?: InputMaybe<ApiKeyScopeInput>;
};

export type IssueCreditNoteInput = {
  /** The receivable being corrected. Sets the credit currency, and caps the credit at what that invoice was raised for (earlier credits against it count toward the cap). Omit for a standalone credit. */
  againstInvoiceId?: InputMaybe<Scalars['ID']['input']>;
  /** Required only when there is neither a target invoice nor a subscription to read the currency from. A value that disagrees with either is refused, never converted. */
  currency?: InputMaybe<Scalars['String']['input']>;
  /** Defaults to now. Backdate only to correct history. */
  invoiceDate?: InputMaybe<Scalars['String']['input']>;
  lines: Array<CreditNoteLineItemInput>;
  /** The client being credited. */
  organizationId: Scalars['ID']['input'];
  /** Why the credit was issued. Required — a credit note is a financial record, and "who decided this and why" is the question it will be asked later. */
  reason: Scalars['String']['input'];
  /** The subscription the credit relates to, when it has one. */
  subscriptionId?: InputMaybe<Scalars['ID']['input']>;
};

export type IssuedApiKey = {
  __typename?: 'IssuedApiKey';
  apiKey: ApiKey;
  /** The plaintext API key. Shown ONCE at issue/rotate; not retrievable afterwards. */
  plaintext: Scalars['String']['output'];
  /** HMAC signing secret used for X-Signature-SHA256 on POST /api/v1/events (PRD §11.4). Shown ONCE at issue/rotate. */
  signingSecret: Scalars['String']['output'];
};

/** A negotiated price for ONE catalog item of a new subscription — the pinned bundle or one of the pinned modules — replacing that item's list price for this client. Exactly one of `bundleId` / `moduleId` names the item. */
export type ItemPriceOverrideInput = {
  /** The pinned bundle this price replaces. */
  bundleId?: InputMaybe<Scalars['ID']['input']>;
  /** The pinned module this price replaces. */
  moduleId?: InputMaybe<Scalars['ID']['input']>;
  /** Price billed per period for this item (zero or more). */
  value: Scalars['Float']['input'];
};

/** Which clients in a sync job can be committed. Read-only — a client is committable only when every one of its invoices is answered, because its subscriptions are reconstructed from all of them at once. */
export type JobCommitReadinessEntity = {
  __typename?: 'JobCommitReadinessEntity';
  /** Ready clients first */
  clients: Array<ClientCommitReadinessEntity>;
  committedClients: Scalars['Int']['output'];
  readyClients: Scalars['Int']['output'];
  /** Rows with no client that a reviewer has already answered. The quietest of the three: nothing is asking about them any more, and the per-client commit is keyed on a client they do not have, so uncounted they make a job read as finished while holding an invoice that can never be committed. */
  unattributedAnswered: Scalars['Int']['output'];
  /** Rows with no client whose extraction failed */
  unattributedErrored: Scalars['Int']['output'];
  /** Rows no client could be resolved for and which still need an answer. Reported here rather than against a client because the per-client commit cannot reach them. */
  unattributedPending: Scalars['Int']['output'];
  waitingClients: Scalars['Int']['output'];
};

export type KbArticle = {
  __typename?: 'KbArticle';
  audience: KbAudience;
  chunkCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  lastIngestedAt?: Maybe<Scalars['DateTime']['output']>;
  lastRetrievedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Where an admin can open the article: its web page, or a ClickUp page's ClickUp link (its url is a place in ClickUp, not a link). Null for documents. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  retrievalCount: Scalars['Int']['output'];
  sourceId: Scalars['ID']['output'];
  status: KbArticleStatus;
  statusReason?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  /** When the article last changed. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url: Scalars['String']['output'];
  /** The address path in lower case (/blog/some-post). Null for documents. */
  urlPath?: Maybe<Scalars['String']['output']>;
};

export type KbArticleBulkTargetInput = {
  /** How many articles the admin was shown. The action changes nothing if the real number differs. */
  expectedCount: Scalars['Int']['input'];
  /** Everything this matches (up to 5,000). Paging and sort are ignored. Give this or ids. */
  filter?: InputMaybe<KbArticleFilterInput>;
  /** The ticked articles, up to 500. Give this or a filter, not both. */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type KbArticleFilterInput = {
  after?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Skip this many rows (table paging). */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Path contains each of these texts, anywhere. Every rule must hold (AND). */
  pathContains?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Path contains none of these texts. Articles with no path are kept. */
  pathNotContains?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Path starts with none of these, at a segment boundary. Articles with no path are kept. */
  pathNotPrefix?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Path starts with each of these, at a segment boundary: /blog takes /blog and /blog/a, not /blogger. Every rule must hold (AND). */
  pathPrefix?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Only articles everyone may read (no role named). */
  publicOnly?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  /** Sort the table. With an offset, replaces cursor paging. */
  sortBy?: InputMaybe<KbArticleSortField>;
  sortDir?: InputMaybe<KbSortDirection>;
  sourceId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<KbArticleStatus>;
};

export type KbArticlePage = {
  __typename?: 'KbArticlePage';
  hasMore: Scalars['Boolean']['output'];
  nodes: Array<KbArticle>;
  /** Articles matching the filter in all, whatever the page. */
  total: Scalars['Int']['output'];
};

export enum KbArticleSortField {
  Path = 'PATH',
  Source = 'SOURCE',
  Status = 'STATUS',
  Title = 'TITLE',
  Updated = 'UPDATED',
}

export enum KbArticleStatus {
  Excluded = 'EXCLUDED',
  Failed = 'FAILED',
  Indexed = 'INDEXED',
  NeedsReview = 'NEEDS_REVIEW',
}

export type KbAudience = {
  __typename?: 'KbAudience';
  confidence: KbConfidence;
  evidence: Array<Scalars['String']['output']>;
  /** Plan keys. Empty means every plan. */
  plans: Array<Scalars['String']['output']>;
  /** Role keys. Empty means everyone. */
  roles: Array<Scalars['String']['output']>;
  source: KbAudienceSource;
};

export type KbAudienceInput = {
  plans: Array<Scalars['String']['input']>;
  /** Role keys. Empty means everyone. */
  roles: Array<Scalars['String']['input']>;
};

export type KbAudienceRule = {
  __typename?: 'KbAudienceRule';
  /** All must hold. */
  conditions: Array<KbAudienceRuleCondition>;
  /** The article is for everyone (roles is then empty). */
  everyone: Scalars['Boolean']['output'];
  /** Role keys this rule gives the article to. */
  roles: Array<Scalars['String']['output']>;
};

export type KbAudienceRuleCondition = {
  __typename?: 'KbAudienceRuleCondition';
  match: KbPathMatch;
  /** A path such as /docs/applicant/, or a full address (its path is used). */
  value: Scalars['String']['output'];
};

export type KbAudienceRuleConditionInput = {
  match: KbPathMatch;
  value: Scalars['String']['input'];
};

export type KbAudienceRuleCount = {
  __typename?: 'KbAudienceRuleCount';
  /** Of those, articles an admin decided, which no rule changes. */
  keptByAdmin: Scalars['Int']['output'];
  /** Articles this rule decides: the first rule that matches. */
  matches: Scalars['Int']['output'];
};

export type KbAudienceRuleInput = {
  conditions: Array<KbAudienceRuleConditionInput>;
  everyone?: InputMaybe<Scalars['Boolean']['input']>;
  /** Role keys or names. */
  roles?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type KbAudienceRulePreview = {
  __typename?: 'KbAudienceRulePreview';
  /** One per rule, in order. */
  rules: Array<KbAudienceRuleCount>;
  /** The source's articles, excluded ones aside. */
  total: Scalars['Int']['output'];
  /** Articles no rule matches: their audience is guessed. */
  unmatched: Scalars['Int']['output'];
};

export type KbAudienceRulesResult = {
  __typename?: 'KbAudienceRulesResult';
  /** Articles whose audience changed. */
  changed: Scalars['Int']['output'];
  /** Articles checked against the rules now (0 when not applied). */
  checked: Scalars['Int']['output'];
  source: KnowledgeSource;
};

export enum KbAudienceSource {
  Inferred = 'INFERRED',
  Override = 'OVERRIDE',
  Rule = 'RULE',
}

export type KbBulkResult = {
  __typename?: 'KbBulkResult';
  /** Articles the action went through for. */
  affected: Scalars['Int']['output'];
  /** Articles it could not be applied to; the rest were done. */
  failed: Scalars['Int']['output'];
  /** Articles the selection or filter resolved to. */
  matched: Scalars['Int']['output'];
};

export enum KbConfidence {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
}

export type KbPathGroup = {
  __typename?: 'KbPathGroup';
  count: Scalars['Int']['output'];
  /** The first path segment, such as /blog. */
  prefix: Scalars['String']['output'];
};

/** How an audience rule's text is compared with an article's address path. */
export enum KbPathMatch {
  Contains = 'CONTAINS',
  EndsWith = 'ENDS_WITH',
  Is = 'IS',
  IsNot = 'IS_NOT',
  NotContains = 'NOT_CONTAINS',
  NotEndsWith = 'NOT_ENDS_WITH',
  NotStartsWith = 'NOT_STARTS_WITH',
  StartsWith = 'STARTS_WITH',
}

export enum KbSortDirection {
  Asc = 'ASC',
  Desc = 'DESC',
}

/** Which way a Key Result is meant to move. */
export enum KeyResultDirection {
  Decrease = 'DECREASE',
  Increase = 'INCREASE',
}

export enum KeyResultPaceStatus {
  Ahead = 'AHEAD',
  Behind = 'BEHIND',
  OnPace = 'ON_PACE',
}

export enum KeyResultSource {
  Manual = 'MANUAL',
  Metric = 'METRIC',
}

export enum KeyResultStatus {
  Dropped = 'DROPPED',
  Open = 'OPEN',
  Scored = 'SCORED',
}

export enum KeyResultUnit {
  Count = 'COUNT',
  Currency = 'CURRENCY',
  Percent = 'PERCENT',
}

export type KnowledgeCrawlStats = {
  __typename?: 'KnowledgeCrawlStats';
  /** The pass stopped at the page cap, so later pages were not seen. */
  capped: Scalars['Boolean']['output'];
  excluded: Scalars['Int']['output'];
  failed: Scalars['Int']['output'];
  found: Scalars['Int']['output'];
  indexed: Scalars['Int']['output'];
  needsReview: Scalars['Int']['output'];
  removed: Scalars['Int']['output'];
  unchanged: Scalars['Int']['output'];
};

export type KnowledgeDocumentInput = {
  /** Markdown or plain text. */
  markdown: Scalars['String']['input'];
  plans?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Roles that may read it. Omit to let the roles be worked out; [] is everyone. */
  roles?: InputMaybe<Array<Scalars['String']['input']>>;
  title: Scalars['String']['input'];
};

export type KnowledgeHealth = {
  __typename?: 'KnowledgeHealth';
  /** What a badge should count: things an admin should look at. */
  attention: Scalars['Int']['output'];
  failedArticles: Scalars['Int']['output'];
  failedSources: Scalars['Int']['output'];
  needsReview: Scalars['Int']['output'];
  /** Failed articles whose earlier text is still being used in answers. */
  outOfDate: Scalars['Int']['output'];
  /** Passages still on an earlier embedding model. */
  reembedPending: Scalars['Int']['output'];
};

export type KnowledgeReclassifyResult = {
  __typename?: 'KnowledgeReclassifyResult';
  changed: Scalars['Int']['output'];
  checked: Scalars['Int']['output'];
};

export enum KnowledgeSchedule {
  Daily = 'DAILY',
  Hourly = 'HOURLY',
  Manual = 'MANUAL',
  Weekly = 'WEEKLY',
}

export type KnowledgeSource = {
  __typename?: 'KnowledgeSource';
  /** Websites and help centres: who may read an article, by its address. The first rule that matches decides; an admin-set audience is never changed. */
  audienceRules: Array<KbAudienceRule>;
  /** Intercom and Zendesk sources: which workspace they read, never the token. */
  connectionLabel?: Maybe<Scalars['String']['output']>;
  /** Whole reads in a row that failed. */
  consecutiveFailures: Scalars['Int']['output'];
  counts: Array<KnowledgeStatusCount>;
  exclude: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  include: Array<Scalars['String']['output']>;
  kind: KnowledgeSourceKind;
  lastCrawlAt?: Maybe<Scalars['DateTime']['output']>;
  lastCrawlStats?: Maybe<KnowledgeCrawlStats>;
  lastError?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** After a failure, the earliest a scheduled read is tried again. */
  nextAttemptAt?: Maybe<Scalars['DateTime']['output']>;
  /** An admin confirmed the site is theirs; nothing is crawled before. */
  ownershipConfirmed: Scalars['Boolean']['output'];
  pageCap: Scalars['Int']['output'];
  /** The last choice made before a manual read: re-guess who can read articles whose audience was guessed. Scheduled reads follow it. */
  reguessAudience: Scalars['Boolean']['output'];
  /** Times answers drew on this source. */
  retrievals: Scalars['Int']['output'];
  rootUrl?: Maybe<Scalars['String']['output']>;
  schedule: KnowledgeSchedule;
  sitemapUrl?: Maybe<Scalars['String']['output']>;
  status: KnowledgeSourceStatus;
  /** ClickUp sources: a `Revvly audience:` line at the top of a page decides who may read it. Off: such a line can only hold a page for review. */
  trustAudienceLines: Scalars['Boolean']['output'];
};

export type KnowledgeSourceEditInput = {
  confirmOwnership?: InputMaybe<Scalars['Boolean']['input']>;
  /** A new API token for an Intercom or Zendesk source. Write-only: never returned. */
  credential?: InputMaybe<Scalars['String']['input']>;
  /** Zendesk: the agent email the token belongs to. */
  email?: InputMaybe<Scalars['String']['input']>;
  exclude?: InputMaybe<Array<Scalars['String']['input']>>;
  include?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Zendesk: the language to read, such as en-us. */
  locale?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pageCap?: InputMaybe<Scalars['Int']['input']>;
  /** Intercom: us, eu or au. */
  region?: InputMaybe<Scalars['String']['input']>;
  schedule?: InputMaybe<KnowledgeSchedule>;
  sitemapUrl?: InputMaybe<Scalars['String']['input']>;
  /** Zendesk: the acme of acme.zendesk.com. */
  subdomain?: InputMaybe<Scalars['String']['input']>;
  /** ClickUp: trust a `Revvly audience:` line at the top of a page. Applies from the next sync. */
  trustAudienceLines?: InputMaybe<Scalars['Boolean']['input']>;
};

export type KnowledgeSourceInput = {
  /** The site is yours to read. */
  confirmOwnership?: InputMaybe<Scalars['Boolean']['input']>;
  exclude?: InputMaybe<Array<Scalars['String']['input']>>;
  include?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
  pageCap?: InputMaybe<Scalars['Int']['input']>;
  rootUrl: Scalars['String']['input'];
  schedule?: InputMaybe<KnowledgeSchedule>;
  sitemapUrl?: InputMaybe<Scalars['String']['input']>;
};

export enum KnowledgeSourceKind {
  Api = 'API',
  Clickup = 'CLICKUP',
  Crawl = 'CRAWL',
  Intercom = 'INTERCOM',
  Upload = 'UPLOAD',
  Zendesk = 'ZENDESK',
}

export enum KnowledgeSourceStatus {
  Crawling = 'CRAWLING',
  Disabled = 'DISABLED',
  Failed = 'FAILED',
  Idle = 'IDLE',
}

export type KnowledgeStatusCount = {
  __typename?: 'KnowledgeStatusCount';
  count: Scalars['Int']['output'];
  status: KbArticleStatus;
};

/** How a CRM relationship record was created. */
export enum LeadSource {
  AiSignal = 'AI_SIGNAL',
  Api = 'API',
  Booking = 'BOOKING',
  Form = 'FORM',
  Import = 'IMPORT',
  InboundEmail = 'INBOUND_EMAIL',
  Manual = 'MANUAL',
  Referral = 'REFERRAL',
}

/** CRM lead/deal status. */
export enum LeadStatus {
  Lost = 'LOST',
  Open = 'OPEN',
  Won = 'WON',
}

export type LegacyPin = {
  __typename?: 'LegacyPin';
  /** True when the newest in-force pin change stated a legacy-pin reason, or was recorded as a backdated (historical) change. */
  grandfathered: Scalars['Boolean']['output'];
  /** The stated reason. Null when the pin is not deliberate. */
  reason?: Maybe<Scalars['String']['output']>;
};

/** Explicit intent to pin a subscription to an ARCHIVED catalog version. Deliberately not derived from the start date: the motivating case is migrating a client onto a legacy plan going FORWARD, whose subscription starts today — inside the current version's window — so a date-derived rule would reject exactly that. */
export type LegacyVersionPinInput = {
  /** Why this client is on a past version. Recorded on the INITIAL_PIN history entry, so the audit trail explains the pin rather than just showing an archived id. */
  reason: Scalars['String']['input'];
};

/** What kind of document it is, for filtering the library. */
export enum LibraryDocumentCategory {
  CaseStudy = 'CASE_STUDY',
  Contract = 'CONTRACT',
  Deck = 'DECK',
  Guide = 'GUIDE',
  Other = 'OTHER',
  Pricing = 'PRICING',
  Proposal = 'PROPOSAL',
}

export type LibraryDocumentEntity = {
  __typename?: 'LibraryDocumentEntity';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  /** True when the current version fits the 10 MB mailbox limit and can be attached. */
  attachable: Scalars['Boolean']['output'];
  category: LibraryDocumentCategory;
  createdAt: Scalars['DateTime']['output'];
  /** Auth sub of the creator. */
  createdBy: Scalars['String']['output'];
  /** Verified stored file behind the current version; pass it as an email attachment id. */
  currentFileId: Scalars['ID']['output'];
  /** Version number of the file the library serves today. */
  currentVersionNumber: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  fileName: Scalars['String']['output'];
  fileSize: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  mimeType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  tags: Array<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type LibraryDocumentStatsEntity = {
  __typename?: 'LibraryDocumentStatsEntity';
  documentId: Scalars['ID']['output'];
  downloads: Scalars['Int']['output'];
  lastViewedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Links sent. */
  sends: Scalars['Int']['output'];
  /** Views, counted once per link and viewer per 15 minutes. */
  totalViews: Scalars['Int']['output'];
  /** Links opened by a browser at least once. */
  viewedLinks: Scalars['Int']['output'];
};

export type LibraryDocumentVersionEntity = {
  __typename?: 'LibraryDocumentVersionEntity';
  createdAt: Scalars['DateTime']['output'];
  fileName: Scalars['String']['output'];
  fileSize: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  mimeType: Scalars['String']['output'];
  /** What changed in this version. */
  note?: Maybe<Scalars['String']['output']>;
  /** Auth sub of the admin who uploaded it. */
  uploadedBy: Scalars['String']['output'];
  versionNumber: Scalars['Int']['output'];
};

export type LibraryLinkInput = {
  /** Default true. False makes the link preview-only. */
  allowDownload?: InputMaybe<Scalars['Boolean']['input']>;
  documentId: Scalars['ID']['input'];
  /** Default 180, at most 730. */
  expiresInDays?: InputMaybe<Scalars['Int']['input']>;
  /** Pin the link to the version that is current now, instead of always serving the latest. */
  pinVersion?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LibraryLinkSelection = {
  __typename?: 'LibraryLinkSelection';
  allowDownload?: Maybe<Scalars['Boolean']['output']>;
  documentId: Scalars['ID']['output'];
  expiresInDays?: Maybe<Scalars['Int']['output']>;
  pinVersion?: Maybe<Scalars['Boolean']['output']>;
};

export type LibraryUploadTarget = {
  __typename?: 'LibraryUploadTarget';
  expiresAt: Scalars['DateTime']['output'];
  /** Pass to the confirm mutation after the PUT. */
  fileId: Scalars['ID']['output'];
  maxBytes: Scalars['Int']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type LimitPeriod = {
  __typename?: 'LimitPeriod';
  alignment?: Maybe<LimitPeriodAlignment>;
  /** ISO 8601 duration (e.g. "PT3H"). Required for FIXED_CYCLE / ROLLING_WINDOW. */
  duration?: Maybe<Scalars['String']['output']>;
  type: LimitPeriodType;
  unusedAtPeriodEnd: LimitPeriodUnusedBehavior;
};

/** Anchor for the limit period reset */
export enum LimitPeriodAlignment {
  CalendarUtc = 'CALENDAR_UTC',
  CustomerTimezone = 'CUSTOMER_TIMEZONE',
  FirstUse = 'FIRST_USE',
  SubscriptionAnchor = 'SUBSCRIPTION_ANCHOR',
}

export type LimitPeriodInput = {
  alignment?: InputMaybe<LimitPeriodAlignment>;
  /** ISO 8601 duration. Required for FIXED_CYCLE / ROLLING_WINDOW. */
  duration?: InputMaybe<Scalars['String']['input']>;
  type?: LimitPeriodType;
  unusedAtPeriodEnd?: LimitPeriodUnusedBehavior;
};

/** How an inclusion/allowance refreshes within the billing cycle */
export enum LimitPeriodType {
  BillingCycle = 'BILLING_CYCLE',
  FixedCycle = 'FIXED_CYCLE',
  RollingWindow = 'ROLLING_WINDOW',
}

/** How leftover inclusions/allowances are handled when a limit period resets */
export enum LimitPeriodUnusedBehavior {
  Forfeit = 'FORFEIT',
  Rollover = 'ROLLOVER',
}

/** A reviewer's change to one extracted line's type */
export type LineTypeCorrectionInput = {
  /** Position of the line in the extracted lineItems */
  index: Scalars['Int']['input'];
  /** The type the reviewer chose. Never UNKNOWN. */
  lineType: InvoiceLineType;
};

export type LinkInvoiceToSubscriptionInput = {
  invoiceId: Scalars['ID']['input'];
  subscriptionId: Scalars['ID']['input'];
};

/** Input for listing stored files */
export type ListFilesInput = {
  category?: InputMaybe<FileCategory>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Search by filename */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Sort by field (createdAt, originalFilename, size) */
  sortBy?: InputMaybe<Scalars['String']['input']>;
  /** Sort order (asc, desc) */
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};

export type ListIncubator = {
  __typename?: 'ListIncubator';
  /** Filtered number of incubators founded */
  filterCount?: Maybe<Scalars['Int']['output']>;
  /** Next item to search from */
  next?: Maybe<Scalars['String']['output']>;
  /** List of incubators found */
  results: Array<Incubator>;
  /** Total number of incubators founded */
  totalCount: Scalars['Int']['output'];
};

export type ListUsersInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  userRoles?: InputMaybe<Array<UserRoles>>;
  userStatuses?: InputMaybe<Array<UserStatuses>>;
};

export type LogCrmEmailMessageInput = {
  bodyText: Scalars['String']['input'];
  direction: CrmEmailDirection;
  emailSubject?: InputMaybe<Scalars['String']['input']>;
  /** When the email happened — must be in the past. */
  occurredAt: Scalars['DateTime']['input'];
  organizationContactId?: InputMaybe<Scalars['ID']['input']>;
  subjectId: Scalars['ID']['input'];
  subjectType: EntityTargetType;
};

/** Log a meeting against a client, contact or lead. */
export type LogCrmMeetingInput = {
  agenda?: InputMaybe<Scalars['String']['input']>;
  attendees?: InputMaybe<Array<CrmMeetingAttendeeInput>>;
  conferenceUrl?: InputMaybe<Scalars['String']['input']>;
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Room, address, or dial-in detail. */
  locationDetail?: InputMaybe<Scalars['String']['input']>;
  locationType?: InputMaybe<CrmMeetingLocationType>;
  /** What came out of the meeting. */
  notes?: InputMaybe<Scalars['String']['input']>;
  scheduledVia?: InputMaybe<CrmMeetingScheduledVia>;
  startAt: Scalars['DateTime']['input'];
  /** Defaults to SCHEDULED for a future meeting and HELD for one already in the past. */
  status?: InputMaybe<CrmMeetingStatus>;
  subjectId: Scalars['ID']['input'];
  subjectType: EntityTargetType;
  /** IANA zone, e.g. America/Montreal. */
  timezone?: InputMaybe<Scalars['String']['input']>;
  /** What the meeting was about. */
  title: Scalars['String']['input'];
};

/** A request a client made outside the widget (a call, an email, in person), logged by an agent. Name the person, the client, or both. */
export type LogSupportTicketInput = {
  /** An active member of the workspace. */
  assigneeUserId?: InputMaybe<Scalars['ID']['input']>;
  /** What the client asked, as an internal note: the client is not told and does not see the ticket until a public reply is posted on it. */
  description: Scalars['String']['input'];
  /** A client. Defaults to the person's client when a person is named. */
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  /** Defaults to normal. */
  priority?: InputMaybe<TicketPriority>;
  /** A person from People. */
  requesterId?: InputMaybe<Scalars['ID']['input']>;
  /** Up to 200 characters. */
  title: Scalars['String']['input'];
  typeId: Scalars['ID']['input'];
};

export type MrrMovementPoint = {
  __typename?: 'MRRMovementPoint';
  /** Number of subscriptions churned (cancelled) this month */
  churnCount: Scalars['Int']['output'];
  /** MRR lost from cancelled subscriptions (positive number) */
  churnMRR: Scalars['Float']['output'];
  /** Number of contraction events (downgrades) this month */
  contractionCount: Scalars['Int']['output'];
  /** MRR lost from downgrades (positive number) */
  contractionMRR: Scalars['Float']['output'];
  /** MRR at the end of this month */
  endingMRR: Scalars['Float']['output'];
  /** Number of expansion events (upgrades, add-ons) this month */
  expansionCount: Scalars['Int']['output'];
  /** MRR gained from upgrades and add-ons */
  expansionMRR: Scalars['Float']['output'];
  /** Month in YYYY-MM format */
  month: Scalars['String']['output'];
  /** Percentage change in MRR this month */
  netChangePercent: Scalars['Float']['output'];
  /** Net MRR change this month (ending - starting) */
  netNewMRR: Scalars['Float']['output'];
  /** MRR from new subscriptions created this month */
  newBusinessMRR: Scalars['Float']['output'];
  /** Number of new subscriptions created this month */
  newSubscriptionCount: Scalars['Int']['output'];
  /** Number of subscriptions reactivated this month */
  reactivationCount: Scalars['Int']['output'];
  /** MRR from reactivated subscriptions */
  reactivationMRR: Scalars['Float']['output'];
  /** MRR at the start of this month */
  startingMRR: Scalars['Float']['output'];
};

export type MrrMovementSummary = {
  __typename?: 'MRRMovementSummary';
  /** When this summary was calculated */
  calculatedAt: Scalars['DateTime']['output'];
  /** Current MRR as of the latest period */
  currentMRR: Scalars['Float']['output'];
  /** Absolute change in MRR month-over-month */
  momChange: Scalars['Float']['output'];
  /** Percentage change in MRR month-over-month */
  momChangePercent: Scalars['Float']['output'];
  /** Monthly MRR movement data points */
  monthlyData: Array<MrrMovementPoint>;
  /** Peak single-month movement magnitude as a fraction of peak MRR across the window (0 = no movement relative to MRR). Drives recommendedAxisMode and lets the client label/adjust the axis decision. */
  movementToMrrRatio: Scalars['Float']['output'];
  /** MRR from the previous month */
  previousMonthMRR: Scalars['Float']['output'];
  /** Backend-recommended default axis mode for the movement chart. SHARED when movementToMrrRatio is at least 30% (movements are comparable to MRR); SEPARATE otherwise (the common case for established businesses). The client may override it. */
  recommendedAxisMode: MrrAxisScaleMode;
  /** Total churned MRR over the requested period */
  totalChurnMRR: Scalars['Float']['output'];
  /** Total contraction MRR over the requested period */
  totalContractionMRR: Scalars['Float']['output'];
  /** Total expansion MRR over the requested period */
  totalExpansionMRR: Scalars['Float']['output'];
  /** Total new business MRR over the requested period */
  totalNewBusinessMRR: Scalars['Float']['output'];
  /** Total reactivation MRR over the requested period */
  totalReactivationMRR: Scalars['Float']['output'];
  /** Absolute change in MRR year-over-year (null if no data) */
  yoyChange?: Maybe<Scalars['Float']['output']>;
  /** Percentage change in MRR year-over-year (null if no data) */
  yoyChangePercent?: Maybe<Scalars['Float']['output']>;
};

/** Why an onboarding left the assistant for the setup wizard */
export enum ManualFallbackReason {
  Chosen = 'CHOSEN',
  ModelError = 'MODEL_ERROR',
}

export type MapProductEventInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  eventName: Scalars['String']['input'];
  targetId?: InputMaybe<Scalars['ID']['input']>;
  targetKind?: InputMaybe<ProductEventTargetKind>;
  valueFeature?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MarkDocumentsResult = {
  __typename?: 'MarkDocumentsResult';
  /** Documents whose mark is locked (imported, or written by Revvly). */
  locked: Scalars['Int']['output'];
  updated: Scalars['Int']['output'];
};

export type MarkPaymentReceivedInput = {
  actualPaymentDate?: InputMaybe<Scalars['String']['input']>;
  /** Amount collected, in the invoice currency. Omit to settle the whole outstanding balance; supply a smaller amount to record a part payment, which leaves the invoice PENDING/OVERDUE with the remainder still due. */
  amount?: InputMaybe<Scalars['Float']['input']>;
  /** Dedup key for this payment. Repeating a key already recorded against the invoice applies nothing and returns the invoice unchanged, so a resubmitted form or a retried request cannot double-count. Generated server-side when absent. */
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  invoiceId: Scalars['ID']['input'];
};

/** The invoice-side facts the proposals were judged against, as recorded */
export type MatchFingerprintEntity = {
  __typename?: 'MatchFingerprintEntity';
  currency?: Maybe<Scalars['String']['output']>;
  invoiceTotal?: Maybe<Scalars['Float']['output']>;
  /** One entry per invoice line, in document order: BASE_RECURRING, USAGE, ONE_TIME, CREDIT, TAX or UNKNOWN. This is what the review card renders as a chip beside each line. */
  lineTypes?: Maybe<Array<Scalars['String']['output']>>;
  oneTimeTotal?: Maybe<Scalars['Float']['output']>;
  /** Days covered, when the invoice states a period */
  periodLengthDays?: Maybe<Scalars['Int']['output']>;
  /** Sum of the recurring base lines — the only figure comparable to a base price */
  recurringBaseTotal?: Maybe<Scalars['Float']['output']>;
  usageLineCount?: Maybe<Scalars['Int']['output']>;
  usageTotal?: Maybe<Scalars['Float']['output']>;
};

/** One matching strategy’s answer, exactly as it was recorded */
export type MatchProposalEntity = {
  __typename?: 'MatchProposalEntity';
  bundleId?: Maybe<Scalars['String']['output']>;
  catalogLineageId?: Maybe<Scalars['String']['output']>;
  /** Catalog version landed on */
  catalogVersionId?: Maybe<Scalars['String']['output']>;
  /** Raw 0..1 score. Prefer `tier` in any reviewer-facing UI. */
  confidence: Scalars['Float']['output'];
  /** Short reviewer-facing reasons. Shown instead of the number. */
  evidence?: Maybe<Array<Scalars['String']['output']>>;
  /** The strategy THREW rather than declining to answer. An error is the absence of an opinion; an abstention is an opinion. Do not render one as the other. */
  failed: Scalars['Boolean']['output'];
  moduleIds?: Maybe<Array<Scalars['String']['output']>>;
  productConfidence?: Maybe<Scalars['Float']['output']>;
  /** Subscription alternatives, best first, including the chosen one */
  rankedSubscriptionIds?: Maybe<Array<Scalars['String']['output']>>;
  reasoning?: Maybe<Scalars['String']['output']>;
  /** Ran in shadow: recorded, never applied */
  shadow: Scalars['Boolean']['output'];
  /** Stable strategy id, e.g. incumbent-v1 */
  strategy: Scalars['String']['output'];
  /** Revision of that strategy’s logic, so metrics never blend two builds */
  strategyVersion: Scalars['Int']['output'];
  subscriptionConfidence?: Maybe<Scalars['Float']['output']>;
  subscriptionId?: Maybe<Scalars['String']['output']>;
  /** STRONG / LIKELY / UNSURE. Reviewers see the tier, never the number: a raw 0.87 invites anchoring on a figure whose calibration is tenant-specific, and reading the evidence is what actually catches a wrong proposal. */
  tier: Scalars['String']['output'];
};

/** Tenant binding used by inbound MCP OAuth sessions for the signed-in user. */
export type McpOauthBinding = {
  __typename?: 'McpOauthBinding';
  tenantId: Scalars['ID']['output'];
  userId: Scalars['String']['output'];
};

export enum McpRemoteAccess {
  Admins = 'ADMINS',
  Members = 'MEMBERS',
}

export enum McpRemoteAuthType {
  Bearer = 'BEARER',
  Header = 'HEADER',
  None = 'NONE',
  Oauth = 'OAUTH',
}

export enum McpRemoteOAuthStatus {
  Connected = 'CONNECTED',
  NeedsReauth = 'NEEDS_REAUTH',
  Pending = 'PENDING',
}

/** An external MCP server connected to the Revvly Agent. Credentials are never returned. */
export type McpRemoteServerView = {
  __typename?: 'McpRemoteServerView';
  access: McpRemoteAccess;
  authType: McpRemoteAuthType;
  /** The agent may use the allowed tools. */
  enabled: Scalars['Boolean']['output'];
  /** Outbound MCP is switched off for the whole platform. */
  globallyDisabled: Scalars['Boolean']['output'];
  /** A bearer token or header value is stored (its value is never returned). */
  hasCredential: Scalars['Boolean']['output'];
  headerName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  oauthConnectedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Set when sign-in uses an OAuth app Revvly registered (GitHub) rather than automatic registration. */
  oauthPreset?: Maybe<Scalars['String']['output']>;
  oauthStatus?: Maybe<McpRemoteOAuthStatus>;
  serverId: Scalars['String']['output'];
  tools: Array<McpRemoteToolView>;
  /** When the tool list below was last read from the server. */
  toolsFetchedAt?: Maybe<Scalars['DateTime']['output']>;
  url: Scalars['String']['output'];
};

/** One tool a connected MCP server advertises. */
export type McpRemoteToolView = {
  __typename?: 'McpRemoteToolView';
  /** The agent may call this tool. */
  allowed: Scalars['Boolean']['output'];
  /** The server's own words. Untrusted: shown to the admin before they allow the tool, and sent to the model if they do. */
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** An admin confirmed it only reads. Every other allowed tool needs approval per use. */
  readOnly: Scalars['Boolean']['output'];
  /** What the server claims about itself; only a suggestion for the read-only box. */
  readOnlyHint?: Maybe<Scalars['Boolean']['output']>;
};

/** Peak (reserved capacity) vs Cumulative (consumption) measurement */
export enum MeasurementMode {
  Cumulative = 'CUMULATIVE',
  Peak = 'PEAK',
}

/** One invitation sent over Slack */
export type MemberInvite = {
  __typename?: 'MemberInvite';
  approvedByName?: Maybe<Scalars['String']['output']>;
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  invitedAt: Scalars['DateTime']['output'];
  invitedByName?: Maybe<Scalars['String']['output']>;
  /** Auth id of whoever it is attributed to */
  invitedByUserId: Scalars['String']['output'];
  /** What became of the last DM. Anything but SENT means it did not arrive */
  lastDeliveryStatus?: Maybe<Scalars['String']['output']>;
  lastSentAt: Scalars['DateTime']['output'];
  /** The reminder DM has gone out */
  reminderSent: Scalars['Boolean']['output'];
  sendCount: Scalars['Int']['output'];
  slackDisplayName: Scalars['String']['output'];
  slackUserId: Scalars['String']['output'];
  /** EXPIRED once past its expiry, even before the daily sweep has run */
  status: MemberInviteStatus;
};

/** What the caller may do with Slack invitations in this company */
export type MemberInviteAccess = {
  __typename?: 'MemberInviteAccess';
  /** May ask an owner to approve a set of invitations */
  canRequestApproval: Scalars['Boolean']['output'];
  /** May send invitations. Owners can; admins can only when the company has no owner */
  canSend: Scalars['Boolean']['output'];
  /** May see the invite list, quotes and requests */
  canView: Scalars['Boolean']['output'];
  /** The owners an approval request goes to */
  ownerNames: Array<Scalars['String']['output']>;
};

/** What the public join page shows for one link */
export type MemberInviteJoinInfo = {
  __typename?: 'MemberInviteJoinInfo';
  companyName?: Maybe<Scalars['String']['output']>;
  invitedByName?: Maybe<Scalars['String']['output']>;
  /** The Slack name the invitation was sent to */
  inviteeName?: Maybe<Scalars['String']['output']>;
  /** Whether signing in with Slack is configured on this server */
  slackSignInAvailable: Scalars['Boolean']['output'];
  state: MemberInviteJoinState;
};

export enum MemberInviteJoinState {
  Accepted = 'ACCEPTED',
  Expired = 'EXPIRED',
  NotFound = 'NOT_FOUND',
  Pending = 'PENDING',
  Revoked = 'REVOKED',
}

/** What inviting these people would cost at most. Seats are charged only when someone accepts, so this is a ceiling */
export type MemberInviteQuote = {
  __typename?: 'MemberInviteQuote';
  count: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
  /** Seats in use right now */
  currentSeats: Scalars['Int']['output'];
  /** More people selected than seats remaining */
  exceedsSeats: Scalars['Boolean']['output'];
  /** count × unit amount, per month */
  monthlyCeiling: Scalars['Float']['output'];
  /** (seats in use + count) × unit amount, per month */
  newTotalCeiling: Scalars['Float']['output'];
  /** The seat limit, or null when unlimited */
  seatLimit?: Maybe<Scalars['Int']['output']>;
  /** Seats left, or null when unlimited */
  seatsRemaining?: Maybe<Scalars['Int']['output']>;
  unitAmount: Scalars['Float']['output'];
};

export enum MemberInviteStatus {
  Accepted = 'ACCEPTED',
  Expired = 'EXPIRED',
  Pending = 'PENDING',
  Revoked = 'REVOKED',
}

export type MergeCarryOverPreview = {
  __typename?: 'MergeCarryOverPreview';
  /** Custom-field values the target has none of; they are filled from the source. */
  fieldValuesCarried: Scalars['Int']['output'];
  /** The target has no manager and the source does; it moves. */
  managerCarried: Scalars['Boolean']['output'];
  /** The target has no CS status and the source does; it moves. */
  statusCarried: Scalars['Boolean']['output'];
  /** Tags the source has that the target lacks; they are added. */
  tagsAdded: Scalars['Int']['output'];
};

export type MergeOrganizationPreview = {
  __typename?: 'MergeOrganizationPreview';
  /** What comes across by rule rather than by a choice in the preview: tags, custom fields, manager and status. The target always wins a conflict. */
  carryOver: MergeCarryOverPreview;
  contactConflicts: Array<ContactConflict>;
  counts: MergePreviewCounts;
  featureFlagConflicts: Array<FeatureFlagConflict>;
  fieldConflicts: Array<FieldConflict>;
  /** Comparable fields where both clients hold the same non-empty value */
  matchingFields: Array<FieldMatch>;
  source: Organization;
  target: Organization;
};

export type MergeOrganizationsInput = {
  contactResolutions?: InputMaybe<Array<ContactResolutionInput>>;
  featureFlagResolutions?: InputMaybe<Array<FeatureFlagResolutionInput>>;
  fieldResolutions: Array<FieldResolutionInput>;
  reason: Scalars['String']['input'];
  sourceId: Scalars['ID']['input'];
  targetId: Scalars['ID']['input'];
};

export type MergeOrganizationsResult = {
  __typename?: 'MergeOrganizationsResult';
  mergedAt?: Maybe<Scalars['DateTime']['output']>;
  mergedBy?: Maybe<Scalars['String']['output']>;
  mergedCounts: MergedCounts;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  targetOrganization: Organization;
};

export type MergePreviewCounts = {
  __typename?: 'MergePreviewCounts';
  sourceContacts: Scalars['Int']['output'];
  sourceEmails: Scalars['Int']['output'];
  sourceFeatureFlags: Scalars['Int']['output'];
  sourceInvoices: Scalars['Int']['output'];
  sourcePaymentReminders: Scalars['Int']['output'];
  sourcePricingRules: Scalars['Int']['output'];
  sourceRenewalActions: Scalars['Int']['output'];
  sourceSubscriptions: Scalars['Int']['output'];
};

export type MergedCounts = {
  __typename?: 'MergedCounts';
  billingTimingHistoryMoved?: Maybe<Scalars['Int']['output']>;
  contactsDeleted: Scalars['Int']['output'];
  contactsMoved: Scalars['Int']['output'];
  emailsMoved: Scalars['Int']['output'];
  featureFlagsDeleted: Scalars['Int']['output'];
  featureFlagsMoved: Scalars['Int']['output'];
  fieldValuesCarried?: Maybe<Scalars['Int']['output']>;
  invoicesMoved: Scalars['Int']['output'];
  lifecycleEventsMoved?: Maybe<Scalars['Int']['output']>;
  paymentRemindersMoved: Scalars['Int']['output'];
  priceOverrideHistoryMoved?: Maybe<Scalars['Int']['output']>;
  pricingRulesMoved: Scalars['Int']['output'];
  renewalActionsMoved: Scalars['Int']['output'];
  subscriptionsMoved: Scalars['Int']['output'];
  tagsCarried?: Maybe<Scalars['Int']['output']>;
  versionEntriesMoved?: Maybe<Scalars['Int']['output']>;
};

/** Message-level triage verdict. */
export enum MessageTriageVerdict {
  Pending = 'PENDING',
  Qualified = 'QUALIFIED',
  Rejected = 'REJECTED',
}

export type MetadataEntryInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type Meter = {
  __typename?: 'Meter';
  /** Which number in the period is rated: MAX, TOTAL or CLOSING. Null until migration 0028 has run — resolve via measurement-axis.util. */
  billedValue?: Maybe<BilledValue>;
  /** Category or group this meter belongs to (e.g., "capacity", "usage", "custom") */
  category?: Maybe<Scalars['String']['output']>;
  /** When this meter was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** User ID who created this meter */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** When this meter was deprecated; null = active */
  deprecatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Description of what this meter measures */
  description?: Maybe<Scalars['String']['output']>;
  /** Human-readable name for this meter */
  displayName: Scalars['String']['output'];
  /** Unique identifier for the meter */
  id: Scalars['ID']['output'];
  /** Whether this meter is currently available for use */
  isActive: Scalars['Boolean']['output'];
  /** Default measurement mode (overridable per component) */
  measurementMode?: Maybe<MeasurementMode>;
  /** If deprecated, the ID of the replacement meter definition */
  migrationTargetId?: Maybe<Scalars['String']['output']>;
  /** Resets each period (PER_PERIOD) or carries forward (STANDING). Null until migration 0028 has run — resolve via measurement-axis.util. */
  resetBehaviour?: Maybe<ResetBehaviour>;
  /** URL-safe identifier, unique per tenant */
  slug?: Maybe<Scalars['String']['output']>;
  /** Singular unit label shown in UIs (e.g. "seat", "GB") */
  unitLabel?: Maybe<Scalars['String']['output']>;
  /** Plural unit label shown in UIs (e.g. "seats", "GB") */
  unitLabelPlural?: Maybe<Scalars['String']['output']>;
  /** Whether this meter counts whole units or decimal amounts */
  unitType?: Maybe<VariableUnitType>;
  /** When this meter was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User ID who last updated this meter */
  updatedBy?: Maybe<Scalars['String']['output']>;
  /** The meter key / type identifier (e.g., "user", "storage", "api_calls") */
  variableType: Scalars['String']['output'];
};

export type MeterFilterInput = {
  /** Filter by category */
  category?: InputMaybe<Scalars['String']['input']>;
  /** Filter by active status */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Search in display name or description */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Filter by variable type */
  variableType?: InputMaybe<Scalars['String']['input']>;
};

/** Mid-period integration health signals for metered usage (Phase 6). Surfaces decaying integrations before period close, not only unverified readings after seal. */
export type MeteredUsageIntegrationHealth = {
  __typename?: 'MeteredUsageIntegrationHealth';
  /** Usage events ACCEPTED in the lookback window. */
  acceptedEventCount: Scalars['Int']['output'];
  /** Closed readings still AWAITING manual entry. */
  awaitingManualCount: Scalars['Int']['output'];
  /** Lookback window in hours used for the silent/event counts. */
  lookbackHours: Scalars['Int']['output'];
  /** Usage events REJECTED in the lookback window. */
  rejectedEventCount: Scalars['Int']['output'];
  /** Open (live) API-mode meters with no increments in the lookback window. */
  silentOpenMeterCount: Scalars['Int']['output'];
  /** Closed readings currently UNVERIFIED. */
  unverifiedReadingCount: Scalars['Int']['output'];
};

/** Operator-facing rollup of open metered-usage work for the dashboard tile (R7). */
export type MeteredUsageOperationalSummary = {
  __typename?: 'MeteredUsageOperationalSummary';
  /** MANUAL readings still AWAITING operator entry. */
  awaitingManualCount: Scalars['Int']['output'];
  /** Invoices in DRAFT held for usage. */
  heldInvoiceCount: Scalars['Int']['output'];
  /** Open MANUAL_USAGE + UNVERIFIED_USAGE tasks. */
  openUsageTaskCount: Scalars['Int']['output'];
  /** API readings marked UNVERIFIED (silent integration). */
  unverifiedCount: Scalars['Int']['output'];
};

export type MetricBreakdown = {
  __typename?: 'MetricBreakdown';
  amount: Scalars['Float']['output'];
  changeFromPreviousMonth?: Maybe<Scalars['Float']['output']>;
  count: Scalars['Int']['output'];
  /** Trailing monthly amounts (oldest first, ending at the drill-down month) in the reporting currency — drives the KPI-card sparkline. */
  history?: Maybe<Array<Scalars['Float']['output']>>;
  percentageChange?: Maybe<Scalars['Float']['output']>;
};

/** Type of metric for monthly drill-down analysis */
export enum MetricType {
  Acquisition = 'ACQUISITION',
  Arr = 'ARR',
  Churn = 'CHURN',
  Contraction = 'CONTRACTION',
  Expansion = 'EXPANSION',
  Mrr = 'MRR',
  Nrr = 'NRR',
  Reactivation = 'REACTIVATION',
  Renewal = 'RENEWAL',
}

/** Which kind of pin a bulk migration is rewriting. */
export enum MigrationKind {
  Bundle = 'BUNDLE',
  Component = 'COMPONENT',
  Module = 'MODULE',
}

/** When a subscription migration takes effect. */
export enum MigrationTiming {
  Backdated = 'BACKDATED',
  MidCycleProrated = 'MID_CYCLE_PRORATED',
  NextRenewal = 'NEXT_RENEWAL',
}

export type MissingRateInfo = {
  __typename?: 'MissingRateInfo';
  /** Currency code */
  currency: Scalars['String']['output'];
  /** Date if historical */
  date?: Maybe<Scalars['String']['output']>;
};

/** Count of PUBLISHED components for a given pricing model type. */
export type ModelTypeCount = {
  __typename?: 'ModelTypeCount';
  count: Scalars['Int']['output'];
  modelType: PricingModelType;
};

export type Module = {
  __typename?: 'Module';
  /** Active pricing rules only (excludes inactive/draft rules) */
  activePricing?: Maybe<Array<PricingRule>>;
  /** Full history across all versions in the chain, newest first. */
  allVersionsSummary: Array<ModuleVersionSummary>;
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  archivedBy?: Maybe<Scalars['String']['output']>;
  /** Subscription periods available for this module */
  availablePeriods: Array<SubscriptionPeriod>;
  bundleModules?: Maybe<Array<BundleModule>>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** When this version took effect. A version runs until the next one in its lineage begins, so there is no stored end date. Null on a draft that has never published. */
  effectiveFrom?: Maybe<Scalars['DateTime']['output']>;
  featureFlags?: Maybe<Array<ModuleFeatureFlag>>;
  id: Scalars['ID']['output'];
  /** Stable identity shared by every version in this chain (the id of its root version). Group by this to address one plan rather than one version of it. */
  lineageId?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  /** The _id of the prior published version document. Null on v1. */
  previousVersionId?: Maybe<Scalars['ID']['output']>;
  pricing?: Maybe<Array<PricingRule>>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  publishedBy?: Maybe<Scalars['String']['output']>;
  status: EntityStatus;
  tiers: Array<ModuleTier>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
  /** Variable components referenced by this module version. */
  variableComponentRefs: Array<ModuleVariableComponentRef>;
  /** Version number. Each publishNewVersion call creates a new document with version + 1. */
  version: Scalars['Int']['output'];
  /** Convenience log of prior version entries on this document. */
  versionHistory: Array<ModuleVersionEntry>;
};

export type ModuleFeatureFlag = {
  __typename?: 'ModuleFeatureFlag';
  featureFlag: FeatureFlag;
  featureFlagId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  module: Module;
  moduleId: Scalars['String']['output'];
};

export type ModuleFilterInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EntityStatus>;
  tierId?: InputMaybe<Scalars['String']['input']>;
  tierName?: InputMaybe<Scalars['String']['input']>;
  tierStatus?: InputMaybe<EntityStatus>;
};

export type ModulePricingBreakdown = {
  __typename?: 'ModulePricingBreakdown';
  moduleId: Scalars['String']['output'];
  moduleName: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  /** Selected module tier whose price was applied; null = base/untiered (86cabjuxn). */
  selectedTierId?: Maybe<Scalars['ID']['output']>;
};

export type ModuleTier = {
  __typename?: 'ModuleTier';
  /** Active pricing rules only (excludes inactive/draft rules) */
  activePricing?: Maybe<Array<PricingRule>>;
  description?: Maybe<Scalars['String']['output']>;
  /** Effective (cumulative) feature flag ids for this tier: the union of featureFlagIds across every tier whose order is ≤ this tier order (Tier 3 ⊇ Tier 2 ⊇ Tier 1). Resolved field. */
  effectiveFeatureFlagIds?: Maybe<Array<Scalars['String']['output']>>;
  /** Incremental feature flags this tier ADDS over the lower tiers. */
  featureFlagIds?: Maybe<Array<Scalars['String']['output']>>;
  featureFlags?: Maybe<Array<ModuleFeatureFlag>>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** Rank within the module (0-based). Lower = smaller/cheaper tier. Drives the cumulative effective-flag union and the per-tier price authoring order. */
  order: Scalars['Int']['output'];
  pricing?: Maybe<Array<PricingRule>>;
  status: EntityStatus;
};

export type ModuleTierSelectionInput = {
  moduleId: Scalars['ID']['input'];
  /** Selected module tier (ModuleTier id); omit/null for the base/untiered price. */
  tierId?: InputMaybe<Scalars['ID']['input']>;
};

export type ModuleVariableComponentRef = {
  __typename?: 'ModuleVariableComponentRef';
  autoIncludeOnSubscribe: Scalars['Boolean']['output'];
  componentId: Scalars['ID']['output'];
  componentVersion: Scalars['Int']['output'];
  includedQuantity?: Maybe<Scalars['Int']['output']>;
  includedTransactionCount?: Maybe<Scalars['Int']['output']>;
  /** Per-term inclusion overrides; the matching term wins over the period-agnostic inclusion. */
  inclusionByPeriod?: Maybe<Array<InclusionPeriodEntry>>;
  notes?: Maybe<Scalars['String']['output']>;
};

export type ModuleVersionEntry = {
  __typename?: 'ModuleVersionEntry';
  changedAt: Scalars['DateTime']['output'];
  changedBy?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  version: Scalars['Int']['output'];
};

/** Published-version summary used in cross-version history chains. */
export type ModuleVersionSummary = {
  __typename?: 'ModuleVersionSummary';
  /** Differences against the version this one was branched from. */
  changes: Array<VersionChange>;
  /** When this version took effect — the start of its window. The lineage is ordered by THIS, not by publishedAt (when the document was written down) and not by version number. A version's window runs until the next one begins. */
  effectiveFrom?: Maybe<Scalars['DateTime']['output']>;
  /** This version's own document id. Each version is a separate document, so this is what a caller pins or migrates onto — the version NUMBER is not addressable on its own. */
  id?: Maybe<Scalars['ID']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  publishedBy?: Maybe<Scalars['String']['output']>;
  /** DRAFT / PUBLISHED / ARCHIVED. Read this rather than inferring from the version number: numbering is immutable mint order, so a retro-authored version holds the highest number in its lineage while being archived and first in time. */
  status?: Maybe<Scalars['String']['output']>;
  version: Scalars['Int']['output'];
  versionHistory: Array<ModuleVersionEntry>;
};

export type MonthlyDrillDown = {
  __typename?: 'MonthlyDrillDown';
  /** Which baseline the per-card deltas were measured against: FULL_MONTH for a closed month, SAME_DAY_RANGE for an in-progress one (compared against the same elapsed span of the previous month, so day 10 meets day 10). Label the comparison with this. */
  comparisonBasis: Scalars['String']['output'];
  metricType: MetricType;
  month: Scalars['String']['output'];
  /** ISO 4217 currency every amount in this payload is denominated in (summary, subscription amounts, total impact). The tenant's reporting currency; conversion happens server-side. */
  reportingCurrency: Scalars['String']['output'];
  subscriptions: MonthlySubscriptionConnection;
  summary: MonthlyMetricsSummary;
  totalImpact: MonthlyImpact;
};

export type MonthlyImpact = {
  __typename?: 'MonthlyImpact';
  arr: Scalars['Float']['output'];
  mrr: Scalars['Float']['output'];
  nrr?: Maybe<Scalars['Float']['output']>;
};

export type MonthlyMetricsSummary = {
  __typename?: 'MonthlyMetricsSummary';
  acquisition: MetricBreakdown;
  churn: MetricBreakdown;
  contraction: MetricBreakdown;
  expansion: MetricBreakdown;
  /** Returning customers. Computed by the summary all along but previously unexposed, so the drill-down cards could not account for the whole of the waterfall. */
  reactivation: MetricBreakdown;
  renewal: MetricBreakdown;
};

export type MonthlySubscriptionConnection = {
  __typename?: 'MonthlySubscriptionConnection';
  edges: Array<MonthlySubscriptionEdge>;
  pageInfo: PageInfo;
};

export type MonthlySubscriptionEdge = {
  __typename?: 'MonthlySubscriptionEdge';
  cursor: Scalars['String']['output'];
  node: MonthlySubscriptionNode;
};

export type MonthlySubscriptionNode = {
  __typename?: 'MonthlySubscriptionNode';
  amount: Scalars['Float']['output'];
  endDate: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  organizationName: Scalars['String']['output'];
  period: Scalars['String']['output'];
  startDate: Scalars['DateTime']['output'];
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type MovementBucket = {
  __typename?: 'MovementBucket';
  amount: Scalars['Float']['output'];
  count: Scalars['Int']['output'];
};

export type MovementSet = {
  __typename?: 'MovementSet';
  churn: MovementBucket;
  contraction: MovementBucket;
  expansion: MovementBucket;
  /** newBusiness + expansion + reactivation − contraction − churn, in the reporting currency. */
  net: Scalars['Float']['output'];
  newBusiness: MovementBucket;
  reactivation: MovementBucket;
};

/** Recommended Y-axis scaling for the MRR movement chart (SHARED = bars and trend line on one axis; SEPARATE = bars on a zoomed secondary axis). */
export enum MrrAxisScaleMode {
  Separate = 'SEPARATE',
  Shared = 'SHARED',
}

export type Mutation = {
  __typename?: 'Mutation';
  /** Create the catalog rows one proposed cluster implies: a new product with its whole price history, or the missing past versions of an existing one. The newest price becomes the PUBLISHED head and closed windows land ARCHIVED with their own effective dates — both resolve, so the client’s invoices start matching immediately. */
  acceptCatalogGap: AcceptCatalogGapResultEntity;
  acceptDriveFolderSuggestions: Array<AcceptDriveFolderSuggestionResult>;
  /** Accept an invitation to join a tenant */
  acceptInvitation: UserTenant;
  /** Accept a Slack invitation. The signed-in user must hold the Slack identity it was sent to */
  acceptMemberInvite: AcceptMemberInviteResult;
  /** Accept an event’s suggestion as it stands. Workspace admins and owners only. */
  acceptProductEventSuggestion: ProductEventType;
  activateFeatureFlag: FeatureFlag;
  activateFeatureFlagCategory: FeatureFlagCategory;
  /** Activate a meter for use */
  activateMeter: Meter;
  /** Turn OKRs on. Requires the OKR entitlement; Slack is recommended, not required. Tenant admins only */
  activateOkrModule: OkrActivationResultType;
  activatePricingRule: PricingRule;
  /** Fire the ACTIVATION trigger: the customer has gone live. Re-anchors the term to the go-live date, opens the usage counters against it, records the subscription as created at that date (so the run-rate starts when service does, not at signature), and bills what go-live owes. Idempotent — a second call returns alreadyActive rather than raising a second invoice. Firing it on a subscription whose clock started at sale is a no-op, not an error. */
  activateSubscription: SubscriptionActivationResult;
  /** Add a currency to a region */
  addCurrencyToRegion: Region;
  addFeatureFlagToBundle: Bundle;
  addFeatureFlagToTier: Module;
  /** Admins and owners only. */
  addKnowledgeDocument: KbArticle;
  addLibraryDocumentVersion: LibraryDocumentEntity;
  addModuleTier: Module;
  addModuleToBundle: Bundle;
  /** Link the work behind a bet. https only; the same URL twice is a no-op */
  addOkrHypothesisLink: OkrHypothesisWriteResult;
  /** Add another tenant user to an existing chat session. */
  addParticipantToChat: ChatCreationSession;
  addPipelineStage: CrmPipeline;
  /** Add a new market (Region) to a PUBLISHED module or bundle additively — writes the market's base and component prices in place without bumping the product version. Rejected if the product already has any price in that market (that is an edit, which requires a new version). Additive by nature, so it cannot affect existing subscriptions. */
  addProductMarket: AddProductMarketResult;
  addProspectToPipeline: CrmLead;
  /** Add a SUBSCRIPTION-scoped price override per v4 §8.4. The subscription must be active, the component must be referenced via the subscription's pin chain, and pricesByCurrency must cover the subscription's locked currency. Appends ADD_SUBSCRIPTION_PRICE to versionHistory. */
  addSubscriptionScopedPrice: VariableComponentPrice;
  /** Add suggested people as real contacts of the organization — attaching an existing unassigned contact where the suggestion had one, creating a new contact otherwise. Every address is re-checked against the record’s domain server-side, and selections that cannot be added are reported in `skipped` rather than failing the batch. */
  addSuggestedOrganizationContacts: AddSuggestedContactsResult;
  /** Validate a Google Drive folder and add it to the synced folders list. */
  addSyncFolder: GoogleDriveConnectionEntity;
  addTaskAssignee: Task;
  addTaskAttachment: Task;
  addTaskExternalLink: Task;
  /** Add several people to a team. Adding someone already on it does nothing */
  addTeamMembers: TeamDetail;
  addUserToTenant: UserTenant;
  /** Add quantity to a Variable Component on a subscription. Idempotent by idempotencyKey (FR-12). */
  addVariableUsage: SubscriptionVariableUsage;
  /** Operator adjustment of a component count on a subscription (e.g. provisioned seats). ADVANCE components with DAILY/FULL_MONTH proration post a prorated mid-cycle EXPANSION invoice for positive differences; ARREARS counts bill at period end; NONE-proration deltas queue for the next renewal. Records an EXPANDED/CONTRACTED lifecycle event. */
  adjustComponentUsage: ComponentUsageAdjustment;
  /** Move the guided tour: next, back, skip, pause, resume, or goto a step. Owner only. fromStep is the step the caller saw; a move from any other step changes nothing. */
  advanceOnboardingTour: AssistantOnboardingState;
  /** Analyze CSV/Excel columns and suggest field mappings using AI */
  analyzeColumns: AnalyzeColumnsResult;
  /** "Looks like an invoice": true marks it Invoice, false dismisses it. */
  answerDocumentSuggestion: Scalars['Boolean']['output'];
  /** Answer "Move it to Clients?": true moves, false keeps it. */
  answerDriveFolderMoveOffer: OrganizationDriveFolder;
  /** Write every part of a client's answers the client record does not hold yet. Parts that cannot be written are named in the error; the rest are applied. */
  applyAllFormClientSubmission: FormClientSubmission;
  /** Spend some or all of a credit note against an outstanding invoice. Clamped by both the credit left and the invoice's balance, so a large credit can be spread over several invoices and a small one leaves the invoice partly open. */
  applyCreditNote: ApplyCreditNoteResult;
  /** Write one part of a client's answers to the client record. */
  applyFormClientSubmission: FormClientSubmission;
  /** Apply a library definition (snapshotting its currency-resolved terms, §8.3/§8.5) or a one-off discount (§8.6) to one target on a subscription. Takes effect from the next invoice. */
  applySubscriptionDiscount: DiscountInstanceEntity;
  /** Approve a request and send its invitations (owners) */
  approveInviteRequest: ApproveInviteRequestResult;
  archiveAgentSession: AgentSessionType;
  /** Archive a check-in. Its history is kept; it never runs again. */
  archiveCheckin: Checkin;
  archiveContractTemplate: Scalars['Boolean']['output'];
  /** Archive a pipeline. One that still has deals needs input.moveDealsToPipelineId (another pipeline the caller can access). */
  archiveCrmPipeline: CrmPipeline;
  /** Archive a definition: blocks future use AND terminates every active sourced instance prospectively (§8.12). Run discountDefinitionArchiveCheck first and show the affected list. */
  archiveDiscountDefinition: DiscountDefinitionEntity;
  archiveForm: Form;
  archivePipelineStage: CrmPipeline;
  archiveTaxRate: TaxRate;
  /** Archive a team. Refused while a feature still depends on it; membership and history are kept */
  archiveTeam: TeamDetail;
  /** Archive a Variable Component. PRD §12.2: components are never hard-deleted because billing snapshots reference them. */
  archiveVariableComponent: VariableComponent;
  assignTask: Task;
  /** Assign to an agent and/or a team. An omitted argument is left as is; null clears it. */
  assignTicket: SupportTicket;
  /** Sell a subscription under a contract: the contract's term becomes the subscription's commitmentEndDate, distinct from endDate (the billing period boundary the renewal cron advances). Refused when the term does not divide into the billing period, when the subscription has autoRenew off while the term still has periods to run, when the contract belongs to another client, or when the subscription is already sold under a different contract — detach that one first. Attaching the contract that is already attached is a no-op. The contract's startsAt never moves service or invoice dates. */
  attachContractToSubscription: OrganizationSubscription;
  /** Take a private copy of a synced Drive file for one email. Returns the stored file id for `attachmentFileIds`. */
  attachDriveFileToEmail: DriveAttachmentFileResult;
  /** Bind a Key Result to a Revvly metric, or move it to a different one */
  attachOkrKeyResultMetric: OkrKeyResult;
  /** Attach a standalone contact to a prospect or client. Refused when the contact already belongs to a company. Unlike adding a same-domain suggestion, the address does not have to match the record's domain — the operator picked the company. */
  attachOrganizationContact: OrganizationContact;
  /** Attach a Variable Component directly to an ACTIVE subscription (PRD §18.2). The component must resolve a price in the locked currency; pass pricesByCurrency to write an inline subscription-scoped price when no default/module/bundle price covers it. Initializes the usage record and appends ADD_COMPONENT to versionHistory. */
  attachVariableComponentToSubscription: OrganizationSubscription;
  /** Manually trigger analytics snapshot backfill for historical data. Use this after importing historical subscriptions to generate MRR trend data. */
  backfillAnalyticsSnapshots: BackfillSnapshotsResult;
  /** Backfill historical exchange rates (requires Fixer.io paid tier) */
  backfillExchangeRates: BackfillExchangeRatesResult;
  backfillOrganizationEmails: OrganizationEmailBackfillResult;
  /** Send every existing record the endpoint subscribes to (up to a limit), so a new destination starts complete. Admin only. */
  backfillOutboundWebhookEndpoint: OutboundWebhookBackfillOutcome;
  /** Begin connecting ClickUp. Returns the URL to send the admin to; the signed state is minted server-side */
  beginClickupConnect: Scalars['String']['output'];
  /** Begin a Slack install. Returns the URL to send the admin to; the signed state is minted server-side */
  beginSlackInstall: Scalars['String']['output'];
  /** Bind the signed-in user to a tenant for inbound MCP OAuth sessions. Called from the OAuth consent page before the authorization code is issued. */
  bindMcpOauthTenant: McpOauthBinding;
  /** Bulk approve multiple renewal actions */
  bulkApproveRenewalActions: Scalars['Int']['output'];
  bulkDeleteApplicationByIncubator: Scalars['String']['output'];
  bulkDeleteInvoices: BulkInvoiceActionResult;
  /** Admins and owners only. Permanently deletes many articles and their passages. Refuses, changing nothing, when the number matched is not expectedCount. */
  bulkDeleteKnowledgeArticles: KbBulkResult;
  /** Permanently delete many tasks (irreversible); returns the count deleted. */
  bulkDeleteTasks: Scalars['Int']['output'];
  /** Disable a feature flag for multiple organizations at once */
  bulkDisableOrganizationFeatureFlag: BulkOperationResult;
  /** Enable a feature flag for multiple organizations at once */
  bulkEnableOrganizationFeatureFlag: BulkOperationResult;
  /** Bulk-enter quantities for many open readings (Phase 6 grid). Each row is independent. */
  bulkEnterUsageReadings: BulkEnterUsageReadingsResult;
  /** Admins and owners only. Takes many articles out of search (reversible). Refuses, changing nothing, when the number matched is not expectedCount. */
  bulkExcludeKnowledgeArticles: KbBulkResult;
  bulkMarkInvoicesPaid: BulkInvoiceActionResult;
  /** Migrate many subscriptions in a single call. Each subscription is processed independently; per-subscription failures do not block the rest. */
  bulkMigrateSubscriptions: BulkMigrationResult;
  /** Regenerate each selected invoice (PDF, payment terms and, where it applies, the recomputed content) through the same path as the invoice page's "Regenerate PDF". One invoice that cannot be regenerated (a draft, one that is gone) is reported in `failed` and never stops the others. */
  bulkRegenerateInvoices: BulkInvoiceActionResult;
  /** Bulk reject multiple renewal actions */
  bulkRejectRenewalActions: Scalars['Int']['output'];
  /** Bulk resolve all pending discrepancies */
  bulkResolveDiscrepancies: BulkResolveResult;
  /** Admins and owners only. Decides who may read many articles, as if set one by one. Refuses, changing nothing, when the number matched is not expectedCount. */
  bulkSetKnowledgeArticleAudience: KbBulkResult;
  /** Archive or unarchive many tasks; returns the count changed. */
  bulkSetTasksArchived: Scalars['Int']['output'];
  /** Bulk sync feature flags to main app for multiple organizations */
  bulkSyncFeatureFlagsToMainApp: BulkOperationResult;
  /** Add or remove tags, assign or clear the customer-success manager, and set or clear the customer-success status on several clients at once. A client that cannot take a change is reported and the others carry on. */
  bulkUpdateClients: BulkUpdateClientsResult;
  bulkUpdatePaymentStatus: Array<Scalars['ID']['output']>;
  cancelContractSendPlan: ContractSendPlan;
  /** Cancel a subscription pendingMigration before it is applied at the next renewal. Appends a CANCEL_PENDING_MIGRATION versionHistory entry. */
  cancelPendingMigration: OrganizationSubscription;
  cancelSignatureRequest: ContractRequest;
  /** Cancel a subscription at the end of its current period. A subscription inside a BINDING committed term whose remaining periods are not yet invoiced needs an early-termination policy — from the contract, or passed here — and is refused without one. */
  cancelSubscription: OrganizationSubscription;
  /** Cancel an active instance before natural expiry. Prospective — the next invoice is generated without it; the record is retained in history (§8.11). */
  cancelSubscriptionDiscount: DiscountInstanceEntity;
  /** Admins and owners only. Stops a run for good; what it did is kept. */
  cancelSupportCompare: SupportCompareRun;
  /** Admins and owners only. Stops an import between conversations. */
  cancelSupportImport: SupportImportRun;
  cancelTask: Task;
  /** Carry into a Key Result of a later cycle. Cycle owners, at close */
  carryOkrHypothesis: OkrHypothesisWriteResult;
  /** Change a subscription's plan — switch the bundle and/or the set of modules (multi-module; not a version bump). Recomputes basePrice, re-resolves auto-included variable components, and records a CHANGE_PLAN versionHistory entry. Omit bundleId to leave the bundle unchanged, pass null to clear it; omit moduleIds to leave modules unchanged, pass an array to replace the set. MID_CYCLE_PRORATED applies immediately (prorated); NEXT_RENEWAL schedules the change for the next renewal. Pass legacyVersionPin to move the subscription onto an ARCHIVED (past) catalog version — grandfathering, which is otherwise refused. */
  changeSubscriptionPlan: OrganizationSubscription;
  /** Charge an unpaid invoice to the client's card now, including one issued before the card was saved or whose retries ran out. Admin only. */
  chargeInvoiceNow: InvoiceChargeView;
  /** Manually trigger an anomaly check and send alerts if issues detected. */
  checkAnomaliesNow: Scalars['Boolean']['output'];
  /** Look for features clients use that the support documentation never mentions: one search per feature (at most 20), so it is an action, not a read. Workspace admins and owners only. */
  checkProductFeatureDocs: ProductFeatureDocCheck;
  /** Bring someone back: they are asked again from today. True if anything was open (tenant admins) */
  clearCheckinAway: Scalars['Boolean']['output'];
  /** Stop a category’s automatic action. What it did stays in the log. */
  clearInboxCategoryPolicy: Scalars['Boolean']['output'];
  /** Clear all pricing combinations cache entries for the current tenant */
  clearPricingCache: Scalars['Boolean']['output'];
  /** Clear all subscription data from the database (use with caution) */
  clearSubscriptionData: Scalars['Boolean']['output'];
  /** Close a cycle that is being scored. It becomes read-only. Refused while Key Results are unscored unless confirmUnscored is set */
  closeOkrCycle: OkrCycle;
  /** Close with a resolution. Closing a closed ticket is a no-op. */
  closeTicket: SupportTicket;
  /** Create the subscriptions a reviewed plan proposes and link their invoices. The plan is rebuilt server-side and checked against the approved planHash, so what is applied is what was reviewed. Everything it writes is stamped with an importBatchId that reverses it. */
  commitSubscriptionPlan: CommitSubscriptionPlanResultEntity;
  commitSyncedInvoices: CommitSyncResultEntity;
  /** Mark an onboarding step as complete */
  completeOnboardingStep: CompleteStepResult;
  completeTask: Task;
  /** Record the verdict: outcome, result and learning */
  concludeOkrHypothesis: OkrHypothesisWriteResult;
  /** Confirm proposed Calendly email matches in bulk. Tenant admin/owner only. */
  confirmCalendlyMatches: CalendlyMappingResult;
  /** Confirm email matches, linking each Revvly user to the ClickUp account. Admin only */
  confirmClickupMatches: ClickUpConfirmResult;
  /** Confirm an email change using the token from the verification link (public) */
  confirmEmailChange: ConfirmEmailChangeResult;
  /** Confirm a pending pricing draft (PRD §22): runs the same validation + publish path as the equivalent manual mutation. Supports VARIABLE_COMPONENT_CREATE drafts carrying an executable component payload. */
  confirmPricingDraft: PricingDraftConfirmationResult;
  /** Confirm proposed email matches in bulk */
  confirmSlackMatches: SlackMappingResult;
  /** Step 2, after the PUT: checks size and contents, then returns the attachment to send with replyToTicket. */
  confirmSupportAttachmentUpload: SupportAttachment;
  /** Confirm file upload completion after uploading to the presigned URL */
  confirmUpload: StoredFileEntity;
  /** Admins and owners only. Sync the Docs under a ClickUp Space, Folder or List, or one Doc, through the workspace's ClickUp connection. Checked hourly by default; start a sync with crawlKnowledgeSource. */
  connectClickUpKnowledgeSource: KnowledgeSource;
  /** Admins and owners only. Connect an Intercom or Zendesk help centre with an API token; the token is checked first and stored encrypted. */
  connectKnowledgeSource: KnowledgeSource;
  /** Connect Stripe with a restricted key. Revvly checks the key and registers its webhook on the account. Admin only. */
  connectStripeWithKey: PaymentConnectionView;
  convertCrmLead: CrmLead;
  /** Correct a sealed reading before its invoice issues (R8). Supersedes the original and re-rates any attached draft. */
  correctUsageReading: UsageReading;
  /** Admins and owners only. Starts reading the site and returns at once; the source shows its progress. */
  crawlKnowledgeSource: KnowledgeSource;
  /** Create a route, or update the one already holding this event-type URI. Tenant admin/owner only — an enabled route lets a public link write into the CRM. */
  createBookingIntakeRoute: BookingIntakeRoute;
  createBundle: Bundle;
  /** Branch an editable DRAFT copy from a published bundle version. The source version stays live; the draft (version+1) clones the base price and component prices so it starts from the same data, and can be edited then published in place via publishBundleDraftVersion. */
  createBundleDraftVersion: Bundle;
  /** Create a check-in. Proves the bot can post to the chosen channel (and posts a line there) before saving. */
  createCheckin: Checkin;
  createContactRole: ContactRole;
  createContractTemplate: ContractTemplate;
  /** Start a contract as a draft. It cannot be sent until it is published, and saves unfinished. */
  createContractTemplateDraft: ContractTemplate;
  createCrmDocumentUploadUrl: CrmDocumentUploadTarget;
  createCrmEmailTemplate: CrmEmailTemplate;
  createCrmLead: CrmLead;
  createCrmNote: CrmNote;
  createCrmPipeline: CrmPipeline;
  createCrmTag: CrmTag;
  createCustomField: CustomFieldDefinition;
  /** Create a Custom Pricing Agreement as DRAFT. Publish separately when negotiated. */
  createCustomPricingAgreement: CustomPricingAgreement;
  /** Create a reusable discount definition (§8.1). Name is unique per tenant. */
  createDiscountDefinition: DiscountDefinitionEntity;
  /** Create a plain folder (the folder browser "New folder"). */
  createDriveFolder: DriveCreatedFolder;
  /** Queue a folder for every client or prospect without one. Returns how many. */
  createDriveFoldersForUnmapped: Scalars['Int']['output'];
  createEmailSignature: EmailSignature;
  createFeatureFlag: FeatureFlag;
  createFeatureFlagCategory: FeatureFlagCategory;
  createForm: Form;
  /** Make a link to a published form for one client. The link is the credential: anyone holding it can answer, once. */
  createFormClientLink: FormClientSubmission;
  createGeoRegion: GeoRegion;
  /** Author a version of a bundle that existed BEFORE the ones already stored — the legacy-pricing case, where a plan predates Revvly and each migrated client has to be pinnable to the pricing that applied to them. Returns a DRAFT carrying the operator's `effectiveFrom`, spliced into the lineage by date (it takes the next free version number, since `version` is mint order, not chronological position). Cloned from whichever version was in force at `effectiveFrom`, or from `basedOnVersion` when given; edit its prices to the historical figures, then publish with publishHistoricalBundleVersion. The current head is untouched. */
  createHistoricalBundleVersion: Bundle;
  /** Author a version of a module that existed BEFORE the ones already stored — the legacy-pricing case, where a plan predates Revvly and each migrated client has to be pinnable to the pricing that applied to them. Returns a DRAFT carrying the operator's `effectiveFrom`, spliced into the lineage by date (it takes the next free version number, since `version` is mint order, not chronological position). Cloned from whichever version was in force at `effectiveFrom`, or from `basedOnVersion` when given; edit its prices and tiers to the historical shape, then publish with publishHistoricalModuleVersion. The current head is untouched. */
  createHistoricalModuleVersion: Module;
  /** Author a version of a usage component that existed BEFORE the ones already stored — the legacy-pricing case, where a plan predates Revvly and each migrated client has to be pinnable to the metering and rates that applied to them. Returns a DRAFT carrying the operator's `effectiveFrom`, spliced into the lineage by date (it takes the next free version number, since `version` is mint order, not chronological position). Cloned from whichever version was in force at `effectiveFrom`, or from `basedOnVersion` when given, GLOBAL_DEFAULT prices included; edit its structure and prices to the historical shape, then publish with publishHistoricalVariableComponentVersion. The current head is untouched. */
  createHistoricalVariableComponentVersion: VariableComponent;
  createIncubator: Incubator;
  createInvoice: SubscriptionInvoice;
  /** Admins and owners only. */
  createKnowledgeSource: KnowledgeSource;
  /** Checks and scans an uploaded file, then adds it to the library as version 1. */
  createLibraryDocument: LibraryDocumentEntity;
  /** Create a new meter (the metered unit components bind to) */
  createMeter: Meter;
  createModule: Module;
  /** Branch an editable DRAFT copy from a published module version. The source version stays live; the draft (version+1) clones the base price and component prices so it starts from the same data, and can be edited then published in place via publishModuleDraftVersion. */
  createModuleDraftVersion: Module;
  /** Check in on a Key Result: its value and a confidence from 1 to 10. A note is required when confidence drops 3 or more. Owner or cycle owner, active cycles only */
  createOkrCheckIn: OkrKeyResult;
  /** Create a draft cycle. Cycle owners only */
  createOkrCycle: OkrCycle;
  /** Propose a hypothesis. Anyone can; it starts in Backlog */
  createOkrHypothesis: OkrHypothesisWriteResult;
  createOkrKeyResult: OkrKeyResult;
  createOkrObjective: OkrObjective;
  /** Create a new organization */
  createOrganization: Organization;
  /** Create a new contact for an organization */
  createOrganizationContact: OrganizationContact;
  /** Record a contract for a client. Its committed term (termMonths) is what separates the commitment from the billing cadence: "annual commitment paid monthly" is termMonths 12 on a MONTHLY subscription. Omit termMonths for an evergreen agreement. endsAt is derived from startsAt + termMonths and cannot be supplied. Attach it to a subscription with attachContractToSubscription — creating it alone commits nothing. */
  createOrganizationContract: OrganizationContract;
  createOrganizationDriveFolder: OrganizationDriveFolder;
  /** Add an endpoint. The response carries the signing secret, which is never shown again. Admin only. */
  createOutboundWebhookEndpoint: OutboundWebhookEndpointWithSecret;
  /** Post an incident everyone sees on the Revvly icon (platform admin only). */
  createPlatformIncident: PlatformIncident;
  createPricingRule: PricingRule;
  createProspectOrganization: Organization;
  createProspectOrganizationContact: OrganizationContact;
  createRecurrenceRule: RecurrenceRule;
  /** Create a new region */
  createRegion: Region;
  /** Create a renewal action for a subscription */
  createRenewalAction: RenewalAction;
  createSampleData: EmptyResponse;
  /** Create a subscription expansion record */
  createSubscriptionExpansion: SubscriptionExpansion;
  createSubscriptionWithPricing: SubscriptionCreationResult;
  /** Step 1 of attaching a file (C3): images (PNG, JPEG, GIF, WebP), PDF or plain text, up to 20 MB. */
  createSupportAttachmentUpload: SupportAttachmentUpload;
  /** A chat token for a practice customer of the sandbox. It works only against the sandbox: it names no real customer and reaches no real data. */
  createSupportSandboxToken: SupportSandboxToken;
  createTask: Task;
  /** Always created as a DRAFT. */
  createTaxRate: TaxRate;
  /** Copies a published rate into a DRAFT with the next version number. */
  createTaxRateVersion: TaxRate;
  createTaxRegistration: TaxRegistration;
  /** Create a team */
  createTeam: TeamDetail;
  createTenant: Tenant;
  /** Create a Variable Component as DRAFT (PRD FR-04). Publish separately when ready. */
  createVariableComponent: VariableComponent;
  /** Branch an editable DRAFT copy from a published component version. The source version stays live; the draft (version+1) clones the GLOBAL_DEFAULT prices so it starts from the same data, and can be edited then published via publishVariableComponent. */
  createVariableComponentDraftVersion: VariableComponent;
  /** Tenant admins and owners only. Registers an endpoint for the chosen events (at most 5 endpoints). The signing secret is returned once. */
  createWebhookEndpoint: WebhookEndpointReveal;
  /** Create a task in a ClickUp list for a ticket and link it. Without a list, the one set for the ticket’s type is used. A ticket gets one task this way; link others by their link. Revvly only adds the task and never changes it afterwards. */
  createWorkItemFromTicket: WorkItemLink;
  deactivateBundle: Bundle;
  deactivateFeatureFlag: FeatureFlag;
  deactivateFeatureFlagCategory: FeatureFlagCategory;
  /** Deactivate a meter */
  deactivateMeter: Meter;
  deactivateModule: Module;
  /** Turn OKRs off. Cycles and their contents are kept — reactivating restores them intact */
  deactivateOkrModule: OkrModuleStatusType;
  deactivatePricingRule: PricingRule;
  deactivateTaxRegistration: TaxRegistrationDeactivation;
  /** Debug method to check cache status and Redis connectivity */
  debugCacheStatus: Scalars['String']['output'];
  /** Make a decision (approve/reject) on a renewal action */
  decideRenewalAction: RenewalAction;
  /** Decline a request (owners) */
  declineInviteRequest: InviteApprovalRequest;
  /** Permanently delete an archived conversation. An active one is refused. */
  deleteAgentSession: Scalars['Boolean']['output'];
  /** Delete a route. Stops future intake; records it already created are left alone. Tenant admin/owner only. */
  deleteBookingIntakeRoute: Scalars['Boolean']['output'];
  deleteBundle: Scalars['Boolean']['output'];
  deleteClientEmailDraft: Scalars['Boolean']['output'];
  deleteCrmEmailTemplate: Scalars['Boolean']['output'];
  /** Permanently delete a deal. This cannot be undone. */
  deleteCrmLead: Scalars['Boolean']['output'];
  /** Permanently delete an archived pipeline. */
  deleteCrmPipeline: Scalars['Boolean']['output'];
  /** Deletes the tag and takes it off every client. */
  deleteCrmTag: Scalars['Boolean']['output'];
  /** Returns false when the signature was already gone. */
  deleteEmailSignature: Scalars['Boolean']['output'];
  deleteFeatureFlag: Scalars['Boolean']['output'];
  deleteFeatureFlagCategory: Scalars['Boolean']['output'];
  /** Delete a stored file (soft delete by default) */
  deleteFile: DeleteFileResult;
  /** Erase a submission. CRM records its actions created are kept. */
  deleteFormSubmission: Scalars['Boolean']['output'];
  deleteGeoRegion: Scalars['Boolean']['output'];
  /** Permanently delete a selection of imported invoices, and optionally the imported subscriptions and clients it leaves empty. Admin only. */
  deleteImportedInvoices: DeleteImportedInvoicesResult;
  /** Delete a rule. Threads it already filed keep their category; new mail is no longer filed by it. */
  deleteInboxRule: Scalars['Boolean']['output'];
  /** Forget a taught line type. Later imports read that wording from the extraction model and the keyword rules again; invoices already imported are not changed. */
  deleteInvoiceLineTypeRule: Scalars['Boolean']['output'];
  /** Admins and owners only. */
  deleteKnowledgeArticle: Scalars['Boolean']['output'];
  /** Admins and owners only. Removes the source, its articles and their index. */
  deleteKnowledgeSource: Scalars['Boolean']['output'];
  /** Delete a meter */
  deleteMeter: Scalars['Boolean']['output'];
  deleteModule: Scalars['Boolean']['output'];
  /** Permanently delete the current account. Only allowed when every team the user belongs to has another active member. */
  deleteMyAccount: Scalars['Boolean']['output'];
  deleteMySignature: Scalars['Boolean']['output'];
  /** Delete a check-in. The Key Result falls back to the one before it. Its author or a cycle owner, active cycles only */
  deleteOkrCheckIn: OkrKeyResult;
  /** Delete a draft cycle and its contents. Refused once published */
  deleteOkrCycle: Scalars['Boolean']['output'];
  /** Draft cycles only. Published Key Results are dropped */
  deleteOkrKeyResult: Scalars['Boolean']['output'];
  /** Refused while Key Results remain — move or remove them first */
  deleteOkrObjective: Scalars['Boolean']['output'];
  /** Delete an organization */
  deleteOrganization: DeleteOrganizationResult;
  /** Delete an organization contact */
  deleteOrganizationContact: Scalars['Boolean']['output'];
  /** Delete an endpoint and its delivery log. Admin only. */
  deleteOutboundWebhookEndpoint: Scalars['Boolean']['output'];
  deletePricingRule: Scalars['Boolean']['output'];
  /** Unregister a device by its push endpoint. Returns false when nothing matched. */
  deletePushSubscription: Scalars['Boolean']['output'];
  deleteRecurrenceRule: Scalars['Boolean']['output'];
  /** Delete a region. Any active pricing rules referencing this region will be marked as legacy. */
  deleteRegion: RegionDeletionResult;
  deleteSubscription: DeleteSubscriptionResult;
  /** Delete an expansion record (admin only) */
  deleteSubscriptionExpansion: Scalars['Boolean']['output'];
  /** Admins and owners only. */
  deleteSupportGuideline: Scalars['Boolean']['output'];
  /** Admins and owners only. Deletes a role and removes it from every article's and guideline's audience. An article the role was the only reader of is held for review (out of search), and a guideline that was only for it is paused: neither is ever opened to everyone. */
  deleteSupportRole: SupportRoleDeleteResult;
  deleteTask: Scalars['Boolean']['output'];
  /** Permanently delete a task (irreversible). */
  deleteTaskPermanently: Scalars['Boolean']['output'];
  /** WARNING: This will permanently delete the tenant and ALL associated data */
  deleteTenant: Scalars['Boolean']['output'];
  /** Tenant admins and owners only. Deletes the endpoint; owed deliveries are dropped. */
  deleteWebhookEndpoint: Scalars['Boolean']['output'];
  /** Permanently delete the data of a client’s workspace that has been blocked for 90 days. Keeps the client and its invoices (platform admin only). */
  deleteWorkspaceData: WorkspaceDataDeletionResultType;
  /** Stop selling a subscription under its contract. Clears commitmentEndDate as well as the link — leaving the boundary behind would have the renewal processor ask for a decision at a date no contract backs. A subscription with no contract is a no-op. */
  detachContractFromSubscription: OrganizationSubscription;
  /** Move a metric-backed Key Result back to manual. keepCurrentValue keeps its last metric value; false resets it to the start value */
  detachOkrKeyResultMetric: OkrKeyResult;
  /** Detach a directly-attached Variable Component from an ACTIVE subscription (PRD §18.2). Inherited (plan-provided) components cannot be detached — migrate the plan instead. Archives any subscription-scoped price and appends REMOVE_COMPONENT to versionHistory. */
  detachVariableComponentFromSubscription: OrganizationSubscription;
  /** Switch a server off and forget its credential; the connection stays listed. */
  disableMcpRemoteServer: Scalars['Boolean']['output'];
  /** Disable a feature flag for a specific organization */
  disableOrganizationFeatureFlag: OrganizationFeatureFlag;
  /** Discard a DRAFT bundle version: deletes the draft and its cloned base-price rules, and archives its BUNDLE-scoped component prices. The version it branched from is untouched. */
  discardBundleDraftVersion: Scalars['Boolean']['output'];
  /** Drop the working copy and go back to the published version. */
  discardContractTemplateDraft: ContractTemplate;
  /** Throw a drafted reply away. */
  discardInboxReplyDraft: Scalars['Boolean']['output'];
  /** Discard a DRAFT module version: deletes the draft and its cloned base-price rules, and archives its MODULE-scoped component prices. The version it branched from is untouched. */
  discardModuleDraftVersion: Scalars['Boolean']['output'];
  /** Discard a pending pricing draft (PRD §22). Returns false when nothing was discarded. */
  discardPricingDraft: Scalars['Boolean']['output'];
  discardSyncResultAsNotInvoice: GoogleDriveSyncResultEntity;
  /** Discard a DRAFT component version — hard-deletes the draft and its cloned GLOBAL_DEFAULT prices. The published version it branched from is untouched. */
  discardVariableComponentDraftVersion: Scalars['Boolean']['output'];
  disconnectAccountingMailbox: Scalars['Boolean']['output'];
  /** Stop ingesting Calendly events for this tenant, remove the subscription at Calendly and revoke the grant. Tenant admin/owner only — it silences intake for everyone. */
  disconnectCalendly: CalendlyDisconnectResult;
  /** Disconnect ClickUp. Links to tasks stay, showing what was last read, and stop refreshing */
  disconnectClickup: ClickUpConnection;
  disconnectGmail: Scalars['Boolean']['output'];
  disconnectGoogleDrive: Scalars['Boolean']['output'];
  /** Disconnect Slack. Requires typing the workspace name; member links are kept so a reconnect restores them */
  disconnectSlack: SlackWorkspaceStatus;
  /** Disconnect Stripe. Nothing more is charged. Admin only. */
  disconnectStripe: Scalars['Boolean']['output'];
  /** One turn of a conversation with the AI coach about a Key Result before it is saved. Advice only: nothing is stored and nothing is applied */
  discussOkrKeyResultDraft: OkrCoachReplyType;
  /** One turn of a conversation with the AI coach about an objective before it is saved. Advice only: nothing is stored and nothing is applied */
  discussOkrObjectiveDraft: OkrCoachReplyType;
  /** Stop offering the suggestion read from the website at the start of an OKR cycle */
  dismissBusinessProfileSuggestion: BusinessProfileType;
  /** The "Not now" on the create-folder prompt. */
  dismissDriveFolderPrompt: Scalars['Boolean']['output'];
  /** Dismiss an event’s suggestion. Workspace admins and owners only. */
  dismissProductEventSuggestion: ProductEventType;
  /** Conclude, drop or carry open hypotheses before a cycle closes. All apply, or none do */
  disposeOkrHypotheses: OkrHypothesisDispositionResult;
  /** Drop a hypothesis that never ran, with a reason */
  dropOkrHypothesis: OkrHypothesisWriteResult;
  /** Take a published Key Result out of the cycle, with a reason. It stays in the cycle marked dropped and is left out of scoring */
  dropOkrKeyResult: OkrKeyResultDropResult;
  /** Creates a private copy owned by the caller. */
  duplicateCrmEmailTemplate: CrmEmailTemplate;
  duplicateForm: Form;
  duplicateModule: Module;
  duplicatePricingRule: PricingRule;
  emailSignedContractCopy: SignatureRequestDetail;
  /** Enable a feature flag for a specific organization */
  enableOrganizationFeatureFlag: OrganizationFeatureFlag;
  /** End a free trial now: the subscription becomes ACTIVE, its first period starts today and is invoiced in advance. Idempotent — on a subscription that is no longer in its trial it returns alreadyConverted and raises nothing. */
  endSubscriptionTrial: SubscriptionTrialConversionResult;
  /** Ensure exchange rates are available for currencies before import */
  ensureExchangeRates: EnsureExchangeRatesResult;
  /** Opens the practice workspace on first use, copying your Support setup. */
  ensureSupportSandbox: SupportSandbox;
  /** Enter a billable quantity on an open closed-period reading and seal it (Phase 6). */
  enterUsageReading: UsageReading;
  /** Erase every product event of one user across all of the workspace’s clients (a data-subject request) and return how many were removed. Cannot be undone. Workspace admins and owners only. */
  eraseProductEventsForUser: Scalars['Int']['output'];
  /** Admins and owners only. Takes it out of search. */
  excludeKnowledgeArticle: KbArticle;
  /** Opt a subscription OUT of one auto-included (plan-inherited) Variable Component, without migrating the plan. Unlike detachVariableComponentFromSubscription (which only ever removes an explicitly-attached component), this targets a component the pinned Module/Bundle marks autoIncludeOnSubscribe. Recorded on excludedComponentLineageIds so the exclusion survives later plan changes instead of silently reappearing. Appends EXCLUDE_COMPONENT to versionHistory. */
  excludeVariableComponentFromSubscription: OrganizationSubscription;
  /** Move a test’s end date later, with a reason */
  extendOkrHypothesisTest: OkrHypothesisWriteResult;
  /** Move a running free trial to a new end date (still ahead, at most 365 days after it started). Nothing is billed until then. */
  extendSubscriptionTrial: OrganizationSubscription;
  /** Force the next `times` metric refreshes for this tenant to fail. `times: 0` clears a standing fault. Not available in production */
  failOkrMetricRefresh: Scalars['Boolean']['output'];
  /** Continue onboarding in the setup wizard instead. Every answer is kept. */
  fallBackToManualOnboarding: AssistantOnboardingState;
  /** Manually fetch today's exchange rates */
  fetchTodayExchangeRates: BackfillExchangeRatesResult;
  /** File every Unsorted thread of one sender (or whole domain) under a category and remember it as a rule; returns how many were filed. */
  fileInboxUnsortedGroup: Scalars['Int']['output'];
  /** The matcher got this one wrong. Charged as a correction against the products it named, which is what takes their autonomy away and puts their invoices back in the review queue. No replacement product is asked for — the point of the lighter pass is "look at this again", not "here is the right answer". */
  flagSpotCheck: SpotCheckDecisionEntity;
  /** Remove one agent memory */
  forgetAgentMemory: Scalars['Boolean']['output'];
  /** Forward the thread’s latest message to the accounting mailbox; returns its address. */
  forwardInboxThreadToAccounting: Scalars['String']['output'];
  /** Generate one InvoiceLineItem + immutable billing_period_snapshot per Variable Component on a subscription. Resets usage counters by default. */
  generateVariableInvoiceLines: Array<GeneratedInvoiceLine>;
  /** Record that this client stays on the plan they are on, on purpose, indefinitely. Moves nothing: the pins are left exactly where they are — that is the decision — and a version history entry is appended carrying the stated reason. From then on `legacyPin` reports the subscription as grandfathered and `subscriptionsWithOutdatedPins` leaves it out, so a deliberate legacy pin stops reading as a pin nobody got round to updating. The reason is required — it is the whole record. Lift it by migrating the subscription explicitly. */
  grandfatherSubscription: OrganizationSubscription;
  /** Grant a function role. Grants no account or billing access */
  grantRole: Array<FunctionRoleSummary>;
  /** Hold a reading that is waiting to seal for review: it turns UNVERIFIED instead of sealing, so its invoice waits until someone enters a figure or waives the period. */
  holdUsageReading: UsageReading;
  /** Mark an event as noise, or bring it back. Workspace admins and owners only. */
  ignoreProductEvent: ProductEventType;
  /** Replace the mailbox's signature with the one configured in its Gmail account. */
  importAccountingMailboxSignature: EmailSignature;
  /** Import mapped company and contact rows. Persists a batch log with created counts and row failures. */
  importCrmContactsAndCompanies: CrmImportBatch;
  importGmailSignatures: Array<EmailSignature>;
  /** Send Invoice/Credit note-marked files to the import review queue now. */
  importMarkedDocuments: ImportMarkedDocumentsResult;
  /** Import subscriptions with automatic renewal generation */
  importSubscriptions: ImportSubscriptionsResult;
  /** Import reference layers as DRAFT rates this tenant owns. All or nothing: an unknown, already-imported or unregistered layer refuses the request. */
  importTaxReferenceRates: Array<TaxRate>;
  /** Import transactions from parsed file data */
  importTransactions: ImportTransactionsResult;
  /** Invalidate only pricing combinations cache entries for the current tenant */
  invalidatePricingCache: Scalars['Boolean']['output'];
  /** Invite a user to the current tenant */
  inviteUserToTenant: UserTenant;
  /** Issue a new API key. Tenant admin/owner only. The plaintext token is returned ONCE in the response; capture it immediately. Subsequent reads return only the ApiKey metadata. */
  issueApiKey: IssuedApiKey;
  /** Raise a credit note against a client, optionally correcting a specific invoice. Nothing is applied or refunded: the credit exists as a numbered document that nets against what the client owes until it is spent or paid out. Line amounts are POSITIVE — the server stores the negative. */
  issueCreditNote: SubscriptionInvoice;
  issueDraftInvoice: SubscriptionInvoice;
  linkInvoiceToSubscription: SubscriptionInvoice;
  /** Link a team Key Result to the company Key Results it serves. Adds; links already there are left alone */
  linkOkrKeyResult: OkrKeyResultAlignment;
  /** Link a ClickUp task to a Key Result by its link or id. Linking the same task twice is a no-op */
  linkOkrWorkItem: OkrKeyResultWorkLinks;
  linkOrganizationDriveFolder: OrganizationDriveFolder;
  /** Link one more email host to a client or prospect, so contacts and suggestions at that host are matched to it as well as those at its website domain. Intended for the host surfaced by `unlinkedDomains`. Refused when another client already holds it; a host the record already matches is a no-op rather than an error, because the panel it is clicked from can be seconds stale. */
  linkOrganizationEmailDomain: Organization;
  /** Link a synced email thread to a client by hand. Null when the thread does not exist or is not visible to this viewer. */
  linkSyncedEmailThreadToClient?: Maybe<SyncedEmailThread>;
  /** Link a Variable Component into a parent Module or Bundle by appending to the parent's variableComponentRefs[]. Re-linking the same component updates the existing ref rather than duplicating it. Returns the (unchanged) component for convenience. */
  linkVariableComponentToParent: VariableComponent;
  /** Link a ClickUp task to a ticket by its link. Linking a task that is already linked refreshes it. */
  linkWorkItem: WorkItemLink;
  logCrmEmailMessage: CrmEmailMessage;
  logCrmMeeting: CrmMeeting;
  /** Log a request a client made outside the widget (a call, an email). Its description is an internal note: the client is told nothing and does not see the ticket until someone replies publicly on it. */
  logSupportTicket: SupportTicket;
  /** Link one Revvly member to a Calendly person by hand. Tenant admin/owner only. */
  mapCalendlyMemberManually: CalendlyMemberLink;
  /** Link a Revvly user to a ClickUp account by hand. Admin only */
  mapClickupMember: Scalars['Boolean']['output'];
  /** Save what an event means: a name, a category, what it belongs to, whether it shows value. Replaces the whole mapping and applies to every event of that name, old ones included. Workspace admins and owners only. */
  mapProductEvent: ProductEventType;
  /** Map one person to a Slack account by hand */
  mapSlackMemberManually: SlackMemberLink;
  /** Mark documents (Invoice, Contract, …). Pass category null to clear. Locked marks are reported, not changed. */
  markDocuments: MarkDocumentsResult;
  /** Mark the open threads of one category done, Gmail included, a batch at a time. */
  markInboxCategoryDone: InboxBulkDoneResult;
  /** Not relevant: done, and the sender’s next mail goes to Other. */
  markInboxThreadNotRelevant: InboxThread;
  /** Marks the given notifications read, or all of yours when ids is omitted. Returns how many changed. */
  markNotificationCenterRead: Scalars['Int']['output'];
  markPaymentReceived: SubscriptionInvoice;
  /** Marks everything up to the newest release the caller can see as read. */
  markReleaseNotesSeen: Scalars['Boolean']['output'];
  /** Mark a subscription as churned due to payment failure. Emits a CHURNED lifecycle event with churnReason = PAYMENT_FAILURE. */
  markSubscriptionChurnedDueToPaymentFailure: OrganizationSubscription;
  /** Marks the given notifications read, or all of yours when ids is omitted. Returns how many changed. */
  markSupportNotificationsRead: Scalars['Int']['output'];
  /** Move your read marker up to a message, clearing the ticket's unread dot. */
  markTicketRead: Scalars['Boolean']['output'];
  /** Merge a source organization into a target organization, transferring all child entities */
  mergeOrganizations: MergeOrganizationsResult;
  /** Migrate a subscription's pinned bundle to a different version. Timing chooses between immediate mid-cycle prorated apply and scheduling for the next renewal. An ARCHIVED target version requires legacyVersionPin { reason } — grandfathering a client onto a plan we no longer sell has to be deliberate and recorded. */
  migrateSubscriptionBundle: OrganizationSubscription;
  /** Migrate a subscription's direct variable component pin to a different version. Updates the matching entry in variableComponentRefs[]. */
  migrateSubscriptionComponent: OrganizationSubscription;
  /** Migrate a subscription's pinned module to a different version. Timing chooses between immediate mid-cycle prorated apply and scheduling for the next renewal. An ARCHIVED target version requires legacyVersionPin { reason } — grandfathering a client onto a plan we no longer sell has to be deliberate and recorded. */
  migrateSubscriptionModule: OrganizationSubscription;
  moveCrmLead: CrmLead;
  /** Move these clients’ folders into the clients folder. Returns how many were planned. */
  moveDriveFoldersToClients: Scalars['Int']['output'];
  /** File the thread under another category. */
  moveInboxThread: InboxThread;
  /** File the thread under another category and say what to ask next: offer an "always file here" rule, or settle a conflict with what the sender is already filed under. */
  moveInboxThreadWithFollowUp: InboxMoveResult;
  /** Move to another Key Result in the same cycle */
  moveOkrHypothesis: OkrHypothesisWriteResult;
  /** Move the folder into the clients folder now. */
  moveOrganizationDriveFolder: OrganizationDriveFolder;
  /** Start saving or replacing the workspace card (Stripe Elements secret). */
  myBillingStartCardSetup: MyBillingCardSetup;
  /** Dispute resolution: write an adjustment snapshot linked to an original. The original is preserved (PRD §21.3). */
  overrideBilledQuantity: BillingPeriodSnapshot;
  /** Set a custom base price on a subscription (PRD §7.2). Drives billing and analytics; the catalog list price is snapshotted for divergence display. IMMEDIATE_PRORATED emits a prorated correction invoice via the Adjustment engine. No guardrails (§7.6). */
  overrideSubscriptionBasePrice: PriceOverrideResult;
  /** Set a client-specific billing timing (ARREARS or ADVANCE) for one variable component on a subscription (PRD §7.2). Always prospective: takes effect at the next billing cycle for that component; the current cycle's scheduled invoicing is left untouched (§7.3). A reason is required. */
  overrideSubscriptionComponentBillingTiming: BillingTimingOverrideResult;
  /** Set or clear a per-component usage capture mode (API or MANUAL) on a subscription (R7). Null clears the override so the component inherits the client default. A reason is required. */
  overrideSubscriptionComponentCaptureMode: CaptureModeOverrideResult;
  /** Set a custom rate and/or included allowance for a variable component on a subscription (PRD §7.7). Written as a SUBSCRIPTION-scoped price that wins the resolver chain. The monetary fields must match the component's pricing model (tierPrices for tiered, stepFees for stairstep, …) — a mis-shaped override is rejected. No guardrails on the values. */
  overrideSubscriptionComponentRate: PriceOverrideResult;
  /** Locally overwrite an instance's value/duration/settings on this subscription only — the source definition and other subscriptions are untouched (§8.5). */
  overwriteSubscriptionDiscount: DiscountInstanceEntity;
  /** The matcher got this one right. Recorded as a reviewer confirmation, so it counts as evidence for the product exactly as a confirmation in the review queue would. */
  passSpotCheck: SpotCheckDecisionEntity;
  pauseCheckin: Checkin;
  /** Manually trigger churn reconciliation for the active tenant, stamping CHURNED for any subscription whose term ended past the grace window without a renewal. Tenant admin/owner only. Idempotent. tenantId, if given, must match the active tenant. */
  processChurnReconciliation: ChurnReconciliationResultOutput;
  /** Manually trigger renewal processing for the active tenant. Tenant admin/owner only. tenantId, if given, must match the active tenant. */
  processRenewals: TenantRenewalSummaryOutput;
  /** Manually run the period-close sweep (same as the 04:00 cron) for the active tenant. Pass asOf to close periods ended by that instant. tenantId, if given, must match the active tenant. */
  processUsagePeriodClose: UsagePeriodCloseResult;
  /** Manually run the seal sweep (same as the hourly cron) for the active tenant and retry its released held drafts. Pass asOf to seal readings whose sealDueAt is at or before that instant. tenantId, if given, must match the active tenant. */
  processUsageSeal: UsageSealResult;
  /** Publish a DRAFT bundle version in place: flips it to PUBLISHED and archives the version it branched from. Subscriptions pinned to older versions are unaffected until migrated. */
  publishBundleDraftVersion: Bundle;
  /** Check the working copy as a whole and publish it as the next version. Contracts already sent keep the text they were sent with. */
  publishContractTemplate: ContractTemplate;
  /** Publish a Custom Pricing Agreement. Takes effect at the customer's next renewal (FR-26). */
  publishCustomPricingAgreement: CustomPricingAgreement;
  /** Snapshot the draft as a new version and make it live. */
  publishForm: Form;
  /** Publish a historical bundle version. Unlike publishBundleDraftVersion it publishes to ARCHIVED — a past version is not the current offer, so it can only be pinned deliberately (legacyVersionPin) and never sold by accident. The operator's `effectiveFrom` is kept while `publishedAt`/`archivedAt` record when we actually wrote it; the lineage head and its neighbours are left exactly as they were. */
  publishHistoricalBundleVersion: Bundle;
  /** Publish a historical module version. Unlike publishModuleDraftVersion it publishes to ARCHIVED — a past version is not the current offer, so it can only be pinned deliberately (legacyVersionPin) and never sold by accident; its tiers are archived with it for the same reason. The operator's `effectiveFrom` is kept while `publishedAt`/`archivedAt` record when we actually wrote it; the lineage head and its neighbours are left exactly as they were. */
  publishHistoricalModuleVersion: Module;
  /** Publish a historical component version. Unlike publishVariableComponent it publishes to ARCHIVED — a past version is not the current offer, so it can only be pinned deliberately (legacyVersionPin) and never sold by accident. Price shape is still validated, so a past version cannot be stored in a state that would throw inside the calculator. The operator's `effectiveFrom` is kept while `publishedAt`/`archivedAt` record when we actually wrote it; the lineage head and its neighbours are left exactly as they were. */
  publishHistoricalVariableComponentVersion: VariableComponent;
  /** Publish a DRAFT module version in place: flips it to PUBLISHED and archives the version it branched from. Subscriptions pinned to older versions are unaffected until migrated. */
  publishModuleDraftVersion: Module;
  /** Publish a draft: lock every start value, make it active, announce it */
  publishOkrCycle: OkrCycle;
  /** Publishes a draft. Refused with the conflicting rate named when it overlaps a published rate for the same levy and items. */
  publishTaxRate: TaxRate;
  /** Promote a DRAFT to PUBLISHED. Validates the pricing configuration, increments version, supersedes any prior PUBLISHED record for the same variable. */
  publishVariableComponent: VariableComponent;
  /** Publish a Variable Component and optionally create DRAFT new versions of any Module or Bundle referencing the prior version, with the new component version pinned in. */
  publishVariableComponentWithCascade: PublishCascadeResult;
  /** Read the website and draft every field from it. Nothing is saved: the draft fills the form, and the admin saves what they keep */
  pullBusinessProfileFromWebsite: BusinessProfilePullType;
  /** Read a client's contract PDF for its sub-processor and breach terms. Stores nothing: the answer is for a person to check. */
  readContractClauses: ContractClauseProposal;
  reassignTask: Task;
  /** Admins and owners only. Reads every article against the roles again, after the roles were edited. Admin decisions are kept. */
  reclassifyKnowledge: KnowledgeReclassifyResult;
  /** Make (or update) the client's contract record for a document, with the terms a person checked. */
  recordContractFromDocument: OrganizationContract;
  /** Record the subscription a person created from a signed contract's order form, so it is not proposed again. Set once. */
  recordContractSubscription: ContractRequest;
  /** Record payments (full or part) on invoices imported from client files. One refusal does not stop the rest. */
  recordDocumentPayments: Array<DocumentPaymentResult>;
  /** Record the subscription a person created from a client's proposed terms, so they are not proposed again. Set once. */
  recordFormClientSubscription: FormClientSubmission;
  /** Record a plan change that already happened, at the date it happened — reconstructing a client's plan history rather than changing their plan. Moves no money: no proration invoice, nothing scheduled, and the MRR movement it emits is dated at the historical change (re-run backfillAnalyticsSnapshots afterwards to restate the daily series). Accepts an ARCHIVED target without legacyVersionPin — a backdated change is inherently a legacy pin — but refuses a DRAFT version, a date before the subscription started, a future date, and any date inside a period an ISSUED invoice already bills. Changes may be recorded in any order: the subscription's current pins follow the newest change, not the most recently written one. */
  recordHistoricalPinChange: OrganizationSubscription;
  /** Record the current user accepting one or more policy versions. */
  recordPolicyAcceptances: Array<PolicyAcceptance>;
  /** Make the client's contract record from a signed contract, with the signed copy as its file. */
  recordSignedContract: ContractRequest;
  /** Ask the server what it offers and store that list for the admin to choose from. */
  refreshMcpRemoteServerTools: McpRemoteServerView;
  /** Re-read a Key Result's linked tasks from ClickUp now */
  refreshOkrWorkLinks: OkrKeyResultWorkLinks;
  /** Pay a credit note out in cash instead of spending it against a receivable. All-or-nothing on the unapplied remainder: a part-refunded, part-spendable credit note has two kinds of consumption in one figure and nothing downstream can tell them apart. */
  refundCreditNote: SubscriptionInvoice;
  regenerateInvoicePdf: SubscriptionInvoice;
  /** Reverse a prior excludeVariableComponentFromSubscription: the component is auto-included again, provided it is still an auto-include candidate on the plan currently pinned to this subscription. Identified by componentLineageId (from excludedComponentLineageIds) rather than componentId, since the excluded component may since have been republished to a new version. Appends INCLUDE_COMPONENT to versionHistory. */
  reincludeVariableComponentOnSubscription: OrganizationSubscription;
  /** Admins and owners only. Reads the page again. */
  reingestKnowledgeArticle: KbArticle;
  /** Save a memory for the Revvly Agent. WORKSPACE needs a tenant admin. Saving the same text again returns the memory already there. */
  rememberAgentMemory: AgentMemory;
  /** Archive the BUNDLE-scoped price for a component on a Bundle version (PRD §17.4). */
  removeBundleComponentPrice: Scalars['Boolean']['output'];
  /** Forget a client's card on file. Admin only. */
  removeClientCard: Scalars['Boolean']['output'];
  /** Archive the GLOBAL_DEFAULT price for a Variable Component (PRD §17.4). */
  removeComponentDefaultPrice: Scalars['Boolean']['output'];
  /** Remove a currency from a region */
  removeCurrencyFromRegion: Region;
  removeFeatureFlagFromBundle: Bundle;
  removeFeatureFlagFromTier: Module;
  removeInvoiceAttachment: SubscriptionInvoice;
  /** Remove the invoice-header logo for the current tenant */
  removeInvoiceLogo: Tenant;
  /** Remove a server and everything stored for it. */
  removeMcpRemoteServer: Scalars['Boolean']['output'];
  /** Archive the MODULE-scoped price for a component on a Module version (PRD §17.4). */
  removeModuleComponentPrice: Scalars['Boolean']['output'];
  removeModuleFromBundle: Bundle;
  removeModuleTier: Module;
  /** Remove a link */
  removeOkrHypothesisLink: OkrHypothesisWriteResult;
  /** Remove a manual feature flag assignment (reverts to bundle/module defaults) */
  removeOrganizationFeatureFlag: Scalars['Boolean']['output'];
  removeProspectFromPipeline: Scalars['Boolean']['output'];
  /** Archive the active SUBSCRIPTION-scoped price for this (subscription, component). Returns false if no such price existed. Appends REMOVE_SUBSCRIPTION_PRICE to versionHistory only when an actual archive happened. */
  removeSubscriptionScopedPrice: Scalars['Boolean']['output'];
  /** Remove a folder from the synced folders list. */
  removeSyncFolder: GoogleDriveConnectionEntity;
  removeTaskAssignee: Task;
  removeTaskAttachment: Task;
  removeTaskExternalLink: Task;
  /** Remove one person from a team. Nothing they own is reassigned */
  removeTeamMember: TeamDetail;
  removeUserFromTenant: Scalars['Boolean']['output'];
  /** Remove quantity from a Variable Component on a subscription. Honors COMMITTED_OVERAGE floor (FR-16) and CUMULATIVE decrement rejection (FR-18). */
  removeVariableUsage: SubscriptionVariableUsage;
  renameAgentSession: AgentSessionType;
  renameContactRole: ContactRole;
  renewSubscription: OrganizationSubscription;
  /** Reopen an ARCHIVED past bundle version for further edits — same document, same effectiveFrom, back to DRAFT. Historical authoring is correction work and the first publish is often incomplete (wrong component pricing model, missing tiers). Branching a new version would mint a different id and leave every pin on the old one. Re-publish with publishHistoricalBundleVersion. The current head is untouched. */
  reopenHistoricalBundleVersion: Bundle;
  /** Reopen an ARCHIVED past module version for further edits — same document, same effectiveFrom, back to DRAFT (tiers included). Re-publish with publishHistoricalModuleVersion. The current head is untouched. */
  reopenHistoricalModuleVersion: Module;
  /** Reopen an ARCHIVED past component version for further edits — same document, same effectiveFrom, back to DRAFT. This is how a legacy component changes shape (flat seats to volume-tiered, a different meter model) after it was first filed. Re-publish with publishHistoricalVariableComponentVersion. The current head is untouched. */
  reopenHistoricalVariableComponentVersion: VariableComponent;
  reopenTask: Task;
  reopenTicket: SupportTicket;
  /** Rewrite the order of an objective’s Key Results */
  reorderOkrKeyResults: Scalars['Boolean']['output'];
  reorderPipelineStages: CrmPipeline;
  /** Tenant admins and owners only. Sends a finished delivery again: same body and event id, a new signature and a fresh run of retries. */
  replayWebhookDelivery: WebhookDelivery;
  /** Reply to one message of the thread from the caller’s own mailbox, as written in the composer; returns who it went to. */
  replyToInboxMessage: Array<Scalars['String']['output']>;
  /** Post a public reply or an internal note. Idempotent on clientMessageId. */
  replyToTicket: SupportMessage;
  /** Record a sale (positive saleAmount) or refund (negative saleAmount referencing the original transactionId) for a COMMISSION-priced component (PRD §5.8, §21.4). */
  reportCommissionEvent: SubscriptionVariableUsage;
  /** Request an email change: sends a verification link to the new address. The change applies only after confirmation. */
  requestEmailChange: RequestEmailChangeResult;
  /** Ask the owners to approve a set of invitations (admins) */
  requestInviteApproval: InviteApprovalRequest;
  requestLibraryDocumentUpload: LibraryUploadTarget;
  /** Ask Revvly for more seats. One open request at a time */
  requestSeats: SeatRequest;
  requestSupportAuthToken: Scalars['String']['output'];
  /** Get a presigned URL for uploading a file to storage */
  requestUploadUrl: PresignedUploadUrl;
  /** Send a recipient's invitation again, once their turn has come. */
  resendContractInvite: SignatureRequestDetail;
  /** Send an invitation again with a fresh link and expiry. The old link stops working */
  resendMemberInvite: MemberInvite;
  /** Resend the invitation email to a tenant member who hasn't logged in yet. Reuses their existing setup token when it is still valid */
  resendTenantUserInvite: Scalars['Boolean']['output'];
  /** Forget what the inbox learned about one sender. */
  resetInboxLearnedSender: Scalars['Boolean']['output'];
  /** Drop the tenant copy so the template renders from its default again. */
  resetPaymentReminderTemplate: PaymentReminderTemplate;
  /** Put an event back in the inbox, clearing its mapping. Workspace admins and owners only. */
  resetProductEventMapping: ProductEventType;
  /** Reset every situation threshold to its default. Takes effect at the next nightly sweep. Tenant admin/owner only. */
  resetSituationThresholds: SituationThresholdSettings;
  /** Admins and owners: wipe everything practised so far and copy your Support setup again. */
  resetSupportSandbox: SupportSandbox;
  /** Resolve a single discrepancy with chosen values */
  resolveDiscrepancy: InvoiceDiscrepancyEntity;
  /** Mark an incident resolved; it stops showing (platform admin only). */
  resolvePlatformIncident: PlatformIncident;
  /** Fulfil or decline a seat request (platform admins). Fulfilling raises the limit by the amount asked for */
  resolveSeatRequest: SeatRequest;
  /** Copy an earlier version into the working copy. Nothing is published. */
  restoreContractTemplateVersion: ContractTemplate;
  /** Write a file removed in Drive back, as a new file. */
  restoreDriveFile: DriveFileSyncItem;
  restoreForm: Form;
  restoreSyncResult: GoogleDriveSyncResultEntity;
  resumeCheckin: Checkin;
  /** Admins and owners only. Continues a run stopped by the spend cap (or failed) where it stopped, on the same sample. */
  resumeSupportCompare: SupportCompareRun;
  /** Read the task's status from ClickUp again. */
  resyncWorkItem: WorkItemLink;
  /** Run a concluded hypothesis again as a new one in Backlog, linked to the original */
  retestOkrHypothesis: OkrHypothesisWriteResult;
  /** Try a stopped one again, with the contract as it reads now. */
  retryContractSendPlan: ContractSendPlan;
  retryDriveFileSync: DriveFileSyncItem;
  /** Retry a FAILED sync job (e.g. one killed by a server restart) without losing its existing SyncResult rows. Returns the jobId (same as input) so the caller can resume polling. */
  retryFailedSyncJob: Scalars['String']['output'];
  /** Re-run the failed steps of a submission. */
  retryFormSubmission: FormSubmission;
  /** Try a failed delivery again now. Admin only. */
  retryOutboundWebhookDelivery: OutboundWebhookDelivery;
  retrySyncExtraction: GoogleDriveSyncResultEntity;
  /** Developing back to Backlog */
  returnOkrHypothesisToBacklog: OkrHypothesisWriteResult;
  /** Reverse every payment on the invoice imported from this file. */
  reverseDocumentPayments: Scalars['Boolean']['output'];
  /** Delete what booking intake created between two instants. Organizations are removed only when intake created them and nothing else references them. Tenant admin/owner only. */
  revertBookingIntake: BookingIntakeRevertPlanResult;
  /** Revert one CRM import batch: delete the contacts it created, and delete the companies it created only when nothing else now references them. */
  revertCrmImportBatch: CrmImportRollbackResult;
  /** Immediately revoke an API key. Tenant admin/owner only. Effect is observable on the next auth attempt. */
  revokeApiKey: ApiKey;
  /** Revoke a Custom Pricing Agreement. The record is preserved for audit. */
  revokeCustomPricingAgreement: CustomPricingAgreement;
  /** Takes a link offline at once. Its sender or a workspace admin can revoke it. */
  revokeDocumentShareLink: DocumentShareLinkEntity;
  /** Revoke a client link that has not been answered. */
  revokeFormClientLink: Scalars['Boolean']['output'];
  /** Withdraw a pending invitation */
  revokeMemberInvite: MemberInvite;
  /** Revoke a function role. Refused when it would leave the role with nobody */
  revokeRole: Array<FunctionRoleSummary>;
  /** Roll back a previous import batch, deleting only the entities it created. Admin only. */
  rollbackImportBatch: ImportBatchRollbackResult;
  /** Issue a successor key inheriting the original's scope + rate limits. Tenant admin/owner only. Both keys remain valid for a 30-day grace period (FR-32). */
  rotateApiKey: IssuedApiKey;
  /** Issue a new signing secret. The old one stops working at once. Admin only. */
  rotateOutboundWebhookSigningSecret: OutboundWebhookEndpointWithSecret;
  /** Tenant admins and owners only. A new signing secret, returned once. */
  rotateWebhookEndpointSecret: WebhookEndpointReveal;
  /** Queue the hourly reconciliation now. */
  runDriveFolderReconcile: Scalars['Boolean']['output'];
  /** Run a scheduled job now instead of waiting for its cron. Not available in production */
  runScheduledJobNow: ScheduledJobRun;
  saveAccountingMailboxSignature: EmailSignature;
  /** Autosave the working copy, finished or not. `expectedRevision` is the draft revision last seen (0 for none); a mismatch is a STALE_WRITE conflict. Never changes the published version. */
  saveContractTemplateDraft: ContractTemplate;
  /** Remember how the caller left the pipeline Forecast table (sort, filters, search, page size). */
  saveCrmForecastViewState: CrmForecastViewState;
  /** Save a rule the person confirmed, and file their existing threads by it. */
  saveInboxRule: SaveInboxRuleResult;
  /** Add a server or edit its connection. A new server starts disabled with no tools allowed. */
  saveMcpRemoteServer: McpRemoteServerView;
  saveMySignature: UserSignature;
  /** Register (or refresh) the current device for push notifications. Idempotent on the endpoint. */
  savePushSubscription: PushSubscription;
  /** Admins and owners only. */
  saveSupportGuideline: SupportGuideline;
  /** Seed the database with default meter configurations */
  seedDefaultMeters: Scalars['Boolean']['output'];
  /** Generate sample feature flags, modules, and bundles */
  seedFeatureFlags: Scalars['Boolean']['output'];
  /** Seed the database with sample subscription data for testing and development */
  seedSampleSubscriptionData: Scalars['Boolean']['output'];
  /** Select a tenant to work with */
  selectTenant: Tenant;
  /** Send a message to the assistant and receive the updated session. */
  sendChatMessage: ChatCreationSession;
  /** Send the questions to the caller as a Slack DM and a test post to the report channel. Nothing is recorded. */
  sendCheckinTest: Scalars['Boolean']['output'];
  sendClientEmail: SendClientEmailResult;
  sendContract: SendContractResult;
  /** Send the client a form asking who signs; the contract goes to that person once it is answered. */
  sendContractAfterForm: SendContractAfterFormResult;
  sendEditablePaymentReminder: SendReminderResult;
  sendFollowUpEmail: SendReminderResult;
  /** Send Slack invitations (owners; admins only when the company has no owner) */
  sendMemberInvites: SendMemberInvitesResult;
  sendPaymentReminder: SendReminderResult;
  /** Send a test alert to Slack to verify configuration. */
  sendTestAlert: Scalars['Boolean']['output'];
  /** Send a test notification through the real delivery path. Returns the delivery-log status. Not available in production */
  sendTestNotification: Scalars['String']['output'];
  /** Send a test event and wait for the endpoint to answer. Works on a disabled endpoint. Admin only. */
  sendTestOutboundWebhook: OutboundWebhookDelivery;
  /** Tenant admins and owners only. Sends a signed webhook.test now. */
  sendWebhookEndpointTest: WebhookTestResult;
  /** Set the daily prospect-creation cap. Zero stops prospect creation without disabling any route. Tenant admin/owner only — the cap bounds an unauthenticated write path. */
  setBookingIntakeDailyCap: BookingIntakeCapStatus;
  /** Switch a route on or off without touching its keys. Tenant admin/owner only. */
  setBookingIntakeRouteEnabled: BookingIntakeRoute;
  /** Set the BUNDLE-scoped price for a component referenced by a Bundle version (PRD §17.4). Overrides MODULE / GLOBAL_DEFAULT for subscriptions pinned to that bundle. Idempotent. */
  setBundleComponentPrice: VariableComponentPrice;
  /** Mark someone away from today (or `from`) until `to`, or until cleared. Days away are not asked and not counted as missed (tenant admins) */
  setCheckinAway: CheckinAway;
  /** Choose the ClickUp Chat channel for company-wide posts, or pass nothing to stop them. Admin only */
  setClickupAnnouncementChannel: ClickUpConnection;
  /** Send OKR messages through ClickUp Chat instead of Slack, or go back. Admin only. Needs a working connection */
  setClickupChatEnabled: ClickUpConnection;
  /** Set the GLOBAL_DEFAULT price for a PUBLISHED Variable Component (PRD §17.4) — the base of the SUBSCRIPTION → BUNDLE → MODULE → GLOBAL_DEFAULT resolver chain that makes a component sellable on its own. Idempotent: replaces any existing default price. */
  setComponentDefaultPrice: VariableComponentPrice;
  setContactRoleRetired: ContactRole;
  /** Make a thread private (visible only to you), hide it from the default conversation, or restore it for the team. */
  setConversationThreadVisibility: ConversationThreadVisibility;
  /** Retire a field (hidden, values kept) or bring it back. */
  setCustomFieldRetired: CustomFieldDefinition;
  /** Make this signature the one used when no address-specific signature matches. */
  setDefaultEmailSignature: EmailSignature;
  setDefaultSignature: UserSignature;
  /** Set what the inbox does on its own with a category. Mail from people is never archived, marked read or moved; only alerted on. */
  setInboxCategoryPolicy: InboxCategoryPolicy;
  setInboxRuleEnabled: InboxRule;
  /** Always file mail from this thread’s sender (or its whole domain) under a category. Confirmed by the person; replaces what was learned for that sender. */
  setInboxSenderRule: InboxSenderRuleResult;
  /** Done archives the thread in Gmail; not done puts it back. */
  setInboxThreadDone: InboxThread;
  setInboxThreadRead: InboxThread;
  setInboxThreadStarred: InboxThread;
  setInvoicePaymentOptions: SubscriptionInvoice;
  /** Admins and owners only. Decides who may see an article. Later crawls leave the decision alone, and it settles a review. */
  setKnowledgeArticleAudience: KbArticle;
  /** Admins and owners only. Replaces a website's or help centre's audience rules, in order. With applyToExisting, the source's articles are brought in line now; otherwise the rules apply as articles are next read or added. */
  setKnowledgeAudienceRules: KbAudienceRulesResult;
  setLibraryDocumentArchived: LibraryDocumentEntity;
  /** Choose which tools the agent may call, which of them only read, and switch on. */
  setMcpRemoteServerTools: McpRemoteServerView;
  /** Set the MODULE-scoped price for a component referenced by a Module version (PRD §17.4). Overrides GLOBAL_DEFAULT for subscriptions pinned to that module. Idempotent. */
  setModuleComponentPrice: VariableComponentPrice;
  /** Sets which incoming email puts a notification in your bell. NONE turns the "new email" notification off. */
  setNotificationCenterEmailScope: EmailNotificationScope;
  /** Move the start value while the cycle is a draft, and the target with it when given. Refused once the start is frozen at publish */
  setOkrKeyResultStartValue: OkrKeyResult;
  /** Set a contact as the primary contact for the organization */
  setOrganizationPrimaryContact: OrganizationContact;
  setPrimaryTaxRegistration: TaxRegistration;
  /** Replace the origins whose pages may send product events from the browser. Each entry is a scheme and host, for example https://app.example.com. Workspace admins and owners only. */
  setProductEventBrowserOrigins: ProductEventSettings;
  setRecurrenceRuleActive: RecurrenceRule;
  /** Choose the channel cycle announcements go to. The bot joins it if needed */
  setSlackAnnouncementChannel: SlackWorkspaceStatus;
  /** Mark zero usage as normal (or not) for one component on a subscription. When normal, a period that closes at zero raises no warning to the admins. Billing is unchanged. */
  setSubscriptionComponentZeroUsageExpected: Scalars['Boolean']['output'];
  /** Set the subscription's discount stacking mode (§8.7). Default COMBINE. */
  setSubscriptionDiscountStackingMode: DiscountStackingMode;
  /** Payments entered on an import review row; applied once when the invoice is committed. */
  setSyncResultPayments: Scalars['Boolean']['output'];
  /** Archive or unarchive a single task. */
  setTaskArchived: Task;
  /** Set grantable features (e.g. CRM) for a client tenant (platform admin only) */
  setTenantFeatures: Tenant;
  /** Set a tenant’s seat limit and price (platform admins). Lowering the limit below current usage is allowed and deactivates nobody */
  setTenantSeatPolicy: SeatUsage;
  /** Let the AI answer this chat beside the team (or stop it). While on, the AI keeps replying to the customer even with an assignee, a public agent reply or an earlier handover. */
  setTicketAiAlongside: SupportTicket;
  /** Tells others on the ticket you are typing. Send at most every few seconds while typing; never stored. internal = writing an internal note. False when live updates are unavailable. */
  setTyping: Scalars['Boolean']['output'];
  /** Set absolute quantity. Internally computed as a delta and validated against the same gates as add/remove. */
  setVariableUsage: SubscriptionVariableUsage;
  /** Remember the current user's last-used view for one UI surface (conversation, tasks, …). Other surfaces are unchanged. */
  setViewPreference: Array<ViewPreference>;
  /** Admins and owners only. Sets the list a ticket type’s tasks start in; a null list clears it. Returns every type’s routing. */
  setWorkItemRouting: Array<WorkItemRouting>;
  /** Display sample analytics data that would be available */
  showSampleAnalytics: Scalars['Boolean']['output'];
  /** Stamps your saved signature onto a PDF and returns a new file. A visual signature, not a certified one. Names a record to file the signed copy on it. */
  signFile: SignedFile;
  /** Pretend Slack is unreachable for this tenant, to exercise the degraded banner. Not available in production */
  simulateSlackOutage: Scalars['Boolean']['output'];
  /** Skip an onboarding step (if allowed) */
  skipOnboardingStep: CompleteStepResult;
  /** Put the thread away until a time; it leaves the inbox in Gmail and comes back then, or when someone writes. */
  snoozeInboxThread: InboxThread;
  snoozeTask: Task;
  startAgentSession: AgentSessionType;
  /** Start (or resume) assistant-led onboarding. Owner only; idempotent. */
  startAssistantOnboarding: AssistantOnboardingState;
  /** Begin connecting this tenant’s Calendly account. Returns the URL to send the operator to. Tenant admin/owner only. */
  startCalendlyConnection: Scalars['String']['output'];
  /** Start a new empty chat session. */
  startChatSession: ChatCreationSession;
  /** Start saving a card for a client; confirm it in the browser with Stripe Elements. */
  startClientCardSetup: CardSetupResult;
  startGoogleDriveSync: Scalars['String']['output'];
  /** Admins and owners only. Starts reading the tenant’s Intercom conversations in the background and returns at once. Read-only on Intercom; safe to run again, existing conversations are skipped. */
  startIntercomImport: SupportImportRun;
  /** Begin OAuth for a server. Returns the page to open in the browser, or null when it is already connected. */
  startMcpRemoteServerOAuth?: Maybe<Scalars['String']['output']>;
  /** Backlog to Developing. Needs an owner and all four score inputs */
  startOkrHypothesisDeveloping: OkrHypothesisWriteResult;
  /** Start the test. Expected outcome, decision rule and end date are required and lock */
  startOkrHypothesisTesting: OkrHypothesisWriteResult;
  /** Move an active cycle into scoring: check-ins stop and owners confirm final values. Cycle owners only */
  startOkrScoring: OkrCycle;
  /** Start the onboarding process for the tenant */
  startOnboarding: OnboardingStatusResponse;
  /** Start Stripe Connect. Returns the Stripe URL to send the admin to. Admin only. */
  startStripeConnect: Scalars['String']['output'];
  /** Admins and owners only. Starts a backtest in the background: Revvly's AI drafts silently on a sample of imported Intercom conversations and a second model grades each draft. Writes nothing to any ticket; counts toward the daily AI spend cap; never billable. Does not need AI answers to be switched on. */
  startSupportCompare: SupportCompareRun;
  /** Stop a definition: blocks future use only; every existing active instance keeps running (§8.12). */
  stopDiscountDefinition: DiscountDefinitionEntity;
  /** Confirm a Key Result’s final value with a comment. The score is computed here, never supplied */
  submitOkrScore: OkrKeyResult;
  /** Ask for suggestions, drawn from the support documentation, for the named events or, with none named, for the waiting events that have none (at most 15 a run). Nothing is mapped until a person accepts. Workspace admins and owners only. */
  suggestProductEventMappings: ProductEventSuggestionRun;
  /** Manually invoke the FR-29 expiry sweep. Returns count of agreements transitioned PUBLISHED → EXPIRED. */
  sweepExpiredCustomPricingAgreements: Scalars['Int']['output'];
  syncCrmEmailDocuments: CrmEmailDocumentFilingResult;
  /** Sync feature flag assignments from the main application */
  syncFeatureFlagsFromMainApp: SyncResult;
  /** Sync feature flag assignments to the main application */
  syncFeatureFlagsToMainApp: SyncResult;
  /** Take an unassigned ticket for yourself (the pull queue). Fails with CONFLICT, naming who has it, when another agent took it first. */
  takeTicket: SupportTicket;
  /** The invitation link for a tenant member who hasn't logged in yet — the same token an invitation email carries, with the same limitations */
  tenantUserInvitationLink: Scalars['String']['output'];
  unarchiveAgentSession: AgentSessionType;
  /** Restore an archived pipeline to the board. */
  unarchiveCrmPipeline: CrmPipeline;
  /** Restore an archived team, with its membership intact */
  unarchiveTeam: TeamDetail;
  /** Undo one automatic action. Refused when the thread has changed since. */
  undoInboxAction: InboxActionLogEntry;
  /** Undo an automatic move to Other; the sender is never demoted again. */
  undoInboxDemotion: InboxThread;
  /** Remove one link. Removing one that is not there is not an error */
  unlinkOkrKeyResult: OkrKeyResultAlignment;
  /** Remove a work link. The task in ClickUp stays; the comment Revvly left on it is struck through and says who disconnected it */
  unlinkOkrWorkItem: OkrKeyResultWorkLinks;
  /** Stop syncing. The Drive folder is left as it is. */
  unlinkOrganizationDriveFolder: OrganizationDriveFolder;
  /** Remove a Variable Component ref from a parent Module or Bundle's variableComponentRefs[]. The inverse of linkVariableComponentToParent. Only permitted while the parent is a DRAFT. Returns false when the ref was not present. Archive any scoped price separately via remove{Module,Bundle}ComponentPrice. */
  unlinkVariableComponentFromParent: Scalars['Boolean']['output'];
  /** Remove a link. The task in ClickUp is untouched. */
  unlinkWorkItem: Scalars['Boolean']['output'];
  /** Remove one member’s Calendly link. Tenant admin/owner only. */
  unmapCalendlyMember: Scalars['Boolean']['output'];
  /** Remove a person’s ClickUp link. Their check-ins stop going to ClickUp. Admin only */
  unmapClickupMember: Scalars['Boolean']['output'];
  /** Remove one person’s Slack link */
  unmapSlackMember: Scalars['Boolean']['output'];
  /** Stop accepting submissions. */
  unpublishForm: Form;
  /** One-click unsubscribe from the sender’s list; the thread is done and the sender skips the inbox. */
  unsubscribeInboxThread: InboxThread;
  /** Reword one agent memory; its scope stays. A workspace memory needs a tenant admin. */
  updateAgentMemory: AgentMemory;
  /** Change the per-second and per-minute request limits of an active key. Tenant admin/owner only. Takes effect on the next request. */
  updateApiKeyRateLimits: ApiKey;
  /** Auto-charge and retry settings. Admin only. */
  updateAutoCharge: PaymentConnectionView;
  /** Edit a route. Only the fields supplied are changed. Tenant admin/owner only. */
  updateBookingIntakeRoute: BookingIntakeRoute;
  updateBundle: Bundle;
  /** Save the business profile. Only the fields sent are changed */
  updateBusinessProfile: BusinessProfileType;
  /** Edit a check-in. Applies from the next run; a run already started keeps what it was started with. */
  updateCheckin: Checkin;
  /** Set or clear a client's customer-success status. */
  updateClientCsStatus: Organization;
  /** Assign or clear a client's customer-success manager. */
  updateClientCsm: Organization;
  /** Set or clear the named custom fields on a client; other fields stay as they are. */
  updateClientCustomFields: Organization;
  /** Admins and owners only. Replaces the stage list. A stale expectedVersion is a CONFLICT. Moves tickets’ stages if mappings are affected, and tells no client anything. */
  updateClientStages: ClientStageSettings;
  /** Replace a client's tags. */
  updateClientTags: Organization;
  /** Set or clear the named custom fields on a contact; other fields stay as they are. */
  updateContactCustomFields: OrganizationContact;
  /** Replace a contact's tags. */
  updateContactTags: OrganizationContact;
  /** Set a contract record's sub-processor and breach terms. A clause left out is cleared. */
  updateContractClauses: OrganizationContract;
  /** Save a new version. Contracts already sent keep the text they were sent with. */
  updateContractTemplate: ContractTemplate;
  /** Edit a manually logged past touch. */
  updateCrmEmailMessage: CrmEmailMessage;
  updateCrmEmailTemplate: CrmEmailTemplate;
  updateCrmLead: CrmLead;
  /** Set or clear the named custom fields on a deal; other fields stay as they are. */
  updateCrmLeadCustomFields: CrmLead;
  /** Replace a deal's tags. */
  updateCrmLeadTags: CrmLead;
  updateCrmLifecycleStage: Scalars['Boolean']['output'];
  updateCrmMeeting: CrmMeeting;
  /** Edit an internal note. */
  updateCrmNote: CrmNote;
  updateCrmOwner: Scalars['Boolean']['output'];
  /** Rename, describe, re-scope access to, or make default a pipeline. */
  updateCrmPipeline: CrmPipeline;
  updateCrmTag: CrmTag;
  updateCustomField: CustomFieldDefinition;
  /** Update a DRAFT Custom Pricing Agreement. PUBLISHED agreements are immutable. */
  updateCustomPricingAgreementDraft: CustomPricingAgreement;
  /** Edit a definition. Affects FUTURE applications only — existing instances are snapshots (§8.1). */
  updateDiscountDefinition: DiscountDefinitionEntity;
  updateDriveClientFolderSettings: DriveClientFolderSettings;
  updateEmailSignature: EmailSignature;
  updateEstimatedPaymentDate: SubscriptionInvoice;
  /** Update external API configuration for the current tenant */
  updateExternalApiConfig: Tenant;
  updateFeatureFlag: FeatureFlag;
  updateFeatureFlagCategory: FeatureFlagCategory;
  /** Save the draft. The live version changes only on publish. */
  updateForm: Form;
  updateGeoRegion: GeoRegion;
  /** Change where categories go and the digest; open threads in a changed category move with it. */
  updateInboxSettings: InboxSettings;
  updateIncubator: Incubator;
  updateIncubatorFeatureFlags: IncubatorFlags;
  updateIncubatorsByFeatureFlags: UpdateIncubatorFlagsPayload;
  updateInvoice: SubscriptionInvoice;
  updateInvoicePaymentStatus: SubscriptionInvoice;
  /** Admins and owners only. */
  updateKnowledgeSource: KnowledgeSource;
  updateLibraryDocument: LibraryDocumentEntity;
  /** Update an existing meter */
  updateMeter: Meter;
  updateModule: Module;
  /** Update the current user's default follow-up task delay in days after sending an email */
  updateMyFollowUpTaskDefaultDays: User;
  /** Update the current user's display name */
  updateMyName: User;
  /** Set the current user’s digest day, hour and muted categories. Assignment and cycle-state messages cannot be muted */
  updateMyNotificationSettings: NotificationSettings;
  /** Set the current user's IANA timezone (e.g. Europe/Brussels). Scheduled prompts fire at this zone's local hour. */
  updateMyTimezone: User;
  /** Sets whether each kind reaches your bell. Kinds not sent keep their setting. */
  updateNotificationCenterPreferences: Array<NotificationCenterPreference>;
  /** Edit a check-in. Its author or a cycle owner, active cycles only */
  updateOkrCheckIn: OkrKeyResult;
  /** Rename a cycle or move its end date */
  updateOkrCycle: OkrCycle;
  /** Edit a hypothesis. RICE inputs, expected outcome and decision rule are locked once testing starts */
  updateOkrHypothesis: OkrHypothesisWriteResult;
  /** Start value is deliberately absent from the input — it is locked at publish */
  updateOkrKeyResult: OkrKeyResult;
  updateOkrObjective: OkrObjective;
  /** Amend a score while the cycle is still being scored. Refused once it is closed */
  updateOkrScore: OkrKeyResult;
  /** Update an existing organization */
  updateOrganization: Organization;
  /** Update an existing organization contact */
  updateOrganizationContact: OrganizationContact;
  /** Edit a contract. Omitted fields are left alone. A change to startsAt or termMonths is checked against every subscription already attached — the term must still divide into their billing periods — and the new commitment boundary is copied to all of them, so a term edit cannot be used to get past the attach guards. */
  updateOrganizationContract: OrganizationContract;
  /** Edit an endpoint. Only the fields supplied change. Admin only. */
  updateOutboundWebhookEndpoint: OutboundWebhookEndpoint;
  updatePaymentReminderTemplate: PaymentReminderTemplate;
  updatePipelineStage: CrmPipeline;
  /** Change self-serve billing settings (platform admin only). Applies to new signups. */
  updatePlatformBillingConfig: PlatformBillingConfig;
  /** Edit an open incident (platform admin only). */
  updatePlatformIncident: PlatformIncident;
  updatePricingRule: PricingRule;
  updateRecurrenceRule: RecurrenceRule;
  /** Update an existing region */
  updateRegion: Region;
  /** Change some situation thresholds. A value sets it, null resets it to the default, and an omitted value is left alone. Takes effect at the next nightly sweep. Tenant admin/owner only. */
  updateSituationThresholds: SituationThresholdSettings;
  updateSubscription: OrganizationSubscription;
  /** Sets in-app and email per kind. Kinds not sent keep their current setting. */
  updateSupportNotificationPreferences: Array<SupportNotificationPreference>;
  /** Tenant admins and owners only. */
  updateSupportSettings: SupportSettings;
  /** Toggle subfolder scanning for a synced folder. */
  updateSyncFolder: GoogleDriveConnectionEntity;
  updateSyncResult: GoogleDriveSyncResultEntity;
  updateTask: Task;
  updateTaskStatus: Task;
  updateTaxRateDraft: TaxRate;
  updateTaxRegistration: TaxRegistration;
  updateTaxSettings: TaxSettings;
  /** Rename a team or change its lead */
  updateTeam: TeamDetail;
  updateTenant: Tenant;
  /** Update core settings for the current tenant (reporting currency and invoice defaults) */
  updateTenantCoreSettings: Tenant;
  /** Update the invoice header (issuer details: logo, address, tax info) for the current tenant */
  updateTenantInvoiceHeader: Tenant;
  /** Set the workspace-wide notification defaults */
  updateTenantNotificationDefaults: TenantNotificationDefaults;
  /** Update payment information (banking details per currency and free-form instructions) for the current tenant */
  updateTenantPaymentInfo: Tenant;
  /** Update a tenant user role or status */
  updateTenantUser: UserTenant;
  /** Set the days the tenant works and, optionally, its timezone (tenant admins only). Applies to follow-up tasks created afterwards; existing tasks keep their due dates. */
  updateTenantWorkingCalendar: TenantWorkingCalendar;
  /** Edit type, status, priority, tags and title in one step. Fails with CONFLICT when the ticket changed since expectedVersion. */
  updateTicket: SupportTicket;
  /** Update a DRAFT Variable Component. PUBLISHED components are immutable. */
  updateVariableComponentDraft: VariableComponent;
  /** Tenant admins and owners only. Changes the URL, the events or whether it is on. Turning it on clears its failure count. The secret is kept. */
  updateWebhookEndpoint: WebhookEndpoint;
  /** Upload and resize the invoice-header logo for the current tenant (returns the updated tenant) */
  uploadInvoiceLogo: Tenant;
  upsertClientEmailDraft: SendClientEmailResult;
  upsertCustomerTaxProfile: CustomerTaxProfile;
  upsertStatusWorkflow: StatusWorkflow;
  upsertSupportRole: SupportRole;
  upsertTicketType: TicketType;
  /** Admins and owners only. Sets which stage each status of a list means (listId omitted: the default for every list without its own). An empty set removes the map. Returns null when removed. */
  upsertWorkItemStatusMap?: Maybe<StatusMap>;
  /** Admins and owners only. Reverses the AI resolution charge on a ticket. The charge stays on record and a void is added; the ticket cannot be charged again. */
  voidAiResolution: Scalars['Boolean']['output'];
  /** Waive an open closed-period reading with a required reason (R11). Releases held invoices and bills nothing for the period. */
  waiveUsageReading: UsageReading;
};

export type MutationAcceptCatalogGapArgs = {
  clusterKey: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};

export type MutationAcceptDriveFolderSuggestionsArgs = {
  items: Array<AcceptDriveFolderSuggestionInput>;
};

export type MutationAcceptInvitationArgs = {
  token: Scalars['String']['input'];
};

export type MutationAcceptMemberInviteArgs = {
  token: Scalars['String']['input'];
};

export type MutationAcceptProductEventSuggestionArgs = {
  eventName: Scalars['String']['input'];
};

export type MutationActivateFeatureFlagArgs = {
  id: Scalars['ID']['input'];
};

export type MutationActivateFeatureFlagCategoryArgs = {
  id: Scalars['ID']['input'];
};

export type MutationActivateMeterArgs = {
  id: Scalars['ID']['input'];
};

export type MutationActivatePricingRuleArgs = {
  id: Scalars['ID']['input'];
};

export type MutationActivateSubscriptionArgs = {
  input: ActivateSubscriptionInput;
};

export type MutationAddCurrencyToRegionArgs = {
  input: AddCurrencyToRegionInput;
};

export type MutationAddFeatureFlagToBundleArgs = {
  bundleId: Scalars['ID']['input'];
  enabled?: Scalars['Boolean']['input'];
  featureFlagId: Scalars['ID']['input'];
};

export type MutationAddFeatureFlagToTierArgs = {
  input: AddFeatureFlagToTierInput;
};

export type MutationAddKnowledgeDocumentArgs = {
  input: KnowledgeDocumentInput;
};

export type MutationAddLibraryDocumentVersionArgs = {
  input: AddLibraryDocumentVersionInput;
};

export type MutationAddModuleTierArgs = {
  input: AddModuleTierInput;
};

export type MutationAddModuleToBundleArgs = {
  bundleId: Scalars['ID']['input'];
  moduleId: Scalars['ID']['input'];
};

export type MutationAddOkrHypothesisLinkArgs = {
  acknowledge?: InputMaybe<Array<Scalars['String']['input']>>;
  hypothesisId: Scalars['ID']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

export type MutationAddParticipantToChatArgs = {
  sessionId: Scalars['ID']['input'];
  userId: Scalars['String']['input'];
};

export type MutationAddPipelineStageArgs = {
  input: PipelineStageInput;
  pipelineId: Scalars['ID']['input'];
};

export type MutationAddProductMarketArgs = {
  input: AddProductMarketInput;
};

export type MutationAddProspectToPipelineArgs = {
  forecast?: InputMaybe<CrmLeadForecastInput>;
  organizationId: Scalars['ID']['input'];
  pipelineId?: InputMaybe<Scalars['ID']['input']>;
  pipelineStageId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationAddSubscriptionScopedPriceArgs = {
  componentId: Scalars['ID']['input'];
  componentVersion: Scalars['Int']['input'];
  pricesByCurrency: Array<PricingVariantInput>;
  reason?: InputMaybe<Scalars['String']['input']>;
  subscriptionId: Scalars['ID']['input'];
};

export type MutationAddSuggestedOrganizationContactsArgs = {
  input: AddSuggestedContactsInput;
};

export type MutationAddSyncFolderArgs = {
  folderId: Scalars['String']['input'];
};

export type MutationAddTaskAssigneeArgs = {
  assignee: AssigneeInput;
  id: Scalars['ID']['input'];
};

export type MutationAddTaskAttachmentArgs = {
  id: Scalars['ID']['input'];
  input: AttachmentInput;
};

export type MutationAddTaskExternalLinkArgs = {
  id: Scalars['ID']['input'];
  input: ExternalLinkInput;
};

export type MutationAddTeamMembersArgs = {
  input: AddTeamMembersInput;
};

export type MutationAddUserToTenantArgs = {
  role?: Scalars['String']['input'];
  tenantId: Scalars['ID']['input'];
  userId: Scalars['String']['input'];
};

export type MutationAddVariableUsageArgs = {
  input: AddVariableUsageInput;
};

export type MutationAdjustComponentUsageArgs = {
  input: AdjustComponentUsageInput;
};

export type MutationAdvanceOnboardingTourArgs = {
  action: OnboardingTourAction;
  fromStep?: InputMaybe<Scalars['String']['input']>;
  toStep?: InputMaybe<Scalars['String']['input']>;
};

export type MutationAnalyzeColumnsArgs = {
  input: AnalyzeColumnsInput;
};

export type MutationAnswerDocumentSuggestionArgs = {
  accept: Scalars['Boolean']['input'];
  documentId: Scalars['ID']['input'];
};

export type MutationAnswerDriveFolderMoveOfferArgs = {
  move: Scalars['Boolean']['input'];
  organizationId: Scalars['ID']['input'];
};

export type MutationApplyAllFormClientSubmissionArgs = {
  id: Scalars['ID']['input'];
};

export type MutationApplyCreditNoteArgs = {
  input: ApplyCreditNoteInput;
};

export type MutationApplyFormClientSubmissionArgs = {
  id: Scalars['ID']['input'];
  target: FormClientApplyTarget;
};

export type MutationApplySubscriptionDiscountArgs = {
  input: ApplyDiscountInput;
};

export type MutationApproveInviteRequestArgs = {
  requestId: Scalars['ID']['input'];
};

export type MutationArchiveAgentSessionArgs = {
  id: Scalars['ID']['input'];
};

export type MutationArchiveCheckinArgs = {
  id: Scalars['ID']['input'];
};

export type MutationArchiveContractTemplateArgs = {
  id: Scalars['ID']['input'];
};

export type MutationArchiveCrmPipelineArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<ArchiveCrmPipelineInput>;
};

export type MutationArchiveDiscountDefinitionArgs = {
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};

export type MutationArchiveFormArgs = {
  id: Scalars['ID']['input'];
};

export type MutationArchivePipelineStageArgs = {
  moveLeadsToStageId?: InputMaybe<Scalars['ID']['input']>;
  pipelineId: Scalars['ID']['input'];
  stageId: Scalars['ID']['input'];
};

export type MutationArchiveTaxRateArgs = {
  id: Scalars['ID']['input'];
};

export type MutationArchiveTeamArgs = {
  id: Scalars['ID']['input'];
};

export type MutationArchiveVariableComponentArgs = {
  id: Scalars['ID']['input'];
};

export type MutationAssignTaskArgs = {
  assignees: Array<AssigneeInput>;
  id: Scalars['ID']['input'];
};

export type MutationAssignTicketArgs = {
  assigneeUserId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  teamId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationAttachContractToSubscriptionArgs = {
  contractId: Scalars['ID']['input'];
  subscriptionId: Scalars['ID']['input'];
};

export type MutationAttachDriveFileToEmailArgs = {
  driveFileId: Scalars['String']['input'];
};

export type MutationAttachOkrKeyResultMetricArgs = {
  id: Scalars['ID']['input'];
  metricKey: OkrMetricKey;
  metricPipelineId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationAttachOrganizationContactArgs = {
  contactId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export type MutationAttachVariableComponentToSubscriptionArgs = {
  billingTiming?: InputMaybe<BillingTiming>;
  componentId: Scalars['ID']['input'];
  componentVersion: Scalars['Int']['input'];
  includedGmvByCurrency?: InputMaybe<Array<IncludedGmvInput>>;
  includedQuantity?: InputMaybe<Scalars['Int']['input']>;
  includedTransactionCount?: InputMaybe<Scalars['Int']['input']>;
  pricesByCurrency?: InputMaybe<Array<PricingVariantInput>>;
  reason?: InputMaybe<Scalars['String']['input']>;
  subscriptionId: Scalars['ID']['input'];
};

export type MutationBackfillAnalyticsSnapshotsArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate: Scalars['DateTime']['input'];
  type?: Scalars['String']['input'];
};

export type MutationBackfillExchangeRatesArgs = {
  input: BackfillExchangeRatesInput;
};

export type MutationBackfillOrganizationEmailsArgs = {
  organizationId: Scalars['ID']['input'];
};

export type MutationBackfillOutboundWebhookEndpointArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};

export type MutationBindMcpOauthTenantArgs = {
  tenantId: Scalars['ID']['input'];
};

export type MutationBulkApproveRenewalActionsArgs = {
  actionIds: Array<Scalars['ID']['input']>;
};

export type MutationBulkDeleteApplicationByIncubatorArgs = {
  confirmationIncubatorName: Scalars['String']['input'];
  incubatorId: Scalars['ID']['input'];
};

export type MutationBulkDeleteInvoicesArgs = {
  input: BulkDeleteInvoicesInput;
};

export type MutationBulkDeleteKnowledgeArticlesArgs = {
  target: KbArticleBulkTargetInput;
};

export type MutationBulkDeleteTasksArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type MutationBulkDisableOrganizationFeatureFlagArgs = {
  input: BulkEnableOrganizationFeatureFlagInput;
};

export type MutationBulkEnableOrganizationFeatureFlagArgs = {
  input: BulkEnableOrganizationFeatureFlagInput;
};

export type MutationBulkEnterUsageReadingsArgs = {
  input: BulkEnterUsageReadingsInput;
};

export type MutationBulkExcludeKnowledgeArticlesArgs = {
  reason?: InputMaybe<Scalars['String']['input']>;
  target: KbArticleBulkTargetInput;
};

export type MutationBulkMarkInvoicesPaidArgs = {
  input: BulkMarkInvoicesPaidInput;
};

export type MutationBulkMigrateSubscriptionsArgs = {
  migrationKind: MigrationKind;
  reason?: InputMaybe<Scalars['String']['input']>;
  subscriptionIds: Array<Scalars['ID']['input']>;
  targetId?: InputMaybe<Scalars['ID']['input']>;
  targetVersion: Scalars['Int']['input'];
  timing: MigrationTiming;
};

export type MutationBulkRegenerateInvoicesArgs = {
  input: BulkInvoiceIdsInput;
};

export type MutationBulkRejectRenewalActionsArgs = {
  actionIds: Array<Scalars['ID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type MutationBulkResolveDiscrepanciesArgs = {
  input: BulkResolveInput;
};

export type MutationBulkSetKnowledgeArticleAudienceArgs = {
  audience: KbAudienceInput;
  target: KbArticleBulkTargetInput;
};

export type MutationBulkSetTasksArchivedArgs = {
  archived: Scalars['Boolean']['input'];
  ids: Array<Scalars['ID']['input']>;
};

export type MutationBulkSyncFeatureFlagsToMainAppArgs = {
  input: SyncFeatureFlagsInput;
};

export type MutationBulkUpdateClientsArgs = {
  input: BulkUpdateClientsInput;
};

export type MutationBulkUpdatePaymentStatusArgs = {
  input: BulkUpdatePaymentStatusInput;
};

export type MutationCancelContractSendPlanArgs = {
  id: Scalars['ID']['input'];
};

export type MutationCancelPendingMigrationArgs = {
  reason?: InputMaybe<Scalars['String']['input']>;
  subscriptionId: Scalars['ID']['input'];
};

export type MutationCancelSignatureRequestArgs = {
  id: Scalars['ID']['input'];
};

export type MutationCancelSubscriptionArgs = {
  earlyTermination?: InputMaybe<EarlyTerminationPolicy>;
  id: Scalars['ID']['input'];
};

export type MutationCancelSubscriptionDiscountArgs = {
  instanceId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};

export type MutationCancelSupportCompareArgs = {
  id: Scalars['ID']['input'];
};

export type MutationCancelSupportImportArgs = {
  id: Scalars['ID']['input'];
};

export type MutationCancelTaskArgs = {
  id: Scalars['ID']['input'];
};

export type MutationCarryOkrHypothesisArgs = {
  id: Scalars['ID']['input'];
  targetKeyResultId: Scalars['ID']['input'];
};

export type MutationChangeSubscriptionPlanArgs = {
  bundleId?: InputMaybe<Scalars['ID']['input']>;
  legacyVersionPin?: InputMaybe<LegacyVersionPinInput>;
  moduleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  moduleTiers?: InputMaybe<Array<ModuleTierSelectionInput>>;
  prepaidSpanChange?: InputMaybe<PrepaidSpanChange>;
  reason?: InputMaybe<Scalars['String']['input']>;
  subscriptionId: Scalars['ID']['input'];
  timing: MigrationTiming;
};

export type MutationChargeInvoiceNowArgs = {
  invoiceId: Scalars['ID']['input'];
};

export type MutationClearCheckinAwayArgs = {
  userId: Scalars['String']['input'];
};

export type MutationClearInboxCategoryPolicyArgs = {
  category: InboxCategory;
};

export type MutationCloseOkrCycleArgs = {
  confirmUnscored?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};

export type MutationCloseTicketArgs = {
  id: Scalars['ID']['input'];
  resolution: AgentTicketResolution;
};

export type MutationCommitSubscriptionPlanArgs = {
  input: CommitSubscriptionPlanInput;
};

export type MutationCommitSyncedInvoicesArgs = {
  jobId: Scalars['String']['input'];
  selectedResultIds: Array<Scalars['String']['input']>;
};

export type MutationCompleteOnboardingStepArgs = {
  input: CompleteOnboardingStepInput;
};

export type MutationCompleteTaskArgs = {
  id: Scalars['ID']['input'];
};

export type MutationConcludeOkrHypothesisArgs = {
  id: Scalars['ID']['input'];
  input: ConcludeHypothesisInputType;
};

export type MutationConfirmCalendlyMatchesArgs = {
  userIds: Array<Scalars['String']['input']>;
};

export type MutationConfirmClickupMatchesArgs = {
  matches: Array<ClickUpMatchInput>;
};

export type MutationConfirmEmailChangeArgs = {
  token: Scalars['String']['input'];
};

export type MutationConfirmPricingDraftArgs = {
  id: Scalars['ID']['input'];
};

export type MutationConfirmSlackMatchesArgs = {
  userIds: Array<Scalars['String']['input']>;
};

export type MutationConfirmSupportAttachmentUploadArgs = {
  fileId: Scalars['ID']['input'];
  ticketId: Scalars['ID']['input'];
};

export type MutationConfirmUploadArgs = {
  input: ConfirmUploadInput;
};

export type MutationConnectClickUpKnowledgeSourceArgs = {
  input: ConnectClickUpKnowledgeSourceInput;
};

export type MutationConnectKnowledgeSourceArgs = {
  input: ConnectKnowledgeSourceInput;
};

export type MutationConnectStripeWithKeyArgs = {
  input: ConnectStripeWithKeyInput;
};

export type MutationConvertCrmLeadArgs = {
  id: Scalars['ID']['input'];
  subscriptionId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationCorrectUsageReadingArgs = {
  input: CorrectUsageReadingInput;
};

export type MutationCrawlKnowledgeSourceArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  reguessAudience?: InputMaybe<Scalars['Boolean']['input']>;
  sourceId: Scalars['ID']['input'];
};

export type MutationCreateBookingIntakeRouteArgs = {
  input: BookingIntakeRouteInput;
};

export type MutationCreateBundleArgs = {
  input: CreateBundleInput;
};

export type MutationCreateBundleDraftVersionArgs = {
  id: Scalars['ID']['input'];
};

export type MutationCreateCheckinArgs = {
  input: CreateCheckinInput;
};

export type MutationCreateContactRoleArgs = {
  input: CreateContactRoleInput;
};

export type MutationCreateContractTemplateArgs = {
  input: ContractTemplateInput;
};

export type MutationCreateContractTemplateDraftArgs = {
  input: ContractTemplateInput;
};

export type MutationCreateCrmDocumentUploadUrlArgs = {
  input: CreateCrmDocumentInput;
};

export type MutationCreateCrmEmailTemplateArgs = {
  input: CreateCrmEmailTemplateInput;
};

export type MutationCreateCrmLeadArgs = {
  input: CreateCrmLeadInput;
};

export type MutationCreateCrmNoteArgs = {
  input: CreateCrmNoteInput;
};

export type MutationCreateCrmPipelineArgs = {
  input: CreateCrmPipelineInput;
};

export type MutationCreateCrmTagArgs = {
  input: CreateCrmTagInput;
};

export type MutationCreateCustomFieldArgs = {
  input: CreateCustomFieldInput;
};

export type MutationCreateCustomPricingAgreementArgs = {
  input: CreateCustomPricingAgreementInput;
};

export type MutationCreateDiscountDefinitionArgs = {
  input: UpsertDiscountDefinitionInput;
};

export type MutationCreateDriveFolderArgs = {
  name: Scalars['String']['input'];
  parentId: Scalars['String']['input'];
};

export type MutationCreateDriveFoldersForUnmappedArgs = {
  scope: Scalars['String']['input'];
};

export type MutationCreateEmailSignatureArgs = {
  input: CreateEmailSignatureInput;
};

export type MutationCreateFeatureFlagArgs = {
  input: CreateFeatureFlagInput;
};

export type MutationCreateFeatureFlagCategoryArgs = {
  input: CreateFeatureFlagCategoryInput;
};

export type MutationCreateFormArgs = {
  input: CreateFormInput;
};

export type MutationCreateFormClientLinkArgs = {
  formId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export type MutationCreateGeoRegionArgs = {
  input: CreateGeoRegionInput;
};

export type MutationCreateHistoricalBundleVersionArgs = {
  basedOnVersion?: InputMaybe<Scalars['Int']['input']>;
  effectiveFrom: Scalars['DateTime']['input'];
  lineageId: Scalars['ID']['input'];
};

export type MutationCreateHistoricalModuleVersionArgs = {
  basedOnVersion?: InputMaybe<Scalars['Int']['input']>;
  effectiveFrom: Scalars['DateTime']['input'];
  lineageId: Scalars['ID']['input'];
};

export type MutationCreateHistoricalVariableComponentVersionArgs = {
  basedOnVersion?: InputMaybe<Scalars['Int']['input']>;
  effectiveFrom: Scalars['DateTime']['input'];
  lineageId: Scalars['ID']['input'];
};

export type MutationCreateIncubatorArgs = {
  createSampleData?: InputMaybe<Scalars['Boolean']['input']>;
  input: CreateIncubatorInput;
};

export type MutationCreateInvoiceArgs = {
  input: CreateInvoiceInput;
};

export type MutationCreateKnowledgeSourceArgs = {
  input: KnowledgeSourceInput;
};

export type MutationCreateLibraryDocumentArgs = {
  input: CreateLibraryDocumentInput;
};

export type MutationCreateMeterArgs = {
  input: CreateMeterInput;
};

export type MutationCreateModuleArgs = {
  input: CreateModuleInput;
};

export type MutationCreateModuleDraftVersionArgs = {
  id: Scalars['ID']['input'];
};

export type MutationCreateOkrCheckInArgs = {
  input: CreateCheckInInputType;
};

export type MutationCreateOkrCycleArgs = {
  input: CreateCycleInputType;
};

export type MutationCreateOkrHypothesisArgs = {
  input: CreateHypothesisInputType;
};

export type MutationCreateOkrKeyResultArgs = {
  input: CreateKeyResultInputType;
};

export type MutationCreateOkrObjectiveArgs = {
  input: CreateObjectiveInputType;
};

export type MutationCreateOrganizationArgs = {
  input: CreateOrganizationInput;
};

export type MutationCreateOrganizationContactArgs = {
  input: CreateOrganizationContactInput;
};

export type MutationCreateOrganizationContractArgs = {
  input: CreateOrganizationContractInput;
};

export type MutationCreateOrganizationDriveFolderArgs = {
  organizationId: Scalars['ID']['input'];
};

export type MutationCreateOutboundWebhookEndpointArgs = {
  input: CreateOutboundWebhookEndpointInput;
};

export type MutationCreatePlatformIncidentArgs = {
  input: PlatformIncidentInput;
};

export type MutationCreatePricingRuleArgs = {
  input: CreatePricingRuleInput;
};

export type MutationCreateProspectOrganizationArgs = {
  input: CreateProspectOrganizationInput;
};

export type MutationCreateProspectOrganizationContactArgs = {
  input: CreateProspectOrganizationContactInput;
};

export type MutationCreateRecurrenceRuleArgs = {
  input: CreateRecurrenceRuleInput;
};

export type MutationCreateRegionArgs = {
  input: CreateRegionInput;
};

export type MutationCreateRenewalActionArgs = {
  subscriptionId: Scalars['ID']['input'];
};

export type MutationCreateSampleDataArgs = {
  incubatorId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type MutationCreateSubscriptionExpansionArgs = {
  input: CreateExpansionInput;
};

export type MutationCreateSubscriptionWithPricingArgs = {
  createSubscriptionInput: CreateSubscriptionWithPricingInput;
};

export type MutationCreateSupportAttachmentUploadArgs = {
  filename: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
  size: Scalars['Int']['input'];
  ticketId: Scalars['ID']['input'];
};

export type MutationCreateSupportSandboxTokenArgs = {
  persona: SupportSandboxPersonaInput;
};

export type MutationCreateTaskArgs = {
  input: CreateTaskInput;
};

export type MutationCreateTaxRateArgs = {
  input: CreateTaxRateInput;
};

export type MutationCreateTaxRateVersionArgs = {
  id: Scalars['ID']['input'];
};

export type MutationCreateTaxRegistrationArgs = {
  input: CreateTaxRegistrationInput;
};

export type MutationCreateTeamArgs = {
  input: CreateTeamInput;
};

export type MutationCreateTenantArgs = {
  input: CreateTenantInput;
};

export type MutationCreateVariableComponentArgs = {
  input: CreateVariableComponentInput;
};

export type MutationCreateVariableComponentDraftVersionArgs = {
  id: Scalars['ID']['input'];
};

export type MutationCreateWebhookEndpointArgs = {
  events: Array<WebhookEventType>;
  url: Scalars['String']['input'];
};

export type MutationCreateWorkItemFromTicketArgs = {
  listId?: InputMaybe<Scalars['ID']['input']>;
  ticketId: Scalars['ID']['input'];
};

export type MutationDeactivateBundleArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeactivateFeatureFlagArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeactivateFeatureFlagCategoryArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeactivateMeterArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeactivateModuleArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeactivatePricingRuleArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeactivateTaxRegistrationArgs = {
  effectiveTo: Scalars['DateTime']['input'];
  id: Scalars['ID']['input'];
};

export type MutationDecideRenewalActionArgs = {
  input: RenewalActionDecisionInput;
};

export type MutationDeclineInviteRequestArgs = {
  requestId: Scalars['ID']['input'];
};

export type MutationDeleteAgentSessionArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteBookingIntakeRouteArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteBundleArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteClientEmailDraftArgs = {
  draftId: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export type MutationDeleteCrmEmailTemplateArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteCrmLeadArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteCrmPipelineArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteCrmTagArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteEmailSignatureArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteFeatureFlagArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteFeatureFlagCategoryArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteFileArgs = {
  input: DeleteFileInput;
};

export type MutationDeleteFormSubmissionArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteGeoRegionArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteImportedInvoicesArgs = {
  input: DeleteImportedInvoicesInput;
};

export type MutationDeleteInboxRuleArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteInvoiceLineTypeRuleArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteKnowledgeArticleArgs = {
  articleId: Scalars['ID']['input'];
};

export type MutationDeleteKnowledgeSourceArgs = {
  sourceId: Scalars['ID']['input'];
};

export type MutationDeleteMeterArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteModuleArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteMySignatureArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteOkrCheckInArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteOkrCycleArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteOkrKeyResultArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteOkrObjectiveArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteOrganizationArgs = {
  input: DeleteOrganizationInput;
};

export type MutationDeleteOrganizationContactArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteOutboundWebhookEndpointArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeletePricingRuleArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeletePushSubscriptionArgs = {
  endpoint: Scalars['String']['input'];
};

export type MutationDeleteRecurrenceRuleArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteRegionArgs = {
  id: Scalars['String']['input'];
};

export type MutationDeleteSubscriptionArgs = {
  id: Scalars['ID']['input'];
  invoiceMode?: InputMaybe<InvoiceDeletionMode>;
};

export type MutationDeleteSubscriptionExpansionArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteSupportGuidelineArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteSupportRoleArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteTaskArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteTaskPermanentlyArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteTenantArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteWebhookEndpointArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteWorkspaceDataArgs = {
  input: DeleteWorkspaceDataInput;
};

export type MutationDetachContractFromSubscriptionArgs = {
  subscriptionId: Scalars['ID']['input'];
};

export type MutationDetachOkrKeyResultMetricArgs = {
  id: Scalars['ID']['input'];
  keepCurrentValue: Scalars['Boolean']['input'];
};

export type MutationDetachVariableComponentFromSubscriptionArgs = {
  componentId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  subscriptionId: Scalars['ID']['input'];
};

export type MutationDisableMcpRemoteServerArgs = {
  serverId: Scalars['String']['input'];
};

export type MutationDisableOrganizationFeatureFlagArgs = {
  input: EnableOrganizationFeatureFlagInput;
};

export type MutationDiscardBundleDraftVersionArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDiscardContractTemplateDraftArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDiscardInboxReplyDraftArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDiscardModuleDraftVersionArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDiscardPricingDraftArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDiscardSyncResultAsNotInvoiceArgs = {
  resultId: Scalars['String']['input'];
};

export type MutationDiscardVariableComponentDraftVersionArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDisconnectAccountingMailboxArgs = {
  deleteEmails?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationDisconnectGmailArgs = {
  deleteEmails?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationDisconnectSlackArgs = {
  confirmName: Scalars['String']['input'];
};

export type MutationDiscussOkrKeyResultDraftArgs = {
  input: DiscussKeyResultDraftInputType;
};

export type MutationDiscussOkrObjectiveDraftArgs = {
  input: DiscussObjectiveDraftInputType;
};

export type MutationDismissDriveFolderPromptArgs = {
  organizationId: Scalars['ID']['input'];
};

export type MutationDismissProductEventSuggestionArgs = {
  eventName: Scalars['String']['input'];
};

export type MutationDisposeOkrHypothesesArgs = {
  acknowledge?: InputMaybe<Array<Scalars['String']['input']>>;
  cycleId: Scalars['ID']['input'];
  dispositions: Array<HypothesisDispositionInputType>;
};

export type MutationDropOkrHypothesisArgs = {
  id: Scalars['ID']['input'];
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type MutationDropOkrKeyResultArgs = {
  acknowledge?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};

export type MutationDuplicateCrmEmailTemplateArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDuplicateFormArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDuplicateModuleArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDuplicatePricingRuleArgs = {
  input: DuplicatePricingRuleInput;
};

export type MutationEmailSignedContractCopyArgs = {
  id: Scalars['ID']['input'];
  to: Scalars['String']['input'];
};

export type MutationEnableOrganizationFeatureFlagArgs = {
  input: EnableOrganizationFeatureFlagInput;
};

export type MutationEndSubscriptionTrialArgs = {
  subscriptionId: Scalars['ID']['input'];
};

export type MutationEnsureExchangeRatesArgs = {
  input: EnsureExchangeRatesInput;
};

export type MutationEnterUsageReadingArgs = {
  input: EnterUsageReadingInput;
};

export type MutationEraseProductEventsForUserArgs = {
  externalUserId: Scalars['String']['input'];
};

export type MutationExcludeKnowledgeArticleArgs = {
  articleId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type MutationExcludeVariableComponentFromSubscriptionArgs = {
  componentId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  subscriptionId: Scalars['ID']['input'];
};

export type MutationExtendOkrHypothesisTestArgs = {
  id: Scalars['ID']['input'];
  input: ExtendTestInputType;
};

export type MutationExtendSubscriptionTrialArgs = {
  subscriptionId: Scalars['ID']['input'];
  trialEndsAt: Scalars['DateTime']['input'];
};

export type MutationFailOkrMetricRefreshArgs = {
  times: Scalars['Int']['input'];
};

export type MutationFallBackToManualOnboardingArgs = {
  reason: ManualFallbackReason;
};

export type MutationFileInboxUnsortedGroupArgs = {
  category: InboxCategory;
  id: Scalars['ID']['input'];
  scope: InboxRuleScope;
};

export type MutationFlagSpotCheckArgs = {
  resultId: Scalars['String']['input'];
};

export type MutationForgetAgentMemoryArgs = {
  id: Scalars['ID']['input'];
};

export type MutationForwardInboxThreadToAccountingArgs = {
  id: Scalars['ID']['input'];
};

export type MutationGenerateVariableInvoiceLinesArgs = {
  input: GenerateVariableInvoiceLinesInput;
};

export type MutationGrandfatherSubscriptionArgs = {
  reason: Scalars['String']['input'];
  subscriptionId: Scalars['ID']['input'];
};

export type MutationGrantRoleArgs = {
  input: FunctionRoleGrantInput;
};

export type MutationHoldUsageReadingArgs = {
  input: HoldUsageReadingInput;
};

export type MutationIgnoreProductEventArgs = {
  eventName: Scalars['String']['input'];
  ignored: Scalars['Boolean']['input'];
};

export type MutationImportCrmContactsAndCompaniesArgs = {
  input: ImportCrmContactsAndCompaniesInput;
};

export type MutationImportGmailSignaturesArgs = {
  addresses?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type MutationImportMarkedDocumentsArgs = {
  documentIds: Array<Scalars['ID']['input']>;
};

export type MutationImportSubscriptionsArgs = {
  input: ImportSubscriptionsInput;
};

export type MutationImportTaxReferenceRatesArgs = {
  input: ImportTaxReferenceRatesInput;
};

export type MutationImportTransactionsArgs = {
  input: ImportTransactionsInput;
};

export type MutationInviteUserToTenantArgs = {
  input: InviteUserToTenantInput;
};

export type MutationIssueApiKeyArgs = {
  input: IssueApiKeyInput;
};

export type MutationIssueCreditNoteArgs = {
  input: IssueCreditNoteInput;
};

export type MutationIssueDraftInvoiceArgs = {
  invoiceId: Scalars['ID']['input'];
};

export type MutationLinkInvoiceToSubscriptionArgs = {
  input: LinkInvoiceToSubscriptionInput;
};

export type MutationLinkOkrKeyResultArgs = {
  companyKeyResultIds: Array<Scalars['ID']['input']>;
  keyResultId: Scalars['ID']['input'];
};

export type MutationLinkOkrWorkItemArgs = {
  keyResultId: Scalars['ID']['input'];
  task: Scalars['String']['input'];
};

export type MutationLinkOrganizationDriveFolderArgs = {
  folderId: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export type MutationLinkOrganizationEmailDomainArgs = {
  domain: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export type MutationLinkSyncedEmailThreadToClientArgs = {
  organizationId: Scalars['ID']['input'];
  threadId: Scalars['ID']['input'];
};

export type MutationLinkVariableComponentToParentArgs = {
  autoIncludeOnSubscribe?: InputMaybe<Scalars['Boolean']['input']>;
  componentId: Scalars['ID']['input'];
  componentVersion: Scalars['Int']['input'];
  includedQuantity?: InputMaybe<Scalars['Int']['input']>;
  inclusionByPeriod?: InputMaybe<Array<InclusionPeriodInput>>;
  parentId: Scalars['ID']['input'];
  parentType: CascadeEntityType;
};

export type MutationLinkWorkItemArgs = {
  ticketId: Scalars['ID']['input'];
  url: Scalars['String']['input'];
};

export type MutationLogCrmEmailMessageArgs = {
  input: LogCrmEmailMessageInput;
};

export type MutationLogCrmMeetingArgs = {
  input: LogCrmMeetingInput;
};

export type MutationLogSupportTicketArgs = {
  input: LogSupportTicketInput;
};

export type MutationMapCalendlyMemberManuallyArgs = {
  calendlyUserUri: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type MutationMapClickupMemberArgs = {
  clickUpUserId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type MutationMapProductEventArgs = {
  input: MapProductEventInput;
};

export type MutationMapSlackMemberManuallyArgs = {
  slackUserId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type MutationMarkDocumentsArgs = {
  category?: InputMaybe<CrmDocumentCategory>;
  documentIds: Array<Scalars['ID']['input']>;
};

export type MutationMarkInboxCategoryDoneArgs = {
  category: InboxCategory;
  cursor?: InputMaybe<Scalars['String']['input']>;
};

export type MutationMarkInboxThreadNotRelevantArgs = {
  id: Scalars['ID']['input'];
};

export type MutationMarkNotificationCenterReadArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type MutationMarkPaymentReceivedArgs = {
  input: MarkPaymentReceivedInput;
};

export type MutationMarkReleaseNotesSeenArgs = {
  upToVersion?: InputMaybe<Scalars['String']['input']>;
};

export type MutationMarkSubscriptionChurnedDueToPaymentFailureArgs = {
  id: Scalars['ID']['input'];
};

export type MutationMarkSupportNotificationsReadArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type MutationMarkTicketReadArgs = {
  id: Scalars['ID']['input'];
  upToMessageId: Scalars['ID']['input'];
};

export type MutationMergeOrganizationsArgs = {
  input: MergeOrganizationsInput;
};

export type MutationMigrateSubscriptionBundleArgs = {
  bundleId: Scalars['ID']['input'];
  legacyVersionPin?: InputMaybe<LegacyVersionPinInput>;
  prepaidSpanChange?: InputMaybe<PrepaidSpanChange>;
  reason?: InputMaybe<Scalars['String']['input']>;
  subscriptionId: Scalars['ID']['input'];
  timing: MigrationTiming;
  toVersion: Scalars['Int']['input'];
};

export type MutationMigrateSubscriptionComponentArgs = {
  componentId: Scalars['ID']['input'];
  prepaidSpanChange?: InputMaybe<PrepaidSpanChange>;
  reason?: InputMaybe<Scalars['String']['input']>;
  subscriptionId: Scalars['ID']['input'];
  timing: MigrationTiming;
  toVersion: Scalars['Int']['input'];
};

export type MutationMigrateSubscriptionModuleArgs = {
  legacyVersionPin?: InputMaybe<LegacyVersionPinInput>;
  moduleId: Scalars['ID']['input'];
  prepaidSpanChange?: InputMaybe<PrepaidSpanChange>;
  reason?: InputMaybe<Scalars['String']['input']>;
  subscriptionId: Scalars['ID']['input'];
  timing: MigrationTiming;
  toVersion: Scalars['Int']['input'];
};

export type MutationMoveCrmLeadArgs = {
  id: Scalars['ID']['input'];
  lostReason?: InputMaybe<Scalars['String']['input']>;
  pipelineStageId: Scalars['ID']['input'];
};

export type MutationMoveDriveFoldersToClientsArgs = {
  organizationIds: Array<Scalars['ID']['input']>;
};

export type MutationMoveInboxThreadArgs = {
  category: InboxCategory;
  id: Scalars['ID']['input'];
};

export type MutationMoveInboxThreadWithFollowUpArgs = {
  category: InboxCategory;
  id: Scalars['ID']['input'];
};

export type MutationMoveOkrHypothesisArgs = {
  id: Scalars['ID']['input'];
  keyResultId: Scalars['ID']['input'];
};

export type MutationMoveOrganizationDriveFolderArgs = {
  organizationId: Scalars['ID']['input'];
};

export type MutationOverrideBilledQuantityArgs = {
  input: OverrideBilledQuantityInput;
};

export type MutationOverrideSubscriptionBasePriceArgs = {
  input: OverrideBasePriceInput;
};

export type MutationOverrideSubscriptionComponentBillingTimingArgs = {
  input: OverrideComponentBillingTimingInput;
};

export type MutationOverrideSubscriptionComponentCaptureModeArgs = {
  input: OverrideComponentCaptureModeInput;
};

export type MutationOverrideSubscriptionComponentRateArgs = {
  input: OverrideComponentRateInput;
};

export type MutationOverwriteSubscriptionDiscountArgs = {
  input: OverwriteDiscountInstanceInput;
};

export type MutationPassSpotCheckArgs = {
  resultId: Scalars['String']['input'];
};

export type MutationPauseCheckinArgs = {
  id: Scalars['ID']['input'];
};

export type MutationProcessChurnReconciliationArgs = {
  tenantId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationProcessRenewalsArgs = {
  tenantId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationProcessUsagePeriodCloseArgs = {
  asOf?: InputMaybe<Scalars['DateTime']['input']>;
  tenantId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationProcessUsageSealArgs = {
  asOf?: InputMaybe<Scalars['DateTime']['input']>;
  tenantId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationPublishBundleDraftVersionArgs = {
  id: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};

export type MutationPublishContractTemplateArgs = {
  expectedRevision: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};

export type MutationPublishCustomPricingAgreementArgs = {
  id: Scalars['ID']['input'];
};

export type MutationPublishFormArgs = {
  id: Scalars['ID']['input'];
};

export type MutationPublishHistoricalBundleVersionArgs = {
  id: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};

export type MutationPublishHistoricalModuleVersionArgs = {
  id: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};

export type MutationPublishHistoricalVariableComponentVersionArgs = {
  id: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};

export type MutationPublishModuleDraftVersionArgs = {
  id: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};

export type MutationPublishOkrCycleArgs = {
  id: Scalars['ID']['input'];
};

export type MutationPublishTaxRateArgs = {
  id: Scalars['ID']['input'];
};

export type MutationPublishVariableComponentArgs = {
  id: Scalars['ID']['input'];
};

export type MutationPublishVariableComponentWithCascadeArgs = {
  id: Scalars['ID']['input'];
};

export type MutationPullBusinessProfileFromWebsiteArgs = {
  website?: InputMaybe<Scalars['String']['input']>;
};

export type MutationReadContractClausesArgs = {
  documentId: Scalars['ID']['input'];
};

export type MutationReassignTaskArgs = {
  assigneeUserId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type MutationRecordContractFromDocumentArgs = {
  input: RecordContractFromDocumentInput;
};

export type MutationRecordContractSubscriptionArgs = {
  id: Scalars['ID']['input'];
  subscriptionId: Scalars['ID']['input'];
};

export type MutationRecordDocumentPaymentsArgs = {
  items: Array<DocumentPaymentInputEntity>;
};

export type MutationRecordFormClientSubscriptionArgs = {
  id: Scalars['ID']['input'];
  subscriptionId: Scalars['ID']['input'];
};

export type MutationRecordHistoricalPinChangeArgs = {
  bundleId?: InputMaybe<Scalars['ID']['input']>;
  moduleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  moduleTiers?: InputMaybe<Array<ModuleTierSelectionInput>>;
  occurredAt: Scalars['DateTime']['input'];
  reason: Scalars['String']['input'];
  subscriptionId: Scalars['ID']['input'];
};

export type MutationRecordPolicyAcceptancesArgs = {
  input: RecordPolicyAcceptancesInput;
};

export type MutationRecordSignedContractArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<RecordSignedContractInput>;
};

export type MutationRefreshMcpRemoteServerToolsArgs = {
  serverId: Scalars['String']['input'];
};

export type MutationRefreshOkrWorkLinksArgs = {
  keyResultId: Scalars['ID']['input'];
};

export type MutationRefundCreditNoteArgs = {
  input: RefundCreditNoteInput;
};

export type MutationRegenerateInvoicePdfArgs = {
  invoiceId: Scalars['ID']['input'];
};

export type MutationReincludeVariableComponentOnSubscriptionArgs = {
  componentLineageId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  subscriptionId: Scalars['ID']['input'];
};

export type MutationReingestKnowledgeArticleArgs = {
  articleId: Scalars['ID']['input'];
  reguessAudience?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationRememberAgentMemoryArgs = {
  input: RememberAgentMemoryInput;
};

export type MutationRemoveBundleComponentPriceArgs = {
  bundleId: Scalars['ID']['input'];
  bundleVersion: Scalars['Int']['input'];
  componentId: Scalars['ID']['input'];
  componentVersion: Scalars['Int']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  regionId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationRemoveClientCardArgs = {
  organizationId: Scalars['ID']['input'];
};

export type MutationRemoveComponentDefaultPriceArgs = {
  componentId: Scalars['ID']['input'];
  componentVersion: Scalars['Int']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  regionId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationRemoveCurrencyFromRegionArgs = {
  input: RemoveCurrencyFromRegionInput;
};

export type MutationRemoveFeatureFlagFromBundleArgs = {
  bundleId: Scalars['ID']['input'];
  featureFlagId: Scalars['ID']['input'];
};

export type MutationRemoveFeatureFlagFromTierArgs = {
  input: RemoveFeatureFlagFromTierInput;
};

export type MutationRemoveInvoiceAttachmentArgs = {
  attachmentId: Scalars['ID']['input'];
  invoiceId: Scalars['ID']['input'];
};

export type MutationRemoveMcpRemoteServerArgs = {
  serverId: Scalars['String']['input'];
};

export type MutationRemoveModuleComponentPriceArgs = {
  componentId: Scalars['ID']['input'];
  componentVersion: Scalars['Int']['input'];
  moduleId: Scalars['ID']['input'];
  moduleVersion: Scalars['Int']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  regionId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationRemoveModuleFromBundleArgs = {
  bundleId: Scalars['ID']['input'];
  moduleId: Scalars['ID']['input'];
};

export type MutationRemoveModuleTierArgs = {
  input: RemoveModuleTierInput;
};

export type MutationRemoveOkrHypothesisLinkArgs = {
  linkId: Scalars['ID']['input'];
};

export type MutationRemoveOrganizationFeatureFlagArgs = {
  featureFlagId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export type MutationRemoveProspectFromPipelineArgs = {
  organizationId: Scalars['ID']['input'];
};

export type MutationRemoveSubscriptionScopedPriceArgs = {
  componentId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  subscriptionId: Scalars['ID']['input'];
};

export type MutationRemoveSyncFolderArgs = {
  folderId: Scalars['String']['input'];
};

export type MutationRemoveTaskAssigneeArgs = {
  assigneeId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type MutationRemoveTaskAttachmentArgs = {
  fileId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type MutationRemoveTaskExternalLinkArgs = {
  id: Scalars['ID']['input'];
  linkId: Scalars['ID']['input'];
};

export type MutationRemoveTeamMemberArgs = {
  teamId: Scalars['ID']['input'];
  userId: Scalars['String']['input'];
};

export type MutationRemoveUserFromTenantArgs = {
  tenantId: Scalars['ID']['input'];
  userId: Scalars['String']['input'];
};

export type MutationRemoveVariableUsageArgs = {
  input: RemoveVariableUsageInput;
};

export type MutationRenameAgentSessionArgs = {
  id: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};

export type MutationRenameContactRoleArgs = {
  input: RenameContactRoleInput;
};

export type MutationRenewSubscriptionArgs = {
  id: Scalars['ID']['input'];
};

export type MutationReopenHistoricalBundleVersionArgs = {
  id: Scalars['ID']['input'];
};

export type MutationReopenHistoricalModuleVersionArgs = {
  id: Scalars['ID']['input'];
};

export type MutationReopenHistoricalVariableComponentVersionArgs = {
  id: Scalars['ID']['input'];
};

export type MutationReopenTaskArgs = {
  id: Scalars['ID']['input'];
};

export type MutationReopenTicketArgs = {
  id: Scalars['ID']['input'];
};

export type MutationReorderOkrKeyResultsArgs = {
  keyResultIds: Array<Scalars['ID']['input']>;
  objectiveId: Scalars['ID']['input'];
};

export type MutationReorderPipelineStagesArgs = {
  orderedStageIds: Array<Scalars['ID']['input']>;
  pipelineId: Scalars['ID']['input'];
};

export type MutationReplayWebhookDeliveryArgs = {
  deliveryId: Scalars['ID']['input'];
};

export type MutationReplyToInboxMessageArgs = {
  id: Scalars['ID']['input'];
  input: InboxReplyInput;
  messageId: Scalars['ID']['input'];
};

export type MutationReplyToTicketArgs = {
  input: ReplyInput;
};

export type MutationReportCommissionEventArgs = {
  input: ReportCommissionEventInput;
};

export type MutationRequestEmailChangeArgs = {
  newEmail: Scalars['String']['input'];
};

export type MutationRequestInviteApprovalArgs = {
  includeGuests?: InputMaybe<Scalars['Boolean']['input']>;
  slackUserIds: Array<Scalars['String']['input']>;
};

export type MutationRequestLibraryDocumentUploadArgs = {
  input: RequestLibraryUploadInput;
};

export type MutationRequestSeatsArgs = {
  note?: InputMaybe<Scalars['String']['input']>;
  requestedSeats: Scalars['Int']['input'];
};

export type MutationRequestSupportAuthTokenArgs = {
  incubatorId: Scalars['ID']['input'];
};

export type MutationRequestUploadUrlArgs = {
  input: RequestUploadUrlInput;
};

export type MutationResendContractInviteArgs = {
  id: Scalars['ID']['input'];
  recipientId: Scalars['ID']['input'];
};

export type MutationResendMemberInviteArgs = {
  inviteId: Scalars['ID']['input'];
};

export type MutationResendTenantUserInviteArgs = {
  id: Scalars['ID']['input'];
};

export type MutationResetInboxLearnedSenderArgs = {
  id: Scalars['ID']['input'];
};

export type MutationResetPaymentReminderTemplateArgs = {
  kind: PaymentReminderTemplateKind;
};

export type MutationResetProductEventMappingArgs = {
  eventName: Scalars['String']['input'];
};

export type MutationResolveDiscrepancyArgs = {
  input: ResolveDiscrepancyInput;
};

export type MutationResolvePlatformIncidentArgs = {
  id: Scalars['ID']['input'];
  revision: Scalars['Int']['input'];
};

export type MutationResolveSeatRequestArgs = {
  outcome: SeatRequestStatus;
  requestId: Scalars['ID']['input'];
  tenantId: Scalars['ID']['input'];
};

export type MutationRestoreContractTemplateVersionArgs = {
  expectedRevision: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
  version: Scalars['Int']['input'];
};

export type MutationRestoreDriveFileArgs = {
  id: Scalars['ID']['input'];
};

export type MutationRestoreFormArgs = {
  id: Scalars['ID']['input'];
};

export type MutationRestoreSyncResultArgs = {
  resultId: Scalars['String']['input'];
};

export type MutationResumeCheckinArgs = {
  id: Scalars['ID']['input'];
};

export type MutationResumeSupportCompareArgs = {
  id: Scalars['ID']['input'];
};

export type MutationResyncWorkItemArgs = {
  linkId: Scalars['ID']['input'];
};

export type MutationRetestOkrHypothesisArgs = {
  id: Scalars['ID']['input'];
  keyResultId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationRetryContractSendPlanArgs = {
  id: Scalars['ID']['input'];
};

export type MutationRetryDriveFileSyncArgs = {
  id: Scalars['ID']['input'];
};

export type MutationRetryFailedSyncJobArgs = {
  jobId: Scalars['String']['input'];
};

export type MutationRetryFormSubmissionArgs = {
  id: Scalars['ID']['input'];
};

export type MutationRetryOutboundWebhookDeliveryArgs = {
  id: Scalars['ID']['input'];
};

export type MutationRetrySyncExtractionArgs = {
  resultId: Scalars['String']['input'];
};

export type MutationReturnOkrHypothesisToBacklogArgs = {
  id: Scalars['ID']['input'];
};

export type MutationReverseDocumentPaymentsArgs = {
  documentId: Scalars['ID']['input'];
};

export type MutationRevertBookingIntakeArgs = {
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};

export type MutationRevertCrmImportBatchArgs = {
  id: Scalars['ID']['input'];
};

export type MutationRevokeApiKeyArgs = {
  id: Scalars['ID']['input'];
};

export type MutationRevokeCustomPricingAgreementArgs = {
  id: Scalars['ID']['input'];
};

export type MutationRevokeDocumentShareLinkArgs = {
  id: Scalars['ID']['input'];
};

export type MutationRevokeFormClientLinkArgs = {
  id: Scalars['ID']['input'];
};

export type MutationRevokeMemberInviteArgs = {
  inviteId: Scalars['ID']['input'];
};

export type MutationRevokeRoleArgs = {
  input: FunctionRoleGrantInput;
};

export type MutationRollbackImportBatchArgs = {
  batchId: Scalars['String']['input'];
};

export type MutationRotateApiKeyArgs = {
  id: Scalars['ID']['input'];
};

export type MutationRotateOutboundWebhookSigningSecretArgs = {
  id: Scalars['ID']['input'];
};

export type MutationRotateWebhookEndpointSecretArgs = {
  id: Scalars['ID']['input'];
};

export type MutationRunScheduledJobNowArgs = {
  job: ScheduledJobKey;
};

export type MutationSaveAccountingMailboxSignatureArgs = {
  bodyHtml: Scalars['String']['input'];
};

export type MutationSaveContractTemplateDraftArgs = {
  expectedRevision: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
  input: ContractTemplateInput;
};

export type MutationSaveCrmForecastViewStateArgs = {
  input: CrmForecastViewStateInput;
};

export type MutationSaveInboxRuleArgs = {
  input: SaveInboxRuleInput;
};

export type MutationSaveMcpRemoteServerArgs = {
  input: SaveMcpRemoteServerInput;
};

export type MutationSaveMySignatureArgs = {
  input: SaveUserSignatureInput;
};

export type MutationSavePushSubscriptionArgs = {
  input: SavePushSubscriptionInput;
};

export type MutationSaveSupportGuidelineArgs = {
  input: SupportGuidelineInput;
};

export type MutationSelectTenantArgs = {
  input: SelectTenantInput;
};

export type MutationSendChatMessageArgs = {
  content: Scalars['String']['input'];
  sessionId: Scalars['ID']['input'];
};

export type MutationSendCheckinTestArgs = {
  id: Scalars['ID']['input'];
};

export type MutationSendClientEmailArgs = {
  input: SendClientEmailInput;
};

export type MutationSendContractArgs = {
  input: SendContractInput;
};

export type MutationSendContractAfterFormArgs = {
  input: SendContractAfterFormInput;
};

export type MutationSendEditablePaymentReminderArgs = {
  input: SendEditablePaymentReminderInput;
};

export type MutationSendFollowUpEmailArgs = {
  input: SendFollowUpEmailInput;
};

export type MutationSendMemberInvitesArgs = {
  includeGuests?: InputMaybe<Scalars['Boolean']['input']>;
  slackUserIds: Array<Scalars['String']['input']>;
};

export type MutationSendPaymentReminderArgs = {
  input: SendPaymentReminderInput;
};

export type MutationSendTestNotificationArgs = {
  recipientUserId?: InputMaybe<Scalars['String']['input']>;
  toAnnouncementChannel?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationSendTestOutboundWebhookArgs = {
  endpointId: Scalars['ID']['input'];
};

export type MutationSendWebhookEndpointTestArgs = {
  id: Scalars['ID']['input'];
};

export type MutationSetBookingIntakeDailyCapArgs = {
  dailyProspectCap: Scalars['Int']['input'];
};

export type MutationSetBookingIntakeRouteEnabledArgs = {
  enabled: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};

export type MutationSetBundleComponentPriceArgs = {
  bundleId: Scalars['ID']['input'];
  bundleVersion: Scalars['Int']['input'];
  componentId: Scalars['ID']['input'];
  componentVersion: Scalars['Int']['input'];
  pricesByCurrency: Array<PricingVariantInput>;
  pricesByPeriod?: InputMaybe<Array<PeriodPriceInput>>;
  reason?: InputMaybe<Scalars['String']['input']>;
  regionId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationSetCheckinAwayArgs = {
  from?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type MutationSetClickupAnnouncementChannelArgs = {
  channelId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationSetClickupChatEnabledArgs = {
  enabled: Scalars['Boolean']['input'];
};

export type MutationSetComponentDefaultPriceArgs = {
  componentId: Scalars['ID']['input'];
  componentVersion: Scalars['Int']['input'];
  pricesByCurrency: Array<PricingVariantInput>;
  pricesByPeriod?: InputMaybe<Array<PeriodPriceInput>>;
  reason?: InputMaybe<Scalars['String']['input']>;
  regionId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationSetContactRoleRetiredArgs = {
  input: SetContactRoleRetiredInput;
};

export type MutationSetConversationThreadVisibilityArgs = {
  input: SetConversationThreadVisibilityInput;
};

export type MutationSetCustomFieldRetiredArgs = {
  id: Scalars['ID']['input'];
  retired: Scalars['Boolean']['input'];
};

export type MutationSetDefaultEmailSignatureArgs = {
  id: Scalars['ID']['input'];
};

export type MutationSetDefaultSignatureArgs = {
  id: Scalars['ID']['input'];
};

export type MutationSetInboxCategoryPolicyArgs = {
  input: SetInboxCategoryPolicyInput;
};

export type MutationSetInboxRuleEnabledArgs = {
  enabled: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};

export type MutationSetInboxSenderRuleArgs = {
  category: InboxCategory;
  id: Scalars['ID']['input'];
  scope: InboxRuleScope;
};

export type MutationSetInboxThreadDoneArgs = {
  done: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};

export type MutationSetInboxThreadReadArgs = {
  id: Scalars['ID']['input'];
  read: Scalars['Boolean']['input'];
};

export type MutationSetInboxThreadStarredArgs = {
  id: Scalars['ID']['input'];
  starred: Scalars['Boolean']['input'];
};

export type MutationSetInvoicePaymentOptionsArgs = {
  input: SetInvoicePaymentOptionsInput;
};

export type MutationSetKnowledgeArticleAudienceArgs = {
  articleId: Scalars['ID']['input'];
  audience: KbAudienceInput;
};

export type MutationSetKnowledgeAudienceRulesArgs = {
  applyToExisting?: InputMaybe<Scalars['Boolean']['input']>;
  rules: Array<KbAudienceRuleInput>;
  sourceId: Scalars['ID']['input'];
};

export type MutationSetLibraryDocumentArchivedArgs = {
  archived: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};

export type MutationSetMcpRemoteServerToolsArgs = {
  input: SetMcpRemoteServerToolsInput;
};

export type MutationSetModuleComponentPriceArgs = {
  componentId: Scalars['ID']['input'];
  componentVersion: Scalars['Int']['input'];
  moduleId: Scalars['ID']['input'];
  moduleVersion: Scalars['Int']['input'];
  pricesByCurrency: Array<PricingVariantInput>;
  pricesByPeriod?: InputMaybe<Array<PeriodPriceInput>>;
  reason?: InputMaybe<Scalars['String']['input']>;
  regionId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationSetNotificationCenterEmailScopeArgs = {
  scope: EmailNotificationScope;
};

export type MutationSetOkrKeyResultStartValueArgs = {
  id: Scalars['ID']['input'];
  startValue: Scalars['Float']['input'];
  targetValue?: InputMaybe<Scalars['Float']['input']>;
};

export type MutationSetOrganizationPrimaryContactArgs = {
  id: Scalars['ID']['input'];
};

export type MutationSetPrimaryTaxRegistrationArgs = {
  id: Scalars['ID']['input'];
};

export type MutationSetProductEventBrowserOriginsArgs = {
  origins: Array<Scalars['String']['input']>;
};

export type MutationSetRecurrenceRuleActiveArgs = {
  active: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};

export type MutationSetSlackAnnouncementChannelArgs = {
  channelId: Scalars['String']['input'];
};

export type MutationSetSubscriptionComponentZeroUsageExpectedArgs = {
  input: SetComponentZeroUsageExpectedInput;
};

export type MutationSetSubscriptionDiscountStackingModeArgs = {
  input: SetDiscountStackingModeInput;
};

export type MutationSetSyncResultPaymentsArgs = {
  payments: Array<ReviewPaymentInput>;
  syncResultId: Scalars['ID']['input'];
};

export type MutationSetTaskArchivedArgs = {
  archived: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};

export type MutationSetTenantFeaturesArgs = {
  features: Array<TenantFeature>;
  tenantId: Scalars['ID']['input'];
};

export type MutationSetTenantSeatPolicyArgs = {
  seatCurrency?: InputMaybe<Scalars['String']['input']>;
  seatLimit?: InputMaybe<Scalars['Int']['input']>;
  tenantId: Scalars['ID']['input'];
  unitAmount?: InputMaybe<Scalars['Float']['input']>;
};

export type MutationSetTicketAiAlongsideArgs = {
  enabled: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};

export type MutationSetTypingArgs = {
  internal?: InputMaybe<Scalars['Boolean']['input']>;
  ticketId: Scalars['ID']['input'];
};

export type MutationSetVariableUsageArgs = {
  input: SetVariableUsageInput;
};

export type MutationSetViewPreferenceArgs = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type MutationSetWorkItemRoutingArgs = {
  listId?: InputMaybe<Scalars['ID']['input']>;
  ticketTypeId: Scalars['ID']['input'];
};

export type MutationSignFileArgs = {
  input: SignFileInput;
};

export type MutationSimulateSlackOutageArgs = {
  enabled: Scalars['Boolean']['input'];
};

export type MutationSkipOnboardingStepArgs = {
  input: SkipOnboardingStepInput;
};

export type MutationSnoozeInboxThreadArgs = {
  id: Scalars['ID']['input'];
  until: Scalars['DateTime']['input'];
};

export type MutationSnoozeTaskArgs = {
  id: Scalars['ID']['input'];
  remindAt: Scalars['DateTime']['input'];
};

export type MutationStartAgentSessionArgs = {
  title?: InputMaybe<Scalars['String']['input']>;
};

export type MutationStartClientCardSetupArgs = {
  organizationId: Scalars['ID']['input'];
};

export type MutationStartGoogleDriveSyncArgs = {
  folderIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type MutationStartIntercomImportArgs = {
  input: StartIntercomImportInput;
};

export type MutationStartMcpRemoteServerOAuthArgs = {
  serverId: Scalars['String']['input'];
};

export type MutationStartOkrHypothesisDevelopingArgs = {
  id: Scalars['ID']['input'];
  ownerUserId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationStartOkrHypothesisTestingArgs = {
  id: Scalars['ID']['input'];
  input: StartTestingInputType;
};

export type MutationStartOkrScoringArgs = {
  id: Scalars['ID']['input'];
};

export type MutationStartOnboardingArgs = {
  input?: InputMaybe<StartOnboardingInput>;
};

export type MutationStartSupportCompareArgs = {
  input: SupportCompareRangeInput;
};

export type MutationStopDiscountDefinitionArgs = {
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};

export type MutationSubmitOkrScoreArgs = {
  input: SubmitScoreInputType;
};

export type MutationSuggestProductEventMappingsArgs = {
  eventNames?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type MutationSyncCrmEmailDocumentsArgs = {
  organizationId: Scalars['ID']['input'];
};

export type MutationSyncFeatureFlagsFromMainAppArgs = {
  organizationId: Scalars['ID']['input'];
};

export type MutationSyncFeatureFlagsToMainAppArgs = {
  organizationId: Scalars['ID']['input'];
};

export type MutationTakeTicketArgs = {
  id: Scalars['ID']['input'];
};

export type MutationTenantUserInvitationLinkArgs = {
  id: Scalars['ID']['input'];
};

export type MutationUnarchiveAgentSessionArgs = {
  id: Scalars['ID']['input'];
};

export type MutationUnarchiveCrmPipelineArgs = {
  id: Scalars['ID']['input'];
};

export type MutationUnarchiveTeamArgs = {
  id: Scalars['ID']['input'];
};

export type MutationUndoInboxActionArgs = {
  id: Scalars['ID']['input'];
};

export type MutationUndoInboxDemotionArgs = {
  id: Scalars['ID']['input'];
};

export type MutationUnlinkOkrKeyResultArgs = {
  companyKeyResultId: Scalars['ID']['input'];
  keyResultId: Scalars['ID']['input'];
};

export type MutationUnlinkOkrWorkItemArgs = {
  linkId: Scalars['ID']['input'];
};

export type MutationUnlinkOrganizationDriveFolderArgs = {
  organizationId: Scalars['ID']['input'];
};

export type MutationUnlinkVariableComponentFromParentArgs = {
  componentId: Scalars['ID']['input'];
  parentId: Scalars['ID']['input'];
  parentType: CascadeEntityType;
};

export type MutationUnlinkWorkItemArgs = {
  linkId: Scalars['ID']['input'];
};

export type MutationUnmapCalendlyMemberArgs = {
  userId: Scalars['String']['input'];
};

export type MutationUnmapClickupMemberArgs = {
  userId: Scalars['String']['input'];
};

export type MutationUnmapSlackMemberArgs = {
  userId: Scalars['String']['input'];
};

export type MutationUnpublishFormArgs = {
  id: Scalars['ID']['input'];
};

export type MutationUnsubscribeInboxThreadArgs = {
  id: Scalars['ID']['input'];
};

export type MutationUpdateAgentMemoryArgs = {
  input: UpdateAgentMemoryInput;
};

export type MutationUpdateApiKeyRateLimitsArgs = {
  id: Scalars['ID']['input'];
  input: ApiKeyRateLimitsInput;
};

export type MutationUpdateAutoChargeArgs = {
  input: UpdateAutoChargeInput;
};

export type MutationUpdateBookingIntakeRouteArgs = {
  id: Scalars['ID']['input'];
  input: BookingIntakeRouteInput;
};

export type MutationUpdateBundleArgs = {
  input: UpdateBundleInput;
};

export type MutationUpdateBusinessProfileArgs = {
  input: UpdateBusinessProfileInput;
};

export type MutationUpdateCheckinArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCheckinInput;
};

export type MutationUpdateClientCsStatusArgs = {
  organizationId: Scalars['ID']['input'];
  status?: InputMaybe<CsLifecycleStatus>;
};

export type MutationUpdateClientCsmArgs = {
  csmUserId?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export type MutationUpdateClientCustomFieldsArgs = {
  organizationId: Scalars['ID']['input'];
  values: Array<CustomFieldValueInput>;
};

export type MutationUpdateClientStagesArgs = {
  expectedVersion: Scalars['Int']['input'];
  input: ClientStagesInput;
};

export type MutationUpdateClientTagsArgs = {
  organizationId: Scalars['ID']['input'];
  tagIds: Array<Scalars['ID']['input']>;
};

export type MutationUpdateContactCustomFieldsArgs = {
  contactId: Scalars['ID']['input'];
  values: Array<CustomFieldValueInput>;
};

export type MutationUpdateContactTagsArgs = {
  contactId: Scalars['ID']['input'];
  tagIds: Array<Scalars['ID']['input']>;
};

export type MutationUpdateContractClausesArgs = {
  clauses: ContractClausesInput;
  contractId: Scalars['ID']['input'];
};

export type MutationUpdateContractTemplateArgs = {
  id: Scalars['ID']['input'];
  input: ContractTemplateInput;
};

export type MutationUpdateCrmEmailMessageArgs = {
  input: UpdateCrmEmailMessageInput;
};

export type MutationUpdateCrmEmailTemplateArgs = {
  input: UpdateCrmEmailTemplateInput;
};

export type MutationUpdateCrmLeadArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCrmLeadInput;
};

export type MutationUpdateCrmLeadCustomFieldsArgs = {
  leadId: Scalars['ID']['input'];
  values: Array<CustomFieldValueInput>;
};

export type MutationUpdateCrmLeadTagsArgs = {
  leadId: Scalars['ID']['input'];
  tagIds: Array<Scalars['ID']['input']>;
};

export type MutationUpdateCrmLifecycleStageArgs = {
  input: UpdateLifecycleStageInput;
};

export type MutationUpdateCrmMeetingArgs = {
  input: UpdateCrmMeetingInput;
};

export type MutationUpdateCrmNoteArgs = {
  input: UpdateCrmNoteInput;
};

export type MutationUpdateCrmOwnerArgs = {
  ownerUserId?: InputMaybe<Scalars['ID']['input']>;
  targetId: Scalars['ID']['input'];
  targetType: EntityTargetType;
};

export type MutationUpdateCrmPipelineArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCrmPipelineInput;
};

export type MutationUpdateCrmTagArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCrmTagInput;
};

export type MutationUpdateCustomFieldArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCustomFieldInput;
};

export type MutationUpdateCustomPricingAgreementDraftArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCustomPricingAgreementInput;
};

export type MutationUpdateDiscountDefinitionArgs = {
  id: Scalars['ID']['input'];
  input: UpsertDiscountDefinitionInput;
};

export type MutationUpdateDriveClientFolderSettingsArgs = {
  input: UpdateDriveClientFolderSettingsInput;
};

export type MutationUpdateEmailSignatureArgs = {
  input: UpdateEmailSignatureInput;
};

export type MutationUpdateEstimatedPaymentDateArgs = {
  input: UpdateEstimatedPaymentDateInput;
};

export type MutationUpdateExternalApiConfigArgs = {
  input: UpdateExternalApiConfigInput;
};

export type MutationUpdateFeatureFlagArgs = {
  input: UpdateFeatureFlagInput;
};

export type MutationUpdateFeatureFlagCategoryArgs = {
  input: UpdateFeatureFlagCategoryInput;
};

export type MutationUpdateFormArgs = {
  id: Scalars['ID']['input'];
  input: UpdateFormInput;
};

export type MutationUpdateGeoRegionArgs = {
  id: Scalars['ID']['input'];
  input: UpdateGeoRegionInput;
};

export type MutationUpdateInboxSettingsArgs = {
  input: UpdateInboxSettingsInput;
};

export type MutationUpdateIncubatorArgs = {
  id: Scalars['ID']['input'];
  input: UpdateIncubatorInput;
};

export type MutationUpdateIncubatorFeatureFlagsArgs = {
  id: Scalars['ID']['input'];
  input: Array<IncubatorFlagInput>;
};

export type MutationUpdateIncubatorsByFeatureFlagsArgs = {
  featureFlags: Array<IncubatorFlagInput>;
  incubatorIDs: Array<Scalars['ID']['input']>;
};

export type MutationUpdateInvoiceArgs = {
  input: UpdateInvoiceInput;
};

export type MutationUpdateInvoicePaymentStatusArgs = {
  input: UpdatePaymentStatusInput;
};

export type MutationUpdateKnowledgeSourceArgs = {
  input: KnowledgeSourceEditInput;
  sourceId: Scalars['ID']['input'];
};

export type MutationUpdateLibraryDocumentArgs = {
  input: UpdateLibraryDocumentInput;
};

export type MutationUpdateMeterArgs = {
  input: UpdateMeterInput;
};

export type MutationUpdateModuleArgs = {
  input: UpdateModuleInput;
};

export type MutationUpdateMyFollowUpTaskDefaultDaysArgs = {
  days: Scalars['Int']['input'];
};

export type MutationUpdateMyNameArgs = {
  name: Scalars['String']['input'];
};

export type MutationUpdateMyNotificationSettingsArgs = {
  digestDay?: InputMaybe<Scalars['Int']['input']>;
  digestHour?: InputMaybe<Scalars['Int']['input']>;
  mutedCategories?: InputMaybe<Array<NotificationCategory>>;
};

export type MutationUpdateMyTimezoneArgs = {
  timezone: Scalars['String']['input'];
};

export type MutationUpdateNotificationCenterPreferencesArgs = {
  input: Array<NotificationCenterPreferenceInput>;
};

export type MutationUpdateOkrCheckInArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCheckInInputType;
};

export type MutationUpdateOkrCycleArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCycleInputType;
};

export type MutationUpdateOkrHypothesisArgs = {
  id: Scalars['ID']['input'];
  input: UpdateHypothesisInputType;
};

export type MutationUpdateOkrKeyResultArgs = {
  id: Scalars['ID']['input'];
  input: UpdateKeyResultInputType;
};

export type MutationUpdateOkrObjectiveArgs = {
  id: Scalars['ID']['input'];
  input: UpdateObjectiveInputType;
};

export type MutationUpdateOkrScoreArgs = {
  input: UpdateScoreInputType;
};

export type MutationUpdateOrganizationArgs = {
  input: UpdateOrganizationInput;
};

export type MutationUpdateOrganizationContactArgs = {
  id: Scalars['ID']['input'];
  input: UpdateOrganizationContactInput;
};

export type MutationUpdateOrganizationContractArgs = {
  input: UpdateOrganizationContractInput;
};

export type MutationUpdateOutboundWebhookEndpointArgs = {
  id: Scalars['ID']['input'];
  input: UpdateOutboundWebhookEndpointInput;
};

export type MutationUpdatePaymentReminderTemplateArgs = {
  input: UpdatePaymentReminderTemplateInput;
};

export type MutationUpdatePipelineStageArgs = {
  input: UpdatePipelineStageInput;
  pipelineId: Scalars['ID']['input'];
  stageId: Scalars['ID']['input'];
};

export type MutationUpdatePlatformBillingConfigArgs = {
  input: UpdatePlatformBillingConfigInput;
};

export type MutationUpdatePlatformIncidentArgs = {
  id: Scalars['ID']['input'];
  input: PlatformIncidentInput;
  revision: Scalars['Int']['input'];
};

export type MutationUpdatePricingRuleArgs = {
  input: UpdatePricingRuleInput;
};

export type MutationUpdateRecurrenceRuleArgs = {
  id: Scalars['ID']['input'];
  input: UpdateRecurrenceRuleInput;
};

export type MutationUpdateRegionArgs = {
  input: UpdateRegionInput;
};

export type MutationUpdateSituationThresholdsArgs = {
  input: SituationThresholdsInput;
};

export type MutationUpdateSubscriptionArgs = {
  updateSubscriptionInput: UpdateOrganizationSubscriptionInput;
};

export type MutationUpdateSupportNotificationPreferencesArgs = {
  input: Array<SupportNotificationPreferenceInput>;
};

export type MutationUpdateSupportSettingsArgs = {
  input: SupportSettingsInput;
};

export type MutationUpdateSyncFolderArgs = {
  folderId: Scalars['String']['input'];
  scanSubfolders: Scalars['Boolean']['input'];
};

export type MutationUpdateSyncResultArgs = {
  bundleId?: InputMaybe<Scalars['String']['input']>;
  editedData: Scalars['String']['input'];
  lineTypeCorrections?: InputMaybe<Array<LineTypeCorrectionInput>>;
  moduleIds?: InputMaybe<Array<Scalars['String']['input']>>;
  oneTime?: InputMaybe<Scalars['Boolean']['input']>;
  propagatedFromResultId?: InputMaybe<Scalars['String']['input']>;
  resultId: Scalars['String']['input'];
  subscriptionId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateTaskArgs = {
  id: Scalars['ID']['input'];
  input: UpdateTaskInput;
};

export type MutationUpdateTaskStatusArgs = {
  id: Scalars['ID']['input'];
  status: TaskStatus;
};

export type MutationUpdateTaxRateDraftArgs = {
  id: Scalars['ID']['input'];
  input: UpdateTaxRateInput;
};

export type MutationUpdateTaxRegistrationArgs = {
  id: Scalars['ID']['input'];
  input: UpdateTaxRegistrationInput;
};

export type MutationUpdateTaxSettingsArgs = {
  input: UpdateTaxSettingsInput;
};

export type MutationUpdateTeamArgs = {
  input: UpdateTeamInput;
};

export type MutationUpdateTenantArgs = {
  input: UpdateTenantInput;
};

export type MutationUpdateTenantCoreSettingsArgs = {
  input: UpdateTenantCoreSettingsInput;
};

export type MutationUpdateTenantInvoiceHeaderArgs = {
  input: UpdateTenantInvoiceHeaderInput;
};

export type MutationUpdateTenantNotificationDefaultsArgs = {
  announceHypothesisLearnings?: InputMaybe<Scalars['Boolean']['input']>;
  ccTeamLeadsOnDigest?: InputMaybe<Scalars['Boolean']['input']>;
  checkInDay?: InputMaybe<Scalars['Int']['input']>;
  checkInHour?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationUpdateTenantPaymentInfoArgs = {
  input: UpdateTenantPaymentInfoInput;
};

export type MutationUpdateTenantUserArgs = {
  input: UpdateTenantUserInput;
};

export type MutationUpdateTenantWorkingCalendarArgs = {
  input: UpdateWorkingCalendarInput;
};

export type MutationUpdateTicketArgs = {
  expectedVersion: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
  input: UpdateTicketInput;
};

export type MutationUpdateVariableComponentDraftArgs = {
  id: Scalars['ID']['input'];
  input: UpdateVariableComponentInput;
};

export type MutationUpdateWebhookEndpointArgs = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  events?: InputMaybe<Array<WebhookEventType>>;
  id: Scalars['ID']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUploadInvoiceLogoArgs = {
  input: UploadInvoiceLogoInput;
};

export type MutationUpsertClientEmailDraftArgs = {
  input: UpsertClientEmailDraftInput;
};

export type MutationUpsertCustomerTaxProfileArgs = {
  input: UpsertCustomerTaxProfileInput;
};

export type MutationUpsertStatusWorkflowArgs = {
  input: StatusWorkflowInput;
};

export type MutationUpsertSupportRoleArgs = {
  input: SupportRoleInput;
};

export type MutationUpsertTicketTypeArgs = {
  input: TicketTypeInput;
};

export type MutationUpsertWorkItemStatusMapArgs = {
  entries: Array<StatusMapEntryInput>;
  listId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationVoidAiResolutionArgs = {
  reason: Scalars['String']['input'];
  ticketId: Scalars['ID']['input'];
};

export type MutationWaiveUsageReadingArgs = {
  input: WaiveUsageReadingInput;
};

export type MyBilling = {
  __typename?: 'MyBilling';
  card?: Maybe<MyBillingCard>;
  invoices: Array<MyBillingInvoice>;
  seats: MyBillingSeats;
  status?: Maybe<TenantBillingStatus>;
  subscription?: Maybe<MyBillingSubscription>;
};

export type MyBillingCard = {
  __typename?: 'MyBillingCard';
  brand?: Maybe<Scalars['String']['output']>;
  expMonth?: Maybe<Scalars['Int']['output']>;
  expYear?: Maybe<Scalars['Int']['output']>;
  last4?: Maybe<Scalars['String']['output']>;
};

export type MyBillingCardSetup = {
  __typename?: 'MyBillingCardSetup';
  clientSecret: Scalars['String']['output'];
  publishableKey: Scalars['String']['output'];
  stripeAccountId?: Maybe<Scalars['String']['output']>;
};

export type MyBillingInvoice = {
  __typename?: 'MyBillingInvoice';
  amount: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  dueDate: Scalars['String']['output'];
  id: Scalars['String']['output'];
  invoiceDate: Scalars['String']['output'];
  invoiceNumber: Scalars['String']['output'];
  paidDate?: Maybe<Scalars['String']['output']>;
  paymentStatus: Scalars['String']['output'];
  pdfUrl?: Maybe<Scalars['String']['output']>;
};

export type MyBillingSeats = {
  __typename?: 'MyBillingSeats';
  limit?: Maybe<Scalars['Int']['output']>;
  pendingInvites: Scalars['Int']['output'];
  used: Scalars['Int']['output'];
};

export type MyBillingSubscription = {
  __typename?: 'MyBillingSubscription';
  currency: Scalars['String']['output'];
  endDate: Scalars['String']['output'];
  period: Scalars['String']['output'];
  status: Scalars['String']['output'];
  trialEndsAt?: Maybe<Scalars['String']['output']>;
};

export type NrrTrendDataPoint = {
  __typename?: 'NRRTrendDataPoint';
  /** Month in YYYY-MM format */
  month: Scalars['String']['output'];
  /** Net Revenue Retention percentage (NRR > 100% indicates growth from existing customers) */
  nrr: Scalars['Float']['output'];
};

export type NetRevenueRetention = {
  __typename?: 'NetRevenueRetention';
  /** When this NRR was calculated */
  calculatedAt: Scalars['DateTime']['output'];
  /** Monthly recurring revenue lost from customer cancellations during the period */
  churnMRR: Scalars['Float']['output'];
  /** Monthly recurring revenue lost from customer downgrades during the period */
  contractionMRR: Scalars['Float']['output'];
  /** End date of the measurement period */
  endDate: Scalars['DateTime']['output'];
  /** Monthly Recurring Revenue at the end of the period */
  endingMRR: Scalars['Float']['output'];
  /** Monthly recurring revenue gained from customer upgrades and expansions during the period */
  expansionMRR: Scalars['Float']['output'];
  /** Net (after-discount) MRR retained at the end of the period (the net NRR numerator). */
  netEndingMRR: Scalars['Float']['output'];
  /** Net Revenue Retention percentage after discounts. Differs from nrr only by discounts: a discount that starts within the window lowers netNrr, one that expires raises it. Equals nrr when no discounts change across the window. */
  netNrr: Scalars['Float']['output'];
  /** Net (after-discount) MRR at the start of the period (the net NRR denominator). */
  netStartingMRR: Scalars['Float']['output'];
  /** Net Revenue Retention percentage. >100% means growing from existing customers, <100% means losing revenue */
  nrr: Scalars['Float']['output'];
  /** Start date of the measurement period */
  startDate: Scalars['DateTime']['output'];
  /** Monthly Recurring Revenue at the start of the period */
  startingMRR: Scalars['Float']['output'];
};

export type NewOrganizationForLeadInput = {
  domain?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export enum NotificationCategory {
  Account = 'ACCOUNT',
  Assignment = 'ASSIGNMENT',
  Checkin = 'CHECKIN',
  CycleState = 'CYCLE_STATE',
  Digest = 'DIGEST',
  TargetChange = 'TARGET_CHANGE',
  Team = 'TEAM',
}

/** Newest first. */
export type NotificationCenterConnection = {
  __typename?: 'NotificationCenterConnection';
  nodes: Array<NotificationCenterItem>;
  pageInfo: PageInfo;
};

export type NotificationCenterItem = {
  __typename?: 'NotificationCenterItem';
  /** The person who caused it, when one did. */
  actorUserId?: Maybe<Scalars['ID']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  kind: NotificationCenterKind;
  /** App-relative path the notification opens, e.g. /invoices/abc. */
  link?: Maybe<Scalars['String']['output']>;
  readAt?: Maybe<Scalars['DateTime']['output']>;
  source: NotificationSource;
  title: Scalars['String']['output'];
};

/** What a notification-center item is about. */
export enum NotificationCenterKind {
  CheckinReportFailed = 'CHECKIN_REPORT_FAILED',
  CheckinSlackPaused = 'CHECKIN_SLACK_PAUSED',
  CrmMeetingBooked = 'CRM_MEETING_BOOKED',
  DriveFoldersPaused = 'DRIVE_FOLDERS_PAUSED',
  EmailReply = 'EMAIL_REPLY',
  EmailSendFailed = 'EMAIL_SEND_FAILED',
  FormActionsFailed = 'FORM_ACTIONS_FAILED',
  FormSubmission = 'FORM_SUBMISSION',
  ImportReviewReady = 'IMPORT_REVIEW_READY',
  InboxDigest = 'INBOX_DIGEST',
  InvoiceOverdue = 'INVOICE_OVERDUE',
  OkrKeyResultAssigned = 'OKR_KEY_RESULT_ASSIGNED',
  OkrObjectiveAssigned = 'OKR_OBJECTIVE_ASSIGNED',
  OkrScoringOpened = 'OKR_SCORING_OPENED',
  OkrTargetChanged = 'OKR_TARGET_CHANGED',
  TaskReminder = 'TASK_REMINDER',
  UsageZeroPending = 'USAGE_ZERO_PENDING',
}

export type NotificationCenterPreference = {
  __typename?: 'NotificationCenterPreference';
  /** Whether this kind reaches your bell. */
  inApp: Scalars['Boolean']['output'];
  kind: NotificationCenterKind;
};

export type NotificationCenterPreferenceInput = {
  inApp: Scalars['Boolean']['input'];
  kind: NotificationCenterKind;
};

export enum NotificationPriority {
  Digest = 'DIGEST',
  Immediate = 'IMMEDIATE',
}

/** A person’s effective notification settings */
export type NotificationSettings = {
  __typename?: 'NotificationSettings';
  /** ISO weekday, 1 = Monday */
  day: Scalars['Int']['output'];
  /** Hour 0-23 in the recipient's own timezone */
  hour: Scalars['Int']['output'];
  /** Categories that may be silenced. The rest tell you something became yours or a cycle changed state. */
  mutableCategories: Array<NotificationCategory>;
  /** Categories they have silenced */
  mutedCategories: Array<NotificationCategory>;
  /** USER when they chose it, TENANT when it follows the workspace default */
  source: Scalars['String']['output'];
};

/** The part of Revvly a notification came from. */
export enum NotificationSource {
  Billing = 'BILLING',
  Checkins = 'CHECKINS',
  Crm = 'CRM',
  Email = 'EMAIL',
  Forms = 'FORMS',
  Integrations = 'INTEGRATIONS',
  Okr = 'OKR',
  Tasks = 'TASKS',
}

/** A message the product can send */
export type NotificationTemplate = {
  __typename?: 'NotificationTemplate';
  category: NotificationCategory;
  description: Scalars['String']['output'];
  key: Scalars['String']['output'];
  /** Whether a person may silence it */
  mutable: Scalars['Boolean']['output'];
};

export type NotifyUsersActionSettings = {
  __typename?: 'NotifyUsersActionSettings';
  subjectTemplate?: Maybe<Scalars['String']['output']>;
  userIds: Array<Scalars['ID']['output']>;
};

export type NotifyUsersActionSettingsInput = {
  subjectTemplate?: InputMaybe<Scalars['String']['input']>;
  userIds: Array<Scalars['ID']['input']>;
};

export enum ObjectiveLevel {
  Company = 'COMPANY',
  Team = 'TEAM',
}

export enum ObjectiveType {
  Aspirational = 'ASPIRATIONAL',
  Committed = 'COMMITTED',
}

/** Direction of a relative anchor offset. */
export enum OffsetDirection {
  After = 'AFTER',
  Before = 'BEFORE',
}

/** One thing standing between this tenant and OKRs. */
export type OkrActivationBlockerType = {
  __typename?: 'OkrActivationBlockerType';
  code: Scalars['String']['output'];
  /** What to do about it, in words an admin can act on. */
  message: Scalars['String']['output'];
};

export type OkrActivationResultType = {
  __typename?: 'OkrActivationResultType';
  status: OkrModuleStatusType;
  /** People who will not be prompted, named now rather than discovered three weeks in. */
  unmappedPeople: Array<TeamPerson>;
};

/** A Key Result named in an alignment */
export type OkrAlignedKeyResult = {
  __typename?: 'OkrAlignedKeyResult';
  id: Scalars['ID']['output'];
  objectiveId: Scalars['ID']['output'];
  objectiveTitle: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

/** How often bets at one confidence level validated */
export type OkrCalibrationLevel = {
  __typename?: 'OkrCalibrationLevel';
  concluded: Scalars['Int']['output'];
  /** 50, 80 or 100 */
  confidence: Scalars['Int']['output'];
  /** At least 5 concluded. Below it the share is not shown */
  enoughData: Scalars['Boolean']['output'];
  validated: Scalars['Int']['output'];
};

/** One check-in: where a Key Result stands, and how sure its owner is. */
export type OkrCheckIn = {
  __typename?: 'OkrCheckIn';
  author: TeamPerson;
  /** The viewer may edit or delete this check-in now. */
  canEdit: Scalars['Boolean']['output'];
  channel: CheckInChannel;
  checkedInAt: Scalars['DateTime']['output'];
  /** 1 to 10. Null only on history carried over from V0 value updates. */
  confidence?: Maybe<Scalars['Int']['output']>;
  editedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  /** The value before this check-in: the previous check-in’s, or the start value for the first. */
  previousValue?: Maybe<Scalars['Float']['output']>;
  /** Null on a metric Key Result, whose value comes from the metric. */
  value?: Maybe<Scalars['Float']['output']>;
};

/** One line of a conversation with the drafting coach, as the editor kept it. */
export type OkrCoachMessageInputType = {
  content: Scalars['String']['input'];
  role: OkrCoachRole;
  /** The titles the coach offered with this line, so it knows what it proposed. */
  suggestedTitles?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** The coach's answer in a conversation about a draft. Advice only: nothing is saved and nothing is applied until the author chooses to. */
export type OkrCoachReplyType = {
  __typename?: 'OkrCoachReplyType';
  /** What the coach says, in plain text. */
  reply: Scalars['String']['output'];
  /** A proposed description, when the conversation produced one. */
  suggestedDescription?: Maybe<Scalars['String']['output']>;
  /** Up to three rewrites to choose from; empty when the reply needs none. */
  suggestions: Array<OkrCoachSuggestionType>;
};

export enum OkrCoachRole {
  Author = 'AUTHOR',
  Coach = 'COACH',
}

/** A rewrite the coach proposes in conversation. Start and target are set only when it proposes moving them, and only to numbers the author gave. */
export type OkrCoachSuggestionType = {
  __typename?: 'OkrCoachSuggestionType';
  startValue?: Maybe<Scalars['Float']['output']>;
  targetValue?: Maybe<Scalars['Float']['output']>;
  title: Scalars['String']['output'];
};

/** Company Key Results × teams, with the objectives that link. No score is rolled up from it */
export type OkrCoverage = {
  __typename?: 'OkrCoverage';
  cycleId: Scalars['ID']['output'];
  cycleName: Scalars['String']['output'];
  cycleState: CycleState;
  rows: Array<OkrCoverageRow>;
  teams: Array<OkrCoverageTeam>;
  /** Company Key Results nothing links to */
  uncoveredCount: Scalars['Int']['output'];
  /** Teams with Key Results, none of which link anywhere */
  unlinkedTeamCount: Scalars['Int']['output'];
};

/** One company Key Result × team: the objectives behind it. Absent when there are none */
export type OkrCoverageCell = {
  __typename?: 'OkrCoverageCell';
  objectiveCount: Scalars['Int']['output'];
  objectives: Array<OkrCoverageObjective>;
  teamId: Scalars['ID']['output'];
};

export type OkrCoverageLinkedKeyResult = {
  __typename?: 'OkrCoverageLinkedKeyResult';
  keyResultId: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type OkrCoverageObjective = {
  __typename?: 'OkrCoverageObjective';
  /** The team Key Results under this objective that link to the row’s company Key Result */
  keyResults: Array<OkrCoverageLinkedKeyResult>;
  objectiveId: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type OkrCoverageRow = {
  __typename?: 'OkrCoverageRow';
  /** Only the teams that link to it. A team with no cell here links to nothing on this row */
  cells: Array<OkrCoverageCell>;
  keyResultId: Scalars['ID']['output'];
  objectiveId: Scalars['ID']['output'];
  objectiveTitle: Scalars['String']['output'];
  title: Scalars['String']['output'];
  /** Nothing links to it: the gap the cycle owner is looking for */
  uncovered: Scalars['Boolean']['output'];
};

export type OkrCoverageTeam = {
  __typename?: 'OkrCoverageTeam';
  /** Live Key Results under the team’s objectives in this cycle */
  keyResultCount: Scalars['Int']['output'];
  /** Total links from this team */
  linkCount: Scalars['Int']['output'];
  /** How many of those link to at least one company Key Result */
  linkedKeyResultCount: Scalars['Int']['output'];
  teamId: Scalars['ID']['output'];
  teamName: Scalars['String']['output'];
  /** It has Key Results and none of them link anywhere */
  unlinked: Scalars['Boolean']['output'];
};

/** A planning period — usually a quarter. */
export type OkrCycle = {
  __typename?: 'OkrCycle';
  /** When the cycle was closed and became read-only. */
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Whole days to the end date, floored at zero. */
  daysRemaining: Scalars['Int']['output'];
  endDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** Who is accountable for running it. */
  owner: TeamPerson;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** When the cycle moved to scoring. */
  scoringOpenedAt?: Maybe<Scalars['DateTime']['output']>;
  startDate: Scalars['DateTime']['output'];
  state: CycleState;
};

/** Everything the OKR cycle screen renders. */
export type OkrCycleView = {
  __typename?: 'OkrCycleView';
  companyObjectives: Array<OkrObjective>;
  cycle: OkrCycle;
  /** Each Key Result’s hypothesis summary, for the chips on its row */
  hypothesisSummaries: Array<OkrKeyResultHypothesisSummary>;
  teamObjectives: Array<OkrObjective>;
  /** Key Results nobody has attached to an objective yet. */
  unattached: Array<OkrKeyResult>;
};

/** One criterion the AI review graded a draft against. */
export type OkrDraftCheckType = {
  __typename?: 'OkrDraftCheckType';
  /** The part of the draft a failure is fixed in: TITLE, DESCRIPTION or VALUES (start and target). */
  fixedIn: Scalars['String']['output'];
  /** Stable identifier of the criterion, e.g. OUTCOME or BASELINE_TARGET. */
  key: Scalars['String']['output'];
  /** The criterion in words, as the editor guidance names it. */
  label: Scalars['String']['output'];
  /** One sentence on why, addressed to the author. */
  note: Scalars['String']['output'];
  passed: Scalars['Boolean']['output'];
};

/** AI feedback on a draft objective or Key Result. Advice only: nothing is saved and nothing is refused. */
export type OkrDraftReviewType = {
  __typename?: 'OkrDraftReviewType';
  /** Every criterion, in the order the editor guidance lists them. */
  checks: Array<OkrDraftCheckType>;
  /** Rewritten titles to choose from, only while a title criterion fails. Never applied automatically. */
  suggestedTitles: Array<Scalars['String']['output']>;
  /** The overall read, in one or two sentences. */
  summary: Scalars['String']['output'];
  verdict: OkrDraftVerdict;
};

export enum OkrDraftVerdict {
  CouldBeStronger = 'COULD_BE_STRONGER',
  NeedsWork = 'NEEDS_WORK',
  Strong = 'STRONG',
}

/** A testable bet under one Key Result. */
export type OkrHypothesis = {
  __typename?: 'OkrHypothesis';
  /** In Backlog or Developing and every linked ClickUp task is done: the owner is asked whether the test is live. Never changes the status */
  allLinkedWorkDone: Scalars['Boolean']['output'];
  carriedFromId?: Maybe<Scalars['ID']['output']>;
  carriedToId?: Maybe<Scalars['ID']['output']>;
  concludedAt?: Maybe<Scalars['DateTime']['output']>;
  /** 50, 80 or 100 */
  confidence?: Maybe<Scalars['Int']['output']>;
  confidenceAtTestStart?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  cycleId: Scalars['ID']['output'];
  cycleName: Scalars['String']['output'];
  /** Whole days in the current status */
  daysInStatus: Scalars['Int']['output'];
  /** Days since the planned end date, when overdue */
  daysOverdue: Scalars['Int']['output'];
  decisionRule?: Maybe<Scalars['String']['output']>;
  droppedReason?: Maybe<Scalars['String']['output']>;
  /** Person-weeks */
  effort?: Maybe<Scalars['Float']['output']>;
  estimatedEffect?: Maybe<Scalars['Float']['output']>;
  expectedOutcome?: Maybe<Scalars['String']['output']>;
  extensionCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  impact?: Maybe<Scalars['Float']['output']>;
  inconclusiveReason?: Maybe<HypothesisInconclusiveReason>;
  /** Its Key Result was dropped. It can still be moved, dropped or concluded */
  keyResultDropped: Scalars['Boolean']['output'];
  keyResultId: Scalars['ID']['output'];
  keyResultTitle: Scalars['String']['output'];
  learning?: Maybe<Scalars['String']['output']>;
  linkCount: Scalars['Int']['output'];
  nextStep?: Maybe<HypothesisNextStep>;
  observedEffect?: Maybe<Scalars['Float']['output']>;
  outcome?: Maybe<HypothesisOutcome>;
  /** In Testing and past the planned end date */
  overdue: Scalars['Boolean']['output'];
  owner?: Maybe<TeamPerson>;
  plannedEndDate?: Maybe<Scalars['DateTime']['output']>;
  /** Written from a Revvly Agent proposal the creator approved */
  proposedByAgent: Scalars['Boolean']['output'];
  /** Position among the scored open hypotheses on its Key Result, 1 first. Null when unscored or closed */
  rank?: Maybe<Scalars['Int']['output']>;
  reach?: Maybe<Scalars['Int']['output']>;
  reachUnit?: Maybe<Scalars['String']['output']>;
  result?: Maybe<Scalars['String']['output']>;
  retestOfId?: Maybe<Scalars['ID']['output']>;
  /** Send it back as baseRevision when editing, so a change someone else made meanwhile is not overwritten */
  revision: Scalars['Int']['output'];
  /** (Reach × Impact × Confidence) ÷ Effort, computed on the server. Null until all four inputs exist */
  score?: Maybe<Scalars['Float']['output']>;
  /** We believe that [change] will [effect] because [reason] */
  statement: Scalars['String']['output'];
  status: HypothesisStatus;
  /** The team owning the objective that holds the Key Result */
  teamName?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  /** No owner, or an owner who is no longer an active member */
  unowned: Scalars['Boolean']['output'];
};

/** The in-flight board for one cycle, across Key Results */
export type OkrHypothesisBoard = {
  __typename?: 'OkrHypothesisBoard';
  /** Oldest first */
  backlog: Array<OkrHypothesis>;
  /** Concluded in this cycle, newest first */
  concluded: Array<OkrHypothesis>;
  cycleId: Scalars['ID']['output'];
  cycleName: Scalars['String']['output'];
  /** Oldest first */
  developing: Array<OkrHypothesis>;
  /** Soonest planned end first */
  testing: Array<OkrHypothesis>;
};

/** A Key Result in a later cycle a hypothesis can be carried to */
export type OkrHypothesisCarryTarget = {
  __typename?: 'OkrHypothesisCarryTarget';
  cycleName: Scalars['String']['output'];
  keyResultId: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

/** What the close-cycle dispositions panel needs */
export type OkrHypothesisCloseCandidates = {
  __typename?: 'OkrHypothesisCloseCandidates';
  carryTargets: Array<OkrHypothesisCarryTarget>;
  open: Array<OkrHypothesis>;
};

/** One hypothesis with everything its page shows */
export type OkrHypothesisDetail = {
  __typename?: 'OkrHypothesisDetail';
  carriedFrom?: Maybe<OkrHypothesis>;
  carriedTo?: Maybe<OkrHypothesis>;
  hypothesis: OkrHypothesis;
  keyResult: OkrHypothesisKeyResultRef;
  links: Array<OkrHypothesisLink>;
  /** Null when the Key Result reads no metric and the test captured none */
  metricSnapshots?: Maybe<OkrHypothesisMetricSnapshots>;
  permissions: OkrHypothesisPermissions;
  /** Scored open hypotheses on the Key Result, for "rank 2 of 5" */
  rankedOnKeyResult: Scalars['Int']['output'];
  retestOf?: Maybe<OkrHypothesis>;
  /** Hypotheses run again from this one */
  retests: Array<OkrHypothesis>;
  timeline: Array<OkrHypothesisTimelineEntry>;
};

/** The close-cycle panel’s outcome: all applied, or none */
export type OkrHypothesisDispositionResult = {
  __typename?: 'OkrHypothesisDispositionResult';
  applied: Scalars['Boolean']['output'];
  issues: Array<OkrHypothesisIssue>;
  /** Open hypotheses left in the cycle */
  remainingOpen: Scalars['Int']['output'];
};

/** A validation result. BLOCK refused the write; CONFIRM refused it until the code is resubmitted in `acknowledge`; INFORM changed nothing. */
export type OkrHypothesisIssue = {
  __typename?: 'OkrHypothesisIssue';
  code: Scalars['String']['output'];
  /** The input field it is about */
  field?: Maybe<Scalars['String']['output']>;
  /** In the close-cycle panel: the row it is about */
  hypothesisId?: Maybe<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
  severity: HypothesisIssueSeverity;
};

/** The Key Result a hypothesis serves, for its header */
export type OkrHypothesisKeyResultRef = {
  __typename?: 'OkrHypothesisKeyResultRef';
  currentValue?: Maybe<Scalars['Float']['output']>;
  cycleEndDate: Scalars['DateTime']['output'];
  cycleState: CycleState;
  id: Scalars['ID']['output'];
  startValue: Scalars['Float']['output'];
  status: KeyResultStatus;
  targetValue: Scalars['Float']['output'];
  title: Scalars['String']['output'];
  unit: KeyResultUnit;
};

/** A link to the work behind a bet. A reference only: it never changes a status. A ClickUp task link shows what ClickUp last said about the task; Revvly writes nothing back */
export type OkrHypothesisLink = {
  __typename?: 'OkrHypothesisLink';
  /** The ClickUp status name as last read. Null until the task has been read */
  cachedStatus?: Maybe<Scalars['String']['output']>;
  /** The ClickUp task title as last read. Null until the task has been read */
  cachedTitle?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** ClickUp counts the last-read status as done or closed */
  isDone: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  /** When the task was last read successfully */
  lastSynced?: Maybe<Scalars['DateTime']['output']>;
  source: HypothesisLinkSource;
  /** NOT_FOUND or NO_ACCESS when the last read could not see the task. The cached fields show what it last said */
  syncError?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

/** The Key Result's metric at one end of a test (HY-38). Context, never an input to the verdict */
export type OkrHypothesisMetricSnapshot = {
  __typename?: 'OkrHypothesisMetricSnapshot';
  capturedAt: Scalars['DateTime']['output'];
  /** Set for a currency metric */
  currency?: Maybe<Scalars['String']['output']>;
  kind: HypothesisSnapshotKind;
  metricKey?: Maybe<OkrMetricKey>;
  /** Why there is no value: the metric was withdrawn or changed, or could not be read */
  skipped?: Maybe<HypothesisSnapshotSkip>;
  unit?: Maybe<KeyResultUnit>;
  /** Null when skipped */
  value?: Maybe<Scalars['Float']['output']>;
};

/** The before and after of a test on a metric-backed Key Result */
export type OkrHypothesisMetricSnapshots = {
  __typename?: 'OkrHypothesisMetricSnapshots';
  end?: Maybe<OkrHypothesisMetricSnapshot>;
  /** The Key Result reads a metric now */
  metricBacked: Scalars['Boolean']['output'];
  /** Taken when the test started, on the first record of a carry chain */
  start?: Maybe<OkrHypothesisMetricSnapshot>;
};

/** What the viewer may do, asked of the same rules the mutations enforce */
export type OkrHypothesisPermissions = {
  __typename?: 'OkrHypothesisPermissions';
  /** Assign or change the owner */
  canAssign: Scalars['Boolean']['output'];
  /** Carry and dispose at cycle close (cycle owners) */
  canDispose: Scalars['Boolean']['output'];
  /** Move to another Key Result in the same cycle */
  canMove: Scalars['Boolean']['output'];
  /** Edit, advance, extend, conclude, drop and manage links */
  canWork: Scalars['Boolean']['output'];
};

/** A test on a Key Result, for marking its start and end on a metric chart (HY-39) */
export type OkrHypothesisTestMarker = {
  __typename?: 'OkrHypothesisTestMarker';
  /** When it concluded; null while running */
  endedAt?: Maybe<Scalars['DateTime']['output']>;
  hypothesisId: Scalars['ID']['output'];
  keyResultId: Scalars['ID']['output'];
  outcome?: Maybe<HypothesisOutcome>;
  /** When the test entered Testing, following a carry back to where it started */
  startedAt: Scalars['DateTime']['output'];
  status: HypothesisStatus;
  title: Scalars['String']['output'];
};

/** A status change or a tracked field change, newest first. Neither can be edited */
export type OkrHypothesisTimelineEntry = {
  __typename?: 'OkrHypothesisTimelineEntry';
  at: Scalars['DateTime']['output'];
  by: TeamPerson;
  field?: Maybe<Scalars['String']['output']>;
  fromStatus?: Maybe<HypothesisStatus>;
  id: Scalars['ID']['output'];
  /** STATUS or CHANGE */
  kind: Scalars['String']['output'];
  newValue?: Maybe<Scalars['String']['output']>;
  /** The note on a status change, or a change’s reason */
  note?: Maybe<Scalars['String']['output']>;
  oldValue?: Maybe<Scalars['String']['output']>;
  toStatus?: Maybe<HypothesisStatus>;
};

/** The outcome of a hypothesis write. `applied` false means nothing was written; `issues` says why */
export type OkrHypothesisWriteResult = {
  __typename?: 'OkrHypothesisWriteResult';
  applied: Scalars['Boolean']['output'];
  hypothesis?: Maybe<OkrHypothesis>;
  issues: Array<OkrHypothesisIssue>;
};

/** A measurable result inside a cycle. */
export type OkrKeyResult = {
  __typename?: 'OkrKeyResult';
  /** The newest check-in’s confidence, 1 to 10. Null before any check-in. */
  confidence?: Maybe<Scalars['Int']['output']>;
  currentValue?: Maybe<Scalars['Float']['output']>;
  /** Confidence fell across the last two consecutive check-ins. */
  declining: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  direction: KeyResultDirection;
  droppedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Why it was dropped. Present on a dropped Key Result. */
  droppedReason?: Maybe<Scalars['String']['output']>;
  /** The value its owner confirmed when scoring. Null until scored. */
  finalValue?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  lastCheckInAt?: Maybe<Scalars['DateTime']['output']>;
  lastValueAt?: Maybe<Scalars['DateTime']['output']>;
  /** Set only when `source` is METRIC. */
  metricKey?: Maybe<OkrMetricKey>;
  /** When the nightly refresh last read this metric successfully. */
  metricLastRefreshedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The CRM pipeline a pipeline-scoped metric counts over. */
  metricPipelineId?: Maybe<Scalars['ID']['output']>;
  /** The metric refresh has failed three or more times in a row. False for a manual Key Result. */
  metricStale: Scalars['Boolean']['output'];
  /** Null while unattached to an objective. */
  objectiveId?: Maybe<Scalars['ID']['output']>;
  owner: TeamPerson;
  position: Scalars['Int']['output'];
  /** Between 0 and 1, direction-aware and clamped. */
  progress: Scalars['Float']['output'];
  /** Only populated by the Key Result detail and analytics-overlay reads — never on the cycle or objective views, which would otherwise pay for a projection on every row. */
  projection?: Maybe<OkrKeyResultProjection>;
  /** Whether the owner will actually be prompted in Slack. */
  reachability: SlackReachability;
  /** Progress toward target from the final value, 0 to 1. Computed by the server, never accepted. */
  score?: Maybe<Scalars['Float']['output']>;
  /** Why it ended where it did. Always present on a scored Key Result. */
  scoreComment?: Maybe<Scalars['String']['output']>;
  scoredAt?: Maybe<Scalars['DateTime']['output']>;
  source: KeyResultSource;
  /** No check-in for two weeks on a running cycle. */
  stale: Scalars['Boolean']['output'];
  startValue: Scalars['Float']['output'];
  /** When the start value was locked at publish. Present means it is read-only. */
  startValueFrozenAt?: Maybe<Scalars['DateTime']['output']>;
  status: KeyResultStatus;
  targetValue: Scalars['Float']['output'];
  title: Scalars['String']['output'];
  unit: KeyResultUnit;
  /** Nobody active holds this. The owner name is kept rather than cleared, so the loss is visible. */
  unowned: Scalars['Boolean']['output'];
};

/** Which company Key Results a team one serves, and which team ones serve a company one */
export type OkrKeyResultAlignment = {
  __typename?: 'OkrKeyResultAlignment';
  /** Company Key Results this team Key Result serves. Empty is legal and expected */
  alignedTo: Array<OkrAlignedKeyResult>;
  /** The viewer may add and remove links on it, and the cycle is still taking structural changes */
  canAlign: Scalars['Boolean']['output'];
  /** Company Key Results still available to link to. Empty unless canAlign */
  options: Array<OkrAlignedKeyResult>;
  /** Team Key Results that serve this company Key Result */
  servedBy: Array<OkrServingKeyResult>;
};

/** A Key Result with its history, for the detail screen. */
export type OkrKeyResultDetail = {
  __typename?: 'OkrKeyResultDetail';
  /** The viewer may check in on this Key Result now. */
  canCheckIn: Scalars['Boolean']['output'];
  /** The viewer may submit or amend its score now: the cycle is in scoring and they own it, or are a cycle owner. */
  canScore: Scalars['Boolean']['output'];
  /** Why check-ins are closed on it, when they are: a draft, scoring or closed cycle. */
  checkInClosedReason?: Maybe<Scalars['String']['output']>;
  /** Newest first. */
  checkIns: Array<OkrCheckIn>;
  /** The cycle it belongs to, so a page can load that cycle rather than assume the current one. */
  cycleId: Scalars['ID']['output'];
  keyResult: OkrKeyResult;
  /** The objective it serves, if any. */
  objectiveTitle?: Maybe<Scalars['String']['output']>;
  targetHistory: Array<OkrTargetChange>;
};

/** Dropping a Key Result. Validation travels in `issues`, as for hypotheses: a CONFIRM is accepted by resending its code in `acknowledge`. */
export type OkrKeyResultDropResult = {
  __typename?: 'OkrKeyResultDropResult';
  applied: Scalars['Boolean']['output'];
  issues: Array<OkrHypothesisIssue>;
  keyResult: OkrKeyResult;
};

/** The Hypotheses tab of a Key Result */
export type OkrKeyResultHypotheses = {
  __typename?: 'OkrKeyResultHypotheses';
  /** The viewer is accountable for the Key Result: may assign, advance and move */
  canAssign: Scalars['Boolean']['output'];
  /** Anyone can propose while the cycle is open and the Key Result not dropped */
  canPropose: Scalars['Boolean']['output'];
  /** Concluded, dropped and carried */
  closed: Array<OkrHypothesis>;
  /** The Key Result is behind its expected pace (for the empty state) */
  keyResultBehind: Scalars['Boolean']['output'];
  /** The unit last used for reach here, the form’s default */
  lastReachUnit?: Maybe<Scalars['String']['output']>;
  /** Open and scored, highest first */
  ranked: Array<OkrHypothesis>;
  summary: OkrKeyResultHypothesisSummary;
  /** Open with a score input missing */
  unscored: Array<OkrHypothesis>;
};

/** Health signals for one Key Result. Counts are plain numbers with no target; rates are hidden while too thin to mean anything */
export type OkrKeyResultHypothesisSummary = {
  __typename?: 'OkrKeyResultHypothesisSummary';
  /** Progress trails the share of the cycle elapsed by more than 10 points, in an active cycle */
  behind: Scalars['Boolean']['output'];
  /** Median days from Developing to Testing; 0 when skipped */
  buildTimeDays?: Maybe<Scalars['Float']['output']>;
  /** Open hypotheses with an estimate but no confidence to weigh it by */
  coverageMissingConfidence: Scalars['Int']['output'];
  /** Open hypotheses with no estimated improvement */
  coverageMissingEstimate: Scalars['Int']['output'];
  /** Σ(confidence × estimated improvement) of open hypotheses ÷ remaining gap, as a percent. Null when the gap is zero or negative, no open hypothesis can contribute, or the Key Result is dropped */
  gapCoveragePercent?: Maybe<Scalars['Int']['output']>;
  /** Non-dropped hypotheses */
  hypotheses: Scalars['Int']['output'];
  /** Currently in Testing */
  inFlight: Scalars['Int']['output'];
  inconclusive: Scalars['Int']['output'];
  invalidated: Scalars['Int']['output'];
  keyResultId: Scalars['ID']['output'];
  /** Links across its hypotheses */
  linkCount: Scalars['Int']['output'];
  /** None at all, and more than 25% of the cycle has elapsed */
  noHypotheses: Scalars['Boolean']['output'];
  overdue: Scalars['Int']['output'];
  /** Distance still to go toward the target, in the Key Result's unit. Null once reached or passed */
  remainingGap?: Maybe<Scalars['Float']['output']>;
  /** Median days from Testing to Concluded, following carries */
  testDurationDays?: Maybe<Scalars['Float']['output']>;
  /** Hypotheses that entered Testing on this Key Result */
  testsRun: Scalars['Int']['output'];
  validated: Scalars['Int']['output'];
  /** Validated + invalidated. Null below 3 concluded */
  validationRateDecided?: Maybe<Scalars['Int']['output']>;
  /** Validated, the numerator of the validation rate. Null below 3 concluded */
  validationRateValidated?: Maybe<Scalars['Int']['output']>;
};

/** Where a metric-backed Key Result is projected to land by its cycle end, from a straight line through its values since publish. */
export type OkrKeyResultProjection = {
  __typename?: 'OkrKeyResultProjection';
  paceStatus: KeyResultPaceStatus;
  projectedValueAtEnd: Scalars['Float']['output'];
};

/** The work linked to a Key Result */
export type OkrKeyResultWorkLinks = {
  __typename?: 'OkrKeyResultWorkLinks';
  /** This viewer may add and remove links, and the cycle still takes them */
  canLink: Scalars['Boolean']['output'];
  /** ClickUp is connected for this tenant */
  connected: Scalars['Boolean']['output'];
  connectionStatus: ClickUpConnectionStatus;
  links: Array<OkrWorkLink>;
};

/** One page of the learnings library */
export type OkrLearningsPage = {
  __typename?: 'OkrLearningsPage';
  items: Array<OkrHypothesis>;
  nextCursor?: Maybe<Scalars['String']['output']>;
  total: Scalars['Int']['output'];
};

/** One metric a Key Result can be bound to instead of a manual check-in. */
export type OkrMetricDefinitionType = {
  __typename?: 'OkrMetricDefinitionType';
  defaultDirection: KeyResultDirection;
  key: OkrMetricKey;
  label: Scalars['String']['output'];
  /** The Key Result must also name a CRM pipeline for this metric. */
  requiresPipeline: Scalars['Boolean']['output'];
  unit: KeyResultUnit;
};

/** A Revvly metric a Key Result can be bound to instead of a manual check-in. */
export enum OkrMetricKey {
  ActiveSubscriptions = 'ACTIVE_SUBSCRIPTIONS',
  Arr = 'ARR',
  DealsCreatedCycle = 'DEALS_CREATED_CYCLE',
  ExpansionMrrMonthly = 'EXPANSION_MRR_MONTHLY',
  LeadsCreatedCycle = 'LEADS_CREATED_CYCLE',
  LeadsCreatedMonthly = 'LEADS_CREATED_MONTHLY',
  MeteredUsageRevenueMonthly = 'METERED_USAGE_REVENUE_MONTHLY',
  Mrr = 'MRR',
  NewAccountsCycle = 'NEW_ACCOUNTS_CYCLE',
  NewAccountsMonthly = 'NEW_ACCOUNTS_MONTHLY',
  Nrr = 'NRR',
  ReceivablesOver_60Days = 'RECEIVABLES_OVER_60_DAYS',
  RenewedAccountsCycle = 'RENEWED_ACCOUNTS_CYCLE',
  RenewedAccountsExclMonthlyCycle = 'RENEWED_ACCOUNTS_EXCL_MONTHLY_CYCLE',
  RenewedAccountsExclMonthlyMonthly = 'RENEWED_ACCOUNTS_EXCL_MONTHLY_MONTHLY',
  RenewedAccountsMonthly = 'RENEWED_ACCOUNTS_MONTHLY',
  RevenueChurnMonthly = 'REVENUE_CHURN_MONTHLY',
}

/** Whether OKRs are available and switched on. */
export type OkrModuleStatusType = {
  __typename?: 'OkrModuleStatusType';
  /** An administrator has turned it on, or it is always on. */
  activated: Scalars['Boolean']['output'];
  activatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Always on, with no activation step and no way to turn it off. True only for the Master tenant, which has every module on. */
  alwaysOn: Scalars['Boolean']['output'];
  announcementChannelSet: Scalars['Boolean']['output'];
  blockers: Array<OkrActivationBlockerType>;
  /** Revvly has sold this tenant the module. */
  entitled: Scalars['Boolean']['output'];
  mappedCount: Scalars['Int']['output'];
  slackConnected: Scalars['Boolean']['output'];
  unmappedCount: Scalars['Int']['output'];
};

/** Hypotheses the viewer owns */
export type OkrMyHypotheses = {
  __typename?: 'OkrMyHypotheses';
  /** Testing and past the planned end date, most overdue first */
  needsVerdict: Array<OkrHypothesis>;
  /** Every open hypothesis owned, overdue first, then Testing, Developing, Backlog */
  open: Array<OkrHypothesis>;
};

/** A team the viewer belongs to or leads. */
export type OkrMyTeam = {
  __typename?: 'OkrMyTeam';
  id: Scalars['ID']['output'];
  /** The viewer leads this team. A lead need not be a member. */
  isLead: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** The team’s own objectives in this cycle. */
  objectiveCount: Scalars['Int']['output'];
};

/** The viewer’s own slice of the current cycle: what they own and the teams they work in. Nothing company-wide. */
export type OkrMyView = {
  __typename?: 'OkrMyView';
  cycle: OkrCycle;
  /** Key Results the viewer owns. */
  keyResults: Array<OkrKeyResult>;
  /** Objectives the viewer owns, each with all of its Key Results. */
  objectives: Array<OkrObjective>;
  teams: Array<OkrMyTeam>;
};

/** What the company or a team is trying to achieve this cycle. */
export type OkrObjective = {
  __typename?: 'OkrObjective';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  keyResults: Array<OkrKeyResult>;
  level: ObjectiveLevel;
  owner: TeamPerson;
  position: Scalars['Int']['output'];
  /** The mean of its Key Results, or 0 when it has none. */
  progress: Scalars['Float']['output'];
  teamId?: Maybe<Scalars['ID']['output']>;
  teamName?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: ObjectiveType;
  unowned: Scalars['Boolean']['output'];
};

/** A Key Result still waiting on a score. */
export type OkrOutstandingScore = {
  __typename?: 'OkrOutstandingScore';
  keyResultId: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

/** One person’s part of the scoring chase list. Not a ranking: it lists what is outstanding. */
export type OkrScoringOwner = {
  __typename?: 'OkrScoringOwner';
  outstanding: Array<OkrOutstandingScore>;
  owner: TeamPerson;
  scoredCount: Scalars['Int']['output'];
  /** Nobody active holds these. Flagged, never silently reassigned. */
  unowned: Scalars['Boolean']['output'];
};

/** Who still owes a score, and how far along the cycle is. */
export type OkrScoringStatus = {
  __typename?: 'OkrScoringStatus';
  /** 0 to 1. A cycle with nothing to score reads as complete. */
  completionRate: Scalars['Float']['output'];
  cycleId: Scalars['ID']['output'];
  outstandingCount: Scalars['Int']['output'];
  /** Owners with the most outstanding first. */
  owners: Array<OkrScoringOwner>;
  scoredCount: Scalars['Int']['output'];
  state: CycleState;
  /** Key Results that can be scored: dropped ones are left out. */
  totalCount: Scalars['Int']['output'];
};

/** A team Key Result that serves a company one */
export type OkrServingKeyResult = {
  __typename?: 'OkrServingKeyResult';
  id: Scalars['ID']['output'];
  objectiveId: Scalars['ID']['output'];
  objectiveTitle: Scalars['String']['output'];
  teamId: Scalars['ID']['output'];
  teamName: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

/** A target that moved after the cycle was published. */
export type OkrTargetChange = {
  __typename?: 'OkrTargetChange';
  changedAt: Scalars['DateTime']['output'];
  changedBy: TeamPerson;
  id: Scalars['ID']['output'];
  newTarget: Scalars['Float']['output'];
  previousTarget: Scalars['Float']['output'];
  reason?: Maybe<Scalars['String']['output']>;
};

/** A company Key Result a team’s work serves, and which of the team’s Key Results serve it. */
export type OkrTeamUpstream = {
  __typename?: 'OkrTeamUpstream';
  keyResult: OkrKeyResult;
  /** The company objective it sits under. */
  objectiveTitle?: Maybe<Scalars['String']['output']>;
  /** The team’s Key Results linked to it. */
  servedBy: Array<Scalars['ID']['output']>;
};

/** One team’s slice of a cycle: its objectives, what they link to upstream and how much links to nothing. Members come from the `team` query. */
export type OkrTeamView = {
  __typename?: 'OkrTeamView';
  cycle: OkrCycle;
  /** Each of the team’s Key Results’ hypothesis summary, for the chips on its row */
  hypothesisSummaries: Array<OkrKeyResultHypothesisSummary>;
  /** The team’s Key Results still in play. Dropped ones are not counted. */
  keyResultCount: Scalars['Int']['output'];
  /** The team’s objectives, in the cycle view’s order. */
  objectives: Array<OkrObjective>;
  teamId: Scalars['ID']['output'];
  /** Of those, how many serve no company Key Result. */
  unlinkedKeyResultCount: Scalars['Int']['output'];
  /** Company Key Results the team’s work serves. */
  upstream: Array<OkrTeamUpstream>;
};

/** Someone a linked task is assigned to */
export type OkrWorkAssignee = {
  __typename?: 'OkrWorkAssignee';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** A task in another tool that serves a Key Result. A reference with a cached view of the task, plus one comment Revvly keeps on it; it never changes the Key Result */
export type OkrWorkLink = {
  __typename?: 'OkrWorkLink';
  assignees: Array<OkrWorkAssignee>;
  /** NOT_FOUND or NO_ACCESS when Revvly could not post its comment on the task. Null when the comment is there, or has not been tried yet */
  commentError?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  externalId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** The tool says this status is done or closed */
  isDone: Scalars['Boolean']['output'];
  /** When the task was last read from the tool */
  lastSyncedAt: Scalars['DateTime']['output'];
  listName?: Maybe<Scalars['String']['output']>;
  source: OkrWorkLinkSource;
  statusColor?: Maybe<Scalars['String']['output']>;
  statusName: Scalars['String']['output'];
  /** Its subtasks by status. Null when the task has none */
  subtasks?: Maybe<OkrWorkSubtasks>;
  /** NOT_FOUND or NO_ACCESS when the last refresh could not read the task. The line shows what was last seen */
  syncError?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export enum OkrWorkLinkSource {
  Clickup = 'CLICKUP',
}

/** How many of a linked task’s subtasks are in one status */
export type OkrWorkSubtaskState = {
  __typename?: 'OkrWorkSubtaskState';
  /** The status colour the tool uses, as a hex */
  color?: Maybe<Scalars['String']['output']>;
  count: Scalars['Int']['output'];
  /** The tool counts this status as done or closed */
  isDone: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

/** A linked task’s subtasks, counted by status */
export type OkrWorkSubtasks = {
  __typename?: 'OkrWorkSubtasks';
  /** Statuses still to do first, then the finished ones */
  byStatus: Array<OkrWorkSubtaskState>;
  /** In a status the tool counts as done or closed */
  closed: Scalars['Int']['output'];
  open: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

/** Criteria for automatic step completion */
export type OnboardingCompletionCriteria = {
  __typename?: 'OnboardingCompletionCriteria';
  /** Minimum count required (for count type) */
  minCount?: Maybe<Scalars['Int']['output']>;
  /** Target field or entity to check */
  target: Scalars['String']['output'];
  /** Type of completion check */
  type: CompletionCriteriaType;
};

/** Onboarding configuration */
export type OnboardingConfig = {
  __typename?: 'OnboardingConfig';
  /** When the config was created */
  createdAt: Scalars['DateTime']['output'];
  /** Configuration description */
  description?: Maybe<Scalars['String']['output']>;
  /** Configuration ID */
  id: Scalars['ID']['output'];
  /** Whether this config is active */
  isActive: Scalars['Boolean']['output'];
  /** Whether this is the default config */
  isDefault: Scalars['Boolean']['output'];
  /** Configuration name */
  name: Scalars['String']['output'];
  /** Array of onboarding steps */
  steps: Array<OnboardingStep>;
  /** When the config was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** One assistant-led onboarding, for the platform funnel */
export type OnboardingFunnelRowType = {
  __typename?: 'OnboardingFunnelRowType';
  gatePassedAt?: Maybe<Scalars['DateTime']['output']>;
  lastEvent?: Maybe<Scalars['String']['output']>;
  lastEventAt?: Maybe<Scalars['DateTime']['output']>;
  phase?: Maybe<AssistantOnboardingPhase>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: OnboardingStatus;
  tenantId: Scalars['String']['output'];
  tenantName: Scalars['String']['output'];
  /** Model tokens spent on this onboarding */
  tokensUsed: Scalars['Int']['output'];
};

export type OnboardingGateItemType = {
  __typename?: 'OnboardingGateItemType';
  need: Scalars['String']['output'];
  question: DiscoveryQuestion;
};

export type OnboardingGateType = {
  __typename?: 'OnboardingGateType';
  missing: Array<OnboardingGateItemType>;
  passed: Scalars['Boolean']['output'];
};

/** Status of tenant onboarding process */
export enum OnboardingStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED',
}

/** Current onboarding status for a tenant */
export type OnboardingStatusResponse = {
  __typename?: 'OnboardingStatusResponse';
  /** When onboarding was completed */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** IDs of completed steps */
  completedStepIds: Array<Scalars['String']['output']>;
  /** Number of completed steps */
  completedStepsCount: Scalars['Int']['output'];
  /** Active onboarding config */
  config: OnboardingConfig;
  /** Current step ID */
  currentStep: Scalars['String']['output'];
  /** Whether onboarding is required (blocking app access) */
  isOnboardingRequired: Scalars['Boolean']['output'];
  /** Number of required steps remaining */
  requiredStepsRemaining: Scalars['Int']['output'];
  /** IDs of skipped steps */
  skippedStepIds: Array<Scalars['String']['output']>;
  /** When onboarding was started */
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Current status */
  status: OnboardingStatus;
  /** Total number of steps */
  totalSteps: Scalars['Int']['output'];
};

/** A single onboarding step configuration */
export type OnboardingStep = {
  __typename?: 'OnboardingStep';
  /** Whether user can skip this step */
  canSkip: Scalars['Boolean']['output'];
  /** Step category: required, recommended, or optional */
  category: OnboardingStepCategory;
  /** How to check completion */
  completionCheck: CompletionCheckType;
  /** Criteria for auto-completion */
  completionCriteria?: Maybe<OnboardingCompletionCriteria>;
  /** Step description */
  description?: Maybe<Scalars['String']['output']>;
  /** Icon name for frontend display */
  icon?: Maybe<Scalars['String']['output']>;
  /** Unique step identifier */
  id: Scalars['String']['output'];
  /** Whether this step is enabled */
  isEnabled: Scalars['Boolean']['output'];
  /** Display order (1-based) */
  order: Scalars['Int']['output'];
  /** Display title */
  title: Scalars['String']['output'];
};

/** Category of an onboarding step */
export enum OnboardingStepCategory {
  Optional = 'OPTIONAL',
  Recommended = 'RECOMMENDED',
  Required = 'REQUIRED',
}

/** Record of a completed onboarding step */
export type OnboardingStepCompletion = {
  __typename?: 'OnboardingStepCompletion';
  /** When the step was completed */
  completedAt: Scalars['DateTime']['output'];
  /** User who completed the step */
  completedBy: Scalars['String']['output'];
  /** Whether the step was skipped */
  skipped: Scalars['Boolean']['output'];
  /** Step identifier */
  stepId: Scalars['String']['output'];
};

export enum OnboardingTourAction {
  Back = 'BACK',
  Goto = 'GOTO',
  Next = 'NEXT',
  Pause = 'PAUSE',
  Resume = 'RESUME',
  Skip = 'SKIP',
}

/** Where a tour step stands; a step left without its action is VIEWED, not DONE */
export enum OnboardingTourStepStatus {
  Done = 'DONE',
  Pending = 'PENDING',
  Skipped = 'SKIPPED',
  Viewed = 'VIEWED',
}

export type OnboardingTourStepType = {
  __typename?: 'OnboardingTourStepType';
  key: Scalars['String']['output'];
  /** The one thing the step offers to do */
  offer: Scalars['String']['output'];
  /** The dashboard page the step opens */
  route: Scalars['String']['output'];
  status: OnboardingTourStepStatus;
  title: Scalars['String']['output'];
};

/** The guided tour after the trial is confirmed */
export type OnboardingTourType = {
  __typename?: 'OnboardingTourType';
  complete: Scalars['Boolean']['output'];
  count: Scalars['Int']['output'];
  /** The step the tour is on; null once complete */
  currentKey?: Maybe<Scalars['String']['output']>;
  paused: Scalars['Boolean']['output'];
  /** 1-based position of the current step; 0 once complete */
  position: Scalars['Int']['output'];
  steps: Array<OnboardingTourStepType>;
};

export type OneOffDiscountInput = {
  durationCount?: InputMaybe<Scalars['Int']['input']>;
  durationType: DiscountDurationType;
  name: Scalars['String']['input'];
  type: DiscountType;
  /** Percentage, or fixed amount in the subscription's locked currency. Non-negative. */
  value: Scalars['Float']['input'];
};

export type Organization = {
  __typename?: 'Organization';
  /** Get all variable limits as a JSON string with current base totals */
  allVariableLimits: Scalars['String']['output'];
  billingAddress?: Maybe<Scalars['String']['output']>;
  /** Company registration number. */
  companyNumber?: Maybe<Scalars['String']['output']>;
  contracts?: Maybe<Array<OrganizationContract>>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  /** When the customer-success status last changed. */
  csLifecycleChangedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Customer-success lifecycle status; null until set. */
  csLifecycleStatus?: Maybe<CsLifecycleStatus>;
  /** Customer-success manager (an active member). Not the account owner. */
  csmUserId?: Maybe<Scalars['ID']['output']>;
  /** Get the current limit for any variable type from base plan configuration */
  currentVariableLimit: Scalars['Float']['output'];
  /** Filled-in custom fields, by field key (`customFieldDefinitions`). */
  customFieldValues: Array<CustomFieldValue>;
  description?: Maybe<Scalars['String']['output']>;
  /** Normalized primary web domain (CRM dedup key). */
  domain?: Maybe<Scalars['String']['output']>;
  /** Further hosts whose addresses belong to this client, beyond the website domain — for a company that serves its site from one host and sends mail from another. Bare lowercase hosts. Contact suggestions match on these as well as on `domain`. */
  emailDomains: Array<Scalars['String']['output']>;
  enrichment?: Maybe<CrmEnrichment>;
  /** Caller-supplied external reference for this client, unique per tenant. Lets another system store its own id and look the client up later. */
  externalId?: Maybe<Scalars['String']['output']>;
  featureFlags?: Maybe<Array<OrganizationFeatureFlag>>;
  id: Scalars['ID']['output'];
  incubatorId?: Maybe<Scalars['String']['output']>;
  /** Free-text industry / sector (CRM). */
  industry?: Maybe<Scalars['String']['output']>;
  /** Prefix for this client's invoice numbers (e.g. ACME yields ACME-00042). Unique per tenant; derived from the client name when not set explicitly. */
  invoicePrefix?: Maybe<Scalars['String']['output']>;
  isTrialActive: Scalars['Boolean']['output'];
  /** Registered name of the legal entity. */
  legalName?: Maybe<Scalars['String']['output']>;
  /** Legal form (SRL, Ltd, GmbH, LLC, …), as written. */
  legalStructure?: Maybe<Scalars['String']['output']>;
  /** Relationship funnel stage. Defaults to CLIENT for billing-created orgs. */
  lifecycleStage: CrmLifecycleStage;
  /** The linked tenant entity (populated when queried) */
  linkedTenant?: Maybe<Tenant>;
  /** Links to a managed tenant (used in Master tenant for client management) */
  linkedTenantId?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  /** Sequence number to use on this client's next generated invoice. Set it when onboarding a client that already has invoice history elsewhere. It is consumed the first time an invoice is generated (numbering then continues on its own) and reads back as null after that. */
  nextInvoiceNumber?: Maybe<Scalars['Int']['output']>;
  /** Account owner (rep) user id. */
  ownerUserId?: Maybe<Scalars['ID']['output']>;
  /** Payment terms in days for invoices sent to this client. Overrides the tenant default when set; null means inherit from tenant. */
  paymentTermsDays?: Maybe<Scalars['Int']['output']>;
  /** Set at import time when this client was created despite a similarly-named existing client. Points at the suspected original for reviewer confirmation or merge. */
  potentialDuplicateOfId?: Maybe<Scalars['ID']['output']>;
  /** An existing customer only now added to Revvly: its first subscription counts as a renewal, not a new acquisition. Null means false. */
  preExistingCustomer?: Maybe<Scalars['Boolean']['output']>;
  region?: Maybe<Region>;
  regionId: Scalars['String']['output'];
  /** Per-period override of the tenant's renewal-invoice lead time. Each period null inherits the tenant default. */
  renewalInvoiceLeadDays?: Maybe<OrganizationRenewalInvoiceLeadDays>;
  source?: Maybe<LeadSource>;
  subscriptions?: Maybe<Array<OrganizationSubscription>>;
  /** Tags on this client (`crmTags`). */
  tagIds: Array<Scalars['ID']['output']>;
  taxId?: Maybe<Scalars['String']['output']>;
  /** The tenant this organization belongs to */
  tenantId: Scalars['String']['output'];
  trialEndDate?: Maybe<Scalars['DateTime']['output']>;
  trialStartDate?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
  /** How metered usage is expected to reach Revvly for this client: API (an integration increments it through the period) or MANUAL (an operator enters a value at period end). Null inherits the API default; overridable per component on the subscription. */
  usageCaptureMode?: Maybe<UsageCaptureMode>;
};

export type OrganizationCurrentVariableLimitArgs = {
  variableType: Scalars['String']['input'];
};

export type OrganizationConnection = {
  __typename?: 'OrganizationConnection';
  edges: Array<OrganizationEdge>;
  filteredCount: Scalars['Int']['output'];
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type OrganizationContact = {
  __typename?: 'OrganizationContact';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  /** Filled-in custom fields, by field key (`customFieldDefinitions`). */
  customFieldValues: Array<CustomFieldValue>;
  email?: Maybe<Scalars['String']['output']>;
  emailConsent: CrmEmailConsent;
  enrichment?: Maybe<CrmEnrichment>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isPrimary: Scalars['Boolean']['output'];
  labels: Array<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  /** Relationship funnel stage, independent of the org stage. */
  lifecycleStage: CrmLifecycleStage;
  notes?: Maybe<Scalars['String']['output']>;
  /** The prospect, client, or company this contact belongs to. */
  organization?: Maybe<Organization>;
  /** Owning company, or null for a standalone contact. */
  organizationId?: Maybe<Scalars['String']['output']>;
  ownerUserId?: Maybe<Scalars['ID']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  /** Structured roles: finance, operations, champion, executive, technical, or one the workspace defined (`contactRoles`). */
  roles: Array<Scalars['String']['output']>;
  secondaryEmails: Array<Scalars['String']['output']>;
  source?: Maybe<LeadSource>;
  /** Prospects or clients this standalone contact's email domain matches. Empty when the contact already belongs to a company, or when there is no usable match. */
  suggestedOrganizations: Array<ContactOrganizationSuggestion>;
  /** Tags on this contact (`crmTags`). */
  tagIds: Array<Scalars['ID']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type OrganizationContactConnection = {
  __typename?: 'OrganizationContactConnection';
  edges: Array<OrganizationContactEdge>;
  filteredCount: Scalars['Int']['output'];
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type OrganizationContactCursorPaginationInput = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type OrganizationContactEdge = {
  __typename?: 'OrganizationContactEdge';
  cursor: Scalars['String']['output'];
  node: OrganizationContact;
  /** Which field matched, when the list was searched */
  searchMatch?: Maybe<SearchMatchInfo>;
};

export type OrganizationContactFilter = {
  createdBy?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lifecycleStage?: InputMaybe<CrmLifecycleStage>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  ownerUserId?: InputMaybe<Scalars['ID']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  /** Only contacts holding this role */
  role?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  /** Narrow `search` to these field groups; every field when empty */
  searchFields?: InputMaybe<Array<SearchField>>;
};

/** People at a client's or prospect's email domain who are not yet contacts of it. */
export type OrganizationContactSuggestions = {
  __typename?: 'OrganizationContactSuggestions';
  /** The domain suggestions were matched on, or null when the record has none usable (no domain, or a consumer mailbox provider like gmail.com, where every address at the domain is a stranger). */
  domain?: Maybe<Scalars['String']['output']>;
  /** Every host that was matched, the website domain first, then any hosts linked to the record. Empty when none is usable. A client that serves its site from one host and sends mail from another is matched on both, and the panel names them rather than leaving the operator to wonder where a suggestion came from. */
  domains: Array<Scalars['String']['output']>;
  suggestions: Array<SuggestedContact>;
  /** Hosts this record's own contacts already use that it does not match on yet. Empty when every contact sits on a domain the record already carries. */
  unlinkedDomains: Array<UnlinkedContactDomain>;
};

export type OrganizationContract = {
  __typename?: 'OrganizationContract';
  /** Sub-processor and breach terms. Null: not recorded yet. */
  clauses?: Maybe<ContractClauses>;
  contractType: ContractType;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /** What this contract says happens to the uninvoiced remainder if the client leaves the committed term early. A default for a cancellation, not the answer — the cancel mutation may override it. Null means the contract does not say, and a cancellation inside a committed term with money on it must then state a policy itself. */
  earlyTerminationPolicy?: Maybe<EarlyTerminationPolicy>;
  /** startsAt + termMonths. Stored rather than derived so a window query is cheap. */
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  filePath?: Maybe<Scalars['String']['output']>;
  fileSize?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  mimeType?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** Days of notice required. Meaningful only when renewalTerms is NOTICE_DAYS. */
  noticeDays?: Maybe<Scalars['Int']['output']>;
  organization?: Maybe<Organization>;
  organizationId: Scalars['String']['output'];
  /** What happens at the end of the committed term. Governs the commitment boundary only — ordinary period boundaries inside the term stay with the subscription's autoRenew flag. It narrows the renewal rather than replacing autoRenew: a contract can stop or gate a renewal, never force one. */
  renewalTerms: ContractRenewalTerms;
  /** When the agreement was signed. Distinct from startsAt: a contract signed in January for a March go-live is normal, and only startsAt anchors the committed term. */
  signedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The client document this record was read from. */
  sourceDocumentId?: Maybe<Scalars['ID']['output']>;
  /** When the committed term begins. Independent of any subscription's startDate — a contract signed in January for a March go-live is normal, and attaching one never moves a subscription's service or invoice dates. */
  startsAt?: Maybe<Scalars['DateTime']['output']>;
  status: ContractStatus;
  /** Subscriptions this contract covers. One contract may cover many, but a subscription takes its committed term from exactly one contract — commitmentEndDate must have a single source. */
  subscriptionIds: Array<Scalars['ID']['output']>;
  /** Months the commitment runs. NULL MEANS EVERGREEN — no committed span, which is the honest shape for an MSA. This is the field that separates the committed term from the billing cadence: "annual commitment paid monthly" is termMonths 12 with period MONTHLY. */
  termMonths?: Maybe<Scalars['Int']['output']>;
  /** Completed committed terms — 0 until an AUTO_RENEW commitment first rolls. endsAt is startsAt + termMonths × (termsElapsed + 1), so the signing date never moves and "which year of this contract are we in" stays answerable. Advanced by the renewal processor when a period boundary crosses the commitment end. */
  termsElapsed: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uploadedAt?: Maybe<Scalars['DateTime']['output']>;
  uploadedBy?: Maybe<Scalars['String']['output']>;
};

/** A client's or prospect's Drive folder, as the record page shows it. */
export type OrganizationDriveFolder = {
  __typename?: 'OrganizationDriveFolder';
  /** The current user may create, link, move or unlink this folder. */
  canManage: Scalars['Boolean']['output'];
  counts: DriveSyncCounts;
  /** Client folders are enabled for the workspace. */
  featureEnabled: Scalars['Boolean']['output'];
  folderId?: Maybe<Scalars['String']['output']>;
  folderName?: Maybe<Scalars['String']['output']>;
  lastError?: Maybe<Scalars['String']['output']>;
  /** CLIENT, PROSPECT, LEAD or DISQUALIFIED. */
  lifecycleStage: Scalars['String']['output'];
  linkedAt?: Maybe<Scalars['DateTime']['output']>;
  mode?: Maybe<DriveFolderMode>;
  move: DriveFolderMoveState;
  organizationId: Scalars['ID']['output'];
  organizationName: Scalars['String']['output'];
  /** The "Create folder / Link existing / Not now" prompt (Ask policy). */
  promptVisible: Scalars['Boolean']['output'];
  /** Sync is running (not paused or disconnected). */
  running: Scalars['Boolean']['output'];
  state: DriveFolderState;
  status?: Maybe<DriveFolderLinkStatus>;
  webViewLink?: Maybe<Scalars['String']['output']>;
};

export type OrganizationEdge = {
  __typename?: 'OrganizationEdge';
  cursor: Scalars['String']['output'];
  node: Organization;
  /** Which field matched, when the list was searched */
  searchMatch?: Maybe<SearchMatchInfo>;
};

export type OrganizationEmailBackfillResult = {
  __typename?: 'OrganizationEmailBackfillResult';
  /** Contact addresses searched. */
  addressesChecked: Scalars['Int']['output'];
  /** Contact addresses beyond the per-run limit, left for another run. */
  addressesNotChecked: Scalars['Int']['output'];
  /** Messages found that were already stored. */
  alreadyStored: Scalars['Int']['output'];
  failed: Scalars['Int']['output'];
  /** Messages newly stored. */
  imported: Scalars['Int']['output'];
  /** A limit was reached or a mailbox failed, so another run may find more. */
  incomplete: Scalars['Boolean']['output'];
  /** Distinct Gmail mailboxes that were searched. */
  mailboxesSearched: Scalars['Int']['output'];
  /** The requester has no Gmail mailbox that could be searched. */
  noMailbox: Scalars['Boolean']['output'];
  /** The mailbox service is not configured or does not support this yet. */
  unavailable: Scalars['Boolean']['output'];
};

export type OrganizationFeatureFlag = {
  __typename?: 'OrganizationFeatureFlag';
  assignedAt: Scalars['DateTime']['output'];
  assignedBy?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  featureFlag: FeatureFlag;
  featureFlagId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  organization: Organization;
  organizationId: Scalars['String']['output'];
  removedAt?: Maybe<Scalars['DateTime']['output']>;
  source: FeatureFlagSource;
  sourceId?: Maybe<Scalars['String']['output']>;
  /** The tenant this flag belongs to */
  tenantId: Scalars['String']['output'];
};

export type OrganizationFilter = {
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  csLifecycleStatus?: InputMaybe<CsLifecycleStatus>;
  csmUserId?: InputMaybe<Scalars['ID']['input']>;
  /** Only records whose custom fields hold these values; every entry must match. A field you may not see cannot be filtered on. */
  customFields?: InputMaybe<Array<CustomFieldFilterValueInput>>;
  includeAllLifecycleStages?: InputMaybe<Scalars['Boolean']['input']>;
  isTrialActive?: InputMaybe<Scalars['Boolean']['input']>;
  lifecycleStage?: InputMaybe<CrmLifecycleStage>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Only clients with no customer-success manager. */
  noCsm?: InputMaybe<Scalars['Boolean']['input']>;
  ownerUserId?: InputMaybe<Scalars['ID']['input']>;
  regionId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  /** Narrow `search` to these field groups; every field when empty */
  searchFields?: InputMaybe<Array<SearchField>>;
  /** Only records carrying at least one of these tags. */
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Per-client override of the tenant's renewal-invoice lead time, per billing period. A null period inherits the tenant default; 0 disables advance invoicing for that period. */
export type OrganizationRenewalInvoiceLeadDays = {
  __typename?: 'OrganizationRenewalInvoiceLeadDays';
  /** Days before renewal to invoice MONTHLY subscriptions (null = inherit tenant) */
  monthly?: Maybe<Scalars['Int']['output']>;
  /** Days before renewal to invoice QUARTERLY subscriptions (null = inherit tenant) */
  quarterly?: Maybe<Scalars['Int']['output']>;
  /** Days before renewal to invoice YEARLY subscriptions (null = inherit tenant) */
  yearly?: Maybe<Scalars['Int']['output']>;
};

export type OrganizationSubscription = {
  __typename?: 'OrganizationSubscription';
  /** The end of a PREPAID_TERM span still running past both now and the current period, or null. Non-null means `changeSubscriptionPlan(timing: MID_CYCLE_PRORATED)` requires prepaidSpanChange and is refused without it — proration alone would charge the price difference for the current period only, because every remaining prepaid period bills nothing. Read this before offering an immediate plan change rather than letting the operator discover the refusal after choosing a new plan; it is the modal's cue to ask. */
  activePrepaidSpanEnd?: Maybe<Scalars['DateTime']['output']>;
  /** Per-subscription base ARR in the tenant's reporting currency, derived from the billed period cost (basePrice × 12 for MONTHLY, × 4 for QUARTERLY, × 1 for YEARLY). Prefer this over mrrInReportingCurrency × 12. Null when the subscription isn't currently active by date, or when conversion fails. */
  arrInReportingCurrency?: Maybe<Scalars['Float']['output']>;
  autoRenew: Scalars['Boolean']['output'];
  basePrice: Scalars['Decimal']['output'];
  /** Subscription base price converted to the tenant's reporting currency */
  basePriceInReportingCurrency?: Maybe<Scalars['Float']['output']>;
  /** Present when the base price was deliberately overridden away from the catalog list price (PRD §7.4). Null = the subscription inherits the catalog price. */
  basePriceOverride?: Maybe<BasePriceOverride>;
  /** Day of the month this subscription bills on (1–31). Term boundaries clamp to the last day of a month too short to hold it — a subscription anchored on the 31st ends its February period on the 28th and returns to the 31st in March. Null on subscriptions predating the field, where the day of the current period end is used instead. */
  billingAnchorDay?: Maybe<Scalars['Int']['output']>;
  /** Bundle included in this subscription */
  bundle?: Maybe<Bundle>;
  /** Pinned Bundle document _id. Mutually exclusive with moduleId. */
  bundleId?: Maybe<Scalars['String']['output']>;
  /** Pinned Bundle version number. */
  bundleVersion?: Maybe<Scalars['Int']['output']>;
  /** When a cancellation the client is committed past actually takes effect. Set only by a CONTINUE_BILLING early termination: the subscription stays ACTIVE and keeps billing period by period to the end of the committed term, then ends here rather than rolling into another term. Deliberately not cancelledAt — a subscription still being billed is not cancelled yet. */
  cancellationEffectiveDate?: Maybe<Scalars['DateTime']['output']>;
  /** Timestamp when the subscription was cancelled */
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  /** The end of the COMMITTED TERM, copied from the attached contract. Distinct from endDate, which is the current billing period boundary and moves on every renewal: a 12-month commitment billed monthly has twelve endDates inside one commitmentEndDate. Eleven of those are ordinary boundaries the cron advances through; the twelfth is where the contract's renewalTerms decides what happens next. Derived — set by attaching a contract, never authored directly. */
  commitmentEndDate?: Maybe<Scalars['DateTime']['output']>;
  /** What ending this subscription early would leave uninvoiced, when anything would. Null means there is nothing to settle — no commitment, a commitment already invoiced, or one that is not BINDING. Non-null means cancelSubscription needs an earlyTermination policy. */
  committedTermExposure?: Maybe<CommittedTermExposure>;
  /** The contract this subscription is sold under, when one is attached. At most one: commitmentEndDate is derived from its term, and two contracts each carrying a term for one subscription would leave the commitment boundary with no single source. One contract may cover many subscriptions. */
  contractId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  /** The user who created this subscription. Null for imports and system-created rows. */
  createdByUser?: Maybe<ActorSummary>;
  currency: Scalars['String']['output'];
  /** How multiple discount instances on the same target compose (Flexible Discounting §8.7). Default COMBINE. */
  discountStackingMode?: Maybe<DiscountStackingMode>;
  /** Discounts on this subscription (every status, oldest first) as display-ready line items: name and source, target, value, how many billing periods it has applied to and how many remain, when it started, and the estimated value per period (Flexible Discounting §8.5). */
  discounts: Array<SubscriptionDiscountLine>;
  documents?: Maybe<Array<SubscriptionDocument>>;
  endDate: Scalars['DateTime']['output'];
  /** Date the exchange rate was looked up for */
  exchangeRateDate?: Maybe<Scalars['DateTime']['output']>;
  /** Exchange rate used for conversion (originalCurrency → currency) */
  exchangeRateUsed?: Maybe<Scalars['Float']['output']>;
  /** Lineage ids of auto-include Variable Components excluded from this subscription via excludeVariableComponentFromSubscription (the variable-component subscription override). Re-include one with reincludeVariableComponentOnSubscription. */
  excludedComponentLineageIds: Array<Scalars['ID']['output']>;
  expansions?: Maybe<Array<SubscriptionExpansion>>;
  /** Customer-supplied external reference (unique per tenant). Use as `externalSubscriptionId` when reporting usage to avoid storing Revvly internal IDs. */
  externalId?: Maybe<Scalars['String']['output']>;
  /** Number of days for grace period after expiration */
  gracePeriodDays?: Maybe<Scalars['Int']['output']>;
  /** End date of the grace period */
  gracePeriodEndDate?: Maybe<Scalars['DateTime']['output']>;
  /** True when moduleVersion or bundleVersion is behind the current published version. */
  hasOutdatedComponents: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  invoices?: Maybe<Array<SubscriptionInvoice>>;
  /** Timestamp of the last auto-renewal attempt */
  lastAutoRenewalAt?: Maybe<Scalars['DateTime']['output']>;
  /** Result of the last auto-renewal attempt (SUCCESS or error message) */
  lastAutoRenewalResult?: Maybe<Scalars['String']['output']>;
  /** Whether this subscription's plan pin is behind the published head ON PURPOSE, and why. Read the pair with `stalePins`: that says the pin is behind, this says whether that is a decision. A grandfathered client is a contract to honour — surface the reason, not a migrate prompt. False for a subscription with no pin history (imported before the timeline existed), which is the safe direction: a genuinely neglected pin stays visible. */
  legacyPin: LegacyPin;
  /** ISO 4217 currency locked at subscription creation. */
  lockedCurrency?: Maybe<Scalars['String']['output']>;
  /** Pinned Module document _id. Mutually exclusive with bundleId. */
  moduleId?: Maybe<Scalars['String']['output']>;
  /** Pinned Module version number. */
  moduleVersion?: Maybe<Scalars['Int']['output']>;
  /** Modules included in this subscription */
  modules?: Maybe<Array<Module>>;
  /** Per-subscription MRR in the tenant's reporting currency. Null when the subscription isn't currently active by date. */
  mrrInReportingCurrency?: Maybe<Scalars['Float']['output']>;
  /** Per-subscription net (effective) ARR in the tenant's reporting currency — the year summed period-by-period after discounts, netting each discount only for the periods it is still active. Equals arrInReportingCurrency when no discount is active — never mrrInReportingCurrency × 12, which re-annualizes an already-rounded monthly figure. Null when the subscription isn't currently active by date, or when conversion fails. */
  netArrInReportingCurrency?: Maybe<Scalars['Float']['output']>;
  /** Upcoming billing periods valued at list price and net of the discounts active for each period (index 0 = the invoice at nextRenewalDate). Null when the subscription is not currently active by date, or when conversion fails. */
  netCashFlowProjection?: Maybe<Array<SubscriptionCashFlowPeriod>>;
  /** Per-subscription net (effective) MRR in the tenant's reporting currency — this period's revenue after the discounts active now. Equals mrrInReportingCurrency when no discount is active. Null when the subscription isn't currently active by date, or when conversion fails. */
  netMrrInReportingCurrency?: Maybe<Scalars['Float']['output']>;
  /** Per-subscription net run-rate ARR in the tenant's reporting currency — the current period's revenue after the discounts active now, annualized by the billing cadence. The annual twin of netMrrInReportingCurrency; prefer it over netMrrInReportingCurrency × 12, which re-annualizes an already-rounded monthly figure. Unlike netArrInReportingCurrency this holds the current discount for the whole year instead of projecting twelve periods. Null when the subscription isn't currently active by date, or when conversion fails. */
  netRunRateArrInReportingCurrency?: Maybe<Scalars['Float']['output']>;
  nextRenewalDate?: Maybe<Scalars['DateTime']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  organizationId: Scalars['String']['output'];
  /** Original amount before currency conversion */
  originalAmount?: Maybe<Scalars['Decimal']['output']>;
  /** Original currency code before conversion */
  originalCurrency?: Maybe<Scalars['String']['output']>;
  /** Migration queued for the next renewal, if any. */
  pendingMigration?: Maybe<PendingMigration>;
  period: SubscriptionPeriod;
  /** The plan this subscription was pinned to at `asOf`, folded out of its pin history. Answers "what was this client on in March 2024" without the caller walking the entries or knowing which catalog documents were current then. Null when `asOf` precedes the subscription's first entry. A change that is only SCHEDULED for the next renewal is not in force and is not reported. */
  pinStateAt?: Maybe<SubscriptionVersionEntryState>;
  /** This client's plan history: which plan they were on, and when. Periods are derived — each runs until the next begins — so they cannot disagree with the entries they come from. Prefer this over folding `versionHistory` client-side: a change only SCHEDULED for the next renewal is not a period the client has been on, and getting that wrong reports them on a plan they have not moved to for the whole window until the renewal lands. */
  planTimeline: SubscriptionPlanTimeline;
  /** How basePrice was composed. Null on legacy/imported subscriptions. */
  priceBreakdown?: Maybe<SubscriptionPriceBreakdown>;
  /** Confidence score of AI product match (0-1) */
  productMatchConfidence?: Maybe<Scalars['Float']['output']>;
  /** AI reasoning for the product match */
  productMatchReasoning?: Maybe<Scalars['String']['output']>;
  /** Status of AI product matching */
  productMatchStatus?: Maybe<ProductMatchStatus>;
  renewalConfirmed: Scalars['Boolean']['output'];
  /** Renewal status information including days until renewal/cancellation and early cancellation details */
  renewalInfo: RenewalInfo;
  /** How far the BASE charge has already been invoiced. A renewal whose period ends on or before this date bills no base line — the money is already in AR. Set by advance invoicing (renewalInvoiceLeadDays) and by a prepaid span, and only ever moved forward. Read it to tell "this renewal will bill nothing" from "this renewal will bill the plan". */
  renewalInvoicedThroughDate?: Maybe<Scalars['DateTime']['output']>;
  /** The tenant's reporting currency */
  reportingCurrency?: Maybe<Scalars['String']['output']>;
  /** What this subscription is (or was) worth per month in the tenant's reporting currency, valued at the nearest instant it was live. Unlike mrrInReportingCurrency this is NOT gated on the subscription being revenue-generating now, so an ended contract still reports a figure. Because of that a column of these does not sum to the portfolio MRR — use the gated fields for any aggregate. */
  runRate?: Maybe<SubscriptionRunRate>;
  /** Pins whose entity has a newer published version than the pinned one. */
  stalePins: Array<StalePin>;
  startDate: Scalars['DateTime']['output'];
  status: SubscriptionStatus;
  /** Type of subscription: acquisition, renewal, or expansion */
  subscriptionType: SubscriptionType;
  /** The tenant this subscription belongs to */
  tenantId: Scalars['String']['output'];
  /** When the trial converted to a paid subscription. Null until it does. */
  trialConvertedAt?: Maybe<Scalars['DateTime']['output']>;
  /** When the free trial ends and the first period is invoiced. While status is TRIAL nothing is billed and nothing counts as revenue. Null when there was no trial. */
  trialEndsAt?: Maybe<Scalars['DateTime']['output']>;
  /** When the free trial began. Kept because conversion moves startDate to the day paid service starts. Null when the subscription never had a trial. */
  trialStartedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  /** Per-subscription ARR from variable/usage components, in the tenant's reporting currency. Prefer this over variableMrrInReportingCurrency × 12. Null when the subscription isn't currently active by date or has no variable components. */
  variableArrInReportingCurrency?: Maybe<Scalars['Float']['output']>;
  /** All resolved variable component pins — from parent Module/Bundle and direct refs. */
  variableComponentRefs: Array<SubscriptionVariableComponentRef>;
  /** Per-subscription monthly recurring revenue from variable/usage components, in the tenant's reporting currency. Null when the subscription isn't currently active by date or has no variable components. */
  variableMrrInReportingCurrency?: Maybe<Scalars['Float']['output']>;
  /** Append-only history of pin changes: INITIAL_PIN at creation, then every migration / add/remove component / subscription-scoped price change / cancellation. */
  versionHistory: Array<SubscriptionVersionEntry>;
};

export type OrganizationSubscriptionNetCashFlowProjectionArgs = {
  periods?: Scalars['Int']['input'];
};

export type OrganizationSubscriptionPinStateAtArgs = {
  asOf: Scalars['DateTime']['input'];
};

/** One message the product tried to deliver */
export type OutboundMessage = {
  __typename?: 'OutboundMessage';
  attempts: Scalars['Int']['output'];
  category: NotificationCategory;
  /** Named channel, for a channel post */
  channelTarget?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  priority: NotificationPriority;
  /** Auth id of the recipient */
  recipientUserId?: Maybe<Scalars['String']['output']>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  status: OutboundMessageStatus;
  /** Why it was skipped or failed, in words an admin can act on */
  statusReason?: Maybe<Scalars['String']['output']>;
  /** What this template is, so the log reads without a lookup */
  templateDescription?: Maybe<Scalars['String']['output']>;
  templateKey: Scalars['String']['output'];
};

export enum OutboundMessageStatus {
  Collapsed = 'COLLAPSED',
  Failed = 'FAILED',
  Queued = 'QUEUED',
  Sent = 'SENT',
  SkippedMuted = 'SKIPPED_MUTED',
  SkippedSuppressed = 'SKIPPED_SUPPRESSED',
  SkippedUnmapped = 'SKIPPED_UNMAPPED',
}

export type OutboundWebhookBackfillOutcome = {
  __typename?: 'OutboundWebhookBackfillOutcome';
  /** Pass as `after` to send the next batch. Null when everything has been queued. */
  nextCursor?: Maybe<Scalars['ID']['output']>;
  queued: Scalars['Int']['output'];
  /** True when there were more records than one backfill sends. */
  truncated: Scalars['Boolean']['output'];
};

export type OutboundWebhookDelivery = {
  __typename?: 'OutboundWebhookDelivery';
  attempts: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  deliveredAt?: Maybe<Scalars['DateTime']['output']>;
  endpointId: Scalars['ID']['output'];
  /** The event id sent in the body. Stable across retries. */
  eventId: Scalars['String']['output'];
  eventType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastError?: Maybe<Scalars['String']['output']>;
  lastStatusCode?: Maybe<Scalars['Int']['output']>;
  nextAttemptAt: Scalars['DateTime']['output'];
  resourceId?: Maybe<Scalars['String']['output']>;
  status: OutboundWebhookDeliveryStatus;
};

export enum OutboundWebhookDeliveryStatus {
  Cancelled = 'CANCELLED',
  Delivered = 'DELIVERED',
  Failed = 'FAILED',
  Pending = 'PENDING',
}

export type OutboundWebhookEndpoint = {
  __typename?: 'OutboundWebhookEndpoint';
  /** Failed deliveries in a row since the last success. */
  consecutiveFailures: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** Why the endpoint is off when the system switched it off. Null otherwise. */
  disabledReason?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  eventTypes: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastDeliveryAt?: Maybe<Scalars['DateTime']['output']>;
  lastStatusCode?: Maybe<Scalars['Int']['output']>;
  lastSuccessAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  /** Only events from these pipelines are sent. Empty means every pipeline. */
  pipelineIds: Array<Scalars['ID']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
};

export type OutboundWebhookEndpointWithSecret = {
  __typename?: 'OutboundWebhookEndpointWithSecret';
  endpoint: OutboundWebhookEndpoint;
  /** The signing secret. Shown once: it is stored encrypted and cannot be read back. Rotate to get a new one. */
  signingSecret: Scalars['String']['output'];
};

export type OutboundWebhookEventTypeInfo = {
  __typename?: 'OutboundWebhookEventTypeInfo';
  description: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type OverrideBasePriceInput = {
  /** When the new price takes effect (prospective or immediate/prorated). */
  effectiveMode: PriceEffectiveMode;
  /** Free-text reason, recorded in the audit trail (§7.5). */
  reason?: InputMaybe<Scalars['String']['input']>;
  subscriptionId: Scalars['ID']['input'];
  /** New base price to bill. */
  value: Scalars['Float']['input'];
};

export type OverrideBilledQuantityInput = {
  newBilledQuantity: Scalars['Float']['input'];
  /** Original billing_period_snapshot to adjust */
  originalSnapshotId: Scalars['ID']['input'];
  /** Reason for the adjustment — required for audit trail (PRD §21.3) */
  reason: Scalars['String']['input'];
  /** Override unit price; defaults to original */
  unitPriceApplied?: InputMaybe<Scalars['Float']['input']>;
};

export type OverrideComponentBillingTimingInput = {
  /** New billing timing for this component on this subscription. */
  billingTiming: BillingTiming;
  componentId: Scalars['ID']['input'];
  /** Free-text reason, recorded in the audit trail (§7.2 — required). */
  reason: Scalars['String']['input'];
  subscriptionId: Scalars['ID']['input'];
};

export type OverrideComponentCaptureModeInput = {
  /** API or MANUAL. Null clears the override (inherit client default). */
  captureModeOverride?: InputMaybe<UsageCaptureMode>;
  componentId: Scalars['ID']['input'];
  /** Required reason for the audit trail. */
  reason: Scalars['String']['input'];
  subscriptionId: Scalars['ID']['input'];
};

export type OverrideComponentRateInput = {
  /** COMMITTED_OVERAGE: price per committed unit. */
  committedUnitPrice?: InputMaybe<Scalars['Float']['input']>;
  componentId: Scalars['ID']['input'];
  componentVersion: Scalars['Int']['input'];
  effectiveMode: PriceEffectiveMode;
  /** COMMISSION: fixed fee per transaction. */
  fixedFeePerTransaction?: InputMaybe<Scalars['Float']['input']>;
  /** New per-subscription included allowance (count-type). Omit to leave unchanged. */
  includedQuantity?: InputMaybe<Scalars['Int']['input']>;
  /** New per-subscription included allowance (commission-type). Omit to leave unchanged. */
  includedTransactionCount?: InputMaybe<Scalars['Int']['input']>;
  /** COMMISSION: maximum per transaction. */
  maxPerTransaction?: InputMaybe<Scalars['Float']['input']>;
  /** COMMISSION: minimum per transaction. */
  minPerTransaction?: InputMaybe<Scalars['Float']['input']>;
  /** TRUE_OVERAGE: overage price per unit. */
  overageUnitPrice?: InputMaybe<Scalars['Float']['input']>;
  /** COMMITTED_OVERAGE: price per unit above the commitment. */
  overageUnitPriceCommitted?: InputMaybe<Scalars['Float']['input']>;
  /** Free-text reason, recorded in the audit trail (§7.5). */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** STAIRSTEP: one flat fee per step, index-aligned with the component's steps[]. Every step needs a value. */
  stepFees?: InputMaybe<Array<Scalars['Float']['input']>>;
  subscriptionId: Scalars['ID']['input'];
  /** VOLUME_TIERED / GRADUATED_TIERED: one rate per tier, index-aligned with the component's tiers[]. Every tier needs a value. */
  tierPrices?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** FLAT_RATE: new per-unit rate in the subscription's locked currency. Other models use their own field(s) below. */
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type OverwriteDiscountInstanceInput = {
  applyToAdjustments?: InputMaybe<Scalars['Boolean']['input']>;
  /** Remove the unit limit, so every unit is discounted again. */
  clearMaxQuantity?: InputMaybe<Scalars['Boolean']['input']>;
  durationCount?: InputMaybe<Scalars['Int']['input']>;
  durationType?: InputMaybe<DiscountDurationType>;
  fixedMode?: InputMaybe<FixedDiscountMode>;
  instanceId: Scalars['ID']['input'];
  /** New unit limit for a COMPONENT discount. Omit to keep the current one. */
  maxQuantity?: InputMaybe<Scalars['Float']['input']>;
  /** Free-text reason, recorded in the audit trail (§8.14 — required). */
  reason: Scalars['String']['input'];
  /** New percentage / fixed amount. Omit to keep. */
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PaginatedDiscrepanciesOutput = {
  __typename?: 'PaginatedDiscrepanciesOutput';
  next?: Maybe<Scalars['String']['output']>;
  prev?: Maybe<Scalars['String']['output']>;
  results: Array<InvoiceDiscrepancyEntity>;
  totalCount: Scalars['Int']['output'];
};

export type PastDueAccount = {
  __typename?: 'PastDueAccount';
  currency: Scalars['String']['output'];
  daysOverdue: Scalars['Int']['output'];
  organizationId: Scalars['String']['output'];
  organizationName: Scalars['String']['output'];
  overdueInvoiceCount: Scalars['Int']['output'];
  totalOverdueAmount: Scalars['Float']['output'];
};

/** The workspace's Stripe connection, without any secret. */
export type PaymentConnectionView = {
  __typename?: 'PaymentConnectionView';
  /** Charge each issued invoice to the client’s saved card. */
  autoChargeEnabled: Scalars['Boolean']['output'];
  /** Whether invoices can be charged through this connection now. ACTIVE alone is not enough: a Stripe Connect account also needs the platform keys on this deployment. */
  chargeable: Scalars['Boolean']['output'];
  connectedAt?: Maybe<Scalars['DateTime']['output']>;
  disconnectReason?: Maybe<Scalars['String']['output']>;
  livemode: Scalars['Boolean']['output'];
  /** CONNECT (Stripe Connect) or API_KEY (a restricted key). */
  mode: Scalars['String']['output'];
  /** Days after the first decline on which to try again. */
  retryDays: Array<Scalars['Int']['output']>;
  /** PENDING, ACTIVE or DISCONNECTED. */
  status: Scalars['String']['output'];
  stripeAccountId?: Maybe<Scalars['String']['output']>;
};

export type PaymentDueThisWeek = {
  __typename?: 'PaymentDueThisWeek';
  amount: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  daysUntilDue: Scalars['Int']['output'];
  estimatedPaymentDate: Scalars['DateTime']['output'];
  invoiceId: Scalars['String']['output'];
  invoiceNumber: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  organizationName: Scalars['String']['output'];
  paymentStatus: PaymentStatus;
};

export type PaymentReminder = {
  __typename?: 'PaymentReminder';
  attachmentIds?: Maybe<Array<Scalars['ID']['output']>>;
  createdAt: Scalars['DateTime']['output'];
  customBody?: Maybe<Scalars['String']['output']>;
  customSubject?: Maybe<Scalars['String']['output']>;
  emailBody: Scalars['String']['output'];
  emailSubject: Scalars['String']['output'];
  emailTo: Scalars['String']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  includeAttachments?: Maybe<Scalars['Boolean']['output']>;
  invoiceId: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  reminderType: ReminderType;
  sentAt: Scalars['DateTime']['output'];
  sentBy?: Maybe<Scalars['ID']['output']>;
  success: Scalars['Boolean']['output'];
  tenantId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PaymentReminderTemplate = {
  __typename?: 'PaymentReminderTemplate';
  /** Current plain-text body, with {{placeholders}}. */
  body: Scalars['String']['output'];
  defaultBody: Scalars['String']['output'];
  defaultSubject: Scalars['String']['output'];
  /** True when the tenant has edited this template. */
  isCustomized: Scalars['Boolean']['output'];
  kind: PaymentReminderTemplateKind;
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  /** Current subject, with {{placeholders}}. */
  subject: Scalars['String']['output'];
  trigger: PaymentReminderTrigger;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Display name of the last editor. */
  updatedByName?: Maybe<Scalars['String']['output']>;
  /** When the template is used. */
  usage: Scalars['String']['output'];
};

/** One of the fixed payment reminder emails the product sends. */
export enum PaymentReminderTemplateKind {
  AutoDueToday = 'AUTO_DUE_TODAY',
  AutoOverdue_1 = 'AUTO_OVERDUE_1',
  AutoOverdue_7 = 'AUTO_OVERDUE_7',
  AutoOverdue_14 = 'AUTO_OVERDUE_14',
  AutoOverdue_30 = 'AUTO_OVERDUE_30',
  AutoUpcoming = 'AUTO_UPCOMING',
  Final = 'FINAL',
  Friendly = 'FRIENDLY',
  Invoice = 'INVOICE',
  Overdue = 'OVERDUE',
}

export type PaymentReminderTemplatePlaceholder = {
  __typename?: 'PaymentReminderTemplatePlaceholder';
  label: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

/** MANUAL is offered in the send composer; AUTOMATIC is sent by the daily sweep. */
export enum PaymentReminderTrigger {
  Automatic = 'AUTOMATIC',
  Manual = 'MANUAL',
}

/** Payment status */
export enum PaymentStatus {
  Cancelled = 'CANCELLED',
  Failed = 'FAILED',
  Overdue = 'OVERDUE',
  Paid = 'PAID',
  Pending = 'PENDING',
}

export type PaymentTimeAnalytics = {
  __typename?: 'PaymentTimeAnalytics';
  averageDaysToPayment: Scalars['Float']['output'];
  fastestPaymentDays?: Maybe<Scalars['Int']['output']>;
  groupName: Scalars['String']['output'];
  groupType: Scalars['String']['output'];
  onTimePaymentRate: Scalars['Float']['output'];
  slowestPaymentDays?: Maybe<Scalars['Int']['output']>;
  totalInvoicesPaid: Scalars['Int']['output'];
};

export type PaymentsSetupInfo = {
  __typename?: 'PaymentsSetupInfo';
  /** Whether this deployment can offer Stripe Connect. */
  connectAvailable: Scalars['Boolean']['output'];
  connection?: Maybe<PaymentConnectionView>;
};

/** A deferred-activation subscription awaiting go-live. */
export type PendingActivation = {
  __typename?: 'PendingActivation';
  /** When the workspace will be alerted that this deal has not gone live. */
  activationDeadlineAt?: Maybe<Scalars['DateTime']['output']>;
  /** Base price per period, in the subscription's currency — what go-live will start billing. */
  basePrice: Scalars['Decimal']['output'];
  currency: Scalars['String']['output'];
  /** Days past the activation deadline. Negative while still inside the window, so the list sorts worst-first on one field. */
  daysOverdue: Scalars['Int']['output'];
  organizationId: Scalars['ID']['output'];
  /** Client name, for the list. */
  organizationName?: Maybe<Scalars['String']['output']>;
  /** When the deal was signed. */
  signedAt: Scalars['DateTime']['output'];
  subscriptionId: Scalars['ID']['output'];
};

/** Migration queued to take effect at the next renewal (timing = NEXT_RENEWAL). Set by migrateSubscriptionModule/Bundle; cleared by cancelPendingMigration or at renewal. */
export type PendingMigration = {
  __typename?: 'PendingMigration';
  reason?: Maybe<Scalars['String']['output']>;
  scheduledAt: Scalars['DateTime']['output'];
  scheduledBy?: Maybe<Scalars['String']['output']>;
  targetBundleId?: Maybe<Scalars['ID']['output']>;
  targetBundleVersion?: Maybe<Scalars['Int']['output']>;
  targetModuleId?: Maybe<Scalars['ID']['output']>;
  targetModuleVersion?: Maybe<Scalars['Int']['output']>;
  timing: Scalars['String']['output'];
};

/** Per-term price override: the full per-currency variant set for one period. */
export type PeriodPrice = {
  __typename?: 'PeriodPrice';
  period: SubscriptionPeriod;
  pricesByCurrency: Array<PricingVariant>;
};

export type PeriodPriceInput = {
  /** MONTHLY | QUARTERLY | YEARLY (∈ parent availablePeriods). */
  period: SubscriptionPeriod;
  /** At least one variant; overrides the default for this term. */
  pricesByCurrency: Array<PricingVariantInput>;
};

/** One plan change in a subscription's history, recorded as a backdated change so the reconstructed invoices for each period bill the plan in force for that period. The INITIAL plan is the one named by the top-level bundleId / moduleIds — deliberately not repeated here, so there is one source of truth for what the subscription started on. */
export type PinTimelineEntryInput = {
  /** Bundle version pinned from this date. */
  bundleId?: InputMaybe<Scalars['ID']['input']>;
  /** When this change took effect. Must be after the subscription start and in the past, and entries must be in ascending order. */
  effectiveFrom: Scalars['DateTime']['input'];
  /** Module set from this date. */
  moduleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Per-module tier selection for this step. */
  moduleTiers?: InputMaybe<Array<ModuleTierSelectionInput>>;
  /** Why the plan changed at this date. */
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type PipelineStage = {
  __typename?: 'PipelineStage';
  color?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  kind: PipelineStageKind;
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
};

export type PipelineStageInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  kind: PipelineStageKind;
  name: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

/** Pipeline stage kind (drives lead status). */
export enum PipelineStageKind {
  Lost = 'LOST',
  Open = 'OPEN',
  Won = 'WON',
}

export type PipelineStageMappingInput = {
  /** A stage on the pipeline being archived. */
  fromStageId: Scalars['ID']['input'];
  /** The stage on the destination pipeline its deals move to. */
  toStageId: Scalars['ID']['input'];
};

export type PlanBreakdown = {
  __typename?: 'PlanBreakdown';
  arr: Scalars['Float']['output'];
  mrr: Scalars['Float']['output'];
  planId: Scalars['String']['output'];
  planName: Scalars['String']['output'];
  subscriptionCount: Scalars['Int']['output'];
};

export type PlanInfo = {
  __typename?: 'PlanInfo';
  /**
   * Current selected plan for the incubator
   * @deprecated Chat are no longer limited by plan
   */
  chatInfo?: Maybe<ChatInfo>;
  /** Current selected plan for the incubator */
  currentPlan?: Maybe<CurrentPlan>;
  emailCountInfo: EmailCountInfo;
  /** Max number of Employees */
  employeeCountLimit: Scalars['Int']['output'];
  maxFileSize?: Maybe<Scalars['Int']['output']>;
  maxNbEvaluationForms?: Maybe<Scalars['Int']['output']>;
  maxNbEvaluators: Scalars['Int']['output'];
  maxNbFunnels?: Maybe<Scalars['Int']['output']>;
  maxNbIntakeForms?: Maybe<Scalars['Int']['output']>;
  maxNbNetworks: Scalars['Int']['output'];
  maxNbPrograms?: Maybe<Scalars['Int']['output']>;
  maxNbStartups: Scalars['Int']['output'];
};

export type PlanInfoInput = {
  /** Current selected plan for the incubator */
  currentPlan: CurrentPlanInput;
  /** Max number of Employees */
  employeeCountLimit: Scalars['Int']['input'];
};

export type PlanInfoUpdateInput = {
  /**
   * Current selected plan for the incubator
   * @deprecated Chat are no longer limited by plan
   */
  chatInfo?: InputMaybe<ChatInfoUpdateInput>;
  /** Current selected plan for the incubator */
  currentPlan?: InputMaybe<CurrentPlanInput>;
  emailCountInfo?: InputMaybe<EmailCountInfoUpdateInput>;
  /** Max number of Employees */
  employeeCountLimit?: InputMaybe<Scalars['Int']['input']>;
  maxFileSize?: InputMaybe<Scalars['Int']['input']>;
  maxNbEvaluationForms?: InputMaybe<Scalars['Int']['input']>;
  maxNbEvaluators?: InputMaybe<Scalars['Int']['input']>;
  maxNbFunnels?: InputMaybe<Scalars['Int']['input']>;
  maxNbIntakeForms?: InputMaybe<Scalars['Int']['input']>;
  maxNbNetworks?: InputMaybe<Scalars['Int']['input']>;
  maxNbPrograms?: InputMaybe<Scalars['Int']['input']>;
  maxNbStartups?: InputMaybe<Scalars['Int']['input']>;
};

export enum PlanOptions {
  Enterprise = 'enterprise',
  Essential = 'essential',
  Premium = 'premium',
  Starter = 'starter',
  StarterPlus = 'starterPlus',
}

/** One span of a proposed subscription billed at a single price */
export type PlannedPriceSegmentEntity = {
  __typename?: 'PlannedPriceSegmentEntity';
  basePrice: Scalars['Float']['output'];
  /** Catalog bundle version pinned for this span */
  bundleId?: Maybe<Scalars['String']['output']>;
  bundleLineageId?: Maybe<Scalars['String']['output']>;
  bundleVersion?: Maybe<Scalars['Int']['output']>;
  /** First invoice date in this segment */
  from: Scalars['DateTime']['output'];
  invoiceIds: Array<Scalars['String']['output']>;
  /** Catalog module version ids pinned for this span */
  moduleIds: Array<Scalars['String']['output']>;
  /** The pinned version is ARCHIVED — a legitimately grandfathered price, not a stale match */
  pinnedArchived: Scalars['Boolean']['output'];
  /** Last invoice date in this segment */
  to: Scalars['DateTime']['output'];
};

/** One subscription a client’s invoices imply */
export type PlannedSubscriptionEntity = {
  __typename?: 'PlannedSubscriptionEntity';
  /** Reasons this proposal must not be committed as it stands. These gate the commit. */
  blockers: Array<Scalars['String']['output']>;
  /** Stable key from the clustering engine; identifies this proposal across re-plans */
  clusterKey: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  endDate: Scalars['DateTime']['output'];
  invoiceIds: Array<Scalars['String']['output']>;
  /** Worth a reviewer’s attention; does not gate the commit */
  notes: Array<Scalars['String']['output']>;
  period: SubscriptionPeriod;
  /** Oldest first */
  segments: Array<PlannedPriceSegmentEntity>;
  startDate: Scalars['DateTime']['output'];
  /** ACQUISITION, EXPANSION or RENEWAL — decidable because the planner sees the client’s whole history at once, unlike the row-by-row importer whose answer depends on file order */
  subscriptionType: SubscriptionType;
};

export type PlatformBillingAddOn = {
  __typename?: 'PlatformBillingAddOn';
  available: Scalars['Boolean']['output'];
  code: Scalars['String']['output'];
  features: Array<TenantFeature>;
  moduleId: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type PlatformBillingAddOnInput = {
  available: Scalars['Boolean']['input'];
  code: Scalars['String']['input'];
  features: Array<TenantFeature>;
  moduleId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type PlatformBillingConfig = {
  __typename?: 'PlatformBillingConfig';
  addOns: Array<PlatformBillingAddOn>;
  collectCardAtSignup: Scalars['Boolean']['output'];
  defaultRegionId?: Maybe<Scalars['String']['output']>;
  dunning: PlatformBillingDunning;
  grantableFeatures: Array<TenantFeature>;
  /** Interim: an onboarding on a workspace with no Master subscription grants the chosen plan's features directly */
  interimTrialGrant: Scalars['Boolean']['output'];
  plans: Array<PlatformBillingPlan>;
  regions: Array<PlatformBillingRegion>;
  seatComponentId?: Maybe<Scalars['String']['output']>;
  seatMetricSlug: Scalars['String']['output'];
  signupEnabled: Scalars['Boolean']['output'];
  trialDays: Scalars['Int']['output'];
};

export type PlatformBillingDunning = {
  __typename?: 'PlatformBillingDunning';
  retryDays: Array<Scalars['Int']['output']>;
  suspendAfterDays: Scalars['Int']['output'];
};

export type PlatformBillingDunningInput = {
  retryDays: Array<Scalars['Int']['input']>;
  suspendAfterDays: Scalars['Int']['input'];
};

export type PlatformBillingPlan = {
  __typename?: 'PlatformBillingPlan';
  available: Scalars['Boolean']['output'];
  /** The Master bundle the plan sells */
  bundleId?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  features: Array<TenantFeature>;
  includedSeats: Scalars['Int']['output'];
  /** Or the Master module the plan sells (one of the two) */
  moduleId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type PlatformBillingPlanInput = {
  available: Scalars['Boolean']['input'];
  /** The Master bundle the plan sells */
  bundleId?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  features: Array<TenantFeature>;
  includedSeats: Scalars['Int']['input'];
  /** Or the Master module the plan sells (one of the two) */
  moduleId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type PlatformBillingRegion = {
  __typename?: 'PlatformBillingRegion';
  countries: Array<Scalars['String']['output']>;
  regionId: Scalars['String']['output'];
};

export type PlatformBillingRegionInput = {
  countries: Array<Scalars['String']['input']>;
  regionId: Scalars['String']['input'];
};

export type PlatformIncident = {
  __typename?: 'PlatformIncident';
  /** The part of Revvly affected. */
  component?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** Public, shown under the title. */
  message?: Maybe<Scalars['String']['output']>;
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Pass it back when editing or resolving. */
  revision: Scalars['Int']['output'];
  severity: PlatformIncidentSeverity;
  startsAt: Scalars['DateTime']['output'];
  /** Public: shown on the Revvly icon, the sign-in page and the website. */
  title: Scalars['String']['output'];
};

export type PlatformIncidentInput = {
  component?: InputMaybe<Scalars['String']['input']>;
  /** Optional: it stops showing at this time. */
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  severity: PlatformIncidentSeverity;
  /** Defaults to now. A future time schedules it. */
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
  title: Scalars['String']['input'];
};

/** DEGRADED and MAINTENANCE show amber, DOWN shows red, on the Revvly icon. */
export enum PlatformIncidentSeverity {
  Degraded = 'DEGRADED',
  Down = 'DOWN',
  Maintenance = 'MAINTENANCE',
}

export type PolicyAcceptance = {
  __typename?: 'PolicyAcceptance';
  acceptedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  policyType: PolicyType;
  /** Where the acceptance was captured. */
  source?: Maybe<Scalars['String']['output']>;
  /** Version of the policy that was accepted. */
  version: Scalars['String']['output'];
};

export type PolicyAcceptanceEntryInput = {
  policyType: PolicyType;
  /** Version of the policy being accepted (e.g. 2026-07-24). */
  version: Scalars['String']['input'];
};

/** A legal policy document a user can accept (Terms, Privacy, Cookies). */
export enum PolicyType {
  Cookies = 'COOKIES',
  Privacy = 'PRIVACY',
  Terms = 'TERMS',
}

export type PostSlackActionSettings = {
  __typename?: 'PostSlackActionSettings';
  channelId: Scalars['String']['output'];
  channelName?: Maybe<Scalars['String']['output']>;
  includeAnswers: Scalars['Boolean']['output'];
  messageTemplate?: Maybe<Scalars['String']['output']>;
};

export type PostSlackActionSettingsInput = {
  channelId?: Scalars['String']['input'];
  channelName?: InputMaybe<Scalars['String']['input']>;
  includeAnswers?: Scalars['Boolean']['input'];
  messageTemplate?: InputMaybe<Scalars['String']['input']>;
};

/** What to do about the money when a plan changes inside a prepaid span. CHARGE_NOW raises one catch-up invoice for the price difference across the periods the prepayment still covers; NO_CHARGE applies the change and bills nothing more until the span runs out. The plan changes immediately either way, and MRR moves with it — this decides cash only. */
export enum PrepaidSpanChange {
  ChargeNow = 'CHARGE_NOW',
  NoCharge = 'NO_CHARGE',
}

/** What a prepaid term's prepay incentive discounts: the BASE price, the standing COMPONENTS paid ahead with it, or BOTH. Components that reset each period are never prepaid. */
export enum PrepayDiscountScope {
  Base = 'BASE',
  Both = 'BOTH',
  Components = 'COMPONENTS',
}

/** Presigned URL for file download */
export type PresignedDownloadUrl = {
  __typename?: 'PresignedDownloadUrl';
  downloadUrl: Scalars['String']['output'];
  expiresAt: Scalars['DateTime']['output'];
  /** URL expiration time in seconds */
  expiresIn: Scalars['Int']['output'];
  filename: Scalars['String']['output'];
};

export type PresignedUploadField = {
  __typename?: 'PresignedUploadField';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** Presigned URL for file upload */
export type PresignedUploadUrl = {
  __typename?: 'PresignedUploadUrl';
  bucket: Scalars['String']['output'];
  expiresAt: Scalars['DateTime']['output'];
  /** URL expiration time in seconds */
  expiresIn: Scalars['Int']['output'];
  fields?: Maybe<Array<PresignedUploadField>>;
  key: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type PreviewVariableChargeComponentInput = {
  componentId: Scalars['ID']['input'];
  componentVersion: Scalars['Int']['input'];
  /** Effective free inclusion gating the charge. Omitted = no inclusion (0). Billing starts above this. */
  includedQuantity?: InputMaybe<Scalars['Float']['input']>;
  /** The full per-client price override, shaped for the component's pricing model (tierPrices for tiered, stepFees for stairstep, …). Projects the charge as if this SUBSCRIPTION-scoped variant already existed — the same variant DirectComponentInput.pricesByCurrency will write at creation. Takes precedence over unitPriceOverride, which stays for FLAT_RATE callers. */
  priceOverride?: InputMaybe<PricingVariantInput>;
  /** Provisioned quantity at creation. */
  startingCount: Scalars['Float']['input'];
  /** Per-client rate override the operator typed in the create form. Projects the charge as if a SUBSCRIPTION-scoped price of {currency, unitPrice} existed (what DirectComponentInput.pricesByCurrency will write at creation). FLAT_RATE only — use priceOverride for any model whose price is not a single per-unit rate (tiered, stairstep, overage, committed, commission). */
  unitPriceOverride?: InputMaybe<Scalars['Float']['input']>;
};

export type PreviewVariableChargesInput = {
  bundleId?: InputMaybe<Scalars['ID']['input']>;
  bundleVersion?: InputMaybe<Scalars['Int']['input']>;
  components: Array<PreviewVariableChargeComponentInput>;
  /** Locked billing currency (ISO 4217). */
  currency: Scalars['String']['input'];
  /** Single pinned module (mutually exclusive with moduleIds). */
  moduleId?: InputMaybe<Scalars['ID']['input']>;
  /** Multiple pinned modules, index-aligned with moduleVersions. Use instead of moduleId for multi-module plans. */
  moduleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  moduleVersion?: InputMaybe<Scalars['Int']['input']>;
  /** Versions index-aligned with moduleIds. */
  moduleVersions?: InputMaybe<Array<Scalars['Int']['input']>>;
  period: SubscriptionPeriod;
  /** Customer's market — for per-region price overrides. */
  regionId?: InputMaybe<Scalars['ID']['input']>;
};

/** One check from the last review, as the editor kept it. */
export type PreviousDraftCheckInputType = {
  key: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  passed: Scalars['Boolean']['input'];
};

/** The last review of this draft and the draft it was run on, so the next review stays consistent with it: what passed and has not changed is not graded again, and a suggested title that was taken is not faulted. */
export type PreviousDraftReviewInputType = {
  checks: Array<PreviousDraftCheckInputType>;
  description?: InputMaybe<Scalars['String']['input']>;
  objectiveTitle?: InputMaybe<Scalars['String']['input']>;
  startValue?: InputMaybe<Scalars['Float']['input']>;
  suggestedTitles?: InputMaybe<Array<Scalars['String']['input']>>;
  summary?: InputMaybe<Scalars['String']['input']>;
  targetValue?: InputMaybe<Scalars['Float']['input']>;
  /** The title as it was when the last review ran. */
  title: Scalars['String']['input'];
  unit?: InputMaybe<KeyResultUnit>;
};

export type PriceChangeResult = {
  __typename?: 'PriceChangeResult';
  /** Price difference (positive = increase, negative = decrease) */
  difference: Scalars['Float']['output'];
  /** Calculated price after applying proposed changes */
  newPrice: Scalars['Float']['output'];
  /** Current subscription price before changes */
  oldPrice: Scalars['Float']['output'];
};

/** When a per-subscription price override takes effect. */
export enum PriceEffectiveMode {
  ImmediateProrated = 'IMMEDIATE_PRORATED',
  Prospective = 'PROSPECTIVE',
}

/** Pricing element a per-subscription override targets. */
export enum PriceOverrideElementType {
  BasePrice = 'BASE_PRICE',
  ComponentRate = 'COMPONENT_RATE',
}

/** Immutable audit entry for a per-subscription price override (PRD §7.5). */
export type PriceOverrideHistoryEntry = {
  __typename?: 'PriceOverrideHistoryEntry';
  changedAt: Scalars['DateTime']['output'];
  /** User who made the change. */
  changedBy?: Maybe<Scalars['String']['output']>;
  /** Set only when elementType is COMPONENT_RATE. */
  componentId?: Maybe<Scalars['ID']['output']>;
  /** ISO 4217 currency (the subscription's locked currency). */
  currency: Scalars['String']['output'];
  effectiveMode: PriceEffectiveMode;
  elementType: PriceOverrideElementType;
  id: Scalars['ID']['output'];
  /** Product list price snapshot at the moment of this change. */
  listValueAtOverride?: Maybe<Scalars['Decimal']['output']>;
  /** New included allowance (component overrides only). */
  newIncludedQuantity?: Maybe<Scalars['Int']['output']>;
  /** New overridden rate now billed. */
  newValue: Scalars['Decimal']['output'];
  /** Prior included allowance (component overrides only). */
  oldIncludedQuantity?: Maybe<Scalars['Int']['output']>;
  /** Prior billed rate (list price if this is the first override). */
  oldValue: Scalars['Decimal']['output'];
  /** Free-text reason entered by the user. */
  reason?: Maybe<Scalars['String']['output']>;
  /** EXPANSION invoice for an immediate/prorated change, if any. */
  relatedInvoiceId?: Maybe<Scalars['ID']['output']>;
  subscriptionId: Scalars['ID']['output'];
};

/** Outcome of a per-subscription price override (PRD §7). */
export type PriceOverrideResult = {
  __typename?: 'PriceOverrideResult';
  componentId?: Maybe<Scalars['ID']['output']>;
  effectiveMode: PriceEffectiveMode;
  elementType: PriceOverrideElementType;
  /** Catalog list price snapshot (reference only). */
  listValueAtOverride?: Maybe<Scalars['Decimal']['output']>;
  /** New overridden rate now billed. */
  newValue: Scalars['Decimal']['output'];
  /** Human-readable summary of what happened. */
  note?: Maybe<Scalars['String']['output']>;
  /** Prior billed rate. */
  oldValue: Scalars['Decimal']['output'];
  /** Correction invoice generated for an immediate/prorated change, if any. */
  relatedInvoiceId?: Maybe<Scalars['ID']['output']>;
  subscriptionId: Scalars['ID']['output'];
};

export type PricingBreakdown = {
  __typename?: 'PricingBreakdown';
  bundlePrice?: Maybe<Scalars['Float']['output']>;
  modulesPricing: Array<ModulePricingBreakdown>;
};

export type PricingCalculation = {
  __typename?: 'PricingCalculation';
  breakdown: PricingBreakdown;
  currency: Scalars['String']['output'];
  limits: PricingLimits;
  totalPrice: Scalars['Float']['output'];
};

export type PricingCombination = {
  __typename?: 'PricingCombination';
  currency: Scalars['String']['output'];
  globalPrice?: Maybe<PricingRule>;
  hasRegionalPricing: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isPricingActive?: Maybe<Scalars['Boolean']['output']>;
  itemId: Scalars['String']['output'];
  itemName: Scalars['String']['output'];
  period: SubscriptionPeriod;
  price?: Maybe<Scalars['Float']['output']>;
  pricingId?: Maybe<Scalars['String']['output']>;
  region: Region;
  regionId: Scalars['String']['output'];
  tierName?: Maybe<Scalars['String']['output']>;
  type: PricingCombinationType;
};

export type PricingCombinationStats = {
  __typename?: 'PricingCombinationStats';
  combinationsWithAnyPricing: Scalars['Int']['output'];
  combinationsWithoutAnyPricing: Scalars['Int']['output'];
  missingAnyPricingActiveBundles: Scalars['Int']['output'];
  missingAnyPricingActiveModules: Scalars['Int']['output'];
  missingAnyPricingInactiveBundles: Scalars['Int']['output'];
  missingAnyPricingInactiveModules: Scalars['Int']['output'];
  totalBundles: Scalars['Int']['output'];
  totalCombinations: Scalars['Int']['output'];
  totalCurrencies: Scalars['Int']['output'];
  totalModules: Scalars['Int']['output'];
  totalPeriods: Scalars['Int']['output'];
  totalRegions: Scalars['Int']['output'];
};

/** Type of pricing combination (bundle or module) */
export enum PricingCombinationType {
  Bundle = 'BUNDLE',
  Module = 'MODULE',
}

export type PricingCombinationsFilterInput = {
  bundleIds?: InputMaybe<Array<Scalars['String']['input']>>;
  currencies?: InputMaybe<Array<Scalars['String']['input']>>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  includeDraft?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  moduleIds?: InputMaybe<Array<Scalars['String']['input']>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  periods?: InputMaybe<Array<SubscriptionPeriod>>;
  pricingFilterOperator?: PricingFilterOperator;
  pricingFilters: Array<PricingFilterType>;
  regionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrder>;
  types?: InputMaybe<Array<PricingCombinationType>>;
};

export type PricingCombinationsResponse = {
  __typename?: 'PricingCombinationsResponse';
  combinations: Array<PricingCombination>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  stats: PricingCombinationStats;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PricingDraftConfirmationResult = {
  __typename?: 'PricingDraftConfirmationResult';
  /** The id of the entity the confirmation created/updated. */
  createdEntityId?: Maybe<Scalars['ID']['output']>;
  /** The type of the created/updated entity (e.g. VariableComponent). */
  createdEntityType?: Maybe<Scalars['String']['output']>;
  /** The draft, now CONFIRMED. */
  draft: PricingDraftSummary;
};

export type PricingDraftDiffEntry = {
  __typename?: 'PricingDraftDiffEntry';
  /** Previous value, formatted for display */
  fromValue?: Maybe<Scalars['String']['output']>;
  /** Field label, e.g. 'Per-unit price' or 'Cap' */
  key: Scalars['String']['output'];
  /** Proposed value, formatted for display */
  toValue: Scalars['String']['output'];
};

export type PricingDraftSummary = {
  __typename?: 'PricingDraftSummary';
  /** Author (always 'AI Draft' for stub data) */
  author: Scalars['String']['output'];
  /** Confidence label shown on the card — 'High' / 'Medium' / 'Confirm'. */
  confidence: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  diff: Array<PricingDraftDiffEntry>;
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** One-sentence rationale shown on the inbox card. */
  rationale: Scalars['String']['output'];
  /** Bullet-list signals that informed the draft, e.g. 'Usage up 23% over the past 30 days'. */
  signals: Array<Scalars['String']['output']>;
  status: PricingDraftSummaryStatus;
  title: Scalars['String']['output'];
  /** Component this draft modifies (for navigation back). */
  variableComponentId?: Maybe<Scalars['ID']['output']>;
};

/** Status of a pending draft — either awaiting review or expired past its 24h TTL. */
export enum PricingDraftSummaryStatus {
  Expired = 'EXPIRED',
  Pending = 'PENDING',
}

export type PricingFilterInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  period?: InputMaybe<SubscriptionPeriod>;
  refId?: InputMaybe<Scalars['ID']['input']>;
  refType?: InputMaybe<PricingRuleRefType>;
  regionId?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrder>;
};

/** Operator to combine multiple pricing filters */
export enum PricingFilterOperator {
  And = 'AND',
  Or = 'OR',
}

/** Type of pricing filter to apply */
export enum PricingFilterType {
  HasGlobal = 'HAS_GLOBAL',
  HasRegional = 'HAS_REGIONAL',
  MissingGlobal = 'MISSING_GLOBAL',
  MissingRegional = 'MISSING_REGIONAL',
}

export type PricingLimits = {
  __typename?: 'PricingLimits';
  totalIncludedFunnels: Scalars['Int']['output'];
  totalIncludedUsers: Scalars['Int']['output'];
};

/** Pricing model for a Variable Component (PRD §5) */
export enum PricingModelType {
  Commission = 'COMMISSION',
  CommittedOverage = 'COMMITTED_OVERAGE',
  FlatRate = 'FLAT_RATE',
  GraduatedTiered = 'GRADUATED_TIERED',
  Promotional = 'PROMOTIONAL',
  Stairstep = 'STAIRSTEP',
  TrueOverage = 'TRUE_OVERAGE',
  VolumeTiered = 'VOLUME_TIERED',
}

export type PricingRule = {
  __typename?: 'PricingRule';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  currency: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  organizationId?: Maybe<Scalars['String']['output']>;
  price: Scalars['Decimal']['output'];
  refId?: Maybe<Scalars['String']['output']>;
  /** Name of the referenced entity (bundle, module, plan, etc.) */
  refName?: Maybe<Scalars['String']['output']>;
  refType?: Maybe<PricingRuleRefType>;
  region?: Maybe<Region>;
  regionId?: Maybe<Scalars['String']['output']>;
  ruleType: PricingRuleType;
  scope: PricingScope;
  subscriptionPeriod?: Maybe<SubscriptionPeriod>;
  /** Module tier this rule prices (ModuleTier id). Null = base/untiered price (also the fallback for a tiered module whose tier has no explicit price). ClickUp 86cabjuxn. */
  tierId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  validFrom?: Maybe<Scalars['DateTime']['output']>;
  validTo?: Maybe<Scalars['DateTime']['output']>;
  /** Variable limits that define included quantities and pricing for additional units (e.g., users, funnels, storage) */
  variableLimits?: Maybe<Array<VariableLimit>>;
};

export type PricingRuleConnection = {
  __typename?: 'PricingRuleConnection';
  edges: Array<PricingRuleEdge>;
  filteredCount: Scalars['Int']['output'];
  pageInfo: PageInfo;
  /** Statistics about active pricing rules */
  statistics: PricingRuleStats;
  totalCount: Scalars['Int']['output'];
};

export type PricingRuleEdge = {
  __typename?: 'PricingRuleEdge';
  cursor: Scalars['String']['output'];
  node: PricingRule;
};

/** Type of entity that the pricing rule references */
export enum PricingRuleRefType {
  Bundle = 'BUNDLE',
  Feature = 'FEATURE',
  Module = 'MODULE',
  Plan = 'PLAN',
}

export type PricingRuleStats = {
  __typename?: 'PricingRuleStats';
  /** Total number of active pricing rules */
  totalActive: Scalars['Int']['output'];
  /** Number of active pricing rules linked to bundles */
  totalLinkedToBundles: Scalars['Int']['output'];
  /** Number of active pricing rules linked to features */
  totalLinkedToFeatures: Scalars['Int']['output'];
  /** Number of active pricing rules linked to modules */
  totalLinkedToModules: Scalars['Int']['output'];
  /** Number of active pricing rules linked to plans */
  totalLinkedToPlans: Scalars['Int']['output'];
};

/** Type of pricing rule */
export enum PricingRuleType {
  BasePrice = 'BASE_PRICE',
  Discount = 'DISCOUNT',
  Tax = 'TAX',
  VariableItem = 'VARIABLE_ITEM',
}

/** Scope of pricing rule application */
export enum PricingScope {
  Global = 'GLOBAL',
  Organization = 'ORGANIZATION',
  Region = 'REGION',
}

export type PricingStep = {
  __typename?: 'PricingStep';
  /** Upper bound (inclusive); null = unlimited */
  limit?: Maybe<Scalars['Int']['output']>;
};

export type PricingStepInput = {
  /** Upper bound (inclusive); null = unlimited */
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type PricingTier = {
  __typename?: 'PricingTier';
  /** Upper bound (inclusive); null = unlimited */
  limit?: Maybe<Scalars['Int']['output']>;
};

export type PricingTierInput = {
  /** Upper bound (inclusive); null = unlimited */
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type PricingVariant = {
  __typename?: 'PricingVariant';
  /** COMMITTED_OVERAGE: committed unit price. */
  committedUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  /** ISO 4217 currency code. */
  currency: Scalars['String']['output'];
  /** PROMOTIONAL (FIXED_AMOUNT discount): discount amount. */
  discountValueAmount?: Maybe<Scalars['Decimal']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  /** COMMISSION: fixed fee per transaction. */
  fixedFeePerTransaction?: Maybe<Scalars['Decimal']['output']>;
  /** COMMISSION: ceiling per transaction. */
  maxPerTransaction?: Maybe<Scalars['Decimal']['output']>;
  /** COMMISSION: floor per transaction. */
  minPerTransaction?: Maybe<Scalars['Decimal']['output']>;
  /** TRUE_OVERAGE / COMMITTED_OVERAGE: overage price. */
  overageUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  /** COMMITTED_OVERAGE: overage price above commit. */
  overageUnitPriceCommitted?: Maybe<Scalars['Decimal']['output']>;
  /** STAIRSTEP: index-aligned with component steps[]. */
  stepFees?: Maybe<Array<Scalars['Decimal']['output']>>;
  /** VOLUME_TIERED / GRADUATED_TIERED: index-aligned with component tiers[]. */
  tierPrices?: Maybe<Array<Scalars['Decimal']['output']>>;
  /** FLAT_RATE: price per unit. */
  unitPrice?: Maybe<Scalars['Decimal']['output']>;
};

export type PricingVariantInput = {
  committedUnitPrice?: InputMaybe<Scalars['Float']['input']>;
  /** ISO 4217 currency code. */
  currency: Scalars['String']['input'];
  discountValueAmount?: InputMaybe<Scalars['Float']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  fixedFeePerTransaction?: InputMaybe<Scalars['Float']['input']>;
  maxPerTransaction?: InputMaybe<Scalars['Float']['input']>;
  minPerTransaction?: InputMaybe<Scalars['Float']['input']>;
  overageUnitPrice?: InputMaybe<Scalars['Float']['input']>;
  overageUnitPriceCommitted?: InputMaybe<Scalars['Float']['input']>;
  /** STAIRSTEP: index-aligned with component steps[]. */
  stepFees?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** VOLUME_TIERED / GRADUATED_TIERED: index-aligned with component tiers[]. */
  tierPrices?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** FLAT_RATE: price per unit. */
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type ProductActivityItem = {
  __typename?: 'ProductActivityItem';
  displayName?: Maybe<Scalars['String']['output']>;
  eventName: Scalars['String']['output'];
  externalUserId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  occurredAt: Scalars['DateTime']['output'];
  /** The properties sent with the event, as JSON. */
  propertiesJson: Scalars['String']['output'];
  userName?: Maybe<Scalars['String']['output']>;
};

export type ProductActivityPage = {
  __typename?: 'ProductActivityPage';
  items: Array<ProductActivityItem>;
  /** Pass as `after` for the next page. */
  nextCursor?: Maybe<Scalars['String']['output']>;
};

/** One catalog item's standing with the matcher */
export type ProductAutonomyEntity = {
  __typename?: 'ProductAutonomyEntity';
  /** Distinct clients still needed */
  clientsToEarn: Scalars['Int']['output'];
  /** Times the matcher named this product and the reviewer agreed */
  confirmedHits: Scalars['Int']['output'];
  /** Times the matcher named this product and the reviewer took it away */
  corrections: Scalars['Int']['output'];
  /** Distinct clients among those hits */
  distinctClients: Scalars['Int']['output'];
  /** Hits still needed to clear the bar */
  hitsToEarn: Scalars['Int']['output'];
  /** BUNDLE, MODULE, or UNKNOWN for a deleted version */
  kind: Scalars['String']['output'];
  /** Lineage this version belongs to */
  lineageId?: Maybe<Scalars['String']['output']>;
  /** Catalog name, absent if the version is gone */
  name?: Maybe<Scalars['String']['output']>;
  /** Catalog VERSION id the evidence is keyed on */
  productId: Scalars['String']['output'];
  /** Times the reviewer named it where the matcher had abstained — neither hit nor miss */
  reviewerSupplied: Scalars['Int']['output'];
  status: ProductAutonomyStatus;
  /** Version number within the lineage */
  version?: Maybe<Scalars['Int']['output']>;
};

/** How far one catalog item is trusted to match without review */
export enum ProductAutonomyStatus {
  Earned = 'EARNED',
  Learning = 'LEARNING',
  NeedsAttention = 'NEEDS_ATTENTION',
}

export type ProductCategoryUsageRow = {
  __typename?: 'ProductCategoryUsageRow';
  category: Scalars['String']['output'];
  events: Scalars['Int']['output'];
  previousEvents: Scalars['Int']['output'];
};

export type ProductEventAttribute = {
  __typename?: 'ProductEventAttribute';
  key: Scalars['String']['output'];
  /** string, number or boolean. */
  type: Scalars['String']['output'];
};

export type ProductEventCatalogue = {
  __typename?: 'ProductEventCatalogue';
  /** Categories already in use, to pick from. */
  categories: Array<Scalars['String']['output']>;
  ignoredCount: Scalars['Int']['output'];
  mappedCount: Scalars['Int']['output'];
  newCount: Scalars['Int']['output'];
  types: Array<ProductEventType>;
};

export type ProductEventDetail = {
  __typename?: 'ProductEventDetail';
  /** Distinct clients in the last 30 days. */
  clients30d: Scalars['Int']['output'];
  eventName: Scalars['String']['output'];
  /** Events in the last 30 days. */
  events30d: Scalars['Int']['output'];
  /** The latest events of this name. */
  samples: Array<ProductEventSample>;
  /** Distinct users in the last 30 days. */
  users30d: Scalars['Int']['output'];
  /** Twelve weeks, oldest first (weeks start on Monday, UTC). */
  weekly: Array<ProductUsageBucket>;
};

/** Who made a mapping. */
export enum ProductEventMappingSource {
  Confirmed = 'CONFIRMED',
  Suggested = 'SUGGESTED',
}

export type ProductEventSample = {
  __typename?: 'ProductEventSample';
  externalUserId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  occurredAt: Scalars['DateTime']['output'];
  organizationName?: Maybe<Scalars['String']['output']>;
  /** The properties sent with the event, as JSON. */
  propertiesJson: Scalars['String']['output'];
};

export type ProductEventSettings = {
  __typename?: 'ProductEventSettings';
  /** Origins (scheme and host) whose pages may send events with a browser token. Empty: no browser may. */
  browserOrigins: Array<Scalars['String']['output']>;
};

export type ProductEventSuggestion = {
  __typename?: 'ProductEventSuggestion';
  category?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  /** What in the documentation led to this suggestion. */
  rationale: Scalars['String']['output'];
  sources: Array<ProductEventSuggestionSource>;
  suggestedAt: Scalars['DateTime']['output'];
  targetId?: Maybe<Scalars['ID']['output']>;
  targetKind?: Maybe<ProductEventTargetKind>;
  targetName?: Maybe<Scalars['String']['output']>;
  valueFeature: Scalars['Boolean']['output'];
};

export type ProductEventSuggestionRun = {
  __typename?: 'ProductEventSuggestionRun';
  skipped: Array<ProductEventSuggestionSkip>;
  suggested: Scalars['Int']['output'];
};

export type ProductEventSuggestionSkip = {
  __typename?: 'ProductEventSuggestionSkip';
  eventName: Scalars['String']['output'];
  reason: Scalars['String']['output'];
};

export type ProductEventSuggestionSource = {
  __typename?: 'ProductEventSuggestionSource';
  title: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type ProductEventTarget = {
  __typename?: 'ProductEventTarget';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** What an event type can be tied to. */
export enum ProductEventTargetKind {
  Bundle = 'BUNDLE',
  FeatureFlag = 'FEATURE_FLAG',
  Module = 'MODULE',
}

export type ProductEventType = {
  __typename?: 'ProductEventType';
  attributes: Array<ProductEventAttribute>;
  category?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  eventCount: Scalars['Int']['output'];
  eventName: Scalars['String']['output'];
  /** Events in the last 30 days. */
  eventsLast30Days: Scalars['Int']['output'];
  firstSeenAt: Scalars['DateTime']['output'];
  lastSeenAt: Scalars['DateTime']['output'];
  mappingSource?: Maybe<ProductEventMappingSource>;
  status: ProductEventTypeStatus;
  /** A proposal drawn from the documentation, waiting for a person to accept or dismiss it. */
  suggestion?: Maybe<ProductEventSuggestion>;
  targetId?: Maybe<Scalars['ID']['output']>;
  targetKind?: Maybe<ProductEventTargetKind>;
  targetName?: Maybe<Scalars['String']['output']>;
  valueFeature: Scalars['Boolean']['output'];
};

/** Where an event type stands in the event inbox. */
export enum ProductEventTypeStatus {
  Ignored = 'IGNORED',
  Mapped = 'MAPPED',
  New = 'NEW',
}

export type ProductFeatureDocCheck = {
  __typename?: 'ProductFeatureDocCheck';
  /** Features whose documentation was looked for. */
  checked: Scalars['Int']['output'];
  /** Features in use that no documentation page mentions, the most used first. */
  gaps: Array<ProductFeatureDocGap>;
  /** Features left out because their target was removed. */
  skipped: Scalars['Int']['output'];
};

export type ProductFeatureDocGap = {
  __typename?: 'ProductFeatureDocGap';
  /** Clients that used it in the last 30 days. */
  clients: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  kind: ProductEventTargetKind;
  name: Scalars['String']['output'];
};

export type ProductFeatureGap = {
  __typename?: 'ProductFeatureGap';
  /** Clients of the workspace that used it in the period. */
  clients: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  kind: ProductEventTargetKind;
  /** Null when the target was removed. */
  name?: Maybe<Scalars['String']['output']>;
};

export type ProductFeatureUsage = {
  __typename?: 'ProductFeatureUsage';
  categories: Array<ProductCategoryUsageRow>;
  /** When the nightly rollup behind this was last computed; null when it never has been. */
  computedAt?: Maybe<Scalars['DateTime']['output']>;
  features: Array<ProductFeatureUsageRow>;
  /** First completed day counted (UTC). */
  from: Scalars['DateTime']['output'];
  /** Features at least a quarter of the active clients (and at least two) used in the period that this client did not; at most five. */
  notUsed: Array<ProductFeatureGap>;
  periodDays: Scalars['Int']['output'];
  previousTotalEvents: Scalars['Int']['output'];
  previousValueEvents: Scalars['Int']['output'];
  /** Last completed day counted: yesterday (UTC). */
  through: Scalars['DateTime']['output'];
  totalEvents: Scalars['Int']['output'];
  /** Events whose type is not tied to a feature flag, module or bundle. */
  unmappedEvents: Scalars['Int']['output'];
  valueEvents: Scalars['Int']['output'];
};

export type ProductFeatureUsageRow = {
  __typename?: 'ProductFeatureUsageRow';
  /** Days in the period with an event. */
  activeDays: Scalars['Int']['output'];
  events: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  kind: ProductEventTargetKind;
  /** Null when the target was removed. */
  name?: Maybe<Scalars['String']['output']>;
  previousEvents: Scalars['Int']['output'];
  /** Distinct users per day added over the days; not distinct users over the period. */
  userDays: Scalars['Int']['output'];
};

/** Status of AI product matching for a subscription */
export enum ProductMatchStatus {
  Manual = 'MANUAL',
  Matched = 'MATCHED',
  Unmatched = 'UNMATCHED',
}

export type ProductOverviewClientRow = {
  __typename?: 'ProductOverviewClientRow';
  /** Days in the period with an event. */
  activeDays: Scalars['Int']['output'];
  events: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  previousEvents: Scalars['Int']['output'];
  valueEvents: Scalars['Int']['output'];
};

export type ProductOverviewFeatureRow = {
  __typename?: 'ProductOverviewFeatureRow';
  /** Clients with at least one event on it in the period. */
  clients: Scalars['Int']['output'];
  events: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  kind: ProductEventTargetKind;
  /** Null when the target was removed. */
  name?: Maybe<Scalars['String']['output']>;
  previousEvents: Scalars['Int']['output'];
  /** Distinct users per day per client added over the days; not distinct users. */
  userDays: Scalars['Int']['output'];
};

export type ProductProfileClient = {
  __typename?: 'ProductProfileClient';
  /** Events in the period. */
  events: Scalars['Int']['output'];
  /** The client has this person as a user of its own. */
  known: Scalars['Boolean']['output'];
  lastSeenAt?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  /** Events ever stored for this person at the client. */
  totalEvents: Scalars['Int']['output'];
};

export type ProductSessionPage = {
  __typename?: 'ProductSessionPage';
  /** Mean active seconds on the page; null when no leave event carried one. */
  avgActiveSeconds?: Maybe<Scalars['Int']['output']>;
  path: Scalars['String']['output'];
  /** Distinct sessions that viewed the page. */
  sessions: Scalars['Int']['output'];
  views: Scalars['Int']['output'];
};

/** One earned product and a sample of what it is auto-accepting */
export type ProductSpotCheckEntity = {
  __typename?: 'ProductSpotCheckEntity';
  /** Every invoice this product is auto-accepting, not just the sampled ones */
  autoAcceptedTotal: Scalars['Int']['output'];
  /** BUNDLE, MODULE, or UNKNOWN for a deleted version */
  kind: Scalars['String']['output'];
  /** Catalog name, absent if the version is gone */
  name?: Maybe<Scalars['String']['output']>;
  /** Catalog VERSION id autonomy is keyed on */
  productId: Scalars['String']['output'];
  /** Sampled sync result ids. Re-drawn at random on each call — a fixed sample is the same invoices forever, so a product whose newer invoices drifted would never be the one shown. */
  resultIds: Array<Scalars['String']['output']>;
};

/** A sellable catalog product priced per market: a Module or a Bundle. */
export enum ProductType {
  Bundle = 'BUNDLE',
  Module = 'MODULE',
}

export type ProductUsageBucket = {
  __typename?: 'ProductUsageBucket';
  /** Events in the bucket, whatever the measure counts. */
  events: Scalars['Int']['output'];
  /** Start of the bucket (UTC). */
  start: Scalars['DateTime']['output'];
  value: Scalars['Int']['output'];
};

export type ProductUsageDay = {
  __typename?: 'ProductUsageDay';
  /** YYYY-MM-DD, UTC. */
  date: Scalars['String']['output'];
  events: Scalars['Int']['output'];
};

export type ProductUsageEventCount = {
  __typename?: 'ProductUsageEventCount';
  category?: Maybe<Scalars['String']['output']>;
  /** The name an admin gave it in the event inbox. */
  displayName?: Maybe<Scalars['String']['output']>;
  eventName: Scalars['String']['output'];
  events: Scalars['Int']['output'];
  users: Scalars['Int']['output'];
  /** An admin marked this event as showing the user got value. */
  valueFeature: Scalars['Boolean']['output'];
};

/** The size of a bucket in a usage trend. Weeks start on Monday; all of it is UTC. */
export enum ProductUsageInterval {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK',
}

/** What a usage trend counts: every event, or the distinct users who fired it. */
export enum ProductUsageMeasure {
  EventCount = 'EVENT_COUNT',
  Users = 'USERS',
}

export type ProductUsageOverview = {
  __typename?: 'ProductUsageOverview';
  activeClients: Scalars['Int']['output'];
  /** The busiest clients; at most 100. */
  clients: Array<ProductOverviewClientRow>;
  /** How many clients are listed. */
  clientsShown: Scalars['Int']['output'];
  /** When the nightly rollup last ran for this workspace. */
  computedAt?: Maybe<Scalars['DateTime']['output']>;
  features: Array<ProductOverviewFeatureRow>;
  /** First completed day counted (UTC). */
  from: Scalars['DateTime']['output'];
  periodDays: Scalars['Int']['output'];
  previousActiveClients: Scalars['Int']['output'];
  previousTotalEvents: Scalars['Int']['output'];
  previousValueEvents: Scalars['Int']['output'];
  /** Last completed day counted: yesterday (UTC). */
  through: Scalars['DateTime']['output'];
  totalEvents: Scalars['Int']['output'];
  valueEvents: Scalars['Int']['output'];
};

export type ProductUsageSessions = {
  __typename?: 'ProductUsageSessions';
  avgPagesPerSession: Scalars['Float']['output'];
  /** Mean seconds from first to last event; one-event sessions are left out. */
  avgSessionSeconds: Scalars['Int']['output'];
  from: Scalars['DateTime']['output'];
  /** False when no browser event (one with a session id) arrived in either period. */
  hasBrowserData: Scalars['Boolean']['output'];
  periodDays: Scalars['Int']['output'];
  previousAvgSessionSeconds: Scalars['Int']['output'];
  previousSessions: Scalars['Int']['output'];
  sessions: Scalars['Int']['output'];
  to: Scalars['DateTime']['output'];
  topPages: Array<ProductSessionPage>;
};

export type ProductUsageSummary = {
  __typename?: 'ProductUsageSummary';
  /** Average active days of the users who were active. */
  activeDaysPerUser: Scalars['Float']['output'];
  /** Distinct users with an event in the period. */
  activeUsers: Scalars['Int']['output'];
  events: Scalars['Int']['output'];
  from: Scalars['DateTime']['output'];
  /** Support end users this client has. */
  knownUsers: Scalars['Int']['output'];
  periodDays: Scalars['Int']['output'];
  previousActiveDaysPerUser: Scalars['Float']['output'];
  previousActiveUsers: Scalars['Int']['output'];
  /** Events in the period just before. */
  previousEvents: Scalars['Int']['output'];
  previousValueEvents: Scalars['Int']['output'];
  to: Scalars['DateTime']['output'];
  /** Busiest events in the period. */
  topEvents: Array<ProductUsageEventCount>;
  /** Every known user of the client, and anyone seen in events during the period or the one before; at most 500. */
  users: Array<ProductUsageUserRow>;
  /** Events of types marked as showing value, in the period. */
  valueEvents: Scalars['Int']['output'];
  /** Active users per week for the last 12 weeks (`value`), with the events behind it. */
  weeklyActiveUsers: Array<ProductUsageBucket>;
};

export type ProductUsageTrend = {
  __typename?: 'ProductUsageTrend';
  /** Oldest first; empty buckets are zero. */
  buckets: Array<ProductUsageBucket>;
  eventName: Scalars['String']['output'];
  interval: ProductUsageInterval;
  /** Support end users this client has. */
  knownUsers: Scalars['Int']['output'];
  measure: ProductUsageMeasure;
  /** Distinct users who fired it across all the buckets. */
  usersFiring: Scalars['Int']['output'];
};

export type ProductUsageUser = {
  __typename?: 'ProductUsageUser';
  /** Days with an event, in the period. */
  activeDays: Scalars['Int']['output'];
  /** One entry per day of the period, oldest first. */
  calendar: Array<ProductUsageDay>;
  email?: Maybe<Scalars['String']['output']>;
  /** Events in the period. */
  events: Scalars['Int']['output'];
  externalUserId: Scalars['String']['output'];
  firstSeenAt?: Maybe<Scalars['DateTime']['output']>;
  known: Scalars['Boolean']['output'];
  lastSeenAt?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  periodDays: Scalars['Int']['output'];
  previousEvents: Scalars['Int']['output'];
  role?: Maybe<Scalars['String']['output']>;
  topEvents: Array<ProductUsageEventCount>;
  /** Events ever stored for this user at this client. */
  totalEvents: Scalars['Int']['output'];
};

export type ProductUsageUserRow = {
  __typename?: 'ProductUsageUserRow';
  /** Days with at least one event, in the period. */
  activeDays: Scalars['Int']['output'];
  email?: Maybe<Scalars['String']['output']>;
  /** Events in the period. */
  events: Scalars['Int']['output'];
  /** The tenant’s own id for the user. */
  externalUserId: Scalars['String']['output'];
  /** A Support end user of this workspace. False for someone only seen in events, whose profile the tenant’s backend has not sent. */
  known: Scalars['Boolean']['output'];
  /** Latest event, in any period. */
  lastSeenAt?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
};

export type ProductUserProfile = {
  __typename?: 'ProductUserProfile';
  /** Days with an event, in the period. */
  activeDays: Scalars['Int']['output'];
  calendar: Array<ProductUsageDay>;
  /** The clients they use; at most 50. */
  clients: Array<ProductProfileClient>;
  email?: Maybe<Scalars['String']['output']>;
  /** Events in the period, at every client. */
  events: Scalars['Int']['output'];
  externalUserId: Scalars['String']['output'];
  firstSeenAt?: Maybe<Scalars['DateTime']['output']>;
  known: Scalars['Boolean']['output'];
  lastSeenAt?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  periodDays: Scalars['Int']['output'];
  previousEvents: Scalars['Int']['output'];
  role?: Maybe<Scalars['String']['output']>;
  topEvents: Array<ProductUsageEventCount>;
  /** Events ever stored for this person. */
  totalEvents: Scalars['Int']['output'];
};

export type ProgressStage = {
  __typename?: 'ProgressStage';
  /** The client has been told about this stage. */
  announced: Scalars['Boolean']['output'];
  current: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  notifyClient: Scalars['Boolean']['output'];
  /** The ticket is at or past this stage. */
  reached: Scalars['Boolean']['output'];
};

export type ProjectSubscriptionBillingInput = {
  asOf?: InputMaybe<Scalars['DateTime']['input']>;
  endCustomerId?: InputMaybe<Scalars['ID']['input']>;
  regionId?: InputMaybe<Scalars['ID']['input']>;
  subscriptionId: Scalars['ID']['input'];
};

export type ProjectVariableBillingInput = {
  /** Defaults to now() */
  asOf?: InputMaybe<Scalars['DateTime']['input']>;
  /** End customer for custom-agreement resolution */
  endCustomerId?: InputMaybe<Scalars['ID']['input']>;
  /** Region to apply currency overrides for */
  regionId?: InputMaybe<Scalars['ID']['input']>;
  scenario?: InputMaybe<ProjectVariableBillingScenarioInput>;
  subscriptionId: Scalars['ID']['input'];
  variableId: Scalars['ID']['input'];
};

export type ProjectVariableBillingScenarioInput = {
  /** Override the measured quantity for what-if analysis */
  measuredQuantity?: InputMaybe<Scalars['Int']['input']>;
  /** Override netGmv (COMMISSION components) */
  netGmv?: InputMaybe<Scalars['Float']['input']>;
  /** Override transactionCount (COMMISSION components) */
  transactionCount?: InputMaybe<Scalars['Int']['input']>;
};

export type ProjectedInvoiceLine = {
  __typename?: 'ProjectedInvoiceLine';
  currency: Scalars['String']['output'];
  description: Scalars['String']['output'];
  quantity: Scalars['Float']['output'];
  totalAmount: Scalars['Float']['output'];
  unitPrice: Scalars['Float']['output'];
  /** The Variable Component this projected line prices. */
  variableComponentId: Scalars['ID']['output'];
};

export type ProjectedVariableBilling = {
  __typename?: 'ProjectedVariableBilling';
  billedQuantity: Scalars['Float']['output'];
  breakdown: Scalars['String']['output'];
  confidence: ProjectionConfidence;
  currency: Scalars['String']['output'];
  customAgreementApplied: Scalars['Boolean']['output'];
  discountApplied: Scalars['Float']['output'];
  freeAllowanceApplied: Scalars['Float']['output'];
  modelType: PricingModelType;
  regionOverrideApplied: Scalars['Boolean']['output'];
  subscriptionId: Scalars['ID']['output'];
  subtotal: Scalars['Float']['output'];
  totalCharged: Scalars['Float']['output'];
  unitPriceApplied: Scalars['Float']['output'];
  variableComponentId: Scalars['ID']['output'];
  variableId: Scalars['ID']['output'];
};

/** Confidence band for a billing projection (PRD §17.1) */
export enum ProjectionConfidence {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
}

/** Which subscription elements a promotion applies to */
export enum PromotionalAppliesTo {
  BaseOnly = 'BASE_ONLY',
  Both = 'BOTH',
  VariableOnly = 'VARIABLE_ONLY',
}

/** Promotional discount type (percentage or fixed currency amount) */
export enum PromotionalDiscountType {
  FixedAmount = 'FIXED_AMOUNT',
  Percentage = 'PERCENTAGE',
}

/** When a promotional discount starts */
export enum PromotionalStartTrigger {
  ExplicitDate = 'EXPLICIT_DATE',
  SubscriptionStart = 'SUBSCRIPTION_START',
}

/** A catalog version a client’s invoices imply but the catalog does not have. A PROPOSAL: nothing is created until an operator accepts it. */
export type ProposedCatalogVersionEntity = {
  __typename?: 'ProposedCatalogVersionEntity';
  basePrice: Scalars['Float']['output'];
  /** Cluster of invoices this was derived from. Accepting is per cluster: a re-priced subscription is one cluster with a segment per price, and applying those separately would mint one product per price. */
  clusterKey: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  /** First invoice carrying this price */
  effectiveFrom: Scalars['DateTime']['output'];
  /** Absent on the newest price — that is what the client pays today */
  effectiveTo?: Maybe<Scalars['DateTime']['output']>;
  /** Reviewer-facing reasons, shown instead of a score */
  evidence: Array<Scalars['String']['output']>;
  invoiceIds: Array<Scalars['String']['output']>;
  /** NEW_VERSION when an existing product is missing this price, NEW_LINEAGE when no product reads like the line at all. The distinction matters: a new lineage where a version was the right answer splits a product’s history in two. */
  kind: Scalars['String']['output'];
  /** Lineage to add the version to, on NEW_VERSION */
  lineageId?: Maybe<Scalars['String']['output']>;
  /** The lineage’s name on NEW_VERSION; the invoice line’s own wording otherwise */
  name: Scalars['String']['output'];
  organizationId?: Maybe<Scalars['String']['output']>;
  /** MONTHLY, QUARTERLY or YEARLY */
  period: Scalars['String']['output'];
  /** BUNDLE or MODULE — which catalog collection the version belongs in. On NEW_VERSION it is the matched lineage’s own kind; a new product is always a MODULE, the unit that carries a price. */
  productKind: Scalars['String']['output'];
  /** Metered lines billed alongside the base charge. Above zero, accepting creates a product that prices the plan and nothing else — the components have to be added by hand, because the invoices evidence that there was usage, not how it was priced. */
  usageLineCount: Scalars['Int']['output'];
};

/** How a mid-cycle quantity change is prorated on the invoice */
export enum ProrationCalculation {
  Daily = 'DAILY',
  FullMonth = 'FULL_MONTH',
  None = 'NONE',
}

/** Coarse public GraphQL capability. READ is always granted; WRITE is required for mutations (createClient, createProspect, …); SUPPORT_TOKEN_MINT lets the key mint Revvly Support end-user tokens; FORM_SUBMIT lets it submit to published forms (submitForm); KNOWLEDGE_WRITE lets it push help articles; USAGE_WRITE lets it report metered usage and events over REST; PAYMENT_WRITE lets it record invoice payments over the inbound payment webhook; PRODUCT_EVENT_WRITE lets it send product usage events over REST. */
export enum PublicApiCapability {
  FormSubmit = 'FORM_SUBMIT',
  KnowledgeWrite = 'KNOWLEDGE_WRITE',
  PaymentWrite = 'PAYMENT_WRITE',
  ProductEventWrite = 'PRODUCT_EVENT_WRITE',
  Read = 'READ',
  SupportTokenMint = 'SUPPORT_TOKEN_MINT',
  UsageWrite = 'USAGE_WRITE',
  Write = 'WRITE',
}

export type PublishCascadeResult = {
  __typename?: 'PublishCascadeResult';
  cascadedDrafts: Array<CascadedDraft>;
  component: VariableComponent;
};

/** Per-component, per-currency gap row for a publish-readiness inspection. Empty `missingCurrencies` means the component is covered for every required currency. */
export type PublishGapComponentRow = {
  __typename?: 'PublishGapComponentRow';
  /** Variable Component _id this row reports on. */
  componentId: Scalars['ID']['output'];
  /** Component display name (variableId or unit plural). */
  componentName?: Maybe<Scalars['String']['output']>;
  /** Pinned component version on the parent ref. */
  componentVersion: Scalars['Int']['output'];
  /** Currencies that have at least one applicable PUBLISHED price. */
  coveredCurrencies: Array<Scalars['String']['output']>;
  /** Markets covered by a region-specific or region-agnostic PUBLISHED price. */
  coveredMarkets: Array<PublishGapMarket>;
  /** Currencies required by the parent that have no PUBLISHED price at MODULE/BUNDLE-scope OR GLOBAL_DEFAULT for this component. */
  missingCurrencies: Array<Scalars['String']['output']>;
  /** Markets (region × currency) with no applicable PUBLISHED price — neither a region-specific nor a region-agnostic one. These block publish. */
  missingMarkets: Array<PublishGapMarket>;
};

/** Catalog entity type a publish-gap check is run against. */
export enum PublishGapEntityType {
  Bundle = 'BUNDLE',
  Module = 'MODULE',
}

/** One (region, currency) market a parent sells in, per its active base PricingRules. regionId null = a currency-only rule (region-agnostic market). The same currency in two regions is two markets — each needs price coverage (region-specific or region-agnostic). */
export type PublishGapMarket = {
  __typename?: 'PublishGapMarket';
  currency: Scalars['String']['output'];
  /** Region code for display (e.g. "LATAM"). */
  regionCode?: Maybe<Scalars['String']['output']>;
  /** Region _id, or null for a region-agnostic market. */
  regionId?: Maybe<Scalars['ID']['output']>;
};

/** Result of a publish-readiness check (Surface F-04 / PublishGap in the v4 design spec). `isPublishable` is true exactly when every row has an empty `missingCurrencies`. */
export type PublishGapResult = {
  __typename?: 'PublishGapResult';
  /** Module / Bundle _id this report is for. */
  entityId: Scalars['ID']['output'];
  entityType: PublishGapEntityType;
  /** Draft version being inspected. */
  entityVersion: Scalars['Int']['output'];
  /** True when there are no gaps — caller can publish without 422. */
  isPublishable: Scalars['Boolean']['output'];
  /** Currencies the parent supports (drives the columns of the gap matrix). */
  requiredCurrencies: Array<Scalars['String']['output']>;
  /** Markets (region × currency) the parent sells in, per its active base PricingRules. The publish gate requires every component ref covered in every market. */
  requiredMarkets: Array<PublishGapMarket>;
  /** One row per variableComponentRefs[] entry on the parent. */
  rows: Array<PublishGapComponentRow>;
};

/** How a billing-impacting change was authored */
export enum PublishPath {
  Api = 'API',
  ChatDraft = 'CHAT_DRAFT',
  Form = 'FORM',
  Template = 'TEMPLATE',
}

export type PushSubscription = {
  __typename?: 'PushSubscription';
  createdAt: Scalars['DateTime']['output'];
  /** Push service endpoint URL (identifies the device) */
  endpoint: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastNotifiedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  /** Device label (User-Agent) captured at registration */
  userAgent?: Maybe<Scalars['String']['output']>;
  /** Auth-provider user id the device is registered to */
  userId: Scalars['ID']['output'];
};

export type PushSubscriptionKeysInput = {
  /** Auth secret from the browser PushSubscription */
  auth: Scalars['String']['input'];
  /** Client public key (p256dh) from the browser PushSubscription */
  p256dh: Scalars['String']['input'];
};

export type Query = {
  __typename?: 'Query';
  /** Open account situations for one client, most recent transition first. Derived nightly from synced email metadata. */
  accountSituations: Array<AccountSituation>;
  accountingMailbox: AccountingMailbox;
  accountingMailboxAuthUrl: GmailAuthUrl;
  activeBundles: Array<Bundle>;
  activeFeatureFlagCategories: Array<FeatureFlagCategory>;
  activeFeatureFlags: Array<FeatureFlag>;
  activeMeters: Array<Meter>;
  activeModules: Array<Module>;
  activeOrganizationSubscription?: Maybe<OrganizationSubscription>;
  /** Get all active regions */
  activeRegions: Array<Region>;
  /** Exactly what the asking person's agent receives about this workspace: the profile, the workspace's memories and their own */
  agentContextPreview: AgentContextPreview;
  /** The workspace's agent memories plus the asking person's own */
  agentMemories: AgentMemoryList;
  agentSession: AgentSessionType;
  agentSessions: Array<AgentSessionType>;
  /** What AI cost across all workspaces in a month, by feature and by workspace (platform admin only). */
  aiEconomics: AiEconomics;
  /** Every AI feature and the rule the price simulator starts it from (platform admin only). */
  aiFeatureCatalog: Array<AiFeatureCatalogEntry>;
  /** Admins and owners only. The AI resolutions of one month and what they come to. */
  aiResolutionUsage: AiResolutionUsage;
  /** AI spend for this workspace, newest month first, for one spender (budgetKey). Empty until that spender has run. */
  aiSpend: Array<AiBudgetPeriod>;
  /** This workspace's month of AI use by feature, for its admins and owners. Counts the calls each feature made to an AI model or search; it never carries tokens or cost. */
  aiUsageSummary: AiUsageSummary;
  /**
   * Get all organizations without pagination (use with caution)
   * @deprecated This query is deprecated. Use organizations instead.
   */
  allOrganizations: Array<Organization>;
  /** Analyze a spreadsheet import TOGETHER with a staged Google Drive sync job before committing either: invoices present in both sources are corroborated field-by-field (agreement raises confidence, disagreement surfaces as conflicts), and each source-unique record is listed. */
  analyzeCombinedImport: CombinedImportAnalysisEntity;
  /** Analyze transactions before import to preview impacts */
  analyzeImport: ImportAnalysisResult;
  apiKey: ApiKey;
  /** Requests made with this key over the last 24 hours, and how many were refused. */
  apiKeyUsage: ApiKeyUsage;
  apiKeys: Array<ApiKey>;
  arrAnalytics: ArrAnalytics;
  arrTrend: Array<ArrTrendPoint>;
  /** Whether this workspace runs assistant-led onboarding, and where it stands */
  assistantOnboarding: AssistantOnboardingState;
  /** Platform admins: every assistant-led onboarding, with token use */
  assistantOnboardingFunnel: Array<OnboardingFunnelRowType>;
  /** Check for authentication anomalies */
  authAnomalies: Scalars['String']['output'];
  /** Get detailed failure analysis */
  authFailureAnalysis: Scalars['String']['output'];
  /** Get comprehensive authentication metrics */
  authMetrics: Scalars['String']['output'];
  availableClientFeatureFlags: Array<Scalars['String']['output']>;
  /** Get all available currencies from active regions */
  availableCurrencies: Array<Scalars['String']['output']>;
  /** Get all available exchange rates for the tenant */
  availableExchangeRates: Array<ExchangeRateInfo>;
  /** Every Revvly metric a Key Result can be bound to (AC-7.13) */
  availableMetrics: Array<OkrMetricDefinitionType>;
  /** Count of held draft invoices awaiting metered usage capture or period sealing. */
  awaitingUsageInvoicesCount: Scalars['Int']['output'];
  /** Billed revenue per period split by invoice line kind — recurring plan, usage, one-time fees, proration and credits. Derived from invoices, not from the MRR run-rate, and bucketed by INVOICE date: what was billed in the period, whatever period the service covers. One row per (period, line kind, invoice currency); native amounts of different currencies are never summed, so read amountInReportingCurrency to compare them. */
  billedRevenueByLineKind: Array<BilledRevenueByLineKind>;
  /** List billing_period_snapshots for an invoice (PRD §20.2) — used for invoice line drill-down / billing forensics. */
  billingPeriodSnapshot: Array<BillingPeriodSnapshot>;
  /** This tenant's daily prospect-creation allowance, how much of it today has used, and when it resets. */
  bookingIntakeCapStatus: BookingIntakeCapStatus;
  /** Preview reverting what booking intake created between two instants. Changes nothing. Tenant admin/owner only. */
  bookingIntakeRevertPreview: BookingIntakeRevertPlanResult;
  /** Scheduling links this tenant creates prospects from. Empty means none do. */
  bookingIntakeRoutes: Array<BookingIntakeRoute>;
  bundle: Bundle;
  bundleStats: Stats;
  /** Dependency summary for a bundle — whether it can be hard-deleted or must be deactivated. */
  bundleUsage: CatalogUsage;
  /** The version of a bundle lineage that was in force at `asOf`. `lineageId` addresses the whole version chain, so this answers "what was this plan on 2024-03-15" without the caller knowing which document that was. Null when `asOf` predates the lineage, or when no version of it was ever in force (drafts are never considered). */
  bundleVersionAt?: Maybe<Bundle>;
  bundles: Array<Bundle>;
  /** What the company does, as its administrators saved it */
  businessProfile: BusinessProfileType;
  calculateBundlePricing: PricingCalculation;
  calculateModulesPricing: PricingCalculation;
  calculatePriceChange: PriceChangeResult;
  /** Calculate prorated amount for a subscription change */
  calculateProratedAmount: Scalars['Float']['output'];
  /** Scheduling links on the connected Calendly organization, each with the booking intake route covering it. Fails when Calendly is not connected. */
  calendlyEventTypes: Array<CalendlyEventType>;
  calendlyIntegration: CalendlyIntegrationStatus;
  /** Confirmed links, proposed email matches and the unlinked, for the Calendly mapping screen. Tenant admin/owner only. */
  calendlyMemberMapping: CalendlyMappingView;
  /** Live Calendly scheduling links an operator can insert into an email, across the organization and tagged with the linked Revvly member. Empty when Calendly is not connected. */
  calendlySchedulingLinks: Array<CalendlySchedulingLink>;
  /** Whether you can manage contract templates and the clauses on contract records: workspace admins and owners. */
  canManageContracts: Scalars['Boolean']['output'];
  /** Catalog gaps across the tenant’s recently-billed clients — the products and past prices the invoices imply but the catalog lacks. Read-only. The scan is bounded and ordered by most recent invoice, so compare clientsScanned against clientsWithInvoices before reading an empty result as a complete catalog. */
  catalogGaps: TenantCatalogGapReportEntity;
  /** Catalog versions this client’s invoices imply but the catalog lacks — a missing past price of an existing product, or a product that was never modelled. Read-only: this creates nothing, and an accepted proposal is a separate, explicit catalog write. */
  catalogGapsForClient: CatalogGapReportEntity;
  /** Unified catalog listing (modules, bundles, variable components) for the Products table. Optionally filtered by type; status/search filtering is done client-side while catalogs are small. */
  catalogItems: Array<CatalogItem>;
  /** List all chat sessions the current user participates in, most recent first. */
  chatSessions: Array<ChatCreationSession>;
  /** Check if a region can be deleted and return dependency information including pricing rules count and legacy count. */
  checkRegionDeletionDependencies: RegionDeletionDependencies;
  /** Check if step auto-completion criteria is met */
  checkStepCompletion: Scalars['Boolean']['output'];
  checkin?: Maybe<Checkin>;
  /** People who are away now or will be, soonest first (tenant admins) */
  checkinAways: Array<CheckinAway>;
  /** Channels a report can be posted to: public ones, plus private ones the bot has been invited to */
  checkinChannels: CheckinChannelList;
  /** Who a selection of teams and people resolves to now, and who Slack can reach */
  checkinParticipantsPreview: Array<CheckinParticipant>;
  /** Check-ins, newest first (tenant admins) */
  checkins: Array<Checkin>;
  churnRate: Scalars['Float']['output'];
  /** Admins and owners only. The ClickUp Spaces, Folders, Lists and Docs a knowledge source can sync, read through the workspace's ClickUp connection. */
  clickUpDocLocations: Array<ClickUpDocLocation>;
  /** The public Chat channels in the connected workspace. Admin only */
  clickupChatChannels: Array<ClickUpChatChannelOption>;
  /** Linked people, email matches awaiting confirmation, and who is left. Admin only */
  clickupChatMapping: ClickUpChatMapping;
  /** This tenant’s ClickUp connection. A tenant that never connected reads DISCONNECTED */
  clickupConnection: ClickUpConnection;
  /** Contracts sent to a client and not recorded yet, newest first. */
  clientContractRequests: Array<ContractRequest>;
  /** Contracts waiting on a form that asks who signs, or stopped on the way. */
  clientContractSendPlans: Array<ContractSendPlan>;
  /** One form sent to or filled in for a client, by id. */
  clientFormSubmission: FormClientSubmission;
  /** Forms sent to one client or prospect, and their answers, newest first. */
  clientFormSubmissions: Array<FormClientSubmission>;
  /** A client's card on file. */
  clientSavedCard?: Maybe<SavedCardView>;
  /** The client stages. A tenant that never edited them runs on the defaults. */
  clientStages: ClientStageSettings;
  /** Reverse-reference count for a Variable Component — how many Modules and Bundles attach it. Drives the "used by N modules · M bundles" line on the editor. */
  componentUsage: ComponentUsage;
  /** The built-in contact roles, then the workspace’s own; retired ones included. */
  contactRoles: Array<ContactRole>;
  /** Every client bound by a signed contract and where it stands on one clause, with its DPO contacts. */
  contractClauseRegister: Array<ContractClauseRegisterRow>;
  /** Published forms a contract can start with, with the questions each asks. */
  contractForms: Array<ContractForm>;
  /** The plans on sale priced for a client's market: what an order form can name. Standard catalog prices. */
  contractOrderPlans: Array<ContractOrderPlanOption>;
  /** Published forms that can ask who signs: they bind the signer's name and email. */
  contractSignerForms: Array<ContractSignerForm>;
  /** Active members who can countersign, the same people sendContract accepts. */
  contractTeamMembers: Array<ContractTeamMember>;
  contractTemplate: ContractTemplate;
  /** The published versions of a contract, newest first. */
  contractTemplateVersions: Array<ContractTemplateVersion>;
  /** Contracts that can be sent. `includeDrafts` adds the ones never published, for the library. */
  contractTemplates: Array<ContractTemplate>;
  /** Private and hidden thread flags for this record. Another member’s private threads omit the owner id. */
  conversationThreadVisibilities: Array<ConversationThreadVisibility>;
  crmBoard: CrmBoard;
  crmDocumentCalendarInvite?: Maybe<CalendarInvitePreview>;
  crmDocumentCount: Scalars['Int']['output'];
  crmDocumentDownloadUrl?: Maybe<Scalars['String']['output']>;
  crmDocuments: Array<CrmDocument>;
  crmEmailMessages: Array<CrmEmailMessage>;
  crmEmailTemplate?: Maybe<CrmEmailTemplate>;
  /** Messages sent from a template the caller can see, newest first. */
  crmEmailTemplateUsage: CrmEmailTemplateUsage;
  /** Templates the caller can use: their private ones plus every shared template. */
  crmEmailTemplates: Array<CrmEmailTemplate>;
  /** The caller's last view of the pipeline Forecast table in this workspace, or null if they have never opened it. */
  crmForecastViewState?: Maybe<CrmForecastViewState>;
  /** One CRM import batch, including its failure list. */
  crmImportBatch: CrmImportBatch;
  /** Recent CRM contact and company import batches for this tenant, newest first. */
  crmImportBatches: Array<CrmImportBatch>;
  crmLead?: Maybe<CrmLead>;
  crmLeads: Array<CrmLead>;
  crmMeeting: CrmMeeting;
  crmMeetings: Array<CrmMeeting>;
  crmNotes: Array<CrmNote>;
  crmPipeline?: Maybe<CrmPipeline>;
  /** Pipelines the caller can access, default first. includeArchived adds archived ones after the active. */
  crmPipelines: Array<CrmPipeline>;
  crmTags: Array<CrmTag>;
  crmTimeline: CrmTimelineConnection;
  crmUpcomingMeetings: Array<CrmMeeting>;
  /** Clients per customer-success manager, busiest first, with the unassigned row last. */
  csmWorkload: Array<CsmWorkloadRow>;
  /** This month’s AI spend for one spender (budgetKey), or null when nothing has been spent yet. Null is "no calls", never "no ceiling". */
  currentAiSpend?: Maybe<AiBudgetPeriod>;
  /** State of an in-progress month, split into confirmed (earned) and scheduled (dated but not yet earned) movements, plus how much of the month’s recurring base has billed. Defaults to the current calendar month. */
  currentMonthProgress: CurrentMonthProgress;
  /** Get the currently selected tenant details */
  currentTenant?: Maybe<Tenant>;
  customFieldDefinitions: Array<CustomFieldDefinition>;
  customPricingAgreement?: Maybe<CustomPricingAgreement>;
  customPricingAgreements: Array<CustomPricingAgreement>;
  customerTaxProfile?: Maybe<CustomerTaxProfile>;
  /** The saved edits to a client's tax profile, newest first. */
  customerTaxProfileHistory: Array<CustomerTaxProfileChange>;
  /** Recent outbound messages, including the ones deliberately not sent */
  deliveryLog: Array<OutboundMessage>;
  /** Delivery outcomes over the last N days, including how many people were reached */
  deliveryStats: DeliveryStats;
  /** Tenant-wide rollups: active discounted value by currency, definition vs one-off counts, stacking-mode distribution, and expected recovery as counted discounts roll off (§10). */
  discountAnalytics: DiscountAnalytics;
  /** One library definition. */
  discountDefinition: DiscountDefinitionEntity;
  /** The §8.12 archive warning gate: every subscription whose active instance would be terminated by archiving this definition. Show this list before allowing the archive. */
  discountDefinitionArchiveCheck: DiscountArchiveCheck;
  /** Per-definition audit timeline (created/edited/stopped/archived), newest first. */
  discountDefinitionHistory: Array<DiscountHistoryEntry>;
  /** The tenant discount library, with per-definition active-instance usage (§10). */
  discountDefinitions: Array<DiscountDefinitionEntity>;
  /** Get count of pending discrepancies for the tenant */
  discrepancyCount: Scalars['Int']['output'];
  /** Views and downloads of the documents sent in one email or ticket, newest first. */
  documentShareViews: Array<DocumentViewEntity>;
  /** The links sent in one email (its message id) or one Support ticket (its id). */
  documentSharesForSource: Array<DocumentShareLinkEntity>;
  /** A synced Drive folder's subfolders and files, with its path. With no folder it opens the record's own folder. Any member. */
  driveBrowse: DriveBrowseResultEntity;
  driveClientFolderSettings: DriveClientFolderSettings;
  driveClientFoldersAuthUrl: GoogleDriveAuthUrl;
  driveFolderMapping: DriveFolderMappingPage;
  /** Files by name across every synced record folder. Any member. */
  driveSearch: Array<DriveBrowseEntryEntity>;
  driveSyncActivity: DriveSyncActivityPage;
  emailAttachmentDownloadUrl: EmailAttachmentDownload;
  /** Dated promises extracted from this client’s synced mail, overdue first. Promises on threads another member has marked private are omitted. */
  emailCommitments: Array<EmailCommitment>;
  emailCommunication?: Maybe<EmailCommunication>;
  /** What the AI tiers have produced, all time: Tier 1’s decisions and Tier 2’s extracted commitments. The counterpart to the spend ledger. */
  emailIntelligenceOutcomes: EmailIntelligenceOutcomes;
  /** Every counted open of one email, oldest first (newest 500 kept). Opens expire after a year, so an old email can list fewer than its openCount. */
  emailOpenEvents: Array<EmailOpenEvent>;
  /** The signature that would be applied to a message sent right now. */
  emailSignatureForSend?: Maybe<EmailSignature>;
  emailThread?: Maybe<EmailThread>;
  emailsByInvoice: EmailCommunicationConnection;
  emailsByOrganization: EmailCommunicationConnection;
  /** Get expansion and contraction metrics for a time period */
  expansionMetrics: ExpansionMetricsResponse;
  /** Get historical expansion and contraction metrics over time (monthly snapshots) */
  expansionTrend: Array<ExpansionTrendDataPoint>;
  /** Every active discount instance across the tenant with source, target, client, and renewals used vs remaining — the Expiring Discounts view (§10). */
  expiringDiscounts: Array<ExpiringDiscountRow>;
  /** The report as CSV with the tenant registration numbers, period and basis in the header rows. Tenant admins only: it carries the registration numbers and the full filing figures. */
  exportTaxReportCsv: Scalars['String']['output'];
  /** The same report as an Excel workbook, base64-encoded. Tenant admins only, like the CSV. */
  exportTaxReportXlsx: Scalars['String']['output'];
  /** The statuses a ClickUp list defines. */
  externalListStatuses: Array<ExternalStatus>;
  /** The ClickUp lists a task can be created in. Empty when ClickUp is not connected here. */
  externalLists: Array<ExternalList>;
  featureFlag: FeatureFlag;
  featureFlagByKey?: Maybe<FeatureFlag>;
  featureFlagCategories: Array<FeatureFlagCategory>;
  featureFlagCategory: FeatureFlagCategory;
  featureFlagCategoryByName?: Maybe<FeatureFlagCategory>;
  featureFlags: Array<FeatureFlag>;
  /** Get a presigned inline URL for previewing a file by its storage key */
  filePreviewUrl: PresignedDownloadUrl;
  form: Form;
  /** The senders a Send email step can use, and whether each is ready for the viewer. */
  formEmailSenders: Array<FormEmailSenderOption>;
  /** Slack channels a Post to Slack step can target. */
  formSlackChannels: FormSlackChannels;
  formSubmission: FormSubmission;
  formSubmissions: FormSubmissionPage;
  /** The submissions the filter selects, newest first, as CSV (`before` and `limit` are ignored). */
  formSubmissionsCsv: FormSubmissionExport;
  forms: Array<Form>;
  /** Every country a location can be in. A country filter is `country:<code>`. */
  geoCountries: Array<GeoCountry>;
  /** The built-in continents followed by the workspace's own regions. */
  geoRegions: Array<GeoRegion>;
  /** Get a specific file by ID */
  getFile?: Maybe<StoredFileEntity>;
  getSyncResults: Array<GoogleDriveSyncResultEntity>;
  /** Cmd-K: search clients, contacts, invoices and subscriptions across their fields, grouped and ranked, with typo tolerance */
  globalSearch: GlobalSearchResult;
  gmailAuthUrl: GmailAuthUrl;
  gmailIntegration: GmailIntegrationStatus;
  gmailSignatureCandidates: Array<GmailSignatureCandidate>;
  googleAuthUrl: GoogleAuthUrl;
  googleDriveAuthUrl: GoogleDriveAuthUrl;
  googleDriveConnection?: Maybe<GoogleDriveConnectionEntity>;
  /** Health check query to verify GraphQL endpoint is working */
  health: HealthStatus;
  /** Past import runs, newest first, with what each still holds. Admin only. */
  importBatches: Array<ImportBatchSummary>;
  /** Imported invoices matching a filter, for review before cleanup. Admin only. */
  importedInvoices: ImportedInvoicePage;
  inboxActionLog: Array<InboxActionLogEntry>;
  /** A short-lived link to one attachment of a message on the caller's own thread. */
  inboxAttachmentDownloadUrl: EmailAttachmentDownload;
  inboxCategoryPolicies: Array<InboxCategoryPolicy>;
  inboxCounts: InboxCounts;
  /** Whether drafting replies is switched on for this deployment (a model and a monthly ceiling are set). */
  inboxDraftsAvailable: Scalars['Boolean']['output'];
  inboxLearnedSenders: Array<InboxLearnedSender>;
  /** Replies the inbox drafted that are still worth reviewing: the thread is open and waiting, and the draft answers its latest message. */
  inboxReplyDrafts: Array<InboxReplyDraft>;
  inboxRules: Array<InboxRule>;
  inboxSettings: InboxSettings;
  inboxThread: InboxThread;
  /** The archive, mark-read or move the inbox did to one thread on its own, while Undo is still on offer; null otherwise. */
  inboxThreadAction?: Maybe<InboxActionLogEntry>;
  /** Invoices of this workspace the thread mentions (Finance on); empty otherwise. */
  inboxThreadInvoices: Array<InboxThreadInvoice>;
  inboxThreadMessages: Array<InboxMessage>;
  inboxThreads: InboxThreadPage;
  /** Open Unsorted threads grouped by sender, largest first, each with the Inbox’s best guess. */
  inboxUnsortedGroups: Array<InboxUnsortedGroup>;
  incubator: Incubator;
  incubatorFlags?: Maybe<IncubatorFlags>;
  incubators: ListIncubator;
  /** Slack accounts that can be invited, and a count of who was left out and why */
  invitableSlackMembers: InvitableSlackMembers;
  /** Get invitation details by token (public) */
  invitationByToken?: Maybe<UserTenant>;
  /** Admins’ requests for owners to send invitations */
  inviteApprovalRequests: Array<InviteApprovalRequest>;
  invoice?: Maybe<SubscriptionInvoice>;
  /** Weekly cash-flow breakdown: collected amounts (past weeks, from PAID invoices) and expected amounts (future weeks, from pending/overdue invoices). */
  invoiceCashFlowByWeek: Array<InvoiceCashFlowWeek>;
  /** How charging this invoice went. */
  invoiceCharge?: Maybe<InvoiceChargeView>;
  /** Get paginated invoice discrepancies for the tenant */
  invoiceDiscrepancies: PaginatedDiscrepanciesOutput;
  /** Line types reviewers have taught the invoice import, most recent first. */
  invoiceLineTypeRules: Array<InvoiceLineTypeRuleEntity>;
  invoices: Array<SubscriptionInvoice>;
  /** Check if Slack alerting is enabled and configured. */
  isAlertingEnabled: Scalars['Boolean']['output'];
  /** Check if onboarding is required for the tenant */
  isOnboardingRequired: Scalars['Boolean']['output'];
  /** Which clients in this sync job are ready to commit and what is holding the rest back. Commit runs per client because a client’s subscriptions are reconstructed from all of its invoices at once — so a client is offered only once every one of its rows is answered. Read-only: asking commits nothing. */
  jobCommitReadiness: JobCommitReadinessEntity;
  /** Every Key Result bound to any of these metrics, with its projection — the analytics overlay’s one query for the whole page */
  keyResultsForMetrics: Array<OkrKeyResult>;
  /** The top first path segments with counts, for one-click path filters. Honours the filter except its path. */
  knowledgeArticlePathGroups: Array<KbPathGroup>;
  knowledgeArticles: KbArticlePage;
  /** Admins and owners only. How many of the source's articles each rule would decide, for the rules editor. Nothing is saved. */
  knowledgeAudienceRulePreview: KbAudienceRulePreview;
  /** What in the knowledge base needs an admin’s attention. */
  knowledgeHealth: KnowledgeHealth;
  /** Pages whose audience could not be told. Not searchable until an admin decides. */
  knowledgeReviewQueue: Array<KbArticle>;
  knowledgeSources: Array<KnowledgeSource>;
  /** Whether the caller can add, change and archive library documents. */
  libraryCanManage: Scalars['Boolean']['output'];
  libraryDocument: LibraryDocumentEntity;
  /** A download link valid for 30 minutes, for the current version or a named one. */
  libraryDocumentDownloadUrl: Scalars['String']['output'];
  libraryDocumentShares: Array<DocumentShareLinkEntity>;
  /** How often each document was sent as a link and viewed. */
  libraryDocumentStats: Array<LibraryDocumentStatsEntity>;
  libraryDocumentVersions: Array<LibraryDocumentVersionEntity>;
  libraryDocuments: Array<LibraryDocumentEntity>;
  /** Documents by id (a template's linked documents). Missing or archived ones are left out. */
  libraryDocumentsByIds: Array<LibraryDocumentEntity>;
  /** Browse folders in the connected Google Drive. Pass parentId to expand a subfolder, omit for root. */
  listDriveFolders: Array<DriveFolderEntry>;
  /** List stored files with optional filtering and pagination */
  listFiles: StoredFileList;
  listUsers: Scalars['Boolean']['output'];
  mcpRemoteServers: Array<McpRemoteServerView>;
  /** Get the current authenticated user profile */
  me?: Maybe<User>;
  /** What the caller may do with Slack invitations in this company */
  memberInviteAccess: MemberInviteAccess;
  /** What the public join page shows for an invitation link (public) */
  memberInviteByToken: MemberInviteJoinInfo;
  /** The most inviting these people could cost per month. Seats are charged only when someone accepts */
  memberInviteQuote: MemberInviteQuote;
  /** Pending invitations, plus ones that expired or were revoked in the last month */
  memberInvites: Array<MemberInvite>;
  /** Preview the result of merging two organizations, including field conflicts and entity counts */
  mergeOrganizationPreview: MergeOrganizationPreview;
  meter: Meter;
  meterByType?: Maybe<Meter>;
  /** Dependency summary for a meter — whether it can be hard-deleted or must be deactivated. */
  meterUsage: CatalogUsage;
  /** Mid-period integration health for metered usage (Phase 6). Surfaces silent API meters and recent event rejects before period close. */
  meteredUsageIntegrationHealth: MeteredUsageIntegrationHealth;
  /** Dashboard tile counts for metered-usage operator work (R7). */
  meteredUsageOperationalSummary: MeteredUsageOperationalSummary;
  /** Get available meters for pricing configuration. A meter defines what is measured (seats, GB, calls); components bind a meter with a pricing model. Lives in Settings → Meters. */
  meters: Array<Meter>;
  module: Module;
  moduleStats: Stats;
  moduleTier: ModuleTier;
  /** Dependency summary for a module — whether it can be hard-deleted or must be deactivated. */
  moduleUsage: CatalogUsage;
  /** The version of a module lineage that was in force at `asOf`. `lineageId` addresses the whole version chain, so this answers "what was this plan on 2024-03-15" without the caller knowing which document that was. Null when `asOf` predates the lineage, or when no version of it was ever in force (drafts are never considered). */
  moduleVersionAt?: Maybe<Module>;
  modules: Array<Module>;
  /** Get detailed drill-down for a specific month showing subscription breakdowns */
  monthlyDrillDown: MonthlyDrillDown;
  /** Get MRR movement data showing month-over-month changes with attribution (new, expansion, contraction, churn, reactivation) */
  mrrMovement: MrrMovementSummary;
  /**
   * Export MRR movement data as CSV for download (deprecated, use mrrMovementXlsx)
   * @deprecated Use mrrMovementXlsx for consistent XLSX export format
   */
  mrrMovementCsv: Scalars['String']['output'];
  /** Export MRR movement data as XLSX for download (base64 encoded) */
  mrrMovementXlsx: Scalars['String']['output'];
  /** Whether the current user may delete their account, and why not if blocked */
  myAccountDeletionEligibility: AccountDeletionEligibility;
  /** This workspace's Revvly subscription, seats and invoices. Null when it was not self-serve. */
  myBilling?: Maybe<MyBilling>;
  /** The address of the caller's connected mailbox, or null when none is connected. */
  myConnectedMailbox?: Maybe<Scalars['String']['output']>;
  /** The current user's email signatures for this tenant, default first. */
  myEmailSignatures: Array<EmailSignature>;
  /** The roles the signed-in user holds, by grant or by being an administrator. Drives which controls a screen offers */
  myFunctionRoles: Array<FunctionRole>;
  /** The current user’s effective schedule and muted categories */
  myNotificationSettings: NotificationSettings;
  /** The current user's most recent acceptance of each policy. */
  myPolicyAcceptances: Array<PolicyAcceptance>;
  /** The current user's registered push devices for this tenant. */
  myPushSubscriptions: Array<PushSubscription>;
  mySignatures: Array<UserSignature>;
  myTasks: Array<Task>;
  /** Get all tenants I have access to */
  myTenants: Array<UserTenant>;
  /** Get Net Revenue Retention (NRR) for a time period. NRR > 100% indicates growth from existing customers */
  netRevenueRetention: NetRevenueRetention;
  notificationCenter: NotificationCenterConnection;
  /** Which incoming email puts a notification in your bell. */
  notificationCenterEmailScope: EmailNotificationScope;
  notificationCenterPreferences: Array<NotificationCenterPreference>;
  notificationCenterUnreadCount: Scalars['Int']['output'];
  /** Every message the product can send, for filtering the delivery log */
  notificationTemplates: Array<NotificationTemplate>;
  /** Get historical Net Revenue Retention over time (monthly snapshots) */
  nrrTrend: Array<NrrTrendDataPoint>;
  /** Company Key Results × teams for a cycle (the current one by default). Null when there is no cycle */
  okrCoverage?: Maybe<OkrCoverage>;
  /** Every Key Result’s hypothesis summary in a cycle, in one round trip */
  okrCycleHypothesisSummaries: Array<OkrKeyResultHypothesisSummary>;
  /** The active cycle (or the most recent one) with everything the screen renders */
  okrCycleView?: Maybe<OkrCycleView>;
  /** Every cycle, newest first */
  okrCycles: Array<OkrCycle>;
  /** Every open hypothesis in a cycle and the Key Results they can be carried to */
  okrHypothesesForClose: OkrHypothesisCloseCandidates;
  /** One hypothesis with its links, timeline and the records it is chained to */
  okrHypothesis: OkrHypothesisDetail;
  /** The in-flight board across Key Results. Opens on the active cycle when none is named. Null when there is no cycle */
  okrHypothesisBoard?: Maybe<OkrHypothesisBoard>;
  /** Per confidence level: how many concluded and how many validated */
  okrHypothesisCalibration: Array<OkrCalibrationLevel>;
  /** The library of concluded hypotheses across every cycle */
  okrHypothesisLearnings: OkrLearningsPage;
  /** The tests run on these Key Results, with start and end dates, for marking metric charts. One round trip for the whole analytics page */
  okrHypothesisTestMarkers: Array<OkrHypothesisTestMarker>;
  /** One Key Result with its check-ins and target history */
  okrKeyResult: OkrKeyResultDetail;
  /** Who a Key Result serves, who serves it, and what it may still be linked to */
  okrKeyResultAlignment: OkrKeyResultAlignment;
  /** A Key Result’s Hypotheses tab: the summary, then ranked, unscored and closed */
  okrKeyResultHypotheses: OkrKeyResultHypotheses;
  /** One Key Result’s hypothesis health, for screens that show it alone. Context only: it never changes a score */
  okrKeyResultHypothesisSummary: OkrKeyResultHypothesisSummary;
  /** The tasks linked to a Key Result, and whether this viewer can change them */
  okrKeyResultWorkLinks: OkrKeyResultWorkLinks;
  /** What the signed-in person owns in the current cycle: their Key Results, their objectives and their teams. Null when there is no cycle. */
  okrMine?: Maybe<OkrMyView>;
  /** Whether OKRs are sold, switched on, and what is blocking activation */
  okrModuleStatus: OkrModuleStatusType;
  /** Open hypotheses the signed-in person owns, and those needing a verdict */
  okrMyHypotheses: OkrMyHypotheses;
  /** Who still owes a score, and how far along the cycle is. Cycle owners only: it is the chase list */
  okrScoringStatus: OkrScoringStatus;
  /** Up to three past or open hypotheses like this text, by meaning when embeddings are configured, else by keyword */
  okrSimilarHypotheses: Array<OkrHypothesis>;
  /** One team’s objectives in a cycle (the current one when no id is given), what they link to upstream, and how much of the team’s work links to nothing. Readable by anyone. Null when there is no cycle. */
  okrTeamView?: Maybe<OkrTeamView>;
  /** Get the active onboarding configuration */
  onboardingConfig?: Maybe<OnboardingConfig>;
  /** Get current onboarding status for the tenant */
  onboardingStatus: OnboardingStatusResponse;
  /** Every open account situation in the workspace, most recent transition first — the attention queue. */
  openAccountSituations: Array<AccountSituation>;
  /** This tenant’s outstanding request for more seats, if there is one */
  openSeatRequest?: Maybe<SeatRequest>;
  /** Every outstanding seat request across tenants (platform admins) */
  openSeatRequests: Array<SeatRequest>;
  /** Open readings needing operator attention (AWAITING / UNVERIFIED by default). */
  openUsageReadings: Array<UsageReading>;
  /** Get a single organization by ID */
  organization: Organization;
  /** Get a single contact by ID */
  organizationContact?: Maybe<OrganizationContact>;
  /** Get all contacts for an organization */
  organizationContacts: Array<OrganizationContact>;
  /** Get all contacts with a specific label for an organization */
  organizationContactsByLabel: Array<OrganizationContact>;
  /** Get a paginated list of organization contacts with filtering, sorting, and search */
  organizationContactsPaginated: OrganizationContactConnection;
  /** One contract by id, or null when it belongs to another tenant. */
  organizationContract?: Maybe<OrganizationContract>;
  organizationDriveFolder: OrganizationDriveFolder;
  /** Timeline of lifecycle events across all subscriptions for one organization. Hard-capped at 1000 results. */
  organizationLifecycleEvents: Array<SubscriptionLifecycleEventEntity>;
  organizationSubscriptions: Array<OrganizationSubscription>;
  /** A client's tickets, for the client page tab (L25). */
  organizationSupportTickets: TicketConnection;
  /** Get all organizations in a specific region */
  organizationsByRegion: Array<Organization>;
  /** Get paginated list of organizations using cursor-based pagination with gte/lte filtering */
  organizationsPaginated: OrganizationConnection;
  /** Recent deliveries to one endpoint, newest first. Admin only. */
  outboundWebhookDeliveries: Array<OutboundWebhookDelivery>;
  /** This tenant's webhook endpoints. Admin only. */
  outboundWebhookEndpoints: Array<OutboundWebhookEndpoint>;
  /** The events a webhook endpoint can subscribe to. */
  outboundWebhookEventTypes: Array<OutboundWebhookEventTypeInfo>;
  paginatedInvoices: InvoiceConnection;
  /** The send composer templates filled in for one invoice. */
  paymentReminderDrafts: Array<RenderedPaymentReminder>;
  paymentReminderHistory: Array<PaymentReminder>;
  /** Placeholders a payment reminder template may use. */
  paymentReminderTemplatePlaceholders: Array<PaymentReminderTemplatePlaceholder>;
  /** Every payment reminder email, with the tenant copy merged over the defaults. */
  paymentReminderTemplates: Array<PaymentReminderTemplate>;
  /** Get payment time analytics grouped by organization */
  paymentTimeByOrganization: Array<PaymentTimeAnalytics>;
  /** Get payment time analytics grouped by region */
  paymentTimeByRegion: Array<PaymentTimeAnalytics>;
  /** Stripe connection for this workspace. Admin only. */
  paymentsSetup: PaymentsSetupInfo;
  /** Subscriptions signed but not yet switched on, worst-overdue first — revenue the workspace has sold and is not yet earning. `daysOverdue` is negative while the deal is still inside its activation window. */
  pendingActivations: Array<PendingActivation>;
  /** Simple ping query for basic connectivity testing */
  ping: Scalars['String']['output'];
  /** Self-serve billing settings: trial length, plans, regions, dunning (platform admin only) */
  platformBillingConfig: PlatformBillingConfig;
  /** Open and scheduled incidents, plus recent resolved ones (platform admin only). */
  platformIncidents: Array<PlatformIncident>;
  /** The company behind a domain, URL or work email, for the first step of creating a client or prospect: records that already hold the domain, what the company's own website states about itself (read by fixed rules, no model), people at the domain the workspace already knows, and a matching region. Stores nothing. */
  previewCompanyFromDomain: CompanyPreview;
  /** Quote a component count change without making it: the full-period difference, the proration and the amount adjustComponentUsage would invoice today. */
  previewComponentUsage: ComponentUsageQuote;
  /** The contract as sending it now would freeze it. Writes nothing. */
  previewContract: ContractPreview;
  /** Read a sentence into a rule to confirm. Saves nothing and sends nothing to a model. */
  previewInboxRule: InboxRulePreview;
  /** Preview what would happen if renewal processing ran now. Does NOT make changes. Scoped to the active tenant. tenantId, if given, must match the active tenant. */
  previewRenewalProcessing: RenewalPreviewOutput;
  /** The exact update a client would read when this ticket reaches a stage. Nothing is saved or sent. */
  previewStageUpdate: Scalars['String']['output'];
  /** Preview subscription import with renewal generation */
  previewSubscriptionImport: ImportSubscriptionsPreview;
  /** Project the creation-time charge for each Variable Component attached to a not-yet-created subscription — drives the create-subscription Live preview. The fee is 0 while the starting count is at/under the inclusion and the overage charge once it exceeds it. Never throws for a single un-priceable component; that line is returned with priced=false and a 0 fee. */
  previewSubscriptionVariableCharges: Array<VariableChargePreviewLine>;
  /** All scoped price documents for a Variable Component (Schema Reference v4 §3). Returns documents across all scopes (GLOBAL_DEFAULT, MODULE, BUNDLE, SUBSCRIPTION) matching the tenant. Filterable by componentVersion, scope, and status. Drives the Component Prices editor — operators see every variant at a glance. */
  pricesForComponent: Array<VariableComponentPrice>;
  pricing: PricingRuleConnection;
  /** Get current pricing cache statistics */
  pricingCacheStats: CacheStats;
  /** Get all possible pricing combinations for bundles and modules across regions, currencies, and periods */
  pricingCombinations: PricingCombinationsResponse;
  /** A single pricing draft by id (PRD §22). */
  pricingDraft?: Maybe<PricingDraftSummary>;
  /** Pending pricing-draft summaries for the trust-surface inbox (PRD §22). */
  pricingDrafts: Array<PricingDraftSummary>;
  pricingRule: PricingRule;
  /** The raw events stored for a client, newest first; narrow to one user or one event. Page with `after`. */
  productActivity: ProductActivityPage;
  /** The event inbox: every event name seen, with its mapping and the last 30 days of volume. */
  productEventCatalogue: ProductEventCatalogue;
  /** What one event looks like in practice: volume, clients and users over 30 days, twelve weeks of trend and the latest examples with their properties. Workspace admins and owners only. */
  productEventDetail: ProductEventDetail;
  /** The workspace’s product-usage settings: which origins may send events from the browser. Workspace admins and owners only. */
  productEventSettings: ProductEventSettings;
  /** The feature flags, modules or bundles an event can be tied to. */
  productEventTargets: Array<ProductEventTarget>;
  /** What a client used, by feature flag, module and bundle, over the last `days` completed days (7 to 90), from the nightly rollup. Today is not included. */
  productFeatureUsage: ProductFeatureUsage;
  /** Product usage across every client of the workspace over the last `days` completed days (7 to 90), from the nightly rollup: the busiest clients and the features in use. Today is not included. */
  productUsageOverview: ProductUsageOverview;
  /** A client’s browser sessions over the last `days` calendar days (7 to 90): count, average length and the pages viewed, against the same number before. */
  productUsageSessions: ProductUsageSessions;
  /** A client’s product usage over the last `days` calendar days (7 to 90, default 30) against the same number before. */
  productUsageSummary: ProductUsageSummary;
  /** How often one event fires at a client, bucket by bucket. */
  productUsageTrend: ProductUsageTrend;
  /** One user at one client: their activity over the last `days` calendar days. */
  productUsageUser: ProductUsageUser;
  /** One person across every client of the workspace over the last `days` calendar days: identity, activity, top events and a row per client. */
  productUserProfile: ProductUserProfile;
  /** Project billing for every Variable Component on a subscription — drives the projected-invoice mid-period preview. */
  projectSubscriptionVariableBilling: Array<ProjectedVariableBilling>;
  /** Project billing for a single Variable Component on a subscription. Supports a scenario override for what-if simulation. */
  projectVariableBilling: ProjectedVariableBilling;
  /** Live preview of the variable invoice lines a subscription would bill right now (PRD §20.2 / Epic D2-D3). Pure projection — resolves prices and runs the model math without writing snapshots or mutating usage. */
  projectedVariableInvoiceLines: Array<ProjectedInvoiceLine>;
  /** Publish-readiness inspection for a Module or Bundle draft (v4 design spec §F-04). For every variableComponentRefs[] entry and every currency the parent supports, reports whether a PUBLISHED price exists at the parent scope OR GLOBAL_DEFAULT. Operators see the full coverage matrix before they hit Publish — and unblock by adding the missing currency variant in the gap row itself. */
  publishGapCheck: PublishGapResult;
  /** VAPID public key used by the client to create a browser PushSubscription. Null when web push is not configured on the server. */
  pushPublicKey?: Maybe<Scalars['String']['output']>;
  /** Get comprehensive receivables analytics for the tenant */
  receivablesAnalytics: ReceivablesAnalytics;
  recurrenceRule?: Maybe<RecurrenceRule>;
  recurrenceRules: Array<RecurrenceRule>;
  /** Get a region by ID */
  region: Region;
  /** Get a region by code */
  regionByCode?: Maybe<Region>;
  /** Get all regions with optional filtering by name, code, currency, or active status */
  regions: Array<Region>;
  /** Get all regions that use a specific currency */
  regionsByCurrency: Array<Region>;
  /** Releases newest first. upToVersion is the dashboard’s own version: releases above it are hidden. */
  releaseNotes: ReleaseNoteConnection;
  /** How many releases worth a dot the caller has not read yet. */
  releaseNotesUnreadCount: Scalars['Int']['output'];
  /** What the Revvly icon announces: the unread count and the release to name. */
  releaseNotesUnreadSummary: ReleaseNotesUnreadSummary;
  /** Get a specific renewal action by ID */
  renewalAction?: Maybe<RenewalAction>;
  /** Get statistics for renewal actions in the current tenant */
  renewalActionStats: RenewalActionStatsOutput;
  /** Get renewal actions for the current tenant */
  renewalActions: Array<RenewalAction>;
  renewalCalendar: RenewalCalendar;
  /** Get a presigned URL for downloading a file from storage */
  requestDownloadUrl: PresignedDownloadUrl;
  /** Render the price-resolution walk for a single (component, version, currency, context) — the "why is this billed at $X?" forensic surface (v4 design spec §F-06). Steps are ordered most-specific to least-specific (SUBSCRIPTION → BUNDLE → MODULE → GLOBAL_DEFAULT) and each step reports whether it was skipped, no-matched, applied, or would-fall-to. */
  resolvePriceWalk: ScopeWalkResult;
  /** Resolve the effective price for a component on a subscription (PRD §17.4) by walking the specificity chain in the subscription's locked currency. Null when no scope covers it. */
  resolvedPriceForSubscription?: Maybe<ResolvedPrice>;
  /** Resume an existing chat session the current user participates in, or null if not found. */
  resumeChatSession?: Maybe<ChatCreationSession>;
  /** AI feedback on a Key Result before it is saved. Advice only: nothing is stored and nothing is refused */
  reviewOkrKeyResultDraft: OkrDraftReviewType;
  /** AI feedback on an objective before it is saved. Advice only: nothing is stored and nothing is refused */
  reviewOkrObjectiveDraft: OkrDraftReviewType;
  /** What to review next and what the catalog has learned so far. Ordered as a curriculum — one representative of every billing shape first, then depth on the products closest to earning autonomy, then disagreements and novelty — rather than as a list to be emptied. Read-only: nothing is confirmed, linked or written by asking. */
  reviewQueue: ReviewQueueEntity;
  /** Folders in the connected Google Drive whose name contains this text (at least 2 characters), each with its full path. At most 25. */
  searchDriveFolders: Array<DriveFolderSearchResult>;
  /** Search organizations by name, description, email, or contact */
  searchOrganizations: Array<Organization>;
  /** The append-only record of seats consumed, released and re-priced */
  seatLedger: Array<SeatEvent>;
  /** How many seats this tenant is using, against its limit and price */
  seatUsage: SeatUsage;
  signatureRequest: SignatureRequestDetail;
  /** The contract as a PDF: a draft until everyone has signed. */
  signatureRequestPdf: ContractPdf;
  /** What a price per credit and a set of rules would have done to the last days of real usage. Writes nothing (platform admin only). */
  simulateAiCreditPrice: AiCreditSimulation;
  /** The thresholds that decide when each account situation opens: the values in force, the defaults, and which values this workspace has changed. */
  situationThresholds: SituationThresholdSettings;
  /** Confirmed links, proposed matches and the unmapped, for the mapping screen */
  slackMemberMapping: SlackMappingView;
  /** Public channels the announcement picker can offer */
  slackPublicChannels: Array<SlackChannelOption>;
  /** This tenant’s Slack connection and how far setup has got */
  slackWorkspace: SlackWorkspaceStatus;
  /** A sample of the invoices each earned product is matching without review. Offered, never required: an earned product is the one place the matcher can be confidently wrong at volume, and this is the only way back to those invoices. Read-only. */
  spotCheck: SpotCheckReportEntity;
  statusWorkflows: Array<StatusWorkflow>;
  /** Get storage usage statistics for the tenant */
  storageStats: StorageStats;
  subscription: OrganizationSubscription;
  /** When and how a subscription is invoiced. Answers for every subscription: one that stores no schedule follows the implicit default (base and ADVANCE components at period start, ARREARS components at period close), which is returned with isExplicit false. */
  subscriptionBillingSchedule: BillingSchedule;
  /** Per-subscription billing-timing override audit timeline, newest first (PRD §7.5). */
  subscriptionBillingTimingOverrideHistory: Array<BillingTimingOverrideHistoryEntry>;
  /** Effective billing timing per component on a subscription: product default vs override, what the current cycle bills under, and whether a change is queued for the next cycle (PRD §6 story 4). */
  subscriptionComponentBillingTimings: Array<ComponentBillingTimingStatus>;
  /** The contract a subscription is sold under. Zero or one row: a subscription takes its committed term from exactly one contract, so that commitmentEndDate has a single source. */
  subscriptionContracts: Array<OrganizationContract>;
  subscriptionCost: Scalars['Float']['output'];
  /** Per-subscription discount audit timeline, newest first (§8.14). */
  subscriptionDiscountHistory: Array<DiscountHistoryEntry>;
  /** All discount instances on a subscription (any status), with the §8.7 pending/superseded flag. */
  subscriptionDiscountInstances: Array<DiscountInstanceEntity>;
  /** Preview the next invoice's discount chain per target: pre-discount effective amount → each contribution → floored final amount (§8.13). Optionally under a different stacking mode. */
  subscriptionDiscountPreview: Array<DiscountPreviewLine>;
  /** Get a specific expansion by ID */
  subscriptionExpansion?: Maybe<SubscriptionExpansion>;
  /** Calculate total expansion cost for a subscription */
  subscriptionExpansionCost: Scalars['Float']['output'];
  /** Get expansion history for a specific subscription */
  subscriptionExpansionHistory: Array<SubscriptionExpansion>;
  /** Get expansion statistics for a subscription */
  subscriptionExpansionStatistics: ExpansionStatistics;
  /** Get subscription expansions with optional filtering */
  subscriptionExpansions: Array<SubscriptionExpansion>;
  /** Export active subscriptions as XLSX with organization, plan, variable pricing, dates, and total amount (base64 encoded) */
  subscriptionExportXlsx: Scalars['String']['output'];
  /** Timeline of lifecycle events for one subscription (oldest first). */
  subscriptionLifecycleEvents: Array<SubscriptionLifecycleEventEntity>;
  /** The subscriptions this client’s unlinked invoices imply, grouped by billing shape and cadence. Read-only: nothing is created, linked or written by asking. Pass the returned planHash to commitSubscriptionPlan to apply exactly what was reviewed. */
  subscriptionPlanForClient: ClientSubscriptionPlanEntity;
  /** Per-subscription price-override audit timeline, newest first (PRD §7.5). */
  subscriptionPriceOverrideHistory: Array<PriceOverrideHistoryEntry>;
  /** A subscription's billing-schedule trigger log, newest first — which charge fired when, on which invoice, and for which periods. Append-only. */
  subscriptionScheduleTriggerEvents: Array<ScheduleTriggerEventEntity>;
  /** List Variable Component usage records on a subscription */
  subscriptionVariableUsage: Array<SubscriptionVariableUsage>;
  /** Append-only pin-change history for a subscription, oldest-first. Optionally filter by changeType and a [from, to] timestamp window. */
  subscriptionVersionHistory: Array<SubscriptionVersionEntry>;
  subscriptions: SubscriptionConnection;
  /** Active subscriptions with at least one stale pin (module, bundle, or component) and the per-pin diff between pinnedVersion and the latest published version. Subscriptions whose pin is deliberate — grandfathered onto a legacy plan, or a reconstructed history — are EXCLUDED unless includeGrandfathered is set: they are contracts to honour, not work to clear, and this list drives a bulk-migrate action. */
  subscriptionsWithOutdatedPins: Array<SubscriptionWithStalePins>;
  /** Candidate existing subscriptions the reviewer could link this sync result to instead of creating a new subscription. Ranked by likelihood (overlap > contiguous > near-renewal > backfill > historical). Returns an empty array if the result has no matched organization yet. */
  suggestSubscriptionsForSyncResult: Array<SubscriptionSuggestionEntity>;
  /** People in the tenant's own contacts and email traffic who share this client's or prospect's email domain and are not yet contacts of it. Returns a null domain (and no suggestions) when the record has no usable company domain. */
  suggestedOrganizationContacts: OrganizationContactSuggestions;
  /** Admins and owners only. The attribute keys on your people and the values each takes, so a role rule can name values that exist. */
  supportAttributeSummary: Array<SupportAttributeSummary>;
  /** A client's plan, base MRR, billing standing and ticket load, for the ticket context panel and the client page (L25). Billing fields are visible to every active member of the workspace, as they are on the Clients pages. */
  supportClientContext: SupportClientContext;
  /** Admins and owners only. The sample and its AI cost before a run starts. Reads only. */
  supportCompareEstimate: SupportCompareEstimate;
  /** Admins and owners only. What a comparison needs (imported conversations, knowledge, AI) and the latest run. */
  supportCompareOverview: SupportCompareOverview;
  /** Admins and owners only. A run's conversations in sample order. */
  supportCompareResults: SupportCompareResultPage;
  /** Admins and owners only. A run by id, or the latest when no id is given. */
  supportCompareRun?: Maybe<SupportCompareRun>;
  /** Admins and owners only. Every comparison run, newest first (up to `first`, at most 100), for the history table. */
  supportCompareRuns: Array<SupportCompareRun>;
  supportGuidelineLimits: SupportGuidelineLimits;
  supportGuidelines: Array<SupportGuideline>;
  /** Admins and owners only. */
  supportImportRun: SupportImportRun;
  /** Admins and owners only. Newest first. */
  supportImportRuns: Array<SupportImportRun>;
  supportInboxCounts: SupportInboxCounts;
  /** Clients and sources to offer in the inbox filter menu. */
  supportInboxFacets: SupportInboxFacets;
  /** The thread, including internal notes. The latest page first; page back with `before`. */
  supportMessages: SupportMessageConnection;
  supportMetrics: Array<SupportMetricRow>;
  supportNotificationPreferences: Array<SupportNotificationPreference>;
  supportNotificationUnreadCount: Scalars['Int']['output'];
  supportNotifications: SupportNotificationConnection;
  /** People: the tenant's end users, most recently seen first. */
  supportPeople: SupportEndUserConnection;
  supportPerson: SupportEndUser;
  supportRoles: Array<SupportRole>;
  /** Your practice workspace, or null until it is first opened. Changes nothing. */
  supportSandbox?: Maybe<SupportSandbox>;
  /** Full-text search across ticket titles and messages, internal notes included (I3). A ticket number finds that ticket first. */
  supportSearch: Array<SupportSearchHit>;
  supportSettings: SupportSettings;
  supportTicket?: Maybe<SupportTicket>;
  /** The audit timeline, newest first (T5). */
  supportTicketEvents: TicketEventConnection;
  /** The inbox: newest activity first. */
  supportTickets: TicketConnection;
  supportViewerAccess: SupportViewerAccess;
  /** Get all supported currencies with their details */
  supportedCurrencies: Array<CurrencyInfo>;
  /** Past imports, newest first, each with how far through its review a person is. */
  syncJobHistory: Array<GoogleDriveSyncJobEntity>;
  syncJobStatus?: Maybe<GoogleDriveSyncJobEntity>;
  /** Presigned URL to preview the stored file for a Google Drive sync result (inline PDF/image) */
  syncResultFilePreviewUrl: PresignedDownloadUrl;
  /** Staged sync results by id, from any job. For callers that already know which rows they want — a spot-check sample is drawn tenant-wide, and its members can come from different imports, so there is no one job to ask for. Rows that do not exist, or belong to another tenant, are simply absent: the caller is reconciling against a list it already holds, and a row that has since been answered or removed is a normal outcome, not an error. */
  syncResultsByIds: Array<GoogleDriveSyncResultEntity>;
  /** Messages on a synced thread, oldest first, most recent page when a thread exceeds the limit. Empty when the thread is not visible to this viewer. */
  syncedEmailMessages: Array<SyncedEmailMessage>;
  /** One synced email thread. Null when it does not exist, or when another member has marked it private — the two are deliberately indistinguishable. */
  syncedEmailThread?: Maybe<SyncedEmailThread>;
  /** Synced email threads resolved to this client, most recent activity first. Threads another member has marked private are omitted. */
  syncedEmailThreads: Array<SyncedEmailThread>;
  task?: Maybe<Task>;
  tasks: TaskConnection;
  /** Taxed invoices whose tax differs from the sum of their ledger rows. Tenant admins only. */
  taxLedgerMismatches: Array<TaxLedgerMismatch>;
  /** What an invoice for these lines would carry, using the same calculation the billing engine uses. Writes nothing. */
  taxPreview: TaxPreviewResult;
  taxRates: Array<TaxRate>;
  /** Revvly's reference rates by country, with how much of each this tenant has imported. */
  taxReferenceCountries: Array<TaxReferenceCountrySummary>;
  taxReferenceCountry: TaxReferenceCountry;
  /** Imported rates the reference data has moved away from since they were imported. */
  taxReferenceDrift: Array<TaxReferenceDrift>;
  taxReferenceInfo: TaxReferenceInfo;
  taxRegistrations: Array<TaxRegistration>;
  /** Tax collected over a period, one total per currency, on the accrual (default) or cash basis. Credit notes net against what they credit. */
  taxReport: TaxReport;
  taxSettings: TaxSettings;
  /** The ledger rows behind a report line. */
  taxTransactions: TaxTransactionPage;
  /** One team with its full member list */
  team: TeamDetail;
  /** Whether a team can be archived, and the specific reason from each feature that says no */
  teamArchiveEligibility: TeamArchiveEligibility;
  teamEmailConnections: Array<TeamEmailConnection>;
  /** Every team in the tenant, sorted by name. Readable by any member */
  teams: Array<Team>;
  tenant?: Maybe<Tenant>;
  tenantBySlug?: Maybe<Tenant>;
  /** The workspace-wide schedule everyone follows unless they chose otherwise */
  tenantNotificationDefaults: TenantNotificationDefaults;
  /** Everyone in the tenant with their team affiliations, for the people picker and member panels */
  tenantPeople: Array<TeamPerson>;
  /** Every function role with its holders, distinguishing direct grants from account administrators */
  tenantRoles: Array<FunctionRoleSummary>;
  /** Seat usage for any tenant (platform admins) */
  tenantSeatUsage: SeatUsage;
  /** Get all users for the current tenant */
  tenantUsers: Array<UserTenant>;
  /** The current tenant's working days and timezone (Monday–Friday until an admin changes it) */
  tenantWorkingCalendar: TenantWorkingCalendar;
  /** Get all tenants (platform administrators only) */
  tenants: Array<Tenant>;
  ticketTypes: Array<TicketType>;
  /** The work items linked to a ticket, and whether ClickUp is connected here. */
  ticketWorkItems: TicketWorkItems;
  /** Get all organizations on trial (active or expired) */
  trialOrganizations: Array<Organization>;
  unmatchedInvoicesCount: Scalars['Int']['output'];
  /** People a check-in would ask but Slack cannot reach */
  unreachableParticipants: Array<CheckinParticipant>;
  /** Synced email threads ingestion could not link to a client — the triage queue. Most recent activity first. Threads another member has marked private are omitted. */
  unresolvedSyncedEmailThreads: Array<SyncedEmailThread>;
  upcomingRenewals: Array<RenewalCalendarEvent>;
  /** Audit log for a (subscription, variable) pair, used for dispute investigation. Records are immutable; no mutation surface exists. */
  usageAuditLog: Array<VariableUsageAudit>;
  /** Durable closed-period readings for a subscription, newest first (R7). */
  usageReadingsForSubscription: Array<UsageReading>;
  /** Get a user by their ID */
  user?: Maybe<User>;
  /** The teams one person belongs to */
  userTeams: Array<Team>;
  variableComponent?: Maybe<VariableComponent>;
  /** Aggregate variable-pricing metrics for the catalog list KPI strip. V1 uses approximations suitable for a dashboard tile, not financial reports — see VariableComponentMetricsService docstring. */
  variableComponentMetrics: VariableComponentMetrics;
  /** Status-count rollup (total / published / draft / archived) for the catalog "Components" KPI tile. Parallel to moduleStats / bundleStats. */
  variableComponentStats: VariableComponentStats;
  /** Dependency summary for a variable component. Components are archive-only, so this reports what references it before deactivation. */
  variableComponentUsage: CatalogUsage;
  /** The version of a variable-component lineage that was in force at `asOf`. `lineageId` addresses the whole version chain, so this answers "what was this component on 2024-03-15" without the caller knowing which document that was. Null when `asOf` predates the lineage, or when no version of it was ever in force (drafts are never considered). */
  variableComponentVersionAt?: Maybe<VariableComponent>;
  variableComponents: Array<VariableComponent>;
  /** Tenant admins and owners only. Deliveries, newest first, kept for 30 days. */
  webhookDeliveries: WebhookDeliveryConnection;
  /** Tenant admins and owners only. Webhook endpoints with the last day of their deliveries. */
  webhookEndpoints: Array<WebhookEndpoint>;
  /** The list each ticket type’s tasks are created in by default. */
  workItemRouting: Array<WorkItemRouting>;
  /** Which client stage each ClickUp status means, per list and as a default. */
  workItemStatusMaps: Array<StatusMap>;
  /** The date `days` working days from now under the tenant calendar, as midnight UTC of that local day — the encoding a task due date uses. Counting starts tomorrow; the result is always a working day. */
  workingDaysFromNow: Scalars['DateTime']['output'];
  /** Whether the client’s linked workspace may have its data deleted (blocked 90 days; platform admin only) */
  workspaceDataDeletion: WorkspaceDataDeletionStateType;
};

export type QueryAccountSituationsArgs = {
  organizationId: Scalars['ID']['input'];
};

export type QueryActiveOrganizationSubscriptionArgs = {
  organizationId: Scalars['ID']['input'];
};

export type QueryAgentSessionArgs = {
  id: Scalars['ID']['input'];
};

export type QueryAgentSessionsArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryAiEconomicsArgs = {
  period?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryAiResolutionUsageArgs = {
  period: Scalars['String']['input'];
};

export type QueryAiSpendArgs = {
  budgetKey: Scalars['String']['input'];
  periods?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryAiUsageSummaryArgs = {
  period?: InputMaybe<Scalars['String']['input']>;
};

export type QueryAnalyzeCombinedImportArgs = {
  driveJobId: Scalars['String']['input'];
  input: ImportTransactionsInput;
};

export type QueryAnalyzeImportArgs = {
  input: ImportTransactionsInput;
};

export type QueryApiKeyArgs = {
  id: Scalars['ID']['input'];
};

export type QueryApiKeyUsageArgs = {
  id: Scalars['ID']['input'];
};

export type QueryApiKeysArgs = {
  includeRevoked?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryArrTrendArgs = {
  endMonth?: InputMaybe<Scalars['String']['input']>;
  months?: InputMaybe<Scalars['Int']['input']>;
  startMonth?: InputMaybe<Scalars['String']['input']>;
};

export type QueryAssistantOnboardingFunnelArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryAvailableExchangeRatesArgs = {
  reportingCurrency?: Scalars['String']['input'];
};

export type QueryBilledRevenueByLineKindArgs = {
  from: Scalars['DateTime']['input'];
  period?: Scalars['String']['input'];
  to: Scalars['DateTime']['input'];
};

export type QueryBillingPeriodSnapshotArgs = {
  invoiceId: Scalars['ID']['input'];
};

export type QueryBookingIntakeRevertPreviewArgs = {
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};

export type QueryBundleArgs = {
  id: Scalars['ID']['input'];
};

export type QueryBundleUsageArgs = {
  id: Scalars['ID']['input'];
};

export type QueryBundleVersionAtArgs = {
  asOf: Scalars['DateTime']['input'];
  lineageId: Scalars['ID']['input'];
};

export type QueryBundlesArgs = {
  filter?: InputMaybe<BundleFilterInput>;
};

export type QueryCalculateBundlePricingArgs = {
  bundleId: Scalars['ID']['input'];
  currency?: Scalars['String']['input'];
  period: SubscriptionPeriod;
  regionId: Scalars['String']['input'];
};

export type QueryCalculateModulesPricingArgs = {
  currency?: Scalars['String']['input'];
  moduleIds: Array<Scalars['ID']['input']>;
  moduleTiers?: InputMaybe<Array<ModuleTierSelectionInput>>;
  period: SubscriptionPeriod;
  regionId: Scalars['String']['input'];
};

export type QueryCalculatePriceChangeArgs = {
  changes: UpdateOrganizationSubscriptionInput;
  subscriptionId: Scalars['ID']['input'];
};

export type QueryCalculateProratedAmountArgs = {
  changeDate?: InputMaybe<Scalars['DateTime']['input']>;
  newPrice: Scalars['Float']['input'];
  subscriptionId: Scalars['ID']['input'];
};

export type QueryCatalogGapsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryCatalogGapsForClientArgs = {
  organizationId: Scalars['String']['input'];
};

export type QueryCatalogItemsArgs = {
  type?: InputMaybe<CatalogItemType>;
};

export type QueryCheckRegionDeletionDependenciesArgs = {
  id: Scalars['String']['input'];
};

export type QueryCheckStepCompletionArgs = {
  stepId: Scalars['String']['input'];
};

export type QueryCheckinArgs = {
  id: Scalars['ID']['input'];
};

export type QueryCheckinParticipantsPreviewArgs = {
  selection: CheckinParticipantsInput;
};

export type QueryCheckinsArgs = {
  includeArchived?: Scalars['Boolean']['input'];
};

export type QueryChurnRateArgs = {
  period?: Scalars['String']['input'];
};

export type QueryClientContractRequestsArgs = {
  organizationId: Scalars['ID']['input'];
};

export type QueryClientContractSendPlansArgs = {
  organizationId: Scalars['ID']['input'];
};

export type QueryClientFormSubmissionArgs = {
  id: Scalars['ID']['input'];
};

export type QueryClientFormSubmissionsArgs = {
  organizationId: Scalars['ID']['input'];
};

export type QueryClientSavedCardArgs = {
  organizationId: Scalars['ID']['input'];
};

export type QueryComponentUsageArgs = {
  componentId: Scalars['ID']['input'];
};

export type QueryContractClauseRegisterArgs = {
  kind: ContractClauseKind;
};

export type QueryContractOrderPlansArgs = {
  organizationId: Scalars['ID']['input'];
};

export type QueryContractTemplateArgs = {
  id: Scalars['ID']['input'];
};

export type QueryContractTemplateVersionsArgs = {
  id: Scalars['ID']['input'];
};

export type QueryContractTemplatesArgs = {
  includeDrafts?: Scalars['Boolean']['input'];
};

export type QueryConversationThreadVisibilitiesArgs = {
  organizationId: Scalars['ID']['input'];
};

export type QueryCrmBoardArgs = {
  pipelineId?: InputMaybe<Scalars['ID']['input']>;
  pipelineIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type QueryCrmDocumentCalendarInviteArgs = {
  id: Scalars['ID']['input'];
};

export type QueryCrmDocumentCountArgs = {
  categories?: InputMaybe<Array<CrmDocumentCategory>>;
  search?: InputMaybe<Scalars['String']['input']>;
  sources?: InputMaybe<Array<CrmDocumentSource>>;
  subjectId: Scalars['ID']['input'];
  subjectType: EntityTargetType;
  view?: InputMaybe<CrmDocumentView>;
};

export type QueryCrmDocumentDownloadUrlArgs = {
  id: Scalars['ID']['input'];
};

export type QueryCrmDocumentsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  categories?: InputMaybe<Array<CrmDocumentCategory>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sources?: InputMaybe<Array<CrmDocumentSource>>;
  subjectId: Scalars['ID']['input'];
  subjectType: EntityTargetType;
  view?: InputMaybe<CrmDocumentView>;
};

export type QueryCrmEmailMessagesArgs = {
  subjectId: Scalars['ID']['input'];
  subjectType: EntityTargetType;
};

export type QueryCrmEmailTemplateArgs = {
  id: Scalars['ID']['input'];
};

export type QueryCrmEmailTemplateUsageArgs = {
  id: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryCrmEmailTemplatesArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  visibility?: InputMaybe<EmailTemplateVisibility>;
};

export type QueryCrmImportBatchArgs = {
  id: Scalars['ID']['input'];
};

export type QueryCrmImportBatchesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryCrmLeadArgs = {
  id: Scalars['ID']['input'];
};

export type QueryCrmLeadsArgs = {
  filter?: InputMaybe<CrmLeadFilter>;
};

export type QueryCrmMeetingArgs = {
  id: Scalars['ID']['input'];
};

export type QueryCrmMeetingsArgs = {
  includeUpcoming?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  subjectId: Scalars['ID']['input'];
  subjectType: EntityTargetType;
};

export type QueryCrmNotesArgs = {
  subjectId: Scalars['ID']['input'];
  subjectType: EntityTargetType;
};

export type QueryCrmPipelineArgs = {
  id: Scalars['ID']['input'];
};

export type QueryCrmPipelinesArgs = {
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryCrmTimelineArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  subjectId: Scalars['ID']['input'];
  subjectType: EntityTargetType;
};

export type QueryCrmUpcomingMeetingsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  subjectId: Scalars['ID']['input'];
  subjectType: EntityTargetType;
};

export type QueryCurrentAiSpendArgs = {
  budgetKey: Scalars['String']['input'];
};

export type QueryCurrentMonthProgressArgs = {
  month?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCustomFieldDefinitionsArgs = {
  entityType: CustomFieldEntityType;
  includeRetired?: Scalars['Boolean']['input'];
};

export type QueryCustomPricingAgreementArgs = {
  id: Scalars['ID']['input'];
};

export type QueryCustomPricingAgreementsArgs = {
  filter?: InputMaybe<CustomPricingAgreementFilterInput>;
};

export type QueryCustomerTaxProfileArgs = {
  organizationId: Scalars['ID']['input'];
};

export type QueryCustomerTaxProfileHistoryArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['ID']['input'];
};

export type QueryDeliveryLogArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<OutboundMessageStatus>;
  templateKey?: InputMaybe<Scalars['String']['input']>;
};

export type QueryDeliveryStatsArgs = {
  days?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryDiscountAnalyticsArgs = {
  rolloffHorizon?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryDiscountDefinitionArgs = {
  id: Scalars['ID']['input'];
};

export type QueryDiscountDefinitionArchiveCheckArgs = {
  id: Scalars['ID']['input'];
};

export type QueryDiscountDefinitionHistoryArgs = {
  definitionId: Scalars['ID']['input'];
};

export type QueryDocumentShareViewsArgs = {
  sourceId: Scalars['String']['input'];
  sourceType: DocumentShareSourceType;
};

export type QueryDocumentSharesForSourceArgs = {
  sourceId: Scalars['String']['input'];
  sourceType: DocumentShareSourceType;
};

export type QueryDriveBrowseArgs = {
  folderId?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryDriveFolderMappingArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type QueryDriveSearchArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  search: Scalars['String']['input'];
};

export type QueryDriveSyncActivityArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<DriveSyncStatus>;
};

export type QueryEmailAttachmentDownloadUrlArgs = {
  mailboxEmailId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  storagePath: Scalars['String']['input'];
};

export type QueryEmailCommitmentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['ID']['input'];
};

export type QueryEmailCommunicationArgs = {
  id: Scalars['ID']['input'];
};

export type QueryEmailOpenEventsArgs = {
  emailId: Scalars['ID']['input'];
};

export type QueryEmailThreadArgs = {
  threadId: Scalars['String']['input'];
};

export type QueryEmailsByInvoiceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  invoiceId: Scalars['ID']['input'];
};

export type QueryEmailsByOrganizationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  contactEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['ID']['input'];
  participantEmails?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type QueryExpansionMetricsArgs = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};

export type QueryExpansionTrendArgs = {
  endMonth?: InputMaybe<Scalars['String']['input']>;
  months?: InputMaybe<Scalars['Int']['input']>;
  startMonth?: InputMaybe<Scalars['String']['input']>;
};

export type QueryExpiringDiscountsArgs = {
  filter?: InputMaybe<ExpiringDiscountsFilterInput>;
};

export type QueryExportTaxReportCsvArgs = {
  input: TaxReportInput;
};

export type QueryExportTaxReportXlsxArgs = {
  input: TaxReportInput;
};

export type QueryExternalListStatusesArgs = {
  listId: Scalars['ID']['input'];
};

export type QueryFeatureFlagArgs = {
  id: Scalars['ID']['input'];
};

export type QueryFeatureFlagByKeyArgs = {
  key: Scalars['String']['input'];
};

export type QueryFeatureFlagCategoryArgs = {
  id: Scalars['ID']['input'];
};

export type QueryFeatureFlagCategoryByNameArgs = {
  name: Scalars['String']['input'];
};

export type QueryFeatureFlagsArgs = {
  filter?: InputMaybe<FeatureFlagFilterInput>;
};

export type QueryFilePreviewUrlArgs = {
  objectKey: Scalars['String']['input'];
};

export type QueryFormArgs = {
  id: Scalars['ID']['input'];
};

export type QueryFormSubmissionArgs = {
  id: Scalars['ID']['input'];
};

export type QueryFormSubmissionsArgs = {
  filter: FormSubmissionFilterInput;
};

export type QueryFormSubmissionsCsvArgs = {
  filter: FormSubmissionFilterInput;
};

export type QueryFormsArgs = {
  includeArchived?: Scalars['Boolean']['input'];
};

export type QueryGetFileArgs = {
  fileId: Scalars['String']['input'];
};

export type QueryGetSyncResultsArgs = {
  jobId: Scalars['String']['input'];
};

export type QueryGlobalSearchArgs = {
  input: GlobalSearchInput;
};

export type QueryGoogleAuthUrlArgs = {
  features: Array<GoogleFeature>;
};

export type QueryImportBatchesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryImportedInvoicesArgs = {
  filter: ImportedInvoiceFilterInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryInboxActionLogArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryInboxAttachmentDownloadUrlArgs = {
  id: Scalars['ID']['input'];
  mailboxEmailId: Scalars['ID']['input'];
  storagePath: Scalars['String']['input'];
};

export type QueryInboxThreadArgs = {
  id: Scalars['ID']['input'];
};

export type QueryInboxThreadActionArgs = {
  id: Scalars['ID']['input'];
};

export type QueryInboxThreadInvoicesArgs = {
  id: Scalars['ID']['input'];
};

export type QueryInboxThreadMessagesArgs = {
  id: Scalars['ID']['input'];
};

export type QueryInboxThreadsArgs = {
  input: InboxThreadsInput;
};

export type QueryIncubatorArgs = {
  id: Scalars['ID']['input'];
};

export type QueryIncubatorFlagsArgs = {
  id: Scalars['ID']['input'];
};

export type QueryIncubatorsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  featureFlags?: InputMaybe<Array<IncubatorFlagInput>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type QueryInvitableSlackMembersArgs = {
  includeGuests?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryInvitationByTokenArgs = {
  token: Scalars['String']['input'];
};

export type QueryInvoiceArgs = {
  id: Scalars['ID']['input'];
};

export type QueryInvoiceCashFlowByWeekArgs = {
  weeksAhead?: Scalars['Int']['input'];
  weeksBack?: Scalars['Int']['input'];
};

export type QueryInvoiceChargeArgs = {
  invoiceId: Scalars['ID']['input'];
};

export type QueryInvoiceDiscrepanciesArgs = {
  filter?: InputMaybe<DiscrepancyFilterInput>;
};

export type QueryInvoicesArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  paymentStatus?: InputMaybe<Scalars['String']['input']>;
  subscriptionId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryJobCommitReadinessArgs = {
  jobId: Scalars['String']['input'];
};

export type QueryKeyResultsForMetricsArgs = {
  metrics: Array<OkrMetricKey>;
};

export type QueryKnowledgeArticlePathGroupsArgs = {
  filter?: InputMaybe<KbArticleFilterInput>;
};

export type QueryKnowledgeArticlesArgs = {
  filter?: InputMaybe<KbArticleFilterInput>;
};

export type QueryKnowledgeAudienceRulePreviewArgs = {
  rules: Array<KbAudienceRuleInput>;
  sourceId: Scalars['ID']['input'];
};

export type QueryLibraryDocumentArgs = {
  id: Scalars['ID']['input'];
};

export type QueryLibraryDocumentDownloadUrlArgs = {
  id: Scalars['ID']['input'];
  versionId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryLibraryDocumentSharesArgs = {
  documentId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryLibraryDocumentStatsArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type QueryLibraryDocumentVersionsArgs = {
  documentId: Scalars['ID']['input'];
};

export type QueryLibraryDocumentsArgs = {
  category?: InputMaybe<LibraryDocumentCategory>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type QueryLibraryDocumentsByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type QueryListDriveFoldersArgs = {
  parentId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryListFilesArgs = {
  input?: InputMaybe<ListFilesInput>;
};

export type QueryListUsersArgs = {
  input: ListUsersInput;
};

export type QueryMemberInviteByTokenArgs = {
  token: Scalars['String']['input'];
};

export type QueryMemberInviteQuoteArgs = {
  includeGuests?: InputMaybe<Scalars['Boolean']['input']>;
  slackUserIds: Array<Scalars['String']['input']>;
};

export type QueryMergeOrganizationPreviewArgs = {
  sourceId: Scalars['ID']['input'];
  targetId: Scalars['ID']['input'];
};

export type QueryMeterArgs = {
  id: Scalars['ID']['input'];
};

export type QueryMeterByTypeArgs = {
  variableType: Scalars['String']['input'];
};

export type QueryMeterUsageArgs = {
  id: Scalars['ID']['input'];
};

export type QueryMeteredUsageIntegrationHealthArgs = {
  lookbackHours?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryMetersArgs = {
  filters?: InputMaybe<MeterFilterInput>;
};

export type QueryModuleArgs = {
  id: Scalars['ID']['input'];
};

export type QueryModuleTierArgs = {
  moduleId: Scalars['ID']['input'];
  tierId: Scalars['ID']['input'];
};

export type QueryModuleUsageArgs = {
  id: Scalars['ID']['input'];
};

export type QueryModuleVersionAtArgs = {
  asOf: Scalars['DateTime']['input'];
  lineageId: Scalars['ID']['input'];
};

export type QueryModulesArgs = {
  filters?: InputMaybe<ModuleFilterInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryMonthlyDrillDownArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  metricType: MetricType;
  month: Scalars['String']['input'];
};

export type QueryMrrMovementArgs = {
  endMonth?: InputMaybe<Scalars['String']['input']>;
  months?: InputMaybe<Scalars['Int']['input']>;
  startMonth?: InputMaybe<Scalars['String']['input']>;
};

export type QueryMrrMovementCsvArgs = {
  endMonth?: InputMaybe<Scalars['String']['input']>;
  months?: InputMaybe<Scalars['Int']['input']>;
  startMonth?: InputMaybe<Scalars['String']['input']>;
};

export type QueryMrrMovementXlsxArgs = {
  endMonth?: InputMaybe<Scalars['String']['input']>;
  months?: InputMaybe<Scalars['Int']['input']>;
  startMonth?: InputMaybe<Scalars['String']['input']>;
};

export type QueryMyTasksArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<TaskStatus>;
};

export type QueryNetRevenueRetentionArgs = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};

export type QueryNotificationCenterArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  unreadOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryNrrTrendArgs = {
  endMonth?: InputMaybe<Scalars['String']['input']>;
  months?: InputMaybe<Scalars['Int']['input']>;
  startMonth?: InputMaybe<Scalars['String']['input']>;
};

export type QueryOkrCoverageArgs = {
  cycleId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryOkrCycleHypothesisSummariesArgs = {
  cycleId: Scalars['ID']['input'];
};

export type QueryOkrCycleViewArgs = {
  cycleId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryOkrCyclesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<CycleState>;
};

export type QueryOkrHypothesesForCloseArgs = {
  cycleId: Scalars['ID']['input'];
};

export type QueryOkrHypothesisArgs = {
  id: Scalars['ID']['input'];
};

export type QueryOkrHypothesisBoardArgs = {
  cycleId?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<HypothesisBoardFilterInputType>;
};

export type QueryOkrHypothesisCalibrationArgs = {
  since?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QueryOkrHypothesisLearningsArgs = {
  filter?: InputMaybe<HypothesisLearningsFilterInputType>;
};

export type QueryOkrHypothesisTestMarkersArgs = {
  keyResultIds: Array<Scalars['ID']['input']>;
};

export type QueryOkrKeyResultArgs = {
  id: Scalars['ID']['input'];
};

export type QueryOkrKeyResultAlignmentArgs = {
  keyResultId: Scalars['ID']['input'];
};

export type QueryOkrKeyResultHypothesesArgs = {
  keyResultId: Scalars['ID']['input'];
};

export type QueryOkrKeyResultHypothesisSummaryArgs = {
  keyResultId: Scalars['ID']['input'];
};

export type QueryOkrKeyResultWorkLinksArgs = {
  keyResultId: Scalars['ID']['input'];
};

export type QueryOkrScoringStatusArgs = {
  cycleId: Scalars['ID']['input'];
};

export type QueryOkrSimilarHypothesesArgs = {
  excludeId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  text: Scalars['String']['input'];
};

export type QueryOkrTeamViewArgs = {
  cycleId?: InputMaybe<Scalars['ID']['input']>;
  teamId: Scalars['ID']['input'];
};

export type QueryOpenAccountSituationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryOpenUsageReadingsArgs = {
  filter?: InputMaybe<UsageReadingFilterInput>;
};

export type QueryOrganizationArgs = {
  id: Scalars['ID']['input'];
};

export type QueryOrganizationContactArgs = {
  id: Scalars['ID']['input'];
};

export type QueryOrganizationContactsArgs = {
  organizationId: Scalars['ID']['input'];
};

export type QueryOrganizationContactsByLabelArgs = {
  label: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export type QueryOrganizationContactsPaginatedArgs = {
  filter?: InputMaybe<OrganizationContactFilter>;
  pagination?: InputMaybe<OrganizationContactCursorPaginationInput>;
};

export type QueryOrganizationContractArgs = {
  id: Scalars['ID']['input'];
};

export type QueryOrganizationDriveFolderArgs = {
  organizationId: Scalars['ID']['input'];
};

export type QueryOrganizationLifecycleEventsArgs = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['String']['input'];
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QueryOrganizationSubscriptionsArgs = {
  organizationId: Scalars['ID']['input'];
};

export type QueryOrganizationSupportTicketsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<TicketFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['ID']['input'];
};

export type QueryOrganizationsByRegionArgs = {
  region: Scalars['String']['input'];
};

export type QueryOrganizationsPaginatedArgs = {
  filter?: InputMaybe<OrganizationFilter>;
  pagination?: InputMaybe<CursorPaginationInput>;
};

export type QueryOutboundWebhookDeliveriesArgs = {
  endpointId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<OutboundWebhookDeliveryStatus>;
};

export type QueryPaginatedInvoicesArgs = {
  filter?: InputMaybe<InvoiceFilterInput>;
};

export type QueryPaymentReminderDraftsArgs = {
  invoiceId: Scalars['ID']['input'];
};

export type QueryPaymentReminderHistoryArgs = {
  invoiceId: Scalars['ID']['input'];
};

export type QueryPlatformIncidentsArgs = {
  includeResolved?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryPreviewCompanyFromDomainArgs = {
  input: Scalars['String']['input'];
};

export type QueryPreviewComponentUsageArgs = {
  input: AdjustComponentUsageInput;
};

export type QueryPreviewContractArgs = {
  input: SendContractInput;
};

export type QueryPreviewInboxRuleArgs = {
  text: Scalars['String']['input'];
};

export type QueryPreviewRenewalProcessingArgs = {
  tenantId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryPreviewStageUpdateArgs = {
  stageKey: Scalars['String']['input'];
  ticketId: Scalars['ID']['input'];
};

export type QueryPreviewSubscriptionImportArgs = {
  input: ImportSubscriptionsInput;
};

export type QueryPreviewSubscriptionVariableChargesArgs = {
  input: PreviewVariableChargesInput;
};

export type QueryPricesForComponentArgs = {
  componentId: Scalars['ID']['input'];
  componentVersion?: InputMaybe<Scalars['Int']['input']>;
  scope?: InputMaybe<VariableComponentPriceScope>;
  status?: InputMaybe<VariableComponentStatus>;
};

export type QueryPricingArgs = {
  filter?: InputMaybe<PricingFilterInput>;
};

export type QueryPricingCombinationsArgs = {
  filter?: InputMaybe<PricingCombinationsFilterInput>;
};

export type QueryPricingDraftArgs = {
  id: Scalars['ID']['input'];
};

export type QueryPricingRuleArgs = {
  id: Scalars['ID']['input'];
};

export type QueryProductActivityArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  eventName?: InputMaybe<Scalars['String']['input']>;
  externalUserId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['ID']['input'];
};

export type QueryProductEventCatalogueArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ProductEventTypeStatus>;
};

export type QueryProductEventDetailArgs = {
  eventName: Scalars['String']['input'];
};

export type QueryProductEventTargetsArgs = {
  kind: ProductEventTargetKind;
};

export type QueryProductFeatureUsageArgs = {
  days?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['ID']['input'];
};

export type QueryProductUsageOverviewArgs = {
  days?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryProductUsageSessionsArgs = {
  days?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['ID']['input'];
};

export type QueryProductUsageSummaryArgs = {
  days?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['ID']['input'];
};

export type QueryProductUsageTrendArgs = {
  buckets?: InputMaybe<Scalars['Int']['input']>;
  eventName: Scalars['String']['input'];
  interval?: InputMaybe<ProductUsageInterval>;
  measure?: InputMaybe<ProductUsageMeasure>;
  organizationId: Scalars['ID']['input'];
};

export type QueryProductUsageUserArgs = {
  days?: InputMaybe<Scalars['Int']['input']>;
  externalUserId: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export type QueryProductUserProfileArgs = {
  days?: InputMaybe<Scalars['Int']['input']>;
  externalUserId: Scalars['String']['input'];
};

export type QueryProjectSubscriptionVariableBillingArgs = {
  input: ProjectSubscriptionBillingInput;
};

export type QueryProjectVariableBillingArgs = {
  input: ProjectVariableBillingInput;
};

export type QueryProjectedVariableInvoiceLinesArgs = {
  subscriptionId: Scalars['ID']['input'];
};

export type QueryPublishGapCheckArgs = {
  entityId: Scalars['ID']['input'];
  entityType: PublishGapEntityType;
};

export type QueryRecurrenceRuleArgs = {
  id: Scalars['ID']['input'];
};

export type QueryRecurrenceRulesArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryRegionArgs = {
  id: Scalars['String']['input'];
};

export type QueryRegionByCodeArgs = {
  code: Scalars['String']['input'];
};

export type QueryRegionsArgs = {
  filter?: InputMaybe<RegionFilterInput>;
};

export type QueryRegionsByCurrencyArgs = {
  currency: Scalars['String']['input'];
};

export type QueryReleaseNotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  minorKey?: InputMaybe<Scalars['String']['input']>;
  upToVersion?: InputMaybe<Scalars['String']['input']>;
};

export type QueryReleaseNotesUnreadCountArgs = {
  upToVersion?: InputMaybe<Scalars['String']['input']>;
};

export type QueryReleaseNotesUnreadSummaryArgs = {
  upToVersion?: InputMaybe<Scalars['String']['input']>;
};

export type QueryRenewalActionArgs = {
  id: Scalars['ID']['input'];
};

export type QueryRenewalActionsArgs = {
  filter?: InputMaybe<RenewalActionFilterInput>;
};

export type QueryRenewalCalendarArgs = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};

export type QueryRequestDownloadUrlArgs = {
  input: RequestDownloadUrlInput;
};

export type QueryResolvePriceWalkArgs = {
  bundleId?: InputMaybe<Scalars['ID']['input']>;
  bundleVersion?: InputMaybe<Scalars['Int']['input']>;
  componentId: Scalars['ID']['input'];
  componentVersion: Scalars['Int']['input'];
  currency: Scalars['String']['input'];
  moduleId?: InputMaybe<Scalars['ID']['input']>;
  moduleVersion?: InputMaybe<Scalars['Int']['input']>;
  period?: InputMaybe<SubscriptionPeriod>;
  subscriptionId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryResolvedPriceForSubscriptionArgs = {
  componentId: Scalars['ID']['input'];
  subscriptionId: Scalars['ID']['input'];
};

export type QueryResumeChatSessionArgs = {
  id: Scalars['ID']['input'];
};

export type QueryReviewOkrKeyResultDraftArgs = {
  input: ReviewKeyResultDraftInputType;
};

export type QueryReviewOkrObjectiveDraftArgs = {
  input: ReviewObjectiveDraftInputType;
};

export type QueryReviewQueueArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type QuerySearchDriveFoldersArgs = {
  query: Scalars['String']['input'];
};

export type QuerySearchOrganizationsArgs = {
  searchTerm: Scalars['String']['input'];
};

export type QuerySeatLedgerArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type QuerySignatureRequestArgs = {
  id: Scalars['ID']['input'];
};

export type QuerySignatureRequestPdfArgs = {
  id: Scalars['ID']['input'];
};

export type QuerySimulateAiCreditPriceArgs = {
  input: AiCreditSimulationInput;
};

export type QuerySpotCheckArgs = {
  jobId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  sampleSize?: InputMaybe<Scalars['Int']['input']>;
};

export type QuerySubscriptionArgs = {
  id: Scalars['ID']['input'];
};

export type QuerySubscriptionBillingScheduleArgs = {
  subscriptionId: Scalars['ID']['input'];
};

export type QuerySubscriptionBillingTimingOverrideHistoryArgs = {
  subscriptionId: Scalars['ID']['input'];
};

export type QuerySubscriptionComponentBillingTimingsArgs = {
  subscriptionId: Scalars['ID']['input'];
};

export type QuerySubscriptionContractsArgs = {
  subscriptionId: Scalars['ID']['input'];
};

export type QuerySubscriptionCostArgs = {
  subscriptionId: Scalars['ID']['input'];
};

export type QuerySubscriptionDiscountHistoryArgs = {
  subscriptionId: Scalars['ID']['input'];
};

export type QuerySubscriptionDiscountInstancesArgs = {
  subscriptionId: Scalars['ID']['input'];
};

export type QuerySubscriptionDiscountPreviewArgs = {
  stackingMode?: InputMaybe<DiscountStackingMode>;
  subscriptionId: Scalars['ID']['input'];
};

export type QuerySubscriptionExpansionArgs = {
  id: Scalars['ID']['input'];
};

export type QuerySubscriptionExpansionCostArgs = {
  subscriptionId: Scalars['ID']['input'];
};

export type QuerySubscriptionExpansionHistoryArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  subscriptionId: Scalars['ID']['input'];
};

export type QuerySubscriptionExpansionStatisticsArgs = {
  subscriptionId: Scalars['ID']['input'];
};

export type QuerySubscriptionExpansionsArgs = {
  filter?: InputMaybe<ExpansionFilterInput>;
};

export type QuerySubscriptionExportXlsxArgs = {
  referenceDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QuerySubscriptionLifecycleEventsArgs = {
  subscriptionId: Scalars['ID']['input'];
};

export type QuerySubscriptionPlanForClientArgs = {
  organizationId: Scalars['String']['input'];
};

export type QuerySubscriptionPriceOverrideHistoryArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  subscriptionId: Scalars['ID']['input'];
};

export type QuerySubscriptionScheduleTriggerEventsArgs = {
  subscriptionId: Scalars['ID']['input'];
};

export type QuerySubscriptionVariableUsageArgs = {
  subscriptionId: Scalars['ID']['input'];
};

export type QuerySubscriptionVersionHistoryArgs = {
  changeType?: InputMaybe<SubscriptionVersionChangeType>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  subscriptionId: Scalars['ID']['input'];
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QuerySubscriptionsArgs = {
  filter?: InputMaybe<SubscriptionFilterInput>;
};

export type QuerySubscriptionsWithOutdatedPinsArgs = {
  includeBundle?: Scalars['Boolean']['input'];
  includeComponent?: Scalars['Boolean']['input'];
  includeGrandfathered?: Scalars['Boolean']['input'];
  includeModule?: Scalars['Boolean']['input'];
  limit?: Scalars['Int']['input'];
};

export type QuerySuggestSubscriptionsForSyncResultArgs = {
  resultId: Scalars['String']['input'];
};

export type QuerySuggestedOrganizationContactsArgs = {
  organizationId: Scalars['ID']['input'];
};

export type QuerySupportClientContextArgs = {
  organizationId: Scalars['ID']['input'];
};

export type QuerySupportCompareEstimateArgs = {
  input: SupportCompareRangeInput;
};

export type QuerySupportCompareResultsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  focus?: InputMaybe<SupportCompareFocus>;
  gap?: InputMaybe<SupportCompareGap>;
  runId: Scalars['ID']['input'];
  verdict?: InputMaybe<SupportCompareVerdict>;
};

export type QuerySupportCompareRunArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QuerySupportCompareRunsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type QuerySupportImportRunArgs = {
  id: Scalars['ID']['input'];
};

export type QuerySupportMessagesArgs = {
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ticketId: Scalars['ID']['input'];
};

export type QuerySupportMetricsArgs = {
  groupBy?: SupportMetricGroup;
  range: SupportDateRangeInput;
};

export type QuerySupportNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  unreadOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuerySupportPeopleArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SupportEndUserFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type QuerySupportPersonArgs = {
  id: Scalars['ID']['input'];
};

export type QuerySupportRolesArgs = {
  includeRetired?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuerySupportSearchArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
};

export type QuerySupportTicketArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
};

export type QuerySupportTicketEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ticketId: Scalars['ID']['input'];
  types?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type QuerySupportTicketsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter: TicketFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type QuerySyncJobHistoryArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type QuerySyncJobStatusArgs = {
  jobId: Scalars['String']['input'];
};

export type QuerySyncResultFilePreviewUrlArgs = {
  resultId: Scalars['String']['input'];
};

export type QuerySyncResultsByIdsArgs = {
  resultIds: Array<Scalars['String']['input']>;
};

export type QuerySyncedEmailMessagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  threadId: Scalars['ID']['input'];
};

export type QuerySyncedEmailThreadArgs = {
  id: Scalars['ID']['input'];
};

export type QuerySyncedEmailThreadsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['ID']['input'];
};

export type QueryTaskArgs = {
  id: Scalars['ID']['input'];
};

export type QueryTasksArgs = {
  assignedToMe?: InputMaybe<Scalars['Boolean']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<TaskFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<TaskSortInput>;
};

export type QueryTaxLedgerMismatchesArgs = {
  input: TaxLedgerCheckInput;
};

export type QueryTaxPreviewArgs = {
  input: TaxPreviewInput;
};

export type QueryTaxRatesArgs = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<TaxRateStatus>;
};

export type QueryTaxReferenceCountryArgs = {
  code: Scalars['String']['input'];
};

export type QueryTaxRegistrationsArgs = {
  status?: InputMaybe<TaxRegistrationStatus>;
};

export type QueryTaxReportArgs = {
  input: TaxReportInput;
};

export type QueryTaxTransactionsArgs = {
  filter: TaxTransactionFilterInput;
};

export type QueryTeamArgs = {
  id: Scalars['ID']['input'];
};

export type QueryTeamArchiveEligibilityArgs = {
  id: Scalars['ID']['input'];
};

export type QueryTeamsArgs = {
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryTenantArgs = {
  id: Scalars['ID']['input'];
};

export type QueryTenantBySlugArgs = {
  slug: Scalars['String']['input'];
};

export type QueryTenantSeatUsageArgs = {
  tenantId: Scalars['ID']['input'];
};

export type QueryTicketTypesArgs = {
  includeRetired?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryTicketWorkItemsArgs = {
  ticketId: Scalars['ID']['input'];
};

export type QueryTrialOrganizationsArgs = {
  activeOnly?: Scalars['Boolean']['input'];
};

export type QueryUnreachableParticipantsArgs = {
  checkinId: Scalars['ID']['input'];
};

export type QueryUnresolvedSyncedEmailThreadsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryUpcomingRenewalsArgs = {
  days?: Scalars['Int']['input'];
};

export type QueryUsageAuditLogArgs = {
  filter: UsageAuditFilterInput;
};

export type QueryUsageReadingsForSubscriptionArgs = {
  subscriptionId: Scalars['ID']['input'];
};

export type QueryUserArgs = {
  id: Scalars['String']['input'];
};

export type QueryUserTeamsArgs = {
  userId: Scalars['String']['input'];
};

export type QueryVariableComponentArgs = {
  id: Scalars['ID']['input'];
};

export type QueryVariableComponentUsageArgs = {
  id: Scalars['ID']['input'];
};

export type QueryVariableComponentVersionAtArgs = {
  asOf: Scalars['DateTime']['input'];
  lineageId: Scalars['ID']['input'];
};

export type QueryVariableComponentsArgs = {
  filter?: InputMaybe<VariableComponentFilterInput>;
};

export type QueryWebhookDeliveriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  endpointId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<WebhookDeliveryStatus>;
};

export type QueryWorkingDaysFromNowArgs = {
  days: Scalars['Int']['input'];
};

export type QueryWorkspaceDataDeletionArgs = {
  organizationId: Scalars['ID']['input'];
};

/** One invoice awaiting review, and why it is here now */
export type QueuedReviewItemEntity = {
  __typename?: 'QueuedReviewItemEntity';
  /** How unambiguous an example this invoice is, 0..1 */
  cleanliness: Scalars['Float']['output'];
  /** Strategies named different answers, or the arbiter held it */
  disagreement: Scalars['Boolean']['output'];
  /** Staged sync result id */
  id: Scalars['String']['output'];
  organizationId?: Maybe<Scalars['String']['output']>;
  /** Catalog versions this invoice is attached to; it leaves the queue only when every one has earned its bar */
  productIds: Array<Scalars['String']['output']>;
  reason: ReviewReason;
  /** Billing shape: currency, base line tokens, usage line count */
  shapeKey: Scalars['String']['output'];
  /** Members of this shape — what a group confirm would apply to */
  shapeSize: Scalars['Int']['output'];
};

/** A market (Region) a catalog item is fully priced and ready to sell in. */
export type ReadyMarket = {
  __typename?: 'ReadyMarket';
  /** Region short code (e.g. 'US', 'EU') — the badge label. */
  code: Scalars['String']['output'];
  /** The region's default currency. */
  defaultCurrency: Currency;
  /** Region display name. */
  name: Scalars['String']['output'];
  regionId: Scalars['ID']['output'];
};

export type ReceivablesAnalytics = {
  __typename?: 'ReceivablesAnalytics';
  byWeek: Array<ReceivablesByWeek>;
  collectedLast30DaysByCurrency: Array<CollectedLast30Days>;
  dueThisWeek: Array<PaymentDueThisWeek>;
  forecast: Array<ReceivablesForecast>;
  pastDueAccounts: Array<PastDueAccount>;
  receivablesByCurrency: Array<CurrencyReceivables>;
  reportingTotals?: Maybe<ReceivablesReportingTotals>;
  /** Combined open-receivables total in the reporting currency. Null when it cannot be combined (multiple currencies with no reporting currency, or a true exchange rate is unavailable) — use receivablesByCurrency for the per-currency breakdown in that case. */
  total?: Maybe<ReceivablesTotal>;
};

export type ReceivablesByWeek = {
  __typename?: 'ReceivablesByWeek';
  amount: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  invoiceCount: Scalars['Int']['output'];
  /** Invoices making up this bucket, highest amount first. Capped at MAX_WEEK_INVOICE_REFS entries — compare against invoiceCount to detect truncation. */
  invoices: Array<WeekInvoiceRef>;
  weekEndDate: Scalars['DateTime']['output'];
  weekStartDate: Scalars['DateTime']['output'];
};

export type ReceivablesForecast = {
  __typename?: 'ReceivablesForecast';
  currency: Scalars['String']['output'];
  date: Scalars['DateTime']['output'];
  estimatedAmount: Scalars['Float']['output'];
  invoiceCount: Scalars['Int']['output'];
  invoiceIds: Array<Scalars['String']['output']>;
  /** Invoices making up this bucket, highest amount first. Capped at MAX_WEEK_INVOICE_REFS entries — compare against invoiceCount to detect truncation. */
  invoices: Array<WeekInvoiceRef>;
};

export type ReceivablesReportingTotals = {
  __typename?: 'ReceivablesReportingTotals';
  collectedLast30Days: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  overdueAmount: Scalars['Float']['output'];
  overdueTaxAmount: Scalars['Float']['output'];
  pendingAmount: Scalars['Float']['output'];
  pendingTaxAmount: Scalars['Float']['output'];
  thisWeekAmount: Scalars['Float']['output'];
  thisWeekTaxAmount: Scalars['Float']['output'];
  totalReceivables: Scalars['Float']['output'];
  totalTaxAmount: Scalars['Float']['output'];
};

export type ReceivablesTotal = {
  __typename?: 'ReceivablesTotal';
  currency: Scalars['String']['output'];
  invoiceCount: Scalars['Int']['output'];
  totalAmount: Scalars['Float']['output'];
};

/** Recommended action for a pending renewal */
export enum RecommendedAction {
  ContactCustomer = 'CONTACT_CUSTOMER',
  Expire = 'EXPIRE',
  Renew = 'RENEW',
}

export type RecordContractFromDocumentInput = {
  clauses: ContractClausesInput;
  contractType?: InputMaybe<ContractType>;
  /** A PDF filed on the client (e.g. from the client's Drive folder). */
  documentId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  signedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RecordPolicyAcceptancesInput = {
  acceptances: Array<PolicyAcceptanceEntryInput>;
  /** Where the acceptance was captured (e.g. INVITE). */
  source?: InputMaybe<Scalars['String']['input']>;
};

export type RecordSignedContractInput = {
  contractType?: InputMaybe<ContractType>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** How often a recurring task series generates a new task. */
export enum RecurrenceFrequency {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY',
}

export type RecurrenceRelationInput = {
  relationId: Scalars['ID']['input'];
  relationType: EntityTargetType;
};

export type RecurrenceRule = {
  __typename?: 'RecurrenceRule';
  active: Scalars['Boolean']['output'];
  assigneeUserIds: Array<Scalars['ID']['output']>;
  byMonthDay?: Maybe<Scalars['Int']['output']>;
  byWeekday: Array<RecurrenceWeekday>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  endAt?: Maybe<Scalars['DateTime']['output']>;
  frequency: RecurrenceFrequency;
  generatedCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  interval: Scalars['Int']['output'];
  lastGeneratedAt?: Maybe<Scalars['DateTime']['output']>;
  maxOccurrences?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  /** When the next task will be generated. */
  nextRunAt?: Maybe<Scalars['DateTime']['output']>;
  priority: TaskPriority;
  relationId?: Maybe<Scalars['ID']['output']>;
  relationType?: Maybe<EntityTargetType>;
  startAt: Scalars['DateTime']['output'];
  /** Human-readable schedule, e.g. "Every 3 months". */
  summary: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type RecurrenceSpecInput = {
  /** MONTHLY/YEARLY only: day of month (1..31). Clamped to the month length. */
  byMonthDay?: InputMaybe<Scalars['Int']['input']>;
  /** WEEKLY only: weekdays to fire on (0=Sun..6=Sat). Empty → the start weekday. */
  byWeekday?: InputMaybe<Array<RecurrenceWeekday>>;
  frequency: RecurrenceFrequency;
  /** Every N units of the frequency. */
  interval?: Scalars['Int']['input'];
};

/** Weekday selector for weekly recurrences (0 = Sunday .. 6 = Saturday). */
export enum RecurrenceWeekday {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY',
}

export type RefundCreditNoteInput = {
  creditNoteId: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  /** PSP refund id, bank reference … */
  reference?: InputMaybe<Scalars['String']['input']>;
  /** When the money left. Defaults to now. */
  refundedAt?: InputMaybe<Scalars['String']['input']>;
};

export type Region = {
  __typename?: 'Region';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  defaultCurrency: Currency;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  supportedCurrencies: Array<Currency>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type RegionBreakdown = {
  __typename?: 'RegionBreakdown';
  arr: Scalars['Float']['output'];
  mrr: Scalars['Float']['output'];
  region: Scalars['String']['output'];
  subscriptionCount: Scalars['Int']['output'];
};

export type RegionDeletionDependencies = {
  __typename?: 'RegionDeletionDependencies';
  canDelete: Scalars['Boolean']['output'];
  pricingRules: Scalars['Int']['output'];
  willBecomeLegacy: Scalars['Int']['output'];
};

export type RegionDeletionResult = {
  __typename?: 'RegionDeletionResult';
  deleted: Scalars['Boolean']['output'];
  legacyPricingRules: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type RegionFilterInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Currency>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export enum ReleaseKind {
  Major = 'MAJOR',
  Minor = 'MINOR',
  Patch = 'PATCH',
}

export type ReleaseNote = {
  __typename?: 'ReleaseNote';
  id: Scalars['ID']['output'];
  items: Array<ReleaseNoteItem>;
  kind: ReleaseKind;
  /** The minor it belongs to, e.g. v4.17. The log is shown grouped by it. */
  minorKey: Scalars['String']['output'];
  /** Whether this release lights the What’s new dot. */
  notify: Scalars['Boolean']['output'];
  releasedAt: Scalars['DateTime']['output'];
  title?: Maybe<Scalars['String']['output']>;
  /** Worth a dot and newer than where the caller last read up to. */
  unread: Scalars['Boolean']['output'];
  /** The release tag, e.g. v4.17.3. */
  version: Scalars['String']['output'];
};

/** Newest first. */
export type ReleaseNoteConnection = {
  __typename?: 'ReleaseNoteConnection';
  nodes: Array<ReleaseNote>;
  pageInfo: PageInfo;
  /** Unread releases across the whole log, not just this page. */
  unreadCount: Scalars['Int']['output'];
};

export type ReleaseNoteItem = {
  __typename?: 'ReleaseNoteItem';
  /** new, fix or imp (improvement). */
  tag: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type ReleaseNotesUnreadSummary = {
  __typename?: 'ReleaseNotesUnreadSummary';
  /** Unread releases worth announcing. */
  count: Scalars['Int']['output'];
  /** The kind to announce: MINOR or MAJOR when any unread one is, else PATCH. */
  kind?: Maybe<ReleaseKind>;
  /** The version that kind belongs to. */
  version?: Maybe<Scalars['String']['output']>;
};

export type RememberAgentMemoryInput = {
  scope: AgentMemoryScope;
  text: Scalars['String']['input'];
};

/** Type of payment reminder based on due date offset */
export enum ReminderType {
  DueToday = 'DUE_TODAY',
  Overdue_1 = 'OVERDUE_1',
  Overdue_7 = 'OVERDUE_7',
  Overdue_14 = 'OVERDUE_14',
  Overdue_30 = 'OVERDUE_30',
  Upcoming = 'UPCOMING',
}

export type RemoveCurrencyFromRegionInput = {
  currency: Currency;
  regionId: Scalars['ID']['input'];
};

export type RemoveFeatureFlagFromTierInput = {
  featureFlagId: Scalars['String']['input'];
  moduleId: Scalars['ID']['input'];
  tierId: Scalars['String']['input'];
};

export type RemoveModuleTierInput = {
  moduleId: Scalars['ID']['input'];
  tierId: Scalars['String']['input'];
};

export type RemoveVariableUsageInput = {
  /** Positive number of units to remove from currentCount */
  delta: Scalars['Float']['input'];
  idempotencyKey: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  reportedAt?: InputMaybe<Scalars['DateTime']['input']>;
  subscriptionId: Scalars['ID']['input'];
  variableId: Scalars['ID']['input'];
};

export type RenameContactRoleInput = {
  key: Scalars['String']['input'];
  label: Scalars['String']['input'];
};

/** A reminder template filled in for one invoice. */
export type RenderedPaymentReminder = {
  __typename?: 'RenderedPaymentReminder';
  body: Scalars['String']['output'];
  kind: PaymentReminderTemplateKind;
  subject: Scalars['String']['output'];
};

/** A pending renewal action requiring admin decision */
export type RenewalAction = {
  __typename?: 'RenewalAction';
  /** Subscription amount */
  amount: Scalars['Decimal']['output'];
  /** Whether auto-renew is enabled on the subscription */
  autoRenew: Scalars['Boolean']['output'];
  /** The committed-term boundary this decision is about. Set only on decisions raised for a contract term; an ordinary renewal action leaves it null. */
  commitmentEndDate?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** Currency code */
  currency: Scalars['String']['output'];
  /** Current subscription end date */
  currentEndDate: Scalars['DateTime']['output'];
  /** Timestamp when decision was made */
  decidedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User who made the decision */
  decidedBy?: Maybe<Scalars['String']['output']>;
  /** Date the subscription is due for renewal */
  dueDate: Scalars['DateTime']['output'];
  /** Error message if processing failed */
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Admin notes or reason for decision */
  notes?: Maybe<Scalars['String']['output']>;
  /** The organization ID */
  organizationId: Scalars['String']['output'];
  /** The organization name for display */
  organizationName?: Maybe<Scalars['String']['output']>;
  /** Timestamp when action was processed */
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User who processed the action */
  processedBy?: Maybe<Scalars['String']['output']>;
  /** Proposed new end date if renewed */
  proposedEndDate?: Maybe<Scalars['DateTime']['output']>;
  /** System-recommended action based on autoRenew flag */
  recommendedAction: RecommendedAction;
  /** Current status of the action */
  status: RenewalActionStatus;
  /** The subscription requiring renewal decision */
  subscriptionId: Scalars['ID']['output'];
  /** The tenant this action belongs to */
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type RenewalActionDecisionInput = {
  actionId: Scalars['ID']['input'];
  /** Decision: "approve" or "reject" */
  decision: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type RenewalActionFilterInput = {
  autoRenew?: InputMaybe<Scalars['Boolean']['input']>;
  dueDateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateTo?: InputMaybe<Scalars['DateTime']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<RenewalActionStatus>>;
};

export type RenewalActionStatsOutput = {
  __typename?: 'RenewalActionStatsOutput';
  approved: Scalars['Int']['output'];
  failed: Scalars['Int']['output'];
  pending: Scalars['Int']['output'];
  processed: Scalars['Int']['output'];
  rejected: Scalars['Int']['output'];
  totalAmount: Scalars['Float']['output'];
};

/** Status of a renewal action in the queue */
export enum RenewalActionStatus {
  Approved = 'APPROVED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processed = 'PROCESSED',
  Rejected = 'REJECTED',
}

export type RenewalBaseProgress = {
  __typename?: 'RenewalBaseProgress';
  processedAmount: Scalars['Float']['output'];
  processedCount: Scalars['Int']['output'];
  /** processedAmount / totalAmount as a 0–100 percentage. 0 when the month has no recurring base, so the meter reads empty rather than complete. */
  processedPercent: Scalars['Float']['output'];
  remainingAmount: Scalars['Float']['output'];
  remainingCount: Scalars['Int']['output'];
  totalAmount: Scalars['Float']['output'];
  totalCount: Scalars['Int']['output'];
};

export type RenewalCalendar = {
  __typename?: 'RenewalCalendar';
  endDate: Scalars['DateTime']['output'];
  events: Array<RenewalCalendarEvent>;
  startDate: Scalars['DateTime']['output'];
  totalRenewalValue: Scalars['Float']['output'];
};

export type RenewalCalendarEvent = {
  __typename?: 'RenewalCalendarEvent';
  autoRenew: Scalars['Boolean']['output'];
  currency: Scalars['String']['output'];
  id: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['String']['output'];
  organizationName: Scalars['String']['output'];
  planName: Scalars['String']['output'];
  renewalAmount: Scalars['Float']['output'];
  renewalDate: Scalars['DateTime']['output'];
  requiresApproval: Scalars['Boolean']['output'];
  subscriptionId: Scalars['String']['output'];
  subscriptionType: Scalars['String']['output'];
};

/** Type of renewal date filter comparison */
export enum RenewalDateFilterType {
  Equal = 'EQUAL',
  GreaterThan = 'GREATER_THAN',
  LessThan = 'LESS_THAN',
}

export type RenewalInfo = {
  __typename?: 'RenewalInfo';
  /** Date when the subscription was cancelled (for early cancellations) */
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  /** Days remaining when cancelled early. Null if not an early cancellation. */
  daysRemainingWhenCancelled?: Maybe<Scalars['Int']['output']>;
  /** Days until renewal or cancellation takes effect. Null if already cancelled/expired. */
  daysUntilChange?: Maybe<Scalars['Int']['output']>;
  /** Human-readable description of the renewal status */
  description: Scalars['String']['output'];
  /** Whether this was an early cancellation (cancelled before end date) */
  isEarlyCancellation: Scalars['Boolean']['output'];
  /** Current renewal status of the subscription */
  status: RenewalStatus;
};

/** Per-period lead time (days) for generating renewal invoices ahead of the renewal date */
export type RenewalInvoiceLeadDaysInput = {
  /** Days before renewal to invoice MONTHLY subscriptions (0 = at renewal) */
  monthly?: InputMaybe<Scalars['Int']['input']>;
  /** Days before renewal to invoice QUARTERLY subscriptions (0 = at renewal) */
  quarterly?: InputMaybe<Scalars['Int']['input']>;
  /** Days before renewal to invoice YEARLY subscriptions (0 = at renewal) */
  yearly?: InputMaybe<Scalars['Int']['input']>;
};

export type RenewalPreviewOutput = {
  __typename?: 'RenewalPreviewOutput';
  wouldEnterGracePeriod: Array<OrganizationSubscription>;
  wouldExpire: Array<OrganizationSubscription>;
  wouldRenew: Array<OrganizationSubscription>;
};

export type RenewalProcessingResultOutput = {
  __typename?: 'RenewalProcessingResultOutput';
  action: Scalars['String']['output'];
  invoiceGenerated?: Maybe<Scalars['Boolean']['output']>;
  message: Scalars['String']['output'];
  newEndDate?: Maybe<Scalars['DateTime']['output']>;
  organizationId: Scalars['String']['output'];
  subscriptionId: Scalars['String']['output'];
};

export type RenewalStatsOutput = {
  __typename?: 'RenewalStatsOutput';
  errors: Scalars['Int']['output'];
  expired: Scalars['Int']['output'];
  gracePeriod: Scalars['Int']['output'];
  renewed: Scalars['Int']['output'];
  skipped: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

/** Renewal status indicating future subscription state */
export enum RenewalStatus {
  Cancelled = 'CANCELLED',
  Expired = 'EXPIRED',
  GracePeriod = 'GRACE_PERIOD',
  PendingDecision = 'PENDING_DECISION',
  WillCancel = 'WILL_CANCEL',
  WillRenew = 'WILL_RENEW',
}

export type ReplyInput = {
  /** Confirmed uploads for this ticket (createSupportAttachmentUpload), at most 10. */
  attachmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Markdown, up to 20,000 characters. */
  body: Scalars['String']['input'];
  /** Idempotency key: a retried send with the same key returns the original message. */
  clientMessageId?: InputMaybe<Scalars['String']['input']>;
  kind?: SupportReplyKind;
  /** Library documents to send as tracked links. Public replies only, at most 5. Each is added to the message as a link the customer can open; views are shown to agents on the ticket. */
  libraryLinks?: InputMaybe<Array<LibraryLinkInput>>;
  /** Agents (auth subjects) @mentioned; each is notified. Internal notes only, at most 20. */
  mentionUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  ticketId: Scalars['ID']['input'];
};

export type ReportCommissionEventInput = {
  idempotencyKey: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  reportedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Sale value in the subscription billing currency. Negative for refunds (must reference original transactionId). */
  saleAmount: Scalars['Float']['input'];
  subscriptionId: Scalars['ID']['input'];
  /** Unique transaction identifier from the underlying marketplace; used for refund-reversal linkage */
  transactionId: Scalars['String']['input'];
  variableId: Scalars['ID']['input'];
};

/** Input for generating presigned download URL */
export type RequestDownloadUrlInput = {
  /** Download URL expiration in seconds (default: 3600) */
  expiresIn?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the stored file */
  fileId: Scalars['String']['input'];
};

/** Result of requesting an account email change */
export type RequestEmailChangeResult = {
  __typename?: 'RequestEmailChangeResult';
  /** Whether the verification email was dispatched to the new address */
  emailSent: Scalars['Boolean']['output'];
  /** The address the verification link was sent to (the pending new email) */
  pendingEmail: Scalars['String']['output'];
};

export type RequestLibraryUploadInput = {
  fileName: Scalars['String']['input'];
  fileSize: Scalars['Int']['input'];
  mimeType: Scalars['String']['input'];
};

/** Input for generating presigned upload URL */
export type RequestUploadUrlInput = {
  category?: InputMaybe<FileCategory>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Upload URL expiration in seconds (default: 3600) */
  expiresIn?: InputMaybe<Scalars['Int']['input']>;
  /** Original filename with extension */
  filename: Scalars['String']['input'];
  /** MIME type of the file (e.g., application/pdf) */
  mimeType: Scalars['String']['input'];
  /** File size in bytes */
  size: Scalars['Int']['input'];
};

/** What happens to the quantity when the period closes: STANDING carries it forward, PER_PERIOD resets it to zero. */
export enum ResetBehaviour {
  PerPeriod = 'PER_PERIOD',
  Standing = 'STANDING',
}

export type ResolveDiscrepancyInput = {
  id: Scalars['ID']['input'];
  resolvedValues: Scalars['String']['input'];
};

/** Resolved effective price for a subscription + component (PRD §17.4). */
export type ResolvedPrice = {
  __typename?: 'ResolvedPrice';
  /** The subscription's locked currency the variant was matched on. */
  currency: Scalars['String']['output'];
  /** Custom Pricing Agreement that overrode the chain, if any. */
  customAgreementId?: Maybe<Scalars['ID']['output']>;
  /** True when a per-term override produced the variant (vs the all-term default). */
  fromPeriodOverride?: Maybe<Scalars['Boolean']['output']>;
  /** The locked term this price was resolved for. */
  period?: Maybe<SubscriptionPeriod>;
  /** Which scope ultimately served the price. */
  scope: VariableComponentPriceScope;
  /** Scope entity id (null for GLOBAL_DEFAULT). */
  scopeId?: Maybe<Scalars['ID']['output']>;
  /** Scope version (MODULE/BUNDLE only). */
  scopeVersion?: Maybe<Scalars['Int']['output']>;
  /** The matched per-currency variant. */
  variant: PricingVariant;
};

/** A Key Result as it stands in the editor, before it is saved. */
export type ReviewKeyResultDraftInputType = {
  description?: InputMaybe<Scalars['String']['input']>;
  /** The title of the objective it serves, so the review can judge whether it moves it. */
  objectiveTitle?: InputMaybe<Scalars['String']['input']>;
  previous?: InputMaybe<PreviousDraftReviewInputType>;
  /** How many Key Results the objective already has, not counting this one. */
  siblingCount?: InputMaybe<Scalars['Int']['input']>;
  startValue?: InputMaybe<Scalars['Float']['input']>;
  targetValue?: InputMaybe<Scalars['Float']['input']>;
  title: Scalars['String']['input'];
  unit?: InputMaybe<KeyResultUnit>;
};

/** An objective as it stands in the editor, before it is saved. */
export type ReviewObjectiveDraftInputType = {
  description?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<ObjectiveLevel>;
  previous?: InputMaybe<PreviousDraftReviewInputType>;
  /** The team a team objective belongs to. It says who the objective is for, so the title does not have to. */
  teamName?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  type?: InputMaybe<ObjectiveType>;
};

export type ReviewPaymentInput = {
  amount: Scalars['Float']['input'];
  paidAt: Scalars['DateTime']['input'];
};

/** What to review next, in the order that teaches the most */
export type ReviewQueueEntity = {
  __typename?: 'ReviewQueueEntity';
  /** Invoices whose product has earned autonomy and which therefore left the queue. Still reachable through spot-check. */
  autoAcceptedTotal: Scalars['Int']['output'];
  /** Carried alongside so the strip and the queue cannot disagree about what is learned */
  autonomy: TenantAutonomyReportEntity;
  items: Array<QueuedReviewItemEntity>;
  /** Everything awaiting review, before earned products were dropped */
  pendingTotal: Scalars['Int']['output'];
};

/** Why an invoice is in the review queue at this position */
export enum ReviewReason {
  Coverage = 'COVERAGE',
  Depth = 'DEPTH',
  Disagreement = 'DISAGREEMENT',
  Novelty = 'NOVELTY',
}

/** Who the company sells to: businesses, consumers, government, or as a marketplace */
export enum SalesModel {
  B2B = 'B2B',
  B2B2C = 'B2B2C',
  B2C = 'B2C',
  B2G = 'B2G',
  Marketplace = 'MARKETPLACE',
}

export type SaveInboxRuleInput = {
  category: InboxCategory;
  field: InboxRuleField;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type SaveInboxRuleResult = {
  __typename?: 'SaveInboxRuleResult';
  /** Existing threads the new rule filed. */
  filed: Scalars['Int']['output'];
  rule: InboxRule;
};

export type SaveMcpRemoteServerInput = {
  access?: InputMaybe<McpRemoteAccess>;
  authType: McpRemoteAuthType;
  /** The token (BEARER) or header value (HEADER). Omit on an update to keep the stored one. */
  credential?: InputMaybe<Scalars['String']['input']>;
  /** For HEADER auth: the header to send the credential in. */
  headerName?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  /** Sign in through a Revvly-registered OAuth app. Only "github" is known. */
  oauthPreset?: InputMaybe<Scalars['String']['input']>;
  /** Short id: lowercase letters, digits, hyphens (e.g. "github"). */
  serverId: Scalars['String']['input'];
  /** The server’s Streamable HTTP endpoint. HTTPS only. */
  url: Scalars['String']['input'];
};

export type SavePushSubscriptionInput = {
  /** Push service endpoint URL */
  endpoint: Scalars['String']['input'];
  keys: PushSubscriptionKeysInput;
  /** Device label (User-Agent) for the manage-devices UI */
  userAgent?: InputMaybe<Scalars['String']['input']>;
};

export type SaveUserSignatureInput = {
  kind: UserSignatureKind;
  makeDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  /** A transparent PNG, as base64 or a data: URL. 256 KB at most. */
  pngBase64: Scalars['String']['input'];
};

/** A card on file, as Stripe reports it. Never the number. */
export type SavedCardView = {
  __typename?: 'SavedCardView';
  brand?: Maybe<Scalars['String']['output']>;
  expMonth?: Maybe<Scalars['Int']['output']>;
  expYear?: Maybe<Scalars['Int']['output']>;
  last4?: Maybe<Scalars['String']['output']>;
  savedAt: Scalars['DateTime']['output'];
};

/** One charge in a subscription billing schedule. */
export type ScheduleCharge = {
  __typename?: 'ScheduleCharge';
  amountRuleType: AmountRuleType;
  /** Stable id within the schedule. A trigger event names the charge it fired by this key. */
  chargeKey: Scalars['String']['output'];
  /** USAGE charges only — a component pinned on the subscription. */
  componentId?: Maybe<Scalars['ID']['output']>;
  /** Periods this charge pays for. 1 is ordinary; 2 or more is a prepaid span. */
  coverageWindow: Scalars['Int']['output'];
  /** Set only when the trigger is EXPLICIT_DATE. */
  explicitDate?: Maybe<Scalars['DateTime']['output']>;
  /** When a ONCE charge fired. Denormalised from the trigger log, which remains the record. */
  firedAt?: Maybe<Scalars['DateTime']['output']>;
  /** FLAT charges only, in the subscription's locked currency. */
  flatAmount?: Maybe<Scalars['Decimal']['output']>;
  /** The invoice that carried it, if any. */
  invoiceId?: Maybe<Scalars['ID']['output']>;
  /** Set only when the trigger is MILESTONE. */
  milestoneKey?: Maybe<Scalars['String']['output']>;
  /** PERCENT_OF_BASE charges only, 0–100. */
  percent?: Maybe<Scalars['Float']['output']>;
  /** The amount this charge will bill, fixed when its counterpart was billed. Set on the ACTIVATION charge of a split base by the signing invoice, so the operator can see what Activate will charge before firing it. Null when the charge computes its own amount. */
  pinnedAmount?: Maybe<Scalars['Decimal']['output']>;
  recurrence: ChargeRecurrence;
  /** Ordering among charges sharing a trigger. */
  sequenceIndex: Scalars['Int']['output'];
  trigger: ChargeTrigger;
};

/** The named shape a billing schedule was built from. v1 exposes DEFERRED_ACTIVATION and PREPAID_TERM; CUSTOM covers directly-supplied charges. */
export enum SchedulePreset {
  Custom = 'CUSTOM',
  DeferredActivation = 'DEFERRED_ACTIVATION',
  PrepaidTerm = 'PREPAID_TERM',
}

/** Who caused a schedule trigger to fire: a dashboard user, a scheduled job, or the API. */
export enum ScheduleTriggerActor {
  Api = 'API',
  System = 'SYSTEM',
  TenantUser = 'TENANT_USER',
}

/** One billing-schedule trigger firing. */
export type ScheduleTriggerEventEntity = {
  __typename?: 'ScheduleTriggerEventEntity';
  amount?: Maybe<Scalars['Decimal']['output']>;
  /** Which charge fired; null for schedule-level events. */
  chargeKey?: Maybe<Scalars['String']['output']>;
  coveredFrom?: Maybe<Scalars['DateTime']['output']>;
  coveredThrough?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  eventType: ScheduleTriggerEventType;
  id: Scalars['ID']['output'];
  invoiceId?: Maybe<Scalars['ID']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  startDateApplied?: Maybe<Scalars['DateTime']['output']>;
  subscriptionId: Scalars['ID']['output'];
  trigger?: Maybe<ChargeTrigger>;
  triggeredBy: ScheduleTriggerActor;
  triggeredById?: Maybe<Scalars['String']['output']>;
};

/** What an entry in the append-only schedule trigger log records. PERIOD_COVERED lives here rather than in the lifecycle log because a covered period moves no MRR. */
export enum ScheduleTriggerEventType {
  Activated = 'ACTIVATED',
  DeadlineMissed = 'DEADLINE_MISSED',
  NoopTrigger = 'NOOP_TRIGGER',
  PeriodCovered = 'PERIOD_COVERED',
  ScheduleAttached = 'SCHEDULE_ATTACHED',
  ScheduleCancelled = 'SCHEDULE_CANCELLED',
  ScheduleCompleted = 'SCHEDULE_COMPLETED',
  TriggerFired = 'TRIGGER_FIRED',
}

/** A scheduled job that can be run on demand outside production. */
export enum ScheduledJobKey {
  ClickupChatPoll = 'CLICKUP_CHAT_POLL',
  InviteExpireSweep = 'INVITE_EXPIRE_SWEEP',
  InviteReminderSweep = 'INVITE_REMINDER_SWEEP',
  NotificationsDigestSweep = 'NOTIFICATIONS_DIGEST_SWEEP',
  OkrCheckinReminder = 'OKR_CHECKIN_REMINDER',
  OkrHypothesisReminder = 'OKR_HYPOTHESIS_REMINDER',
  OkrMetricRefresh = 'OKR_METRIC_REFRESH',
  OkrScoringReminder = 'OKR_SCORING_REMINDER',
  OkrWeeklyDigest = 'OKR_WEEKLY_DIGEST',
  OkrWeeklyPrompt = 'OKR_WEEKLY_PROMPT',
  OkrWorkLinkSync = 'OKR_WORK_LINK_SYNC',
  SlackHealthCheck = 'SLACK_HEALTH_CHECK',
}

/** The result of running a scheduled job on demand. */
export type ScheduledJobRun = {
  __typename?: 'ScheduledJobRun';
  /** How long it took, so a slow job is visible as one. */
  durationMs: Scalars['Int']['output'];
  job: ScheduledJobKey;
  ran: Scalars['Boolean']['output'];
  /** What the job did, in one line — e.g. "checked 3, changed 1". */
  summary?: Maybe<Scalars['String']['output']>;
};

/** Full resolution walk for a single (component, version, currency) and resolution context. The Scope-walk inspector renders `steps[]` as a vertical timeline; `appliedScope` indicates the winner. */
export type ScopeWalkResult = {
  __typename?: 'ScopeWalkResult';
  /** Which scope produced the applied price. Null when no level matched. */
  appliedScope?: Maybe<VariableComponentPriceScope>;
  /** Headline value of the applied price (null when no level matched). */
  appliedValue?: Maybe<Scalars['Float']['output']>;
  componentId: Scalars['ID']['output'];
  componentVersion: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
  steps: Array<ScopeWalkStep>;
};

/** Per-level outcome from the price resolution walk. */
export enum ScopeWalkState {
  Applied = 'APPLIED',
  Fallback = 'FALLBACK',
  NoMatch = 'NO_MATCH',
  Skipped = 'SKIPPED',
}

/** One step in the price resolution walk (Surface F-06 / ScopeWalk in the v4 design spec). The walk is ordered most-specific to least-specific: SUBSCRIPTION → BUNDLE → MODULE → GLOBAL_DEFAULT. CustomPricingAgreement override is reported as the SUBSCRIPTION level when present. */
export type ScopeWalkStep = {
  __typename?: 'ScopeWalkStep';
  /** Human-readable explanation operators see in the inspector. */
  reason: Scalars['String']['output'];
  scope: VariableComponentPriceScope;
  scopeId?: Maybe<Scalars['ID']['output']>;
  scopeVersion?: Maybe<Scalars['Int']['output']>;
  state: ScopeWalkState;
  /** Headline monetary value for this level (unitPrice / overageUnitPrice / committedUnitPrice in priority order). Null when state is SKIPPED or NO_MATCH, or for non-monetary variant shapes (commission, promotional, tiered). */
  value?: Maybe<Scalars['Float']['output']>;
};

/** A group of fields a search can be narrowed to */
export enum SearchField {
  Domain = 'DOMAIN',
  Email = 'EMAIL',
  InvoiceNumber = 'INVOICE_NUMBER',
  Name = 'NAME',
  Notes = 'NOTES',
  Phone = 'PHONE',
  Reference = 'REFERENCE',
  TaxId = 'TAX_ID',
}

/** Which field a search result matched, shown as "Matched on" */
export type SearchMatchInfo = {
  __typename?: 'SearchMatchInfo';
  /** The query equals the whole value (an invoice number typed in full) */
  exact: Scalars['Boolean']['output'];
  /** Human label of the field, e.g. "Email" or "Company" */
  field: Scalars['String']['output'];
  /** Matched by typo tolerance rather than as typed */
  fuzzy: Scalars['Boolean']['output'];
  /** The stored value that matched */
  value: Scalars['String']['output'];
};

/** One entry in the append-only seat ledger */
export type SeatEvent = {
  __typename?: 'SeatEvent';
  actorUserId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  occurredAt: Scalars['DateTime']['output'];
  seatCurrency: Scalars['String']['output'];
  /** The limit after a LIMIT_CHANGED */
  seatLimitAfter?: Maybe<Scalars['Int']['output']>;
  source: SeatEventSource;
  type: SeatEventType;
  /** Per-seat price in force when this happened */
  unitAmount: Scalars['Float']['output'];
  userId?: Maybe<Scalars['String']['output']>;
};

export enum SeatEventSource {
  AddUser = 'ADD_USER',
  Deactivation = 'DEACTIVATION',
  InviteEmail = 'INVITE_EMAIL',
  InviteSlack = 'INVITE_SLACK',
  Master = 'MASTER',
}

export enum SeatEventType {
  LimitChanged = 'LIMIT_CHANGED',
  PriceChanged = 'PRICE_CHANGED',
  SeatConsumed = 'SEAT_CONSUMED',
  SeatReleased = 'SEAT_RELEASED',
}

/** What a seat costs this tenant and how many they may hold */
export type SeatPolicy = {
  __typename?: 'SeatPolicy';
  /** ISO 4217 code the seat price is denominated in */
  seatCurrency: Scalars['String']['output'];
  /** Maximum active memberships. Null means unlimited, which is every tenant until a platform admin sets a number. */
  seatLimit?: Maybe<Scalars['Int']['output']>;
  /** Contracted price per seat per month */
  unitAmount: Scalars['Float']['output'];
};

/** A tenant asking Revvly for more seats */
export type SeatRequest = {
  __typename?: 'SeatRequest';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  requestedBy: Scalars['String']['output'];
  requestedSeats: Scalars['Int']['output'];
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  status: SeatRequestStatus;
  tenantId: Scalars['String']['output'];
  /** Tenant name, for the platform-admin list */
  tenantName?: Maybe<Scalars['String']['output']>;
};

export enum SeatRequestStatus {
  Declined = 'DECLINED',
  Fulfilled = 'FULFILLED',
  Open = 'OPEN',
}

/** How many seats a tenant is using */
export type SeatUsage = {
  __typename?: 'SeatUsage';
  /** The limit, or null for unlimited */
  limit?: Maybe<Scalars['Int']['output']>;
  /** How far usage exceeds the limit. Non-zero only when a platform admin lowered the limit below current usage, which is allowed and never deactivates anyone. */
  overLimitBy: Scalars['Int']['output'];
  /** Invitations not yet accepted that hold no seat yet: Slack invitations, and memberships kept inactive until accepted. An invitation sent by email activates the membership straight away, so it is already counted in used. */
  pendingInvites: Scalars['Int']['output'];
  /** The policy these numbers are measured against */
  policy: SeatPolicy;
  /** Seats left, or null when unlimited. Never negative — see overLimitBy */
  remaining?: Maybe<Scalars['Int']['output']>;
  /** Active memberships right now */
  used: Scalars['Int']['output'];
};

export type SelectTenantInput = {
  tenantId: Scalars['ID']['input'];
};

export type SendClientEmailInput = {
  attachmentFileIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  bcc?: InputMaybe<Array<EmailRecipientInput>>;
  body: Scalars['String']['input'];
  cc?: InputMaybe<Array<EmailRecipientInput>>;
  draftId?: InputMaybe<Scalars['String']['input']>;
  emailTemplateId?: InputMaybe<Scalars['ID']['input']>;
  includeSignature?: InputMaybe<Scalars['Boolean']['input']>;
  libraryLinks?: InputMaybe<Array<LibraryLinkInput>>;
  organizationId: Scalars['ID']['input'];
  signatureId?: InputMaybe<Scalars['ID']['input']>;
  subject: Scalars['String']['input'];
  threadId?: InputMaybe<Scalars['String']['input']>;
  to: Array<EmailRecipientInput>;
};

export type SendClientEmailResult = {
  __typename?: 'SendClientEmailResult';
  email?: Maybe<EmailCommunication>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

/** A contract to send once a form is answered: the form names who signs, fills the contract, or both. */
export type SendContractAfterFormInput = {
  answers?: Array<ContractAnswerMappingInput>;
  /** The sender writes the first email themselves (one client signer asked first). */
  firstInviteManual?: Scalars['Boolean']['input'];
  /** A published form. Leave it out to ask with a temporary form (`temporaryForm`). */
  formId?: InputMaybe<Scalars['ID']['input']>;
  orderForm?: InputMaybe<ContractOrderChoiceInput>;
  organizationId: Scalars['ID']['input'];
  recipients?: Array<ContractRecipientInput>;
  signingOrder?: InputMaybe<SigningOrder>;
  templateId: Scalars['ID']['input'];
  /** Make a form for this send alone: it asks the client only for the targets named, is not in the forms list, cannot be reused, and is closed once the contract is sent or withdrawn. */
  temporaryForm?: InputMaybe<TemporaryContractFormInput>;
  values?: Array<ContractValueInput>;
};

export type SendContractAfterFormResult = {
  __typename?: 'SendContractAfterFormResult';
  /** The form for the client, for the sender to send. */
  formUrl: Scalars['String']['output'];
  plan: ContractSendPlan;
};

export type SendContractInput = {
  /** The sender writes the first email themselves (one client signer asked first). */
  firstInviteManual?: Scalars['Boolean']['input'];
  orderForm?: InputMaybe<ContractOrderChoiceInput>;
  organizationId: Scalars['ID']['input'];
  recipients?: Array<ContractRecipientInput>;
  signNow?: InputMaybe<SignNowInput>;
  signingOrder?: InputMaybe<SigningOrder>;
  templateId: Scalars['ID']['input'];
  values?: Array<ContractValueInput>;
};

export type SendContractResult = {
  __typename?: 'SendContractResult';
  request: ContractRequest;
  /** The first step's link, for the sender to send themselves. */
  url?: Maybe<Scalars['String']['output']>;
};

export type SendEditablePaymentReminderInput = {
  attachmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  body: Scalars['String']['input'];
  cc?: InputMaybe<Scalars['String']['input']>;
  includeAttachments?: InputMaybe<Scalars['Boolean']['input']>;
  includeSignature?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceId: Scalars['ID']['input'];
  reminderType?: InputMaybe<Scalars['String']['input']>;
  /** Send from the calling user's connected Gmail instead of SES. */
  sendViaMailbox?: InputMaybe<Scalars['Boolean']['input']>;
  /** Which identity to send from. Omitted falls back to `sendViaMailbox`, so existing callers are unchanged. ACCOUNTING_MAILBOX uses the tenant's shared mailbox and its own signature; `signatureId` does not apply to it. */
  sender?: InputMaybe<InvoiceEmailSender>;
  signatureId?: InputMaybe<Scalars['ID']['input']>;
  subject: Scalars['String']['input'];
  to: Scalars['String']['input'];
  trackingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SendEmailActionSettings = {
  __typename?: 'SendEmailActionSettings';
  bodyTemplate: Scalars['String']['output'];
  replyTo?: Maybe<Scalars['String']['output']>;
  sender: FormEmailSender;
  /** USER_MAILBOX: whether the mailbox is the viewer's own. */
  senderIsViewer: Scalars['Boolean']['output'];
  /** USER_MAILBOX: the name of the person whose mailbox sends. */
  senderUserName?: Maybe<Scalars['String']['output']>;
  subjectTemplate: Scalars['String']['output'];
  submitterFieldKey?: Maybe<Scalars['String']['output']>;
  toAddresses: Array<Scalars['String']['output']>;
  toSubmitter: Scalars['Boolean']['output'];
};

export type SendEmailActionSettingsInput = {
  bodyTemplate?: Scalars['String']['input'];
  replyTo?: InputMaybe<Scalars['String']['input']>;
  sender: FormEmailSender;
  subjectTemplate?: Scalars['String']['input'];
  submitterFieldKey?: InputMaybe<Scalars['String']['input']>;
  toAddresses?: Array<Scalars['String']['input']>;
  toSubmitter?: Scalars['Boolean']['input'];
};

export type SendFollowUpEmailInput = {
  body: Scalars['String']['input'];
  includeQuotedReply?: InputMaybe<Scalars['Boolean']['input']>;
  originalEmailId: Scalars['ID']['input'];
  subject: Scalars['String']['input'];
};

/** The outcome of sending a batch of invitations */
export type SendMemberInvitesResult = {
  __typename?: 'SendMemberInvitesResult';
  /** Invitations whose DM was delivered */
  delivered: Scalars['Int']['output'];
  /** Invitations created whose DM did not arrive; they can be resent */
  deliveryFailed: Scalars['Int']['output'];
  invites: Array<MemberInvite>;
};

export type SendPaymentReminderInput = {
  invoiceId: Scalars['ID']['input'];
  reminderType?: InputMaybe<Scalars['String']['input']>;
};

export type SendReminderResult = {
  __typename?: 'SendReminderResult';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type SetComponentZeroUsageExpectedInput = {
  componentId: Scalars['ID']['input'];
  /** True: zero usage is normal for this component on this subscription, so a period that closes at zero raises no warning. False: warn again. */
  expected: Scalars['Boolean']['input'];
  subscriptionId: Scalars['ID']['input'];
};

export type SetContactRoleRetiredInput = {
  key: Scalars['String']['input'];
  retired: Scalars['Boolean']['input'];
};

export type SetConversationThreadVisibilityInput = {
  organizationId: Scalars['ID']['input'];
  state: ConversationThreadVisibilityState;
  threadId: Scalars['String']['input'];
};

export type SetDiscountStackingModeInput = {
  stackingMode: DiscountStackingMode;
  subscriptionId: Scalars['ID']['input'];
};

export type SetInboxCategoryPolicyInput = {
  action: InboxPolicyAction;
  afterDays: Scalars['Int']['input'];
  category: InboxCategory;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Skip threads still unread (archive and move only). */
  leaveUnread?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input for setting the extra payment options on an invoice */
export type SetInvoicePaymentOptionsInput = {
  invoiceId: Scalars['ID']['input'];
  /** Full replacement list of extra payment options printed on this invoice */
  options: Array<UpdateTenantBankingDetailInput>;
};

export type SetMcpRemoteServerToolsInput = {
  /** Tools the agent may call. Must have been advertised. */
  allowedTools: Array<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
  /** The allowed tools an admin confirmed only read. All others need approval per use. */
  readOnlyTools: Array<Scalars['String']['input']>;
  serverId: Scalars['String']['input'];
};

export type SetVariableUsageInput = {
  idempotencyKey: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Absolute target value for currentCount */
  quantity: Scalars['Float']['input'];
  reportedAt?: InputMaybe<Scalars['DateTime']['input']>;
  subscriptionId: Scalars['ID']['input'];
  variableId: Scalars['ID']['input'];
};

export type SignFileInput = {
  /** Add a record-of-signature page (signer, time, id, fingerprint) after the document. On unless false. */
  addRecordPage?: InputMaybe<Scalars['Boolean']['input']>;
  category?: InputMaybe<CrmDocumentCategory>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  /** Keep the result as the next version of this library document. Library managers only; sourceFileId must be its current file. */
  libraryDocumentId?: InputMaybe<Scalars['ID']['input']>;
  placements: Array<SignaturePlacementInput>;
  /** Frame each signature with the Revvly mark and its signature id. On unless false. */
  showSignatureId?: InputMaybe<Scalars['Boolean']['input']>;
  /** Defaults to your default signature. */
  signatureId?: InputMaybe<Scalars['ID']['input']>;
  /** A PDF uploaded to a client's or prospect's Documents tab. The signed copy is filed on the same record. */
  sourceCrmDocumentId?: InputMaybe<Scalars['ID']['input']>;
  /** A stored PDF: an attachment or a library document version. Give this or sourceCrmDocumentId. */
  sourceFileId?: InputMaybe<Scalars['ID']['input']>;
  subjectId?: InputMaybe<Scalars['ID']['input']>;
  /** The record the signed copy is filed on, with subjectId. */
  subjectType?: InputMaybe<EntityTargetType>;
  /** Lines of text the signer typed onto the pages. */
  textFields?: InputMaybe<Array<TextFieldInput>>;
  /** What changed, shown on the new library version. */
  versionNote?: InputMaybe<Scalars['String']['input']>;
};

/** Sign as your own team signer when you send, with one of your saved signatures. You are signed in, so no link or email code is involved. */
export type SignNowInput = {
  /** You agree to sign this contract electronically with your signature. */
  agreed: Scalars['Boolean']['input'];
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  /** Defaults to your default signature. */
  signatureId?: InputMaybe<Scalars['ID']['input']>;
  /** The team slot you sign as. Its signer must be you. */
  slot: Scalars['String']['input'];
  /** The fields your slot fills, by key. */
  values?: Array<ContractValueInput>;
};

export type SignaturePlacementInput = {
  /** A line printed under the signature (name, date). */
  caption?: InputMaybe<Scalars['String']['input']>;
  /** 1-based page number. */
  page: Scalars['Int']['input'];
  /** Signature width, 0–1 of the page width. */
  width: Scalars['Float']['input'];
  /** Left edge, 0–1 of the page width. */
  x: Scalars['Float']['input'];
  /** Top edge, 0–1 of the page height, from the top. */
  y: Scalars['Float']['input'];
};

/** One sent contract in full, for its own page. */
export type SignatureRequestDetail = {
  __typename?: 'SignatureRequestDetail';
  copies: Array<ContractCopyEmail>;
  /** The contract as it reads now: signed text once complete, otherwise blanks where values are still to come. */
  html: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  openedAt?: Maybe<Scalars['DateTime']['output']>;
  organizationId: Scalars['ID']['output'];
  recipients: Array<ContractRecipientView>;
  recordedContractId?: Maybe<Scalars['String']['output']>;
  requireEmailCode: Scalars['Boolean']['output'];
  sentAt: Scalars['DateTime']['output'];
  signatures: Array<ContractSignatureBlock>;
  signedAt?: Maybe<Scalars['DateTime']['output']>;
  signedSha256?: Maybe<Scalars['String']['output']>;
  signerEmail: Scalars['String']['output'];
  /** The client's first signer. */
  signerName: Scalars['String']['output'];
  signingOrder: SigningOrder;
  status: ContractRequestStatus;
  title: Scalars['String']['output'];
  /** The client's first signer's link, while they can still sign. */
  url?: Maybe<Scalars['String']['output']>;
  /** Who it waits on now, while it is out. */
  waitingOn?: Maybe<Scalars['String']['output']>;
};

export enum SignedCopyStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Sent = 'SENT',
}

export type SignedFile = {
  __typename?: 'SignedFile';
  /** The document filed on the record, when a record was named. */
  crmDocumentId?: Maybe<Scalars['ID']['output']>;
  fileName: Scalars['String']['output'];
  fileSize: Scalars['Int']['output'];
  /** The library version made, when a library document was signed. */
  libraryVersionNumber?: Maybe<Scalars['Int']['output']>;
  /** False only when a record was named but could not be made; the file itself is fine. */
  recorded: Scalars['Boolean']['output'];
  signedAt: Scalars['DateTime']['output'];
  /** The new stored file; attach it to an email by this id. */
  signedFileId: Scalars['ID']['output'];
  /** SHA-256 of the signed file. */
  signedSha256: Scalars['String']['output'];
};

export enum SigningOrder {
  Parallel = 'PARALLEL',
  Sequential = 'SEQUENTIAL',
}

/** A workspace’s situation thresholds: the values in force, the defaults they start from, and which values the workspace has changed. */
export type SituationThresholdSettings = {
  __typename?: 'SituationThresholdSettings';
  /** What each value is when not changed. */
  defaults: SituationThresholds;
  /** Names of the values this workspace has changed. */
  overridden: Array<Scalars['String']['output']>;
  /** The values the nightly sweep uses. */
  values: SituationThresholds;
};

/** The thresholds that decide when each account situation opens. */
export type SituationThresholds = {
  __typename?: 'SituationThresholds';
  /** Replies a contact needs before their own history is their baseline; until then the workspace's median stands in. */
  baselineMinReplies: Scalars['Int']['output'];
  /** How many of the latest messages the champion must be missing from. */
  championAbsentFromLast: Scalars['Int']['output'];
  /** Message appearances before a contact counts as the account champion. */
  championMinAppearances: Scalars['Int']['output'];
  /** Days past a due date before a commitment is overdue. */
  commitmentGraceDays: Scalars['Int']['output'];
  /** Days of silence after which the stakeholder-shape situations stop firing. */
  dormantAfterDays: Scalars['Int']['output'];
  /** How many of a contact's usual reply times late before they count as going dark. */
  goingDarkLatencyMultiplier: Scalars['Float']['output'];
  /** Our messages in a row, unanswered, that count as being ignored. */
  goingDarkUnansweredOutbound: Scalars['Int']['output'];
  /** Shortest reply time, in days, treated as meaningful when judging lateness. */
  minReplyBaselineDays: Scalars['Float']['output'];
  /** Distinct contacts at which an account counts as multithreaded. */
  multithreadingMinContacts: Scalars['Int']['output'];
  /** How many of a contact's usual reply times a wait may last and still be normal. */
  replyWindowMultiplier: Scalars['Float']['output'];
  /** Days after our last message before an account counts as stalled. */
  stallAfterDays: Scalars['Int']['output'];
};

export type SituationThresholdsInput = {
  baselineMinReplies?: InputMaybe<Scalars['Int']['input']>;
  championAbsentFromLast?: InputMaybe<Scalars['Int']['input']>;
  championMinAppearances?: InputMaybe<Scalars['Int']['input']>;
  commitmentGraceDays?: InputMaybe<Scalars['Int']['input']>;
  dormantAfterDays?: InputMaybe<Scalars['Int']['input']>;
  goingDarkLatencyMultiplier?: InputMaybe<Scalars['Float']['input']>;
  goingDarkUnansweredOutbound?: InputMaybe<Scalars['Int']['input']>;
  minReplyBaselineDays?: InputMaybe<Scalars['Float']['input']>;
  multithreadingMinContacts?: InputMaybe<Scalars['Int']['input']>;
  replyWindowMultiplier?: InputMaybe<Scalars['Float']['input']>;
  stallAfterDays?: InputMaybe<Scalars['Int']['input']>;
};

/** Input for skipping an onboarding step */
export type SkipOnboardingStepInput = {
  /** Step ID to skip */
  stepId: Scalars['String']['input'];
};

/** A cluster that produced no proposal, and why */
export type SkippedCatalogGapEntity = {
  __typename?: 'SkippedCatalogGapEntity';
  clusterKey: Scalars['String']['output'];
  reason: Scalars['String']['output'];
};

/** One selection that could not be added, and the reason, for a partial batch. */
export type SkippedContactSuggestion = {
  __typename?: 'SkippedContactSuggestion';
  email: Scalars['String']['output'];
  reason: Scalars['String']['output'];
};

/** A public channel the announcement picker can offer. */
export type SlackChannelOption = {
  __typename?: 'SlackChannelOption';
  id: Scalars['String']['output'];
  /** Whether the bot is already in it. It joins on save if not. */
  isMember: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export enum SlackConnectionStatus {
  Connected = 'CONNECTED',
  Degraded = 'DEGRADED',
  Disconnected = 'DISCONNECTED',
  Revoked = 'REVOKED',
  Uninstalled = 'UNINSTALLED',
}

/** A Slack account with no Revvly user — the invite pool. */
export type SlackDirectoryEntry = {
  __typename?: 'SlackDirectoryEntry';
  displayName: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  slackUserId: Scalars['String']['output'];
};

export type SlackMappingResult = {
  __typename?: 'SlackMappingResult';
  mapped: Scalars['Int']['output'];
  /** Reasons, one per person who could not be mapped. */
  skipped: Array<Scalars['String']['output']>;
};

export enum SlackMappingSource {
  EmailMatch = 'EMAIL_MATCH',
  Invite = 'INVITE',
  Manual = 'MANUAL',
  SelfLinked = 'SELF_LINKED',
}

/** Everything the member-mapping screen renders. */
export type SlackMappingView = {
  __typename?: 'SlackMappingView';
  invitableSlackUsers: Array<SlackDirectoryEntry>;
  mapped: Array<SlackMemberLink>;
  /** Nothing matched at all, which usually means the Slack and Revvly email domains differ. */
  noMatchesFound: Scalars['Boolean']['output'];
  proposals: Array<SlackMatchSuggestion>;
  unmapped: Array<SlackUnmappedUser>;
};

/** A proposed pairing, computed on demand. Never stored until confirmed. */
export type SlackMatchSuggestion = {
  __typename?: 'SlackMatchSuggestion';
  slackDisplayName: Scalars['String']['output'];
  slackUserId: Scalars['String']['output'];
  userEmail: Scalars['String']['output'];
  userId: Scalars['String']['output'];
  userName: Scalars['String']['output'];
};

/** A confirmed link between a Revvly user and a Slack account. */
export type SlackMemberLink = {
  __typename?: 'SlackMemberLink';
  mappedAt: Scalars['DateTime']['output'];
  reachability: SlackReachability;
  slackDisplayName?: Maybe<Scalars['String']['output']>;
  slackEmail?: Maybe<Scalars['String']['output']>;
  slackUserId: Scalars['String']['output'];
  source: SlackMappingSource;
  userEmail?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
  /** The Revvly person, by name */
  userName?: Maybe<Scalars['String']['output']>;
};

export enum SlackReachability {
  Deactivated = 'DEACTIVATED',
  Mapped = 'MAPPED',
  Unmapped = 'UNMAPPED',
}

/** A Revvly member with neither a link nor a proposal. */
export type SlackUnmappedUser = {
  __typename?: 'SlackUnmappedUser';
  userEmail?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
  userName: Scalars['String']['output'];
};

/** A tenant's Slack connection, as the settings screen reads it. */
export type SlackWorkspaceStatus = {
  __typename?: 'SlackWorkspaceStatus';
  announcementChannelId?: Maybe<Scalars['String']['output']>;
  /** The bot was removed from the announcement channel, or it was deleted. Distinct from never having chosen one. */
  announcementChannelLost: Scalars['Boolean']['output'];
  announcementChannelName?: Maybe<Scalars['String']['output']>;
  /** Connected, someone mapped, and a channel chosen. */
  complete: Scalars['Boolean']['output'];
  /** Slack accounts with no Revvly user yet. */
  invitableCount: Scalars['Int']['output'];
  lastHealthyAt?: Maybe<Scalars['DateTime']['output']>;
  mappedCount: Scalars['Int']['output'];
  slackTeamName?: Maybe<Scalars['String']['output']>;
  status: SlackConnectionStatus;
  /** Why the status is what it is, in words. */
  statusReason?: Maybe<Scalars['String']['output']>;
  unmappedCount: Scalars['Int']['output'];
};

/** Sort order for paginated queries */
export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC',
}

/** What one spot-check answer did */
export type SpotCheckDecisionEntity = {
  __typename?: 'SpotCheckDecisionEntity';
  /** True when the flag cost at least one product its autonomy, so its invoices return to the review queue. False on a pass, and false on a flag against a product that had already lost it. */
  autonomyChanged: Scalars['Boolean']['output'];
  /** Products the decision was charged against — the ones the matcher proposed */
  productIds: Array<Scalars['String']['output']>;
  resultId: Scalars['String']['output'];
};

/** The lighter pass over invoices nobody sees. A product that has earned autonomy is matched without review, which is also the only place the matcher can be confidently wrong at volume; this is how a reviewer looks anyway. Read-only — asking checks nothing. */
export type SpotCheckReportEntity = {
  __typename?: 'SpotCheckReportEntity';
  /** Auto-accepted invoices across every earned product */
  autoAcceptedTotal: Scalars['Int']['output'];
  /** Most-exposed product first */
  products: Array<ProductSpotCheckEntity>;
  /** Members offered per product */
  sampleSize: Scalars['Int']['output'];
};

/** Instance count per stacking mode (Flexible Discounting §10). */
export type StackingModeCount = {
  __typename?: 'StackingModeCount';
  count: Scalars['Int']['output'];
  mode: DiscountStackingMode;
};

export type StalePin = {
  __typename?: 'StalePin';
  currentPublishedVersion: Scalars['Int']['output'];
  entityId: Scalars['ID']['output'];
  entityName?: Maybe<Scalars['String']['output']>;
  pinType: StalePinType;
  pinnedVersion: Scalars['Int']['output'];
};

/** Which pin on a subscription is stale: module, bundle, or component. */
export enum StalePinType {
  Bundle = 'BUNDLE',
  Component = 'COMPONENT',
  Module = 'MODULE',
}

export type StartIntercomImportInput = {
  /** An Intercom access token that can read conversations, contacts and admins. Encrypted at rest and discarded when the import ends; never returned. */
  accessToken: Scalars['String']['input'];
  region: IntercomRegion;
  /** Import conversations started on or after this date. Defaults to 24 months ago, which is also the furthest back an import reads. */
  sinceDate?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Input for starting onboarding */
export type StartOnboardingInput = {
  /** Optional config ID to use (defaults to active default) */
  configId?: InputMaybe<Scalars['String']['input']>;
};

export type StartTestingInputType = {
  acknowledge?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Locks on confirm */
  decisionRule?: InputMaybe<Scalars['String']['input']>;
  /** Locks on confirm */
  expectedOutcome?: InputMaybe<Scalars['String']['input']>;
  /** A retried request with the same key is not applied twice */
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  /** Today or later */
  plannedEndDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Stats = {
  __typename?: 'Stats';
  active: Scalars['Int']['output'];
  draft: Scalars['Int']['output'];
  legacy: Scalars['Int']['output'];
  recent: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

/** The four fixed categories every tenant-defined status maps to. */
export enum StatusCategory {
  Closed = 'CLOSED',
  InProgress = 'IN_PROGRESS',
  Open = 'OPEN',
  Pending = 'PENDING',
}

/** Which client stage each status of a ClickUp list means. Statuses not listed are internal. */
export type StatusMap = {
  __typename?: 'StatusMap';
  entries: Array<StatusMapEntry>;
  /** Null: the default for every list with no map of its own. */
  listId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type StatusMapEntry = {
  __typename?: 'StatusMapEntry';
  externalStatus: Scalars['String']['output'];
  /** Null: internal, the client never hears of it. */
  stageKey?: Maybe<Scalars['String']['output']>;
};

export type StatusMapEntryInput = {
  externalStatus: Scalars['String']['input'];
  stageKey?: InputMaybe<Scalars['String']['input']>;
};

export type StatusWorkflow = {
  __typename?: 'StatusWorkflow';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  statuses: Array<WorkflowStatus>;
  /** Empty = any move between non-retired statuses is allowed. */
  transitions: Array<WorkflowTransition>;
  /** Send back as expectedUpdatedAt when editing. */
  updatedAt: Scalars['DateTime']['output'];
};

/** The whole workflow. Statuses can be renamed, reordered, added and retired, never removed or re-categorised. */
export type StatusWorkflowInput = {
  /** The updatedAt you loaded. Send it: a newer stored copy fails with CONFLICT. */
  expectedUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Omit to create a workflow. */
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  statuses: Array<WorkflowStatusInput>;
  /** Empty = any move between live statuses. */
  transitions?: InputMaybe<Array<WorkflowTransitionInput>>;
};

/** Storage usage statistics */
export type StorageStats = {
  __typename?: 'StorageStats';
  byCategory: Array<CategoryStats>;
  /** Total number of files */
  totalFiles: Scalars['Int']['output'];
  /** Total storage used in bytes (as string for large numbers) */
  totalSizeBytes: Scalars['String']['output'];
  /** Human-readable total storage */
  totalSizeFormatted: Scalars['String']['output'];
};

/** Stored file metadata */
export type StoredFileEntity = {
  __typename?: 'StoredFileEntity';
  category: FileCategory;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  filename: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** S3 storage key for the file */
  key: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  originalFilename: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  status: FileStatus;
  updatedAt: Scalars['DateTime']['output'];
  uploadedByEmail?: Maybe<Scalars['String']['output']>;
};

/** Paginated list of stored files */
export type StoredFileList = {
  __typename?: 'StoredFileList';
  hasMore: Scalars['Boolean']['output'];
  items: Array<StoredFileEntity>;
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type SubmitScoreInputType = {
  /** Required. Why it ended where it did. */
  comment: Scalars['String']['input'];
  /** Where the Key Result ended. */
  finalValue: Scalars['Float']['input'];
  keyResultId: Scalars['ID']['input'];
};

/** What a client is owed before a new sub-processor starts. */
export type SubprocessorChangeClause = {
  __typename?: 'SubprocessorChangeClause';
  consent: SubprocessorConsent;
  /** How notice is given. */
  notes?: Maybe<Scalars['String']['output']>;
  /** Days of notice before it starts. Null: none given. */
  noticeDays?: Maybe<Scalars['Int']['output']>;
  /** Days to object, under OBJECTION. */
  objectionDays?: Maybe<Scalars['Int']['output']>;
  /** The contract's own words. */
  quote?: Maybe<Scalars['String']['output']>;
};

export type SubprocessorChangeClauseInput = {
  consent: SubprocessorConsent;
  notes?: InputMaybe<Scalars['String']['input']>;
  noticeDays?: InputMaybe<Scalars['Int']['input']>;
  objectionDays?: InputMaybe<Scalars['Int']['input']>;
  quote?: InputMaybe<Scalars['String']['input']>;
};

/** Sub-processor terms read from a document, before a person checks them. */
export type SubprocessorChangeProposal = {
  __typename?: 'SubprocessorChangeProposal';
  consent?: Maybe<SubprocessorConsent>;
  notes?: Maybe<Scalars['String']['output']>;
  noticeDays?: Maybe<Scalars['Int']['output']>;
  objectionDays?: Maybe<Scalars['Int']['output']>;
  quote?: Maybe<Scalars['String']['output']>;
};

/** What a client is owed before a new sub-processor starts. */
export enum SubprocessorConsent {
  Notice = 'NOTICE',
  Objection = 'OBJECTION',
  PriorConsent = 'PRIOR_CONSENT',
}

/** Result of firing the ACTIVATION trigger on a subscription. */
export type SubscriptionActivationResult = {
  __typename?: 'SubscriptionActivationResult';
  /** The go-live date the term was re-anchored to. */
  activatedAt: Scalars['DateTime']['output'];
  /** True when this call changed nothing because the subscription was already live (or never awaited activation). Not an error: a second Activate click must not raise a second invoice. */
  alreadyActive: Scalars['Boolean']['output'];
  /** The go-live invoice, when one was raised. */
  invoiceId?: Maybe<Scalars['ID']['output']>;
  /** End of the first real billing period. */
  periodEnd: Scalars['DateTime']['output'];
  subscriptionId: Scalars['ID']['output'];
  /** What went wrong without stopping the activation — a counter that failed to initialise, or an invoice that could not be generated. The subscription is live either way. */
  warnings?: Maybe<Array<Scalars['String']['output']>>;
};

/** Per-collection counts of the operational records removed when a subscription is cascade-deleted. Audit/compliance logs (lifecycle events, usage audit, billing snapshots) are intentionally preserved and are not counted here. */
export type SubscriptionCascadeDeletionCounts = {
  __typename?: 'SubscriptionCascadeDeletionCounts';
  /** API keys whose scope.subscriptionIds were scrubbed of this subscription */
  apiKeysScrubbed: Scalars['Int']['output'];
  /** SubscriptionExpansion records deleted */
  expansions: Scalars['Int']['output'];
  /** RenewalAction records deleted */
  renewalActions: Scalars['Int']['output'];
  /** SUBSCRIPTION-scoped VariableComponentPrice records deleted */
  subscriptionScopedPrices: Scalars['Int']['output'];
  /** VariableUsageEvent raw events deleted */
  variableUsageEvents: Scalars['Int']['output'];
  /** SubscriptionVariableUsage counter records deleted */
  variableUsageRecords: Scalars['Int']['output'];
};

export type SubscriptionCashFlowPeriod = {
  __typename?: 'SubscriptionCashFlowPeriod';
  /** Date the period is billed on (the renewal date), stepped from nextRenewalDate by the subscription's billing cadence. Null when the subscription has no nextRenewalDate. */
  billingDate?: Maybe<Scalars['DateTime']['output']>;
  /** True when this period's BASE charge was already invoiced ahead of the renewal — by a prepaid span, or by the client's renewal lead time — so the renewal bills no base line and the amounts here carry usage only. The money is not missing: it is an issued invoice in AR. Label the period rather than reading the dip as lost revenue. */
  coveredByPrepayment: Scalars['Boolean']['output'];
  /** The tenant's reporting currency. */
  currency: Scalars['String']['output'];
  /** grossAmount − netAmount: the cash this period will not collect. Never negative. */
  discountAmount: Scalars['Float']['output'];
  /** List cash for the full billing period in the tenant's reporting currency — base price plus projected variable-component charges, before any discount. */
  grossAmount: Scalars['Float']['output'];
  /** Cash for the full billing period after the discounts that are still active for THIS period. Equals grossAmount once every time-bound discount has expired. */
  netAmount: Scalars['Float']['output'];
  /** Offset of this billing period from the next renewal: 0 = the period billed at nextRenewalDate, 1 = the one after it, and so on. */
  periodIndex: Scalars['Int']['output'];
};

export type SubscriptionConnection = {
  __typename?: 'SubscriptionConnection';
  edges: Array<SubscriptionEdge>;
  filteredCount: Scalars['Int']['output'];
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SubscriptionCreationResult = {
  __typename?: 'SubscriptionCreationResult';
  /** When the subscription was created */
  createdAt: Scalars['DateTime']['output'];
  /** Feature flags enabled for this subscription */
  enabledFeatureFlags: Array<FeatureFlag>;
  /** List of bundle IDs included in the subscription */
  includedBundleIds?: Maybe<Array<Scalars['String']['output']>>;
  /** List of module IDs included in the subscription */
  includedModuleIds: Array<Scalars['String']['output']>;
  /** Pricing breakdown and calculation details */
  pricingBreakdown: SubscriptionPricingBreakdown;
  /** Region code */
  regionCode: Scalars['String']['output'];
  /** Region where the subscription is active */
  regionName: Scalars['String']['output'];
  /** The created subscription */
  subscription: OrganizationSubscription;
  /** Any warnings or additional information */
  warnings?: Maybe<Array<Scalars['String']['output']>>;
};

/** One discount on a subscription, enriched for display: the snapshotted terms, its source, the target it reduces, duration progress (applied vs remaining) and a per-billing-period value estimate (Flexible Discounting §8.5/§10). */
export type SubscriptionDiscountLine = {
  __typename?: 'SubscriptionDiscountLine';
  /** Estimated value taken off ONE billing period at current terms, in the subscription currency. Null when the amount is usage-dependent (a percentage on a usage component) — subscriptionDiscountPreview is the precise per-invoice figure. */
  estimatedPeriodDiscount?: Maybe<Scalars['Decimal']['output']>;
  /** The instance itself: name, type/value, duration, appliedCount, remainingRenewals, status and appliedAt (when it started on this subscription). */
  instance: DiscountInstanceEntity;
  /** Name of the source library definition, or "One-off" for a one-off discount. */
  sourceName?: Maybe<Scalars['String']['output']>;
  /** The subscription's locked currency — the currency of the estimate. */
  subscriptionCurrency: Scalars['String']['output'];
  /** Human-readable target: "Base price" or the component name. */
  targetLabel: Scalars['String']['output'];
};

export type SubscriptionDocument = {
  __typename?: 'SubscriptionDocument';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  documentType: DocumentType;
  fileName: Scalars['String']['output'];
  filePath: Scalars['String']['output'];
  fileSize?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  mimeType?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  subscription: OrganizationSubscription;
  subscriptionId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uploadedAt: Scalars['DateTime']['output'];
  uploadedBy?: Maybe<Scalars['String']['output']>;
};

export type SubscriptionEdge = {
  __typename?: 'SubscriptionEdge';
  cursor: Scalars['String']['output'];
  node: OrganizationSubscription;
  /** Which field matched, when the list was searched */
  searchMatch?: Maybe<SearchMatchInfo>;
};

export type SubscriptionExpansion = {
  __typename?: 'SubscriptionExpansion';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  currency: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  effectiveDate: Scalars['DateTime']['output'];
  expansionType: ExpansionType;
  id: Scalars['ID']['output'];
  itemId?: Maybe<Scalars['String']['output']>;
  itemName?: Maybe<Scalars['String']['output']>;
  proratedAmount: Scalars['Decimal']['output'];
  quantityChange?: Maybe<Scalars['Int']['output']>;
  relatedInvoiceId?: Maybe<Scalars['ID']['output']>;
  subscription: OrganizationSubscription;
  subscriptionId: Scalars['String']['output'];
};

export type SubscriptionFilterInput = {
  bundleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter subscriptions cancelled on or after this date */
  cancelledFrom?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter subscriptions cancelled on or before this date */
  cancelledTo?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter subscriptions created by this user */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  /** Filter subscriptions created on or after this date */
  createdFrom?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter subscriptions created on or before this date */
  createdTo?: InputMaybe<Scalars['DateTime']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  /** Filter subscriptions ending on or after this date */
  endDateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter subscriptions ending on or before this date */
  endDateTo?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  moduleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  periods?: InputMaybe<Array<SubscriptionPeriod>>;
  renewalDateDays?: InputMaybe<Scalars['Int']['input']>;
  renewalDateFilterType?: InputMaybe<RenewalDateFilterType>;
  /** Search by organization name, ID, notes, or bundle/module IDs */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Narrow `search` to these field groups; every field when empty */
  searchFields?: InputMaybe<Array<SearchField>>;
  sortBy?: InputMaybe<SubscriptionSortField>;
  sortOrder?: InputMaybe<SortOrder>;
  /** Filter subscriptions starting on or after this date */
  startDateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter subscriptions starting on or before this date */
  startDateTo?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<SubscriptionStatusFilter>;
  /** Filter by subscription types */
  subscriptionTypes?: InputMaybe<Array<SubscriptionType>>;
  tiers?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SubscriptionImportItem = {
  /** Subscription amount (base price) */
  amount: Scalars['Float']['input'];
  /** Churn/cancellation date (ISO format). If churned but no date, only 1 period is created. */
  churnDate?: InputMaybe<Scalars['String']['input']>;
  /** Currency code (e.g., USD, EUR, QAR) - REQUIRED */
  currency: Scalars['String']['input'];
  /** Invoice prefix to identify the organization (e.g., "INV-ACME-") */
  invoicePrefix?: InputMaybe<Scalars['String']['input']>;
  /** Whether the subscription has churned (cancelled/not renewed) */
  isChurned?: Scalars['Boolean']['input'];
  /** Additional notes */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Contact email for the organization */
  organizationEmail?: InputMaybe<Scalars['String']['input']>;
  /** Organization/Customer name */
  organizationName: Scalars['String']['input'];
  /** Subscription billing period */
  period?: SubscriptionPeriod;
  /** Region name or ID for the subscription */
  region?: InputMaybe<Scalars['String']['input']>;
  /** Subscription start date (ISO format) */
  startDate: Scalars['String']['input'];
};

export type SubscriptionInvoice = {
  __typename?: 'SubscriptionInvoice';
  actualPaymentDate?: Maybe<Scalars['DateTime']['output']>;
  /** What the customer owes. With tax on this is `subtotalAmount + taxAmount`; AR and payments read it. */
  amount: Scalars['Decimal']['output'];
  /** Outstanding balance (amount - amountPaid), floored at 0. */
  amountDue: Scalars['Decimal']['output'];
  /** Cumulative amount collected against this invoice, in the invoice currency. A partial payment leaves paymentStatus at PENDING/OVERDUE with a non-zero amountPaid. */
  amountPaid: Scalars['Decimal']['output'];
  attachments?: Maybe<Array<InvoiceAttachment>>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['ID']['output']>;
  /** The user who created this invoice */
  createdByUser?: Maybe<ActorSummary>;
  /** CREDIT NOTES ONLY — append-only record of which receivables the credit was spent on. A credit can be spread over several invoices. */
  creditApplications?: Maybe<Array<CreditApplication>>;
  /** CREDIT NOTES ONLY — how much of the credit has been spent, as a positive figure against its positive face value. Null on ordinary invoices. */
  creditAppliedAmount?: Maybe<Scalars['Decimal']['output']>;
  creditNotes: Array<SubscriptionInvoice>;
  /** CREDIT NOTES ONLY — credit still available to apply or refund. Deliberately not amountDue, which reads amount − amountPaid and floors at zero, so on a negative amount it reports every credit note as already settled. */
  creditRemaining?: Maybe<Scalars['Decimal']['output']>;
  /** CREDIT NOTES ONLY — the invoice this credit was raised against, when it corrects a specific one. Null for a standalone credit. Provenance, not a constraint: the credit can be applied to a different invoice. */
  creditsInvoiceId?: Maybe<Scalars['ID']['output']>;
  currency: Scalars['String']['output'];
  discountAmount?: Maybe<Scalars['Decimal']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  estimatedPaymentDate?: Maybe<Scalars['DateTime']['output']>;
  /** Payment options added to this invoice on top of the default account for the client’s region and currency. Printed on the PDF the next time it is regenerated. */
  extraPaymentOptions?: Maybe<Array<TenantBankingDetail>>;
  googleDriveFileId?: Maybe<Scalars['String']['output']>;
  /** True when this RENEWAL invoice also carried usage-driven expansion (more usage than the prior period). invoiceType stays RENEWAL; the billing history shows "renewal · expansion". */
  hasExpansion?: Maybe<Scalars['Boolean']['output']>;
  /** Why this draft is held. Null once issued. */
  heldReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invoiceDate?: Maybe<Scalars['DateTime']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  invoiceType: InvoiceType;
  /** True when this document is a credit note rather than a receivable: invoiceType REFUND with a negative amount. A credit note carries no due date and never ages or draws a payment reminder — there is nothing for the client to pay. */
  isCreditNote: Scalars['Boolean']['output'];
  isUnmatched?: Maybe<Scalars['Boolean']['output']>;
  /** Issuance state, independent of payment. DRAFT invoices carry no number or dates. */
  issueState: InvoiceIssueState;
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  lineItems: Array<InvoiceLineItem>;
  /** A discount added by hand to this unpaid invoice. Its amount is already inside `discountAmount` and the line totals. */
  manualDiscount?: Maybe<InvoiceManualDiscount>;
  notes?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  organizationId: Scalars['ID']['output'];
  paymentStatus?: Maybe<PaymentStatus>;
  paymentTermsDays: Scalars['Float']['output'];
  /** Payments recorded against this invoice, oldest first. */
  payments: Array<InvoicePayment>;
  pdfStatus?: Maybe<InvoicePdfStatus>;
  periodEnd?: Maybe<Scalars['DateTime']['output']>;
  periodStart?: Maybe<Scalars['DateTime']['output']>;
  source?: Maybe<InvoiceSource>;
  subscription?: Maybe<OrganizationSubscription>;
  subscriptionId?: Maybe<Scalars['ID']['output']>;
  /** Net of all lines after discounts. Null on an invoice without tax; read it as `subtotalAmount ?? amount`. */
  subtotalAmount?: Maybe<Scalars['Decimal']['output']>;
  /** Total tax; null when none was charged. */
  taxAmount?: Maybe<Scalars['Decimal']['output']>;
  taxBreakdown?: Maybe<Array<InvoiceTaxLine>>;
  taxSnapshot?: Maybe<InvoiceTaxSnapshot>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Scalars['ID']['output']>;
};

/** One persisted transition on a subscription lifecycle. */
export type SubscriptionLifecycleEventEntity = {
  __typename?: 'SubscriptionLifecycleEventEntity';
  actorUserId?: Maybe<Scalars['String']['output']>;
  /** Reason the subscription churned. Present only on CHURNED events. */
  churnReason?: Maybe<ChurnReason>;
  /** When the event was persisted. */
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** Event-specific metadata serialized as JSON. Shape varies by type. Parse client-side if you need structured access; otherwise treat as opaque. */
  metadataJson?: Maybe<Scalars['String']['output']>;
  /** MRR impact in the tenant reporting currency at event time. */
  mrrDelta: Scalars['Decimal']['output'];
  /** Subscription native currency at event time. */
  nativeCurrency?: Maybe<Scalars['String']['output']>;
  /** MRR impact in the subscription native currency. Present when the native currency differs from the reporting currency. */
  nativeMrrDelta?: Maybe<Scalars['Decimal']['output']>;
  /** Effective date of the transition. Use this for timeline ordering, not createdAt (which is the insertion time and may lag for back-dated imports). */
  occurredAt: Scalars['DateTime']['output'];
  organizationId: Scalars['String']['output'];
  /** Reporting currency the mrrDelta is denominated in. */
  reportingCurrency: Scalars['String']['output'];
  subscriptionId: Scalars['ID']['output'];
  type: SubscriptionLifecycleEventType;
  /** MRR impact from variable/usage components in the reporting currency at event time. Captured as projected when the event fired; usage drift between events is not reflected. */
  variableMrrDelta?: Maybe<Scalars['Decimal']['output']>;
};

/** Kind of subscription lifecycle transition. Analytics derives ARR/MRR/churn/expansion from these events. */
export enum SubscriptionLifecycleEventType {
  AddComponent = 'ADD_COMPONENT',
  CancelScheduled = 'CANCEL_SCHEDULED',
  Churned = 'CHURNED',
  Contracted = 'CONTRACTED',
  Created = 'CREATED',
  Expanded = 'EXPANDED',
  MigrateBundle = 'MIGRATE_BUNDLE',
  MigrateComponent = 'MIGRATE_COMPONENT',
  MigrateModule = 'MIGRATE_MODULE',
  Reactivated = 'REACTIVATED',
  RemoveComponent = 'REMOVE_COMPONENT',
  Renewed = 'RENEWED',
}

/** One pinned module in a subscription's plan. Each module version is its own catalog document with its own pricing, so the version here is what the client was billed against. */
export type SubscriptionModulePin = {
  __typename?: 'SubscriptionModulePin';
  /** Module document _id (a specific version). */
  moduleId: Scalars['ID']['output'];
  /** The module lineage this version belongs to — stable across versions, so two pins of the same commercial module are recognisable as one plan element. */
  moduleLineageId?: Maybe<Scalars['ID']['output']>;
  /** Pinned module version. */
  moduleVersion: Scalars['Int']['output'];
  /** Selected priced tier, or null for the base price. */
  tierId?: Maybe<Scalars['ID']['output']>;
};

/** Subscription billing period */
export enum SubscriptionPeriod {
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  Yearly = 'YEARLY',
}

/** One stretch of time a subscription spent on one plan. Derived: a period runs until the next one begins, so `until` is null on the period still in force and no end date is ever stored. Read this rather than folding versionHistory yourself — a change only SCHEDULED for the next renewal is not a period the client has been on, and is reported separately. */
export type SubscriptionPlanPeriod = {
  __typename?: 'SubscriptionPlanPeriod';
  /** When this plan took effect for this client. */
  from: Scalars['DateTime']['output'];
  /** Set when this pin was deliberately placed on a version that is not the offer. */
  legacyPinReason?: Maybe<Scalars['String']['output']>;
  /** The plan's name — the pinned bundle's, or the pinned modules' joined. Null when the version no longer resolves. */
  planName?: Maybe<Scalars['String']['output']>;
  /** Why the plan changed at `from`. */
  reason?: Maybe<Scalars['String']['output']>;
  /** True when this period was recorded after the fact — a reconstructed history rather than a change captured as it happened. */
  reconstructed: Scalars['Boolean']['output'];
  /** The pins and price in force for this period. */
  state: SubscriptionVersionEntryState;
  /** When the next plan began. Null while this one is still in force. */
  until?: Maybe<Scalars['DateTime']['output']>;
};

/** A subscription's plan history: the periods it spent on each plan, plus the change queued for its next renewal, if any. */
export type SubscriptionPlanTimeline = {
  __typename?: 'SubscriptionPlanTimeline';
  /** The change scheduled for the next renewal. Not a period the client has been on — it is the target, recorded when the change was scheduled. */
  pendingChange?: Maybe<SubscriptionPlanPeriod>;
  /** Oldest first. */
  periods: Array<SubscriptionPlanPeriod>;
};

export type SubscriptionPriceBreakdown = {
  __typename?: 'SubscriptionPriceBreakdown';
  bundlePrice?: Maybe<Scalars['Decimal']['output']>;
  calculatedAt: Scalars['DateTime']['output'];
  /** True when an admin override was used instead of catalog pricing */
  isOverridden: Scalars['Boolean']['output'];
  modulePrices: Array<SubscriptionPriceBreakdownModuleEntry>;
};

export type SubscriptionPriceBreakdownModuleEntry = {
  __typename?: 'SubscriptionPriceBreakdownModuleEntry';
  moduleId: Scalars['ID']['output'];
  moduleName: Scalars['String']['output'];
  price: Scalars['Decimal']['output'];
};

export type SubscriptionPricingBreakdown = {
  __typename?: 'SubscriptionPricingBreakdown';
  /** List of applied discounts */
  appliedDiscounts?: Maybe<Array<Scalars['String']['output']>>;
  /** List of applied pricing rules */
  appliedPricingRules: Array<Scalars['String']['output']>;
  /** Base price for the subscription */
  basePrice: Scalars['Float']['output'];
  /** Currency of the pricing */
  currency: Scalars['String']['output'];
  /** Total subscription price */
  totalPrice: Scalars['Float']['output'];
  /** Total price for variable items (extras) */
  variableItemsPrice: Scalars['Float']['output'];
};

export type SubscriptionRunRate = {
  __typename?: 'SubscriptionRunRate';
  /** Base (plan) MRR in the reporting currency. Null when conversion fails. */
  baseMrr?: Maybe<Scalars['Float']['output']>;
  /** Projected usage-component MRR in the reporting currency, as of `valuedAt`. Null when the subscription has no variable components, or when conversion fails. */
  componentMrr?: Maybe<Scalars['Float']['output']>;
  /** The tenant's reporting currency. */
  currency: Scalars['String']['output'];
  /** Base MRR after the discounts in force at `valuedAt`. Equals baseMrr when none applied. */
  netMrr?: Maybe<Scalars['Float']['output']>;
  /** The instant these figures were computed at: the end date for a term that has closed, the start date for one not yet begun, otherwise now. A usage projection valued at the wrong instant reports zero rather than what the subscription actually metered. */
  valuedAt: Scalars['DateTime']['output'];
};

/** Available fields for sorting subscriptions */
export enum SubscriptionSortField {
  BasePrice = 'BASE_PRICE',
  CreatedAt = 'CREATED_AT',
  EndDate = 'END_DATE',
  NextRenewalDate = 'NEXT_RENEWAL_DATE',
  OrganizationId = 'ORGANIZATION_ID',
  StartDate = 'START_DATE',
  UpdatedAt = 'UPDATED_AT',
}

/** Current status of the subscription */
export enum SubscriptionStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Expired = 'EXPIRED',
  GracePeriod = 'GRACE_PERIOD',
  Pending = 'PENDING',
  Suspended = 'SUSPENDED',
  Trial = 'TRIAL',
}

/** Filter for subscription status */
export enum SubscriptionStatusFilter {
  Active = 'ACTIVE',
  All = 'ALL',
  Inactive = 'INACTIVE',
}

export type SubscriptionSuggestionEntity = {
  __typename?: 'SubscriptionSuggestionEntity';
  basePrice: Scalars['Float']['output'];
  bundleId?: Maybe<Scalars['String']['output']>;
  /** 0.0 – 1.0 confidence that this is the right match. */
  confidence: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  endDate: Scalars['DateTime']['output'];
  moduleIds: Array<Scalars['String']['output']>;
  period: Scalars['String']['output'];
  reason: SubscriptionSuggestionReason;
  startDate: Scalars['DateTime']['output'];
  status: Scalars['String']['output'];
  subscriptionId: Scalars['String']['output'];
};

/** Reason a subscription was suggested as a candidate link for a sync result */
export enum SubscriptionSuggestionReason {
  Backfill = 'BACKFILL',
  Contiguous = 'CONTIGUOUS',
  Historical = 'HISTORICAL',
  NearRenewal = 'NEAR_RENEWAL',
  Overlap = 'OVERLAP',
}

/** What ending a free trial did. */
export type SubscriptionTrialConversionResult = {
  __typename?: 'SubscriptionTrialConversionResult';
  /** True when the trial had already converted (or was not a trial); nothing was done and no second invoice was raised. */
  alreadyConverted: Scalars['Boolean']['output'];
  /** The first invoice, when one was raised. */
  invoiceId?: Maybe<Scalars['ID']['output']>;
  subscription: OrganizationSubscription;
  warnings?: Maybe<Array<Scalars['String']['output']>>;
};

/** Type of subscription based on customer lifecycle */
export enum SubscriptionType {
  Acquisition = 'ACQUISITION',
  Expansion = 'EXPANSION',
  Renewal = 'RENEWAL',
}

export type SubscriptionTypeBreakdown = {
  __typename?: 'SubscriptionTypeBreakdown';
  arr: Scalars['Float']['output'];
  mrr: Scalars['Float']['output'];
  subscriptionCount: Scalars['Int']['output'];
  subscriptionType: Scalars['String']['output'];
};

export type SubscriptionVariableComponentRef = {
  __typename?: 'SubscriptionVariableComponentRef';
  /** Client-specific billing-timing override for this component (arrears vs advance). Null = inherits the product default and keeps tracking it. Changes apply from the next billing cycle only. */
  billingTimingOverride?: Maybe<BillingTiming>;
  /** Per-component override of the client usageCaptureMode. Null inherits the client value, which itself defaults to API. Lets a client integrate one meter and hand-report another. */
  captureModeOverride?: Maybe<UsageCaptureMode>;
  /** The pinned Variable Component document this ref points at. */
  component?: Maybe<VariableComponent>;
  /** Variable Component document _id */
  componentId: Scalars['ID']['output'];
  /** The component lineage this pin belongs to — stable across republishing, and what excludeVariableComponentFromSubscription / reincludeVariableComponentOnSubscription key on. */
  componentLineageId?: Maybe<Scalars['ID']['output']>;
  /** Pinned component version */
  componentVersion: Scalars['Int']['output'];
  /** Direct-attachment free allowance (count models). */
  includedQuantity?: Maybe<Scalars['Int']['output']>;
  /** Direct-attachment free allowance (COMMISSION transactions). */
  includedTransactionCount?: Maybe<Scalars['Int']['output']>;
  /** True when auto-included from the parent Module or Bundle; false for explicit direct refs. */
  inheritedFromParent: Scalars['Boolean']['output'];
  /** Zero usage is normal for this component on this subscription: a period that closes at zero raises no warning. Billing is unchanged. */
  zeroUsageExpected?: Maybe<Scalars['Boolean']['output']>;
};

export type SubscriptionVariableUsage = {
  __typename?: 'SubscriptionVariableUsage';
  aiChurnRiskScore?: Maybe<Scalars['Float']['output']>;
  aiHealthScore?: Maybe<Scalars['Float']['output']>;
  aiScoresUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  aiUpsellScore?: Maybe<Scalars['Float']['output']>;
  /** Which number in the period is rated: MAX, TOTAL or CLOSING. Null until migration 0028 has run — resolve via measurement-axis.util. */
  billedValue?: Maybe<BilledValue>;
  billingTiming: BillingTiming;
  committedQuantity?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  cumulativeCount: Scalars['Float']['output'];
  cumulativeGmv: Scalars['Decimal']['output'];
  cumulativeGmvBilling: Scalars['Decimal']['output'];
  currentCount: Scalars['Float']['output'];
  firstUseInWindowAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  limitPeriodEnd?: Maybe<Scalars['DateTime']['output']>;
  limitPeriodResetCount: Scalars['Int']['output'];
  limitPeriodStart?: Maybe<Scalars['DateTime']['output']>;
  measurementMode: MeasurementMode;
  netGmv: Scalars['Decimal']['output'];
  /** Quantity change queued for next renewal (NEXT_CYCLE proration) */
  nextCyclePendingCount?: Maybe<Scalars['Int']['output']>;
  peakCount: Scalars['Float']['output'];
  peakReachedAt: Scalars['DateTime']['output'];
  periodEnd: Scalars['DateTime']['output'];
  periodStart: Scalars['DateTime']['output'];
  /** Live "what would this bill right now" figure (PRD §20.2 / Epic D2). Resolves the effective price through the v4 chain and applies the component model math to the current counters. Null when no price resolves in the locked currency. */
  projectedCost?: Maybe<Scalars['Float']['output']>;
  /** Full live projection (billed quantity, inclusion applied, unit rate, total). Null when no price resolves in the locked currency. */
  projection?: Maybe<UsageProjection>;
  prorationCalculation: ProrationCalculation;
  refundedAmount: Scalars['Decimal']['output'];
  /** Resets each period (PER_PERIOD) or carries forward (STANDING). Null until migration 0028 has run — resolve via measurement-axis.util. */
  resetBehaviour?: Maybe<ResetBehaviour>;
  rolloverUnits: Scalars['Int']['output'];
  subscriptionId: Scalars['ID']['output'];
  tenantId: Scalars['ID']['output'];
  transactionCount: Scalars['Int']['output'];
  transactionCountBilling: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  variableComponentId: Scalars['ID']['output'];
  variableId: Scalars['ID']['output'];
};

export enum SubscriptionVersionChangeType {
  AddComponent = 'ADD_COMPONENT',
  AddSubscriptionPrice = 'ADD_SUBSCRIPTION_PRICE',
  CancelPendingMigration = 'CANCEL_PENDING_MIGRATION',
  ChangeComponentQuantity = 'CHANGE_COMPONENT_QUANTITY',
  ChangePlan = 'CHANGE_PLAN',
  ExcludeComponent = 'EXCLUDE_COMPONENT',
  Grandfather = 'GRANDFATHER',
  IncludeComponent = 'INCLUDE_COMPONENT',
  InitialPin = 'INITIAL_PIN',
  MigrateBundle = 'MIGRATE_BUNDLE',
  MigrateComponent = 'MIGRATE_COMPONENT',
  MigrateModule = 'MIGRATE_MODULE',
  RemoveComponent = 'REMOVE_COMPONENT',
  RemoveSubscriptionPrice = 'REMOVE_SUBSCRIPTION_PRICE',
  Status = 'STATUS',
}

export type SubscriptionVersionEntry = {
  __typename?: 'SubscriptionVersionEntry';
  actorUserId?: Maybe<Scalars['String']['output']>;
  changeType: SubscriptionVersionChangeType;
  fromState?: Maybe<SubscriptionVersionEntryState>;
  /** Why this pin was deliberately placed on a version that is not the current offer — the stated legacyVersionPin reason, or the reason on a backdated change. Null on an ordinary change. Read it to tell a grandfathered client from one whose pin has simply been neglected: only the second is work to do. */
  legacyPinReason?: Maybe<Scalars['String']['output']>;
  migrationTiming?: Maybe<MigrationTiming>;
  prorationFactor?: Maybe<Scalars['Float']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  relatedInvoiceId?: Maybe<Scalars['ID']['output']>;
  /** True when this entry records a change that was SCHEDULED for a later renewal rather than applied: its state is the target, not one the subscription was ever in. The renewal appends its own entry when the change actually lands. Both carry NEXT_RENEWAL, so this is the only field that separates them. */
  scheduled: Scalars['Boolean']['output'];
  timestamp: Scalars['DateTime']['output'];
  toState: SubscriptionVersionEntryState;
};

/** A subscription's plan as pinned at one point in time. Read from version history, so it describes what the client was on then rather than what they are on now. */
export type SubscriptionVersionEntryState = {
  __typename?: 'SubscriptionVersionEntryState';
  /** The base price in force for this state, in the subscription's currency. Recorded rather than re-derived: the pins cannot reproduce a per-client negotiated price, so pricing them against the catalog would restate this client at list price. Null on entries written before this field existed. */
  basePrice?: Maybe<Scalars['Decimal']['output']>;
  bundleId?: Maybe<Scalars['ID']['output']>;
  /** The bundle lineage this version belongs to — stable across versions, so a state read out of history names the commercial plan rather than one document of it. */
  bundleLineageId?: Maybe<Scalars['ID']['output']>;
  bundleVersion?: Maybe<Scalars['Int']['output']>;
  /** Legacy mirror of the FIRST module pin. Read modulePins for the whole set. */
  moduleId?: Maybe<Scalars['ID']['output']>;
  /** Every module pinned at this point. `moduleId` above is only the first of these, so a multi-module plan is only fully described here. */
  modulePins?: Maybe<Array<SubscriptionModulePin>>;
  moduleVersion?: Maybe<Scalars['Int']['output']>;
  variableComponentRefs?: Maybe<Array<SubscriptionVariableComponentRef>>;
};

export type SubscriptionWithStalePins = {
  __typename?: 'SubscriptionWithStalePins';
  /** True when this pin is behind the published head ON PURPOSE — the client was grandfathered onto a legacy plan, or their history was reconstructed. Such rows are EXCLUDED from this query by default: they are contracts to honour, not work to clear. Present here for the rows returned when includeGrandfathered is set. */
  grandfathered: Scalars['Boolean']['output'];
  /** Why the pin was placed deliberately — the stated legacyVersionPin reason, or the reason on the backdated change. Null when the pin is not deliberate. */
  legacyPinReason?: Maybe<Scalars['String']['output']>;
  stalePins: Array<StalePin>;
  subscription: OrganizationSubscription;
};

/** A person who shares a client's or prospect's email domain and is not yet one of its contacts. Not a stored document — it is derived on read from the tenant's own contacts and email traffic, so it has no id of its own. */
export type SuggestedContact = {
  __typename?: 'SuggestedContact';
  /** Set when the suggestion is an existing unassigned contact. Adding it attaches that record rather than creating a second one. */
  contactId?: Maybe<Scalars['ID']['output']>;
  /** The matched address. Always present — it is what matched the domain. */
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  /** Stable key for list rendering and selection. An existing contact keys on its id; an address seen only in email keys on the address. */
  key: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  /** Most recent email the address appeared in. EMAIL_PARTICIPANT only. */
  lastSeenAt?: Maybe<Scalars['DateTime']['output']>;
  /** Emails the address appeared in. Only set for an EMAIL_PARTICIPANT suggestion. */
  messageCount?: Maybe<Scalars['Int']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  source: ContactSuggestionSource;
};

/** One suggested person the operator chose to add. With a contactId an existing unassigned contact is attached; without one a new contact is created. */
export type SuggestedContactSelectionInput = {
  /** An existing unassigned contact to attach instead of creating a new one. Taken from the suggestion’s contactId. */
  contactId?: InputMaybe<Scalars['ID']['input']>;
  /** The matched address. Re-validated against the record’s domain. */
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export enum SupportAiState {
  Answering = 'ANSWERING',
  HandedOver = 'HANDED_OVER',
  Off = 'OFF',
}

export type SupportAttachment = {
  __typename?: 'SupportAttachment';
  filename?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  mimeType?: Maybe<Scalars['String']['output']>;
  /** Inline preview link, images only; valid for 30 minutes. */
  previewUrl?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  /** Download link, valid for 30 minutes. */
  url?: Maybe<Scalars['String']['output']>;
};

/** PUT the file to uploadUrl with its Content-Type, then call confirmSupportAttachmentUpload. */
export type SupportAttachmentUpload = {
  __typename?: 'SupportAttachmentUpload';
  expiresAt: Scalars['DateTime']['output'];
  fileId: Scalars['ID']['output'];
  maxBytes: Scalars['Int']['output'];
  uploadUrl: Scalars['String']['output'];
};

/** An attribute key found on your people, from the profile your backend sends or from an import, with the values it takes. Used to write role rules against values that exist. */
export type SupportAttributeSummary = {
  __typename?: 'SupportAttributeSummary';
  key: Scalars['String']['output'];
  total: Scalars['Int']['output'];
  /** Most common first. */
  values: Array<SupportAttributeValue>;
};

export type SupportAttributeValue = {
  __typename?: 'SupportAttributeValue';
  /** People who carry this value. */
  count: Scalars['Int']['output'];
  value: Scalars['String']['output'];
};

export enum SupportAuthorType {
  Agent = 'AGENT',
  Ai = 'AI',
  EndUser = 'END_USER',
  System = 'SYSTEM',
}

export type SupportCitation = {
  __typename?: 'SupportCitation';
  anchor?: Maybe<Scalars['String']['output']>;
  quote?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export enum SupportClientBillingStanding {
  Good = 'GOOD',
  NoActiveSubscription = 'NO_ACTIVE_SUBSCRIPTION',
  Overdue = 'OVERDUE',
}

/** What an agent needs to know about a client while answering them (L25). Billing fields are read-only and come from the client's subscriptions and invoices. */
export type SupportClientContext = {
  __typename?: 'SupportClientContext';
  /** OVERDUE when any invoice is overdue; NO_ACTIVE_SUBSCRIPTION when nothing is earning revenue; otherwise GOOD. This is billing standing only, not a health score (Phase 5). */
  billingStanding: SupportClientBillingStanding;
  /** Base plan MRR, one entry per subscription currency, summed over the subscriptions earning revenue now. Variable usage is not included. Never converted between currencies. */
  mrr: Array<SupportClientMoney>;
  name: Scalars['String']['output'];
  /** Tickets of this client that are not closed. */
  openTickets: Scalars['Int']['output'];
  organizationId: Scalars['ID']['output'];
  overdueInvoices: Scalars['Int']['output'];
  /** Plan names of the client's current subscriptions, sorted. Empty when none. */
  plans: Array<Scalars['String']['output']>;
  /** The three most recently active tickets of this client, closed ones included. */
  recentTickets: Array<SupportTicket>;
};

export type SupportClientMoney = {
  __typename?: 'SupportClientMoney';
  /** In the currency below, not converted. */
  amount: Scalars['Float']['output'];
  /** ISO 4217 code of the subscriptions this sums. */
  currency: Scalars['String']['output'];
};

export type SupportCompareCitation = {
  __typename?: 'SupportCompareCitation';
  articleId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type SupportCompareCounters = {
  __typename?: 'SupportCompareCounters';
  answered: Scalars['Int']['output'];
  errors: Scalars['Int']['output'];
  graded: Scalars['Int']['output'];
  handover: Scalars['Int']['output'];
  incorrect: Scalars['Int']['output'];
  noQuestion: Scalars['Int']['output'];
  noReference: Scalars['Int']['output'];
  noRole: Scalars['Int']['output'];
  partial: Scalars['Int']['output'];
  processed: Scalars['Int']['output'];
  sampled: Scalars['Int']['output'];
  ungraded: Scalars['Int']['output'];
  wouldResolve: Scalars['Int']['output'];
};

/** What the comparison saw while answering one conversation: the search text, the articles that came back, and where each article Fin cited stands. */
export type SupportCompareDiagnostics = {
  __typename?: 'SupportCompareDiagnostics';
  finSources: Array<SupportCompareFinSourceMatch>;
  /** The guidelines the draft read. Empty on conversations compared before guidelines. */
  guidelines: Array<SupportCompareGuideline>;
  questionWords: Scalars['Int']['output'];
  retrieved: Array<SupportCompareRetrievedArticle>;
  /** The search rewritten from the whole conversation, searched beside the customer's words. Null when the run did not rewrite or no search was written. */
  rewrittenQuery?: Maybe<Scalars['String']['output']>;
  /** The customer's own words as searched. */
  searchQuery: Scalars['String']['output'];
};

export type SupportCompareEstimate = {
  __typename?: 'SupportCompareEstimate';
  aiAvailable: Scalars['Boolean']['output'];
  aiUnavailableReason?: Maybe<Scalars['String']['output']>;
  answerModel: Scalars['String']['output'];
  dailyCapUsd?: Maybe<Scalars['Float']['output']>;
  eligibleConversations: Scalars['Int']['output'];
  estimatedCostUsd: Scalars['Float']['output'];
  graderModel: Scalars['String']['output'];
  perConversationUsd: Scalars['Float']['output'];
  sampleSize: Scalars['Int']['output'];
  spentTodayUsd: Scalars['Float']['output'];
};

export type SupportCompareFin = {
  __typename?: 'SupportCompareFin';
  /** Fin's last reply in the thread. */
  answer?: Maybe<Scalars['String']['output']>;
  conversationRating?: Maybe<Scalars['Int']['output']>;
  participated?: Maybe<Scalars['Boolean']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  ratingRemark?: Maybe<Scalars['String']['output']>;
  resolutionState: FinResolutionState;
  sources: Array<SupportCompareSource>;
};

export type SupportCompareFinSourceMatch = {
  __typename?: 'SupportCompareFinSourceMatch';
  articleId?: Maybe<Scalars['ID']['output']>;
  articleTitle?: Maybe<Scalars['String']['output']>;
  /** Whether Revvly's search returned it. */
  retrieved: Scalars['Boolean']['output'];
  status: SupportCompareFinSourceStatus;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** Where an article Fin cited stands in this workspace's knowledge base, for the customer asking. MISSING: no article matches it. NOT_INDEXED: in the knowledge base, not searchable. HIDDEN: searchable, not by this customer's roles or plan. READABLE: this customer could read it. */
export enum SupportCompareFinSourceStatus {
  Hidden = 'HIDDEN',
  Missing = 'MISSING',
  NotIndexed = 'NOT_INDEXED',
  Readable = 'READABLE',
}

/** A view of a run's conversations that sets Revvly beside Fin. FIN_RESOLVED_REVVLY_NOT: Intercom recorded Fin as resolving it (assumed or confirmed) and Revvly's draft did not. FIN_ARTICLE_REVVLY_MISSED: Fin cited at least one article and Revvly's search returned none of them. */
export enum SupportCompareFocus {
  FinArticleRevvlyMissed = 'FIN_ARTICLE_REVVLY_MISSED',
  FinResolvedRevvlyNot = 'FIN_RESOLVED_REVVLY_NOT',
}

/** The most likely reason a conversation was not resolved, read off the articles Fin cited and what Revvly's search returned. FOUND_NOT_USED: the search returned Fin's article and Revvly still did not resolve. NOT_FOUND: the customer could read Fin's article and the search did not bring it up. HIDDEN_BY_ROLE: Fin's article is searchable, but not by this customer's roles or plan. NOT_INDEXED: it is in the knowledge base and left out of search. MISSING_ARTICLE: no article matches it. NO_FIN_SOURCE: Fin cited nothing. NOT_COMPARED: outside the rates for another reason. */
export enum SupportCompareGap {
  FoundNotUsed = 'FOUND_NOT_USED',
  HiddenByRole = 'HIDDEN_BY_ROLE',
  MissingArticle = 'MISSING_ARTICLE',
  NotCompared = 'NOT_COMPARED',
  NotFound = 'NOT_FOUND',
  NotIndexed = 'NOT_INDEXED',
  NoFinSource = 'NO_FIN_SOURCE',
  Resolved = 'RESOLVED',
}

/** Conversations Revvly did not resolve, by their most likely reason. */
export type SupportCompareGapCounts = {
  __typename?: 'SupportCompareGapCounts';
  foundNotUsed: Scalars['Int']['output'];
  hiddenByRole: Scalars['Int']['output'];
  missingArticle: Scalars['Int']['output'];
  noFinSource: Scalars['Int']['output'];
  notFound: Scalars['Int']['output'];
  notIndexed: Scalars['Int']['output'];
};

/** A guideline the draft read, as it stood when the conversation was compared. */
export type SupportCompareGuideline = {
  __typename?: 'SupportCompareGuideline';
  body: Scalars['String']['output'];
  /** Whether Revvly's draft cited it. */
  cited: Scalars['Boolean']['output'];
  guidelineId: Scalars['ID']['output'];
  kind: SupportGuidelineKind;
  title: Scalars['String']['output'];
};

/** Graded conversations Fin took part in, with a known outcome. */
export type SupportCompareHeadToHead = {
  __typename?: 'SupportCompareHeadToHead';
  both: Scalars['Int']['output'];
  neither: Scalars['Int']['output'];
  onlyFin: Scalars['Int']['output'];
  onlyRevvly: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type SupportCompareMetrics = {
  __typename?: 'SupportCompareMetrics';
  aiCostUsd: Scalars['Float']['output'];
  costPerProjectedResolutionUsd?: Maybe<Scalars['Float']['output']>;
  errors: Scalars['Int']['output'];
  /** Fin's actual resolution rate: (assumed + confirmed) / graded conversations Fin took part in. */
  fin: SupportCompareRate;
  /** Fin's confirmed-only resolution rate. */
  finConfirmed: SupportCompareRate;
  finNotParticipated: Scalars['Int']['output'];
  finParticipated: Scalars['Int']['output'];
  /** Fewer than 50 graded conversations Fin took part in. */
  finSmallSample: Scalars['Boolean']['output'];
  /** Graded conversations Intercom gave no Fin outcome for. */
  finUnknown: Scalars['Int']['output'];
  graded: Scalars['Int']['output'];
  handoverRate?: Maybe<Scalars['Float']['output']>;
  headToHead: SupportCompareHeadToHead;
  incorrectRate?: Maybe<Scalars['Float']['output']>;
  minGradedForComparison: Scalars['Int']['output'];
  noQuestion: Scalars['Int']['output'];
  noReference: Scalars['Int']['output'];
  noRole: Scalars['Int']['output'];
  partialRate?: Maybe<Scalars['Float']['output']>;
  processed: Scalars['Int']['output'];
  /** Revvly's projected resolution rate: would_resolve / graded. */
  revvly: SupportCompareRate;
  /** How often Revvly answered rather than handed over, whatever the grade, over the same conversations: the figure beside Fin's (assumed + confirmed) rate, since an assumed resolution only means Fin answered and the customer did not come back. */
  revvlyAnsweredWhereFinTookPart: SupportCompareRate;
  /** Revvly's would-resolve rate over the conversations Fin's rate is taken over (graded, Fin took part, known outcome): the like-for-like figure beside Fin's. */
  revvlyWhereFinTookPart: SupportCompareRate;
  sampled: Scalars['Int']['output'];
  /** Fewer than 50 graded conversations: too few to compare. */
  smallSample: Scalars['Boolean']['output'];
  ungraded: Scalars['Int']['output'];
  verdicts: SupportCompareVerdictCounts;
};

export type SupportCompareOverview = {
  __typename?: 'SupportCompareOverview';
  /** Whether a run can start (an AI model and the provider key). */
  aiAvailable: Scalars['Boolean']['output'];
  aiUnavailableReason?: Maybe<Scalars['String']['output']>;
  /** Tickets imported from Intercom, all time. */
  importedConversations: Scalars['Int']['output'];
  /** Knowledge articles indexed and searchable. */
  knowledgeArticles: Scalars['Int']['output'];
  latestRun?: Maybe<SupportCompareRun>;
};

/** An article Fin cited in conversations Revvly did not resolve. */
export type SupportComparePatternArticle = {
  __typename?: 'SupportComparePatternArticle';
  /** The matching knowledge article, if any. */
  articleId?: Maybe<Scalars['ID']['output']>;
  conversations: Scalars['Int']['output'];
  /** Of those, how many times Revvly's search returned it. */
  retrieved: Scalars['Int']['output'];
  status: SupportCompareFinSourceStatus;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** Revvly's resolution rate within one slice of the conversations. */
export type SupportComparePatternSegment = {
  __typename?: 'SupportComparePatternSegment';
  dimension: Scalars['String']['output'];
  label: Scalars['String']['output'];
  n: Scalars['Int']['output'];
  rate?: Maybe<Scalars['Float']['output']>;
  resolved: Scalars['Int']['output'];
};

/** What tells the conversations Revvly resolved apart from the rest. Read over graded conversations and those lost to a role gap, from runs that recorded diagnostics. */
export type SupportComparePatterns = {
  __typename?: 'SupportComparePatterns';
  diagnosed: Scalars['Int']['output'];
  finArticles: Array<SupportComparePatternArticle>;
  gaps: SupportCompareGapCounts;
  medianTopScoreNotResolved?: Maybe<Scalars['Float']['output']>;
  medianTopScoreResolved?: Maybe<Scalars['Float']['output']>;
  notResolved: Scalars['Int']['output'];
  reasons: SupportCompareReasonCounts;
  resolved: Scalars['Int']['output'];
  segments: Array<SupportComparePatternSegment>;
  /** Conversations from before diagnostics were recorded. */
  undiagnosed: Scalars['Int']['output'];
};

export type SupportCompareRangeInput = {
  /** The model that drafts Revvly's answers in this run: claude-haiku-5-5, claude-sonnet-5-5 or claude-opus-5-5. Default: the workspace's Support AI model. Only this run uses it; live answers do not change. */
  answerModel?: InputMaybe<Scalars['String']['input']>;
  /** Conversations started on or after this moment. */
  from: Scalars['DateTime']['input'];
  /** Rewrite each conversation into one search before the knowledge search, as live answers do. Default true; false measures the search without it. */
  rewriteQueries?: InputMaybe<Scalars['Boolean']['input']>;
  /** Conversations to sample. Default 200, at most 500. */
  sampleSize?: InputMaybe<Scalars['Int']['input']>;
  /** Conversations started on or before this moment. */
  to: Scalars['DateTime']['input'];
};

/** A proportion with its 95% Wilson interval. rate, low and high are null when n is 0. */
export type SupportCompareRate = {
  __typename?: 'SupportCompareRate';
  high?: Maybe<Scalars['Float']['output']>;
  low?: Maybe<Scalars['Float']['output']>;
  n: Scalars['Int']['output'];
  rate?: Maybe<Scalars['Float']['output']>;
  successes: Scalars['Int']['output'];
};

/** Who the customer was taken to be when Revvly answered, and what that was decided on. Copied when the answer was drafted. */
export type SupportCompareReader = {
  __typename?: 'SupportCompareReader';
  attributes: Array<SupportCompareReaderAttribute>;
  intercomRole?: Maybe<Scalars['String']['output']>;
  roles: Array<SupportCompareReaderRole>;
  /** PROFILE: the roles came from the profile your backend sent. INTERCOM: from what Intercom held about the person. NONE: no role matched. */
  source: Scalars['String']['output'];
};

export type SupportCompareReaderAttribute = {
  __typename?: 'SupportCompareReaderAttribute';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type SupportCompareReaderRole = {
  __typename?: 'SupportCompareReaderRole';
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** Why Revvly gave no answer. NOTHING_RETRIEVED: the search found nothing this customer may read. NO_ANSWER: it found passages and the model said they did not answer. UNCITED: the draft cited nothing, so it would not have been shown. NO_ROLE: nothing found, and the customer matched none of the roles. ERROR: the search or the model failed. */
export enum SupportCompareReasonCode {
  Error = 'ERROR',
  NothingRetrieved = 'NOTHING_RETRIEVED',
  NoAnswer = 'NO_ANSWER',
  NoRole = 'NO_ROLE',
  Uncited = 'UNCITED',
}

/** Conversations Revvly did not resolve, by why it gave no answer. */
export type SupportCompareReasonCounts = {
  __typename?: 'SupportCompareReasonCounts';
  error: Scalars['Int']['output'];
  noAnswer: Scalars['Int']['output'];
  noRole: Scalars['Int']['output'];
  nothingRetrieved: Scalars['Int']['output'];
  uncited: Scalars['Int']['output'];
};

export enum SupportCompareReferenceKind {
  Fin = 'FIN',
  Human = 'HUMAN',
  None = 'NONE',
}

export type SupportCompareResult = {
  __typename?: 'SupportCompareResult';
  /** When the comparison analyzed this conversation. */
  analyzedAt: Scalars['DateTime']['output'];
  conversationAt: Scalars['DateTime']['output'];
  costUsd: Scalars['Float']['output'];
  /** Null when nothing was drafted, and on conversations from before diagnostics were recorded. */
  diagnostics?: Maybe<SupportCompareDiagnostics>;
  earlierTurns: Scalars['Int']['output'];
  fin: SupportCompareFin;
  /** Null on conversations from before diagnostics were recorded. */
  gap?: Maybe<SupportCompareGap>;
  graderReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  question: Scalars['String']['output'];
  reader?: Maybe<SupportCompareReader>;
  referenceKind: SupportCompareReferenceKind;
  referenceText?: Maybe<Scalars['String']['output']>;
  revvlyCitations: Array<SupportCompareCitation>;
  revvlyDraft?: Maybe<Scalars['String']['output']>;
  revvlyOutcome?: Maybe<SupportCompareRevvlyOutcome>;
  revvlyReason?: Maybe<Scalars['String']['output']>;
  revvlyReasonCode?: Maybe<SupportCompareReasonCode>;
  sampleIndex: Scalars['Int']['output'];
  ticketId: Scalars['ID']['output'];
  ticketNumber: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  verdict: SupportCompareVerdict;
};

export type SupportCompareResultPage = {
  __typename?: 'SupportCompareResultPage';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  nodes: Array<SupportCompareResult>;
  totalCount: Scalars['Int']['output'];
};

export type SupportCompareRetrievedArticle = {
  __typename?: 'SupportCompareRetrievedArticle';
  articleId: Scalars['ID']['output'];
  /** Whether Revvly's draft cited it. */
  cited: Scalars['Boolean']['output'];
  /** The search's score for its best passage. */
  score: Scalars['Float']['output'];
  title: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export enum SupportCompareRevvlyOutcome {
  Answered = 'ANSWERED',
  Error = 'ERROR',
  Handover = 'HANDOVER',
}

export type SupportCompareRun = {
  __typename?: 'SupportCompareRun';
  aiCostUsd: Scalars['Float']['output'];
  answerModel: Scalars['String']['output'];
  /** Imported conversations in the range when the sample was drawn. */
  candidates: Scalars['Int']['output'];
  counters: SupportCompareCounters;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  from: Scalars['DateTime']['output'];
  graderModel: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Articles in that knowledge base. */
  knowledgeArticleCount?: Maybe<Scalars['Int']['output']>;
  /** True when the knowledge base changed during the run (a resume), so its results mix two versions. */
  knowledgeChanged: Scalars['Boolean']['output'];
  /** The latest edit among those articles. */
  knowledgeUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Fingerprint of the knowledge base the run answered from. Equal on two runs means the same articles; null on runs from before it was kept. */
  knowledgeVersion?: Maybe<Scalars['String']['output']>;
  lastError?: Maybe<Scalars['String']['output']>;
  metrics: SupportCompareMetrics;
  patterns: SupportComparePatterns;
  /** Whether each conversation was rewritten into one search before the knowledge search. */
  rewriteQueries: Scalars['Boolean']['output'];
  sampleSize: Scalars['Int']['output'];
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: SupportCompareStatus;
  to: Scalars['DateTime']['output'];
};

export type SupportCompareSource = {
  __typename?: 'SupportCompareSource';
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** Where a "Compare with Intercom" backtest run is. STOPPED_SPEND_CAP: the daily AI spend cap was reached; the results so far stand and the run can be resumed. */
export enum SupportCompareStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Queued = 'QUEUED',
  Running = 'RUNNING',
  StoppedSpendCap = 'STOPPED_SPEND_CAP',
}

/** The grader's verdict on Revvly's draft. UNGRADED (unreadable grade), ERROR (the draft failed), NO_REFERENCE (nothing to compare with), NO_ROLE (the customer's Intercom profile matched none of the workspace's roles, so only articles open to everyone were readable and none matched) and NO_QUESTION (the customer never asked anything: they tapped a quick reply and left) are counted and left out of the rates. */
export enum SupportCompareVerdict {
  Error = 'ERROR',
  Handover = 'HANDOVER',
  Incorrect = 'INCORRECT',
  NoQuestion = 'NO_QUESTION',
  NoReference = 'NO_REFERENCE',
  NoRole = 'NO_ROLE',
  Partial = 'PARTIAL',
  Ungraded = 'UNGRADED',
  WouldResolve = 'WOULD_RESOLVE',
}

export type SupportCompareVerdictCounts = {
  __typename?: 'SupportCompareVerdictCounts';
  error: Scalars['Int']['output'];
  handover: Scalars['Int']['output'];
  incorrect: Scalars['Int']['output'];
  noQuestion: Scalars['Int']['output'];
  noReference: Scalars['Int']['output'];
  noRole: Scalars['Int']['output'];
  partial: Scalars['Int']['output'];
  ungraded: Scalars['Int']['output'];
  wouldResolve: Scalars['Int']['output'];
};

export type SupportContactRef = {
  __typename?: 'SupportContactRef';
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type SupportDateRangeInput = {
  /** Inclusive. */
  from: Scalars['DateTime']['input'];
  /** Exclusive. At most a year after from. */
  to: Scalars['DateTime']['input'];
};

/** One of the tenant's users, as its backend described them (People). Written only by the tenant: at token mint and by upsertSupportUsers. */
export type SupportEndUser = {
  __typename?: 'SupportEndUser';
  attributes: Array<SupportUserAttribute>;
  /** The client's contact with the same email, when there is one. */
  contact?: Maybe<SupportContactRef>;
  createdAt: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  /** The user's own choice: email them about replies they have not read. Only they can change it. */
  emailWhenOffline: Scalars['Boolean']['output'];
  externalUserId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  imported?: Maybe<SupportEndUserImported>;
  /** Keys of the support roles the imported data would match. Shown when the live profile holds none; the live product ignores it. */
  importedRoleKeys: Array<Scalars['String']['output']>;
  /** Null until the user first uses the chat. */
  lastSeenAt?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<SupportOrganizationRef>;
  plan?: Maybe<Scalars['String']['output']>;
  /** Last write from the tenant's backend. */
  profileUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The role value the tenant's backend sent for this user, as is. */
  role?: Maybe<Scalars['String']['output']>;
  /** Keys of the support roles this user matches now, by the role rules. */
  roleKeys: Array<Scalars['String']['output']>;
  /** Requests this user has opened. */
  ticketCount: Scalars['Int']['output'];
};

export type SupportEndUserConnection = {
  __typename?: 'SupportEndUserConnection';
  nodes: Array<SupportEndUser>;
  pageInfo: PageInfo;
};

export type SupportEndUserFilter = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  /** A support role key. */
  role?: InputMaybe<Scalars['String']['input']>;
  /** Matches name, email or external id. */
  search?: InputMaybe<Scalars['String']['input']>;
};

/** What an import copied from the other tool about this person. Read-only, and never used to decide what they may read in the live product. */
export type SupportEndUserImported = {
  __typename?: 'SupportEndUserImported';
  at: Scalars['DateTime']['output'];
  attributes: Array<SupportUserAttribute>;
  /** Their role in the other tool, e.g. Intercom's user or lead. */
  role?: Maybe<Scalars['String']['output']>;
  source: Scalars['String']['output'];
};

export type SupportGuideline = {
  __typename?: 'SupportGuideline';
  /** The instruction the AI reads. */
  body: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  kind: SupportGuidelineKind;
  /** Read with answers. A paused guideline is kept but not read. */
  live: Scalars['Boolean']['output'];
  /** Why Revvly paused it (its only role was deleted); null when a person decided. */
  pausedReason?: Maybe<Scalars['String']['output']>;
  /** Role keys it applies to; empty means everyone. */
  roles: Array<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SupportGuidelineInput = {
  body: Scalars['String']['input'];
  /** Absent to create one. */
  id?: InputMaybe<Scalars['ID']['input']>;
  kind: SupportGuidelineKind;
  live: Scalars['Boolean']['input'];
  /** Role keys; empty means everyone. */
  roles: Array<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

/** What a guideline tells the AI: how to write, context to use, or what to leave to a person. */
export enum SupportGuidelineKind {
  CommunicationStyle = 'COMMUNICATION_STYLE',
  Context = 'CONTEXT',
  Handover = 'HANDOVER',
}

export type SupportGuidelineLimits = {
  __typename?: 'SupportGuidelineLimits';
  maxGuidelineChars: Scalars['Int']['output'];
  maxGuidelines: Scalars['Int']['output'];
  /** The text of every live guideline together, at most. */
  maxLiveChars: Scalars['Int']['output'];
  maxTitleChars: Scalars['Int']['output'];
};

export type SupportImage = {
  __typename?: 'SupportImage';
  alt?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type SupportImportCounters = {
  __typename?: 'SupportImportCounters';
  /** New people whose email matched contacts of more than one client, so none was linked. */
  contactsAmbiguous: Scalars['Int']['output'];
  /** People who had no end-user profile and were given one. */
  contactsCreated: Scalars['Int']['output'];
  /** People matched to a client contact by email. */
  contactsLinked: Scalars['Int']['output'];
  conversationsSeen: Scalars['Int']['output'];
  /** Conversations not imported because a person in them was erased. */
  conversationsSkippedErased: Scalars['Int']['output'];
  failed: Scalars['Int']['output'];
  messagesCreated: Scalars['Int']['output'];
  ticketsCreated: Scalars['Int']['output'];
  /** Conversations an earlier run already imported. */
  ticketsSkipped: Scalars['Int']['output'];
};

export type SupportImportFailure = {
  __typename?: 'SupportImportFailure';
  at: Scalars['DateTime']['output'];
  /** The conversation id in Intercom. */
  externalId: Scalars['String']['output'];
  reason: Scalars['String']['output'];
};

export enum SupportImportProvider {
  Intercom = 'INTERCOM',
}

export type SupportImportRun = {
  __typename?: 'SupportImportRun';
  counters: SupportImportCounters;
  createdAt: Scalars['DateTime']['output'];
  /** The first 100 conversations that could not be imported; the counter keeps counting. */
  failures: Array<SupportImportFailure>;
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  lastError?: Maybe<Scalars['String']['output']>;
  /** Search pages fully read; a restart resumes after them. */
  pagesDone: Scalars['Int']['output'];
  provider: SupportImportProvider;
  region: IntercomRegion;
  sinceDate: Scalars['DateTime']['output'];
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  startedBy?: Maybe<Scalars['String']['output']>;
  status: SupportImportStatus;
};

export enum SupportImportStatus {
  Cancelled = 'CANCELLED',
  Cancelling = 'CANCELLING',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Running = 'RUNNING',
}

export type SupportInboxCounts = {
  __typename?: 'SupportInboxCounts';
  mine: Scalars['Int']['output'];
  open: Scalars['Int']['output'];
  unassigned: Scalars['Int']['output'];
  untitled: Scalars['Int']['output'];
  waiting: Scalars['Int']['output'];
};

/** What the inbox can be filtered by, read from the tenant's tickets. */
export type SupportInboxFacets = {
  __typename?: 'SupportInboxFacets';
  /** Clients with tickets, by name. */
  clients: Array<SupportOrganizationRef>;
  /** Sources tickets were opened from, alphabetically. */
  sources: Array<Scalars['String']['output']>;
};

export type SupportMessage = {
  __typename?: 'SupportMessage';
  attachments: Array<SupportAttachment>;
  /** The agent, requester or "AI"; null for system rows. */
  author?: Maybe<SupportPerson>;
  authorType: SupportAuthorType;
  /** Markdown. */
  body: Scalars['String']['output'];
  citations: Array<SupportCitation>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  images: Array<SupportImage>;
  kind: SupportMessageKind;
  /** Agents @mentioned. Internal notes only. */
  mentions: Array<SupportPerson>;
  ticketId: Scalars['ID']['output'];
};

/** Oldest first within the page; page backwards with `before`. */
export type SupportMessageConnection = {
  __typename?: 'SupportMessageConnection';
  edges: Array<SupportMessageEdge>;
  pageInfo: PageInfo;
};

export type SupportMessageEdge = {
  __typename?: 'SupportMessageEdge';
  cursor: Scalars['String']['output'];
  node: SupportMessage;
};

export enum SupportMessageKind {
  InternalNote = 'INTERNAL_NOTE',
  Public = 'PUBLIC',
  System = 'SYSTEM',
}

/** NONE: one row for the range. TYPE: per ticket type. AGENT: per current assignee. DAY: per UTC day. */
export enum SupportMetricGroup {
  Agent = 'AGENT',
  Day = 'DAY',
  None = 'NONE',
  Type = 'TYPE',
}

/** Basic support metrics (L26) for one group. */
export type SupportMetricRow = {
  __typename?: 'SupportMetricRow';
  /** Tickets created in the range that have had a first reply. */
  firstResponses: Scalars['Int']['output'];
  /** Type id, agent auth id, YYYY-MM-DD (UTC), "unassigned", or "all". */
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  medianFirstResponseSeconds?: Maybe<Scalars['Int']['output']>;
  medianResolutionSeconds?: Maybe<Scalars['Int']['output']>;
  /** Closes in the range; a ticket closed twice counts twice. */
  ticketsClosed: Scalars['Int']['output'];
  /** Tickets created in the range. */
  ticketsCreated: Scalars['Int']['output'];
};

export type SupportNotification = {
  __typename?: 'SupportNotification';
  actorId?: Maybe<Scalars['ID']['output']>;
  /** end_user, agent, ai, system or integration. */
  actorType: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  kind: SupportNotificationKind;
  readAt?: Maybe<Scalars['DateTime']['output']>;
  ticketId: Scalars['ID']['output'];
  ticketNumber: Scalars['String']['output'];
  /** The ticket title when the notification was made. */
  title?: Maybe<Scalars['String']['output']>;
};

/** Newest first. */
export type SupportNotificationConnection = {
  __typename?: 'SupportNotificationConnection';
  nodes: Array<SupportNotification>;
  pageInfo: PageInfo;
};

/** What an agent can be notified about. */
export enum SupportNotificationKind {
  AssignedToYou = 'ASSIGNED_TO_YOU',
  Mentioned = 'MENTIONED',
  ReplyOnYourTicket = 'REPLY_ON_YOUR_TICKET',
  StatusChangedOnYourTicket = 'STATUS_CHANGED_ON_YOUR_TICKET',
  TicketCreated = 'TICKET_CREATED',
}

export type SupportNotificationPreference = {
  __typename?: 'SupportNotificationPreference';
  email: Scalars['Boolean']['output'];
  inApp: Scalars['Boolean']['output'];
  kind: SupportNotificationKind;
};

export type SupportNotificationPreferenceInput = {
  email: Scalars['Boolean']['input'];
  inApp: Scalars['Boolean']['input'];
  kind: SupportNotificationKind;
};

export type SupportOrganizationRef = {
  __typename?: 'SupportOrganizationRef';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** An agent as shown on a ticket. */
export type SupportPerson = {
  __typename?: 'SupportPerson';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export enum SupportReplyKind {
  InternalNote = 'INTERNAL_NOTE',
  Public = 'PUBLIC',
}

export type SupportRequester = {
  __typename?: 'SupportRequester';
  attributes: Array<SupportUserAttribute>;
  email?: Maybe<Scalars['String']['output']>;
  /** The tenant's own id for the user. */
  externalUserId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Last time the user used the chat. */
  lastSeenAt?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  plan?: Maybe<Scalars['String']['output']>;
  /** The role value the tenant's backend sent, as is. */
  role?: Maybe<Scalars['String']['output']>;
};

export type SupportRole = {
  __typename?: 'SupportRole';
  /** Whether the AI answers people who hold this role. Off: they get a person. A person with several roles gets no AI answer when any one is off. */
  aiEnabled: Scalars['Boolean']['output'];
  /** Knowledge articles whose audience names this role. */
  articleCount: Scalars['Int']['output'];
  contentHints: SupportRoleContentHints;
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isPublic: Scalars['Boolean']['output'];
  /** Internal identifier, generated from the name and never changed. Articles reference roles by it; it is not what an end-user token must send. */
  key: Scalars['String']['output'];
  match: Array<SupportRoleMatchRule>;
  retired: Scalars['Boolean']['output'];
};

export type SupportRoleContentHints = {
  __typename?: 'SupportRoleContentHints';
  keywords: Array<Scalars['String']['output']>;
  paths: Array<Scalars['String']['output']>;
  sections: Array<Scalars['String']['output']>;
};

export type SupportRoleContentHintsInput = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  paths?: InputMaybe<Array<Scalars['String']['input']>>;
  sections?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SupportRoleDeleteResult = {
  __typename?: 'SupportRoleDeleteResult';
  /** Of those, articles the role was the only reader of. They were held for review (out of search), never opened to everyone. */
  articlesHeldForReview: Scalars['Int']['output'];
  /** Articles the role was removed from. */
  articlesUpdated: Scalars['Int']['output'];
  /** Guidelines that were for this role alone. They were paused, never opened to everyone. */
  guidelinesPaused: Scalars['Int']['output'];
  key: Scalars['String']['output'];
};

/** Creates a role (no id) or updates one. The internal key is generated from the name on create and never changes. Omitted fields keep their value. */
export type SupportRoleInput = {
  /** Whether the AI answers people who hold this role. Off gives them a person from the start. Omitted keeps the value (on for a new role). */
  aiEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  contentHints?: InputMaybe<SupportRoleContentHintsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  /** Omit to create. */
  id?: InputMaybe<Scalars['ID']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  /** Replaces the matching rules. A role with no rules matches nobody. */
  match?: InputMaybe<Array<SupportRoleMatchRuleInput>>;
  /** A retired role grants its users nothing. */
  retired?: InputMaybe<Scalars['Boolean']['input']>;
};

/** One matching rule: the user holds the role when ANY rule matches. */
export type SupportRoleMatchRule = {
  __typename?: 'SupportRoleMatchRule';
  attributeKey?: Maybe<Scalars['String']['output']>;
  source: SupportRoleMatchSource;
  values: Array<Scalars['String']['output']>;
};

/** One matching rule. A user holds the role when ANY of its rules matches. Compared trimmed and case-insensitive. */
export type SupportRoleMatchRuleInput = {
  /** Required when source is ATTRIBUTE: the user attribute compared. */
  attributeKey?: InputMaybe<Scalars['String']['input']>;
  source: SupportRoleMatchSource;
  /** The user matches when their value is any of these. */
  values: Array<Scalars['String']['input']>;
};

/** ROLE compares the user's role value; ATTRIBUTE compares one of their attributes. */
export enum SupportRoleMatchSource {
  Attribute = 'ATTRIBUTE',
  Role = 'ROLE',
}

/** A practice workspace: a hidden copy of your Support setup where nothing reaches real customers, the real inbox, metrics or emails. */
export type SupportSandbox = {
  __typename?: 'SupportSandbox';
  createdAt: Scalars['DateTime']['output'];
  endUserCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  /** The roles your real workspace declares, to practise with. */
  roles: Array<SupportSandboxRole>;
  /** Send this as x-tenant-id to work the sandbox inbox as an agent. */
  tenantId: Scalars['ID']['output'];
  ticketCount: Scalars['Int']['output'];
};

export type SupportSandboxAttributeInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

/** A practice customer: the same key is the same person next time. */
export type SupportSandboxPersonaInput = {
  /** Attributes a real backend would send, to exercise attribute rules. */
  attributes?: InputMaybe<Array<SupportSandboxAttributeInput>>;
  company?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  /** Lowercase letters, digits and dashes, up to 40. */
  key: Scalars['String']['input'];
  name: Scalars['String']['input'];
  plan?: InputMaybe<Scalars['String']['input']>;
  /** The role value a real token would carry. Any value; your role rules decide which roles it grants. */
  role?: InputMaybe<Scalars['String']['input']>;
};

export type SupportSandboxRole = {
  __typename?: 'SupportSandboxRole';
  displayName: Scalars['String']['output'];
  key: Scalars['String']['output'];
  /** What a practice customer must carry to hold this role. */
  match: Array<SupportRoleMatchRule>;
};

/** A one-hour chat token for a practice customer of the sandbox. Do not log it. */
export type SupportSandboxToken = {
  __typename?: 'SupportSandboxToken';
  expiresAt: Scalars['DateTime']['output'];
  /** The practice identity the token names (sandbox:<key>). */
  externalUserId: Scalars['String']['output'];
  sandboxTenantId: Scalars['ID']['output'];
  /** An end-user token for the support chat API. */
  token: Scalars['String']['output'];
};

/** One ticket matching a search (I3), best match first. */
export type SupportSearchHit = {
  __typename?: 'SupportSearchHit';
  matchedIn: SupportSearchMatchedIn;
  /** The matching message, for MESSAGE hits. */
  messageId?: Maybe<Scalars['ID']['output']>;
  /** Internal notes are searched too. */
  messageKind?: Maybe<SupportMessageKind>;
  /** Plain text around the match, for MESSAGE hits. */
  snippet?: Maybe<Scalars['String']['output']>;
  ticket: SupportTicket;
};

export enum SupportSearchMatchedIn {
  Message = 'MESSAGE',
  Number = 'NUMBER',
  Title = 'TITLE',
}

export type SupportSettings = {
  __typename?: 'SupportSettings';
  /** null = uncapped. */
  aiDailySpendCapUsd?: Maybe<Scalars['Float']['output']>;
  aiEnabled: Scalars['Boolean']['output'];
  /** null = auto-close off. */
  autoCloseHours?: Maybe<Scalars['Int']['output']>;
  /** C5: minutes a reply may sit unread before the client is emailed. */
  clientEmailDelayMinutes: Scalars['Int']['output'];
  /** C5: page where clients read replies, linked from the email. null = none. */
  clientReplyUrl?: Maybe<Scalars['String']['output']>;
  ticketPrefix: Scalars['String']['output'];
  widget: SupportWidgetSettings;
};

/** Omitted fields are left as they are. */
export type SupportSettingsInput = {
  /** USD per day; send aiSpendCapEnabled: false to remove the cap. */
  aiDailySpendCapUsd?: InputMaybe<Scalars['Float']['input']>;
  aiEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  aiSpendCapEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** false switches auto-close off; send autoCloseHours to switch it on. */
  autoCloseEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** 1–720 hours. Setting it switches auto-close on. */
  autoCloseHours?: InputMaybe<Scalars['Int']['input']>;
  /** C5: 1–1440 minutes a reply may sit unread before the client is emailed. */
  clientEmailDelayMinutes?: InputMaybe<Scalars['Int']['input']>;
  /** C5: https page where clients read replies, linked from the email. null or "" clears it. */
  clientReplyUrl?: InputMaybe<Scalars['String']['input']>;
  /** 2–8 letters or digits. Applies to new tickets only. */
  ticketPrefix?: InputMaybe<Scalars['String']['input']>;
  /** Origins allowed to embed the widget, e.g. https://app.example.com. */
  widgetAllowedOrigins?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SupportTeamRef = {
  __typename?: 'SupportTeamRef';
  /** An archived team can hold old tickets but not be given new ones. */
  archived: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type SupportTicket = {
  __typename?: 'SupportTicket';
  /** True when a person let the AI keep answering this chat beside the team: it replies even with an assignee, a public agent reply or an earlier handover. */
  aiAlongsideAgent: Scalars['Boolean']['output'];
  aiState: SupportAiState;
  assignee?: Maybe<SupportPerson>;
  channel: TicketChannel;
  closeReason?: Maybe<Scalars['String']['output']>;
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  firstResponseAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  lastMessageAt: Scalars['DateTime']['output'];
  /** Human ticket number, e.g. AA-1042. */
  number: Scalars['String']['output'];
  organization?: Maybe<SupportOrganizationRef>;
  priority: TicketPriority;
  requester?: Maybe<SupportRequester>;
  /** The role value the requester's token carried when they opened the ticket. Display only: access is resolved from their current profile. */
  requesterRole?: Maybe<Scalars['String']['output']>;
  /** Keys of the support roles the requester matched when they opened the ticket. Empty for tickets opened before roles were matched by value. */
  requesterRoleKeys: Array<Scalars['String']['output']>;
  resolution?: Maybe<TicketResolution>;
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Where in the tenant's product the request was opened (e.g. web, ios). */
  source?: Maybe<Scalars['String']['output']>;
  statusCategory: StatusCategory;
  statusKey: Scalars['String']['output'];
  /** The status's display name from the type's workflow. */
  statusName: Scalars['String']['output'];
  summary?: Maybe<Scalars['String']['output']>;
  tags: Array<Scalars['String']['output']>;
  team?: Maybe<SupportTeamRef>;
  title?: Maybe<Scalars['String']['output']>;
  /** Who set the title: ai, agent, requester or none. */
  titleSource: Scalars['String']['output'];
  type: SupportTicketTypeRef;
  /** True when the ticket has activity this agent has not read. */
  unreadForMe: Scalars['Boolean']['output'];
  /** Pass back as expectedVersion on updateTicket. */
  version: Scalars['Int']['output'];
};

export type SupportTicketTypeRef = {
  __typename?: 'SupportTicketTypeRef';
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export enum SupportTicketView {
  All = 'ALL',
  Closed = 'CLOSED',
  Mine = 'MINE',
  Open = 'OPEN',
  Unassigned = 'UNASSIGNED',
  Untitled = 'UNTITLED',
  Waiting = 'WAITING',
}

/** A fact the tenant's backend sent about an end user, e.g. company_stage: seed. */
export type SupportUserAttribute = {
  __typename?: 'SupportUserAttribute';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** What the signed-in agent may do in Support. */
export type SupportViewerAccess = {
  __typename?: 'SupportViewerAccess';
  /** Tenant admins and owners: edit settings, types, workflows and roles. */
  canManageSettings: Scalars['Boolean']['output'];
};

export type SupportWidgetSettings = {
  __typename?: 'SupportWidgetSettings';
  allowedOrigins: Array<Scalars['String']['output']>;
};

export type SyncFeatureFlagsInput = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  organizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** How far through reviewing this job's invoices a person is. Distinct from the file counters, which only say the extractor finished: an import is reviewed days after it is read, so a job can be 26/26 files and 5/26 answered. */
export type SyncJobReviewProgress = {
  __typename?: 'SyncJobReviewProgress';
  /** Invoices a reviewer settled: saved with an answer, or marked not an invoice. */
  answered: Scalars['Int']['output'];
  /** Invoices already committed into real invoices. */
  committed: Scalars['Int']['output'];
  /** Invoices whose extraction failed — they need a retry, not an answer. */
  errored: Scalars['Int']['output'];
  /** Invoices still waiting for a person. This is the resume-here number. */
  pending: Scalars['Int']['output'];
  /** Invoices this job staged for review. */
  total: Scalars['Int']['output'];
};

export type SyncResult = {
  __typename?: 'SyncResult';
  error?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  syncedFlagsCount: Scalars['Int']['output'];
};

export type SyncResultPayment = {
  __typename?: 'SyncResultPayment';
  amount: Scalars['Float']['output'];
  paidAt: Scalars['DateTime']['output'];
};

/** Status of a sync result after extraction */
export enum SyncResultStatus {
  DiscardedNotInvoice = 'DISCARDED_NOT_INVOICE',
  Error = 'ERROR',
  Extracted = 'EXTRACTED',
  NeedsReview = 'NEEDS_REVIEW',
  Updated = 'UPDATED',
}

export type SyncedEmailMessage = {
  __typename?: 'SyncedEmailMessage';
  bodyText?: Maybe<Scalars['String']['output']>;
  direction: CrmEmailDirection;
  fromContactId?: Maybe<Scalars['ID']['output']>;
  hasAttachment: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  responseLatencyMs?: Maybe<Scalars['Float']['output']>;
  sentAt: Scalars['DateTime']['output'];
  seq: Scalars['Int']['output'];
  triageTier: EmailTriageTier;
  triageVerdict: MessageTriageVerdict;
  wordCountNew: Scalars['Int']['output'];
};

export type SyncedEmailThread = {
  __typename?: 'SyncedEmailThread';
  dealId?: Maybe<Scalars['ID']['output']>;
  firstMessageAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  lastDirection: CrmEmailDirection;
  lastInboundAt?: Maybe<Scalars['DateTime']['output']>;
  lastMessageAt: Scalars['DateTime']['output'];
  lastOutboundAt?: Maybe<Scalars['DateTime']['output']>;
  messageCount: Scalars['Int']['output'];
  organizationId?: Maybe<Scalars['ID']['output']>;
  participantContactIds: Array<Scalars['ID']['output']>;
  provider: EmailProvider;
  providerThreadId: Scalars['String']['output'];
  resolutionMethod: ThreadResolutionMethod;
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  triageReason?: Maybe<Scalars['String']['output']>;
  triageVerdict: ThreadTriageVerdict;
};

export type SyncedFolderEntity = {
  __typename?: 'SyncedFolderEntity';
  addedAt: Scalars['DateTime']['output'];
  folderId: Scalars['String']['output'];
  folderName: Scalars['String']['output'];
  lastSyncAt?: Maybe<Scalars['DateTime']['output']>;
  lastSyncJobId?: Maybe<Scalars['String']['output']>;
  scanSubfolders: Scalars['Boolean']['output'];
};

export type Task = {
  __typename?: 'Task';
  anchor?: Maybe<TaskAnchor>;
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  assignees: Array<TaskAssignee>;
  attachments: Array<TaskAttachment>;
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  /** When the task reached a terminal state (completed or cancelled); null while open. */
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['ID']['output'];
  /** Raw Markdown source. */
  description?: Maybe<Scalars['String']['output']>;
  descriptionFormat: DescriptionFormat;
  /** Sanitized HTML render (field resolver). */
  descriptionHtml?: Maybe<Scalars['String']['output']>;
  descriptionText?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  externalLinks: Array<TaskExternalLink>;
  id: Scalars['ID']['output'];
  /** Archived tasks are hidden from the default list. */
  isArchived: Scalars['Boolean']['output'];
  /** effectiveDue < now && status in (TODO, DOING). */
  isOverdue: Scalars['Boolean']['output'];
  /** System-generated task kind (metered usage). Null for operator-created tasks. */
  kind?: Maybe<TaskKind>;
  name: Scalars['String']['output'];
  origin: TaskOrigin;
  priority: TaskPriority;
  relation?: Maybe<TaskRelation>;
  remindAt?: Maybe<Scalars['DateTime']['output']>;
  /** Anchor-resolved due date; equals dueDate for absolute tasks. */
  resolvedDueAt?: Maybe<Scalars['DateTime']['output']>;
  status: TaskStatus;
  /** Idempotency key for system-generated tasks. */
  systemKey?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type TaskAnchor = {
  __typename?: 'TaskAnchor';
  anchorType: AnchorType;
  eventType?: Maybe<AnchorEventType>;
  offsetDays?: Maybe<Scalars['Int']['output']>;
  offsetDirection?: Maybe<OffsetDirection>;
  resolvedDueAt?: Maybe<Scalars['DateTime']['output']>;
};

export type TaskAnchorInput = {
  anchorType: AnchorType;
  eventType?: InputMaybe<AnchorEventType>;
  offsetDays?: InputMaybe<Scalars['Int']['input']>;
  offsetDirection?: InputMaybe<OffsetDirection>;
};

export type TaskAssignee = {
  __typename?: 'TaskAssignee';
  assignedAt: Scalars['DateTime']['output'];
  assignedBy?: Maybe<Scalars['ID']['output']>;
  assigneeId: Scalars['ID']['output'];
  assigneeType: AssigneeType;
  /** Resolved user; null when AGENT. */
  user?: Maybe<User>;
};

export type TaskAttachment = {
  __typename?: 'TaskAttachment';
  fileId: Scalars['ID']['output'];
  filename: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  sizeBytes: Scalars['Int']['output'];
  uploadedAt: Scalars['DateTime']['output'];
  uploadedBy?: Maybe<Scalars['ID']['output']>;
  /** Signed download URL (field resolver). */
  url?: Maybe<Scalars['String']['output']>;
};

export type TaskConnection = {
  __typename?: 'TaskConnection';
  edges: Array<TaskEdge>;
  pageInfo: TaskPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TaskEdge = {
  __typename?: 'TaskEdge';
  cursor: Scalars['String']['output'];
  node: Task;
};

export type TaskExternalLink = {
  __typename?: 'TaskExternalLink';
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type TaskFilterInput = {
  /** Tasks about this client account: related to the organization itself, to any of its contacts, or to any of its deals. Intersects with relationType/relationId when both are set. */
  accountId?: InputMaybe<Scalars['ID']['input']>;
  /** Archive axis. Omitted returns all tasks; false returns only active (non-archived); true returns only archived. */
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  assigneeId?: InputMaybe<Scalars['ID']['input']>;
  /** Lifecycle axis. Omitted returns both; false returns only open (TODO/DOING); true returns only closed (DONE/CANCELLED). */
  closed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only tasks closed at or after this instant. Pass the start of the local day for "closed today". Implies closed tasks only. */
  closedAfter?: InputMaybe<Scalars['DateTime']['input']>;
  dueAfter?: InputMaybe<Scalars['DateTime']['input']>;
  dueBefore?: InputMaybe<Scalars['DateTime']['input']>;
  /** Effective due date (anchor.resolvedDueAt ?? dueDate) at or before this instant. Unlike dueBefore — which only reads dueDate — this matches what the UI shows as the due date. Undated tasks are excluded. Pass the end of the local day to get "overdue or due today". */
  dueOnOrBefore?: InputMaybe<Scalars['DateTime']['input']>;
  /** Limit to these system task kinds (e.g. MANUAL_USAGE, UNVERIFIED_USAGE). */
  kind?: InputMaybe<Array<TaskKind>>;
  priority?: InputMaybe<Array<TaskPriority>>;
  relationId?: InputMaybe<Scalars['ID']['input']>;
  relationType?: InputMaybe<EntityTargetType>;
  /** Matches name + descriptionText. */
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<TaskStatus>>;
};

/** System-generated task kind (metered usage prompts and faults). */
export enum TaskKind {
  ActivationOverdue = 'ACTIVATION_OVERDUE',
  ManualUsage = 'MANUAL_USAGE',
  SeatRequest = 'SEAT_REQUEST',
  UnverifiedUsage = 'UNVERIFIED_USAGE',
}

/** How a task was created. */
export enum TaskOrigin {
  Agent = 'AGENT',
  Api = 'API',
  Direct = 'DIRECT',
}

export type TaskPageInfo = {
  __typename?: 'TaskPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** Task priority (LOW=1 .. URGENT=4). Stored as an integer for urgency sorting. */
export enum TaskPriority {
  High = 'HIGH',
  Low = 'LOW',
  Normal = 'NORMAL',
  Urgent = 'URGENT',
}

export type TaskRelation = {
  __typename?: 'TaskRelation';
  relationId: Scalars['ID']['output'];
  relationType: EntityTargetType;
  /** Resolved target; null if the target is unavailable (deleted/converted). */
  target?: Maybe<TaskRelationTarget>;
};

export type TaskRelationInput = {
  relationId: Scalars['ID']['input'];
  relationType: EntityTargetType;
};

export type TaskRelationTarget = CrmLead | Organization | OrganizationContact;

/** Task list sort field. */
export enum TaskSortField {
  ClosedAt = 'CLOSED_AT',
  CreatedAt = 'CREATED_AT',
  DueDate = 'DUE_DATE',
  Name = 'NAME',
  Priority = 'PRIORITY',
  Status = 'STATUS',
  UpdatedAt = 'UPDATED_AT',
}

export type TaskSortInput = {
  direction?: SortOrder;
  field?: TaskSortField;
};

/** Task lifecycle state. */
export enum TaskStatus {
  Cancelled = 'CANCELLED',
  Doing = 'DOING',
  Done = 'DONE',
  Todo = 'TODO',
}

export type TaxCurrencyTotal = {
  __typename?: 'TaxCurrencyTotal';
  currency: Scalars['String']['output'];
  /** Charged plus credited: what a return reports. */
  taxAmount: Scalars['String']['output'];
  /** Tax charged on invoices. */
  taxCharged: Scalars['String']['output'];
  /** Tax reversed by credit notes, as a negative. */
  taxCredited: Scalars['String']['output'];
  taxableBase: Scalars['String']['output'];
};

export type TaxExemption = {
  __typename?: 'TaxExemption';
  certificateRef?: Maybe<Scalars['String']['output']>;
  isExempt: Scalars['Boolean']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  validFrom?: Maybe<Scalars['DateTime']['output']>;
  validTo?: Maybe<Scalars['DateTime']['output']>;
};

export type TaxExemptionInput = {
  certificateRef?: InputMaybe<Scalars['String']['input']>;
  isExempt: Scalars['Boolean']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  validFrom?: InputMaybe<Scalars['DateTime']['input']>;
  validTo?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum TaxIdValidationStatus {
  Invalid = 'INVALID',
  Unvalidated = 'UNVALIDATED',
  Valid = 'VALID',
}

export type TaxLedgerCheckInput = {
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};

export type TaxLedgerMismatch = {
  __typename?: 'TaxLedgerMismatch';
  invoiceId: Scalars['ID']['output'];
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  invoiceTaxAmount: Scalars['String']['output'];
  ledgerTaxAmount: Scalars['String']['output'];
};

export type TaxPreviewInput = {
  currency: Scalars['String']['input'];
  /** A draft rate to include as though published, to try it before publishing. */
  draftRateId?: InputMaybe<Scalars['ID']['input']>;
  /** Defaults to now. */
  invoiceDate?: InputMaybe<Scalars['DateTime']['input']>;
  lines: Array<TaxPreviewLineInput>;
  organizationId: Scalars['ID']['input'];
};

export type TaxPreviewLine = {
  __typename?: 'TaxPreviewLine';
  grossAmount: Scalars['Decimal']['output'];
  key: Scalars['String']['output'];
  netAmount: Scalars['Decimal']['output'];
  taxAmount: Scalars['Decimal']['output'];
  taxLines: Array<TaxPreviewTaxLine>;
  treatment: TaxTreatment;
};

export type TaxPreviewLineInput = {
  key: Scalars['String']['input'];
  /** Net after discounts. */
  netAmount: Scalars['Decimal']['input'];
  taxCategory?: InputMaybe<Scalars['String']['input']>;
};

export type TaxPreviewResult = {
  __typename?: 'TaxPreviewResult';
  breakdown: Array<TaxPreviewTaxLine>;
  currency: Scalars['String']['output'];
  grossAmount: Scalars['Decimal']['output'];
  legends: Array<Scalars['String']['output']>;
  lines: Array<TaxPreviewLine>;
  subtotalAmount: Scalars['Decimal']['output'];
  taxAmount: Scalars['Decimal']['output'];
  /** False when tax is off or no registration applies; the invoice is untouched. */
  taxApplied: Scalars['Boolean']['output'];
  /** The decisions behind this result, in the order they were taken. */
  trace: Array<TaxTraceStep>;
  /** JURISDICTION_ASSUMED, NO_RATE_FOR_JURISDICTION */
  warnings: Array<Scalars['String']['output']>;
};

export type TaxPreviewTaxLine = {
  __typename?: 'TaxPreviewTaxLine';
  displayLabel: Scalars['String']['output'];
  ratePct: Scalars['Decimal']['output'];
  taxAmount: Scalars['Decimal']['output'];
  taxCode: Scalars['String']['output'];
  taxableBase: Scalars['Decimal']['output'];
};

export type TaxRate = {
  __typename?: 'TaxRate';
  code: Scalars['String']['output'];
  compound: Scalars['Boolean']['output'];
  countryCode: Scalars['String']['output'];
  displayLabel: Scalars['String']['output'];
  effectiveFrom: Scalars['DateTime']['output'];
  effectiveTo?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  ratePct: Scalars['Decimal']['output'];
  registrationId: Scalars['ID']['output'];
  replacesCountryRates: Scalars['Boolean']['output'];
  sequence: Scalars['Int']['output'];
  status: TaxRateStatus;
  subdivisionCode?: Maybe<Scalars['String']['output']>;
  /** Null applies to every item. */
  taxCategories?: Maybe<Array<Scalars['String']['output']>>;
  /** The levy this is a rate of (VAT, GST, QST). One rate per levy applies to a line. */
  taxCode: Scalars['String']['output'];
  taxType: TaxType;
  treatment: TaxTreatment;
  version: Scalars['Int']['output'];
};

export enum TaxRateStatus {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
}

export enum TaxReferenceBehaviour {
  Adds = 'ADDS',
  Country = 'COUNTRY',
  ReplacesCountry = 'REPLACES_COUNTRY',
}

export type TaxReferenceCountry = {
  __typename?: 'TaxReferenceCountry';
  authority?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  /** The country-level rate, e.g. "VAT 21%". Null when not seeded. */
  headline?: Maybe<Scalars['String']['output']>;
  /** Layers already in this tenant rates. */
  importedCount: Scalars['Int']['output'];
  /** YYYY-MM. */
  lastChecked: Scalars['String']['output'];
  layerCount: Scalars['Int']['output'];
  layers: Array<TaxReferenceLayer>;
  name: Scalars['String']['output'];
  region: Scalars['String']['output'];
  sourceUrl?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
};

export type TaxReferenceCountrySummary = {
  __typename?: 'TaxReferenceCountrySummary';
  code: Scalars['String']['output'];
  /** The country-level rate, e.g. "VAT 21%". Null when not seeded. */
  headline?: Maybe<Scalars['String']['output']>;
  /** Layers already in this tenant rates. */
  importedCount: Scalars['Int']['output'];
  layerCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  region: Scalars['String']['output'];
};

/** An imported rate whose reference layer changed (or was removed) after it was imported. */
export type TaxReferenceDrift = {
  __typename?: 'TaxReferenceDrift';
  code: Scalars['String']['output'];
  currentVersion: Scalars['Int']['output'];
  importedVersion: Scalars['Int']['output'];
  key: Scalars['String']['output'];
  kind: TaxReferenceDriftKind;
  rateId: Scalars['ID']['output'];
  /** The tenant's rate, percent. */
  ratePct: Scalars['String']['output'];
  /** The reference's rate now, percent. */
  referenceRatePct?: Maybe<Scalars['String']['output']>;
};

export enum TaxReferenceDriftKind {
  RateChanged = 'RATE_CHANGED',
  Removed = 'REMOVED',
}

export type TaxReferenceInfo = {
  __typename?: 'TaxReferenceInfo';
  countryCount: Scalars['Int']['output'];
  /** YYYY-MM of the last review. */
  reviewedAt?: Maybe<Scalars['String']['output']>;
  /** 0 when no reference data is loaded. */
  version: Scalars['Int']['output'];
};

export type TaxReferenceLayer = {
  __typename?: 'TaxReferenceLayer';
  behaviour: TaxReferenceBehaviour;
  caution?: Maybe<Scalars['String']['output']>;
  compound?: Maybe<Scalars['Boolean']['output']>;
  countryCode: Scalars['String']['output'];
  displayLabel: Scalars['String']['output'];
  jurisdictionName?: Maybe<Scalars['String']['output']>;
  /** Becomes the rate code on import. */
  key: Scalars['String']['output'];
  layer: Scalars['String']['output'];
  /** Exact decimal string, e.g. 9.975. */
  ratePct: Scalars['String']['output'];
  /** Order within the jurisdiction, when the layer sets one. */
  sequence?: Maybe<Scalars['Int']['output']>;
  status: TaxReferenceLayerStatus;
  subdivisionCode?: Maybe<Scalars['String']['output']>;
  taxCode: Scalars['String']['output'];
  taxType: TaxType;
  treatment: TaxTreatment;
};

export enum TaxReferenceLayerStatus {
  Available = 'AVAILABLE',
  CodeTaken = 'CODE_TAKEN',
  Imported = 'IMPORTED',
  NeedsRegistration = 'NEEDS_REGISTRATION',
}

export type TaxRegistration = {
  __typename?: 'TaxRegistration';
  countryCode: Scalars['String']['output'];
  effectiveFrom: Scalars['DateTime']['output'];
  effectiveTo?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isPrimary: Scalars['Boolean']['output'];
  legalName?: Maybe<Scalars['String']['output']>;
  registrationNumber: Scalars['String']['output'];
  scheme: TaxType;
  status: TaxRegistrationStatus;
  subdivisionCode?: Maybe<Scalars['String']['output']>;
};

export type TaxRegistrationDeactivation = {
  __typename?: 'TaxRegistrationDeactivation';
  /** Published rates that stop applying once the registration ends. */
  affectedRateCodes: Array<Scalars['String']['output']>;
  registration: TaxRegistration;
};

export enum TaxRegistrationStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
}

export type TaxReport = {
  __typename?: 'TaxReport';
  /** ACCRUAL: tax counts when the invoice is issued. CASH: as each payment arrives. */
  basis: Scalars['String']['output'];
  groupBy: TaxReportGroupBy;
  periodEnd: Scalars['DateTime']['output'];
  periodStart: Scalars['DateTime']['output'];
  rows: Array<TaxSummaryRow>;
  /** One total per currency; no conversion. */
  totalsByCurrency: Array<TaxCurrencyTotal>;
  /** Taxable value of zero-rated, exempt, reverse-charge and out-of-scope supplies. */
  treatmentTotals: Array<TaxTreatmentTotal>;
};

export enum TaxReportBasis {
  Accrual = 'ACCRUAL',
  Cash = 'CASH',
}

export enum TaxReportGroupBy {
  Jurisdiction = 'JURISDICTION',
  Month = 'MONTH',
  TaxCode = 'TAX_CODE',
}

export type TaxReportInput = {
  /** ACCRUAL counts tax on the invoice date; CASH counts it as payments arrive. */
  basis?: TaxReportBasis;
  /** Only ledger lines taxed in this country (ISO 3166-1 alpha-2). */
  countryCode?: InputMaybe<Scalars['String']['input']>;
  /** Only ledger lines in this invoice currency (ISO 4217). */
  currency?: InputMaybe<Scalars['String']['input']>;
  groupBy?: TaxReportGroupBy;
  periodEnd: Scalars['DateTime']['input'];
  periodStart: Scalars['DateTime']['input'];
  /** Only ledger lines with this tax code. */
  taxCode?: InputMaybe<Scalars['String']['input']>;
};

export type TaxSettings = {
  __typename?: 'TaxSettings';
  enabled: Scalars['Boolean']['output'];
  exemptLegend?: Maybe<Scalars['String']['output']>;
  reverseChargeEnabled: Scalars['Boolean']['output'];
  reverseChargeLegend?: Maybe<Scalars['String']['output']>;
  showTaxIdsOnInvoice: Scalars['Boolean']['output'];
};

export type TaxSummaryRow = {
  __typename?: 'TaxSummaryRow';
  currency: Scalars['String']['output'];
  group: Scalars['String']['output'];
  invoiceCount: Scalars['Int']['output'];
  taxAmount: Scalars['String']['output'];
  taxableBase: Scalars['String']['output'];
};

export type TaxTraceStep = {
  __typename?: 'TaxTraceStep';
  detail: Scalars['String']['output'];
  /** APPLIED: the rule decided something. PASSED: it did not apply, the next was tried. STOPPED: it ended the walk. */
  outcome: Scalars['String']['output'];
  /** SWITCH, JURISDICTION, EXEMPTION, REVERSE_CHARGE, REGISTRATION or RATES. */
  step: Scalars['String']['output'];
};

export type TaxTransaction = {
  __typename?: 'TaxTransaction';
  countryCode: Scalars['String']['output'];
  creditsInvoiceId?: Maybe<Scalars['ID']['output']>;
  currency: Scalars['String']['output'];
  direction: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  invoiceDate: Scalars['DateTime']['output'];
  invoiceId: Scalars['ID']['output'];
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  ratePct: Scalars['String']['output'];
  taxAmount: Scalars['String']['output'];
  taxCode: Scalars['String']['output'];
  taxableBase: Scalars['String']['output'];
  treatment: TaxTreatment;
};

export type TaxTransactionFilterInput = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  periodEnd: Scalars['DateTime']['input'];
  periodStart: Scalars['DateTime']['input'];
  taxCode?: InputMaybe<Scalars['String']['input']>;
};

export type TaxTransactionPage = {
  __typename?: 'TaxTransactionPage';
  items: Array<TaxTransaction>;
  total: Scalars['Int']['output'];
};

export enum TaxTreatment {
  Exempt = 'EXEMPT',
  OutOfScope = 'OUT_OF_SCOPE',
  Reduced = 'REDUCED',
  ReverseCharge = 'REVERSE_CHARGE',
  Standard = 'STANDARD',
  ZeroRated = 'ZERO_RATED',
}

export type TaxTreatmentTotal = {
  __typename?: 'TaxTreatmentTotal';
  currency: Scalars['String']['output'];
  taxableBase: Scalars['String']['output'];
  treatment: TaxTreatment;
};

export enum TaxType {
  ConsumptionTax = 'CONSUMPTION_TAX',
  Gst = 'GST',
  Other = 'OTHER',
  SalesTax = 'SALES_TAX',
  Vat = 'VAT',
}

/** A named group of people inside the tenant */
export type Team = {
  __typename?: 'Team';
  /** When the team was archived, or null */
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  /** When the team was created */
  createdAt: Scalars['DateTime']['output'];
  /** MongoDB ObjectId — the only identifier, since names repeat */
  id: Scalars['ID']['output'];
  /** Convenience for archivedAt !== null */
  isArchived: Scalars['Boolean']['output'];
  /** The team lead, or null. A lead need not be a member of the team they lead, so this is not drawn from the member list. */
  lead?: Maybe<TeamPerson>;
  /** Whether the lead sits outside the member list. Usually deliberate, occasionally a mistake, so it is surfaced rather than hidden. */
  leadIsMember: Scalars['Boolean']['output'];
  /** Number of members */
  memberCount: Scalars['Int']['output'];
  /** Up to five members for the avatar cluster on the list. The full list comes from the team query. */
  memberPreview: Array<TeamPerson>;
  /** Display name. Not unique: two teams may both be Sales */
  name: Scalars['String']['output'];
};

/** Whether a team can be archived, and why not */
export type TeamArchiveEligibility = {
  __typename?: 'TeamArchiveEligibility';
  /** Whether archiving is allowed right now */
  canArchive: Scalars['Boolean']['output'];
  /** One sentence per blocking dependency, empty when archiving is allowed */
  reasons: Array<Scalars['String']['output']>;
};

/** A team with its full member list */
export type TeamDetail = {
  __typename?: 'TeamDetail';
  /** When the team was archived, or null */
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  /** When the team was created */
  createdAt: Scalars['DateTime']['output'];
  /** MongoDB ObjectId — the only identifier, since names repeat */
  id: Scalars['ID']['output'];
  /** Convenience for archivedAt !== null */
  isArchived: Scalars['Boolean']['output'];
  /** The team lead, or null. A lead need not be a member of the team they lead, so this is not drawn from the member list. */
  lead?: Maybe<TeamPerson>;
  /** Whether the lead sits outside the member list. Usually deliberate, occasionally a mistake, so it is surfaced rather than hidden. */
  leadIsMember: Scalars['Boolean']['output'];
  /** Number of members */
  memberCount: Scalars['Int']['output'];
  /** Up to five members for the avatar cluster on the list. The full list comes from the team query. */
  memberPreview: Array<TeamPerson>;
  /** Every member, ordered by name */
  members: Array<TeamMembership>;
  /** Display name. Not unique: two teams may both be Sales */
  name: Scalars['String']['output'];
};

export type TeamEmailConnection = {
  __typename?: 'TeamEmailConnection';
  connected?: Maybe<Scalars['Boolean']['output']>;
  userId: Scalars['String']['output'];
};

/** One person’s membership of a team */
export type TeamMembership = {
  __typename?: 'TeamMembership';
  /** When they were added to the team */
  addedAt: Scalars['DateTime']['output'];
  /** Whether this member is also the team’s lead */
  isLead: Scalars['Boolean']['output'];
  /** The member */
  person: TeamPerson;
};

/** A person in the tenant, as shown on team and role surfaces */
export type TeamPerson = {
  __typename?: 'TeamPerson';
  /** Email address */
  email: Scalars['String']['output'];
  /** Names of the teams this person leads. Shown ahead of membership ("leads Sales") because leading is the more informative fact. */
  leadsTeamNames: Array<Scalars['String']['output']>;
  /** Display name, when the profile has one */
  name?: Maybe<Scalars['String']['output']>;
  /** Invited but never logged in. A pending person is still a full, choosable member — an objective or key result can be assigned to them the same as anyone active — this only flags that they have not taken any action since being invited, for a picker or member row to say so. */
  pending: Scalars['Boolean']['output'];
  /** Profile picture URL */
  picture?: Maybe<Scalars['String']['output']>;
  /** Names of the teams this person is a member of. Member rows and the people picker render an affiliation from this ("also in Platform", "no team yet"), which is what stops two similar names reading as the same person. */
  teamNames: Array<Scalars['String']['output']>;
  /** The person's account role on this tenant: owner, admin or member */
  tenantRole?: Maybe<Scalars['String']['output']>;
  /** Auth id (JWT sub) — the identifier to pass back in */
  userId: Scalars['String']['output'];
};

/** Headcount band */
export enum TeamSizeRange {
  Size_1_10 = 'SIZE_1_10',
  Size_11_50 = 'SIZE_11_50',
  Size_51_200 = 'SIZE_51_200',
  Size_201_1000 = 'SIZE_201_1000',
  Size_1000Plus = 'SIZE_1000_PLUS',
}

/** What a temporary form, made for one contract send, asks the client. */
export type TemporaryContractFormInput = {
  /** `field.<key>` (a field of the contract the client fills) or a client detail token such as `client.legal_name` that the contract uses. */
  targets: Array<Scalars['String']['input']>;
};

export type Tenant = {
  __typename?: 'Tenant';
  /** Optional Anthropic model ID to use for Drive invoice extraction for this tenant. Unset → service default (Haiku). Must begin with "claude-" to take effect. */
  aiDocumentModelOverride?: Maybe<Scalars['String']['output']>;
  /** Analytics behaviour configuration */
  analyticsConfig?: Maybe<TenantAnalyticsConfig>;
  /** Whether automated (scheduled) emails such as payment reminders are sent automatically for this tenant. When false, the operator sends them manually. (default: true) */
  autoSendEmails: Scalars['Boolean']['output'];
  /** Tenant-wide defaults for billing-schedule presets */
  billingScheduleConfig?: Maybe<TenantBillingScheduleConfig>;
  /** Billing standing of a self-serve workspace; null when it is not billed that way. SUSPENDED and CANCELLED workspaces are read-only. */
  billingStatus?: Maybe<TenantBillingStatus>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** External API endpoint URL for this tenant */
  externalApiEndpoint?: Maybe<Scalars['String']['output']>;
  /** Array of enabled features for this tenant */
  features: Array<TenantFeature>;
  /** Whether external API is configured for this tenant */
  hasExternalApiConfig?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /** Invoice configuration defaults */
  invoiceConfig?: Maybe<TenantInvoiceConfig>;
  /** Issuer details rendered at the top of generated invoice PDFs */
  invoiceHeader?: Maybe<TenantInvoiceHeader>;
  isActive: Scalars['Boolean']['output'];
  /** Whether this tenant is mandatory (cannot be deleted) */
  isMandatory: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  /** Tenant-wide OKR settings: activation state and the default check-in schedule */
  okrConfig?: Maybe<TenantOkrConfig>;
  /** Tenant onboarding progress and configuration */
  onboardingState?: Maybe<TenantOnboardingState>;
  /** Banking details and payment instructions rendered on generated invoice PDFs */
  paymentInfo?: Maybe<TenantPaymentInfo>;
  /** Per-period default lead time (days) for generating renewal invoices ahead of the renewal date */
  renewalInvoiceLeadDays?: Maybe<TenantRenewalInvoiceLeadDays>;
  /** Currency used for consolidated ARR/MRR reporting (default: USD) */
  reportingCurrency?: Maybe<Scalars['String']['output']>;
  /** Seat limit and contracted per-seat price for this tenant */
  seatPolicy?: Maybe<TenantSeatPolicy>;
  slug: Scalars['String']['output'];
  /** IANA timezone used as the fallback for scheduling when a recipient has no timezone of their own */
  timezone?: Maybe<Scalars['String']['output']>;
  /** Type of tenant: MASTER, ACCELERATOR_APP, or REGULAR */
  type: TenantType;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
};

/** Analytics behaviour configuration for the tenant */
export type TenantAnalyticsConfig = {
  __typename?: 'TenantAnalyticsConfig';
  /** Days after a subscription ends within which a new subscription for the same organisation is treated as a renewal rather than a churn. (default: 30) */
  churnGracePeriodDays: Scalars['Int']['output'];
  /** Days after a subscription ends beyond which a returning customer is classified as a REACTIVATION rather than a RENEWAL. Gap >= this value = reactivation. (default: 90) */
  reactivationWindowDays: Scalars['Int']['output'];
};

/** What the tenant has taught the matcher, product by product */
export type TenantAutonomyReportEntity = {
  __typename?: 'TenantAutonomyReportEntity';
  /** Decisions folded, after the newest-per-subject fold */
  decisionsConsidered: Scalars['Int']['output'];
  products: Array<ProductAutonomyEntity>;
  /** Distinct clients those hits must come from */
  requiredClients: Scalars['Int']['output'];
  /** Clean hits a product needs to be matched without review */
  requiredHits: Scalars['Int']['output'];
  /** True only when every product with evidence has earned it. Derived from the per-product states, never stored beside them. */
  tenantEarned: Scalars['Boolean']['output'];
};

/** A single bank account entry, scoped to one region and denominated in one currency */
export type TenantBankingDetail = {
  __typename?: 'TenantBankingDetail';
  /** Account holder / beneficiary name */
  accountName?: Maybe<Scalars['String']['output']>;
  /** Domestic account number */
  accountNumber?: Maybe<Scalars['String']['output']>;
  /** Which identifier scheme this account uses (IBAN, SWIFT/BIC, or routing/sort code). Unset shows every structured field for backwards compatibility with accounts saved before this field existed. */
  accountType?: Maybe<BankAccountType>;
  /** Bank's postal address */
  bankAddress?: Maybe<Scalars['String']['output']>;
  /** Bank name */
  bankName?: Maybe<Scalars['String']['output']>;
  /** Bank branch code */
  branchCode?: Maybe<Scalars['String']['output']>;
  /** ISO 4217 currency code this account is denominated in */
  currency: Scalars['String']['output'];
  /** IBAN, for SEPA / international transfers */
  iban?: Maybe<Scalars['String']['output']>;
  /** Region this account applies to. Null = region-agnostic default used for any region that has no region-specific entry for the currency. */
  regionId?: Maybe<Scalars['ID']['output']>;
  /** Routing / sort code / ABA number */
  routingNumber?: Maybe<Scalars['String']['output']>;
  /** SWIFT / BIC code */
  swiftBic?: Maybe<Scalars['String']['output']>;
};

/** Tenant-wide defaults for billing-schedule presets. Overridable per subscription when a preset is applied. */
export type TenantBillingScheduleConfig = {
  __typename?: 'TenantBillingScheduleConfig';
  /** Days after signing that a deferred-activation subscription may wait before the daily sweep raises it with the tenant */
  defaultActivationGapDays: Scalars['Int']['output'];
  /** What a prepaid span means on cancellation when the operator does not choose one */
  defaultCommitment: BillingCommitment;
};

/** Where a self-serve workspace stands with its subscription. SUSPENDED and CANCELLED are read-only. */
export enum TenantBillingStatus {
  Active = 'ACTIVE',
  Blocked = 'BLOCKED',
  Cancelled = 'CANCELLED',
  PastDue = 'PAST_DUE',
  Suspended = 'SUSPENDED',
  Trialing = 'TRIALING',
}

/** Catalog gaps across the tenant’s recently-billed clients. Read-only. The scan is bounded, so compare clientsScanned against clientsWithInvoices before reading an empty result as "the catalog is complete". */
export type TenantCatalogGapReportEntity = {
  __typename?: 'TenantCatalogGapReportEntity';
  /** Clients with something to say, most proposals first. A client whose invoices produced neither a proposal nor a skipped cluster is omitted. */
  clients: Array<ClientCatalogGapsEntity>;
  /** Clients whose invoices were read on this pass */
  clientsScanned: Scalars['Int']['output'];
  /** Clients with any invoices at all — the denominator, so a bounded scan cannot read as a complete one */
  clientsWithInvoices: Scalars['Int']['output'];
};

/** Features that can be enabled/disabled per tenant */
export enum TenantFeature {
  Analytics = 'ANALYTICS',
  AssistantOnboarding = 'ASSISTANT_ONBOARDING',
  AutoRenewal = 'AUTO_RENEWAL',
  BillingSchedule = 'BILLING_SCHEDULE',
  Checkins = 'CHECKINS',
  Crm = 'CRM',
  DriveFolders = 'DRIVE_FOLDERS',
  EmailTier1Triage = 'EMAIL_TIER1_TRIAGE',
  EmailTier2Extraction = 'EMAIL_TIER2_EXTRACTION',
  FeatureFlags = 'FEATURE_FLAGS',
  Finance = 'FINANCE',
  Forms = 'FORMS',
  Import = 'IMPORT',
  Incubators = 'INCUBATORS',
  MarketConfig = 'MARKET_CONFIG',
  Okr = 'OKR',
  Organizations = 'ORGANIZATIONS',
  Pricing = 'PRICING',
  ProductConfig = 'PRODUCT_CONFIG',
  ProductUsage = 'PRODUCT_USAGE',
  Subscriptions = 'SUBSCRIPTIONS',
  Support = 'SUPPORT',
  Tax = 'TAX',
  TenantManagement = 'TENANT_MANAGEMENT',
  UserManagement = 'USER_MANAGEMENT',
  WorkInbox = 'WORK_INBOX',
}

/** Invoice configuration defaults for the tenant */
export type TenantInvoiceConfig = {
  __typename?: 'TenantInvoiceConfig';
  /** Default payment terms in days (0 = due on receipt) */
  defaultPaymentTermsDays: Scalars['Int']['output'];
};

/** Issuer details rendered at the top of generated invoice PDFs */
export type TenantInvoiceHeader = {
  __typename?: 'TenantInvoiceHeader';
  /** First address line (street) */
  addressLine1?: Maybe<Scalars['String']['output']>;
  /** Second address line (suite, unit, etc.) */
  addressLine2?: Maybe<Scalars['String']['output']>;
  /** City / town */
  city?: Maybe<Scalars['String']['output']>;
  /** Legal/display company name shown as the invoice issuer (defaults to tenant name) */
  companyName?: Maybe<Scalars['String']['output']>;
  /** Country */
  country?: Maybe<Scalars['String']['output']>;
  /** Billing contact email shown in the header */
  email?: Maybe<Scalars['String']['output']>;
  /** Object-storage key of an uploaded logo; used to re-sign a fresh preview/download URL */
  logoStorageKey?: Maybe<Scalars['String']['output']>;
  /** URL of the logo image embedded on the invoice. For uploaded logos it is re-signed from logoStorageKey on every read and is short-lived; if signing fails it falls back to the stored URL, which may already have expired. */
  logoUrl?: Maybe<Scalars['String']['output']>;
  /** Billing contact phone shown in the header */
  phone?: Maybe<Scalars['String']['output']>;
  /** Postal / ZIP code */
  postalCode?: Maybe<Scalars['String']['output']>;
  /** Company registration / incorporation number */
  registrationNumber?: Maybe<Scalars['String']['output']>;
  /** State / province / region */
  state?: Maybe<Scalars['String']['output']>;
  /** Tax / VAT registration number */
  taxId?: Maybe<Scalars['String']['output']>;
  /** Label for the tax identifier (e.g. "VAT", "EIN"). Defaults to "Tax ID". */
  taxLabel?: Maybe<Scalars['String']['output']>;
  /** Company website shown in the header */
  website?: Maybe<Scalars['String']['output']>;
};

/** Workspace-wide notification defaults */
export type TenantNotificationDefaults = {
  __typename?: 'TenantNotificationDefaults';
  /** Whether each concluded hypothesis test is posted to the announcement channel with its outcome and learning */
  announceHypothesisLearnings: Scalars['Boolean']['output'];
  /** Whether team leads are copied on the weekly digest */
  ccTeamLeadsOnDigest: Scalars['Boolean']['output'];
  /** Default weekday for the prompt, 1 = Monday */
  checkInDay: Scalars['Int']['output'];
  /** Default hour, in each recipient's local time */
  checkInHour: Scalars['Int']['output'];
};

/** Tenant-wide OKR settings */
export type TenantOkrConfig = {
  __typename?: 'TenantOkrConfig';
  /** When an org admin activated the OKR module. Null means entitled but not yet turned on — activation additionally requires a connected Slack workspace. */
  activatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Auth id of the org admin who activated the module */
  activatedBy?: Maybe<Scalars['String']['output']>;
  /** Whether each concluded hypothesis test is posted to the announcement channel. Unset reads as off */
  announceHypothesisLearnings?: Maybe<Scalars['Boolean']['output']>;
  /** Whether team leads are copied on the weekly digest alongside cycle owners */
  ccTeamLeadsOnDigest: Scalars['Boolean']['output'];
  /** Default weekday for the check-in prompt (1 = Monday … 7 = Sunday) */
  checkInDay: Scalars['Int']['output'];
  /** Default hour (0-23) for the check-in prompt, in the recipient's local time rather than the tenant's */
  checkInHour: Scalars['Int']['output'];
};

/** Tenant onboarding state and progress */
export type TenantOnboardingState = {
  __typename?: 'TenantOnboardingState';
  /** When onboarding was completed */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Array of completed steps */
  completedSteps: Array<OnboardingStepCompletion>;
  /** Configuration ID being used for onboarding */
  configId: Scalars['String']['output'];
  /** Current step ID */
  currentStep: Scalars['String']['output'];
  /** When onboarding was started */
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Current onboarding status */
  status: OnboardingStatus;
};

/** Payment information rendered on generated invoice PDFs */
export type TenantPaymentInfo = {
  __typename?: 'TenantPaymentInfo';
  /** Structured bank account details, at most one entry per region + currency */
  bankingDetails: Array<TenantBankingDetail>;
  /** Free-form payment instructions rendered on every invoice */
  paymentInstructions?: Maybe<Scalars['String']['output']>;
};

/** Per-period default lead time (in days) for generating renewal invoices ahead of the renewal date. 0 = invoice at the renewal date (no advance invoicing). */
export type TenantRenewalInvoiceLeadDays = {
  __typename?: 'TenantRenewalInvoiceLeadDays';
  /** Days before renewal to invoice MONTHLY subscriptions */
  monthly: Scalars['Int']['output'];
  /** Days before renewal to invoice QUARTERLY subscriptions */
  quarterly: Scalars['Int']['output'];
  /** Days before renewal to invoice YEARLY subscriptions */
  yearly: Scalars['Int']['output'];
};

export type TenantRenewalSummaryOutput = {
  __typename?: 'TenantRenewalSummaryOutput';
  processedAt: Scalars['DateTime']['output'];
  results: Array<RenewalProcessingResultOutput>;
  stats: RenewalStatsOutput;
  tenantId: Scalars['String']['output'];
  tenantName: Scalars['String']['output'];
};

/** Seat limit and contracted per-seat price for the tenant */
export type TenantSeatPolicy = {
  __typename?: 'TenantSeatPolicy';
  /** ISO 4217 code the seat price is denominated in */
  seatCurrency: Scalars['String']['output'];
  /** Maximum active memberships; null means unlimited */
  seatLimit?: Maybe<Scalars['Int']['output']>;
  /** Contracted price per seat per month, in seatCurrency */
  unitAmount: Scalars['Float']['output'];
};

/** Type of tenant and its role in the platform */
export enum TenantType {
  AcceleratorApp = 'ACCELERATOR_APP',
  Master = 'MASTER',
  Regular = 'REGULAR',
}

/** The days of the week the tenant works, and the timezone a calendar day is read in. Business-day arithmetic (follow-up due dates, check-ins) follows this. */
export type TenantWorkingCalendar = {
  __typename?: 'TenantWorkingCalendar';
  /** IANA timezone the calendar day is evaluated in (the tenant timezone) */
  timezone: Scalars['String']['output'];
  /** When the setting was last changed; null if never */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** ISO weekdays the tenant works: 1 = Monday … 7 = Sunday */
  workingDays: Array<Scalars['Int']['output']>;
};

export type TextFieldInput = {
  /** 1-based page number. */
  page: Scalars['Int']['input'];
  /** What the signer typed. One line. */
  text: Scalars['String']['input'];
  /** Left edge, 0–1 of the page width. */
  x: Scalars['Float']['input'];
  /** Vertical centre of the line, 0–1 of the page height, from the top. */
  y: Scalars['Float']['input'];
};

/** How an email thread was linked to an Organization. */
export enum ThreadResolutionMethod {
  ContactMatch = 'CONTACT_MATCH',
  DomainMatch = 'DOMAIN_MATCH',
  Manual = 'MANUAL',
  Unresolved = 'UNRESOLVED',
}

/** Thread-level triage rollup. */
export enum ThreadTriageVerdict {
  Pending = 'PENDING',
  Qualified = 'QUALIFIED',
  RejectedT0 = 'REJECTED_T0',
  RejectedT1 = 'REJECTED_T1',
}

export enum TicketChannel {
  Agent = 'AGENT',
  Api = 'API',
  IntercomImport = 'INTERCOM_IMPORT',
  Widget = 'WIDGET',
}

export type TicketConnection = {
  __typename?: 'TicketConnection';
  edges: Array<TicketEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TicketEdge = {
  __typename?: 'TicketEdge';
  cursor: Scalars['String']['output'];
  node: SupportTicket;
};

export type TicketEvent = {
  __typename?: 'TicketEvent';
  actor: TicketEventActor;
  createdAt: Scalars['DateTime']['output'];
  /** Dotted event type, e.g. ticket.status_changed — the same string the stream carries. */
  eventType: Scalars['String']['output'];
  field?: Maybe<Scalars['String']['output']>;
  /** Previous value. Strings as is; anything else (tags) JSON-encoded. */
  from?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  messageId?: Maybe<Scalars['ID']['output']>;
  seq: Scalars['Int']['output'];
  /** New value, encoded like `from`. */
  to?: Maybe<Scalars['String']['output']>;
  /** internal or end_user. */
  visibility: Scalars['String']['output'];
};

export type TicketEventActor = {
  __typename?: 'TicketEventActor';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** end_user, agent, ai, system or integration. */
  type: Scalars['String']['output'];
};

/** Newest first. */
export type TicketEventConnection = {
  __typename?: 'TicketEventConnection';
  edges: Array<TicketEventEdge>;
  pageInfo: PageInfo;
};

export type TicketEventEdge = {
  __typename?: 'TicketEventEdge';
  cursor: Scalars['String']['output'];
  node: TicketEvent;
};

export type TicketFilter = {
  /** Agent auth subjects. */
  assigneeUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  organizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Tickets requested by any of these people. */
  requesterIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Tickets whose requester matched any of these support role keys when they opened it. */
  requesterRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Tickets opened from any of these sources. */
  sources?: InputMaybe<Array<Scalars['String']['input']>>;
  statusCategories?: InputMaybe<Array<StatusCategory>>;
  statusKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Tickets carrying any of these tags. */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Tickets assigned to any of these teams. */
  teamIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  typeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  view?: SupportTicketView;
};

export enum TicketPriority {
  High = 'HIGH',
  Low = 'LOW',
  Normal = 'NORMAL',
  Urgent = 'URGENT',
}

export type TicketProgress = {
  __typename?: 'TicketProgress';
  currentKey?: Maybe<Scalars['String']['output']>;
  currentLabel?: Maybe<Scalars['String']['output']>;
  /** An update is held back and goes then, unless the stage moves again first. */
  noticeDueAt?: Maybe<Scalars['DateTime']['output']>;
  reachedAt?: Maybe<Scalars['DateTime']['output']>;
  stages: Array<ProgressStage>;
};

/** How a ticket was closed. Only AI_RESOLVED is billable. */
export enum TicketResolution {
  AgentResolved = 'AGENT_RESOLVED',
  AiResolved = 'AI_RESOLVED',
  AutoClosed = 'AUTO_CLOSED',
  ClosedByRequester = 'CLOSED_BY_REQUESTER',
  Duplicate = 'DUPLICATE',
  WontFix = 'WONT_FIX',
}

export type TicketType = {
  __typename?: 'TicketType';
  aiEnabled: Scalars['Boolean']['output'];
  closedStatusKey: Scalars['String']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  initialStatusKey: Scalars['String']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  retired: Scalars['Boolean']['output'];
  workflowId: Scalars['ID']['output'];
};

export type TicketTypeInput = {
  aiEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** A live closed status. */
  closedStatusKey: Scalars['String']['input'];
  /** An icon name, e.g. "help-circle". */
  icon?: InputMaybe<Scalars['String']['input']>;
  /** Omit to create a type. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** A live status that is not closed. */
  initialStatusKey: Scalars['String']['input'];
  /** Only on create; derived from the name when omitted. */
  key?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  retired?: InputMaybe<Scalars['Boolean']['input']>;
  /** Fixed once the type has tickets. */
  workflowId: Scalars['ID']['input'];
};

export type TicketWorkItems = {
  __typename?: 'TicketWorkItems';
  /** The tracker is connected, so a task can be linked and refreshed. */
  connected: Scalars['Boolean']['output'];
  connectionStatus: ClickUpConnectionStatus;
  /** The list this ticket type’s tasks go to by default, when the tenant set one. */
  defaultListId?: Maybe<Scalars['ID']['output']>;
  links: Array<WorkItemLink>;
  /** ClickUp pushes changes to Revvly, so a linked task is current. When false its status is read every 15 minutes. */
  live: Scalars['Boolean']['output'];
  /** What the client is shown of this work: the stage, and which stages they were told about. */
  progress: TicketProgress;
};

/** What Tier 1 triage has decided, all time. */
export type Tier1Outcomes = {
  __typename?: 'Tier1Outcomes';
  /** Messages Tier 1 decided either way. */
  classified: Scalars['Int']['output'];
  /** Decided not to be, and dropped. */
  dropped: Scalars['Int']['output'];
  /** Decided to be a real client conversation, and kept. */
  kept: Scalars['Int']['output'];
  /** Billed but undecided: the model was unsure or its reply was unreadable, so the message stayed pending. */
  undecided: Scalars['Int']['output'];
};

/** What Tier 2 commitment extraction has produced, all time. */
export type Tier2Outcomes = {
  __typename?: 'Tier2Outcomes';
  /** Clients with an overdue-commitment situation open right now. */
  accountsWithOverdueCommitments: Scalars['Int']['output'];
  /** Dated promises on file. A promise is held only as long as the body it came from, so this can fall as old mail expires. */
  commitments: Scalars['Int']['output'];
  /** Messages Tier 2 has read. */
  messagesRead: Scalars['Int']['output'];
  /** Of those, messages that held at least one dated promise. */
  messagesWithCommitments: Scalars['Int']['output'];
};

export type TransactionImportItem = {
  /** Transaction amount (final total after discounts) */
  amount?: InputMaybe<Scalars['Float']['input']>;
  /** Remaining balance on the invoice after partial payments */
  balance?: InputMaybe<Scalars['Float']['input']>;
  /** Bundle ID to associate with this specific transaction (overrides batch-level bundleId) */
  bundleId?: InputMaybe<Scalars['String']['input']>;
  /** Currency code (default: USD) */
  currency?: InputMaybe<Scalars['String']['input']>;
  /** Invoice description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Total discount applied to the invoice */
  discountAmount?: InputMaybe<Scalars['Float']['input']>;
  /** Payment due date (ISO format) */
  dueDate?: InputMaybe<Scalars['String']['input']>;
  /** Expected payment date (ISO format) */
  estimatedPaymentDate?: InputMaybe<Scalars['String']['input']>;
  /** Invoice date (ISO format) */
  invoiceDate?: InputMaybe<Scalars['String']['input']>;
  /** Invoice number/reference */
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
  /** Invoice prefix to identify the organization (e.g., "INV-ACME-") */
  invoicePrefix?: InputMaybe<Scalars['String']['input']>;
  /** Invoice line items to persist verbatim on the created invoice. When present, the invoice preserves this breakdown instead of collapsing to a single synthetic line. */
  lineItems?: InputMaybe<Array<TransactionLineItemInput>>;
  /** Module IDs to associate with this specific transaction (overrides batch-level moduleIds) */
  moduleIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Additional notes */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Contact email for the organization */
  organizationEmail?: InputMaybe<Scalars['String']['input']>;
  /** Stable external reference for the organization (e.g. a CRM or Stripe customer id). Strongest client-matching signal when provided. */
  organizationExternalId?: InputMaybe<Scalars['String']['input']>;
  /** Organization/Customer name */
  organizationName?: InputMaybe<Scalars['String']['input']>;
  /** Actual payment date (ISO format) */
  paymentDate?: InputMaybe<Scalars['String']['input']>;
  /** Payment status */
  paymentStatus?: InputMaybe<Scalars['String']['input']>;
  /** End date of the billing period (ISO format) */
  periodEndDate?: InputMaybe<Scalars['String']['input']>;
  /** Start date of the billing period (ISO format) */
  periodStartDate?: InputMaybe<Scalars['String']['input']>;
  /** Inferred prior payment amount (total minus balance) */
  previousPaymentAmount?: InputMaybe<Scalars['Float']['input']>;
  /** Region name or ID for the subscription */
  region?: InputMaybe<Scalars['String']['input']>;
};

export type TransactionLineItemInput = {
  /** Line total amount */
  amount?: InputMaybe<Scalars['Float']['input']>;
  /** Line item description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Commercial meaning of the line; derived from the description when absent */
  lineType?: InputMaybe<InvoiceLineType>;
  /** Quantity (defaults to 1) */
  quantity?: InputMaybe<Scalars['Float']['input']>;
  /** Unit price (defaults to line total / quantity) */
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

/** A host this record's own contacts already use that it does not match on yet — the way a client whose website and mail sit on different domains is noticed. Advisory: linking it is a separate, confirmed mutation. */
export type UnlinkedContactDomain = {
  __typename?: 'UnlinkedContactDomain';
  /** How many of this record's contacts use it. */
  contactCount: Scalars['Int']['output'];
  /** The bare host, e.g. acme-group.email. */
  host: Scalars['String']['output'];
  /** One address at that host, as evidence for the operator. */
  sampleEmail: Scalars['String']['output'];
};

export type UnpriceableComponent = {
  __typename?: 'UnpriceableComponent';
  /** Why it could not be priced, verbatim from the pricing resolver. */
  reason: Scalars['String']['output'];
  /** Subscription carrying the component — link the operator here. */
  subscriptionId: Scalars['String']['output'];
  variableComponentId: Scalars['String']['output'];
};

/** What an unreported metered period means for this component: REVIEW (hold the invoice for a human) or ZERO (seal at zero automatically). */
export enum UnreportedUsagePolicy {
  Review = 'REVIEW',
  Zero = 'ZERO',
}

/** What happens to unused committed units at period end */
export enum UnusedUnitBehavior {
  Credit = 'CREDIT',
  Forfeit = 'FORFEIT',
  Rollover = 'ROLLOVER',
}

export type UpdateAgentMemoryInput = {
  id: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};

export type UpdateAutoChargeInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  retryDays?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type UpdateBundleInput = {
  /** Subscription periods available for this bundle */
  availablePeriods?: InputMaybe<Array<SubscriptionPeriod>>;
  description?: InputMaybe<Scalars['String']['input']>;
  featureFlagIds?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['ID']['input'];
  moduleIds?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EntityStatus>;
  tier?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBusinessProfileInput = {
  /** One per entry; null or [] clears them */
  constraints?: InputMaybe<Array<Scalars['String']['input']>>;
  customerSegments?: InputMaybe<Scalars['String']['input']>;
  /** Null or empty clears it */
  focus?: InputMaybe<Scalars['String']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  pricingModel?: InputMaybe<Scalars['String']['input']>;
  /** True when this save takes or rejects the pending suggestion, so it is no longer offered */
  resolveSuggestion?: InputMaybe<Scalars['Boolean']['input']>;
  salesModels?: InputMaybe<Array<SalesModel>>;
  summary?: InputMaybe<Scalars['String']['input']>;
  teamSize?: InputMaybe<TeamSizeRange>;
  valueProposition?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCheckInInputType = {
  confidence?: InputMaybe<Scalars['Int']['input']>;
  /** Null or blank clears it. */
  note?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateCheckinInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  participants?: InputMaybe<CheckinParticipantsInput>;
  questions?: InputMaybe<Array<CheckinQuestionInput>>;
  schedule?: InputMaybe<CheckinScheduleInput>;
  slackChannelId?: InputMaybe<Scalars['String']['input']>;
};

/** Edit a manually logged touch. Omitted fields are left as they are; organizationContactId: null unlinks the contact. */
export type UpdateCrmEmailMessageInput = {
  bodyText?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<CrmEmailDirection>;
  emailSubject?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  /** Must be in the past. */
  occurredAt?: InputMaybe<Scalars['DateTime']['input']>;
  organizationContactId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateCrmEmailTemplateInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  /** Pass empty string to clear. */
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  /** Library documents to attach when the template is applied (at most 5). */
  libraryDocumentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  visibility?: InputMaybe<EmailTemplateVisibility>;
};

export type UpdateCrmLeadInput = {
  billingPeriod?: InputMaybe<SubscriptionPeriod>;
  closeProbability?: InputMaybe<Scalars['Int']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  /** Demo date, entered by hand. Overrides the date derived from a booked meeting; null clears it. */
  demoDate?: InputMaybe<Scalars['DateTime']['input']>;
  estimatedValue?: InputMaybe<Scalars['Float']['input']>;
  /** Expected annual recurring revenue, in the deal currency. */
  expectedArr?: InputMaybe<Scalars['Float']['input']>;
  expectedCloseDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Selected module tier; only meaningful when interestedPlanKind is MODULE. */
  interestedModuleTierId?: InputMaybe<Scalars['ID']['input']>;
  interestedPlanId?: InputMaybe<Scalars['ID']['input']>;
  interestedPlanKind?: InputMaybe<CrmInterestedPlanKind>;
  /** Why the deal was lost. Only accepted when the deal is (or is being moved to) a LOST stage; null clears it. Leaving a LOST stage always clears it. */
  lostReason?: InputMaybe<Scalars['String']['input']>;
  /** Rep responsible for the deal. Null unassigns it. */
  ownerUserId?: InputMaybe<Scalars['ID']['input']>;
  /** Move the deal to this pipeline. The deal lands on `pipelineStageId` when given (it must belong to this pipeline), otherwise on the pipeline's first open stage. */
  pipelineId?: InputMaybe<Scalars['ID']['input']>;
  /** Move the deal to this stage — on its current pipeline, or on `pipelineId` when that is set. */
  pipelineStageId?: InputMaybe<Scalars['ID']['input']>;
  /** Estimated contract length, in billing periods paid upfront (mirrors the PREPAID_TERM billing schedule preset). Two or more; null clears it. */
  prepaidPeriods?: InputMaybe<Scalars['Int']['input']>;
  /** Trial end date, entered by hand; null clears it. */
  trialEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Trial start date, entered by hand; null clears it. */
  trialStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  variableEstimates?: InputMaybe<Array<CrmLeadVariableEstimateInput>>;
};

/** Edit a logged meeting. On a meeting a calendar owns, the time and attendee fields are refused — those are the calendar’s truth; notes, agenda, title, outcome and subject stay editable. */
export type UpdateCrmMeetingInput = {
  agenda?: InputMaybe<Scalars['String']['input']>;
  attendees?: InputMaybe<Array<CrmMeetingAttendeeInput>>;
  conferenceUrl?: InputMaybe<Scalars['String']['input']>;
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  locationDetail?: InputMaybe<Scalars['String']['input']>;
  locationType?: InputMaybe<CrmMeetingLocationType>;
  meetingId: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<CrmMeetingStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCrmNoteInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateCrmPipelineInput = {
  /** Replaces the teams granted access. */
  accessTeamIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Replaces the people granted access. */
  accessUserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Rich-text description, as Markdown. Empty string clears it. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** true makes this the workspace default pipeline. */
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCrmTagInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCustomFieldInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  /** The full list: every existing key must stay. */
  options?: InputMaybe<Array<CustomFieldOptionInput>>;
  /** Omit to leave as is; null shows the field to everyone with CRM again. */
  visibilityRole?: InputMaybe<FunctionRole>;
};

export type UpdateCustomPricingAgreementInput = {
  customBillingTiming?: InputMaybe<BillingTiming>;
  customCommittedQty?: InputMaybe<Scalars['Int']['input']>;
  customCurrency?: InputMaybe<Scalars['String']['input']>;
  customIncludedUnits?: InputMaybe<Scalars['Int']['input']>;
  customModelType?: InputMaybe<PricingModelType>;
  customOveragePrice?: InputMaybe<Scalars['Float']['input']>;
  customProrationCalculation?: InputMaybe<ProrationCalculation>;
  customSteps?: InputMaybe<Array<CustomPricingStepInput>>;
  customTiers?: InputMaybe<Array<CustomPricingTierInput>>;
  customUnitPrice?: InputMaybe<Scalars['Float']['input']>;
  effectiveFrom?: InputMaybe<Scalars['DateTime']['input']>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  overrideScope?: InputMaybe<Array<CustomAgreementOverrideAxis>>;
};

export type UpdateCycleInputType = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ownerUserId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDriveClientFolderSettingsInput = {
  /** Empty string clears it. */
  clientsRootFolderId?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  importFromClientFolders?: InputMaybe<DriveImportMode>;
  inboundEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  invoicesSubfolderMarks?: InputMaybe<Scalars['Boolean']['input']>;
  layout?: InputMaybe<DriveFolderLayout>;
  nameTemplate?: InputMaybe<Scalars['String']['input']>;
  newRecordPolicy?: InputMaybe<DriveNewRecordPolicy>;
  onProspectConverted?: InputMaybe<DriveProspectConvertedPolicy>;
  onProspectConvertedOutsideRoot?: InputMaybe<DriveOutsideFolderPolicy>;
  /** Empty string clears it. */
  prospectsRootFolderId?: InputMaybe<Scalars['String']['input']>;
  sources?: InputMaybe<Array<DriveSyncSource>>;
  subfolderNames?: InputMaybe<Array<DriveSubfolderNameInput>>;
};

export type UpdateEmailSignatureInput = {
  bodyHtml?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Pass null to unbind from a specific address */
  sendingAddress?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEstimatedPaymentDateInput = {
  estimatedPaymentDate: Scalars['String']['input'];
  invoiceId: Scalars['ID']['input'];
};

/** Input for updating tenant external API configuration */
export type UpdateExternalApiConfigInput = {
  /** External API endpoint URL (e.g., https://api.example.com) */
  externalApiEndpoint?: InputMaybe<Scalars['String']['input']>;
  /** External API key for authentication */
  externalApiKey?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFeatureFlagCategoryInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFeatureFlagInput = {
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFormInput = {
  definition?: InputMaybe<FormDefinitionInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateGeoRegionInput = {
  /** The full list; omit to leave as is. */
  countryCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** The full list; omit to leave as is. */
  shapes?: InputMaybe<Array<GeoShapeInput>>;
};

export type UpdateHypothesisInputType = {
  acknowledge?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The revision the edit was made against. Fields someone else changed since then refuse the edit (STALE_WRITE); other fields merge */
  baseRevision?: InputMaybe<Scalars['Int']['input']>;
  confidence?: InputMaybe<Scalars['Int']['input']>;
  decisionRule?: InputMaybe<Scalars['String']['input']>;
  effort?: InputMaybe<Scalars['Float']['input']>;
  estimatedEffect?: InputMaybe<Scalars['Float']['input']>;
  expectedOutcome?: InputMaybe<Scalars['String']['input']>;
  impact?: InputMaybe<Scalars['Float']['input']>;
  ownerUserId?: InputMaybe<Scalars['String']['input']>;
  plannedEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  reach?: InputMaybe<Scalars['Int']['input']>;
  reachUnit?: InputMaybe<Scalars['String']['input']>;
  statement?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateInboxSettingsInput = {
  confidenceThreshold?: InputMaybe<Scalars['Float']['input']>;
  dailyDigest?: InputMaybe<Scalars['Boolean']['input']>;
  digestHour?: InputMaybe<Scalars['Int']['input']>;
  gmailCategoryLabels?: InputMaybe<Scalars['Boolean']['input']>;
  placements?: InputMaybe<Array<InboxCategoryPlacementInput>>;
  replyDrafts?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateIncubatorFlagsPayload = {
  __typename?: 'UpdateIncubatorFlagsPayload';
  incubators?: Maybe<Array<IncubatorSummary>>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  updatedCount: Scalars['Int']['output'];
};

export type UpdateIncubatorInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  customDomain?: InputMaybe<Scalars['String']['input']>;
  defaultLanguage?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  domainUrl?: InputMaybe<Scalars['String']['input']>;
  /** General Email for incubator */
  generalEmail?: InputMaybe<EmailInput>;
  gtmId?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Incubators Plan Information */
  planInfo?: InputMaybe<PlanInfoUpdateInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** Email of Support for incubator. If not provided, could be same as General email */
  supportEmail?: InputMaybe<EmailInput>;
};

export type UpdateInvoiceInput = {
  /** Actual payment date (ISO format) */
  actualPaymentDate?: InputMaybe<Scalars['String']['input']>;
  /** Attachments to add to the invoice */
  attachments?: InputMaybe<Array<InvoiceAttachmentInput>>;
  /** Add a discount to an unpaid invoice, spread over its existing lines. Replaces a discount added earlier; value 0 removes it. */
  discount?: InputMaybe<InvoiceDiscountInput>;
  /** Due date (ISO format) */
  dueDate?: InputMaybe<Scalars['String']['input']>;
  /** Expected payment date (ISO format) */
  estimatedPaymentDate?: InputMaybe<Scalars['String']['input']>;
  /** Invoice date (ISO format) */
  invoiceDate?: InputMaybe<Scalars['String']['input']>;
  invoiceId: Scalars['ID']['input'];
  /** Invoice number/reference */
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
  /** Replace all line items (recalculates total amount) */
  lineItems?: InputMaybe<Array<CreateInvoiceLineItemInput>>;
  /** Notes for the invoice */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Payment status */
  paymentStatus?: InputMaybe<PaymentStatus>;
};

export type UpdateKeyResultInputType = {
  description?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<KeyResultDirection>;
  objectiveId?: InputMaybe<Scalars['ID']['input']>;
  ownerUserId?: InputMaybe<Scalars['String']['input']>;
  /** Recorded with the target change, on a published cycle. */
  targetChangeReason?: InputMaybe<Scalars['String']['input']>;
  targetValue?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<KeyResultUnit>;
};

export type UpdateLibraryDocumentInput = {
  category?: InputMaybe<LibraryDocumentCategory>;
  /** Pass an empty string to clear. */
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateLifecycleStageInput = {
  reason?: InputMaybe<Scalars['String']['input']>;
  /** CLIENT is not settable here. */
  stage: CrmLifecycleStage;
  targetId: Scalars['ID']['input'];
  /** ORGANIZATION or ORGANIZATION_CONTACT. */
  targetType: EntityTargetType;
};

export type UpdateMeterInput = {
  billedValue?: InputMaybe<BilledValue>;
  /** Category or group this variable belongs to (e.g., "capacity", "usage", "custom") */
  category?: InputMaybe<Scalars['String']['input']>;
  /** Description of what this variable represents */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Human-readable name for this variable type */
  displayName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  /** Whether this variable type is currently available for use */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Legacy default measurement preset. Prefer resetBehaviour + billedValue. */
  measurementMode?: InputMaybe<MeasurementMode>;
  resetBehaviour?: InputMaybe<ResetBehaviour>;
  /** URL-safe identifier, unique per tenant */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** Singular unit label shown in UIs and invoices (e.g. "seat", "GB") */
  unitLabel?: InputMaybe<Scalars['String']['input']>;
  /** Plural unit label shown in UIs (e.g. "seats", "GB"); defaults to singular */
  unitLabelPlural?: InputMaybe<Scalars['String']['input']>;
  /** Whether this variable counts whole units or decimal amounts */
  unitType?: InputMaybe<VariableUnitType>;
  /** The variable type identifier (e.g., "user", "storage", "api_calls") */
  variableType?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateModuleInput = {
  /** Subscription periods available for this module */
  availablePeriods?: InputMaybe<Array<SubscriptionPeriod>>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EntityStatus>;
  tiers?: InputMaybe<Array<UpdateModuleTierInput>>;
};

export type UpdateModuleTierInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  /** Incremental feature flags this tier adds over the lower tiers. */
  featureFlagIds?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  /** Rank (0-based). Lower = smaller/cheaper tier; drives cumulative effective flags. */
  order?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<EntityStatus>;
};

export type UpdateObjectiveInputType = {
  description?: InputMaybe<Scalars['String']['input']>;
  ownerUserId?: InputMaybe<Scalars['String']['input']>;
  teamId?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ObjectiveType>;
};

export type UpdateOrganizationContactInput = {
  /** Email address of the contact. Pass null to clear it. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** First name of the contact. Pass null to clear it. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Whether this is the primary contact for the organization */
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  /** Labels for the contact (e.g., billing, owner, champion, technical) */
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Last name of the contact. Pass null to clear it. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Additional notes about the contact */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Phone number of the contact */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** Roles: finance, operations, champion, executive, technical */
  roles?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateOrganizationContractInput = {
  /** Omit to leave the kind unchanged. */
  contractType?: InputMaybe<ContractType>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** What happens to the uninvoiced remainder if the client leaves the committed term early. The default a cancellation inherits, not the answer — the cancel mutation may override it. Omit to leave the contract silent, which makes a cancellation inside a committed term state a policy of its own. */
  earlyTerminationPolicy?: InputMaybe<EarlyTerminationPolicy>;
  id: Scalars['ID']['input'];
  /** Operator-facing name. A contract nobody can identify is noise. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Days of notice required before the term ends. Required with NOTICE_DAYS and refused with any other renewalTerms, where it would read as a rule nothing consults. */
  noticeDays?: InputMaybe<Scalars['Int']['input']>;
  /** Omit to leave the end-of-term posture unchanged. Moving off NOTICE_DAYS drops any stored notice period, which is the point of the change rather than a contradiction. */
  renewalTerms?: InputMaybe<ContractRenewalTerms>;
  signedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** When the committed term begins. Independent of any subscription's startDate — attaching a contract never moves service or invoice dates. */
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Omit to leave the signing status unchanged. */
  status?: InputMaybe<ContractStatus>;
  /** Omit to leave the committed term unchanged; pass NULL to make the contract evergreen, which clears commitmentEndDate on every attached subscription. A new term is refused if it no longer divides into an attached subscription's billing period. */
  termMonths?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateOrganizationInput = {
  billingAddress?: InputMaybe<Scalars['String']['input']>;
  companyNumber?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Primary web domain (CRM dedup key). Normalized to a bare lowercase host; unique per tenant. Null clears it. */
  domain?: InputMaybe<Scalars['String']['input']>;
  /** Further hosts whose addresses belong to this client, beyond the website domain — for a company that serves its site from one host and sends mail from another. Replaces the whole list; an empty list or null unlinks every extra host. Each entry is reduced to a bare lowercase host, and one already claimed by another client is refused. */
  emailDomains?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Your own external reference for this client (unique per tenant). Store the id from your system and address the client by it later. */
  externalId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  incubatorId?: InputMaybe<Scalars['String']['input']>;
  /** Free-text industry / sector (CRM). Null clears it. */
  industry?: InputMaybe<Scalars['String']['input']>;
  /** Prefix for this client's invoice numbers, e.g. "INV-ACME" yields INV-ACME-00042. Must be unique per tenant. Omit it and one is derived from the name (first four letters, uppercased, with a numeric suffix if another client already took that slug). */
  invoicePrefix?: InputMaybe<Scalars['String']['input']>;
  isTrialActive?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  legalStructure?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Sequence number to use on this client's next generated invoice. Set it when onboarding a client that already has invoice history elsewhere (e.g. they are at invoice 14, so pass 15). Consumed on the first generated invoice; numbering continues from there on its own. */
  nextInvoiceNumber?: InputMaybe<Scalars['Int']['input']>;
  /** Payment terms in days for invoices sent to this client. Overrides the tenant default when set; leave unset to inherit. */
  paymentTermsDays?: InputMaybe<Scalars['Int']['input']>;
  /** An existing customer that is only now being added to Revvly. Its first subscription is reported as a renewal rather than a new acquisition — in the MRR movement, the drill-down and the new/renewed-accounts OKR metrics. Changeable later; analytics follow the current value. */
  preExistingCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  /** Region ID where the organization will be located. Must be a valid, active region. */
  regionId?: InputMaybe<Scalars['String']['input']>;
  /** Per-period override of the tenant's renewal-invoice lead time. Each period left unset inherits the tenant default; 0 disables advance invoicing for that period. */
  renewalInvoiceLeadDays?: InputMaybe<RenewalInvoiceLeadDaysInput>;
  /** How this record entered the system (CRM). Null clears it. */
  source?: InputMaybe<LeadSource>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  trialEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  trialStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Default how metered usage reaches Revvly for this client (API or MANUAL). Null inherits the platform default (API). Per-component overrides on a subscription win over this. */
  usageCaptureMode?: InputMaybe<UsageCaptureMode>;
};

export type UpdateOrganizationSubscriptionInput = {
  actualFunnelsPrograms?: InputMaybe<Scalars['Int']['input']>;
  actualManagerLicenses?: InputMaybe<Scalars['Int']['input']>;
  actualNetworkUsers?: InputMaybe<Scalars['Int']['input']>;
  autoRenew?: InputMaybe<Scalars['Boolean']['input']>;
  /** Bundle ID to associate with subscription */
  bundleId?: InputMaybe<Scalars['ID']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Customer-supplied external reference (unique per tenant). Pass an empty string to clear it. */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** Number of days for grace period after expiration */
  gracePeriodDays?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['String']['input'];
  /** How existing invoices are handled when regenerateInvoices cascades a start-date change. Defaults to REBUILD_ALL when regenerateInvoices is true. */
  invoiceRegenerationMode?: InputMaybe<InvoiceRegenerationMode>;
  /** Module IDs to associate with subscription */
  moduleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  period?: InputMaybe<SubscriptionPeriod>;
  /** When the start date changes, cascade the change: recompute endDate and nextRenewalDate anchored on the new start date, and regenerate the invoice series to match. Ignored unless startDate is actually being changed. */
  regenerateInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<SubscriptionStatus>;
};

export type UpdateOutboundWebhookEndpointInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  eventTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Replaces the pipeline list. An empty list means every pipeline. */
  pipelineIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePaymentReminderTemplateInput = {
  body: Scalars['String']['input'];
  kind: PaymentReminderTemplateKind;
  subject: Scalars['String']['input'];
};

export type UpdatePaymentStatusInput = {
  invoiceId: Scalars['ID']['input'];
  newStatus: PaymentStatus;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePipelineStageInput = {
  /** Stage colour key (e.g. gray, blue, teal, green, orange, red). */
  color?: InputMaybe<Scalars['String']['input']>;
  kind?: InputMaybe<PipelineStageKind>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePlatformBillingConfigInput = {
  addOns?: InputMaybe<Array<PlatformBillingAddOnInput>>;
  collectCardAtSignup?: InputMaybe<Scalars['Boolean']['input']>;
  defaultRegionId?: InputMaybe<Scalars['String']['input']>;
  dunning?: InputMaybe<PlatformBillingDunningInput>;
  interimTrialGrant?: InputMaybe<Scalars['Boolean']['input']>;
  plans?: InputMaybe<Array<PlatformBillingPlanInput>>;
  regions?: InputMaybe<Array<PlatformBillingRegionInput>>;
  seatComponentId?: InputMaybe<Scalars['String']['input']>;
  seatMetricSlug?: InputMaybe<Scalars['String']['input']>;
  signupEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  trialDays?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdatePricingRuleInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  regionId?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<PricingScope>;
  subscriptionPeriod?: InputMaybe<SubscriptionPeriod>;
  validFrom?: InputMaybe<Scalars['DateTime']['input']>;
  validTo?: InputMaybe<Scalars['DateTime']['input']>;
  /** Variable limits that define included quantities and pricing for additional units */
  variableLimits?: InputMaybe<Array<VariableLimitInput>>;
};

export type UpdateRecurrenceRuleInput = {
  assigneeUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxOccurrences?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<TaskPriority>;
  recurrence?: InputMaybe<RecurrenceSpecInput>;
};

export type UpdateRegionInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  defaultCurrency?: InputMaybe<Currency>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  supportedCurrencies?: InputMaybe<Array<Currency>>;
};

export type UpdateScoreInputType = {
  /** When given it must still say something. */
  comment?: InputMaybe<Scalars['String']['input']>;
  finalValue?: InputMaybe<Scalars['Float']['input']>;
  keyResultId: Scalars['ID']['input'];
};

export type UpdateTaskInput = {
  /** null clears the anchor. */
  anchor?: InputMaybe<TaskAnchorInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** null clears; a set value must be today or later. */
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<TaskPriority>;
  /** null clears the relation. */
  relation?: InputMaybe<TaskRelationInput>;
  remindAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateTaxRateInput = {
  compound?: InputMaybe<Scalars['Boolean']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  displayLabel?: InputMaybe<Scalars['String']['input']>;
  effectiveFrom?: InputMaybe<Scalars['DateTime']['input']>;
  effectiveTo?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  ratePct?: InputMaybe<Scalars['String']['input']>;
  registrationId?: InputMaybe<Scalars['ID']['input']>;
  replacesCountryRates?: InputMaybe<Scalars['Boolean']['input']>;
  sequence?: InputMaybe<Scalars['Int']['input']>;
  subdivisionCode?: InputMaybe<Scalars['String']['input']>;
  taxCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  taxCode?: InputMaybe<Scalars['String']['input']>;
  taxType?: InputMaybe<TaxType>;
  treatment?: InputMaybe<TaxTreatment>;
};

export type UpdateTaxRegistrationInput = {
  effectiveFrom?: InputMaybe<Scalars['DateTime']['input']>;
  effectiveTo?: InputMaybe<Scalars['DateTime']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTaxSettingsInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  exemptLegend?: InputMaybe<Scalars['String']['input']>;
  reverseChargeEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  reverseChargeLegend?: InputMaybe<Scalars['String']['input']>;
  showTaxIdsOnInvoice?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Rename a team or change its lead */
export type UpdateTeamInput = {
  /** Team id */
  id: Scalars['ID']['input'];
  /** New lead. Pass an empty string to clear it; omit the field to leave the lead unchanged */
  leadUserId?: InputMaybe<Scalars['String']['input']>;
  /** New name */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Input for one region + currency's banking details */
export type UpdateTenantBankingDetailInput = {
  /** Account holder / beneficiary name */
  accountName?: InputMaybe<Scalars['String']['input']>;
  /** Domestic account number */
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  /** Which identifier scheme this account uses (IBAN, SWIFT/BIC, or routing/sort code) */
  accountType?: InputMaybe<BankAccountType>;
  /** Bank's postal address */
  bankAddress?: InputMaybe<Scalars['String']['input']>;
  /** Bank name */
  bankName?: InputMaybe<Scalars['String']['input']>;
  /** Bank branch code */
  branchCode?: InputMaybe<Scalars['String']['input']>;
  /** ISO 4217 currency code this account is denominated in */
  currency: Scalars['String']['input'];
  /** IBAN, for SEPA / international transfers */
  iban?: InputMaybe<Scalars['String']['input']>;
  /** Region this account applies to. Omit for a region-agnostic default used for any region without a region-specific entry for the currency. */
  regionId?: InputMaybe<Scalars['ID']['input']>;
  /** Routing / sort code / ABA number */
  routingNumber?: InputMaybe<Scalars['String']['input']>;
  /** SWIFT / BIC code */
  swiftBic?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating tenant core settings */
export type UpdateTenantCoreSettingsInput = {
  /** Whether automated emails (e.g. scheduled payment reminders) are sent automatically for this tenant. When false, automatic sends are suppressed and the operator sends emails manually instead. */
  autoSendEmails?: InputMaybe<Scalars['Boolean']['input']>;
  /** Days after a subscription ends within which a new subscription for the same organisation is treated as a renewal rather than a churn */
  churnGracePeriodDays?: InputMaybe<Scalars['Int']['input']>;
  /** Default number of days a deferred-activation subscription may wait to go live before the daily sweep raises it with the tenant */
  defaultActivationGapDays?: InputMaybe<Scalars['Int']['input']>;
  /** Default commitment posture for prepaid-term billing schedules when the operator does not choose one. BINDING serves the span out, REFUNDABLE credits the unconsumed whole periods back on cancellation, NONE is standard cancellation. */
  defaultCommitment?: InputMaybe<BillingCommitment>;
  /** Default payment terms in days for new invoices (0 = due on receipt) */
  defaultPaymentTermsDays?: InputMaybe<Scalars['Int']['input']>;
  /** Days after a subscription ends beyond which a returning customer is classified as a reactivation rather than a renewal. Must be >= churn grace. */
  reactivationWindowDays?: InputMaybe<Scalars['Int']['input']>;
  /** Per-period default lead time (days) for generating renewal invoices ahead of the renewal date. Only the periods provided are updated; 0 disables advance invoicing for that period. */
  renewalInvoiceLeadDays?: InputMaybe<RenewalInvoiceLeadDaysInput>;
  /** Currency used for consolidated ARR/MRR reporting */
  reportingCurrency?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTenantInput = {
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** External API endpoint URL */
  externalApiEndpoint?: InputMaybe<Scalars['String']['input']>;
  /** External API key for authentication */
  externalApiKey?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating the tenant invoice header (issuer details) */
export type UpdateTenantInvoiceHeaderInput = {
  /** First address line (street) */
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  /** Second address line (suite, unit, etc.) */
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  /** City / town */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Legal/display company name shown as the invoice issuer */
  companyName?: InputMaybe<Scalars['String']['input']>;
  /** Country */
  country?: InputMaybe<Scalars['String']['input']>;
  /** Billing contact email shown in the header */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Publicly reachable URL of the logo image embedded on the invoice */
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  /** Billing contact phone shown in the header */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** Postal / ZIP code */
  postalCode?: InputMaybe<Scalars['String']['input']>;
  /** Company registration / incorporation number */
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  /** State / province / region */
  state?: InputMaybe<Scalars['String']['input']>;
  /** Tax / VAT registration number */
  taxId?: InputMaybe<Scalars['String']['input']>;
  /** Label for the tax identifier (e.g. "VAT", "EIN"). Defaults to "Tax ID". */
  taxLabel?: InputMaybe<Scalars['String']['input']>;
  /** Company website shown in the header */
  website?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating the tenant's payment information */
export type UpdateTenantPaymentInfoInput = {
  /** Full replacement list of banking details, one entry per region + currency */
  bankingDetails?: InputMaybe<Array<UpdateTenantBankingDetailInput>>;
  /** Free-form payment instructions rendered on every invoice */
  paymentInstructions?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTenantUserInput = {
  id: Scalars['ID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};

/** Omitted fields are left as they are. Closing goes through closeTicket. */
export type UpdateTicketInput = {
  priority?: InputMaybe<TicketPriority>;
  statusKey?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Empty string clears the title. */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Move to another type. The status carries over to the new type's workflow by key, else by category; send statusKey to pick it. */
  typeId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateVariableComponentInput = {
  appliesTo?: InputMaybe<PromotionalAppliesTo>;
  applyTo?: InputMaybe<CommissionApplyTo>;
  /** Billing terms this component is offered on. */
  availablePeriods?: InputMaybe<Array<SubscriptionPeriod>>;
  basePricingRuleId?: InputMaybe<Scalars['ID']['input']>;
  billedValue?: InputMaybe<BilledValue>;
  billingTiming?: InputMaybe<BillingTiming>;
  committedQuantity?: InputMaybe<Scalars['Int']['input']>;
  discountType?: InputMaybe<PromotionalDiscountType>;
  discountValue?: InputMaybe<Scalars['Float']['input']>;
  durationPeriods?: InputMaybe<Scalars['Int']['input']>;
  freeAllowance?: InputMaybe<Scalars['Int']['input']>;
  hardCap?: InputMaybe<Scalars['Boolean']['input']>;
  includedUnits?: InputMaybe<Scalars['Int']['input']>;
  invoicePresentation?: InputMaybe<InvoicePresentationInput>;
  limitPeriod?: InputMaybe<LimitPeriodInput>;
  /** Legacy preset. Prefer resetBehaviour + billedValue when updating measurement. */
  measurementMode?: InputMaybe<MeasurementMode>;
  modelType?: InputMaybe<PricingModelType>;
  /** Operator-facing display name for this component */
  name?: InputMaybe<Scalars['String']['input']>;
  percentageRate?: InputMaybe<Scalars['Float']['input']>;
  promotionStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  prorationCalculation?: InputMaybe<ProrationCalculation>;
  resetBehaviour?: InputMaybe<ResetBehaviour>;
  startTrigger?: InputMaybe<PromotionalStartTrigger>;
  steps?: InputMaybe<Array<PricingStepInput>>;
  tiers?: InputMaybe<Array<PricingTierInput>>;
  unit?: InputMaybe<Scalars['String']['input']>;
  unitPlural?: InputMaybe<Scalars['String']['input']>;
  /** What an unreported metered period means here: REVIEW holds the invoice for a human (default), ZERO seals at zero automatically. */
  unreportedUsagePolicy?: InputMaybe<UnreportedUsagePolicy>;
  unusedUnitBehavior?: InputMaybe<UnusedUnitBehavior>;
};

/** Input for updating the tenant working calendar */
export type UpdateWorkingCalendarInput = {
  /** IANA timezone (e.g. Europe/Brussels). Omit to keep the tenant timezone. */
  timezone?: InputMaybe<Scalars['String']['input']>;
  /** ISO weekdays the tenant works (1 = Monday … 7 = Sunday). At least one, no duplicates. */
  workingDays: Array<Scalars['Int']['input']>;
};

/** Input for uploading a tenant invoice-header logo */
export type UploadInvoiceLogoInput = {
  /** Base64-encoded image data (raw or a data: URL). PNG or JPEG. */
  data: Scalars['String']['input'];
};

export type UpsertClientEmailDraftInput = {
  attachmentFileIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  bcc?: InputMaybe<Array<EmailRecipientInput>>;
  body?: InputMaybe<Scalars['String']['input']>;
  cc?: InputMaybe<Array<EmailRecipientInput>>;
  /** Message-ID of an existing DRAFT to update. */
  draftId?: InputMaybe<Scalars['String']['input']>;
  includeSignature?: InputMaybe<Scalars['Boolean']['input']>;
  libraryLinks?: InputMaybe<Array<LibraryLinkInput>>;
  organizationId: Scalars['ID']['input'];
  signatureId?: InputMaybe<Scalars['ID']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  threadId?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Array<EmailRecipientInput>>;
};

export type UpsertCustomerTaxProfileInput = {
  billingCountry: Scalars['String']['input'];
  billingSubdivision?: InputMaybe<Scalars['String']['input']>;
  exempt?: InputMaybe<TaxExemptionInput>;
  isBusiness: Scalars['Boolean']['input'];
  organizationId: Scalars['ID']['input'];
  reverseChargeEligible?: InputMaybe<Scalars['Boolean']['input']>;
  taxIds?: InputMaybe<Array<CustomerTaxIdInput>>;
};

export type UpsertDiscountDefinitionInput = {
  /** Required when durationType = FIXED_COUNT. */
  durationCount?: InputMaybe<Scalars['Int']['input']>;
  durationType: DiscountDurationType;
  /** Fixed value per currency — FIXED type only (§8.3). */
  fixedValueByCurrency?: InputMaybe<Array<DiscountCurrencyValueInput>>;
  /** Unique per tenant. */
  name: Scalars['String']['input'];
  /** Currency-agnostic percentage — PERCENTAGE type only. Non-negative. */
  percentageValue?: InputMaybe<Scalars['Float']['input']>;
  type: DiscountType;
};

/** Type of action recorded in a usage audit entry */
export enum UsageAuditAction {
  CommissionEvent = 'COMMISSION_EVENT',
  Decrement = 'DECREMENT',
  Increment = 'INCREMENT',
  Override = 'OVERRIDE',
  PeriodReset = 'PERIOD_RESET',
  Reset = 'RESET',
  Rollback = 'ROLLBACK',
  Set = 'SET',
}

export type UsageAuditFilterInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  since?: InputMaybe<Scalars['DateTime']['input']>;
  subscriptionId: Scalars['ID']['input'];
  until?: InputMaybe<Scalars['DateTime']['input']>;
  variableId: Scalars['ID']['input'];
};

/** How a metered quantity reaches Revvly: API (integration increments it) or MANUAL (an operator enters it). */
export enum UsageCaptureMode {
  Api = 'API',
  Manual = 'MANUAL',
}

/** What an open usage reading asks of an operator: NEEDS_ENTRY (manual entry due), INTEGRATION_FAULT (unverified API period), AWAITING_SEAL (self-resolving), UNREPORTED (nothing ever reported — suspect capture-mode configuration), RESOLVED (settled). */
export enum UsageEntryDisposition {
  AwaitingSeal = 'AWAITING_SEAL',
  IntegrationFault = 'INTEGRATION_FAULT',
  NeedsEntry = 'NEEDS_ENTRY',
  Resolved = 'RESOLVED',
  Unreported = 'UNREPORTED',
}

export type UsagePeriodCloseResult = {
  __typename?: 'UsagePeriodCloseResult';
  alreadyClosed: Scalars['Int']['output'];
  closed: Scalars['Int']['output'];
  failed: Scalars['Int']['output'];
};

/** Live projection details for a usage row — what the period would bill right now, with the inclusion and unit rate that produced it. */
export type UsageProjection = {
  __typename?: 'UsageProjection';
  billedQuantity: Scalars['Float']['output'];
  confidence: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  freeAllowanceApplied: Scalars['Float']['output'];
  /** Total unit inclusion (component + plan refs). Billing starts above this. */
  inclusionLimit: Scalars['Float']['output'];
  subtotal: Scalars['Float']['output'];
  totalCharged: Scalars['Float']['output'];
  unitPriceApplied: Scalars['Float']['output'];
};

export type UsageReading = {
  __typename?: 'UsageReading';
  actualSource?: Maybe<UsageReadingSource>;
  /** True when this sealed, unsuperseded reading may still be corrected (no invoice, or linked invoice is still DRAFT). */
  correctable: Scalars['Boolean']['output'];
  /** Reason recorded on a correction replacement reading. */
  correctionReason?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** What this reading asks of an operator. Derived from status + capture mode + what arrived — read this rather than inferring work from `status`, which is AWAITING for every reading during the seal delay whether or not anyone must act. */
  disposition: UsageEntryDisposition;
  expectedSource: UsageCaptureMode;
  /** Why an operator held this reading for review instead of letting it seal. */
  heldReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  incrementCount: Scalars['Int']['output'];
  invoiceId?: Maybe<Scalars['ID']['output']>;
  measurementMode: MeasurementMode;
  netGmv?: Maybe<Scalars['Float']['output']>;
  organizationId: Scalars['ID']['output'];
  periodEnd: Scalars['DateTime']['output'];
  periodStart: Scalars['DateTime']['output'];
  /** VariableComponentPrice document pinned at seal (plan item 19). */
  pinnedPriceId?: Maybe<Scalars['ID']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  sealDueAt?: Maybe<Scalars['DateTime']['output']>;
  sealedAt?: Maybe<Scalars['DateTime']['output']>;
  sealedBy?: Maybe<Scalars['String']['output']>;
  status: UsageReadingStatus;
  subscriptionId: Scalars['ID']['output'];
  /** Replacement reading when this one was corrected. */
  supersededBy?: Maybe<Scalars['ID']['output']>;
  /** Prior reading this one supersedes (correction history). */
  supersededFrom?: Maybe<Scalars['ID']['output']>;
  transactionCount?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  variableComponentId: Scalars['ID']['output'];
  variableId: Scalars['ID']['output'];
  waivedReason?: Maybe<Scalars['String']['output']>;
  /** True while this reading is about to bill zero usage and can still be changed: an API meter counted per period that closed at zero, still waiting to seal. An operator can enter a figure, or hold it for review so the invoice waits. */
  zeroUsagePending: Scalars['Boolean']['output'];
};

export type UsageReadingFilterInput = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  /** Limit to these statuses (default: AWAITING + UNVERIFIED). */
  status?: InputMaybe<Array<UsageReadingStatus>>;
  subscriptionId?: InputMaybe<Scalars['ID']['input']>;
};

/** Where a sealed reading’s quantity actually came from. */
export enum UsageReadingSource {
  Api = 'API',
  Manual = 'MANUAL',
  Override = 'OVERRIDE',
  ZeroDefault = 'ZERO_DEFAULT',
}

/** Lifecycle of a metered usage reading. Only SEALED and WAIVED allow the invoice to be issued. */
export enum UsageReadingStatus {
  Accumulating = 'ACCUMULATING',
  Awaiting = 'AWAITING',
  Sealed = 'SEALED',
  Unverified = 'UNVERIFIED',
  Waived = 'WAIVED',
}

export type UsageSealResult = {
  __typename?: 'UsageSealResult';
  /** 1 if retryReleasedDrafts threw after a successful seal; 0 if retry completed (including per-draft holds). */
  draftRetryFailed: Scalars['Int']['output'];
  failed: Scalars['Int']['output'];
  sealed: Scalars['Int']['output'];
  skipped: Scalars['Int']['output'];
  unverified: Scalars['Int']['output'];
};

/** Surface a usage mutation arrived through */
export enum UsageSource {
  Graphql = 'GRAPHQL',
  Internal = 'INTERNAL',
  Rest = 'REST',
  Webhook = 'WEBHOOK',
}

/** Actor that triggered a usage mutation */
export enum UsageTriggeredBy {
  AiAgent = 'AI_AGENT',
  Api = 'API',
  EndCustomer = 'END_CUSTOMER',
  System = 'SYSTEM',
  TenantUser = 'TENANT_USER',
  Webhook = 'WEBHOOK',
}

/** User profile managed by the embedded auth system */
export type User = {
  __typename?: 'User';
  /** Auth provider user ID (sub claim from JWT) */
  authId: Scalars['String']['output'];
  /** When the user was created */
  createdAt: Scalars['DateTime']['output'];
  /** User email address */
  email: Scalars['String']['output'];
  /** First name */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Default calendar days until a follow-up task created from an outbound email is due. The composer uses this as the default and can override or skip the task per send. */
  followUpTaskDefaultDays: Scalars['Int']['output'];
  /** MongoDB ObjectId */
  id: Scalars['ID']['output'];
  /** Whether the user is active */
  isActive: Scalars['Boolean']['output'];
  /** Last name */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Full display name */
  name?: Maybe<Scalars['String']['output']>;
  /** Profile picture URL */
  picture?: Maybe<Scalars['String']['output']>;
  /** IANA timezone name (e.g. Europe/Brussels). Scheduled prompts fire at the recipient's local hour; null falls back to the tenant's timezone. */
  timezone?: Maybe<Scalars['String']['output']>;
  /** When the user was last updated */
  updatedAt: Scalars['DateTime']['output'];
  /** Username */
  username?: Maybe<Scalars['String']['output']>;
  /** Last-used UI views for this user. One entry per surface (conversation, tasks, …); the same preference applies to every page of that surface. */
  viewPreferences: Array<ViewPreference>;
};

export enum UserRoles {
  Admin = 'Admin',
  AdminCoach = 'AdminCoach',
  Coach = 'Coach',
  Cofounder = 'Cofounder',
  CommunityMember = 'CommunityMember',
  Evaluator = 'Evaluator',
  Expert = 'Expert',
  Mentor = 'Mentor',
  Staff = 'Staff',
  SubAdmin = 'SubAdmin',
}

export type UserSignature = {
  __typename?: 'UserSignature';
  createdAt: Scalars['DateTime']['output'];
  /** The signature as a data: URL, for previewing. */
  dataUrl: Scalars['String']['output'];
  height: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  kind: UserSignatureKind;
  name: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

/** How a saved signature was made: drawn, typed or uploaded as an image. */
export enum UserSignatureKind {
  Drawn = 'DRAWN',
  Image = 'IMAGE',
  Typed = 'TYPED',
}

export enum UserStatuses {
  Active = 'Active',
  Archived = 'Archived',
  Deleted = 'Deleted',
  Deny = 'Deny',
  Pending = 'Pending',
  Unactive = 'Unactive',
}

export type UserTenant = {
  __typename?: 'UserTenant';
  createdAt: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invitationAcceptedAt?: Maybe<Scalars['DateTime']['output']>;
  invitedAt?: Maybe<Scalars['DateTime']['output']>;
  invitedBy?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  lastAccessedAt?: Maybe<Scalars['DateTime']['output']>;
  permissions: Array<Scalars['String']['output']>;
  role: Scalars['String']['output'];
  tenant?: Maybe<Tenant>;
  tenantId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  /** User profile from auth provider */
  user?: Maybe<User>;
  userId: Scalars['String']['output'];
};

export type VariableChargePreviewLine = {
  __typename?: 'VariableChargePreviewLine';
  billingTiming: BillingTiming;
  breakdown: Scalars['String']['output'];
  componentId: Scalars['ID']['output'];
  currency: Scalars['String']['output'];
  fee: Scalars['Float']['output'];
  includedQuantity: Scalars['Float']['output'];
  modelType: PricingModelType;
  overageUnits: Scalars['Float']['output'];
  priced: Scalars['Boolean']['output'];
  startingCount: Scalars['Float']['output'];
  unit: Scalars['String']['output'];
  unitPlural: Scalars['String']['output'];
  unitPrice: Scalars['Float']['output'];
};

/** A single Variable Component pricing configuration (v4 §3). One of three peer sellable-unit types alongside Module and Bundle. Monetary values live on VariableComponentPrice and resolve at billing time via the SUBSCRIPTION → BUNDLE → MODULE → GLOBAL_DEFAULT chain. */
export type VariableComponent = {
  __typename?: 'VariableComponent';
  aiAssisted: Scalars['Boolean']['output'];
  /** Full history across all versions in the chain, newest first. */
  allVersionsSummary: Array<VariableComponentVersionSummary>;
  appliesTo?: Maybe<PromotionalAppliesTo>;
  applyTo?: Maybe<CommissionApplyTo>;
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  archivedBy?: Maybe<Scalars['ID']['output']>;
  /** Billing terms this component is offered on. Mirrors Module/Bundle availablePeriods — the pricing surface only exposes (and the resolver only serves) prices for these terms. */
  availablePeriods: Array<SubscriptionPeriod>;
  basePricingRuleId?: Maybe<Scalars['ID']['output']>;
  /** Which number in the period is rated: MAX, TOTAL or CLOSING. Null until migration 0028 has run — resolve via measurement-axis.util. */
  billedValue?: Maybe<BilledValue>;
  billingTiming: BillingTiming;
  committedQuantity?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  /** Original chat prompt or template name when chat/template-authored */
  creationRationale?: Maybe<Scalars['String']['output']>;
  disambiguationLog: Array<DisambiguationLogEntry>;
  discountType?: Maybe<PromotionalDiscountType>;
  discountValue?: Maybe<Scalars['Float']['output']>;
  durationPeriods?: Maybe<Scalars['Int']['output']>;
  /** When this version took effect. A version runs until the next one in its lineage begins, so there is no stored end date. Null on a draft that has never published. */
  effectiveFrom?: Maybe<Scalars['DateTime']['output']>;
  /** Free units per limit period before any charge applies */
  freeAllowance?: Maybe<Scalars['Int']['output']>;
  /** Reject mutations that would exceed committedQuantity */
  hardCap: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  includedUnits?: Maybe<Scalars['Int']['output']>;
  /** Customer-facing invoice rendering options (presentational only). */
  invoicePresentation: InvoicePresentation;
  limitPeriod: LimitPeriod;
  /** Stable identity shared by every version in this chain (the id of its root version). Group by this to address one plan rather than one version of it. */
  lineageId?: Maybe<Scalars['ID']['output']>;
  measurementMode: MeasurementMode;
  modelType: PricingModelType;
  /** Operator-facing display name, independent of the bound Meter's displayName */
  name?: Maybe<Scalars['String']['output']>;
  /** For COMMISSION: e.g. 0.05 = 5% */
  percentageRate?: Maybe<Scalars['Float']['output']>;
  /** The version this one was branched from (newest → oldest chain). */
  previousVersionId?: Maybe<Scalars['ID']['output']>;
  promotionStartDate?: Maybe<Scalars['DateTime']['output']>;
  prorationCalculation: ProrationCalculation;
  publishPath?: Maybe<PublishPath>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  publishedBy?: Maybe<Scalars['ID']['output']>;
  /** Resets each period (PER_PERIOD) or carries forward (STANDING). Null until migration 0028 has run — resolve via measurement-axis.util. */
  resetBehaviour?: Maybe<ResetBehaviour>;
  startTrigger?: Maybe<PromotionalStartTrigger>;
  status: VariableComponentStatus;
  steps?: Maybe<Array<PricingStep>>;
  supersededBy?: Maybe<Scalars['ID']['output']>;
  tiers?: Maybe<Array<PricingTier>>;
  unit: Scalars['String']['output'];
  unitPlural: Scalars['String']['output'];
  /** What an unreported metered period means here: REVIEW holds the invoice for a human (default), ZERO seals at zero automatically. */
  unreportedUsagePolicy?: Maybe<UnreportedUsagePolicy>;
  unusedUnitBehavior?: Maybe<UnusedUnitBehavior>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
  variable?: Maybe<Meter>;
  /** Variable definition this component prices */
  variableId: Scalars['ID']['output'];
  version: Scalars['Int']['output'];
  /** Append-only publish log for this document. */
  versionHistory: Array<VariableComponentVersionEntry>;
};

export type VariableComponentFilterInput = {
  /** When true, collapse the version chain to a single row per `variableId`: only the highest-version PUBLISHED component is returned (drafts, archived, and superseded versions are excluded). This matches what the billing engine resolves, so attach/select pickers should pass `latestPublishedOnly: true`. */
  latestPublishedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter to components referenced (via variableComponentRefs) by this Module or Bundle. */
  linkedTo?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<VariableComponentStatus>;
  variableId?: InputMaybe<Scalars['ID']['input']>;
};

/** Aggregate variable-pricing metrics for a tenant — drives the catalog list KPI strip. */
export type VariableComponentMetrics = {
  __typename?: 'VariableComponentMetrics';
  /** Count of PUBLISHED variable components in the catalog. */
  activeComponents: Scalars['Int']['output'];
  /** Average take rate across COMMISSION components — commission revenue ÷ GMV. Returns 0 when no GMV. */
  avgTakeRate: Scalars['Float']['output'];
  /** Count of PUBLISHED components grouped by pricing model type. */
  componentCountByModel: Array<ModelTypeCount>;
  /** Count of PUBLISHED components grouped by the Variable they bind to — the "used by N components" reverse-reference for the Variables catalog surface. */
  componentCountByVariable: Array<VariableIdCount>;
  /** ISO 4217 currency code for monetary fields above. */
  currency: Scalars['String']['output'];
  /** GMV processed in the trailing window across all COMMISSION-priced components (sum of cumulativeGmvBilling). */
  gmvProcessed: Scalars['Float']['output'];
  /** Variable Monthly Recurring Revenue — sum of committed MRR across all variable components on active subscriptions, normalized monthly. */
  variableMrr: Scalars['Float']['output'];
};

/** Scoped pricing record for a Variable Component (Schema Reference v4 §3). One per (component, version, scope, scopeId, scopeVersion). */
export type VariableComponentPrice = {
  __typename?: 'VariableComponentPrice';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  archivedBy?: Maybe<Scalars['ID']['output']>;
  /** Variable Component this price applies to. */
  componentId: Scalars['ID']['output'];
  /** Pinned (PUBLISHED) component version. */
  componentVersion: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** SUBSCRIPTION scope only: when this override took effect (PRD §7.2). */
  effectiveMode?: Maybe<PriceEffectiveMode>;
  id: Scalars['ID']['output'];
  /** SUBSCRIPTION scope only: catalog list rate snapshot at the moment of the last override (PRD §7.4), in the subscription's locked currency. Reference only — never billed. */
  listValueAtOverride?: Maybe<Scalars['Decimal']['output']>;
  /** Per-currency monetary variants. At least one entry required. */
  pricesByCurrency: Array<PricingVariant>;
  /** Per-term overrides (reusable scopes only). When the subscription term matches an entry, it wins over pricesByCurrency; otherwise pricesByCurrency applies to all terms. */
  pricesByPeriod?: Maybe<Array<PeriodPrice>>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  publishedBy?: Maybe<Scalars['ID']['output']>;
  /** Optional market (Region id). null = region-agnostic default for the scope. A specific region lets the same currency price differently per market; resolution prefers the region-specific price, then falls back to the region-agnostic one at the same scope. */
  regionId?: Maybe<Scalars['ID']['output']>;
  scope: VariableComponentPriceScope;
  /** null for GLOBAL_DEFAULT. moduleId/bundleId/subscriptionId for the other scopes. */
  scopeId?: Maybe<Scalars['ID']['output']>;
  /** null for GLOBAL_DEFAULT and SUBSCRIPTION. Pinned Module/Bundle version otherwise. */
  scopeVersion?: Maybe<Scalars['Int']['output']>;
  status: VariableComponentStatus;
  updatedAt: Scalars['DateTime']['output'];
};

/** Where a Variable Component Price applies. Resolution at billing time is most-specific-wins: SUBSCRIPTION > BUNDLE > MODULE > GLOBAL_DEFAULT. */
export enum VariableComponentPriceScope {
  Bundle = 'BUNDLE',
  GlobalDefault = 'GLOBAL_DEFAULT',
  Module = 'MODULE',
  Subscription = 'SUBSCRIPTION',
}

export type VariableComponentStats = {
  __typename?: 'VariableComponentStats';
  archived: Scalars['Int']['output'];
  draft: Scalars['Int']['output'];
  published: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

/** Lifecycle state of a Variable Component (DRAFT → PUBLISHED → ARCHIVED) */
export enum VariableComponentStatus {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
}

export type VariableComponentVersionEntry = {
  __typename?: 'VariableComponentVersionEntry';
  changedAt: Scalars['DateTime']['output'];
  changedBy?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  version: Scalars['Int']['output'];
};

/** Published-version summary used in cross-version history chains. */
export type VariableComponentVersionSummary = {
  __typename?: 'VariableComponentVersionSummary';
  /** Differences against the version this one was branched from. */
  changes: Array<VersionChange>;
  /** When this version took effect — the start of its window. The lineage is ordered by THIS, not by publishedAt (when the document was written down) and not by version number. A version's window runs until the next one begins. */
  effectiveFrom?: Maybe<Scalars['DateTime']['output']>;
  /** This version's own document id. Each version is a separate document, so this is what a caller pins or migrates onto — the version NUMBER is not addressable on its own. */
  id?: Maybe<Scalars['ID']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  publishedBy?: Maybe<Scalars['String']['output']>;
  /** DRAFT / PUBLISHED / ARCHIVED. Read this rather than inferring from the version number: numbering is immutable mint order, so a retro-authored version holds the highest number in its lineage while being archived and first in time. */
  status?: Maybe<Scalars['String']['output']>;
  version: Scalars['Int']['output'];
  versionHistory: Array<VariableComponentVersionEntry>;
};

/** Count of PUBLISHED components bound to a given Variable (catalog reverse-reference). */
export type VariableIdCount = {
  __typename?: 'VariableIdCount';
  count: Scalars['Int']['output'];
  variableId: Scalars['ID']['output'];
};

/** Defines variable quantity limits and pricing for bundles and modules. Each limit specifies how many units of a variable type (like users, funnels, storage) are included in the base price and the cost for additional units. */
export type VariableLimit = {
  __typename?: 'VariableLimit';
  /** Number of units included in the base price (e.g., 5 users included) */
  includedQuantity: Scalars['Int']['output'];
  /** Optional notes about this variable limit configuration */
  notes?: Maybe<Scalars['String']['output']>;
  /** Price per additional unit beyond the included quantity */
  pricePerAdditional: Scalars['Float']['output'];
  /** Unit of measurement (e.g., "per user", "per GB", "per funnel") */
  unit?: Maybe<Scalars['String']['output']>;
  /** The ID of the variable this limit applies to */
  variableId: Scalars['ID']['output'];
  /** The type of variable this limit applies to (e.g., "user", "funnel", "storage") */
  variableType: Scalars['String']['output'];
};

export type VariableLimitInput = {
  /** How many are included in the base price */
  includedQuantity?: Scalars['Int']['input'];
  /** Optional notes about this variable limit */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Price per unit above included quantity */
  pricePerAdditional?: Scalars['Float']['input'];
  /** Unit of measurement (e.g., "per user", "per GB", "per funnel") */
  unit?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the variable this limit applies to */
  variableId: Scalars['ID']['input'];
};

/** Whether the variable is counted in whole units or decimal */
export enum VariableUnitType {
  Decimal = 'DECIMAL',
  Integer = 'INTEGER',
}

export type VariableUsageAudit = {
  __typename?: 'VariableUsageAudit';
  action: UsageAuditAction;
  commissionCalculated?: Maybe<Scalars['Decimal']['output']>;
  createdAt: Scalars['DateTime']['output'];
  delta?: Maybe<Scalars['Float']['output']>;
  editPath: EditPath;
  eventId?: Maybe<Scalars['String']['output']>;
  /** Whether the action was performed via an API key */
  hasApiKey?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  idempotencyKey: Scalars['String']['output'];
  newCount: Scalars['Float']['output'];
  newPeak: Scalars['Float']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  previousCount: Scalars['Float']['output'];
  previousPeak: Scalars['Float']['output'];
  saleAmount?: Maybe<Scalars['Decimal']['output']>;
  source: UsageSource;
  subscriptionId: Scalars['ID']['output'];
  tenantId: Scalars['ID']['output'];
  transactionId?: Maybe<Scalars['String']['output']>;
  triggeredBy: UsageTriggeredBy;
  triggeredById?: Maybe<Scalars['ID']['output']>;
  variableId: Scalars['ID']['output'];
};

/** One human-readable difference between a catalog version and the version it was branched from. */
export type VersionChange = {
  __typename?: 'VersionChange';
  description: Scalars['String']['output'];
  /** Logical field the change belongs to (name, modules, tiers, featureFlags, …). */
  field: Scalars['String']['output'];
};

/** Last-used UI view for a single surface */
export type ViewPreference = {
  __typename?: 'ViewPreference';
  /** Surface id, e.g. conversation or tasks */
  key: Scalars['String']['output'];
  /** Last-used view id for that surface */
  value: Scalars['String']['output'];
};

export type WaiveUsageReadingInput = {
  readingId: Scalars['ID']['input'];
  /** Required reason recorded on the reading and audit trail. */
  reason: Scalars['String']['input'];
};

export type WebhookDelivery = {
  __typename?: 'WebhookDelivery';
  attempts: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  deliveredAt?: Maybe<Scalars['DateTime']['output']>;
  endpointId: Scalars['ID']['output'];
  /** The event id the receiver sees in Revvly-Event-Id. Dedupe on it. */
  eventId: Scalars['ID']['output'];
  /** The dotted event type, e.g. ticket.created. */
  eventType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastError?: Maybe<Scalars['String']['output']>;
  lastStatusCode?: Maybe<Scalars['Int']['output']>;
  /** When the next attempt is due, while pending. */
  nextAttemptAt?: Maybe<Scalars['DateTime']['output']>;
  /** How many times an admin sent it again. */
  replayCount: Scalars['Int']['output'];
  status: WebhookDeliveryStatus;
  ticketId: Scalars['ID']['output'];
  ticketNumber?: Maybe<Scalars['String']['output']>;
};

/** Newest first. */
export type WebhookDeliveryConnection = {
  __typename?: 'WebhookDeliveryConnection';
  nodes: Array<WebhookDelivery>;
  pageInfo: PageInfo;
};

/** PENDING is owed now or waiting to retry; FAILED gave up after every retry; SKIPPED was dropped (endpoint off or removed, or too old). */
export enum WebhookDeliveryStatus {
  Delivered = 'DELIVERED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Skipped = 'SKIPPED',
}

/** A URL that receives signed ticket events, with the last day of its deliveries. The signing secret is never returned here, only once when it is made or rotated. */
export type WebhookEndpoint = {
  __typename?: 'WebhookEndpoint';
  createdAt: Scalars['DateTime']['output'];
  deliveredLastDay: Scalars['Int']['output'];
  disabledAt?: Maybe<Scalars['DateTime']['output']>;
  /** Why it is off, when it is. */
  disabledReason?: Maybe<Scalars['String']['output']>;
  /** False once an admin turned it off, or it was switched off after failures. */
  enabled: Scalars['Boolean']['output'];
  events: Array<WebhookEventType>;
  /** Gave up after every retry, in the last 24 hours. */
  failedLastDay: Scalars['Int']['output'];
  /** Deliveries in a row that gave up. Reset by a success. */
  failureCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  lastError?: Maybe<Scalars['String']['output']>;
  lastErrorAt?: Maybe<Scalars['DateTime']['output']>;
  lastSuccessAt?: Maybe<Scalars['DateTime']['output']>;
  /** Owed now, including ones waiting to retry. */
  pending: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};

/** An endpoint with its signing secret, shown once. Store it with your server secrets. */
export type WebhookEndpointReveal = {
  __typename?: 'WebhookEndpointReveal';
  endpoint: WebhookEndpoint;
  secret: Scalars['String']['output'];
};

/** A ticket event a webhook endpoint can subscribe to. The receiver sees the dotted value as `type`, e.g. ticket.status_changed. */
export enum WebhookEventType {
  TicketClosed = 'TICKET_CLOSED',
  TicketCreated = 'TICKET_CREATED',
  TicketMessage = 'TICKET_MESSAGE',
  TicketProgressed = 'TICKET_PROGRESSED',
  TicketReopened = 'TICKET_REOPENED',
  TicketStatusChanged = 'TICKET_STATUS_CHANGED',
  TicketUpdated = 'TICKET_UPDATED',
}

export type WebhookTestResult = {
  __typename?: 'WebhookTestResult';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  statusCode?: Maybe<Scalars['Int']['output']>;
};

/** A single invoice behind a weekly receivables bucket. Enough detail for the cash-flow chart to list the invoices making up a week and link to each one. */
export type WeekInvoiceRef = {
  __typename?: 'WeekInvoiceRef';
  amount: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  dueDate: Scalars['DateTime']['output'];
  estimatedPaymentDate?: Maybe<Scalars['DateTime']['output']>;
  invoiceId: Scalars['String']['output'];
  invoiceNumber: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  organizationName: Scalars['String']['output'];
  paymentStatus: Scalars['String']['output'];
};

export type WorkItemAssignee = {
  __typename?: 'WorkItemAssignee';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** A task in a work tracker that a ticket is linked to. Shown to agents only; Revvly reads the task and never changes it. */
export type WorkItemLink = {
  __typename?: 'WorkItemLink';
  assignees: Array<WorkItemAssignee>;
  /** The workspace custom id, e.g. ENG-42. */
  customId?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  externalId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** The tracker says this status is done or closed. */
  isDone: Scalars['Boolean']['output'];
  linkMode: WorkItemLinkMode;
  listName?: Maybe<Scalars['String']['output']>;
  provider: WorkItemProvider;
  /** The client stage this task’s status means. Null while the status is internal. */
  stageKey?: Maybe<Scalars['String']['output']>;
  statusColor?: Maybe<Scalars['String']['output']>;
  /** The task's status in the tracker, as last read. */
  statusName: Scalars['String']['output'];
  /** The last refresh could not read the task; the fields show what was last seen. */
  syncError?: Maybe<Scalars['String']['output']>;
  /** When the task was last read from the tracker. */
  syncedAt: Scalars['DateTime']['output'];
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/** Whether Revvly created the task or an agent linked one that already existed. */
export enum WorkItemLinkMode {
  Created = 'CREATED',
  Linked = 'LINKED',
}

/** The tracker a work item lives in. */
export enum WorkItemProvider {
  Clickup = 'CLICKUP',
}

/** The ClickUp list a ticket type’s tasks are created in by default. */
export type WorkItemRouting = {
  __typename?: 'WorkItemRouting';
  listId: Scalars['ID']['output'];
  ticketTypeId: Scalars['ID']['output'];
};

export type WorkflowStatus = {
  __typename?: 'WorkflowStatus';
  category: StatusCategory;
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  retired: Scalars['Boolean']['output'];
};

export type WorkflowStatusInput = {
  /** Fixed once the status exists. */
  category: StatusCategory;
  /** Omit on a new status to derive it from the name. Existing keys must all be sent. */
  key?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  /** Defaults to the position in the list. */
  order?: InputMaybe<Scalars['Int']['input']>;
  retired?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowTransition = {
  __typename?: 'WorkflowTransition';
  from: Scalars['String']['output'];
  to: Scalars['String']['output'];
};

export type WorkflowTransitionInput = {
  from: Scalars['String']['input'];
  to: Scalars['String']['input'];
};

export type WorkspaceDataDeletionCollectionType = {
  __typename?: 'WorkspaceDataDeletionCollectionType';
  deleted: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorkspaceDataDeletionResultType = {
  __typename?: 'WorkspaceDataDeletionResultType';
  collections: Array<WorkspaceDataDeletionCollectionType>;
  /** Stored file objects removed from object storage */
  filesDeleted: Scalars['Int']['output'];
  slug: Scalars['String']['output'];
  totalDeleted: Scalars['Int']['output'];
};

/** Whether a client’s blocked workspace may have its data deleted */
export type WorkspaceDataDeletionStateType = {
  __typename?: 'WorkspaceDataDeletionStateType';
  blockedSince?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  eligible: Scalars['Boolean']['output'];
  /** Blocked since + 90 days */
  eligibleFrom?: Maybe<Scalars['DateTime']['output']>;
  /** Why not, when it is not eligible */
  reason?: Maybe<Scalars['String']['output']>;
  /** The slug to type to confirm */
  slug?: Maybe<Scalars['String']['output']>;
};
